export let videoList = {
  // Gen 2
  Ayame :
  [
  {
    "videoId": "jchmBjT8JPw",
    "thumbnail": "https://i.ytimg.com/vi/jchmBjT8JPw/mqdefault.jpg",
    "title": "【生放送】初マリオカート８デラックス！！",
    "publishedAt": "2018-09-29T16:40:44Z"
  },
  {
    "videoId": "gV5voSVa1kc",
    "thumbnail": "https://i.ytimg.com/vi/gV5voSVa1kc/mqdefault.jpg",
    "title": "【生放送】マリオカート8DX！！　いざ勝負！",
    "publishedAt": "2018-10-06T13:43:42Z"
  },
  {
    "videoId": "iUZpxMfALXI",
    "thumbnail": "https://i.ytimg.com/vi/iUZpxMfALXI/mqdefault.jpg",
    "title": "【生放送】卍組クラフト！！",
    "publishedAt": "2018-10-13T13:52:18Z"
  },
  {
    "videoId": "AI75JFtCxLs",
    "thumbnail": "https://i.ytimg.com/vi/AI75JFtCxLs/mqdefault.jpg",
    "title": "【生放送】のんびりマインクラフト",
    "publishedAt": "2018-10-21T13:31:14Z"
  },
  {
    "videoId": "-VX03G-m8Zc",
    "thumbnail": "https://i.ytimg.com/vi/-VX03G-m8Zc/mqdefault.jpg",
    "title": "【生放送】あやめ×あくあ　らぶらぶ新婚マイクラ生活♡",
    "publishedAt": "2018-11-07T14:49:26Z"
  },
  {
    "videoId": "J7Blv4tC80U",
    "thumbnail": "https://i.ytimg.com/vi/J7Blv4tC80U/mqdefault.jpg",
    "title": "【生放送】Re:ゼロから始めるマイクラ生活　～お宝発掘～",
    "publishedAt": "2018-12-02T15:29:58Z"
  },
  {
    "videoId": "a4KYPYOcN74",
    "thumbnail": "https://i.ytimg.com/vi/a4KYPYOcN74/mqdefault.jpg",
    "title": "【生放送】鬼＆マネージャーのマイクラ生活",
    "publishedAt": "2018-12-08T16:37:11Z"
  },
  {
    "videoId": "fFryRADvBVo",
    "thumbnail": "https://i.ytimg.com/vi/fFryRADvBVo/mqdefault.jpg",
    "title": "【生放送】百鬼城建設計画　～進捗報告＆建設～",
    "publishedAt": "2018-12-10T15:35:36Z"
  },
  {
    "videoId": "1adhR6tImMU",
    "thumbnail": "https://i.ytimg.com/vi/1adhR6tImMU/mqdefault.jpg",
    "title": "【生放送】大乱闘スマッシュブラザーズ SPECIAL　※ガチ初心者",
    "publishedAt": "2018-12-19T15:45:55Z"
  },
  {
    "videoId": "XgBeGLwf4VE",
    "thumbnail": "https://i.ytimg.com/vi/XgBeGLwf4VE/mqdefault.jpg",
    "title": "【スマブラSP】視聴者参加型！オフコラボの余たちに勝てるかな【#ろぼなきり】",
    "publishedAt": "2018-12-25T11:52:38Z"
  },
  {
    "videoId": "To-FnfaBCBo",
    "thumbnail": "https://i.ytimg.com/vi/To-FnfaBCBo/mqdefault.jpg",
    "title": "【生放送】ホロライブマイクラ　～ご新規1名様ご案内～　あやめ視点",
    "publishedAt": "2019-01-10T10:50:19Z"
  },
  {
    "videoId": "G2JfFK4q06Q",
    "thumbnail": "https://i.ytimg.com/vi/G2JfFK4q06Q/mqdefault.jpg",
    "title": "【生放送】Apex　あやめ×スバル",
    "publishedAt": "2019-03-02T17:45:38Z"
  },
  {
    "videoId": "t-ES9KW_Ij8",
    "thumbnail": "https://i.ytimg.com/vi/t-ES9KW_Ij8/mqdefault.jpg",
    "title": "【生放送】家族3人でApex Legends　母・娘・息子　#鬼竜辛APEX",
    "publishedAt": "2019-03-06T14:39:30Z"
  },
  {
    "videoId": "vhk1cD71rM0",
    "thumbnail": "https://i.ytimg.com/vi/vhk1cD71rM0/mqdefault.jpg",
    "title": "【APEX】ぱっつんでもちゃんぽんが食べたい！ロボ子さん&スバル【百鬼あやめ視点】",
    "publishedAt": "2019-03-07T13:56:50Z"
  },
  {
    "videoId": "4X4l58ChYDA",
    "thumbnail": "https://i.ytimg.com/vi/4X4l58ChYDA/mqdefault.jpg",
    "title": "【APEX】初のソロ練習【Apex legends /ソロ】",
    "publishedAt": "2019-03-12T16:48:54Z"
  },
  {
    "videoId": "0yExE1kXkto",
    "thumbnail": "https://i.ytimg.com/vi/0yExE1kXkto/mqdefault.jpg",
    "title": "【APEX】ちゃんぽんが取りたい...！！！！～空腹の鬼神が行く～【Apex legends 】",
    "publishedAt": "2019-03-13T13:36:34Z"
  },
  {
    "videoId": "aIG9o-S6cN4",
    "thumbnail": "https://i.ytimg.com/vi/aIG9o-S6cN4/mqdefault.jpg",
    "title": "【APEX】今夜のご飯はちゃんぽんだ！！！！　【Apex Legends/#百鬼あやめ】",
    "publishedAt": "2019-03-27T13:41:19Z"
  },
  {
    "videoId": "vmEb0UtwU5s",
    "thumbnail": "https://i.ytimg.com/vi/vmEb0UtwU5s/mqdefault.jpg",
    "title": "【マイクラ】百鬼城内装工事を進めるの巻【Minecraft/#百鬼あやめ】",
    "publishedAt": "2019-03-28T12:49:52Z"
  },
  {
    "videoId": "D-oDqG82FIg",
    "thumbnail": "https://i.ytimg.com/vi/D-oDqG82FIg/mqdefault.jpg",
    "title": "【APEX】ちゃんぽん目指して修行じゃい！　【Apex Legends/#百鬼あやめ】",
    "publishedAt": "2019-03-29T17:33:28Z"
  },
  {
    "videoId": "R3dY8Ez5pA0",
    "thumbnail": "https://i.ytimg.com/vi/R3dY8Ez5pA0/mqdefault.jpg",
    "title": "【マイクラ】お家に帰ってきた余　【Minecraft/#百鬼あやめ】",
    "publishedAt": "2019-03-30T16:33:27Z"
  },
  {
    "videoId": "ajxsmz5L35g",
    "thumbnail": "https://i.ytimg.com/vi/ajxsmz5L35g/mqdefault.jpg",
    "title": "【APEX】息抜きApex legends【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-04-08T13:34:35Z"
  },
  {
    "videoId": "M52TUm11A1E",
    "thumbnail": "https://i.ytimg.com/vi/M52TUm11A1E/mqdefault.jpg",
    "title": "【マイクラ】スバルとキャンプする余 【百鬼あやめ視点/ホロライブ】",
    "publishedAt": "2019-05-10T11:13:45Z"
  },
  {
    "videoId": "cC8fs4iyATg",
    "thumbnail": "https://i.ytimg.com/vi/cC8fs4iyATg/mqdefault.jpg",
    "title": "【マイクラ】スバルとキャンプする余 【百鬼あやめ視点/ホロライブ】",
    "publishedAt": "2019-05-10T13:03:50Z"
  },
  {
    "videoId": "GyPd77ttGt4",
    "thumbnail": "https://i.ytimg.com/vi/GyPd77ttGt4/mqdefault.jpg",
    "title": "【Minecraft】 久しぶりののんびりクラフト【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-05-15T14:39:46Z"
  },
  {
    "videoId": "L2dmOGbE5n8",
    "thumbnail": "https://i.ytimg.com/vi/L2dmOGbE5n8/mqdefault.jpg",
    "title": "【スプラ2】うまうまになってやるんだ余ー!!!!!【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-05-19T15:47:50Z"
  },
  {
    "videoId": "Y8syqWkoQXc",
    "thumbnail": "https://i.ytimg.com/vi/Y8syqWkoQXc/mqdefault.jpg",
    "title": "【Minecraft】のんびりクラフト【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-05-20T14:31:16Z"
  },
  {
    "videoId": "RH4gW-1_4Qc",
    "thumbnail": "https://i.ytimg.com/vi/RH4gW-1_4Qc/mqdefault.jpg",
    "title": "【スプラ2】ゲリラスプラトゥーン【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-05-21T14:14:20Z"
  },
  {
    "videoId": "tgPOIvx5Ngk",
    "thumbnail": "https://i.ytimg.com/vi/tgPOIvx5Ngk/mqdefault.jpg",
    "title": "【Minecraft】ネザー探検隊!!!【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-05-21T16:08:45Z"
  },
  {
    "videoId": "jCAF2e7V6_w",
    "thumbnail": "https://i.ytimg.com/vi/jCAF2e7V6_w/mqdefault.jpg",
    "title": "【Minecraft】初めての要塞探索【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-05-28T15:04:34Z"
  },
  {
    "videoId": "3GUg1uGTIF0",
    "thumbnail": "https://i.ytimg.com/vi/3GUg1uGTIF0/mqdefault.jpg",
    "title": "【マリカ】7位以下で即終了！？！？マリオカート8DX【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-06-05T12:45:12Z"
  },
  {
    "videoId": "o_TfemFjME0",
    "thumbnail": "https://i.ytimg.com/vi/o_TfemFjME0/mqdefault.jpg",
    "title": "【APEX】アプデ初APEX LEGENDS【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-06-10T14:49:02Z"
  },
  {
    "videoId": "Vwr0eUhAGHY",
    "thumbnail": "https://i.ytimg.com/vi/Vwr0eUhAGHY/mqdefault.jpg",
    "title": "【Minecraft】マイクラで水槽作る!!!!!!【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-06-13T15:02:29Z"
  },
  {
    "videoId": "ujx-czBUd_Y",
    "thumbnail": "https://i.ytimg.com/vi/ujx-czBUd_Y/mqdefault.jpg",
    "title": "【Minecraft】マイクラで水槽作る!!!!!! #2【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-06-14T13:56:21Z"
  },
  {
    "videoId": "2bqcwqRWv3Q",
    "thumbnail": "https://i.ytimg.com/vi/2bqcwqRWv3Q/mqdefault.jpg",
    "title": "【Minecraft】あやスバで伝説のパンダを探す【#百鬼あやめ視点/ホロライブ】",
    "publishedAt": "2019-06-17T15:44:33Z"
  },
  {
    "videoId": "ao0fpioDJOE",
    "thumbnail": "https://i.ytimg.com/vi/ao0fpioDJOE/mqdefault.jpg",
    "title": "【Minecraft】サンゴ礁採りに行く!!!!!【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-06-19T16:21:34Z"
  },
  {
    "videoId": "-UN5oxiKw5U",
    "thumbnail": "https://i.ytimg.com/vi/-UN5oxiKw5U/mqdefault.jpg",
    "title": "【スプラ２】リハビリスプラトゥーン２【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-06-21T15:50:47Z"
  },
  {
    "videoId": "s_UcjHthxc0",
    "thumbnail": "https://i.ytimg.com/vi/s_UcjHthxc0/mqdefault.jpg",
    "title": "【マイクラ】のんびりマイクラ生活【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-06-29T15:51:59Z"
  },
  {
    "videoId": "B6NbCs5pt20",
    "thumbnail": "https://i.ytimg.com/vi/B6NbCs5pt20/mqdefault.jpg",
    "title": "【Minecraft】のんびりクラフトだぞぉ～【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-07-04T15:43:34Z"
  },
  {
    "videoId": "VNaZMkPtv7o",
    "thumbnail": "https://i.ytimg.com/vi/VNaZMkPtv7o/mqdefault.jpg",
    "title": "【Minecraft】水族館づくり進めるんだ～～～～～！【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-07-10T15:41:50Z"
  },
  {
    "videoId": "T9KX533ze2w",
    "thumbnail": "https://i.ytimg.com/vi/T9KX533ze2w/mqdefault.jpg",
    "title": "【Minecraft】レアバイオーム探索！！！！【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-07-18T16:45:39Z"
  },
  {
    "videoId": "sKBUED-Sj2g",
    "thumbnail": "https://i.ytimg.com/vi/sKBUED-Sj2g/mqdefault.jpg",
    "title": "【スプラ2】久しぶりにスプラで遊ぶ!!!!!【#あやロボ/ホロライブ】",
    "publishedAt": "2019-07-25T13:55:57Z"
  },
  {
    "videoId": "PEbdjFkFOHQ",
    "thumbnail": "https://i.ytimg.com/vi/PEbdjFkFOHQ/mqdefault.jpg",
    "title": "【マインクラフト】第2別荘計画進める【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-08-05T13:42:18Z"
  },
  {
    "videoId": "Lc1NPKY9JWs",
    "thumbnail": "https://i.ytimg.com/vi/Lc1NPKY9JWs/mqdefault.jpg",
    "title": "【#おにべろす】未開の地見つけちゃった、、、【百鬼あやめ/戌亥とこ】",
    "publishedAt": "2019-08-06T11:41:51Z"
  },
  {
    "videoId": "8E7yWfFQWzc",
    "thumbnail": "https://i.ytimg.com/vi/8E7yWfFQWzc/mqdefault.jpg",
    "title": "【スプラ2】夏だスプラだ!!!!!!!!!!!!!!【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-08-18T12:48:04Z"
  },
  {
    "videoId": "NDM79IC-uac",
    "thumbnail": "https://i.ytimg.com/vi/NDM79IC-uac/mqdefault.jpg",
    "title": "【#あやスバ】あやスバてぇてぇマイクラ（笑）【百鬼あやめ視点】",
    "publishedAt": "2019-08-24T05:21:25Z"
  },
  {
    "videoId": "soIbQLzS4v4",
    "thumbnail": "https://i.ytimg.com/vi/soIbQLzS4v4/mqdefault.jpg",
    "title": "【ホロ鯖】はじめのいっぽ【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-08-29T13:50:18Z"
  },
  {
    "videoId": "q1gUzLTMWKs",
    "thumbnail": "https://i.ytimg.com/vi/q1gUzLTMWKs/mqdefault.jpg",
    "title": "【ホロ鯖】ホロ鯖に茶屋を作りたい【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-09-01T14:50:12Z"
  },
  {
    "videoId": "cCgofxDRHig",
    "thumbnail": "https://i.ytimg.com/vi/cCgofxDRHig/mqdefault.jpg",
    "title": "【マイクラ】お茶屋完成させたからお披露目とダイヤを掘りに行く【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-09-07T15:48:42Z"
  },
  {
    "videoId": "hoqc8I8yvDo",
    "thumbnail": "https://i.ytimg.com/vi/hoqc8I8yvDo/mqdefault.jpg",
    "title": "【ホロ鯖】ホロ鯖にみんなの公園を作りたい!!!!【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-09-10T18:24:54Z"
  },
  {
    "videoId": "zmW5WTBlTz8",
    "thumbnail": "https://i.ytimg.com/vi/zmW5WTBlTz8/mqdefault.jpg",
    "title": "【ホロ鯖】公園の進捗はどうだ…？【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-09-13T15:45:42Z"
  },
  {
    "videoId": "zaj1AZ9Er1M",
    "thumbnail": "https://i.ytimg.com/vi/zaj1AZ9Er1M/mqdefault.jpg",
    "title": "【ホロ鯖】公園に砂場＆ジャングルジムを作る余【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-09-19T14:30:39Z"
  },
  {
    "videoId": "TDVWuItyPJw",
    "thumbnail": "https://i.ytimg.com/vi/TDVWuItyPJw/mqdefault.jpg",
    "title": "【ホロ鯖】鉄ピッケル3本でダイヤ掘り勝負じゃい!!!!!!【百鬼あやめ視点/ホロライブ】",
    "publishedAt": "2019-09-21T18:33:52Z"
  },
  {
    "videoId": "yEfU_Xtp6aw",
    "thumbnail": "https://i.ytimg.com/vi/yEfU_Xtp6aw/mqdefault.jpg",
    "title": "【ホロ鯖マイクラ】エンチャント本釣るまで終われない放送【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-09-23T15:40:55Z"
  },
  {
    "videoId": "6FM3bUOZ_ig",
    "thumbnail": "https://i.ytimg.com/vi/6FM3bUOZ_ig/mqdefault.jpg",
    "title": "【新ホロ鯖】新鯖で新しい生活始めるぞ!!!!!!!!!!!【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-10-13T15:20:05Z"
  },
  {
    "videoId": "FGe0f7lE-EI",
    "thumbnail": "https://i.ytimg.com/vi/FGe0f7lE-EI/mqdefault.jpg",
    "title": "【3D放送】みんなのリズム天国全クリするまで終われない!!!!!!!!! 【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-10-14T19:53:20Z"
  },
  {
    "videoId": "3FL5_ZsM4Ow",
    "thumbnail": "https://i.ytimg.com/vi/3FL5_ZsM4Ow/mqdefault.jpg",
    "title": "【新ホロ鯖】のんびりクラフトするぞおお～～【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-10-15T14:47:17Z"
  },
  {
    "videoId": "VzFlfZl58RQ",
    "thumbnail": "https://i.ytimg.com/vi/VzFlfZl58RQ/mqdefault.jpg",
    "title": "【新ホロ鯖】なきり野宿卒業する！！！【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-10-18T14:42:54Z"
  },
  {
    "videoId": "NDdvFrVDJY0",
    "thumbnail": "https://i.ytimg.com/vi/NDdvFrVDJY0/mqdefault.jpg",
    "title": "【新ホロ鯖/マイクラ】今日こそ！！！！！完成させるぞ！！！！！【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-10-24T16:09:25Z"
  },
  {
    "videoId": "ENQIWpSOzUk",
    "thumbnail": "https://i.ytimg.com/vi/ENQIWpSOzUk/mqdefault.jpg",
    "title": "【#おにべろす】雑おにべろすクラフト　其の参【百鬼視点/ホロライブ】",
    "publishedAt": "2019-11-03T17:02:16Z"
  },
  {
    "videoId": "75HbTB7jIp0",
    "thumbnail": "https://i.ytimg.com/vi/75HbTB7jIp0/mqdefault.jpg",
    "title": "【マリオカート８DX】おにひとねこマリオカート!!!!!!!!!!!!【#おにひとねこ/ホロライブ】",
    "publishedAt": "2019-11-05T14:41:36Z"
  },
  {
    "videoId": "Kj731Cuu_zI",
    "thumbnail": "https://i.ytimg.com/vi/Kj731Cuu_zI/mqdefault.jpg",
    "title": "【#スプラ部】復活!!!!!!!!!!!!!!!!スプラ部!!!!!!!!!!!!!!!!!!!!!!!【百鬼視点/ホロライブ】",
    "publishedAt": "2019-11-06T14:39:56Z"
  },
  {
    "videoId": "NLyA5oCguSo",
    "thumbnail": "https://i.ytimg.com/vi/NLyA5oCguSo/mqdefault.jpg",
    "title": "【マリカ8DX】視聴者参加型マリカ!!!!!1位の座は余がとる!!!!!!【#百鬼あやめ/ホロライブ】",
    "publishedAt": "2019-11-07T15:46:05Z"
  },
  {
    "videoId": "AP_xo2HzqO0",
    "thumbnail": "https://i.ytimg.com/vi/AP_xo2HzqO0/mqdefault.jpg",
    "title": "久しぶりにFPSなるものをやってみる【#百鬼あやめ/ ホロライブ】",
    "publishedAt": "2019-11-20T12:24:41Z"
  },
  {
    "videoId": "-ORdtZrgzHk",
    "thumbnail": "https://i.ytimg.com/vi/-ORdtZrgzHk/mqdefault.jpg",
    "title": "【ARK】遂に初ARK!!!!!!!!ていむしたい!!!!!!!!!!!!!!【#とまらないARK】",
    "publishedAt": "2020-02-23T15:33:56Z"
  },
  {
    "videoId": "oItsMVr6s6o",
    "thumbnail": "https://i.ytimg.com/vi/oItsMVr6s6o/mqdefault.jpg",
    "title": "【APEX】久しぶりに銃を持ってみた【#百鬼あやめch/ホロライブ】",
    "publishedAt": "2020-03-08T14:37:13Z"
  },
  {
    "videoId": "tmMoK1AxbZY",
    "thumbnail": "https://i.ytimg.com/vi/tmMoK1AxbZY/mqdefault.jpg",
    "title": "【APEX】修行という名の修行【#百鬼あやめch/ホロライブ】",
    "publishedAt": "2020-03-11T17:38:53Z"
  },
  {
    "videoId": "24WeV1UsQwI",
    "thumbnail": "https://i.ytimg.com/vi/24WeV1UsQwI/mqdefault.jpg",
    "title": "【APEX】やっぱり勝利を勝ち取りたい【#百鬼あやめch/ホロライブ】",
    "publishedAt": "2020-03-14T13:41:40Z"
  },
  {
    "videoId": "dm2VoQocFfg",
    "thumbnail": "https://i.ytimg.com/vi/dm2VoQocFfg/mqdefault.jpg",
    "title": "【あつまれどうぶつの森】待ちに待ったゲームやるぞおおおおおお！！！！！！【#百鬼あやめch/ホロライブ】",
    "publishedAt": "2020-03-19T17:00:25Z"
  },
  {
    "videoId": "pNlA04uQ5J0",
    "thumbnail": "https://i.ytimg.com/vi/pNlA04uQ5J0/mqdefault.jpg",
    "title": "【APEX】ランク上げ修行にいざ出陣！！！！！！！【#百鬼あやめch/ホロライブ】",
    "publishedAt": "2020-03-29T15:49:15Z"
  },
  {
    "videoId": "35VBv-WfzB0",
    "thumbnail": "https://i.ytimg.com/vi/35VBv-WfzB0/mqdefault.jpg",
    "title": "【APEX】ウルトラハイセンシからの卒業練習apex【#百鬼あやめch/ホロライブ】",
    "publishedAt": "2020-04-02T15:38:42Z"
  },
  {
    "videoId": "dyngXZ_EkEM",
    "thumbnail": "https://i.ytimg.com/vi/dyngXZ_EkEM/mqdefault.jpg",
    "title": "【あつまれどうぶつの森】春のイースター家具服コンプしたい!!!!!!!!!!!!!【#百鬼あやめch/ホロライブ】",
    "publishedAt": "2020-04-03T15:57:36Z"
  },
  {
    "videoId": "HN_2wCEaR_A",
    "thumbnail": "https://i.ytimg.com/vi/HN_2wCEaR_A/mqdefault.jpg",
    "title": "【#卍組】3人揃えば最強！？！？伝説の卍組APEX！！！！",
    "publishedAt": "2020-04-15T13:38:49Z"
  },
  {
    "videoId": "cjraJKf0yrk",
    "thumbnail": "https://i.ytimg.com/vi/cjraJKf0yrk/mqdefault.jpg",
    "title": "【APEX】APEX道場！！！！いざ修行！！！",
    "publishedAt": "2020-04-27T17:24:54Z"
  },
  {
    "videoId": "AOoxcw4Kl4k",
    "thumbnail": "https://i.ytimg.com/vi/AOoxcw4Kl4k/mqdefault.jpg",
    "title": "【APEX】新シーズン５到来！！いざ修行！",
    "publishedAt": "2020-05-13T19:08:47Z"
  },
  {
    "videoId": "437PWLz5JqM",
    "thumbnail": "https://i.ytimg.com/vi/437PWLz5JqM/mqdefault.jpg",
    "title": "【APEX / エーペックスレジェンズ】G1スタートからどこまでいけるか配信",
    "publishedAt": "2020-05-19T17:34:47Z"
  },
  {
    "videoId": "TgNy5t8IaNk",
    "thumbnail": "https://i.ytimg.com/vi/TgNy5t8IaNk/mqdefault.jpg",
    "title": "【APEX】深夜のあぺ修行～ガスおじしか勝たん！～【エーペックスレジェンズ】",
    "publishedAt": "2020-05-21T18:14:23Z"
  },
  {
    "videoId": "WPu7jvZUeHI",
    "thumbnail": "https://i.ytimg.com/vi/WPu7jvZUeHI/mqdefault.jpg",
    "title": "【#おにべろす】鬼とケルベロスが兎で遊ぶ末路",
    "publishedAt": "2020-06-01T14:46:57Z"
  },
  {
    "videoId": "mx2ST27iK8U",
    "thumbnail": "https://i.ytimg.com/vi/mx2ST27iK8U/mqdefault.jpg",
    "title": "【雑談】なにはなそっかな～～～～～",
    "publishedAt": "2020-06-06T15:10:27Z"
  },
  {
    "videoId": "FQabDyuC_wQ",
    "thumbnail": "https://i.ytimg.com/vi/FQabDyuC_wQ/mqdefault.jpg",
    "title": "おいでませ参拝者！！！！百鬼神社始めました",
    "publishedAt": "2020-06-09T13:12:54Z"
  },
  {
    "videoId": "UiR0fCmW7OU",
    "thumbnail": "https://i.ytimg.com/vi/UiR0fCmW7OU/mqdefault.jpg",
    "title": "【VALORANT】はじめてのヴァロ放送やってみるぞおぉぉ！！！",
    "publishedAt": "2020-06-10T15:55:18Z"
  },
  {
    "videoId": "r6aaEdEWUXg",
    "thumbnail": "https://i.ytimg.com/vi/r6aaEdEWUXg/mqdefault.jpg",
    "title": "【歌枠】夜更かししちゃうんだもん",
    "publishedAt": "2020-06-13T16:59:20Z"
  },
  {
    "videoId": "DYijjS3Twag",
    "thumbnail": "https://i.ytimg.com/vi/DYijjS3Twag/mqdefault.jpg",
    "title": "【Ultimate Chicken Horse】障害物競走を勝ち抜くのは誰だ！？！？！『 アルティメットチキンホース 』",
    "publishedAt": "2020-06-14T13:32:03Z"
  },
  {
    "videoId": "druH6vW_OJI",
    "thumbnail": "https://i.ytimg.com/vi/druH6vW_OJI/mqdefault.jpg",
    "title": "【 VALORANT 】ヴぁろ修行に出てみる！！！",
    "publishedAt": "2020-06-17T17:41:30Z"
  },
  {
    "videoId": "ngQAlMmTJPU",
    "thumbnail": "https://i.ytimg.com/vi/ngQAlMmTJPU/mqdefault.jpg",
    "title": "【雑談】しずかにおはなしする！！！！！！！！！！（爆音）",
    "publishedAt": "2020-06-22T17:24:10Z"
  },
  {
    "videoId": "DZCLsGHS2jM",
    "thumbnail": "https://i.ytimg.com/vi/DZCLsGHS2jM/mqdefault.jpg",
    "title": "【雑談】なきり復帰！！！！！！！！！！！！！！！！！！",
    "publishedAt": "2020-07-01T17:43:01Z"
  },
  {
    "videoId": "bC4nQRgTV_0",
    "thumbnail": "https://i.ytimg.com/vi/bC4nQRgTV_0/mqdefault.jpg",
    "title": "【 VALORANT 】 ヴぁろらんくいざ出陣！！！しようと思ったけどアンレートしかできませんでしたの会",
    "publishedAt": "2020-07-03T17:11:59Z"
  },
  {
    "videoId": "s0GxtS29X9k",
    "thumbnail": "https://i.ytimg.com/vi/s0GxtS29X9k/mqdefault.jpg",
    "title": "【 VALORANT 】 ～リベンジ編～　ヴぁろランクいざ出陣！！！",
    "publishedAt": "2020-07-07T19:18:34Z"
  },
  {
    "videoId": "EMet3PGXzoQ",
    "thumbnail": "https://i.ytimg.com/vi/EMet3PGXzoQ/mqdefault.jpg",
    "title": "【ゲリラ歌枠 】鼻が詰まっている気がするが歌ってみる",
    "publishedAt": "2020-07-09T18:31:23Z"
  },
  {
    "videoId": "GIurudkLM58",
    "thumbnail": "https://i.ytimg.com/vi/GIurudkLM58/mqdefault.jpg",
    "title": "【VALORANT】鬼と魔女のヴァロラントいざ出陣！！！！！",
    "publishedAt": "2020-07-25T16:38:26Z"
  },
  {
    "videoId": "KPnGhtn1VVs",
    "thumbnail": "https://i.ytimg.com/vi/KPnGhtn1VVs/mqdefault.jpg",
    "title": "【記念配信】30万人ありがとう！！！！！！＆重大発表！！！",
    "publishedAt": "2020-07-28T17:15:09Z"
  },
  {
    "videoId": "gsSYyGrtEAU",
    "thumbnail": "https://i.ytimg.com/vi/gsSYyGrtEAU/mqdefault.jpg",
    "title": "【APEX】最協決定戦練習！ちーむはっぴーせっとおおおお～～～～！【エーペックスレジェンズ】",
    "publishedAt": "2020-07-30T19:30:29Z"
  },
  {
    "videoId": "H4gO1FhRIjc",
    "thumbnail": "https://i.ytimg.com/vi/H4gO1FhRIjc/mqdefault.jpg",
    "title": "【 #百鬼新2D 】百鬼アップデート ver2.0！！！進化した余を見てて…",
    "publishedAt": "2020-07-31T14:21:44Z"
  },
  {
    "videoId": "qZCGxpyAgSk",
    "thumbnail": "https://i.ytimg.com/vi/qZCGxpyAgSk/mqdefault.jpg",
    "title": "【APEX】HPS 大会直前練習！",
    "publishedAt": "2020-08-02T08:49:38Z"
  },
  {
    "videoId": "XpDCule6Cyg",
    "thumbnail": "https://i.ytimg.com/vi/XpDCule6Cyg/mqdefault.jpg",
    "title": "【#VTuber最協決定戦】#ハッピーセットWIN　百鬼あやめ視点【ロボ子さん/百鬼あやめ/夏色まつり】",
    "publishedAt": "2020-08-02T12:48:52Z"
  },
  {
    "videoId": "pBdcdVmIwzE",
    "thumbnail": "https://i.ytimg.com/vi/pBdcdVmIwzE/mqdefault.jpg",
    "title": "【APEX】お疲れ様会兼修行あぺ！【エーペックスレジェンズ】",
    "publishedAt": "2020-08-03T17:43:16Z"
  },
  {
    "videoId": "PFeITK7BgbE",
    "thumbnail": "https://i.ytimg.com/vi/PFeITK7BgbE/mqdefault.jpg",
    "title": "【APEX】今日も今日とて修行にでる【エーペックスレジェンズ】",
    "publishedAt": "2020-08-06T15:59:56Z"
  },
  {
    "videoId": "d5aO-Q6NPck",
    "thumbnail": "https://i.ytimg.com/vi/d5aO-Q6NPck/mqdefault.jpg",
    "title": "【APEX】ダイヤ帯ランクにのまれる【エーペックスレジェンズ】",
    "publishedAt": "2020-08-09T17:55:41Z"
  },
  {
    "videoId": "IxaSkrTJtiE",
    "thumbnail": "https://i.ytimg.com/vi/IxaSkrTJtiE/mqdefault.jpg",
    "title": "【 APEX 】もうそろシーズンが終わっちゃうな…【エーペックスレジェンズ】",
    "publishedAt": "2020-08-16T19:36:48Z"
  },
  {
    "videoId": "c9VYairGvn4",
    "thumbnail": "https://i.ytimg.com/vi/c9VYairGvn4/mqdefault.jpg",
    "title": "【 Fall Guys 】1位目指して頑張る！！！！！！！！！！！【フォールガイズ アルティメット ノックアウト】",
    "publishedAt": "2020-08-18T17:01:02Z"
  },
  {
    "videoId": "WCTnR6oS6oI",
    "thumbnail": "https://i.ytimg.com/vi/WCTnR6oS6oI/mqdefault.jpg",
    "title": "【深夜雑談】最近調子どう？？？？？？？？　【 百鬼あやめ / ホロライブ 】",
    "publishedAt": "2020-08-21T18:02:43Z"
  },
  {
    "videoId": "DBdsciM5f_k",
    "thumbnail": "https://i.ytimg.com/vi/DBdsciM5f_k/mqdefault.jpg",
    "title": "【 Fall Guys 】1位をとるのはどっちだ！？！？！？うさおに大戦争！！【 #うさおに大戦争 / 百鬼あやめ視点 】",
    "publishedAt": "2020-08-24T14:29:13Z"
  },
  {
    "videoId": "UgpasSMG6RY",
    "thumbnail": "https://i.ytimg.com/vi/UgpasSMG6RY/mqdefault.jpg",
    "title": "【 Fall Guys 】今度こそ1位を取ってやるんだああああああああああああ！！",
    "publishedAt": "2020-08-27T01:35:26Z"
  },
  {
    "videoId": "QAKS6rSbZT0",
    "thumbnail": "https://i.ytimg.com/vi/QAKS6rSbZT0/mqdefault.jpg",
    "title": "【 歌枠 】2.0verになってからの初の歌枠！！！！！！！！",
    "publishedAt": "2020-08-28T17:04:10Z"
  },
  {
    "videoId": "soEBBr9mmfM",
    "thumbnail": "https://i.ytimg.com/vi/soEBBr9mmfM/mqdefault.jpg",
    "title": "【 Fall Guys 】今日こそ…！今日こそは…！！！！！！1位を…！！！！！取るつもりで頑張る予定",
    "publishedAt": "2020-09-01T16:23:07Z"
  },
  {
    "videoId": "eEYaw4Bgpig",
    "thumbnail": "https://i.ytimg.com/vi/eEYaw4Bgpig/mqdefault.jpg",
    "title": "【 APEX 】新シーズン初あぺぺ配信！！～どの武器が強い？相棒探しの旅～",
    "publishedAt": "2020-09-02T17:00:33Z"
  },
  {
    "videoId": "ClrzryIkpTA",
    "thumbnail": "https://i.ytimg.com/vi/ClrzryIkpTA/mqdefault.jpg",
    "title": "【 #百鬼あやめ2周年 】みんなのおかげ様で2周年！！！！！！！本当にありがとう！！！",
    "publishedAt": "2020-09-03T13:10:51Z"
  },
  {
    "videoId": "TDcuzEGHDSE",
    "thumbnail": "https://i.ytimg.com/vi/TDcuzEGHDSE/mqdefault.jpg",
    "title": "【 雑談 】久しぶりの人間様達とおはなし！！",
    "publishedAt": "2020-09-05T16:08:46Z"
  },
  {
    "videoId": "t6cnyE-tQA0",
    "thumbnail": "https://i.ytimg.com/vi/t6cnyE-tQA0/mqdefault.jpg",
    "title": "【 APEX 】アーマー耐久値増えたって！？！？！？やるしかないよなぁ！？",
    "publishedAt": "2020-09-05T18:54:23Z"
  },
  {
    "videoId": "bd7brSeQ-nA",
    "thumbnail": "https://i.ytimg.com/vi/bd7brSeQ-nA/mqdefault.jpg",
    "title": "【 APEX 】今日も今日とて修行！！！サボってた分取り返すんだ！！！！！！",
    "publishedAt": "2020-09-07T15:59:49Z"
  },
  {
    "videoId": "THs2a9vUTsg",
    "thumbnail": "https://i.ytimg.com/vi/THs2a9vUTsg/mqdefault.jpg",
    "title": "【 APEX 】あぺ修行するぞおおおおおおおおお！！！！！！",
    "publishedAt": "2020-09-11T16:14:06Z"
  },
  {
    "videoId": "_RsDFaGnYV8",
    "thumbnail": "https://i.ytimg.com/vi/_RsDFaGnYV8/mqdefault.jpg",
    "title": "【 Fall Guys 】今度こそ1位を取りたいフォールガイズ配信（※5回目）",
    "publishedAt": "2020-09-13T13:41:51Z"
  },
  {
    "videoId": "3DVDPgPEprg",
    "thumbnail": "https://i.ytimg.com/vi/3DVDPgPEprg/mqdefault.jpg",
    "title": "【 APEX 】残り日数を見て焦りだしたらんく配信だあ！！",
    "publishedAt": "2020-09-13T17:21:05Z"
  },
  {
    "videoId": "hAo6NGQlkOA",
    "thumbnail": "https://i.ytimg.com/vi/hAo6NGQlkOA/mqdefault.jpg",
    "title": "【 歌枠 】久しぶりに歌ってやるんだ～～～～～～！！！」",
    "publishedAt": "2020-09-15T16:30:41Z"
  },
  {
    "videoId": "UdNpNN5YKKM",
    "thumbnail": "https://i.ytimg.com/vi/UdNpNN5YKKM/mqdefault.jpg",
    "title": "【 APEX 】休んでいた分練習するぞぉぉ～～！！！",
    "publishedAt": "2020-09-20T17:20:40Z"
  },
  {
    "videoId": "3MIDH2SnOgI",
    "thumbnail": "https://i.ytimg.com/vi/3MIDH2SnOgI/mqdefault.jpg",
    "title": "【 APEX 】間に合わせなくちゃああああああああああああああ！！",
    "publishedAt": "2020-09-24T17:51:56Z"
  },
  {
    "videoId": "dENBslwgSTY",
    "thumbnail": "https://i.ytimg.com/vi/dENBslwgSTY/mqdefault.jpg",
    "title": "【 百鬼あやめ視点 】Fチーム FallGuys Vtuberr大会！！王冠勝ち取るぞぉぉぉぉぉおお！！！【#弱肉強食ホロ弁当】",
    "publishedAt": "2020-09-30T13:35:35Z"
  },
  {
    "videoId": "8IWHjP0_YRE",
    "thumbnail": "https://i.ytimg.com/vi/8IWHjP0_YRE/mqdefault.jpg",
    "title": "【 復帰 】ただいま！！！！！！！そしてお待たせしました！！！",
    "publishedAt": "2020-10-26T12:12:26Z"
  },
  {
    "videoId": "8X2JLwR2tEk",
    "thumbnail": "https://i.ytimg.com/vi/8X2JLwR2tEk/mqdefault.jpg",
    "title": "【歌枠】久しぶりの歌！！！！！！気合い入れるぞ！！！",
    "publishedAt": "2020-10-27T13:47:07Z"
  },
  {
    "videoId": "7LyiPKjUnPI",
    "thumbnail": "https://i.ytimg.com/vi/7LyiPKjUnPI/mqdefault.jpg",
    "title": "【視聴者参加型】初めての Among us 参加型！！！！！英語出来なくても勝てるのか…！？",
    "publishedAt": "2020-10-29T17:21:46Z"
  },
  {
    "videoId": "f59gisLhZ2I",
    "thumbnail": "https://i.ytimg.com/vi/f59gisLhZ2I/mqdefault.jpg",
    "title": "【視聴者参加型】英語初心者による Among us…！！！",
    "publishedAt": "2020-10-31T16:28:29Z"
  },
  {
    "videoId": "ewfY1I2iOV4",
    "thumbnail": "https://i.ytimg.com/vi/ewfY1I2iOV4/mqdefault.jpg",
    "title": "【Phasmophobia】心霊調査ELITE部隊/あやめ視点【#ホロライブFAMS】",
    "publishedAt": "2020-11-03T13:40:35Z"
  },
  {
    "videoId": "KpzmKFDAVHE",
    "thumbnail": "https://i.ytimg.com/vi/KpzmKFDAVHE/mqdefault.jpg",
    "title": "【#ポンホロAmongUs】人狼をみつけて生き残るんじゃ・・・・百鬼あやめ視点/ホロライブ",
    "publishedAt": "2020-11-04T14:11:48Z"
  },
  {
    "videoId": "8ak-tuqLPLw",
    "thumbnail": "https://i.ytimg.com/vi/8ak-tuqLPLw/mqdefault.jpg",
    "title": "【Papers, Please】 余、入国審査官始めました。",
    "publishedAt": "2020-11-08T14:14:48Z"
  },
  {
    "videoId": "n2jR-hOP3Hg",
    "thumbnail": "https://i.ytimg.com/vi/n2jR-hOP3Hg/mqdefault.jpg",
    "title": "【Papers, Please】家族全滅させた入国審査官が再就職する",
    "publishedAt": "2020-11-10T14:16:37Z"
  },
  {
    "videoId": "c-86erW1RgQ",
    "thumbnail": "https://i.ytimg.com/vi/c-86erW1RgQ/mqdefault.jpg",
    "title": "【歌枠】50万人いくまで終われない…！？！？！？久しぶりの歌枠！！！",
    "publishedAt": "2020-11-12T15:29:51Z"
  },
  {
    "videoId": "YvHGsgjbLDE",
    "thumbnail": "https://i.ytimg.com/vi/YvHGsgjbLDE/mqdefault.jpg",
    "title": "【Among us】imposterを暴いていきたい鬼　#宇宙ホロ人狼",
    "publishedAt": "2020-11-15T14:54:55Z"
  },
  {
    "videoId": "36wK5Hg6ahA",
    "thumbnail": "https://i.ytimg.com/vi/36wK5Hg6ahA/mqdefault.jpg",
    "title": "【Among us】ぐいぐい暴いていく鬼！精一杯頑張ります（）　#ホロのぐいぐい宇宙人狼",
    "publishedAt": "2020-11-18T14:03:43Z"
  },
  {
    "videoId": "o6NRRekF9fI",
    "thumbnail": "https://i.ytimg.com/vi/o6NRRekF9fI/mqdefault.jpg",
    "title": "【雑談】久しぶりの雑談！！！！！話したいことが沢山あるんだ余！",
    "publishedAt": "2020-11-23T15:05:34Z"
  },
  {
    "videoId": "4RYpR073iWw",
    "thumbnail": "https://i.ytimg.com/vi/4RYpR073iWw/mqdefault.jpg",
    "title": "【Papers, Please】家族全滅 & 職場爆破させた入国審査官が3度目の再就職をする",
    "publishedAt": "2020-11-26T16:02:51Z"
  },
  {
    "videoId": "JTVA3yn2GyU",
    "thumbnail": "https://i.ytimg.com/vi/JTVA3yn2GyU/mqdefault.jpg",
    "title": "【歌枠】久しぶりの歌枠！！！発散するぞおぉぉぉ！！！",
    "publishedAt": "2020-12-04T16:16:56Z"
  },
  {
    "videoId": "GzFln4dVQBQ",
    "thumbnail": "https://i.ytimg.com/vi/GzFln4dVQBQ/mqdefault.jpg",
    "title": "【Papers, Please】悉くEZICの言うことをきかない（きけない）入国審査官の日常",
    "publishedAt": "2020-12-08T14:53:44Z"
  },
  {
    "videoId": "8d5M0ZU0H1M",
    "thumbnail": "https://i.ytimg.com/vi/8d5M0ZU0H1M/mqdefault.jpg",
    "title": "【晩酌】久しぶりに人間様と一緒に酒を呑む",
    "publishedAt": "2020-12-10T16:02:14Z"
  },
  {
    "videoId": "475ryoXOIFk",
    "thumbnail": "https://i.ytimg.com/vi/475ryoXOIFk/mqdefault.jpg",
    "title": "【歌枠】ライブまでもう少し！！歌練習すっぞおおおお！",
    "publishedAt": "2020-12-12T08:32:35Z"
  },
  {
    "videoId": "bG-FMPrxNA0",
    "thumbnail": "https://i.ytimg.com/vi/bG-FMPrxNA0/mqdefault.jpg",
    "title": "誕生日直前！！！！！！カウントダウンで一緒に誕生日を迎えたい！！",
    "publishedAt": "2020-12-12T16:04:25Z"
  },
  {
    "videoId": "_m2hQrFdiP4",
    "thumbnail": "https://i.ytimg.com/vi/_m2hQrFdiP4/mqdefault.jpg",
    "title": "【凸待ち】初めての挑戦…！！！！！誕生日ドキドキ凸待ち！！！",
    "publishedAt": "2020-12-13T14:02:08Z"
  },
  {
    "videoId": "8G3umZ9iMqw",
    "thumbnail": "https://i.ytimg.com/vi/8G3umZ9iMqw/mqdefault.jpg",
    "title": "【APEX】初めてのAPEX（3ヶ月ぶり）やる余",
    "publishedAt": "2020-12-19T18:01:23Z"
  },
  {
    "videoId": "CiQQ8zJUWOk",
    "thumbnail": "https://i.ytimg.com/vi/CiQQ8zJUWOk/mqdefault.jpg",
    "title": "【歌枠】ライブ直前！！！ドキドキ歌練習！！！！！",
    "publishedAt": "2020-12-20T15:56:31Z"
  },
  {
    "videoId": "NdGs2gKFyMA",
    "thumbnail": "https://i.ytimg.com/vi/NdGs2gKFyMA/mqdefault.jpg",
    "title": "【APEX】今日は勝てるかどきどきAPEX！！！！！！！",
    "publishedAt": "2020-12-26T16:29:29Z"
  },
  {
    "videoId": "4TYKG157gEQ",
    "thumbnail": "https://i.ytimg.com/vi/4TYKG157gEQ/mqdefault.jpg",
    "title": "【Among us】百鬼あやめ視点　どきどきごちゃまぜあもんがす！！！！～コミュ障発揮してます編～",
    "publishedAt": "2020-12-28T14:20:34Z"
  },
  {
    "videoId": "e7KI9_0zsck",
    "thumbnail": "https://i.ytimg.com/vi/e7KI9_0zsck/mqdefault.jpg",
    "title": "【謹賀新年】あけましておめでとう！！！！！！！2021年もよろしくおねがいします配信",
    "publishedAt": "2021-01-01T04:14:52Z"
  },
  {
    "videoId": "Nu0vyXUrdvU",
    "thumbnail": "https://i.ytimg.com/vi/Nu0vyXUrdvU/mqdefault.jpg",
    "title": "【歌枠】新年！！！！初歌！！！！！！！",
    "publishedAt": "2021-01-05T17:10:25Z"
  },
  {
    "videoId": "LMs6wjPP3aI",
    "thumbnail": "https://i.ytimg.com/vi/LMs6wjPP3aI/mqdefault.jpg",
    "title": "【Fall Guys】新シーズンきたからサクッと優勝していく余～ん",
    "publishedAt": "2021-01-07T15:53:59Z"
  },
  {
    "videoId": "xrQP_QPj33I",
    "thumbnail": "https://i.ytimg.com/vi/xrQP_QPj33I/mqdefault.jpg",
    "title": "【歌枠】歌強化するぞぉぉぉぉおぉぉお～～！",
    "publishedAt": "2021-01-10T16:23:05Z"
  },
  {
    "videoId": "h9isLVXCfEI",
    "thumbnail": "https://i.ytimg.com/vi/h9isLVXCfEI/mqdefault.jpg",
    "title": "【APEX】最協決定戦個人練習！！！",
    "publishedAt": "2021-01-20T17:53:01Z"
  },
  {
    "videoId": "aCau4w0ZFJ0",
    "thumbnail": "https://i.ytimg.com/vi/aCau4w0ZFJ0/mqdefault.jpg",
    "title": "【最協決定戦】チームGON!　百鬼あやめ / 現よみ/ 紫咲シオン　#GONWIN",
    "publishedAt": "2021-01-24T11:46:00Z"
  },
  {
    "videoId": "jHd7SPreuAQ",
    "thumbnail": "https://i.ytimg.com/vi/jHd7SPreuAQ/mqdefault.jpg",
    "title": "【歌枠】鼻がずびずびな気がするけれど歌うッッッ！！",
    "publishedAt": "2021-01-29T16:12:31Z"
  },
  {
    "videoId": "mIkObWAwMnc",
    "thumbnail": "https://i.ytimg.com/vi/mIkObWAwMnc/mqdefault.jpg",
    "title": "【APEX】シーズン８やっていく～～～～！！！！！",
    "publishedAt": "2021-02-05T17:38:16Z"
  },
  {
    "videoId": "pYl9ftYGYR8",
    "thumbnail": "https://i.ytimg.com/vi/pYl9ftYGYR8/mqdefault.jpg",
    "title": "【APEX】シーズン８ランク進める！！！！！！！！",
    "publishedAt": "2021-02-07T21:59:31Z"
  },
  {
    "videoId": "VmkbHpO1As0",
    "thumbnail": "https://i.ytimg.com/vi/VmkbHpO1As0/mqdefault.jpg",
    "title": "【晩酌】美味しいお酒を頂いたから飲みながら話す～～",
    "publishedAt": "2021-02-08T17:18:05Z"
  },
  {
    "videoId": "0nBTiAt2kbc",
    "thumbnail": "https://i.ytimg.com/vi/0nBTiAt2kbc/mqdefault.jpg",
    "title": "【歌枠】70万人ありがとう感謝祭！！！！！！！！",
    "publishedAt": "2021-02-11T18:16:22Z"
  },
  {
    "videoId": "rG0mRyPLQ6A",
    "thumbnail": "https://i.ytimg.com/vi/rG0mRyPLQ6A/mqdefault.jpg",
    "title": "【歌枠】ライブまであと2日！！！練習だあああおい！",
    "publishedAt": "2021-02-15T18:02:22Z"
  },
  {
    "videoId": "1BGPJ0tVPWs",
    "thumbnail": "https://i.ytimg.com/vi/1BGPJ0tVPWs/mqdefault.jpg",
    "title": "【振り返り】Bloom,ライブお疲れ様！！！！皆で振り返り🌸【 ホロライブ/百鬼あやめ 】",
    "publishedAt": "2021-02-18T18:53:54Z"
  },
  {
    "videoId": "P817n2JNdfI",
    "thumbnail": "https://i.ytimg.com/vi/P817n2JNdfI/mqdefault.jpg",
    "title": "【APEX】昼活で勝つ～～～～～～～～～～～～！",
    "publishedAt": "2021-02-25T07:18:08Z"
  },
  {
    "videoId": "3LUoe_-zrv8",
    "thumbnail": "https://i.ytimg.com/vi/3LUoe_-zrv8/mqdefault.jpg",
    "title": "【APEX】修行の旅に出ます　※ちょこっと発表もアリ！",
    "publishedAt": "2021-03-03T19:57:54Z"
  },
  {
    "videoId": "DdF3cl-IBlM",
    "thumbnail": "https://i.ytimg.com/vi/DdF3cl-IBlM/mqdefault.jpg",
    "title": "【APEX】あぺ修行僧に余はなる",
    "publishedAt": "2021-03-05T13:02:59Z"
  },
  {
    "videoId": "43NsdiPXeMQ",
    "thumbnail": "https://i.ytimg.com/vi/43NsdiPXeMQ/mqdefault.jpg",
    "title": "【APEX】一生懸命頑張っている余のあぺ",
    "publishedAt": "2021-03-05T19:41:17Z"
  },
  {
    "videoId": "ctNrfRXsg4I",
    "thumbnail": "https://i.ytimg.com/vi/ctNrfRXsg4I/mqdefault.jpg",
    "title": "【APEX】ぷらちなGOGO！！ぶんぶんぶ～～～～ん",
    "publishedAt": "2021-03-07T19:30:12Z"
  },
  {
    "videoId": "3kMSj4JuUqE",
    "thumbnail": "https://i.ytimg.com/vi/3kMSj4JuUqE/mqdefault.jpg",
    "title": "【Papers, Please】解雇寸前崖っぷち入国審査官",
    "publishedAt": "2021-03-12T16:09:11Z"
  },
  {
    "videoId": "Q8bHuJdgzqg",
    "thumbnail": "https://i.ytimg.com/vi/Q8bHuJdgzqg/mqdefault.jpg",
    "title": "【歌枠】花粉にダメージを食らい続けながら歌う配信",
    "publishedAt": "2021-03-19T18:56:48Z"
  },
  {
    "videoId": "c1cYfAw915A",
    "thumbnail": "https://i.ytimg.com/vi/c1cYfAw915A/mqdefault.jpg",
    "title": "【歌枠】ボイトレの成果はいかに・・・？",
    "publishedAt": "2021-03-27T18:24:41Z"
  },
  {
    "videoId": "B1ErENTsf2s",
    "thumbnail": "https://i.ytimg.com/vi/B1ErENTsf2s/mqdefault.jpg",
    "title": "【空気読み３】すー、うーん美味しい空気。",
    "publishedAt": "2021-03-28T16:57:16Z"
  },
  {
    "videoId": "rv6WD8R3lTo",
    "thumbnail": "https://i.ytimg.com/vi/rv6WD8R3lTo/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE】初心者ハンター！！一狩りいきます！！",
    "publishedAt": "2021-04-03T19:33:12Z"
  },
  {
    "videoId": "FGhIbI9AJr0",
    "thumbnail": "https://i.ytimg.com/vi/FGhIbI9AJr0/mqdefault.jpg",
    "title": "【歌枠】80万人無事に見届けられるのか…！？！？80万人チャレンジの巻",
    "publishedAt": "2021-04-05T17:26:47Z"
  },
  {
    "videoId": "wV1AGU0rxpw",
    "thumbnail": "https://i.ytimg.com/vi/wV1AGU0rxpw/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE】初心者ハンター修行2日目！！やさーしくやさーしく",
    "publishedAt": "2021-04-07T17:56:26Z"
  },
  {
    "videoId": "ZyUvqo-cu_g",
    "thumbnail": "https://i.ytimg.com/vi/ZyUvqo-cu_g/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE】初心者ハンター修行！肉焼くことだけが取り柄です！⚔⚔",
    "publishedAt": "2021-04-18T18:19:08Z"
  },
  {
    "videoId": "_BcPYef-66g",
    "thumbnail": "https://i.ytimg.com/vi/_BcPYef-66g/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE】視聴者参加型をやってみたいと思っているけど出来るかわからないモンハン",
    "publishedAt": "2021-04-26T20:09:16Z"
  },
  {
    "videoId": "uTO0KnDsVH0",
    "thumbnail": "https://i.ytimg.com/vi/uTO0KnDsVH0/mqdefault.jpg",
    "title": "【歌ってみた】KING / 百鬼あやめ cover",
    "publishedAt": "2021-04-29T11:00:17Z"
  },
  {
    "videoId": "K8V_SP5iulw",
    "thumbnail": "https://i.ytimg.com/vi/K8V_SP5iulw/mqdefault.jpg",
    "title": "【 雑談 】久しぶりの歌ってみたとても緊張しました感想会とおはなし",
    "publishedAt": "2021-04-29T18:08:25Z"
  },
  {
    "videoId": "dYtnP9s3QXs",
    "thumbnail": "https://i.ytimg.com/vi/dYtnP9s3QXs/mqdefault.jpg",
    "title": "【 #百鬼あやめ新衣装 】新衣装お披露目会！！！やっときたあああ！！！",
    "publishedAt": "2021-05-02T17:02:05Z"
  },
  {
    "videoId": "VH_lVKwgB-4",
    "thumbnail": "https://i.ytimg.com/vi/VH_lVKwgB-4/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE】あやるしモンハンライズ！！！一狩りいくぞおおおお！！【百鬼あやめ視点】",
    "publishedAt": "2021-05-09T18:34:07Z"
  },
  {
    "videoId": "pElhBw9EGt8",
    "thumbnail": "https://i.ytimg.com/vi/pElhBw9EGt8/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE】少しずつ成長してきたモンハン修行",
    "publishedAt": "2021-05-13T17:40:40Z"
  },
  {
    "videoId": "tRCzC1TJUo8",
    "thumbnail": "https://i.ytimg.com/vi/tRCzC1TJUo8/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE】納刀術を覚えた初心者剣士⚔⚔",
    "publishedAt": "2021-05-16T18:23:07Z"
  },
  {
    "videoId": "z1W4c7ym49Y",
    "thumbnail": "https://i.ytimg.com/vi/z1W4c7ym49Y/mqdefault.jpg",
    "title": "【歌ってみた】グッバイ宣言 / 百鬼あやめ cover",
    "publishedAt": "2021-05-22T12:00:16Z"
  },
  {
    "videoId": "df7hQS1JfDM",
    "thumbnail": "https://i.ytimg.com/vi/df7hQS1JfDM/mqdefault.jpg",
    "title": "【復活】やっと喋れる歌える！！！！お待たせしました！！！！！",
    "publishedAt": "2021-07-06T14:21:11Z"
  },
  {
    "videoId": "VZuRwKIr34k",
    "thumbnail": "https://i.ytimg.com/vi/VZuRwKIr34k/mqdefault.jpg",
    "title": "【100万人突破】チャンネル登録者100万人突破！！！！ばたばた感謝祭！！",
    "publishedAt": "2021-07-08T15:29:20Z"
  },
  {
    "videoId": "exIS9Etx71s",
    "thumbnail": "https://i.ytimg.com/vi/exIS9Etx71s/mqdefault.jpg",
    "title": "【スパチャ読み】復活と100万人記念のスパチャ読み＆おはなし！！",
    "publishedAt": "2021-07-16T14:17:20Z"
  },
  {
    "videoId": "d50ydKyP8vA",
    "thumbnail": "https://i.ytimg.com/vi/d50ydKyP8vA/mqdefault.jpg",
    "title": "【習字？】あぁ～～～！！なんだか習字をしたい気分だなぁ～！",
    "publishedAt": "2021-07-20T14:00:26Z"
  },
  {
    "videoId": "Phlmweq_EcA",
    "thumbnail": "https://i.ytimg.com/vi/Phlmweq_EcA/mqdefault.jpg",
    "title": "【歌枠】うたう余　※歌のリハビリします",
    "publishedAt": "2021-07-31T14:11:17Z"
  },
  {
    "videoId": "eGfyyU9qouA",
    "thumbnail": "https://i.ytimg.com/vi/eGfyyU9qouA/mqdefault.jpg",
    "title": "【歌ってみた】花に亡霊/ 百鬼あやめ cover",
    "publishedAt": "2021-08-08T12:00:28Z"
  },
  {
    "videoId": "4lr7Osefzoc",
    "thumbnail": "https://i.ytimg.com/vi/4lr7Osefzoc/mqdefault.jpg",
    "title": "【歌枠】新しいマイクで初の歌枠挑戦！！！🎤🎤✨",
    "publishedAt": "2021-08-16T17:43:19Z"
  },
  {
    "videoId": "qtHoQ71M9ok",
    "thumbnail": "https://i.ytimg.com/vi/qtHoQ71M9ok/mqdefault.jpg",
    "title": "【ポケモンユナイト】初心者練習頑張ります！！🔰🔰",
    "publishedAt": "2021-08-25T15:13:07Z"
  },
  {
    "videoId": "FNBIsexCXM0",
    "thumbnail": "https://i.ytimg.com/vi/FNBIsexCXM0/mqdefault.jpg",
    "title": "【#ゆるホロチームカート】運転ブロンズ一生懸命走ります！！！！！🚙🚙",
    "publishedAt": "2021-08-27T13:22:26Z"
  },
  {
    "videoId": "tJI7JKgLOnY",
    "thumbnail": "https://i.ytimg.com/vi/tJI7JKgLOnY/mqdefault.jpg",
    "title": "【＃百鬼あやめ3周年】皆々様のおかげで３周年！！ちょこっと凸待ちも…？重大告知もアリ！！！",
    "publishedAt": "2021-09-03T13:31:01Z"
  },
  {
    "videoId": "ylL8dKpG9QI",
    "thumbnail": "https://i.ytimg.com/vi/ylL8dKpG9QI/mqdefault.jpg",
    "title": "【雑談】３周年配信スパチャお礼＆雑談　グッズ裏話も…？👚🧸",
    "publishedAt": "2021-09-06T18:28:04Z"
  },
  {
    "videoId": "4H3Na-dhIY4",
    "thumbnail": "https://i.ytimg.com/vi/4H3Na-dhIY4/mqdefault.jpg",
    "title": "【リングフィットアドベンチャー】日頃の運動不足解消！？！？どこまでいけるか初挑戦！",
    "publishedAt": "2021-09-10T16:56:11Z"
  },
  {
    "videoId": "Tr78G5PJHNo",
    "thumbnail": "https://i.ytimg.com/vi/Tr78G5PJHNo/mqdefault.jpg",
    "title": "【 #ホロ地球防衛隊 】地球守るどーーーーーーーーー！！！！EDF！EDF！！！【ホロライブ/白上フブキ/百鬼あやめ/大神ミオ/角巻わため】",
    "publishedAt": "2021-09-26T12:06:30Z"
  },
  {
    "videoId": "wX6brfXzSXE",
    "thumbnail": "https://i.ytimg.com/vi/wX6brfXzSXE/mqdefault.jpg",
    "title": "【歌枠】最近ダンスの練習ばかりで歌ってない…！？！？！？修行だああ！！",
    "publishedAt": "2021-09-27T19:03:13Z"
  },
  {
    "videoId": "N0mQHlL7Qo4",
    "thumbnail": "https://i.ytimg.com/vi/N0mQHlL7Qo4/mqdefault.jpg",
    "title": "【３周年記念】祝３周年記念ライブ！！！宵の余、良い！！！！！！！🌸🌙　#百鬼あやめ３周年",
    "publishedAt": "2021-10-02T12:09:06Z"
  },
  {
    "videoId": "ECkxzFgbJqQ",
    "thumbnail": "https://i.ytimg.com/vi/ECkxzFgbJqQ/mqdefault.jpg",
    "title": "宵の余、良い！/ 百鬼あやめ original",
    "publishedAt": "2021-11-03T11:00:12Z"
  },
  {
    "videoId": "2xwmZMqMup8",
    "thumbnail": "https://i.ytimg.com/vi/2xwmZMqMup8/mqdefault.jpg",
    "title": "大変お待たせしました！！お久しぶりです！！！！！！！！！",
    "publishedAt": "2021-12-06T17:18:37Z"
  },
  {
    "videoId": "xaFIGjRembM",
    "thumbnail": "https://i.ytimg.com/vi/xaFIGjRembM/mqdefault.jpg",
    "title": "【歌枠】お歌の深夜練習会:(っ`ω´c):",
    "publishedAt": "2021-12-09T19:18:52Z"
  },
  {
    "videoId": "bn7OaRnM9-A",
    "thumbnail": "https://i.ytimg.com/vi/bn7OaRnM9-A/mqdefault.jpg",
    "title": "【生誕祭】百鬼あやめ 4th Birth Dayライブ!!!!!!!!!!! 　＃百鬼あやめ4th生誕祭",
    "publishedAt": "2021-12-13T12:08:28Z"
  },
  {
    "videoId": "9r3c-C96Irs",
    "thumbnail": "https://i.ytimg.com/vi/9r3c-C96Irs/mqdefault.jpg",
    "title": "【ポケモンBDSP】いくぜポケモンの旅！！仲間を求めていざ出陣～～～～！！",
    "publishedAt": "2021-12-19T17:37:15Z"
  },
  {
    "videoId": "JU5oiEYkbmE",
    "thumbnail": "https://i.ytimg.com/vi/JU5oiEYkbmE/mqdefault.jpg",
    "title": "【オンラインクレーンゲーム】ミオママと余のコラボグッズ取りたい！！！！！！",
    "publishedAt": "2021-12-23T14:57:37Z"
  },
  {
    "videoId": "SrHRlSW7as0",
    "thumbnail": "https://i.ytimg.com/vi/SrHRlSW7as0/mqdefault.jpg",
    "title": "【 #ホロクリスマス歌枠リレー 】めりーくりすます！！皆との歌枠リレー！！一生懸命歌います！！",
    "publishedAt": "2021-12-25T10:07:11Z"
  },
  {
    "videoId": "YrYgXgPbxmI",
    "thumbnail": "https://i.ytimg.com/vi/YrYgXgPbxmI/mqdefault.jpg",
    "title": "めり～くりすます～🎅",
    "publishedAt": "2021-12-25T10:29:30Z"
  },
  {
    "videoId": "qkawmOxU11Y",
    "thumbnail": "https://i.ytimg.com/vi/qkawmOxU11Y/mqdefault.jpg",
    "title": "【マリカ8DX】新年初あけましておめでとうマリカ！！補助輪遂に外します🔰🚗",
    "publishedAt": "2022-01-02T19:28:54Z"
  },
  {
    "videoId": "cWlluVQStVI",
    "thumbnail": "https://i.ytimg.com/vi/cWlluVQStVI/mqdefault.jpg",
    "title": "【 百鬼あやめ視点 】#ホロお正月CUP2022 補助輪を手放した鬼、走ります。🚗",
    "publishedAt": "2022-01-07T05:07:40Z"
  },
  {
    "videoId": "3enlAJJriIE",
    "thumbnail": "https://i.ytimg.com/vi/3enlAJJriIE/mqdefault.jpg",
    "title": "【歌枠】練習会会場🎤",
    "publishedAt": "2022-01-23T17:03:59Z"
  },
  {
    "videoId": "MiktlqTanck",
    "thumbnail": "https://i.ytimg.com/vi/MiktlqTanck/mqdefault.jpg",
    "title": "【歌枠】おうたをうたう！！！！！",
    "publishedAt": "2022-02-09T17:20:22Z"
  },
  {
    "videoId": "zmEqLY0Vy_M",
    "thumbnail": "https://i.ytimg.com/vi/zmEqLY0Vy_M/mqdefault.jpg",
    "title": "【ヘブンバーンズレッド】ホロライブヘブバンWEEK Day.2　百鬼あやめ",
    "publishedAt": "2022-02-11T11:44:17Z"
  },
  {
    "videoId": "GVwMDJeMLpc",
    "thumbnail": "https://i.ytimg.com/vi/GVwMDJeMLpc/mqdefault.jpg",
    "title": "【 Fall Guys 】バレンタインチョコ（１位）を皆にあげるべくがんばる🍫",
    "publishedAt": "2022-02-14T16:58:15Z"
  },
  {
    "videoId": "mJxiSWb2q1M",
    "thumbnail": "https://i.ytimg.com/vi/mJxiSWb2q1M/mqdefault.jpg",
    "title": "【 VALORANT 】トワちと一緒にヴぁろらんと～～～～😊 ＃あやトワ",
    "publishedAt": "2022-02-19T15:28:07Z"
  },
  {
    "videoId": "MF9UpVX-dAo",
    "thumbnail": "https://i.ytimg.com/vi/MF9UpVX-dAo/mqdefault.jpg",
    "title": "【APEX 】くろちゃんに介護してもらう会",
    "publishedAt": "2022-03-11T15:33:11Z"
  },
  {
    "videoId": "QXOSOs4SITc",
    "thumbnail": "https://i.ytimg.com/vi/QXOSOs4SITc/mqdefault.jpg",
    "title": "【#ゆるホロスプラ】久しぶりのイカぱぶろぉぉぉぉぉ～～！",
    "publishedAt": "2022-03-31T14:44:54Z"
  },
  {
    "videoId": "IWx6mh4WKOM",
    "thumbnail": "https://i.ytimg.com/vi/IWx6mh4WKOM/mqdefault.jpg",
    "title": "【ホロシチュエーションAmongUs】あもんぐあすって難しいって聞いたんですけど(´・ω・`)",
    "publishedAt": "2022-04-01T14:58:49Z"
  },
  {
    "videoId": "ObE-AeFGRJA",
    "thumbnail": "https://i.ytimg.com/vi/ObE-AeFGRJA/mqdefault.jpg",
    "title": "【おはなし】近況報告！少しおはなしする！",
    "publishedAt": "2022-05-28T11:47:26Z"
  },
  {
    "videoId": "l-hgfjVN7BM",
    "thumbnail": "https://i.ytimg.com/vi/l-hgfjVN7BM/mqdefault.jpg",
    "title": "【モーリーオンライン】余、いっぱいお菓子とか色々欲しい！！！！！！！！！！！！！",
    "publishedAt": "2022-05-29T12:55:38Z"
  },
  {
    "videoId": "bzGegZoav-I",
    "thumbnail": "https://i.ytimg.com/vi/bzGegZoav-I/mqdefault.jpg",
    "title": "【VALORANT】ヴぁろらんとやらんと",
    "publishedAt": "2022-06-03T12:49:35Z"
  },
  {
    "videoId": "QH17HGMM7fo",
    "thumbnail": "https://i.ytimg.com/vi/QH17HGMM7fo/mqdefault.jpg",
    "title": "【VALORANT】ヴぁろらんと練習するます！！！！！",
    "publishedAt": "2022-06-08T17:17:41Z"
  },
  {
    "videoId": "sAHqu-Vywi4",
    "thumbnail": "https://i.ytimg.com/vi/sAHqu-Vywi4/mqdefault.jpg",
    "title": "【おはなし】母なきりに色々聞いてみた！！！！！話とか色々！",
    "publishedAt": "2022-06-13T17:20:45Z"
  },
  {
    "videoId": "YPyHgTU7Hjg",
    "thumbnail": "https://i.ytimg.com/vi/YPyHgTU7Hjg/mqdefault.jpg",
    "title": "やっとみんなに会える！！！！！！！元気です！！！",
    "publishedAt": "2022-09-02T17:21:29Z"
  },
  {
    "videoId": "mwJGZ8YU7o4",
    "thumbnail": "https://i.ytimg.com/vi/mwJGZ8YU7o4/mqdefault.jpg",
    "title": "【＃百鬼あやめ４周年記念 / 3DLIVE】Nakiriayame 4th anniversary　~Hapiness to you ♡~",
    "publishedAt": "2022-09-03T12:23:01Z"
  },
  {
    "videoId": "5QVq6BaDdFg",
    "thumbnail": "https://i.ytimg.com/vi/5QVq6BaDdFg/mqdefault.jpg",
    "title": "【＃ホロAmongUs】よく分からないけど余じゃないと思います",
    "publishedAt": "2022-09-04T14:55:29Z"
  },
  {
    "videoId": "zryLA2VZ8H0",
    "thumbnail": "https://i.ytimg.com/vi/zryLA2VZ8H0/mqdefault.jpg",
    "title": "【Goonect 】鬼と幹部の絆はいかに…！？！？！？！？",
    "publishedAt": "2022-09-05T14:18:18Z"
  },
  {
    "videoId": "ma28TY9JyA8",
    "thumbnail": "https://i.ytimg.com/vi/ma28TY9JyA8/mqdefault.jpg",
    "title": "【スプラトゥーン３】スプラ３きちゃ～～～～～～～～！！！🦑🔰",
    "publishedAt": "2022-09-10T15:39:07Z"
  },
  {
    "videoId": "wo0mTA1iSD8",
    "thumbnail": "https://i.ytimg.com/vi/wo0mTA1iSD8/mqdefault.jpg",
    "title": "【スパチャ読み】４周年ライブ振り返り＆スパチャお礼雑談",
    "publishedAt": "2022-09-23T14:57:20Z"
  },
  {
    "videoId": "4doa3Ongv_Q",
    "thumbnail": "https://i.ytimg.com/vi/4doa3Ongv_Q/mqdefault.jpg",
    "title": "【 VALORANT 】ランクいくど～～～～～～～～！",
    "publishedAt": "2022-09-27T19:29:05Z"
  },
  {
    "videoId": "h0zNvpONM_A",
    "thumbnail": "https://i.ytimg.com/vi/h0zNvpONM_A/mqdefault.jpg",
    "title": "【スプラトゥーン３】みんなでわいわいすぷらつーーーん！#ホロスプラ部",
    "publishedAt": "2022-10-10T18:35:55Z"
  },
  {
    "videoId": "5_IYro0Ch_4",
    "thumbnail": "https://i.ytimg.com/vi/5_IYro0Ch_4/mqdefault.jpg",
    "title": "【 VALORANT 】あ、あっお、おおお邪魔します、、💎1",
    "publishedAt": "2022-10-13T20:11:49Z"
  },
  {
    "videoId": "BDu7VP2uY-Q",
    "thumbnail": "https://i.ytimg.com/vi/BDu7VP2uY-Q/mqdefault.jpg",
    "title": "【 #カプとれ 】余の分もももちろん取れるよね・・・？",
    "publishedAt": "2022-11-04T12:09:23Z"
  },
  {
    "videoId": "gvLng6_O_wE",
    "thumbnail": "https://i.ytimg.com/vi/gvLng6_O_wE/mqdefault.jpg",
    "title": "【 開封 】ホロクッキングくじ開封＆雑談！！余の出るかな～～！？",
    "publishedAt": "2022-11-11T18:23:11Z"
  },
  {
    "videoId": "Qoq7PICHReA",
    "thumbnail": "https://i.ytimg.com/vi/Qoq7PICHReA/mqdefault.jpg",
    "title": "あっ！なんだか”また”習字したくなってきちゃったなぁ～～～～～",
    "publishedAt": "2022-11-16T16:09:54Z"
  },
  {
    "videoId": "r-64EAl3ZTw",
    "thumbnail": "https://i.ytimg.com/vi/r-64EAl3ZTw/mqdefault.jpg",
    "title": "ゲリラヴぁろ活いくど～～～～～～～ん！",
    "publishedAt": "2022-11-17T15:30:03Z"
  },
  {
    "videoId": "CfALcaasl5A",
    "thumbnail": "https://i.ytimg.com/vi/CfALcaasl5A/mqdefault.jpg",
    "title": "【 ゲリラ 】機材新調した余～～～～～",
    "publishedAt": "2022-11-25T17:42:38Z"
  },
  {
    "videoId": "n64iaqGTNNc",
    "thumbnail": "https://i.ytimg.com/vi/n64iaqGTNNc/mqdefault.jpg",
    "title": "【 Cats Organized Neatly 】ねこちゃんパズルでのんびり～～🐈",
    "publishedAt": "2022-12-07T19:36:47Z"
  },
  {
    "videoId": "vXUVCOhnFv8",
    "thumbnail": "https://i.ytimg.com/vi/vXUVCOhnFv8/mqdefault.jpg",
    "title": "【 VALORANT 】逃げちゃだめだ逃げちゃだめだ逃げちゃだめ",
    "publishedAt": "2022-12-09T19:12:14Z"
  },
  {
    "videoId": "YilIMtJ_KY0",
    "thumbnail": "https://i.ytimg.com/vi/YilIMtJ_KY0/mqdefault.jpg",
    "title": "【A Dance of Fire and Ice】たんたんたんたんたんたんたんたんたんたんたんたん",
    "publishedAt": "2022-12-11T16:40:26Z"
  },
  {
    "videoId": "dafJZHFybUA",
    "thumbnail": "https://i.ytimg.com/vi/dafJZHFybUA/mqdefault.jpg",
    "title": "【カウントダウン】お誕生日カウントダウンしながら皆で晩酌だ～い・・！！🍶",
    "publishedAt": "2022-12-12T16:27:28Z"
  },
  {
    "videoId": "irMD1KMIYE4",
    "thumbnail": "https://i.ytimg.com/vi/irMD1KMIYE4/mqdefault.jpg",
    "title": "夢花火 / 百鬼あやめ original",
    "publishedAt": "2022-12-13T13:00:08Z"
  },
  {
    "videoId": "ojz7pUMiXtI",
    "thumbnail": "https://i.ytimg.com/vi/ojz7pUMiXtI/mqdefault.jpg",
    "title": "【お誕生日】誕生日だ～～～～い！！Nakiri ayame 5th Birth Day🎂",
    "publishedAt": "2022-12-13T13:24:34Z"
  },
  {
    "videoId": "y7QaeFBZSeY",
    "thumbnail": "https://i.ytimg.com/vi/y7QaeFBZSeY/mqdefault.jpg",
    "title": "【DAVE THE DIVER】 潜って潜ってお寿司作り～～🍣🍣！",
    "publishedAt": "2022-12-17T17:46:52Z"
  },
  {
    "videoId": "Xm_YWcbqly0",
    "thumbnail": "https://i.ytimg.com/vi/Xm_YWcbqly0/mqdefault.jpg",
    "title": "【#ホロクリスマス歌枠リレー 】何歌おっかな～～～～～～～～～～！",
    "publishedAt": "2022-12-25T07:41:38Z"
  },
  {
    "videoId": "4uQH85VJRGM",
    "thumbnail": "https://i.ytimg.com/vi/4uQH85VJRGM/mqdefault.jpg",
    "title": "【 #ホロお正月CUP2023 】つよ杯目指して！！Bブロックいざ出陣～～～～！！🚗",
    "publishedAt": "2023-01-07T06:56:39Z"
  },
  {
    "videoId": "ZyW_PbdSfsM",
    "thumbnail": "https://i.ytimg.com/vi/ZyW_PbdSfsM/mqdefault.jpg",
    "title": "【 #ホロお正月CUP2023 】つ・・・つよ杯・・・？",
    "publishedAt": "2023-01-07T09:01:50Z"
  },
  {
    "videoId": "FRQ3pM1dKLU",
    "thumbnail": "https://i.ytimg.com/vi/FRQ3pM1dKLU/mqdefault.jpg",
    "title": "【あけおめ】正月衣装2.0あけおめお披露目！新年雑談！",
    "publishedAt": "2023-01-08T16:49:52Z"
  },
  {
    "videoId": "VIeUROHP5ck",
    "thumbnail": "https://i.ytimg.com/vi/VIeUROHP5ck/mqdefault.jpg",
    "title": "【VALORANT】新マップ先行体験会！！！わーーーい！！",
    "publishedAt": "2023-01-09T07:17:36Z"
  },
  {
    "videoId": "c9ZmCn0krG8",
    "thumbnail": "https://i.ytimg.com/vi/c9ZmCn0krG8/mqdefault.jpg",
    "title": "【DAVE THE DIVER】へいお待ちぃ！！今日もいいネタある余ォ！＃２",
    "publishedAt": "2023-01-17T16:55:33Z"
  },
  {
    "videoId": "lmMvmtKojyk",
    "thumbnail": "https://i.ytimg.com/vi/lmMvmtKojyk/mqdefault.jpg",
    "title": "【新ホロ鯖】ミオちゃんと新しくなったホロ鯖探索＆拠点づくり！！",
    "publishedAt": "2023-01-26T13:24:55Z"
  },
  {
    "videoId": "L7AAFGBiaks",
    "thumbnail": "https://i.ytimg.com/vi/L7AAFGBiaks/mqdefault.jpg",
    "title": "【VALORANT】低気圧やばだけど負けない、ランクにも～！p1",
    "publishedAt": "2023-01-27T16:56:29Z"
  },
  {
    "videoId": "QbDSMCie9hk",
    "thumbnail": "https://i.ytimg.com/vi/QbDSMCie9hk/mqdefault.jpg",
    "title": "久しぶりのおはなし～",
    "publishedAt": "2023-01-31T16:24:32Z"
  },
  {
    "videoId": "k4IJROgvWHc",
    "thumbnail": "https://i.ytimg.com/vi/k4IJROgvWHc/mqdefault.jpg",
    "title": "【歌ってみた】キャットラビング / 百鬼あやめ cover",
    "publishedAt": "2023-02-14T11:00:10Z"
  },
  {
    "videoId": "6NVWbCRXRp8",
    "thumbnail": "https://i.ytimg.com/vi/6NVWbCRXRp8/mqdefault.jpg",
    "title": "【#ホロライブヘブバンWEEK】ヘブンバーンズレッド1周年記念！リベンジ・・！！いくぞおおおおお",
    "publishedAt": "2023-02-18T13:06:29Z"
  },
  {
    "videoId": "eRPMlb6IAiM",
    "thumbnail": "https://i.ytimg.com/vi/eRPMlb6IAiM/mqdefault.jpg",
    "title": "【感想会】EXPO＆hololive 4th fes. お疲れ様会！！",
    "publishedAt": "2023-03-20T16:58:10Z"
  },
  {
    "videoId": "hu404LVySXc",
    "thumbnail": "https://i.ytimg.com/vi/hu404LVySXc/mqdefault.jpg",
    "title": "【バイオハザード RE:2】『ロートＺ！』体験していく！👀  ✨",
    "publishedAt": "2023-03-27T12:42:49Z"
  },
  {
    "videoId": "MTCC2S5onHc",
    "thumbnail": "https://i.ytimg.com/vi/MTCC2S5onHc/mqdefault.jpg",
    "title": "久しぶりの新衣装お披露目だあああああ！！！！お披露目後重大告知アリ #百鬼あやめ新衣装",
    "publishedAt": "2023-03-29T15:16:24Z"
  },
  {
    "videoId": "3z1NjGqz9LE",
    "thumbnail": "https://i.ytimg.com/vi/3z1NjGqz9LE/mqdefault.jpg",
    "title": "2PCテストはいしん VALORANT",
    "publishedAt": "2023-04-04T15:49:25Z"
  },
  {
    "videoId": "id6mGNNq4ac",
    "thumbnail": "https://i.ytimg.com/vi/id6mGNNq4ac/mqdefault.jpg",
    "title": "【 Minecraft 】ミオちゃんとお家づくりする！",
    "publishedAt": "2023-04-06T11:33:13Z"
  },
  {
    "videoId": "y2JaT3VmNCM",
    "thumbnail": "https://i.ytimg.com/vi/y2JaT3VmNCM/mqdefault.jpg",
    "title": "【Q REMASTERED】余、解りました",
    "publishedAt": "2023-04-13T16:21:53Z"
  },
  {
    "videoId": "hgNaHOK-mcc",
    "thumbnail": "https://i.ytimg.com/vi/hgNaHOK-mcc/mqdefault.jpg",
    "title": "【晩酌】余と一緒に飲もう～～！！！🍶",
    "publishedAt": "2023-04-23T15:30:24Z"
  },
  {
    "videoId": "aXq6Wkz__dQ",
    "thumbnail": "https://i.ytimg.com/vi/aXq6Wkz__dQ/mqdefault.jpg",
    "title": "【VALORANT】目指せ汗修行 SOLO D1💎～",
    "publishedAt": "2023-04-28T17:27:04Z"
  },
  {
    "videoId": "UBaPrMu-lys",
    "thumbnail": "https://i.ytimg.com/vi/UBaPrMu-lys/mqdefault.jpg",
    "title": "【Duolingo】 STUDY ENGLISH!!!!",
    "publishedAt": "2023-04-29T06:32:36Z"
  },
  {
    "videoId": "t3WgB_gGzOg",
    "thumbnail": "https://i.ytimg.com/vi/t3WgB_gGzOg/mqdefault.jpg",
    "title": "【 VALORANT 】皆で新モード！！！チームデスマッチ体験会✨",
    "publishedAt": "2023-06-20T14:56:04Z"
  },
  {
    "videoId": "mySACB_aVAE",
    "thumbnail": "https://i.ytimg.com/vi/mySACB_aVAE/mqdefault.jpg",
    "title": "【歌ってみた】きゅうくらりん/ 百鬼あやめ cover",
    "publishedAt": "2023-06-30T12:00:06Z"
  },
  {
    "videoId": "0DDMc-NtSIY",
    "thumbnail": "https://i.ytimg.com/vi/0DDMc-NtSIY/mqdefault.jpg",
    "title": "【雑談】歌ってみたがあがりました余っと",
    "publishedAt": "2023-07-02T16:39:31Z"
  },
  {
    "videoId": "33gLXRHMXio",
    "thumbnail": "https://i.ytimg.com/vi/33gLXRHMXio/mqdefault.jpg",
    "title": "【VALORANT】一先ず振り分け戦‼やるぞお‼",
    "publishedAt": "2023-07-03T17:42:34Z"
  },
  {
    "videoId": "LcES_1wsQBU",
    "thumbnail": "https://i.ytimg.com/vi/LcES_1wsQBU/mqdefault.jpg",
    "title": "【雑談】あっちぃ余～～～～～～～～～～",
    "publishedAt": "2023-07-09T16:58:23Z"
  },
  {
    "videoId": "kvw9xAlppR8",
    "thumbnail": "https://i.ytimg.com/vi/kvw9xAlppR8/mqdefault.jpg",
    "title": "余の浴衣、可愛い？#ホロサマshorts #hololivesummer2023 #shorts",
    "publishedAt": "2023-07-11T03:00:31Z"
  },
  {
    "videoId": "0pG5J1N3--8",
    "thumbnail": "https://i.ytimg.com/vi/0pG5J1N3--8/mqdefault.jpg",
    "title": "【 VALORANT 】Aチーム：”それが大事”　チーム練習会！",
    "publishedAt": "2023-07-31T15:23:09Z"
  },
  {
    "videoId": "hLWhG9XKpBk",
    "thumbnail": "https://i.ytimg.com/vi/hLWhG9XKpBk/mqdefault.jpg",
    "title": "【 VALORANT 】Aチーム：”それが大事”　スクリム！顔合わせ練習！ #それが大事WIN #ホロヴァロ",
    "publishedAt": "2023-08-01T12:22:40Z"
  },
  {
    "videoId": "wh-e1z9MuPg",
    "thumbnail": "https://i.ytimg.com/vi/wh-e1z9MuPg/mqdefault.jpg",
    "title": "【VALORANT】hololive × VALORANT MEETUP powered by Holizontal【百鬼あやめ視点】＃それが大事WIN",
    "publishedAt": "2023-08-03T14:24:21Z"
  },
  {
    "videoId": "Yo15scrIbFg",
    "thumbnail": "https://i.ytimg.com/vi/Yo15scrIbFg/mqdefault.jpg",
    "title": "【雑談】最近どうなの余～～～～～～",
    "publishedAt": "2023-08-19T16:32:28Z"
  },
  {
    "videoId": "isKfR7BopUU",
    "thumbnail": "https://i.ytimg.com/vi/isKfR7BopUU/mqdefault.jpg",
    "title": "【歌ってみた】可愛くてごめん / 百鬼あやめ cover",
    "publishedAt": "2023-09-03T13:00:10Z"
  },
  {
    "videoId": "nwBxJMXRBbQ",
    "thumbnail": "https://i.ytimg.com/vi/nwBxJMXRBbQ/mqdefault.jpg",
    "title": "【５周年記念】５周年って・・・５周年ってコト！？お披露目＆最後に告知アリ！！ます！！！！！ #百鬼あやめ５周年",
    "publishedAt": "2023-09-03T13:23:05Z"
  },
  {
    "videoId": "gybNKVMAJ3U",
    "thumbnail": "https://i.ytimg.com/vi/gybNKVMAJ3U/mqdefault.jpg",
    "title": "【 DAVE THE DIVER 】バイトのお時間余～～～！🍣🍣 #3",
    "publishedAt": "2023-09-08T16:28:39Z"
  },
  {
    "videoId": "t2cIH3o1WA4",
    "thumbnail": "https://i.ytimg.com/vi/t2cIH3o1WA4/mqdefault.jpg",
    "title": "【 漢字でGO! 】漢字でYO!",
    "publishedAt": "2023-09-14T15:29:24Z"
  },
  {
    "videoId": "UaYXMlJHYAk",
    "thumbnail": "https://i.ytimg.com/vi/UaYXMlJHYAk/mqdefault.jpg",
    "title": "はなそう余",
    "publishedAt": "2023-09-23T15:32:44Z"
  },
  {
    "videoId": "Q__QStsIo44",
    "thumbnail": "https://i.ytimg.com/vi/Q__QStsIo44/mqdefault.jpg",
    "title": "マイクラ肝試し2023Virtual Week　#いろはにほへっとあやふぶみ #マイクラ肝試し2023",
    "publishedAt": "2023-10-01T11:30:24Z"
  },
  {
    "videoId": "GFdo2R-TXnI",
    "thumbnail": "https://i.ytimg.com/vi/GFdo2R-TXnI/mqdefault.jpg",
    "title": "【VALORANT】おひさしヴぁろらんと　動作確認がてら",
    "publishedAt": "2023-10-22T18:34:39Z"
  },
  {
    "videoId": "c9BIio0E9hY",
    "thumbnail": "https://i.ytimg.com/vi/c9BIio0E9hY/mqdefault.jpg",
    "title": "【 VALORANT 】女子カスタム参加、、いいんですか！？！？！？ ＃にじほろすぽ",
    "publishedAt": "2023-10-28T16:38:18Z"
  },
  {
    "videoId": "tHP7bd8Jtm0",
    "thumbnail": "https://i.ytimg.com/vi/tHP7bd8Jtm0/mqdefault.jpg",
    "title": "【 #ホロライブ大運動会2023 】白組優勝だあああああああああああああい！！！💙",
    "publishedAt": "2023-11-04T12:49:18Z"
  },
  {
    "videoId": "VQxOXJ3HTRU",
    "thumbnail": "https://i.ytimg.com/vi/VQxOXJ3HTRU/mqdefault.jpg",
    "title": "【 VALORANT 】V最協顔合わせ！！初めまして～～～～～～！！ドキドキ",
    "publishedAt": "2023-11-06T20:51:02Z"
  },
  {
    "videoId": "cnHtO-m7N9s",
    "thumbnail": "https://i.ytimg.com/vi/cnHtO-m7N9s/mqdefault.jpg",
    "title": "最近のおはなしとかとか～～！",
    "publishedAt": "2023-11-07T17:13:50Z"
  },
  {
    "videoId": "qf6iqsbWrUw",
    "thumbnail": "https://i.ytimg.com/vi/qf6iqsbWrUw/mqdefault.jpg",
    "title": "高音質ワイヤレスイヤホン AK UW100MKII を2人でレビュー！",
    "publishedAt": "2023-11-09T11:03:32Z"
  },
  {
    "videoId": "DWRAvM786MU",
    "thumbnail": "https://i.ytimg.com/vi/DWRAvM786MU/mqdefault.jpg",
    "title": "【VALORANT】ソロ練、いきます→ふるぱ参戦→フィジカル練習",
    "publishedAt": "2023-11-09T20:10:04Z"
  },
  {
    "videoId": "nQfY6hyyUT8",
    "thumbnail": "https://i.ytimg.com/vi/nQfY6hyyUT8/mqdefault.jpg",
    "title": "【VALORANT】V最練習いきます！！！！！！！！！！！！！！",
    "publishedAt": "2023-11-13T19:49:08Z"
  },
  {
    "videoId": "9FSrt9CfbDY",
    "thumbnail": "https://i.ytimg.com/vi/9FSrt9CfbDY/mqdefault.jpg",
    "title": "【VALORANT】V最チーム練習いっくどーーーーーーーー！！！！！！！！",
    "publishedAt": "2023-11-14T20:49:34Z"
  },
  {
    "videoId": "GAjBuyrd_zk",
    "thumbnail": "https://i.ytimg.com/vi/GAjBuyrd_zk/mqdefault.jpg",
    "title": "【VALORANT】V最スクリム1日目  #V最協A1",
    "publishedAt": "2023-11-15T19:35:22Z"
  },
  {
    "videoId": "4fC-Dk1pGVc",
    "thumbnail": "https://i.ytimg.com/vi/4fC-Dk1pGVc/mqdefault.jpg",
    "title": "【VALORANT】V最スクリム2日目  #V最協A1 #ちねるWIN",
    "publishedAt": "2023-11-16T18:41:38Z"
  },
  {
    "videoId": "0jX5Fphlmbw",
    "thumbnail": "https://i.ytimg.com/vi/0jX5Fphlmbw/mqdefault.jpg",
    "title": "【VALORANT】V最スクリム３日目  #V最協A1 #ちねるWIN",
    "publishedAt": "2023-11-17T17:52:35Z"
  },
  {
    "videoId": "7opZBjYVkcs",
    "thumbnail": "https://i.ytimg.com/vi/7opZBjYVkcs/mqdefault.jpg",
    "title": "【VALORANT】V最スクリム最終日！！VSべにさんチーム  #V最協A1 #ちねるWIN 【 百鬼あやめ /ホロライブ 】",
    "publishedAt": "2023-11-18T15:45:21Z"
  },
  {
    "videoId": "mE45wINuBPY",
    "thumbnail": "https://i.ytimg.com/vi/mE45wINuBPY/mqdefault.jpg",
    "title": "【VALORANT】VTuber最協決定戦 #V最協A1 #ちねるWIN 【 百鬼あやめ /ホロライブ 】",
    "publishedAt": "2023-11-19T15:40:54Z"
  },
  {
    "videoId": "IeoSkxkMSK8",
    "thumbnail": "https://i.ytimg.com/vi/IeoSkxkMSK8/mqdefault.jpg",
    "title": "【荒野行動】ぺこちゃんと一緒にHIKAKIN荒野バトルを遊んでいく余～ 【 百鬼あやめ /ホロライブ 】",
    "publishedAt": "2023-11-28T12:06:44Z"
  },
  {
    "videoId": "FOai83VIogA",
    "thumbnail": "https://i.ytimg.com/vi/FOai83VIogA/mqdefault.jpg",
    "title": "【 ＃百鬼あやめ生誕祭2023 】Nakiriayame 6th BirthDay  ～Shoot the heart～",
    "publishedAt": "2023-12-13T12:57:27Z"
  },
  {
    "videoId": "qQqHUcmtKXU",
    "thumbnail": "https://i.ytimg.com/vi/qQqHUcmtKXU/mqdefault.jpg",
    "title": "【雑談】話すことありすぎ問題ってはなし【百鬼あやめ/ホロライブ】",
    "publishedAt": "2023-12-14T17:59:20Z"
  },
  {
    "videoId": "jZDCbRsBf7s",
    "thumbnail": "https://i.ytimg.com/vi/jZDCbRsBf7s/mqdefault.jpg",
    "title": "【 ＃百鬼あやめ生誕祭2023 】Nakiriayame 6th BirthDay ～Shoot the heart～　「白い雪のプリンセスは」",
    "publishedAt": "2023-12-15T01:03:43Z"
  },
  {
    "videoId": "YheymNxBXcE",
    "thumbnail": "https://i.ytimg.com/vi/YheymNxBXcE/mqdefault.jpg",
    "title": "【同時視聴】hololive Xmas AR LIVE 『Sweet Happy Holiday』#イブはホロライブ【百鬼あやめ/ホロライブ】",
    "publishedAt": "2023-12-24T14:09:43Z"
  },
  {
    "videoId": "x-WiRmSqE6I",
    "thumbnail": "https://i.ytimg.com/vi/x-WiRmSqE6I/mqdefault.jpg",
    "title": "【雑談】あけおめ雑談🎍✨【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-01-06T15:14:04Z"
  },
  {
    "videoId": "IHrI7ypYkbs",
    "thumbnail": "https://i.ytimg.com/vi/IHrI7ypYkbs/mqdefault.jpg",
    "title": "【 #ホロお正月CUP2024 】予選まずいかもです【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-01-07T08:55:23Z"
  },
  {
    "videoId": "XQA-rbQ1zWc",
    "thumbnail": "https://i.ytimg.com/vi/XQA-rbQ1zWc/mqdefault.jpg",
    "title": "【 #ホロお正月CUP2024 】Eグループ本選いく余～～【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-01-08T09:17:30Z"
  },
  {
    "videoId": "98exkqLgtp0",
    "thumbnail": "https://i.ytimg.com/vi/98exkqLgtp0/mqdefault.jpg",
    "title": "【雑談】突然ですが【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-01-13T16:25:25Z"
  },
  {
    "videoId": "1e6GNF687Dc",
    "thumbnail": "https://i.ytimg.com/vi/1e6GNF687Dc/mqdefault.jpg",
    "title": "【Palworld】おにかんでホロ鯖パルワールド参戦！！！ #おにかん【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-01-24T16:57:10Z"
  },
  {
    "videoId": "DXmf9wbd0Uw",
    "thumbnail": "https://i.ytimg.com/vi/DXmf9wbd0Uw/mqdefault.jpg",
    "title": "【Palworld】ぱーるぱるぱるぱるぱる2日目【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-01-25T18:36:12Z"
  },
  {
    "videoId": "acSGWc8v5j4",
    "thumbnail": "https://i.ytimg.com/vi/acSGWc8v5j4/mqdefault.jpg",
    "title": "【新衣装お披露目】節分なので恵方巻と新衣装（？）※重大告知もアリ！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-02-03T14:00:17Z"
  },
  {
    "videoId": "04wObit0nS4",
    "thumbnail": "https://i.ytimg.com/vi/04wObit0nS4/mqdefault.jpg",
    "title": "【雑談】なーーーーーーにをはなそうかね【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-02-11T16:02:52Z"
  },
  {
    "videoId": "Nxj3exDxjqM",
    "thumbnail": "https://i.ytimg.com/vi/Nxj3exDxjqM/mqdefault.jpg",
    "title": "【雑談】5th fesお疲れ様でしたあああ！！感想とか裏話とかとか【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-03-18T16:41:29Z"
  },
  {
    "videoId": "hSmivjPHf0g",
    "thumbnail": "https://i.ytimg.com/vi/hSmivjPHf0g/mqdefault.jpg",
    "title": "【雑談】お花見行った余～🌸【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-04-12T15:48:50Z"
  },
  {
    "videoId": "M3EBQkpMO6Q",
    "thumbnail": "https://i.ytimg.com/vi/M3EBQkpMO6Q/mqdefault.jpg",
    "title": "【VCR RUST】スト鯖RUST初参戦🔰うおおおおおおおお！【百鬼あやめ/ホロライブ】#VCRRUST",
    "publishedAt": "2024-04-13T14:34:34Z"
  },
  {
    "videoId": "BTw4DLeHZ0Y",
    "thumbnail": "https://i.ytimg.com/vi/BTw4DLeHZ0Y/mqdefault.jpg",
    "title": "【VCR RUST】スト鯖RUST初参戦🔰1日目その２【百鬼あやめ/ホロライブ】#VCRRUST",
    "publishedAt": "2024-04-13T20:21:11Z"
  },
  {
    "videoId": "ixjnz8wkmbA",
    "thumbnail": "https://i.ytimg.com/vi/ixjnz8wkmbA/mqdefault.jpg",
    "title": "【VCR RUST】スト鯖RUST 2日目 世界についていきたい【百鬼あやめ/ホロライブ】#VCRRUST",
    "publishedAt": "2024-04-15T21:13:36Z"
  },
  {
    "videoId": "-U7vL9K6juI",
    "thumbnail": "https://i.ytimg.com/vi/-U7vL9K6juI/mqdefault.jpg",
    "title": "【VCR RUST】スト鯖RUST初心者🔰3日目【百鬼あやめ/ホロライブ】#VCRRUST",
    "publishedAt": "2024-04-16T19:00:20Z"
  },
  {
    "videoId": "Bby16eQtnDk",
    "thumbnail": "https://i.ytimg.com/vi/Bby16eQtnDk/mqdefault.jpg",
    "title": "【VCR RUST】スト鯖RUST初心者🔰４日目　新しい事もいろいろしたい！【百鬼あやめ/ホロライブ】#VCRRUST",
    "publishedAt": "2024-04-17T21:23:13Z"
  },
  {
    "videoId": "vgX5FiOzor8",
    "thumbnail": "https://i.ytimg.com/vi/vgX5FiOzor8/mqdefault.jpg",
    "title": "【VCR RUST】スト鯖RUST初心者🔰５日目　今日は踏まない余【百鬼あやめ/ホロライブ】#VCRRUST",
    "publishedAt": "2024-04-18T21:29:29Z"
  },
  {
    "videoId": "ALWu6_NCqXY",
    "thumbnail": "https://i.ytimg.com/vi/ALWu6_NCqXY/mqdefault.jpg",
    "title": "【VCR RUST】スト鯖RUST初心者🔰６日目　出来ることをできるだけ！【百鬼あやめ/ホロライブ】#VCRRUST",
    "publishedAt": "2024-04-19T21:29:06Z"
  },
  {
    "videoId": "fRt1-vIbnyc",
    "thumbnail": "https://i.ytimg.com/vi/fRt1-vIbnyc/mqdefault.jpg",
    "title": "【VCR RUST】スト鯖RUST初心者🔰  かぼトラ最終日🎃🐯【百鬼あやめ/ホロライブ】#VCRRUST",
    "publishedAt": "2024-04-21T19:08:26Z"
  },
  {
    "videoId": "VYQHDRKTVEw",
    "thumbnail": "https://i.ytimg.com/vi/VYQHDRKTVEw/mqdefault.jpg",
    "title": "【雑談】VCRおつかれさまでした！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-04-24T16:12:13Z"
  },
  {
    "videoId": "xJ54jXWtVRY",
    "thumbnail": "https://i.ytimg.com/vi/xJ54jXWtVRY/mqdefault.jpg",
    "title": "【Buckshot Roulette】命賭けのロシアンルーレット！？！！？【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-04-28T16:19:07Z"
  },
  {
    "videoId": "vuqXdLQBEDs",
    "thumbnail": "https://i.ytimg.com/vi/vuqXdLQBEDs/mqdefault.jpg",
    "title": "【Refind Self】性格が暴かれちゃう！？！？！？【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-05-04T16:25:19Z"
  },
  {
    "videoId": "jVGJdbA7gGg",
    "thumbnail": "https://i.ytimg.com/vi/jVGJdbA7gGg/mqdefault.jpg",
    "title": "【We Were Here Expeditions: The Friendship】おにかんは脱出できるのか・・！？【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-05-05T14:40:53Z"
  },
  {
    "videoId": "_oX-_Z4VmEg",
    "thumbnail": "https://i.ytimg.com/vi/_oX-_Z4VmEg/mqdefault.jpg",
    "title": "【俺だけレベルアップな件：ARISE】俺レベ新作ゲーム先行体験！！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-05-06T11:24:32Z"
  },
  {
    "videoId": "LbdzYDXnUWs",
    "thumbnail": "https://i.ytimg.com/vi/LbdzYDXnUWs/mqdefault.jpg",
    "title": "【VALORANT】認定戦おわらせにいきますか ！2/5【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-05-14T19:28:32Z"
  },
  {
    "videoId": "IOU5D84EaOE",
    "thumbnail": "https://i.ytimg.com/vi/IOU5D84EaOE/mqdefault.jpg",
    "title": "【歌枠】お歌のりはびり？？？？？？？【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-05-18T17:26:46Z"
  },
  {
    "videoId": "z5GZpyJ6VOQ",
    "thumbnail": "https://i.ytimg.com/vi/z5GZpyJ6VOQ/mqdefault.jpg",
    "title": "【VALORANT】汗ちゃれんじ1日目【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-05-24T17:39:02Z"
  },
  {
    "videoId": "ij7rO4MtUBg",
    "thumbnail": "https://i.ytimg.com/vi/ij7rO4MtUBg/mqdefault.jpg",
    "title": "おおおおおおおひさしぶりです！！！！！！！！！！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-07-21T17:02:05Z"
  },
  {
    "videoId": "yVbHrWYZCtw",
    "thumbnail": "https://i.ytimg.com/vi/yVbHrWYZCtw/mqdefault.jpg",
    "title": "顔合わせ おはじめまして!!!  1日目  #ハルヴァロ",
    "publishedAt": "2024-07-22T17:28:33Z"
  },
  {
    "videoId": "Y6C5YkUx6WQ",
    "thumbnail": "https://i.ytimg.com/vi/Y6C5YkUx6WQ/mqdefault.jpg",
    "title": "【#ハルヴァロ】チーム座学意味ないもん ！スクリム2日目  今日も学んでいきます！",
    "publishedAt": "2024-07-23T17:11:36Z"
  },
  {
    "videoId": "7YysmPdnNoc",
    "thumbnail": "https://i.ytimg.com/vi/7YysmPdnNoc/mqdefault.jpg",
    "title": "【#ハルヴァロ】チーム座学意味ないもん ！スクリム3日目  今日は勝ちたい ＃IMNIWIN",
    "publishedAt": "2024-07-24T17:42:26Z"
  },
  {
    "videoId": "03klm_3TYNw",
    "thumbnail": "https://i.ytimg.com/vi/03klm_3TYNw/mqdefault.jpg",
    "title": "【#ハルヴァロ】チーム座学意味ないもん ！スクリム最終日  フィジで破壊したい ＃IMNIWIN",
    "publishedAt": "2024-07-25T17:43:35Z"
  },
  {
    "videoId": "IBaKWz4SkEo",
    "thumbnail": "https://i.ytimg.com/vi/IBaKWz4SkEo/mqdefault.jpg",
    "title": "【#ハルヴァロ】チーム座学意味ないもん ！勝つぞぉおおおおおおお！！！ ＃IMNIWIN",
    "publishedAt": "2024-07-26T14:05:21Z"
  },
  {
    "videoId": "Ecckr7rCJTo",
    "thumbnail": "https://i.ytimg.com/vi/Ecckr7rCJTo/mqdefault.jpg",
    "title": "【 VALORANT 】大会おつかれさまでした！！！ちょっと雑談＆VALORANT",
    "publishedAt": "2024-07-29T18:45:01Z"
  },
  {
    "videoId": "nSAt9UDpqhI",
    "thumbnail": "https://i.ytimg.com/vi/nSAt9UDpqhI/mqdefault.jpg",
    "title": "#魔眼ウインク 踊った余〜💃 #shorts",
    "publishedAt": "2024-08-05T09:00:42Z"
  },
  {
    "videoId": "WWtpc7kuN88",
    "thumbnail": "https://i.ytimg.com/vi/WWtpc7kuN88/mqdefault.jpg",
    "title": "【STAGE:0 公認ウォッチパーティー】VALORANT部門日本一の王座に輝くのは誰だ！？【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-08-12T11:52:22Z"
  },
  {
    "videoId": "nKYJKC_9JN0",
    "thumbnail": "https://i.ytimg.com/vi/nKYJKC_9JN0/mqdefault.jpg",
    "title": "【お宝マウンテン】ホロメンたくさん積みあげちゃう余～～～～～～～～ん【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-08-21T15:32:09Z"
  },
  {
    "videoId": "u0H5ctcCL88",
    "thumbnail": "https://i.ytimg.com/vi/u0H5ctcCL88/mqdefault.jpg",
    "title": "【VALORANT】めいっぱいたのしむんだああああああ　#女子VALOカスタム【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-08-26T14:33:19Z"
  },
  {
    "videoId": "CZUropAFzms",
    "thumbnail": "https://i.ytimg.com/vi/CZUropAFzms/mqdefault.jpg",
    "title": "【雑談】え？今日で夏休み最後な・・・んですか・・？【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-08-31T14:41:40Z"
  },
  {
    "videoId": "RjVOWeHbOQE",
    "thumbnail": "https://i.ytimg.com/vi/RjVOWeHbOQE/mqdefault.jpg",
    "title": "【6周年】みんなとカウントダウンしたい！！！！！！！！わああああああ！！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-09-02T19:18:00Z"
  },
  {
    "videoId": "GDCq9cNnk50",
    "thumbnail": "https://i.ytimg.com/vi/GDCq9cNnk50/mqdefault.jpg",
    "title": "【アニメMV】melting／百鬼あやめ",
    "publishedAt": "2024-09-03T13:00:20Z"
  },
  {
    "videoId": "t8ER_WC8OaE",
    "thumbnail": "https://i.ytimg.com/vi/t8ER_WC8OaE/mqdefault.jpg",
    "title": "【6周年記念】みんなのお部屋見に行ってみる！！！！！！！👀👀　※最後に重大告知アリ【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-09-03T15:24:09Z"
  },
  {
    "videoId": "MgM4gOBOGvU",
    "thumbnail": "https://i.ytimg.com/vi/MgM4gOBOGvU/mqdefault.jpg",
    "title": "【 VALORANT 】新ACTれっつごーーーーーーーーーー！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-09-06T15:28:04Z"
  },
  {
    "videoId": "1iz9AxcgvPg",
    "thumbnail": "https://i.ytimg.com/vi/1iz9AxcgvPg/mqdefault.jpg",
    "title": "【 #holoGTA DAY1 】れっつごーぎゃんぐ！！ホロサントスの街にいざ上陸【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-09-17T16:40:50Z"
  },
  {
    "videoId": "Uxd8B4IqUps",
    "thumbnail": "https://i.ytimg.com/vi/Uxd8B4IqUps/mqdefault.jpg",
    "title": "【 nosh ナッシュ 】食レポ下手なんて言わせない・・・！実はユーザーでした。【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-09-18T04:40:00Z"
  },
  {
    "videoId": "JObFBptSfjc",
    "thumbnail": "https://i.ytimg.com/vi/JObFBptSfjc/mqdefault.jpg",
    "title": "【 #holoGTA DAY2 】ギャングのてっぺんとってやるんだ余【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-09-18T16:29:41Z"
  },
  {
    "videoId": "rf5WuO8f-K0",
    "thumbnail": "https://i.ytimg.com/vi/rf5WuO8f-K0/mqdefault.jpg",
    "title": "【 #holoGTA DAY3 】BIG GANG みりもん始動！！！！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-09-19T16:38:18Z"
  },
  {
    "videoId": "F0UZkCJS0Hc",
    "thumbnail": "https://i.ytimg.com/vi/F0UZkCJS0Hc/mqdefault.jpg",
    "title": "【 #holoGTA DAY4 】悪いコト沢山して荒稼ぎすっぞお～～～～～～～～～【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-09-20T16:50:01Z"
  },
  {
    "videoId": "M25h40KyC3M",
    "thumbnail": "https://i.ytimg.com/vi/M25h40KyC3M/mqdefault.jpg",
    "title": "【 #holoGTA DAY5 】遂に自分の車購入・・・・なるか！？！？！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-09-21T16:39:10Z"
  },
  {
    "videoId": "LkLNJ-K3368",
    "thumbnail": "https://i.ytimg.com/vi/LkLNJ-K3368/mqdefault.jpg",
    "title": "【 #holoGTA DAY6 】でっけえことかましてやるぜええええええ！！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-09-22T16:31:38Z"
  },
  {
    "videoId": "q8Kbl-HjkQ8",
    "thumbnail": "https://i.ytimg.com/vi/q8Kbl-HjkQ8/mqdefault.jpg",
    "title": "【 #holoGTA 最終日 】最高の最終日に！！！！！！！！！！！！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-09-23T17:56:45Z"
  },
  {
    "videoId": "EH9oqGrgar8",
    "thumbnail": "https://i.ytimg.com/vi/EH9oqGrgar8/mqdefault.jpg",
    "title": "【 #ホロAmongUs 】なにかあやしいですね・・・・【百鬼あやめ視点/ホロライブ】",
    "publishedAt": "2024-09-25T15:13:48Z"
  },
  {
    "videoId": "QCRzo8hkjIg",
    "thumbnail": "https://i.ytimg.com/vi/QCRzo8hkjIg/mqdefault.jpg",
    "title": "【Warframe】Warframeに初挑戦！？～Koumeiと五つの定め～【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-10-11T13:35:08Z"
  },
  {
    "videoId": "an1igiYaRpg",
    "thumbnail": "https://i.ytimg.com/vi/an1igiYaRpg/mqdefault.jpg",
    "title": "【#おにかん1ブロック】ロスせず生き残りたい。Day2【百鬼あやめ/鷹嶺ルイ/ホロライブ】",
    "publishedAt": "2024-11-03T14:42:24Z"
  },
  {
    "videoId": "O6zWA8QqDgA",
    "thumbnail": "https://i.ytimg.com/vi/O6zWA8QqDgA/mqdefault.jpg",
    "title": "【 VALORANT 】THE UNLOCKERS    3人でミッションをクリアせよ！？【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-11-06T16:58:34Z"
  },
  {
    "videoId": "wvPyJuVrHvc",
    "thumbnail": "https://i.ytimg.com/vi/wvPyJuVrHvc/mqdefault.jpg",
    "title": "【 VALORANT 】再チャレンジの段【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-11-25T18:55:02Z"
  },
  {
    "videoId": "hJ4nxRk3Isg",
    "thumbnail": "https://i.ytimg.com/vi/hJ4nxRk3Isg/mqdefault.jpg",
    "title": "【#ストリノヴァ】トワと一緒にStrinovaを遊んでみる余【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-11-26T11:33:26Z"
  },
  {
    "videoId": "PBPxW43Yylk",
    "thumbnail": "https://i.ytimg.com/vi/PBPxW43Yylk/mqdefault.jpg",
    "title": "【マクセルイズミ】 余がCVOに就任・・・！？【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-12-02T12:03:59Z"
  },
  {
    "videoId": "iqREj8RMq8A",
    "thumbnail": "https://i.ytimg.com/vi/iqREj8RMq8A/mqdefault.jpg",
    "title": "【雑談】いろいろ話したいけどなんだっけ？　※告知アリ【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-12-11T16:11:16Z"
  },
  {
    "videoId": "vV1wZ8eKTIQ",
    "thumbnail": "https://i.ytimg.com/vi/vV1wZ8eKTIQ/mqdefault.jpg",
    "title": "【前夜祭】誕生日カウントダウン！！！！！！みんなとお祝い！！！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-12-12T18:09:12Z"
  },
  {
    "videoId": "d4l17lJKhDE",
    "thumbnail": "https://i.ytimg.com/vi/d4l17lJKhDE/mqdefault.jpg",
    "title": "【 ＃百鬼あやめ生誕祭2024】Dream Festival‼ ～Nakiriayame 7th BirthDay～【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-12-13T11:57:25Z"
  },
  {
    "videoId": "-s7_EV3e-tA",
    "thumbnail": "https://i.ytimg.com/vi/-s7_EV3e-tA/mqdefault.jpg",
    "title": "【同時視聴】Riot Games ONE 2024 Offline Day x Watch Party【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-12-14T13:15:17Z"
  },
  {
    "videoId": "MK2zTP_Y1fo",
    "thumbnail": "https://i.ytimg.com/vi/MK2zTP_Y1fo/mqdefault.jpg",
    "title": "【歌枠】まぼろしのメリクリ歌枠🎅🎄【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-12-24T18:13:31Z"
  },
  {
    "videoId": "hAaP1bUUUT8",
    "thumbnail": "https://i.ytimg.com/vi/hAaP1bUUUT8/mqdefault.jpg",
    "title": "【年越し】今年もお世話になりました！！！一緒にカウントダウン【百鬼あやめ/ホロライブ】",
    "publishedAt": "2024-12-31T18:14:07Z"
  },
  {
    "videoId": "FTs607SsnF0",
    "thumbnail": "https://i.ytimg.com/vi/FTs607SsnF0/mqdefault.jpg",
    "title": "【雑談】あけおめ２０２５！！！今年の目標でも決めますか！！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-01-05T15:28:37Z"
  },
  {
    "videoId": "r8bYEXkz7fI",
    "thumbnail": "https://i.ytimg.com/vi/r8bYEXkz7fI/mqdefault.jpg",
    "title": "【アソビ大全】全CPUに勝つまで終われない！？ 五目並べ【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-01-07T13:52:01Z"
  },
  {
    "videoId": "LovFhtSbG0g",
    "thumbnail": "https://i.ytimg.com/vi/LovFhtSbG0g/mqdefault.jpg",
    "title": "【 #ホロ新春ゲーム祭2025 】おかゆんチーム🍙 ⛓️chained-together⛓️⁠ Fall guys がんばるどおおお！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-01-13T13:39:00Z"
  },
  {
    "videoId": "SaYAPbxc3ms",
    "thumbnail": "https://i.ytimg.com/vi/SaYAPbxc3ms/mqdefault.jpg",
    "title": "【占い】出張！ビッグゴッドミオーンの占いの館🔮 先生に2025年の運勢をみてもらう・・！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-01-14T12:11:16Z"
  },
  {
    "videoId": "0RG5AxPcRCQ",
    "thumbnail": "https://i.ytimg.com/vi/0RG5AxPcRCQ/mqdefault.jpg",
    "title": "【呪われたデジカメ】はいチーズ……………📸【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-01-18T15:13:51Z"
  },
  {
    "videoId": "APCPEZpL0i0",
    "thumbnail": "https://i.ytimg.com/vi/APCPEZpL0i0/mqdefault.jpg",
    "title": "【Fast Food Simulator】ホロナルド初出勤！！ここで働かせてください！🍔🍟✨【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-01-19T16:13:12Z"
  },
  {
    "videoId": "wmiitBstJXY",
    "thumbnail": "https://i.ytimg.com/vi/wmiitBstJXY/mqdefault.jpg",
    "title": "【Fast Food Simulator】本日も出勤させていただきます！！🍔🍟✨【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-01-26T15:55:43Z"
  },
  {
    "videoId": "_YRhzET4LWk",
    "thumbnail": "https://i.ytimg.com/vi/_YRhzET4LWk/mqdefault.jpg",
    "title": "【Fast Food Simulator】ナイトメアチャレンジいくぞおおおお！！！🍔🍟✨【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-01-27T15:06:32Z"
  },
  {
    "videoId": "55boWU5nWys",
    "thumbnail": "https://i.ytimg.com/vi/55boWU5nWys/mqdefault.jpg",
    "title": "【節分】みんなと一緒に恵方巻食べる！！！！！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-02-02T15:33:24Z"
  },
  {
    "videoId": "kO35itkD2cw",
    "thumbnail": "https://i.ytimg.com/vi/kO35itkD2cw/mqdefault.jpg",
    "title": "【歌枠】バレンタイン歌枠！？🍫💞告知アリ！！！！！！！！！！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-02-14T14:26:51Z"
  },
  {
    "videoId": "m7IMrXzB8go",
    "thumbnail": "https://i.ytimg.com/vi/m7IMrXzB8go/mqdefault.jpg",
    "title": "【 hololive 6th fes. 】ライブの感想＆お礼会！！　【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-03-10T09:39:34Z"
  },
  {
    "videoId": "1xq_7Y_vq64",
    "thumbnail": "https://i.ytimg.com/vi/1xq_7Y_vq64/mqdefault.jpg",
    "title": "百鬼あやめ ビジュアルアップデートお披露目【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-05-04T16:48:51Z"
  },
  {
    "videoId": "oqVBAFOV6Rs",
    "thumbnail": "https://i.ytimg.com/vi/oqVBAFOV6Rs/mqdefault.jpg",
    "title": "【スト６】はじめてのストリートファイター６！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-05-06T18:41:01Z"
  },
  {
    "videoId": "lUULGBMLJ3g",
    "thumbnail": "https://i.ytimg.com/vi/lUULGBMLJ3g/mqdefault.jpg",
    "title": "【スト６】トレモに山籠もり【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-05-13T17:44:13Z"
  },
  {
    "videoId": "LQYQKV8m-Yc",
    "thumbnail": "https://i.ytimg.com/vi/LQYQKV8m-Yc/mqdefault.jpg",
    "title": "【 That's Not My Neighbor 】なんか・・・変！！！！！！！！！！！！！！！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-05-31T15:46:19Z"
  },
  {
    "videoId": "AuwZPnHs0WU",
    "thumbnail": "https://i.ytimg.com/vi/AuwZPnHs0WU/mqdefault.jpg",
    "title": "【 #ホロ落選マリカ 】落、、、、、選、、、、？【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-06-05T14:24:58Z"
  },
  {
    "videoId": "k8tDVSzTWWA",
    "thumbnail": "https://i.ytimg.com/vi/k8tDVSzTWWA/mqdefault.jpg",
    "title": "【雑談】ざっつだんぬ【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-06-06T15:01:33Z"
  },
  {
    "videoId": "z5w2JfYSViU",
    "thumbnail": "https://i.ytimg.com/vi/z5w2JfYSViU/mqdefault.jpg",
    "title": "【 R.E.P.O. 】はじめてのれ　　　　　　ぽ！#みっころおにかん【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-06-07T15:39:01Z"
  },
  {
    "videoId": "ru5wYOdYSHU",
    "thumbnail": "https://i.ytimg.com/vi/ru5wYOdYSHU/mqdefault.jpg",
    "title": "【Galaxy Burger 】ハンバーガー屋さん開店！！いらっしゃいませ～🍔【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-06-10T17:09:09Z"
  },
  {
    "videoId": "IQNJqLNHe4g",
    "thumbnail": "https://i.ytimg.com/vi/IQNJqLNHe4g/mqdefault.jpg",
    "title": "【歌枠】るんるんるんるん♪【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-06-14T14:45:48Z"
  },
  {
    "videoId": "x2Foz4JaMYc",
    "thumbnail": "https://i.ytimg.com/vi/x2Foz4JaMYc/mqdefault.jpg",
    "title": "【 マリオカート8DX 】Switch2 抽選結果を待つ。時は来た【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-06-17T04:45:45Z"
  },
  {
    "videoId": "2ovSj-fsiM8",
    "thumbnail": "https://i.ytimg.com/vi/2ovSj-fsiM8/mqdefault.jpg",
    "title": "【朝活】おはｙ９おうございまｓづ【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-06-23T00:17:36Z"
  },
  {
    "videoId": "1CFlQycr7pA",
    "thumbnail": "https://i.ytimg.com/vi/1CFlQycr7pA/mqdefault.jpg",
    "title": "【プチプチおみせっち おまちど～さま!】きｔｙあああああああああああああああああああ【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-06-29T14:06:16Z"
  },
  {
    "videoId": "qQw7eJJbYd8",
    "thumbnail": "https://i.ytimg.com/vi/qQw7eJJbYd8/mqdefault.jpg",
    "title": "【 R.E.P.O. 】緊急で動画をまわしています #ホロREPO【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-07-02T17:54:29Z"
  },
  {
    "videoId": "wDVBMYPBvf4",
    "thumbnail": "https://i.ytimg.com/vi/wDVBMYPBvf4/mqdefault.jpg",
    "title": "【 雑談 】のほほん【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-07-03T16:01:12Z"
  },
  {
    "videoId": "IVZKfS_obNA",
    "thumbnail": "https://i.ytimg.com/vi/IVZKfS_obNA/mqdefault.jpg",
    "title": "【 雑談 】超ゲマDay1 おつかれさまでした！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-07-06T14:03:30Z"
  },
  {
    "videoId": "dlZiFqmlQEo",
    "thumbnail": "https://i.ytimg.com/vi/dlZiFqmlQEo/mqdefault.jpg",
    "title": "【 Steamサマーセール】リスナー＆ホロメンの！？おすすめゲーム調査！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-07-09T15:49:50Z"
  },
  {
    "videoId": "d63ZIAUHpR0",
    "thumbnail": "https://i.ytimg.com/vi/d63ZIAUHpR0/mqdefault.jpg",
    "title": "【 Backrooms Cleanup Crew 】#みっころおにかん お掃除隊出動ーーーッ！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-07-16T14:53:00Z"
  },
  {
    "videoId": "qq5Cm2vrg4s",
    "thumbnail": "https://i.ytimg.com/vi/qq5Cm2vrg4s/mqdefault.jpg",
    "title": "そのままの余がいちばん！だよね？#holonatsuParadise #ホロナツpiece #shorts",
    "publishedAt": "2025-07-17T09:30:25Z"
  },
  {
    "videoId": "IuRtRMsRuyQ",
    "thumbnail": "https://i.ytimg.com/vi/IuRtRMsRuyQ/mqdefault.jpg",
    "title": "【 #ホロ7DTDハード 】初のハードコア！DAY1 生き残れるのか・・！？【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-07-17T16:38:43Z"
  },
  {
    "videoId": "qkcBNoLaCQU",
    "thumbnail": "https://i.ytimg.com/vi/qkcBNoLaCQU/mqdefault.jpg",
    "title": "【 #ホロ7DTDハード 】DAY2 ゾンビ初襲撃・・！？【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-07-18T17:14:34Z"
  },
  {
    "videoId": "HtOdEmp6WI8",
    "thumbnail": "https://i.ytimg.com/vi/HtOdEmp6WI8/mqdefault.jpg",
    "title": "【 VALORANT 】ちょっと覗いてみますわ【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-07-19T14:18:25Z"
  },
  {
    "videoId": "VudFkMLdoYQ",
    "thumbnail": "https://i.ytimg.com/vi/VudFkMLdoYQ/mqdefault.jpg",
    "title": "【 VALORANT 】突然ですが【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-07-20T12:13:51Z"
  },
  {
    "videoId": "0NLw4O-z95c",
    "thumbnail": "https://i.ytimg.com/vi/0NLw4O-z95c/mqdefault.jpg",
    "title": "【 #ホロの花札 】初代女王決定戦！女王は一体誰の手に・・・！？【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-07-28T14:10:36Z"
  },
  {
    "videoId": "fAjrfM5Yyj8",
    "thumbnail": "https://i.ytimg.com/vi/fAjrfM5Yyj8/mqdefault.jpg",
    "title": "【 雑談 】ひさしぶりにまったり【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-07-29T14:06:50Z"
  },
  {
    "videoId": "CsVDCNUwFUg",
    "thumbnail": "https://i.ytimg.com/vi/CsVDCNUwFUg/mqdefault.jpg",
    "title": "【 VALORANT 】新しいマウス試してみる！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-08-02T09:41:49Z"
  },
  {
    "videoId": "sYyeIVErpPo",
    "thumbnail": "https://i.ytimg.com/vi/sYyeIVErpPo/mqdefault.jpg",
    "title": "【 歌枠 】久しぶりに歌う…！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-08-02T15:06:30Z"
  },
  {
    "videoId": "d9pq4ZLjGos",
    "thumbnail": "https://i.ytimg.com/vi/d9pq4ZLjGos/mqdefault.jpg",
    "title": "【 Minecraft 】#ホロ鯖サマーパーク おにかん夏祭りデート！？💖",
    "publishedAt": "2025-08-16T14:22:09Z"
  },
  {
    "videoId": "08tWy9YWmsA",
    "thumbnail": "https://i.ytimg.com/vi/08tWy9YWmsA/mqdefault.jpg",
    "title": "【 VALORANT 】ちょっとだけですからね【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-08-19T18:17:59Z"
  },
  {
    "videoId": "SzuAlTDREsc",
    "thumbnail": "https://i.ytimg.com/vi/SzuAlTDREsc/mqdefault.jpg",
    "title": "【 #カゲマス 】余、実装きちゃあああああああああああああああああ！【百鬼あやめ/鷹嶺ルイ/ホロライブ】",
    "publishedAt": "2025-08-21T11:22:21Z"
  },
  {
    "videoId": "5wOimVAtXoA",
    "thumbnail": "https://i.ytimg.com/vi/5wOimVAtXoA/mqdefault.jpg",
    "title": "【 歌枠 】重大告知アリ！な歌枠　【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-08-24T16:02:44Z"
  },
  {
    "videoId": "IiDk7VXOs0k",
    "thumbnail": "https://i.ytimg.com/vi/IiDk7VXOs0k/mqdefault.jpg",
    "title": "【 雑談 】皆と一緒に！！7周年カウントダウン！！うおおおおおお【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-09-02T16:42:29Z"
  },
  {
    "videoId": "aOcYn6YAO5E",
    "thumbnail": "https://i.ytimg.com/vi/aOcYn6YAO5E/mqdefault.jpg",
    "title": "花吹雪 / 百鬼あやめ original",
    "publishedAt": "2025-09-03T12:03:07Z"
  },
  {
    "videoId": "uRa-uLMea7w",
    "thumbnail": "https://i.ytimg.com/vi/uRa-uLMea7w/mqdefault.jpg",
    "title": "【 #百鬼あやめ7周年新衣装3D 】百鬼あやめ７周年記念ライブ  ～天女繚華～ 【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-09-03T12:10:48Z"
  },
  {
    "videoId": "6rwF8U-Zh4I",
    "thumbnail": "https://i.ytimg.com/vi/6rwF8U-Zh4I/mqdefault.jpg",
    "title": "7周年記念ライブ感想＆裏話...etc 振り返り！！！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-09-04T15:09:18Z"
  },
  {
    "videoId": "_p0828ivKrA",
    "thumbnail": "https://i.ytimg.com/vi/_p0828ivKrA/mqdefault.jpg",
    "title": "【#OMEN_HyperX_TGS2025】TGS直前の日本HPさんに殴り込みじゃあああああ【百鬼あやめ/常闇トワ/獅白ぼたん/ラプラス・ダークネス/ホロライブ】",
    "publishedAt": "2025-09-24T12:05:03Z"
  },
  {
    "videoId": "P4aKFkmV9Tk",
    "thumbnail": "https://i.ytimg.com/vi/P4aKFkmV9Tk/mqdefault.jpg",
    "title": "【 VALORANT 】V最チーム７顔合わせ　よろしくおねがいします！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-10-30T18:23:58Z"
  },
  {
    "videoId": "BxrIJzA4DpU",
    "thumbnail": "https://i.ytimg.com/vi/BxrIJzA4DpU/mqdefault.jpg",
    "title": "【 VALORANT 】V最チーム７ DAY2【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-10-31T19:00:11Z"
  },
  {
    "videoId": "qoNEDzHqAuU",
    "thumbnail": "https://i.ytimg.com/vi/qoNEDzHqAuU/mqdefault.jpg",
    "title": "【新衣装お披露目】遂にこの時が来た…ッ！！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-01T13:01:05Z"
  },
  {
    "videoId": "b5UOXcp65fU",
    "thumbnail": "https://i.ytimg.com/vi/b5UOXcp65fU/mqdefault.jpg",
    "title": "【 VALORANT 】V最チーム７ DAY3 引きちぎっていく【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-01T17:10:38Z"
  },
  {
    "videoId": "zygVJq_DaV8",
    "thumbnail": "https://i.ytimg.com/vi/zygVJq_DaV8/mqdefault.jpg",
    "title": "【 VALORANT 】V最チーム７ DAY4  昨日よりも上へ【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-02T16:52:38Z"
  },
  {
    "videoId": "qBVZw90APDU",
    "thumbnail": "https://i.ytimg.com/vi/qBVZw90APDU/mqdefault.jpg",
    "title": "【 VALORANT 】V最チーム７ DAY5  ショーティマスターに余はなる！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-03T16:50:41Z"
  },
  {
    "videoId": "3fxxpBnhbZw",
    "thumbnail": "https://i.ytimg.com/vi/3fxxpBnhbZw/mqdefault.jpg",
    "title": "【 VALORANT 】V最チーム７ スクリム初日 VS猫汰チーム！勝つぞおおお  【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-05T18:24:32Z"
  },
  {
    "videoId": "h9zCwBOBr_g",
    "thumbnail": "https://i.ytimg.com/vi/h9zCwBOBr_g/mqdefault.jpg",
    "title": "【 VALORANT 】V最チーム７ スクリム2日 VS小柳チーム！  【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-06T17:17:12Z"
  },
  {
    "videoId": "A7GNqnjpl5E",
    "thumbnail": "https://i.ytimg.com/vi/A7GNqnjpl5E/mqdefault.jpg",
    "title": "【 VALORANT 】V最チーム７ スクリム3日 VS ツルギチーム！  【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-07T17:59:22Z"
  },
  {
    "videoId": "d1j5cJQyfzo",
    "thumbnail": "https://i.ytimg.com/vi/d1j5cJQyfzo/mqdefault.jpg",
    "title": "【 VALORANT 】チーム先いけ忍者 #SINWIN スクリム最終日 VS白那チーム！  【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-08T15:02:01Z"
  },
  {
    "videoId": "sDMJBt4YLE8",
    "thumbnail": "https://i.ytimg.com/vi/sDMJBt4YLE8/mqdefault.jpg",
    "title": "【 VALORANT 】V最本番 『先いけ忍者WIN』 #SINWIN   【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-09T10:36:12Z"
  },
  {
    "videoId": "GjGO_T8hZQY",
    "thumbnail": "https://i.ytimg.com/vi/GjGO_T8hZQY/mqdefault.jpg",
    "title": "【雑談】V最お疲れ様＆まったりチル雑談【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-12T15:50:48Z"
  },
  {
    "videoId": "LA8w_IJWY94",
    "thumbnail": "https://i.ytimg.com/vi/LA8w_IJWY94/mqdefault.jpg",
    "title": "先いけ忍者 二次会会場！【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-13T13:28:27Z"
  },
  {
    "videoId": "3pOqL7Iicvg",
    "thumbnail": "https://i.ytimg.com/vi/3pOqL7Iicvg/mqdefault.jpg",
    "title": "先いけ忍者 三次会らしい【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-13T15:34:24Z"
  },
  {
    "videoId": "jFi544Ac9uQ",
    "thumbnail": "https://i.ytimg.com/vi/jFi544Ac9uQ/mqdefault.jpg",
    "title": "【VALORANT】 スカーミッシュトーナメント　一回負けたら即終了 Day1【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-15T14:14:10Z"
  },
  {
    "videoId": "XlMH2wmCMTw",
    "thumbnail": "https://i.ytimg.com/vi/XlMH2wmCMTw/mqdefault.jpg",
    "title": "【VALORANT】 スカーミッシュトーナメント　一回負けたら即終了 Day2  w/ロボ子さん、Meiyさん 【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-16T11:27:00Z"
  },
  {
    "videoId": "vcqm3j4fQ3A",
    "thumbnail": "https://i.ytimg.com/vi/vcqm3j4fQ3A/mqdefault.jpg",
    "title": "【 DEVOUR 】スカーミッシュ敗退罰ゲーム w/ロボ子さん、Meiyさん【百鬼あやめ/ホロライブ】",
    "publishedAt": "2025-11-16T14:36:54Z"
  }
],
  Aqua :
  [
  {
    "videoId": "S3CAGeeMRvo",
    "thumbnail": "https://i.ytimg.com/vi/S3CAGeeMRvo/mqdefault.jpg",
    "title": "【自己紹介】はじめまして、湊あくあです！",
    "publishedAt": "2018-08-08T14:50:56Z"
  },
  {
    "videoId": "mj9-GDUwDuk",
    "thumbnail": "https://i.ytimg.com/vi/mj9-GDUwDuk/mqdefault.jpg",
    "title": "【鬼畜】キノコが出るたびにテンションが上がるマリオカート8 with えーちゃん",
    "publishedAt": "2018-12-30T15:19:37Z"
  },
  {
    "videoId": "2oVs_gxR8Wg",
    "thumbnail": "https://i.ytimg.com/vi/2oVs_gxR8Wg/mqdefault.jpg",
    "title": "【Vtuber】ホロライブレジスタンス出陣【悲しみを乗り越えて】",
    "publishedAt": "2019-01-11T15:41:45Z"
  },
  {
    "videoId": "1-CbtYkvrjA",
    "thumbnail": "https://i.ytimg.com/vi/1-CbtYkvrjA/mqdefault.jpg",
    "title": "【反省】ホロライブ鯖へ、今までありがとう・・・【Minecraft】",
    "publishedAt": "2019-02-02T05:36:13Z"
  },
  {
    "videoId": "-aB6MQU8l1s",
    "thumbnail": "https://i.ytimg.com/vi/-aB6MQU8l1s/mqdefault.jpg",
    "title": "【バレンタインに】インドア系ならトラックメイカー／湊あくあ【歌ってみた】",
    "publishedAt": "2019-02-14T12:43:43Z"
  },
  {
    "videoId": "49bm_Zxck2k",
    "thumbnail": "https://i.ytimg.com/vi/49bm_Zxck2k/mqdefault.jpg",
    "title": "【Vtuber】超ハイスペックPCでホロライブ本社爆破してみたｗｗｗｗｗｗｗ【Minecraft】",
    "publishedAt": "2019-03-04T15:51:18Z"
  },
  {
    "videoId": "4iiBcjeUFdU",
    "thumbnail": "https://i.ytimg.com/vi/4iiBcjeUFdU/mqdefault.jpg",
    "title": "【Vtuber】リコーダー演奏会【神回】",
    "publishedAt": "2019-03-28T14:46:19Z"
  },
  {
    "videoId": "WmVXxYj1cdY",
    "thumbnail": "https://i.ytimg.com/vi/WmVXxYj1cdY/mqdefault.jpg",
    "title": "【Vtuber】新メンバーに捧ぐピアニカ演奏会",
    "publishedAt": "2019-04-06T13:53:43Z"
  },
  {
    "videoId": "BacoqH2e86U",
    "thumbnail": "https://i.ytimg.com/vi/BacoqH2e86U/mqdefault.jpg",
    "title": "【祝3D化】湊あくあ3Dお披露目生放送【#湊あくあ3D】",
    "publishedAt": "2019-04-08T14:34:53Z"
  },
  {
    "videoId": "oHZmwVYBST0",
    "thumbnail": "https://i.ytimg.com/vi/oHZmwVYBST0/mqdefault.jpg",
    "title": "【3D化】脱ぷにぷに！？伝説の3Dダイエット配信【WiiFit】",
    "publishedAt": "2019-04-27T12:40:13Z"
  },
  {
    "videoId": "YB9JeE0KK5k",
    "thumbnail": "https://i.ytimg.com/vi/YB9JeE0KK5k/mqdefault.jpg",
    "title": "【#湊あくあ3D】運動音痴でもちゃんと踊れるもん！【リズム天国で9万人記念枠】",
    "publishedAt": "2019-05-28T12:47:55Z"
  },
  {
    "videoId": "fNArtBpLho8",
    "thumbnail": "https://i.ytimg.com/vi/fNArtBpLho8/mqdefault.jpg",
    "title": "【耐久配信】ダイヤのクワが壊れるまで地面を耕すだけの生放送【Minecraft】",
    "publishedAt": "2019-06-07T17:06:49Z"
  },
  {
    "videoId": "uXYXC0jaN74",
    "thumbnail": "https://i.ytimg.com/vi/uXYXC0jaN74/mqdefault.jpg",
    "title": "【チームNASS】今日の夜ご飯は茄子そうめん！【Minecraft】",
    "publishedAt": "2019-08-03T17:13:39Z"
  },
  {
    "videoId": "O8v5S1nhKzo",
    "thumbnail": "https://i.ytimg.com/vi/O8v5S1nhKzo/mqdefault.jpg",
    "title": "【１周年記念】ダダダダ天使／湊あくあ【歌ってみた】",
    "publishedAt": "2019-08-17T14:14:39Z"
  },
  {
    "videoId": "c5epucj2uGU",
    "thumbnail": "https://i.ytimg.com/vi/c5epucj2uGU/mqdefault.jpg",
    "title": "【混ぜるな危険】陰キャ×陽キャ!?交じりあう危険物コラボ！【Minecraft】",
    "publishedAt": "2019-09-03T16:01:07Z"
  },
  {
    "videoId": "JiuC5rPlUDQ",
    "thumbnail": "https://i.ytimg.com/vi/JiuC5rPlUDQ/mqdefault.jpg",
    "title": "【Ver2.0お披露目会】生まれ変わった湊あくあに萌えたら即ツイート【#湊あくあ生放送】",
    "publishedAt": "2019-09-14T12:59:40Z"
  },
  {
    "videoId": "BjZecMBGx2k",
    "thumbnail": "https://i.ytimg.com/vi/BjZecMBGx2k/mqdefault.jpg",
    "title": "【新モデル耐久】ゼロからエンドラ初討伐するまで眠らない！【Minecraft】",
    "publishedAt": "2019-09-14T23:07:56Z"
  },
  {
    "videoId": "2OI5ZZoVEBc",
    "thumbnail": "https://i.ytimg.com/vi/2OI5ZZoVEBc/mqdefault.jpg",
    "title": "【涙の最終回】ホロライブ鯖へ、今までありがとう・・・【#湊あくあ生放送】",
    "publishedAt": "2019-10-11T10:20:55Z"
  },
  {
    "videoId": "N99L2ALq2LI",
    "thumbnail": "https://i.ytimg.com/vi/N99L2ALq2LI/mqdefault.jpg",
    "title": "【Minecraft】知らぬ間に共有鯖がすごい発展してるってマ？【湊あくあ/浦島あく太郎】",
    "publishedAt": "2019-11-02T11:25:46Z"
  },
  {
    "videoId": "E_1lhnRLtww",
    "thumbnail": "https://i.ytimg.com/vi/E_1lhnRLtww/mqdefault.jpg",
    "title": "【Minecraft】全ロスに負けずにトライデント耐久準備・・・！【湊あくあ/瀕死】",
    "publishedAt": "2019-11-02T20:22:53Z"
  },
  {
    "videoId": "wreRY3R064k",
    "thumbnail": "https://i.ytimg.com/vi/wreRY3R064k/mqdefault.jpg",
    "title": "【地獄耐久】激レア武器『トライデント』手に入れるまで終われない！【Minecraft/湊あくあ】",
    "publishedAt": "2019-11-03T23:04:03Z"
  },
  {
    "videoId": "GW_-YuCQCDE",
    "thumbnail": "https://i.ytimg.com/vi/GW_-YuCQCDE/mqdefault.jpg",
    "title": "【耐久】マリオカート8DXで『２連続１位』取れるまで終われない！【湊あくあ/絶対優勝卍】",
    "publishedAt": "2019-11-10T01:31:38Z"
  },
  {
    "videoId": "23y5h8kQsv8",
    "thumbnail": "https://i.ytimg.com/vi/23y5h8kQsv8/mqdefault.jpg",
    "title": "【 #ホロライブ杯 】目指すは『優勝』、ただそれだけ！【湊あくあ/絶対優勝卍】",
    "publishedAt": "2019-11-10T12:31:05Z"
  },
  {
    "videoId": "MzgvKiKYGHM",
    "thumbnail": "https://i.ytimg.com/vi/MzgvKiKYGHM/mqdefault.jpg",
    "title": "【（視聴者が）耐久】湊あくあが釣りするところを１時間見守る配信【湊あくあ】",
    "publishedAt": "2019-11-14T15:58:00Z"
  },
  {
    "videoId": "NECjE0zNko0",
    "thumbnail": "https://i.ytimg.com/vi/NECjE0zNko0/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖で一人きり…？そうだ！いたずらしよう！【湊あくあ】",
    "publishedAt": "2019-11-16T15:39:43Z"
  },
  {
    "videoId": "jwZ5fDJ_XnU",
    "thumbnail": "https://i.ytimg.com/vi/jwZ5fDJ_XnU/mqdefault.jpg",
    "title": "【Minecraft】自動収穫機で世界のじゃがいもを食べ尽くす！【湊あくあ/ソラニン中毒】",
    "publishedAt": "2019-11-23T16:22:17Z"
  },
  {
    "videoId": "lfb2wr-Ba70",
    "thumbnail": "https://i.ytimg.com/vi/lfb2wr-Ba70/mqdefault.jpg",
    "title": "【#湊あくあ３D】まさかの展開！？あくあ×おかゆ３Dコラボ！！【湊あくあ/猫又おかゆ】",
    "publishedAt": "2019-11-26T14:25:43Z"
  },
  {
    "videoId": "qwThaj6I2QI",
    "thumbnail": "https://i.ytimg.com/vi/qwThaj6I2QI/mqdefault.jpg",
    "title": "【#3D狂人A】今夜、決着をつける！バチバチ決戦三本勝負コラボ！！【湊あくあ/友人A】",
    "publishedAt": "2019-11-27T14:50:42Z"
  },
  {
    "videoId": "X33257dr9nU",
    "thumbnail": "https://i.ytimg.com/vi/X33257dr9nU/mqdefault.jpg",
    "title": "【#アズールレーン】検証！湊あくあは100連建造で何人の自分を呼び出せるの？【湊あくあ】",
    "publishedAt": "2019-11-28T12:39:58Z"
  },
  {
    "videoId": "0fTmEfBvp50",
    "thumbnail": "https://i.ytimg.com/vi/0fTmEfBvp50/mqdefault.jpg",
    "title": "【誕生日に】Ubiquitous dB／湊あくあ【歌ってみた】",
    "publishedAt": "2019-12-08T13:15:11Z"
  },
  {
    "videoId": "uEZUH76Y32s",
    "thumbnail": "https://i.ytimg.com/vi/uEZUH76Y32s/mqdefault.jpg",
    "title": "【神回？】１位の時以外しゃべれないマリオカート8DX【湊あくあ/卍解】",
    "publishedAt": "2019-12-08T14:35:17Z"
  },
  {
    "videoId": "et4afyloaDM",
    "thumbnail": "https://i.ytimg.com/vi/et4afyloaDM/mqdefault.jpg",
    "title": "【Minecraft】クリスマスツリーの上に住みたい！！！【湊あくあ】",
    "publishedAt": "2019-12-18T15:21:31Z"
  },
  {
    "videoId": "Ru7DkI-5Z0Y",
    "thumbnail": "https://i.ytimg.com/vi/Ru7DkI-5Z0Y/mqdefault.jpg",
    "title": "【女王のイキリ】上位安定の最強戦術『打開』の力に溺れた結果…【マリオカート8DX】",
    "publishedAt": "2019-12-19T09:00:16Z"
  },
  {
    "videoId": "qg-RM8Y2fLM",
    "thumbnail": "https://i.ytimg.com/vi/qg-RM8Y2fLM/mqdefault.jpg",
    "title": "【Minecraft】あくあサンタとクリスマス準備しよっ！！！【湊あくあ】",
    "publishedAt": "2019-12-23T11:10:48Z"
  },
  {
    "videoId": "oKzDuDVxcgU",
    "thumbnail": "https://i.ytimg.com/vi/oKzDuDVxcgU/mqdefault.jpg",
    "title": "【Minecraft】おかゆがレジスタンス面接にやってきた！【湊あくあ/猫又おかゆ】",
    "publishedAt": "2019-12-27T11:36:09Z"
  },
  {
    "videoId": "ezzSnXQoSh8",
    "thumbnail": "https://i.ytimg.com/vi/ezzSnXQoSh8/mqdefault.jpg",
    "title": "【Minecraft】ホロライブメンバーに爆破ドッキリ仕掛けるぞ！準備編【湊あくあ/ホロライブレジスタンス】",
    "publishedAt": "2019-12-28T07:42:19Z"
  },
  {
    "videoId": "fdvuyvXTNEs",
    "thumbnail": "https://i.ytimg.com/vi/fdvuyvXTNEs/mqdefault.jpg",
    "title": "【リベンジ】ホロライブメンバーに爆破ドッキリしたら絶対に面白い説【Minecraft/湊あくあ】",
    "publishedAt": "2019-12-29T09:30:16Z"
  },
  {
    "videoId": "TB06WTVuDFk",
    "thumbnail": "https://i.ytimg.com/vi/TB06WTVuDFk/mqdefault.jpg",
    "title": "【Minecraft】▼和服メイドは新衣装を貰ってウキウキ気分なようです。【湊あくあ/あげぽよ】",
    "publishedAt": "2020-01-02T13:15:35Z"
  },
  {
    "videoId": "HxRCOOKTvsQ",
    "thumbnail": "https://i.ytimg.com/vi/HxRCOOKTvsQ/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖を秘密の地下通路で繋げたら影の支配者になれるのだ？【湊あくあ/IQ400】",
    "publishedAt": "2020-01-05T09:41:21Z"
  },
  {
    "videoId": "hOleS05Au9c",
    "thumbnail": "https://i.ytimg.com/vi/hOleS05Au9c/mqdefault.jpg",
    "title": "【3Dコラボ】初コラボでガチバトル！？真の筋肉マスターはこの私だ！【白銀ノエル/湊あくあ/リングフィットアドベンチャー】",
    "publishedAt": "2020-01-06T14:43:33Z"
  },
  {
    "videoId": "ssc5UsitGQo",
    "thumbnail": "https://i.ytimg.com/vi/ssc5UsitGQo/mqdefault.jpg",
    "title": "【 #ムングラ 】帰ってきた幻の四人組！今度はオフコラボで暴れまくる！【マリオパーティー】",
    "publishedAt": "2020-01-07T13:56:00Z"
  },
  {
    "videoId": "tXP-KzZrFj0",
    "thumbnail": "https://i.ytimg.com/vi/tXP-KzZrFj0/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖全土に私のトラップ付き地下帝国を張り巡らせるのだ！【湊あくあ/IQ11111】",
    "publishedAt": "2020-01-11T08:43:36Z"
  },
  {
    "videoId": "eCVkaWF7W2U",
    "thumbnail": "https://i.ytimg.com/vi/eCVkaWF7W2U/mqdefault.jpg",
    "title": "【Minecraft】地下アジトドッキリ計画でメンバーを舎弟にしてみせるのだ！【湊あくあ/しんだ世界戦線】",
    "publishedAt": "2020-01-13T09:39:27Z"
  },
  {
    "videoId": "yn0qEFUzux4",
    "thumbnail": "https://i.ytimg.com/vi/yn0qEFUzux4/mqdefault.jpg",
    "title": "【極秘任務】猫又おかゆに爆破ドッキリを仕掛けてやるのだ！！【湊あくあ/芸術は爆発】",
    "publishedAt": "2020-01-15T15:26:35Z"
  },
  {
    "videoId": "KsHfyEsJP9s",
    "thumbnail": "https://i.ytimg.com/vi/KsHfyEsJP9s/mqdefault.jpg",
    "title": "【Minecraft】次のドッキリ対象は誰だ・・！？秘密のトラップを張り巡らせるのだ！【反省会/湊あくあ】",
    "publishedAt": "2020-01-16T14:55:02Z"
  },
  {
    "videoId": "O6_2PqwYBC0",
    "thumbnail": "https://i.ytimg.com/vi/O6_2PqwYBC0/mqdefault.jpg",
    "title": "【Minecraft】秘密の地下アジトがバレてきた？これは『秘策』の出番かな・・！！【湊あくあ】",
    "publishedAt": "2020-01-20T15:22:24Z"
  },
  {
    "videoId": "x0Y_yoYivnM",
    "thumbnail": "https://i.ytimg.com/vi/x0Y_yoYivnM/mqdefault.jpg",
    "title": "【Minecraft】雲より高いガラスの道！？地上５０００ｍに天空あくあロードつくるのだ！【湊あくあ/だいてんし】",
    "publishedAt": "2020-01-21T15:06:54Z"
  },
  {
    "videoId": "DIcVCnvqwgA",
    "thumbnail": "https://i.ytimg.com/vi/DIcVCnvqwgA/mqdefault.jpg",
    "title": "【耐久】裏ボス『ウィザー』の討伐報酬を天空拠点に飾るまで終わらないのだ！【湊あくあ】",
    "publishedAt": "2020-01-26T10:31:27Z"
  },
  {
    "videoId": "qFOafAWSrSw",
    "thumbnail": "https://i.ytimg.com/vi/qFOafAWSrSw/mqdefault.jpg",
    "title": "【夜勤事件】クリア耐久！流行りに乗り遅れたメイド、それでも見てくれますか・・？【湊あくあ/ホロライブ】",
    "publishedAt": "2020-03-05T16:11:15Z"
  },
  {
    "videoId": "o7i-07_wQpI",
    "thumbnail": "https://i.ytimg.com/vi/o7i-07_wQpI/mqdefault.jpg",
    "title": "【あつ森🌲】徹夜確定？魚図鑑🐡全種類コンプリートするまで眠れない生放送！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-03-21T11:09:19Z"
  },
  {
    "videoId": "_ejOOQ-Tbnk",
    "thumbnail": "https://i.ytimg.com/vi/_ejOOQ-Tbnk/mqdefault.jpg",
    "title": "【あつ森🌲】12時間確定☆魚図鑑🐡全種類コンプリートするまで眠れない生放送！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-03-21T12:34:06Z"
  },
  {
    "videoId": "C1Mp0SKSmj0",
    "thumbnail": "https://i.ytimg.com/vi/C1Mp0SKSmj0/mqdefault.jpg",
    "title": "【企画】島求む！リスナーさんの自慢の島に遊びにいく生放送！！！",
    "publishedAt": "2020-03-28T12:42:26Z"
  },
  {
    "videoId": "PmKonidlvlQ",
    "thumbnail": "https://i.ytimg.com/vi/PmKonidlvlQ/mqdefault.jpg",
    "title": "【視聴者参加型】あつ森🌳リスナーさんの島に遊びにいっちゃうぞ☆【湊あくあ/ホロライブ】",
    "publishedAt": "2020-03-31T14:41:37Z"
  },
  {
    "videoId": "0rU7ybW7wO0",
    "thumbnail": "https://i.ytimg.com/vi/0rU7ybW7wO0/mqdefault.jpg",
    "title": "【初配信】はじめまして！新人メイドのAKUKINです！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-04-01T12:49:46Z"
  },
  {
    "videoId": "bRSiYWNsdpk",
    "thumbnail": "https://i.ytimg.com/vi/bRSiYWNsdpk/mqdefault.jpg",
    "title": "【決戦】行くぞ！一位の時以外しゃべれないマリオカート８DXだ！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-04-02T15:36:32Z"
  },
  {
    "videoId": "PFT0bzdIvh0",
    "thumbnail": "https://i.ytimg.com/vi/PFT0bzdIvh0/mqdefault.jpg",
    "title": "【🌸アニメ映像有】グレイプニル第３話みんなで一緒にみよおお！！【ホロライブ/夏色まつり・湊あくあ・宝鐘マリン】",
    "publishedAt": "2020-04-19T15:32:01Z"
  },
  {
    "videoId": "aU_T6zGk7eE",
    "thumbnail": "https://i.ytimg.com/vi/aU_T6zGk7eE/mqdefault.jpg",
    "title": "【APEX】ソロダイアモンドちゃれんじっ！一日目！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-04-29T06:30:20Z"
  },
  {
    "videoId": "vqhj1a0MCR4",
    "thumbnail": "https://i.ytimg.com/vi/vqhj1a0MCR4/mqdefault.jpg",
    "title": "まったりおはなしっ！＆『Ver２.１』あっぷでーとだっ！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-04-30T16:28:43Z"
  },
  {
    "videoId": "vRizsX9i57g",
    "thumbnail": "https://i.ytimg.com/vi/vRizsX9i57g/mqdefault.jpg",
    "title": "【APEX】最終回！ソロダイアモンドになるまでおわらない！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-05-10T17:22:48Z"
  },
  {
    "videoId": "pN6OIBfvIls",
    "thumbnail": "https://i.ytimg.com/vi/pN6OIBfvIls/mqdefault.jpg",
    "title": "【APEX】ソロダイアモンド達成の瞬間！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-05-10T20:25:18Z"
  },
  {
    "videoId": "m7fP8RMgCKk",
    "thumbnail": "https://i.ytimg.com/vi/m7fP8RMgCKk/mqdefault.jpg",
    "title": "【APEXガチャ】魂の１５０連ガチャでスーパーレジェンドを狙い撃つ！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-05-15T15:47:20Z"
  },
  {
    "videoId": "LDb02sw5bSk",
    "thumbnail": "https://i.ytimg.com/vi/LDb02sw5bSk/mqdefault.jpg",
    "title": "【APEX】超耐久！１００キルするまでおわらない・・・！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-05-16T16:24:04Z"
  },
  {
    "videoId": "FjQoPMlGsHc",
    "thumbnail": "https://i.ytimg.com/vi/FjQoPMlGsHc/mqdefault.jpg",
    "title": "【APEXガチャ】魂の１５０連ガチャで今日こそ幸せになりたい・・・！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-05-17T05:20:09Z"
  },
  {
    "videoId": "PksApsNDfB8",
    "thumbnail": "https://i.ytimg.com/vi/PksApsNDfB8/mqdefault.jpg",
    "title": "【Minecraft】ホ ロ 鯖 に 舞 い 降 り た 天 使 【湊あくあ/ホロライブ】",
    "publishedAt": "2020-05-20T15:10:33Z"
  },
  {
    "videoId": "JC54FFRk-jw",
    "thumbnail": "https://i.ytimg.com/vi/JC54FFRk-jw/mqdefault.jpg",
    "title": "【Minecraft】 ホ ロ 鯖 天 空 爆 破 ド ッ キ リ 計 画  【湊あくあ/ホロライブ】",
    "publishedAt": "2020-05-22T16:35:22Z"
  },
  {
    "videoId": "Ajnxmj0GcoM",
    "thumbnail": "https://i.ytimg.com/vi/Ajnxmj0GcoM/mqdefault.jpg",
    "title": "【復活のスマブラSP】VS視聴者『40連戦』全員まとめてかかってこい！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-05-23T17:01:27Z"
  },
  {
    "videoId": "2J7erW4AtGg",
    "thumbnail": "https://i.ytimg.com/vi/2J7erW4AtGg/mqdefault.jpg",
    "title": "【#あくシオ隣人戦争 】ホ ロ 鯖 爆 破 ド ッ キ リ 計 画 本 番 【湊あくあ/ホロライブ】",
    "publishedAt": "2020-05-27T13:34:30Z"
  },
  {
    "videoId": "o41aBPpm8nQ",
    "thumbnail": "https://i.ytimg.com/vi/o41aBPpm8nQ/mqdefault.jpg",
    "title": "【 #走れあくあ 】チャンネル５０万人達成を目指して１時間っ！走り続けるんだ！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-05-30T12:53:23Z"
  },
  {
    "videoId": "TPtVUCi1AMI",
    "thumbnail": "https://i.ytimg.com/vi/TPtVUCi1AMI/mqdefault.jpg",
    "title": "【Minecraft】ホ ロ 鯖 復 興 大 作 戦  第 一 話  【湊あくあ/ホロライブ】",
    "publishedAt": "2020-06-03T15:32:06Z"
  },
  {
    "videoId": "-RbriUA8MJ4",
    "thumbnail": "https://i.ytimg.com/vi/-RbriUA8MJ4/mqdefault.jpg",
    "title": "【ついに】３週間分のおはなしっ！いまっ！ここに集えっ！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-06-23T14:09:27Z"
  },
  {
    "videoId": "sIZZdz0F2Gw",
    "thumbnail": "https://i.ytimg.com/vi/sIZZdz0F2Gw/mqdefault.jpg",
    "title": "【放送事故】ぴえん【湊あくあ/ホロライブ】",
    "publishedAt": "2020-06-26T12:34:16Z"
  },
  {
    "videoId": "O0YlcpHc6bU",
    "thumbnail": "https://i.ytimg.com/vi/O0YlcpHc6bU/mqdefault.jpg",
    "title": "【 #あくあマリンの絆 】負けるたびに体が消えていく・・！？『真・闇のゲーム』開戦！【どうぶつタワーバトル】",
    "publishedAt": "2020-07-02T12:44:27Z"
  },
  {
    "videoId": "3ileSPonDXI",
    "thumbnail": "https://i.ytimg.com/vi/3ileSPonDXI/mqdefault.jpg",
    "title": "【 #ホロARK探検隊 】 復 活 の A R K 【湊あくあ/ホロライブ】",
    "publishedAt": "2020-07-05T15:29:21Z"
  },
  {
    "videoId": "J-qsc-0_aUQ",
    "thumbnail": "https://i.ytimg.com/vi/J-qsc-0_aUQ/mqdefault.jpg",
    "title": "【負けない】今話題の！ロリダークソウルをクリアまで！！【Little Witch Nobeta/湊あくあ】",
    "publishedAt": "2020-07-05T17:21:22Z"
  },
  {
    "videoId": "lNyPXqfe7p0",
    "thumbnail": "https://i.ytimg.com/vi/lNyPXqfe7p0/mqdefault.jpg",
    "title": "【湊あくあ】 重 大 発 表 【ホロライブ】",
    "publishedAt": "2020-07-06T13:01:36Z"
  },
  {
    "videoId": "gR-7-np5H3w",
    "thumbnail": "https://i.ytimg.com/vi/gR-7-np5H3w/mqdefault.jpg",
    "title": "【 #チームNASS 】ドキッ☆地獄の七夕たこ焼きパーティ！やよ～！",
    "publishedAt": "2020-07-07T13:51:18Z"
  },
  {
    "videoId": "mOBvvwCosE4",
    "thumbnail": "https://i.ytimg.com/vi/mOBvvwCosE4/mqdefault.jpg",
    "title": "【#湊あくあ3D 】だんだん身体が沈んでいく世界…。",
    "publishedAt": "2020-07-09T14:07:29Z"
  },
  {
    "videoId": "Q9yLd9yXiTA",
    "thumbnail": "https://i.ytimg.com/vi/Q9yLd9yXiTA/mqdefault.jpg",
    "title": "【APEX/ソロ】シルバー⇒ダイアモンド ちゃれんじっ！【１日目】",
    "publishedAt": "2020-07-11T10:26:04Z"
  },
  {
    "videoId": "UOauD2qP5fE",
    "thumbnail": "https://i.ytimg.com/vi/UOauD2qP5fE/mqdefault.jpg",
    "title": "ん゛あ゛あ゛あ゛あ゛あ゛あ゛",
    "publishedAt": "2020-07-13T02:30:04Z"
  },
  {
    "videoId": "PdDptrN4feU",
    "thumbnail": "https://i.ytimg.com/vi/PdDptrN4feU/mqdefault.jpg",
    "title": "【切り抜き】みなとあくあのさいなん！～地獄のコラボ編～",
    "publishedAt": "2020-07-14T09:45:01Z"
  },
  {
    "videoId": "9pHkss5g6os",
    "thumbnail": "https://i.ytimg.com/vi/9pHkss5g6os/mqdefault.jpg",
    "title": "【湊あくあ】世界一ド派手なデコイトラップに騙されたんだけど・・？【APEX Stream HighLights①】",
    "publishedAt": "2020-07-15T02:45:00Z"
  },
  {
    "videoId": "0I4GalfuhDo",
    "thumbnail": "https://i.ytimg.com/vi/0I4GalfuhDo/mqdefault.jpg",
    "title": "【壺男RTA】１０分でクリアしたい人生だった【一日目】",
    "publishedAt": "2020-07-19T09:42:05Z"
  },
  {
    "videoId": "bj7AUQGm0D8",
    "thumbnail": "https://i.ytimg.com/vi/bj7AUQGm0D8/mqdefault.jpg",
    "title": "【Slither.io】世界一位です。（予言）",
    "publishedAt": "2020-07-19T16:42:49Z"
  },
  {
    "videoId": "Rp0RXltfPgA",
    "thumbnail": "https://i.ytimg.com/vi/Rp0RXltfPgA/mqdefault.jpg",
    "title": "【#壺男RTAちゃれんじっ】私の山登りを見てほしい。【​Day 2】",
    "publishedAt": "2020-07-20T10:57:09Z"
  },
  {
    "videoId": "dI_ND573rKM",
    "thumbnail": "https://i.ytimg.com/vi/dI_ND573rKM/mqdefault.jpg",
    "title": "【雀魂】『人生初役満』or『+15万点』するまで終われない麻雀部",
    "publishedAt": "2020-07-20T15:40:37Z"
  },
  {
    "videoId": "EOuSsjNs7ko",
    "thumbnail": "https://i.ytimg.com/vi/EOuSsjNs7ko/mqdefault.jpg",
    "title": "【#壺男RTAちゃれんじっ】 覚 醒 の 日【​Day 3】",
    "publishedAt": "2020-07-21T11:46:55Z"
  },
  {
    "videoId": "WdaV_mOeuOE",
    "thumbnail": "https://i.ytimg.com/vi/WdaV_mOeuOE/mqdefault.jpg",
    "title": "【APEX】プラチナまで！シルバー⇒ダイアモンド ちゃれんじっ！【４日目】",
    "publishedAt": "2020-07-21T16:49:07Z"
  },
  {
    "videoId": "UVZH-x8jpyQ",
    "thumbnail": "https://i.ytimg.com/vi/UVZH-x8jpyQ/mqdefault.jpg",
    "title": "【報告】隠しごとを叫びきったら即終了【休むな！８分音符ちゃん】",
    "publishedAt": "2020-07-22T13:48:08Z"
  },
  {
    "videoId": "abP9iH3I0bY",
    "thumbnail": "https://i.ytimg.com/vi/abP9iH3I0bY/mqdefault.jpg",
    "title": "【APEX】脱魔境！シルバー⇒ダイアモンド ちゃれんじっ！",
    "publishedAt": "2020-07-23T07:51:36Z"
  },
  {
    "videoId": "7kGw1NU9a58",
    "thumbnail": "https://i.ytimg.com/vi/7kGw1NU9a58/mqdefault.jpg",
    "title": "感謝と涙のホラーゲーム",
    "publishedAt": "2020-07-23T13:52:31Z"
  },
  {
    "videoId": "CTixPfOAtD4",
    "thumbnail": "https://i.ytimg.com/vi/CTixPfOAtD4/mqdefault.jpg",
    "title": "【 #週間APEX 】私の金アーマー盗まないでぇ・・・(つд⊂)【APEX LEGENDS Stream Highlights】",
    "publishedAt": "2020-07-24T11:50:21Z"
  },
  {
    "videoId": "I5sAMerT5to",
    "thumbnail": "https://i.ytimg.com/vi/I5sAMerT5to/mqdefault.jpg",
    "title": "【幽霊列車】う゛あ゛あ゛あ゛あ゛あ゛【in本社スタジオ】",
    "publishedAt": "2020-07-27T15:36:31Z"
  },
  {
    "videoId": "ug-J1RPVK6k",
    "thumbnail": "https://i.ytimg.com/vi/ug-J1RPVK6k/mqdefault.jpg",
    "title": "【世界一位】このゲームには必勝法がある【Slither.io】",
    "publishedAt": "2020-07-30T11:00:52Z"
  },
  {
    "videoId": "hcu8HMk-Zro",
    "thumbnail": "https://i.ytimg.com/vi/hcu8HMk-Zro/mqdefault.jpg",
    "title": "【The Elder Scrolls V: Skyrim】完全初見！メイド、冒険の旅に出る！",
    "publishedAt": "2020-07-30T19:32:34Z"
  },
  {
    "videoId": "qFcisTLgkMY",
    "thumbnail": "https://i.ytimg.com/vi/qFcisTLgkMY/mqdefault.jpg",
    "title": "【Jump King】ク リ ア 耐 久 ｜最 強 の 鬼 畜 ゲ ー ム",
    "publishedAt": "2020-08-01T02:26:20Z"
  },
  {
    "videoId": "E0ptngGsd04",
    "thumbnail": "https://i.ytimg.com/vi/E0ptngGsd04/mqdefault.jpg",
    "title": "【Jump King】ク リ ア 耐 久 ｜最 強 の 鬼 畜 ゲ ー ム 【二枠目】",
    "publishedAt": "2020-08-01T04:18:39Z"
  },
  {
    "videoId": "vnvny8RdU6U",
    "thumbnail": "https://i.ytimg.com/vi/vnvny8RdU6U/mqdefault.jpg",
    "title": "【Jump King】執 念 で ク リ ア を 目 指 す  | リ ベ ン ジ 【三枠目】",
    "publishedAt": "2020-08-01T18:27:54Z"
  },
  {
    "videoId": "It9gNijCFWM",
    "thumbnail": "https://i.ytimg.com/vi/It9gNijCFWM/mqdefault.jpg",
    "title": "【耐久】Jump King｜今日こそ絶対にクリアしてみせる！",
    "publishedAt": "2020-08-02T06:49:48Z"
  },
  {
    "videoId": "OCS2aYnErMo",
    "thumbnail": "https://i.ytimg.com/vi/OCS2aYnErMo/mqdefault.jpg",
    "title": "【空気読み】Japanese 空気めっちゃ読める陰キャ 【湊あくあ】",
    "publishedAt": "2020-08-02T15:03:03Z"
  },
  {
    "videoId": "sNY_e8_u-nk",
    "thumbnail": "https://i.ytimg.com/vi/sNY_e8_u-nk/mqdefault.jpg",
    "title": "【スマブラSP】地 獄 の １ ０ ０ 人 組 手 【かかってこい】",
    "publishedAt": "2020-08-04T15:49:54Z"
  },
  {
    "videoId": "jimiikRHk04",
    "thumbnail": "https://i.ytimg.com/vi/jimiikRHk04/mqdefault.jpg",
    "title": "【緊急ゲリラ！】６０万人達成まで歌い続ける！！！！！【感謝】",
    "publishedAt": "2020-08-05T10:39:11Z"
  },
  {
    "videoId": "PuCcwoQIM-I",
    "thumbnail": "https://i.ytimg.com/vi/PuCcwoQIM-I/mqdefault.jpg",
    "title": "【マリオカート8DX】湊あくあ杯開催！私に勝てる人おるうう？？（）【視聴者参加型】",
    "publishedAt": "2020-08-06T14:40:49Z"
  },
  {
    "videoId": "IOElqHk8gq0",
    "thumbnail": "https://i.ytimg.com/vi/IOElqHk8gq0/mqdefault.jpg",
    "title": "【#湊あくあ24h】祝二周年！開会式！きらきらスケジュール発表だああ！！",
    "publishedAt": "2020-08-08T12:53:49Z"
  },
  {
    "videoId": "skDqeyd0NaM",
    "thumbnail": "https://i.ytimg.com/vi/skDqeyd0NaM/mqdefault.jpg",
    "title": "誰よりもメンバーを理解せよ！ホロライブ同期愛決定戦♡【#湊あくあ24h】",
    "publishedAt": "2020-08-08T14:36:28Z"
  },
  {
    "videoId": "-Mhju03lOJo",
    "thumbnail": "https://i.ytimg.com/vi/-Mhju03lOJo/mqdefault.jpg",
    "title": "【特別企画】あくあとノエルの土曜日でも夜更かし・・！【#湊あくあ24h】",
    "publishedAt": "2020-08-08T16:05:57Z"
  },
  {
    "videoId": "PF5BjcnHrJU",
    "thumbnail": "https://i.ytimg.com/vi/PF5BjcnHrJU/mqdefault.jpg",
    "title": "【アソビ大全】はしゃげ！深夜、それは私たち『大人』の時間・・・・。【#湊あくあ24h】",
    "publishedAt": "2020-08-08T19:26:49Z"
  },
  {
    "videoId": "qXMvd0_dCXw",
    "thumbnail": "https://i.ytimg.com/vi/qXMvd0_dCXw/mqdefault.jpg",
    "title": "【#湊あくあ24h】みんな寝ちゃった・・。特別な時間・・？？",
    "publishedAt": "2020-08-08T23:55:12Z"
  },
  {
    "videoId": "sNQ9ZSFVOGQ",
    "thumbnail": "https://i.ytimg.com/vi/sNQ9ZSFVOGQ/mqdefault.jpg",
    "title": "【圧倒的黒歴史・・！】初配信をフルで見返すの会・・・。【#湊あくあ24h】",
    "publishedAt": "2020-08-09T01:36:19Z"
  },
  {
    "videoId": "3askU-GipX4",
    "thumbnail": "https://i.ytimg.com/vi/3askU-GipX4/mqdefault.jpg",
    "title": "【#湊あくあ24h】神様おねがい！朝のUFOキャッチャーでお菓子大量GET計画！【モーリーオンライン】",
    "publishedAt": "2020-08-09T03:02:30Z"
  },
  {
    "videoId": "577MuT9ywQo",
    "thumbnail": "https://i.ytimg.com/vi/577MuT9ywQo/mqdefault.jpg",
    "title": "【凸待ち】メンバーへ、私はここで待っています。【#湊あくあ24h】",
    "publishedAt": "2020-08-09T04:21:40Z"
  },
  {
    "videoId": "1B7aL_25eRc",
    "thumbnail": "https://i.ytimg.com/vi/1B7aL_25eRc/mqdefault.jpg",
    "title": "【最後の挑戦】もはや限界ギリギリ…。でもエンドラ倒すまで終わらない！！【#湊あくあ24h】",
    "publishedAt": "2020-08-09T09:38:24Z"
  },
  {
    "videoId": "kmdHuz0fu08",
    "thumbnail": "https://i.ytimg.com/vi/kmdHuz0fu08/mqdefault.jpg",
    "title": "【#湊あくあ24h最終回】極限状態…。突発ホラーでラストまで走り抜ける！",
    "publishedAt": "2020-08-09T11:48:56Z"
  },
  {
    "videoId": "UXUn_ZqeM4Q",
    "thumbnail": "https://i.ytimg.com/vi/UXUn_ZqeM4Q/mqdefault.jpg",
    "title": "【２周年記念】ワンルームシュガーライフ／湊あくあ【歌ってみた】",
    "publishedAt": "2020-08-09T12:15:14Z"
  },
  {
    "videoId": "A61RYGGvCHU",
    "thumbnail": "https://i.ytimg.com/vi/A61RYGGvCHU/mqdefault.jpg",
    "title": "NEW歌ってみた公開？！ついに完走目前カウントダウン！！！【#湊あくあ24h】",
    "publishedAt": "2020-08-09T12:32:39Z"
  },
  {
    "videoId": "RwNZbBbGM50",
    "thumbnail": "https://i.ytimg.com/vi/RwNZbBbGM50/mqdefault.jpg",
    "title": "【闇のゲーム】負ける度に体が消えていく地獄のアソビ大全【負けない】",
    "publishedAt": "2020-08-11T12:05:29Z"
  },
  {
    "videoId": "zSamSwAIFvE",
    "thumbnail": "https://i.ytimg.com/vi/zSamSwAIFvE/mqdefault.jpg",
    "title": "【APEX】残り７日！滑り込みソロダイヤモンドちゃれんじっ！",
    "publishedAt": "2020-08-11T20:33:19Z"
  },
  {
    "videoId": "Fmn3VdPdzR4",
    "thumbnail": "https://i.ytimg.com/vi/Fmn3VdPdzR4/mqdefault.jpg",
    "title": "【ゼルダの伝説 時のオカリナ】完全初見！失われた世界を救う！この剣で！【お盆特別企画】",
    "publishedAt": "2020-08-13T09:09:21Z"
  },
  {
    "videoId": "dADPFSV_f-k",
    "thumbnail": "https://i.ytimg.com/vi/dADPFSV_f-k/mqdefault.jpg",
    "title": "【突発コラボ】あくあマリンの絆？アソビ大全にそんなものはないんだよ！！【湊あくあ/宝鐘マリン】",
    "publishedAt": "2020-08-13T11:03:13Z"
  },
  {
    "videoId": "hvez5OoZ_FA",
    "thumbnail": "https://i.ytimg.com/vi/hvez5OoZ_FA/mqdefault.jpg",
    "title": "【Fall Guys】絶対に一位になる！！超最新ふにゃふにゃバトロワ！！【湊あくあ】",
    "publishedAt": "2020-08-13T12:00:23Z"
  },
  {
    "videoId": "Zt9UpXmGiR8",
    "thumbnail": "https://i.ytimg.com/vi/Zt9UpXmGiR8/mqdefault.jpg",
    "title": "【APEX】残り５日！滑り込みソロダイヤモンドちゃれんじっ！",
    "publishedAt": "2020-08-13T18:07:25Z"
  },
  {
    "videoId": "cmhIABgimTs",
    "thumbnail": "https://i.ytimg.com/vi/cmhIABgimTs/mqdefault.jpg",
    "title": "【ゼルダの伝説 時のオカリナ】完全初見！どこまでも行こう！この世界を救うんだ！",
    "publishedAt": "2020-08-14T11:44:01Z"
  },
  {
    "videoId": "dvNJcR2Ow6A",
    "thumbnail": "https://i.ytimg.com/vi/dvNJcR2Ow6A/mqdefault.jpg",
    "title": "【ゼルダの伝説 時のオカリナ】完全初見！ついに時の神殿へ！今日、世界救います。",
    "publishedAt": "2020-08-15T12:22:43Z"
  },
  {
    "videoId": "-0m8oAgEkWM",
    "thumbnail": "https://i.ytimg.com/vi/-0m8oAgEkWM/mqdefault.jpg",
    "title": "【APEX】残り２日！？行けるのか？ソロダイアモンドっ・・！",
    "publishedAt": "2020-08-15T20:00:14Z"
  },
  {
    "videoId": "Mm0KCzYpMhQ",
    "thumbnail": "https://i.ytimg.com/vi/Mm0KCzYpMhQ/mqdefault.jpg",
    "title": "【APEX耐久】ダイアモンドになるまで終わらないラストバトル！！【湊あくあ】",
    "publishedAt": "2020-08-16T12:26:09Z"
  },
  {
    "videoId": "G78DLSUPG_M",
    "thumbnail": "https://i.ytimg.com/vi/G78DLSUPG_M/mqdefault.jpg",
    "title": "【FallGuys】大乱闘！？一位になるまで終わらない！負けない！！【湊あくあ】",
    "publishedAt": "2020-08-17T17:53:46Z"
  },
  {
    "videoId": "snh4iou-dfM",
    "thumbnail": "https://i.ytimg.com/vi/snh4iou-dfM/mqdefault.jpg",
    "title": "【FallGuys】制限時間は３時間！チャンピオン取りまくるぞおおお！！",
    "publishedAt": "2020-08-18T09:51:58Z"
  },
  {
    "videoId": "coIo0JtK-yA",
    "thumbnail": "https://i.ytimg.com/vi/coIo0JtK-yA/mqdefault.jpg",
    "title": "【アニメ】大事なソロライブが中止！？【湊あくあ/ホロライブ #出張ホロぐら】",
    "publishedAt": "2020-08-20T09:00:15Z"
  },
  {
    "videoId": "SSJbqqiJiMY",
    "thumbnail": "https://i.ytimg.com/vi/SSJbqqiJiMY/mqdefault.jpg",
    "title": "ソロライブおわったああああああ！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-08-22T15:32:26Z"
  },
  {
    "videoId": "8KZwT1JOkJ4",
    "thumbnail": "https://i.ytimg.com/vi/8KZwT1JOkJ4/mqdefault.jpg",
    "title": "【夏の終わり】新居とうちゃーーく！……え？ここ…事故物件…？【恐怖の始まり】",
    "publishedAt": "2020-08-27T15:51:13Z"
  },
  {
    "videoId": "1I_cIWSFKYo",
    "thumbnail": "https://i.ytimg.com/vi/1I_cIWSFKYo/mqdefault.jpg",
    "title": "【歌枠】夏の終わりに！うたうよ～！みらくるっ！☆【湊あくあ】",
    "publishedAt": "2020-08-30T15:44:31Z"
  },
  {
    "videoId": "_nMtyqzdqkY",
    "thumbnail": "https://i.ytimg.com/vi/_nMtyqzdqkY/mqdefault.jpg",
    "title": "【リングフィット】べ、別に…。運動とか？全然？よゆうですけど…っ！？",
    "publishedAt": "2020-09-02T14:59:34Z"
  },
  {
    "videoId": "tpPlNHgfUdk",
    "thumbnail": "https://i.ytimg.com/vi/tpPlNHgfUdk/mqdefault.jpg",
    "title": "【FallGuys】負けたら即罰ゲーム！？自らを追い込んで強くなれ！地獄の激辛バトル🔥",
    "publishedAt": "2020-09-03T16:03:43Z"
  },
  {
    "videoId": "gKoVrWqv-MA",
    "thumbnail": "https://i.ytimg.com/vi/gKoVrWqv-MA/mqdefault.jpg",
    "title": "【歌枠】うたうよ。【湊あくあ/ホロライブ】",
    "publishedAt": "2020-09-06T16:31:02Z"
  },
  {
    "videoId": "L5QeVNaER_E",
    "thumbnail": "https://i.ytimg.com/vi/L5QeVNaER_E/mqdefault.jpg",
    "title": "【オフコラボ】笑ったら即終了するMr.President!【湊あくあ/紫咲シオン】",
    "publishedAt": "2020-09-09T11:27:31Z"
  },
  {
    "videoId": "C_GoaHrPVWc",
    "thumbnail": "https://i.ytimg.com/vi/C_GoaHrPVWc/mqdefault.jpg",
    "title": "【耐久】影廊クリアするまで終われない【湊あくあ/紫咲シオン】",
    "publishedAt": "2020-09-10T16:54:14Z"
  },
  {
    "videoId": "pFwb-U3BwjA",
    "thumbnail": "https://i.ytimg.com/vi/pFwb-U3BwjA/mqdefault.jpg",
    "title": "【歌枠】うたうよ。/ Singing for you 🎵【湊あくあ】",
    "publishedAt": "2020-09-13T17:33:12Z"
  },
  {
    "videoId": "Zb2MlIS8lc8",
    "thumbnail": "https://i.ytimg.com/vi/Zb2MlIS8lc8/mqdefault.jpg",
    "title": "【Minecraft】ホ ロ 鯖 深 夜 徘 徊 【#あくあマリンGO建設計画】",
    "publishedAt": "2020-09-15T18:16:36Z"
  },
  {
    "videoId": "ofh2NXKaDqs",
    "thumbnail": "https://i.ytimg.com/vi/ofh2NXKaDqs/mqdefault.jpg",
    "title": "【Minecraft】深夜のLOVELOVEあくあマリンGO！！！【つくるよ】",
    "publishedAt": "2020-09-16T19:04:10Z"
  },
  {
    "videoId": "UuepfFumXFQ",
    "thumbnail": "https://i.ytimg.com/vi/UuepfFumXFQ/mqdefault.jpg",
    "title": "【アズレンガチャ祭】幸運をこの手に！限定ガチャで全キャラ出すまで終われない！",
    "publishedAt": "2020-09-17T18:44:22Z"
  },
  {
    "videoId": "4hJPgfMW5ZA",
    "thumbnail": "https://i.ytimg.com/vi/4hJPgfMW5ZA/mqdefault.jpg",
    "title": "【歌枠】しっとりうたうよ。/ Piano arrange 【湊あくあ】",
    "publishedAt": "2020-09-21T16:54:38Z"
  },
  {
    "videoId": "YGQ1iZsvQVE",
    "thumbnail": "https://i.ytimg.com/vi/YGQ1iZsvQVE/mqdefault.jpg",
    "title": "【Minecraft】重大発表！そして深夜のあくあマリン号！大作戦！！【湊あくあ】",
    "publishedAt": "2020-09-22T19:48:36Z"
  },
  {
    "videoId": "BTJFY0F6B4g",
    "thumbnail": "https://i.ytimg.com/vi/BTJFY0F6B4g/mqdefault.jpg",
    "title": "【Minecraft】深夜くらふと！ホロ鯖に新しいビーコンたてたああい作戦！！【湊あくあ】",
    "publishedAt": "2020-09-24T18:40:53Z"
  },
  {
    "videoId": "8kxthB-jp_Y",
    "thumbnail": "https://i.ytimg.com/vi/8kxthB-jp_Y/mqdefault.jpg",
    "title": "【Dark Deception】ゲリラっ！逃げきれっ！！追いかけてくる恐怖からっ・・！！【湊あくあ】",
    "publishedAt": "2020-09-25T11:57:26Z"
  },
  {
    "videoId": "_bfuue-luq0",
    "thumbnail": "https://i.ytimg.com/vi/_bfuue-luq0/mqdefault.jpg",
    "title": "【Minecraft】深夜くらふとっ！あくあマリンLOVE☆LOVE☆GOをこの手に・・！【湊あくあ】",
    "publishedAt": "2020-09-25T19:10:28Z"
  },
  {
    "videoId": "Mhe2gXZtU6w",
    "thumbnail": "https://i.ytimg.com/vi/Mhe2gXZtU6w/mqdefault.jpg",
    "title": "【Singing♪】夢の70万人！目指して！歌いつづける！！【Go 70man touroku!】",
    "publishedAt": "2020-09-26T06:38:24Z"
  },
  {
    "videoId": "HUWyLcPf1vo",
    "thumbnail": "https://i.ytimg.com/vi/HUWyLcPf1vo/mqdefault.jpg",
    "title": "【#湊あくあ新衣装】ついに新衣装☆お披露目だああ！【ホロライブ】",
    "publishedAt": "2020-09-26T13:11:17Z"
  },
  {
    "videoId": "0OtNQEpSeIA",
    "thumbnail": "https://i.ytimg.com/vi/0OtNQEpSeIA/mqdefault.jpg",
    "title": "チューリングラブ /Cover 湊あくあ/猫又おかゆ【ホロライブ】",
    "publishedAt": "2020-09-27T09:00:12Z"
  },
  {
    "videoId": "UcY4SahvZl0",
    "thumbnail": "https://i.ytimg.com/vi/UcY4SahvZl0/mqdefault.jpg",
    "title": "【#あくおか質問コーナー】猫耳にゃあ～。ましゅまろもぐもぐっ！【湊あくあ/猫又おかゆ】",
    "publishedAt": "2020-09-27T15:11:15Z"
  },
  {
    "videoId": "rddmVGgem2Q",
    "thumbnail": "https://i.ytimg.com/vi/rddmVGgem2Q/mqdefault.jpg",
    "title": "ん゛に゛ゃ゛あ゛あ゛あ゛あ゛あ゛",
    "publishedAt": "2020-09-27T23:18:34Z"
  },
  {
    "videoId": "N6H1udXvuRE",
    "thumbnail": "https://i.ytimg.com/vi/N6H1udXvuRE/mqdefault.jpg",
    "title": "【Minecraft】夜のホロ鯖ぱーてぃーないと！！vs AQUAMARINGO!",
    "publishedAt": "2020-09-28T19:23:36Z"
  },
  {
    "videoId": "TxY6zQbUYs8",
    "thumbnail": "https://i.ytimg.com/vi/TxY6zQbUYs8/mqdefault.jpg",
    "title": "【Minecraft】夜のホロ鯖と愛のいたずら大作戦！with建築【湊あくあ】",
    "publishedAt": "2020-09-29T18:19:26Z"
  },
  {
    "videoId": "EH2ng9Hxsqc",
    "thumbnail": "https://i.ytimg.com/vi/EH2ng9Hxsqc/mqdefault.jpg",
    "title": "【マリオカート8DX】一位以外だと・・顔が・・おっきくなってしまうらしいッ・・！",
    "publishedAt": "2020-09-30T14:01:03Z"
  },
  {
    "videoId": "tgjyGcJVkvU",
    "thumbnail": "https://i.ytimg.com/vi/tgjyGcJVkvU/mqdefault.jpg",
    "title": "【Minecraft】深夜ホロ鯖！へ～。あなた、私に無断で引っ越したんだ？？【湊あくあ】",
    "publishedAt": "2020-09-30T19:51:25Z"
  },
  {
    "videoId": "GGS4USXd8Ag",
    "thumbnail": "https://i.ytimg.com/vi/GGS4USXd8Ag/mqdefault.jpg",
    "title": "【SUPER MARIO BROS. 35】新作マリオはまさかのバトロワ！？目指すのは一位のみ！！【Sランクの女】",
    "publishedAt": "2020-10-01T11:54:20Z"
  },
  {
    "videoId": "I5ohnxw-hnk",
    "thumbnail": "https://i.ytimg.com/vi/I5ohnxw-hnk/mqdefault.jpg",
    "title": "【負けたら即終了】スマブラ！修行してきたので絶対に負けません。【湊あくあ/ホロライブ】",
    "publishedAt": "2020-10-02T13:51:17Z"
  },
  {
    "videoId": "qelypSy-9wQ",
    "thumbnail": "https://i.ytimg.com/vi/qelypSy-9wQ/mqdefault.jpg",
    "title": "【Minecraft】ドキドキッ！深夜のホロ鯖Newドッキリ計画！！+α【湊あくあ/ホロライブ】",
    "publishedAt": "2020-10-02T19:39:36Z"
  },
  {
    "videoId": "3xB4vcsvOoY",
    "thumbnail": "https://i.ytimg.com/vi/3xB4vcsvOoY/mqdefault.jpg",
    "title": "【歌枠】うたうよ！！/Singing🎵【湊あくあ/ホロライブ】",
    "publishedAt": "2020-10-03T17:42:50Z"
  },
  {
    "videoId": "mqwBMDIsRJQ",
    "thumbnail": "https://i.ytimg.com/vi/mqwBMDIsRJQ/mqdefault.jpg",
    "title": "【Minecraft】ついに！あくあマリン号完結編【湊あくあ/宝鐘マリン】",
    "publishedAt": "2020-10-04T20:40:38Z"
  },
  {
    "videoId": "rcYl6Pca0jc",
    "thumbnail": "https://i.ytimg.com/vi/rcYl6Pca0jc/mqdefault.jpg",
    "title": "【初配信】ホロライブ二期生デビュー配信【#二期生オフコラボ】",
    "publishedAt": "2020-10-05T17:45:48Z"
  },
  {
    "videoId": "7OtJi8WNXvQ",
    "thumbnail": "https://i.ytimg.com/vi/7OtJi8WNXvQ/mqdefault.jpg",
    "title": "【オフコラボ】団長の手作り料理が食べたい！【#脳筋メイド】",
    "publishedAt": "2020-10-06T16:00:32Z"
  },
  {
    "videoId": "secaYztdD-g",
    "thumbnail": "https://i.ytimg.com/vi/secaYztdD-g/mqdefault.jpg",
    "title": "【鍋パ】カニ、食べたくない？？【#あくシオマリン】",
    "publishedAt": "2020-10-07T12:25:40Z"
  },
  {
    "videoId": "B5ifs6_bVNU",
    "thumbnail": "https://i.ytimg.com/vi/B5ifs6_bVNU/mqdefault.jpg",
    "title": "【Minecraft】ただいま！深夜のゆるゆるホロ鯖～！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-10-12T21:00:08Z"
  },
  {
    "videoId": "gcA2KNNYt5g",
    "thumbnail": "https://i.ytimg.com/vi/gcA2KNNYt5g/mqdefault.jpg",
    "title": "【SUPER MARIO BROS.35】「一位」以外で即終了！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-10-13T10:30:33Z"
  },
  {
    "videoId": "gv-jqlJ6UUI",
    "thumbnail": "https://i.ytimg.com/vi/gv-jqlJ6UUI/mqdefault.jpg",
    "title": "【SUPER MARIO BROS.35】超ゲリラ！「一位」以外で即終了！【#湊あくあ生放送】",
    "publishedAt": "2020-10-14T10:43:04Z"
  },
  {
    "videoId": "c3D4CHDd5Yo",
    "thumbnail": "https://i.ytimg.com/vi/c3D4CHDd5Yo/mqdefault.jpg",
    "title": "【スマブラSP】スティーブ参戦！緊急！湊あくあ杯開催だああ！！【視聴者参加型】",
    "publishedAt": "2020-10-14T13:58:59Z"
  },
  {
    "videoId": "hn0zlzVoGJk",
    "thumbnail": "https://i.ytimg.com/vi/hn0zlzVoGJk/mqdefault.jpg",
    "title": "【スマブラSP】私と！マイクラと！人生初のVIPの景色！！【目指して一日目】",
    "publishedAt": "2020-10-15T13:43:46Z"
  },
  {
    "videoId": "XIDzSr3oX1w",
    "thumbnail": "https://i.ytimg.com/vi/XIDzSr3oX1w/mqdefault.jpg",
    "title": "【オススメ!!】10分でわかる！ようこそ実力至上主義の教室へ【湊あくあ】",
    "publishedAt": "2020-10-16T10:00:32Z"
  },
  {
    "videoId": "cnFyiysuBrQ",
    "thumbnail": "https://i.ytimg.com/vi/cnFyiysuBrQ/mqdefault.jpg",
    "title": "に゛ゃ゛あ゛あ゛に゛ゃ゛あ゛あ゛あ゛あ゛あ゛",
    "publishedAt": "2020-10-16T13:38:05Z"
  },
  {
    "videoId": "HEltoOx5Y3U",
    "thumbnail": "https://i.ytimg.com/vi/HEltoOx5Y3U/mqdefault.jpg",
    "title": "【ママにゲーム隠された】おかあさーーん！？ママ～～！？！ママ～～～！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-10-17T09:56:14Z"
  },
  {
    "videoId": "5Go_DtN2QEQ",
    "thumbnail": "https://i.ytimg.com/vi/5Go_DtN2QEQ/mqdefault.jpg",
    "title": "【湊あくあ×MF文庫J】ネタバレ歓迎！みんなで魅力を語り合おおお！！【ようこそ実力至上主義の教室へ】",
    "publishedAt": "2020-10-23T11:51:52Z"
  },
  {
    "videoId": "r-kUBHFW5YM",
    "thumbnail": "https://i.ytimg.com/vi/r-kUBHFW5YM/mqdefault.jpg",
    "title": "【Minecraft】Halloween！ホラーハウス計画！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-10-24T10:21:50Z"
  },
  {
    "videoId": "7vdop_hHaLE",
    "thumbnail": "https://i.ytimg.com/vi/7vdop_hHaLE/mqdefault.jpg",
    "title": "【Minecraft】お昼のホロ鯖！ドッキリびっくりハロウィン施設だじょ～～！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-10-25T10:10:45Z"
  },
  {
    "videoId": "2EYxzZbXdcY",
    "thumbnail": "https://i.ytimg.com/vi/2EYxzZbXdcY/mqdefault.jpg",
    "title": "【歌枠】Singing | うたライブうううううう！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-10-25T13:13:36Z"
  },
  {
    "videoId": "CZGFm-O5IOU",
    "thumbnail": "https://i.ytimg.com/vi/CZGFm-O5IOU/mqdefault.jpg",
    "title": "Minato Aqua - For The Win 【湊あくあ/オリジナル曲】",
    "publishedAt": "2020-10-26T10:45:00Z"
  },
  {
    "videoId": "Mo6aKZrIeuI",
    "thumbnail": "https://i.ytimg.com/vi/Mo6aKZrIeuI/mqdefault.jpg",
    "title": "【スマブラSP】修行してきた！心も体もエンダーマン！！【VIPちゃれんじ2日目】",
    "publishedAt": "2020-10-26T15:23:36Z"
  },
  {
    "videoId": "F-qrv79PRao",
    "thumbnail": "https://i.ytimg.com/vi/F-qrv79PRao/mqdefault.jpg",
    "title": "【AKUKIN建設】Emergency！第1回株主総会【湊あくあ/ホロライブ】",
    "publishedAt": "2020-10-27T11:23:40Z"
  },
  {
    "videoId": "1PkWVn_p4TQ",
    "thumbnail": "https://i.ytimg.com/vi/1PkWVn_p4TQ/mqdefault.jpg",
    "title": "【#雑ホロAmongUs】最強はこの私！宇 宙 人 狼 開 催 !!【湊あくあ視点/ホロライブ】",
    "publishedAt": "2020-10-27T15:09:46Z"
  },
  {
    "videoId": "BOGnLoa6FNQ",
    "thumbnail": "https://i.ytimg.com/vi/BOGnLoa6FNQ/mqdefault.jpg",
    "title": "【マリオメーカー2】残機は77！世界の人気コース『77』を制覇する！【湊あくあ】",
    "publishedAt": "2020-10-28T12:15:08Z"
  },
  {
    "videoId": "5tRTKC--p_M",
    "thumbnail": "https://i.ytimg.com/vi/5tRTKC--p_M/mqdefault.jpg",
    "title": "【AKUKIN建設】AKUKIN～BUNBUN~AKUKIN～【湊あくあ/ホロライブ】",
    "publishedAt": "2020-10-29T14:44:03Z"
  },
  {
    "videoId": "HnUsWAok_Lk",
    "thumbnail": "https://i.ytimg.com/vi/HnUsWAok_Lk/mqdefault.jpg",
    "title": "【Minecraft】AKUKIN建設！ホロ鯖Halloween night！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-10-31T17:48:41Z"
  },
  {
    "videoId": "78_zDeMaz7w",
    "thumbnail": "https://i.ytimg.com/vi/78_zDeMaz7w/mqdefault.jpg",
    "title": "【スマブラSP】あくあクラウドで本気でVIPいく！【VIPちゃれんじ3日目】",
    "publishedAt": "2020-11-02T15:05:37Z"
  },
  {
    "videoId": "NAaORCjdrCo",
    "thumbnail": "https://i.ytimg.com/vi/NAaORCjdrCo/mqdefault.jpg",
    "title": "【Ib】ねえ！この美術館なんかおかしいよ！？【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-03T13:18:54Z"
  },
  {
    "videoId": "iTFHrA-nO4Y",
    "thumbnail": "https://i.ytimg.com/vi/iTFHrA-nO4Y/mqdefault.jpg",
    "title": "【Minecraft】げりらくらふと！旅立ちの準備！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-04T10:05:46Z"
  },
  {
    "videoId": "JkZOXpGdzCw",
    "thumbnail": "https://i.ytimg.com/vi/JkZOXpGdzCw/mqdefault.jpg",
    "title": "【#ポンホロAmongUs】IQ5000！これが陰キャの底力！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-04T14:15:07Z"
  },
  {
    "videoId": "zShv6eMoRK4",
    "thumbnail": "https://i.ytimg.com/vi/zShv6eMoRK4/mqdefault.jpg",
    "title": "【ゲリラ】まだ寝ちゃダメ！！あくあ歌います！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-04T16:14:15Z"
  },
  {
    "videoId": "yCPu9t2l4_0",
    "thumbnail": "https://i.ytimg.com/vi/yCPu9t2l4_0/mqdefault.jpg",
    "title": "【APEX】潜入！新シーズン！リハビリStarBurst Stream!!!!!!!!【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-05T18:57:45Z"
  },
  {
    "videoId": "xNxgQ3ZxUoU",
    "thumbnail": "https://i.ytimg.com/vi/xNxgQ3ZxUoU/mqdefault.jpg",
    "title": "【Singing!】Let's Party!! 80万人行っても止まらない！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-06T14:46:54Z"
  },
  {
    "videoId": "v7fEJyG9Z6w",
    "thumbnail": "https://i.ytimg.com/vi/v7fEJyG9Z6w/mqdefault.jpg",
    "title": "【PLUG&PLAY】なんだこれ…なんなんだこれ…！？【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-07T08:54:56Z"
  },
  {
    "videoId": "rxRfGL7lAro",
    "thumbnail": "https://i.ytimg.com/vi/rxRfGL7lAro/mqdefault.jpg",
    "title": "【スマブラSP】視聴者参加型！強くなった私に勝てる人おる～？？？【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-07T13:53:54Z"
  },
  {
    "videoId": "10hitoSpG_A",
    "thumbnail": "https://i.ytimg.com/vi/10hitoSpG_A/mqdefault.jpg",
    "title": "【Minecraft】深夜！ホロ鯖エンドワールドに潜入しちゃうよん！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-07T18:09:16Z"
  },
  {
    "videoId": "tzhCI1m6vOE",
    "thumbnail": "https://i.ytimg.com/vi/tzhCI1m6vOE/mqdefault.jpg",
    "title": "【歌枠】Singing  |  癒しのおうた！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-08T15:11:41Z"
  },
  {
    "videoId": "pPDEYs4gbWE",
    "thumbnail": "https://i.ytimg.com/vi/pPDEYs4gbWE/mqdefault.jpg",
    "title": "【Minecraft】求むエリトラ！真・エンドワールド攻略作戦！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-09T11:04:35Z"
  },
  {
    "videoId": "16-RbPbKruw",
    "thumbnail": "https://i.ytimg.com/vi/16-RbPbKruw/mqdefault.jpg",
    "title": "【slither.io】深夜ゲリラ！みてみて！私がミミズ界のNo.1！！（願望）【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-09T15:55:37Z"
  },
  {
    "videoId": "WYVHM_3S22c",
    "thumbnail": "https://i.ytimg.com/vi/WYVHM_3S22c/mqdefault.jpg",
    "title": "【CoD:MW】わっくわく！初めてのCampaignでうひょひょい！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-10T20:21:49Z"
  },
  {
    "videoId": "fCJPjgYH0V0",
    "thumbnail": "https://i.ytimg.com/vi/fCJPjgYH0V0/mqdefault.jpg",
    "title": "【slither.io】I AM MIMIZU!!!!No.1になる!!!!!!!!!!【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-11T10:21:40Z"
  },
  {
    "videoId": "noTHD1YlKLM",
    "thumbnail": "https://i.ytimg.com/vi/noTHD1YlKLM/mqdefault.jpg",
    "title": "【VISAGE】この屋敷…なんかおかしいよ…！？【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-11T17:14:41Z"
  },
  {
    "videoId": "5vZqrFOPG8k",
    "thumbnail": "https://i.ytimg.com/vi/5vZqrFOPG8k/mqdefault.jpg",
    "title": "【AKUKIN建設】電車で街をぶんぶんぶん〜！したい！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-13T11:36:39Z"
  },
  {
    "videoId": "T33DtKaz-oU",
    "thumbnail": "https://i.ytimg.com/vi/T33DtKaz-oU/mqdefault.jpg",
    "title": "【APEX】シーズン７ソロダイアちゃれんじっ！１日目！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-14T09:05:00Z"
  },
  {
    "videoId": "w5XB0tXLsng",
    "thumbnail": "https://i.ytimg.com/vi/w5XB0tXLsng/mqdefault.jpg",
    "title": "【スマブラSP】ガチ耐久！『VIP』になるまでおわらないいいい！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-14T20:33:28Z"
  },
  {
    "videoId": "2DC4YLfPgJ0",
    "thumbnail": "https://i.ytimg.com/vi/2DC4YLfPgJ0/mqdefault.jpg",
    "title": "【APEX】シーズン７ソロダイアちゃれんじっ！２日目！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-15T10:35:52Z"
  },
  {
    "videoId": "1LmxK1whApI",
    "thumbnail": "https://i.ytimg.com/vi/1LmxK1whApI/mqdefault.jpg",
    "title": "【歌枠】Singing｜深夜のアニソンメドレー！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-15T18:59:02Z"
  },
  {
    "videoId": "i4-l-dIkYww",
    "thumbnail": "https://i.ytimg.com/vi/i4-l-dIkYww/mqdefault.jpg",
    "title": "【Minecraft】AKUKIN建設は今日も行く！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-16T15:38:46Z"
  },
  {
    "videoId": "PPXybL1bJb0",
    "thumbnail": "https://i.ytimg.com/vi/PPXybL1bJb0/mqdefault.jpg",
    "title": "【AKUKIN建設】ついに始動！地下帝国プロジェクト！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-17T14:55:33Z"
  },
  {
    "videoId": "_E6_EDLq8IA",
    "thumbnail": "https://i.ytimg.com/vi/_E6_EDLq8IA/mqdefault.jpg",
    "title": "【Papers, Please】あてぃし、入国審査官になる！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-18T13:05:58Z"
  },
  {
    "videoId": "egq_q7KCIIw",
    "thumbnail": "https://i.ytimg.com/vi/egq_q7KCIIw/mqdefault.jpg",
    "title": "【Minecraft】AKUKIN建設ぶんぶんぶん！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-19T16:45:53Z"
  },
  {
    "videoId": "WzAkQmCJxEc",
    "thumbnail": "https://i.ytimg.com/vi/WzAkQmCJxEc/mqdefault.jpg",
    "title": "【歌枠】Singing｜うたうよおおおお！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-20T14:03:38Z"
  },
  {
    "videoId": "qqXNceOPq5I",
    "thumbnail": "https://i.ytimg.com/vi/qqXNceOPq5I/mqdefault.jpg",
    "title": "ホロライブ秋の大運動会！白Aチーム視点【#ホロライブ運動会 / Minecraft】",
    "publishedAt": "2020-11-21T09:58:42Z"
  },
  {
    "videoId": "Ue-nkJD5DRU",
    "thumbnail": "https://i.ytimg.com/vi/Ue-nkJD5DRU/mqdefault.jpg",
    "title": "【歌枠】Singing｜いいツインテールの日いいい！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-22T16:39:19Z"
  },
  {
    "videoId": "vGYbP-f_wqA",
    "thumbnail": "https://i.ytimg.com/vi/vGYbP-f_wqA/mqdefault.jpg",
    "title": "【APEX】ダイアモンドに私はなる！！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-23T12:07:14Z"
  },
  {
    "videoId": "XQiaiv-M0iQ",
    "thumbnail": "https://i.ytimg.com/vi/XQiaiv-M0iQ/mqdefault.jpg",
    "title": "【Minecraft】85万人めざして！ひたむきな地下生活！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-24T17:03:31Z"
  },
  {
    "videoId": "mUCmIkyjnsw",
    "thumbnail": "https://i.ytimg.com/vi/mUCmIkyjnsw/mqdefault.jpg",
    "title": "【Cooking Simulator】あなたの胃袋つかんじゃうぞ☆【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-26T15:42:44Z"
  },
  {
    "videoId": "eciK6t1dKKU",
    "thumbnail": "https://i.ytimg.com/vi/eciK6t1dKKU/mqdefault.jpg",
    "title": "【Minecraft】AKUKIN建設！時代は自動化ぶんぶん！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-27T15:38:08Z"
  },
  {
    "videoId": "63tZVtraFSk",
    "thumbnail": "https://i.ytimg.com/vi/63tZVtraFSk/mqdefault.jpg",
    "title": "【APEX】ソロダイアモンドになりたいんだ！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-28T11:09:26Z"
  },
  {
    "videoId": "yWiZBcMr_5Q",
    "thumbnail": "https://i.ytimg.com/vi/yWiZBcMr_5Q/mqdefault.jpg",
    "title": "【Minecraft】夜ふかしいいい！AKUKIN建設クラフト！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-28T20:29:00Z"
  },
  {
    "videoId": "KwGKOBSZf7s",
    "thumbnail": "https://i.ytimg.com/vi/KwGKOBSZf7s/mqdefault.jpg",
    "title": "【Minecraft】海底5000ｍ【湊あくあ/ホロライブ】",
    "publishedAt": "2020-11-29T23:48:38Z"
  },
  {
    "videoId": "Fkja0yzTv-k",
    "thumbnail": "https://i.ytimg.com/vi/Fkja0yzTv-k/mqdefault.jpg",
    "title": "【カウントダウン歌LIVE】もうすぐ！Happy Birthday !! (12/01)【 #湊あくあ生誕祭2020 】",
    "publishedAt": "2020-11-30T15:57:48Z"
  },
  {
    "videoId": "6bnaBnd4kyU",
    "thumbnail": "https://i.ytimg.com/vi/6bnaBnd4kyU/mqdefault.jpg",
    "title": "【original】#あくあ色ぱれっと【ホロライブ/湊あくあ】",
    "publishedAt": "2020-12-01T12:00:13Z"
  },
  {
    "videoId": "76KDBkkZMb0",
    "thumbnail": "https://i.ytimg.com/vi/76KDBkkZMb0/mqdefault.jpg",
    "title": "【🔥凸待ち🔥】コミュ障は誕生日パワーでみんなと仲良くなれるのか？【#凸待ちあくたん】",
    "publishedAt": "2020-12-01T14:40:54Z"
  },
  {
    "videoId": "NPHGv7uX3P0",
    "thumbnail": "https://i.ytimg.com/vi/NPHGv7uX3P0/mqdefault.jpg",
    "title": "【#おかころvsあくあマリン 】今宵は戦争だあああああ！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-02T14:56:23Z"
  },
  {
    "videoId": "n-R2FTtO1fk",
    "thumbnail": "https://i.ytimg.com/vi/n-R2FTtO1fk/mqdefault.jpg",
    "title": "【#おかころvsあくあマリン 】今宵は戦争だあああああ！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-02T16:11:52Z"
  },
  {
    "videoId": "oOqJqusup04",
    "thumbnail": "https://i.ytimg.com/vi/oOqJqusup04/mqdefault.jpg",
    "title": "【#湊あくあVRホラー】恐怖度Max!?あのVRホラーに初挑戦……！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-03T13:08:14Z"
  },
  {
    "videoId": "VTVn8HvvSq4",
    "thumbnail": "https://i.ytimg.com/vi/VTVn8HvvSq4/mqdefault.jpg",
    "title": "【APEX】今日は寝ない！ソロダイア本気で目指す！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-06T02:19:54Z"
  },
  {
    "videoId": "m8H7_GFrTzQ",
    "thumbnail": "https://i.ytimg.com/vi/m8H7_GFrTzQ/mqdefault.jpg",
    "title": "【歌枠】しっとりうたうよ。/ Singing Piano arrange【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-06T16:29:15Z"
  },
  {
    "videoId": "jQd8NrsR-dA",
    "thumbnail": "https://i.ytimg.com/vi/jQd8NrsR-dA/mqdefault.jpg",
    "title": "【Minecraft】深夜のAKUKIN建設！今日もげんきいいいいい！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-07T18:15:14Z"
  },
  {
    "videoId": "7LCF8kRMDvI",
    "thumbnail": "https://i.ytimg.com/vi/7LCF8kRMDvI/mqdefault.jpg",
    "title": "【Minecraft】#あくシオにゃんにゃん ドット絵づくり！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-08T15:33:02Z"
  },
  {
    "videoId": "ozdYdMjLNP4",
    "thumbnail": "https://i.ytimg.com/vi/ozdYdMjLNP4/mqdefault.jpg",
    "title": "【APEX】SOLO！ダイアモンド！ちゃれんじっ！！！絶対！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-09T12:32:08Z"
  },
  {
    "videoId": "DW3G7Tj4Rr8",
    "thumbnail": "https://i.ytimg.com/vi/DW3G7Tj4Rr8/mqdefault.jpg",
    "title": "【APEX】SOLO！ダイアモンド！ちゃれんじっ！！！絶対！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-10T03:08:08Z"
  },
  {
    "videoId": "frUt9ZeAHAo",
    "thumbnail": "https://i.ytimg.com/vi/frUt9ZeAHAo/mqdefault.jpg",
    "title": "【歌枠】９０万人！目指して！全力Singing！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-10T14:53:15Z"
  },
  {
    "videoId": "LgXrX_TgQ2k",
    "thumbnail": "https://i.ytimg.com/vi/LgXrX_TgQ2k/mqdefault.jpg",
    "title": "【Super Smash Bros】視聴者参加型！『VIP』の私にかかってこい！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-11T15:37:25Z"
  },
  {
    "videoId": "gOEnxFFgIX0",
    "thumbnail": "https://i.ytimg.com/vi/gOEnxFFgIX0/mqdefault.jpg",
    "title": "【APEX】耐久！SOLO！ダイアモンドまで！終わらない！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-13T01:02:32Z"
  },
  {
    "videoId": "h2Pcsejpme8",
    "thumbnail": "https://i.ytimg.com/vi/h2Pcsejpme8/mqdefault.jpg",
    "title": "【APEX】シーズン最終日！人生初のD3！ぜったい行く！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-14T20:40:29Z"
  },
  {
    "videoId": "1Lov6P5iss4",
    "thumbnail": "https://i.ytimg.com/vi/1Lov6P5iss4/mqdefault.jpg",
    "title": "【Minecraft】Kawaii !! 幸せのあてぃしハウス！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-17T17:21:52Z"
  },
  {
    "videoId": "Go2JRGbhlE0",
    "thumbnail": "https://i.ytimg.com/vi/Go2JRGbhlE0/mqdefault.jpg",
    "title": "【スマブラSP】ついに来た！新キャラ『セフィロス』でVIP目指すっ！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-18T16:38:52Z"
  },
  {
    "videoId": "dgLnduZt_oo",
    "thumbnail": "https://i.ytimg.com/vi/dgLnduZt_oo/mqdefault.jpg",
    "title": "【マリオ64】完全初見！懐かしのマリオを一気にクリアする！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-20T00:00:59Z"
  },
  {
    "videoId": "JgT5vhDB7W8",
    "thumbnail": "https://i.ytimg.com/vi/JgT5vhDB7W8/mqdefault.jpg",
    "title": "【歌枠】ライブ直前！｜ Non stop 歌LIVE！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-20T16:19:17Z"
  },
  {
    "videoId": "2rJwMl0VUpM",
    "thumbnail": "https://i.ytimg.com/vi/2rJwMl0VUpM/mqdefault.jpg",
    "title": "【Minecraft】あくあとエンダードラゴンRTA：練習編【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-23T16:05:10Z"
  },
  {
    "videoId": "S5V8z-785M4",
    "thumbnail": "https://i.ytimg.com/vi/S5V8z-785M4/mqdefault.jpg",
    "title": "【Minecraft】ついに本番！聖夜のエンダードラゴンRTA！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-24T14:54:34Z"
  },
  {
    "videoId": "lerk9192c3s",
    "thumbnail": "https://i.ytimg.com/vi/lerk9192c3s/mqdefault.jpg",
    "title": "【 #ホロライブクリスマス】フィナーレ！寝るまでがクリスマス！だよね？！？【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-25T15:41:31Z"
  },
  {
    "videoId": "8Jkb48Ioj_E",
    "thumbnail": "https://i.ytimg.com/vi/8Jkb48Ioj_E/mqdefault.jpg",
    "title": "【#AKUKIN面接】求む！新入社員！面接会場はこちらです。【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-26T14:30:40Z"
  },
  {
    "videoId": "aQk7m-0eWNQ",
    "thumbnail": "https://i.ytimg.com/vi/aQk7m-0eWNQ/mqdefault.jpg",
    "title": "【APEX】行くぞランク戦！新スプリットに潜入だあああああ！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-27T07:58:14Z"
  },
  {
    "videoId": "3WkMsalWDqM",
    "thumbnail": "https://i.ytimg.com/vi/3WkMsalWDqM/mqdefault.jpg",
    "title": "【歌枠】この曲〇〇年前！？懐かしのアニソンメドレー・・！；；【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-27T15:07:58Z"
  },
  {
    "videoId": "SV8p1RoCD3M",
    "thumbnail": "https://i.ytimg.com/vi/SV8p1RoCD3M/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖さん・・・一年間ありがとう・・・；；【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-28T14:05:35Z"
  },
  {
    "videoId": "sXaoj4JZ8zI",
    "thumbnail": "https://i.ytimg.com/vi/sXaoj4JZ8zI/mqdefault.jpg",
    "title": "【Minecraft】Ver1.16！ついにきた！アップデート後の世界へ！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-29T09:22:35Z"
  },
  {
    "videoId": "4_w_8mx3-3o",
    "thumbnail": "https://i.ytimg.com/vi/4_w_8mx3-3o/mqdefault.jpg",
    "title": "【深夜】95万人まで終わらない！本気のマリカ大会練習＾～＾【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-29T18:29:26Z"
  },
  {
    "videoId": "TzC5Hg17KMo",
    "thumbnail": "https://i.ytimg.com/vi/TzC5Hg17KMo/mqdefault.jpg",
    "title": "【Minecraft】全ロスの、その先へ。魂のネザライト耐久。【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-30T09:07:47Z"
  },
  {
    "videoId": "QHbpp6bDang",
    "thumbnail": "https://i.ytimg.com/vi/QHbpp6bDang/mqdefault.jpg",
    "title": "【APEXガチャ】今年最後の日！狙えスパレジェ！魂の100連ガチャ！！【湊あくあ/ホロライブ】",
    "publishedAt": "2020-12-31T10:53:55Z"
  },
  {
    "videoId": "mYDjN1at7yw",
    "thumbnail": "https://i.ytimg.com/vi/mYDjN1at7yw/mqdefault.jpg",
    "title": "【あけおめ！】うおお！！新年あくトーーーーーク！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-01T12:12:07Z"
  },
  {
    "videoId": "oiBVIqhn034",
    "thumbnail": "https://i.ytimg.com/vi/oiBVIqhn034/mqdefault.jpg",
    "title": "【桃鉄耐久】目標は全国統一！？ひとりぼっちの100年戦争！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-03T01:13:48Z"
  },
  {
    "videoId": "Tf3t9oVHrB4",
    "thumbnail": "https://i.ytimg.com/vi/Tf3t9oVHrB4/mqdefault.jpg",
    "title": "【桃鉄耐久】目標は全国制覇！？ひとりぼっちの100年戦争…！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-03T15:41:15Z"
  },
  {
    "videoId": "aUSGY1X6OA8",
    "thumbnail": "https://i.ytimg.com/vi/aUSGY1X6OA8/mqdefault.jpg",
    "title": "【マリカ8DX】あてぃし、しんや、がち、れんしゅう、！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-04T16:59:15Z"
  },
  {
    "videoId": "-cCwhOW6sWo",
    "thumbnail": "https://i.ytimg.com/vi/-cCwhOW6sWo/mqdefault.jpg",
    "title": "【マリオカート8DX】修行【視聴者参加型】",
    "publishedAt": "2021-01-07T09:46:54Z"
  },
  {
    "videoId": "UvbkmwwRuBo",
    "thumbnail": "https://i.ytimg.com/vi/UvbkmwwRuBo/mqdefault.jpg",
    "title": "【APEX】アプデきたー！ランク行くぞおおお！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-07T17:46:30Z"
  },
  {
    "videoId": "raXwo_K8vd0",
    "thumbnail": "https://i.ytimg.com/vi/raXwo_K8vd0/mqdefault.jpg",
    "title": "【APEX】バグに負けない【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-09T08:42:28Z"
  },
  {
    "videoId": "agoz7sd1nGk",
    "thumbnail": "https://i.ytimg.com/vi/agoz7sd1nGk/mqdefault.jpg",
    "title": "【マリオカート8DX】本気の本気のガチ練習【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-09T22:18:22Z"
  },
  {
    "videoId": "oo56_BzlO3w",
    "thumbnail": "https://i.ytimg.com/vi/oo56_BzlO3w/mqdefault.jpg",
    "title": "【#雑ホロ杯】大会前夜【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-10T13:10:27Z"
  },
  {
    "videoId": "jAQNkXzEgP0",
    "thumbnail": "https://i.ytimg.com/vi/jAQNkXzEgP0/mqdefault.jpg",
    "title": "【大会前日】深夜の合同練習！#おかあくすば 【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-10T17:22:27Z"
  },
  {
    "videoId": "enMnSVOBAeE",
    "thumbnail": "https://i.ytimg.com/vi/enMnSVOBAeE/mqdefault.jpg",
    "title": "【#ホロお正月CUP】予選【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-11T10:20:57Z"
  },
  {
    "videoId": "cJVjD5Voh9k",
    "thumbnail": "https://i.ytimg.com/vi/cJVjD5Voh9k/mqdefault.jpg",
    "title": "【#ホロお正月CUP】優勝祈願：決勝【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-11T13:39:52Z"
  },
  {
    "videoId": "kl7BJWlUgNo",
    "thumbnail": "https://i.ytimg.com/vi/kl7BJWlUgNo/mqdefault.jpg",
    "title": "【初おうち3D！】New Face！激レアざつだんんんn！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-12T16:00:00Z"
  },
  {
    "videoId": "Qk51imbGXR0",
    "thumbnail": "https://i.ytimg.com/vi/Qk51imbGXR0/mqdefault.jpg",
    "title": "【ついに】目指せMillion！100万人まで歌う！Singing！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-13T12:33:03Z"
  },
  {
    "videoId": "az3YDI9eWVk",
    "thumbnail": "https://i.ytimg.com/vi/az3YDI9eWVk/mqdefault.jpg",
    "title": "【Minecraft】AKUKIN建設ううう！！れっつごー！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-15T16:35:45Z"
  },
  {
    "videoId": "pos2Q5OVilo",
    "thumbnail": "https://i.ytimg.com/vi/pos2Q5OVilo/mqdefault.jpg",
    "title": "【APEX】ソロダイアモンドⅢになりたい！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-16T10:10:36Z"
  },
  {
    "videoId": "2Eq7j0i_fZc",
    "thumbnail": "https://i.ytimg.com/vi/2Eq7j0i_fZc/mqdefault.jpg",
    "title": "【歌枠】みんな聞いて！癒しのらぶりーSinging！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-17T14:50:29Z"
  },
  {
    "videoId": "76ykVW5fiK8",
    "thumbnail": "https://i.ytimg.com/vi/76ykVW5fiK8/mqdefault.jpg",
    "title": "【Penguin/獄門ペンギン】なんかこのペンギン...ヤバくない！？！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-19T16:19:05Z"
  },
  {
    "videoId": "6kUlLn_Gxj0",
    "thumbnail": "https://i.ytimg.com/vi/6kUlLn_Gxj0/mqdefault.jpg",
    "title": "zzZ",
    "publishedAt": "2021-01-21T02:00:01Z"
  },
  {
    "videoId": "9BO-H1fqONM",
    "thumbnail": "https://i.ytimg.com/vi/9BO-H1fqONM/mqdefault.jpg",
    "title": "う゛わ゛あ゛あ゛あ゛あ゛あ゛あ゛💃",
    "publishedAt": "2021-01-22T02:30:02Z"
  },
  {
    "videoId": "x2k0FCEHNqM",
    "thumbnail": "https://i.ytimg.com/vi/x2k0FCEHNqM/mqdefault.jpg",
    "title": "【APEX】行くぞソロダイア！げりらああえぺ！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-22T11:28:37Z"
  },
  {
    "videoId": "ZKjwAwsEpDM",
    "thumbnail": "https://i.ytimg.com/vi/ZKjwAwsEpDM/mqdefault.jpg",
    "title": "【APEX】行くぞ！今日で！ソロダイアモンドに！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-23T09:05:11Z"
  },
  {
    "videoId": "fSmrjBcTXu4",
    "thumbnail": "https://i.ytimg.com/vi/fSmrjBcTXu4/mqdefault.jpg",
    "title": "【歌枠】癒しの深夜！ゲリラでうたうよ～～♪【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-23T18:25:16Z"
  },
  {
    "videoId": "SECC3_aiZWc",
    "thumbnail": "https://i.ytimg.com/vi/SECC3_aiZWc/mqdefault.jpg",
    "title": "【#AKUKIN建設株主総会】綺麗な！本社が！欲しい！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-24T13:15:46Z"
  },
  {
    "videoId": "1E8uHA5r3uE",
    "thumbnail": "https://i.ytimg.com/vi/1E8uHA5r3uE/mqdefault.jpg",
    "title": "【#AKUKIN本社建設リレー】素敵な！本社を！みんなで作る！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-25T10:07:08Z"
  },
  {
    "videoId": "YICTdOYB5qM",
    "thumbnail": "https://i.ytimg.com/vi/YICTdOYB5qM/mqdefault.jpg",
    "title": "【#AKUKIN本社建設リレー】ついに！本社完成！お披露目だあああ！！ 【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-25T15:34:32Z"
  },
  {
    "videoId": "YSLj7ETWMMM",
    "thumbnail": "https://i.ytimg.com/vi/YSLj7ETWMMM/mqdefault.jpg",
    "title": "【APEX】ソロダイアモンド耐久！行くまでホントに終わらない！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-28T16:56:20Z"
  },
  {
    "videoId": "MyZCXVOYtEU",
    "thumbnail": "https://i.ytimg.com/vi/MyZCXVOYtEU/mqdefault.jpg",
    "title": "【歌枠】けいおん縛り！Special Singing！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-01-31T15:27:19Z"
  },
  {
    "videoId": "WTuTPpx68DA",
    "thumbnail": "https://i.ytimg.com/vi/WTuTPpx68DA/mqdefault.jpg",
    "title": "【APEX】緊急！ゲリラ！人生初のソロｄ３へ！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-02-01T13:41:47Z"
  },
  {
    "videoId": "bRYYJU88q6Y",
    "thumbnail": "https://i.ytimg.com/vi/bRYYJU88q6Y/mqdefault.jpg",
    "title": "【AKUKIN建設】新時代の給料システム－TARA GACHA－【湊あくあ/ホロライブ】",
    "publishedAt": "2021-02-02T17:49:30Z"
  },
  {
    "videoId": "R1c0FMLNuhA",
    "thumbnail": "https://i.ytimg.com/vi/R1c0FMLNuhA/mqdefault.jpg",
    "title": "【APEX】突撃！新シーズン初チャンピオン取るまで終わらない！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-02-03T21:38:13Z"
  },
  {
    "videoId": "ofxv4Xn2UY8",
    "thumbnail": "https://i.ytimg.com/vi/ofxv4Xn2UY8/mqdefault.jpg",
    "title": "【歌枠】はっぴーばれんたいんっ！恋愛ソング縛り！Love song KARAOKE♡【湊あくあ/ホロライブ】",
    "publishedAt": "2021-02-14T15:28:06Z"
  },
  {
    "videoId": "VCzuq-GOUY8",
    "thumbnail": "https://i.ytimg.com/vi/VCzuq-GOUY8/mqdefault.jpg",
    "title": "【激レア雑談】ライブ前日！ちょっときいてええ！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-02-16T16:13:41Z"
  },
  {
    "videoId": "JO31hIVSrgI",
    "thumbnail": "https://i.ytimg.com/vi/JO31hIVSrgI/mqdefault.jpg",
    "title": "【歌枠】つよつようたわく！Sing a song～♪【湊あくあ/ホロライブ】",
    "publishedAt": "2021-02-18T17:49:29Z"
  },
  {
    "videoId": "0BBZs5rZktc",
    "thumbnail": "https://i.ytimg.com/vi/0BBZs5rZktc/mqdefault.jpg",
    "title": "『e-ma e-ma』歌って踊ってみた【ホロライブ / 湊あくあ】",
    "publishedAt": "2021-02-20T10:00:01Z"
  },
  {
    "videoId": "taIGVZoKNzk",
    "thumbnail": "https://i.ytimg.com/vi/taIGVZoKNzk/mqdefault.jpg",
    "title": "【APEX】最強環境！はじめての2PCでランクする！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-02-23T11:42:53Z"
  },
  {
    "videoId": "wMmBIwNGdHo",
    "thumbnail": "https://i.ytimg.com/vi/wMmBIwNGdHo/mqdefault.jpg",
    "title": "【激レア雑談】速報、遂に一人暮らし！など【湊あくあ/ホロライブ】",
    "publishedAt": "2021-02-26T15:35:21Z"
  },
  {
    "videoId": "R_RPrwu_MVw",
    "thumbnail": "https://i.ytimg.com/vi/R_RPrwu_MVw/mqdefault.jpg",
    "title": "【歌枠】止まらない！Non Stop ! Singing !!!!!!【湊あくあ/ホロライブ】",
    "publishedAt": "2021-02-27T13:11:12Z"
  },
  {
    "videoId": "9y_h_L0l5e4",
    "thumbnail": "https://i.ytimg.com/vi/9y_h_L0l5e4/mqdefault.jpg",
    "title": "【APEX】行くぞダイアモンド！行くぞキルムーブ！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-02-28T11:59:55Z"
  },
  {
    "videoId": "xIxTMQNgQ3U",
    "thumbnail": "https://i.ytimg.com/vi/xIxTMQNgQ3U/mqdefault.jpg",
    "title": "【ウマ娘 プリティーダービー】はじめてのウマ娘！やるよおおおおお！！【湊あくあ/馬】",
    "publishedAt": "2021-03-03T17:59:24Z"
  },
  {
    "videoId": "AczcfXLz3GI",
    "thumbnail": "https://i.ytimg.com/vi/AczcfXLz3GI/mqdefault.jpg",
    "title": "【APEX】魔境D4の世界【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-05T11:08:56Z"
  },
  {
    "videoId": "SXb5KkZahkk",
    "thumbnail": "https://i.ytimg.com/vi/SXb5KkZahkk/mqdefault.jpg",
    "title": "NE・KO・MI・MI☆",
    "publishedAt": "2021-03-07T07:29:02Z"
  },
  {
    "videoId": "xqAUACAV5rA",
    "thumbnail": "https://i.ytimg.com/vi/xqAUACAV5rA/mqdefault.jpg",
    "title": "【歌枠】HoneyWorks縛り！青春ソングKARAOKE～♪【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-07T13:19:37Z"
  },
  {
    "videoId": "7ekZL8lco-w",
    "thumbnail": "https://i.ytimg.com/vi/7ekZL8lco-w/mqdefault.jpg",
    "title": "み゛て゛え゛え゛え゛！！！！！！！！",
    "publishedAt": "2021-03-08T16:02:21Z"
  },
  {
    "videoId": "sQ-1o5Nm88s",
    "thumbnail": "https://i.ytimg.com/vi/sQ-1o5Nm88s/mqdefault.jpg",
    "title": "【APEX】ソロマスターちゃれんじ！一日目【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-09T12:32:12Z"
  },
  {
    "videoId": "lsIvVMavlIg",
    "thumbnail": "https://i.ytimg.com/vi/lsIvVMavlIg/mqdefault.jpg",
    "title": "【神様】ウマ娘：愛と涙と新作ガチャ【おねがい】",
    "publishedAt": "2021-03-09T15:52:00Z"
  },
  {
    "videoId": "_uJPzev14y4",
    "thumbnail": "https://i.ytimg.com/vi/_uJPzev14y4/mqdefault.jpg",
    "title": "【APEX】ソロマスターちゃれんじ！二日目【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-10T12:42:36Z"
  },
  {
    "videoId": "DPS0ariCGBU",
    "thumbnail": "https://i.ytimg.com/vi/DPS0ariCGBU/mqdefault.jpg",
    "title": "はじめてのグランブルーファンタジー【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-11T15:06:27Z"
  },
  {
    "videoId": "wfwg4Lhj79Y",
    "thumbnail": "https://i.ytimg.com/vi/wfwg4Lhj79Y/mqdefault.jpg",
    "title": "【APEX】ソロマスターちゃれんじ！三日目【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-12T12:29:31Z"
  },
  {
    "videoId": "StcHBb4AS3I",
    "thumbnail": "https://i.ytimg.com/vi/StcHBb4AS3I/mqdefault.jpg",
    "title": "【APEX】ソロマスターちゃれんじ！四日目【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-13T12:44:15Z"
  },
  {
    "videoId": "42Q5M2Cqalw",
    "thumbnail": "https://i.ytimg.com/vi/42Q5M2Cqalw/mqdefault.jpg",
    "title": "【APEX】ソロマスターちゃれんじっ！涙のD3脱出編【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-14T09:05:18Z"
  },
  {
    "videoId": "wQ2Kr0JCqpE",
    "thumbnail": "https://i.ytimg.com/vi/wQ2Kr0JCqpE/mqdefault.jpg",
    "title": "💗 🍫 Happy Whiteday 💌 💘【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-14T15:45:19Z"
  },
  {
    "videoId": "pXqUHGkp7xM",
    "thumbnail": "https://i.ytimg.com/vi/pXqUHGkp7xM/mqdefault.jpg",
    "title": "【APEX】目指せD2！ソロマスターちゃれんじっ！６日目【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-15T21:44:11Z"
  },
  {
    "videoId": "qO8Ld-qLjb0",
    "thumbnail": "https://i.ytimg.com/vi/qO8Ld-qLjb0/mqdefault.jpg",
    "title": "【APEX】D1目指して！ソロマスターちゃれんじっ！七日目【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-17T23:09:50Z"
  },
  {
    "videoId": "k3Nzow_OqQY",
    "thumbnail": "https://i.ytimg.com/vi/k3Nzow_OqQY/mqdefault.jpg",
    "title": "【APEX】行くぞD1！ソロマスターちゃれんじっ！八日目【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-19T23:00:51Z"
  },
  {
    "videoId": "y3DCfZmX8iA",
    "thumbnail": "https://i.ytimg.com/vi/y3DCfZmX8iA/mqdefault.jpg",
    "title": "【APEX】絶対行くぞ！ソロマスターちゃれんじっ！九日目【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-20T19:55:31Z"
  },
  {
    "videoId": "qHZwDxea7fQ",
    "thumbnail": "https://i.ytimg.com/vi/qHZwDxea7fQ/mqdefault.jpg",
    "title": "【APEX】絶対行くんだ！ソロマスターちゃれんじっ！十日目【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-21T20:57:32Z"
  },
  {
    "videoId": "cibdBr9TkEo",
    "thumbnail": "https://i.ytimg.com/vi/cibdBr9TkEo/mqdefault.jpg",
    "title": "【APEX】絶対にあきらめない！ソロマスターちゃれんじっ！十一日目【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-22T16:12:11Z"
  },
  {
    "videoId": "rW8jSXVsW2E",
    "thumbnail": "https://i.ytimg.com/vi/rW8jSXVsW2E/mqdefault.jpg",
    "title": "【APEX】くじけない！ソロマスターちゃれんじっ！最終日【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-23T17:27:11Z"
  },
  {
    "videoId": "eIi8zCPFyng",
    "thumbnail": "https://i.ytimg.com/vi/eIi8zCPFyng/mqdefault.jpg",
    "title": "【空気読み。３】なるほど！あはは！それな～！わかる！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-24T14:10:04Z"
  },
  {
    "videoId": "wtJj3CO_YR0",
    "thumbnail": "https://i.ytimg.com/vi/wtJj3CO_YR0/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】最新作｜冒険の始まりだあああ！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-25T18:18:33Z"
  },
  {
    "videoId": "97DWg8tqo4M",
    "thumbnail": "https://i.ytimg.com/vi/97DWg8tqo4M/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】プロハンターへの道｜目標：上位【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-27T12:17:53Z"
  },
  {
    "videoId": "sXnTgUkXqEE",
    "thumbnail": "https://i.ytimg.com/vi/sXnTgUkXqEE/mqdefault.jpg",
    "title": "【MONSTER HUNTER RISE】プロハンターへの道｜上位到達編【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-28T13:27:34Z"
  },
  {
    "videoId": "zl5P5lAvLwM",
    "thumbnail": "https://i.ytimg.com/vi/zl5P5lAvLwM/mqdefault.jpg",
    "title": "【 歌枠 】Anime Singing ☆ ナイトフィーバー！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-03-29T12:59:01Z"
  },
  {
    "videoId": "GsgbCSC6d50",
    "thumbnail": "https://i.ytimg.com/vi/GsgbCSC6d50/mqdefault.jpg",
    "title": "【 陰陽師 】幸運をこの手に！グラブル100連レジェンドフェス！【 湊あくあ/大空スバル 】",
    "publishedAt": "2021-03-30T13:36:49Z"
  },
  {
    "videoId": "TDXBiMKQZpI",
    "thumbnail": "https://i.ytimg.com/vi/TDXBiMKQZpI/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE 】行くぞ上位！出てこい！まだ見ぬモンスター！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-04-02T12:13:27Z"
  },
  {
    "videoId": "fkWB_8Yyt0A",
    "thumbnail": "https://i.ytimg.com/vi/fkWB_8Yyt0A/mqdefault.jpg",
    "title": "【APEX】復活のソロマスターちゃれんじっ！一日目【湊あくあ/ホロライブ】",
    "publishedAt": "2021-04-03T11:45:48Z"
  },
  {
    "videoId": "8QEhoC-DOjM",
    "thumbnail": "https://i.ytimg.com/vi/8QEhoC-DOjM/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE 】初の視聴者参加型！いっしょに装備つくろおおおお！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-04-03T15:43:52Z"
  },
  {
    "videoId": "DaT7j74W7zw",
    "thumbnail": "https://i.ytimg.com/vi/DaT7j74W7zw/mqdefault.jpg",
    "title": "【 歌枠 】いっぱい歌っちゃお～～～♪♪【湊あくあ/ホロライブ】",
    "publishedAt": "2021-04-04T16:47:00Z"
  },
  {
    "videoId": "1kxCz6tt2MU",
    "thumbnail": "https://i.ytimg.com/vi/1kxCz6tt2MU/mqdefault.jpg",
    "title": "【APEX】行くよ！ソロマスターちゃれんじっ！新章：二日目【湊あくあ/ホロライブ】",
    "publishedAt": "2021-04-05T17:43:21Z"
  },
  {
    "videoId": "qYPvBXjAbyU",
    "thumbnail": "https://i.ytimg.com/vi/qYPvBXjAbyU/mqdefault.jpg",
    "title": "【歌枠】おひさしぶり！おうた！おしゃべり！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-04-18T16:59:15Z"
  },
  {
    "videoId": "8ZxNvzmQ_OA",
    "thumbnail": "https://i.ytimg.com/vi/8ZxNvzmQ_OA/mqdefault.jpg",
    "title": "【激レア雑談】おやすみ前におはなししよ？【湊あくあ/ホロライブ】",
    "publishedAt": "2021-04-21T15:54:17Z"
  },
  {
    "videoId": "jl1A8ReVXBE",
    "thumbnail": "https://i.ytimg.com/vi/jl1A8ReVXBE/mqdefault.jpg",
    "title": "☆OUT OF BODY☆",
    "publishedAt": "2021-04-22T11:48:35Z"
  },
  {
    "videoId": "K4iwYT57hrk",
    "thumbnail": "https://i.ytimg.com/vi/K4iwYT57hrk/mqdefault.jpg",
    "title": "【歌枠】さみしかったあああ；；いっぱい歌うよおお！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-04-28T18:15:52Z"
  },
  {
    "videoId": "4lAZUuNY7VQ",
    "thumbnail": "https://i.ytimg.com/vi/4lAZUuNY7VQ/mqdefault.jpg",
    "title": "【ウマ娘】Aランク目指して！ゴルシとうまぴょい！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-04-29T17:20:54Z"
  },
  {
    "videoId": "4N_HwrzWCac",
    "thumbnail": "https://i.ytimg.com/vi/4N_HwrzWCac/mqdefault.jpg",
    "title": "【引き籠りが】グッバイ宣言／湊あくあ【歌ってみた】",
    "publishedAt": "2021-04-30T11:00:15Z"
  },
  {
    "videoId": "ZM8rlZYRlNw",
    "thumbnail": "https://i.ytimg.com/vi/ZM8rlZYRlNw/mqdefault.jpg",
    "title": "【歌枠】歌ってみた動画あげたよ～！今日は歌いまくる！Singing♪【湊あくあ/ホロライブ】",
    "publishedAt": "2021-05-02T16:49:12Z"
  },
  {
    "videoId": "gf7RSwmp8dM",
    "thumbnail": "https://i.ytimg.com/vi/gf7RSwmp8dM/mqdefault.jpg",
    "title": "【3DLIVE】あくあ色すーぱーみらくる☆どり〜む♪【#湊あくあ3Dライブ 】",
    "publishedAt": "2021-05-09T12:59:51Z"
  },
  {
    "videoId": "Snn2gWq-3KY",
    "thumbnail": "https://i.ytimg.com/vi/Snn2gWq-3KY/mqdefault.jpg",
    "title": "Aqua Cat [Minato Aqua/hololive]",
    "publishedAt": "2021-05-09T13:00:15Z"
  },
  {
    "videoId": "uBr8CvOnlh4",
    "thumbnail": "https://i.ytimg.com/vi/uBr8CvOnlh4/mqdefault.jpg",
    "title": "【メイドの日】3Dライブおつかれさま雑談！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-05-10T14:08:08Z"
  },
  {
    "videoId": "dT6pcpX_2hU",
    "thumbnail": "https://i.ytimg.com/vi/dT6pcpX_2hU/mqdefault.jpg",
    "title": "【歌枠】元気に歌うよおおおおお！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-06-07T13:36:33Z"
  },
  {
    "videoId": "BIPh0cYfd8I",
    "thumbnail": "https://i.ytimg.com/vi/BIPh0cYfd8I/mqdefault.jpg",
    "title": "【例外配達/Night Delivery】あくたんイーツはじめました。【湊あくあ/ホロライブ】",
    "publishedAt": "2021-06-08T14:33:06Z"
  },
  {
    "videoId": "Sywgq3l7ruk",
    "thumbnail": "https://i.ytimg.com/vi/Sywgq3l7ruk/mqdefault.jpg",
    "title": "【ウマ娘】セイウンスカイとらぶらぶ温泉旅行♡【湊あくあ/ホロライブ】",
    "publishedAt": "2021-06-11T18:49:14Z"
  },
  {
    "videoId": "rbPa0Qp3zJQ",
    "thumbnail": "https://i.ytimg.com/vi/rbPa0Qp3zJQ/mqdefault.jpg",
    "title": "【あてぃし】ヴァンパイア／湊あくあ【歌ってみた】",
    "publishedAt": "2021-06-12T09:00:10Z"
  },
  {
    "videoId": "hVRaAMVfn-c",
    "thumbnail": "https://i.ytimg.com/vi/hVRaAMVfn-c/mqdefault.jpg",
    "title": "【歌枠】歌ってみた上げたよおお！！アニメEDも決定！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-06-13T17:25:28Z"
  },
  {
    "videoId": "I3ryUDAz7kM",
    "thumbnail": "https://i.ytimg.com/vi/I3ryUDAz7kM/mqdefault.jpg",
    "title": "【BIOHAZARD 7】びびびびびび、びびってないし・・・？【湊あくあ/ホロライブ】",
    "publishedAt": "2021-06-19T17:35:45Z"
  },
  {
    "videoId": "t9erPqu3PYE",
    "thumbnail": "https://i.ytimg.com/vi/t9erPqu3PYE/mqdefault.jpg",
    "title": "【#レッドブルとLIMITBREAK】家にやばいものがきました……【湊あくあ/ホロライブ】",
    "publishedAt": "2021-06-20T09:29:24Z"
  },
  {
    "videoId": "PiqfrGp8bQ8",
    "thumbnail": "https://i.ytimg.com/vi/PiqfrGp8bQ8/mqdefault.jpg",
    "title": "【BIOHAZARD 7】完全初見！絶対に叫ばない！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-06-20T17:45:04Z"
  },
  {
    "videoId": "JO4QYfe4PI8",
    "thumbnail": "https://i.ytimg.com/vi/JO4QYfe4PI8/mqdefault.jpg",
    "title": "【BIOHAZARD 7】狂気のブラックジャック！？『21』【湊あくあ/ホロライブ】",
    "publishedAt": "2021-06-26T17:44:07Z"
  },
  {
    "videoId": "WEejHne5L6s",
    "thumbnail": "https://i.ytimg.com/vi/WEejHne5L6s/mqdefault.jpg",
    "title": "【耐久】本気で10人抜きする魂のブラックジャック『21 Survival+』",
    "publishedAt": "2021-07-03T21:46:36Z"
  },
  {
    "videoId": "_IVGZMRurwA",
    "thumbnail": "https://i.ytimg.com/vi/_IVGZMRurwA/mqdefault.jpg",
    "title": "【歌枠】Singing！耐久おつかれさまああ！うたうよおお！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-07-04T16:34:52Z"
  },
  {
    "videoId": "YFogAYSQFm0",
    "thumbnail": "https://i.ytimg.com/vi/YFogAYSQFm0/mqdefault.jpg",
    "title": "【川崎競馬】#湊あくあ杯 ！みんなで予想しよおお！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-07-05T12:11:16Z"
  },
  {
    "videoId": "gP8iNSq6Kwc",
    "thumbnail": "https://i.ytimg.com/vi/gP8iNSq6Kwc/mqdefault.jpg",
    "title": "【original】ヨーコソ！Sweet Carnival！【横須賀フェステーマソング】",
    "publishedAt": "2021-07-15T13:00:11Z"
  },
  {
    "videoId": "nCvv_A9Gsug",
    "thumbnail": "https://i.ytimg.com/vi/nCvv_A9Gsug/mqdefault.jpg",
    "title": "【Singing】うたあああああう！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-07-18T16:33:47Z"
  },
  {
    "videoId": "jsl7U1039TE",
    "thumbnail": "https://i.ytimg.com/vi/jsl7U1039TE/mqdefault.jpg",
    "title": "【ウマ娘 ガチャ】ゴールドシチー＆ウォッカ出すまで回す！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-07-20T15:55:06Z"
  },
  {
    "videoId": "eRZbt1K3iXE",
    "thumbnail": "https://i.ytimg.com/vi/eRZbt1K3iXE/mqdefault.jpg",
    "title": "【完全初見】バイオハザードヴィレッジ：Resident Evil Village【湊あくあ/ホロライブ】",
    "publishedAt": "2021-07-24T19:06:26Z"
  },
  {
    "videoId": "-hes2FlWUVM",
    "thumbnail": "https://i.ytimg.com/vi/-hes2FlWUVM/mqdefault.jpg",
    "title": "【完全初見】バイオハザードヴィレッジ：Resident Evil Village【湊あくあ/ホロライブ】",
    "publishedAt": "2021-07-25T16:32:28Z"
  },
  {
    "videoId": "AZvZQo7ied8",
    "thumbnail": "https://i.ytimg.com/vi/AZvZQo7ied8/mqdefault.jpg",
    "title": "【ウマ娘ガチャ】水着ｷﾀ━(ﾟ∀ﾟ)━!!!!!!!【湊あくあ/ホロライブ】",
    "publishedAt": "2021-07-29T14:06:03Z"
  },
  {
    "videoId": "yqN97IcVpbA",
    "thumbnail": "https://i.ytimg.com/vi/yqN97IcVpbA/mqdefault.jpg",
    "title": "【クリア耐久】バイオハザードヴィレッジ：Resident Evil Village【湊あくあ/ホロライブ】",
    "publishedAt": "2021-08-01T09:19:29Z"
  },
  {
    "videoId": "Ds7_PGM5s2Y",
    "thumbnail": "https://i.ytimg.com/vi/Ds7_PGM5s2Y/mqdefault.jpg",
    "title": "【歌枠】Singing…？Shinging？もうわかんないなこれ【湊あくあ/ホロライブ】",
    "publishedAt": "2021-08-04T16:29:27Z"
  },
  {
    "videoId": "PAVE5ykNRBs",
    "thumbnail": "https://i.ytimg.com/vi/PAVE5ykNRBs/mqdefault.jpg",
    "title": "【Minecraft】AKUKIN社長のホロ鯖お忍び計画【湊あくあ/ホロライブ】",
    "publishedAt": "2021-08-07T16:28:50Z"
  },
  {
    "videoId": "Ndik2fklmFo",
    "thumbnail": "https://i.ytimg.com/vi/Ndik2fklmFo/mqdefault.jpg",
    "title": "【3rd anniversary】絶対キョドらない凸待ち【湊あくあ/ホロライブ】",
    "publishedAt": "2021-08-08T14:57:21Z"
  },
  {
    "videoId": "tuWw5EQPGlc",
    "thumbnail": "https://i.ytimg.com/vi/tuWw5EQPGlc/mqdefault.jpg",
    "title": "【original】海想列車／湊あくあ【アニメーションMV】",
    "publishedAt": "2021-08-09T13:00:09Z"
  },
  {
    "videoId": "CtOkB0YQljY",
    "thumbnail": "https://i.ytimg.com/vi/CtOkB0YQljY/mqdefault.jpg",
    "title": "【#湊あくあ3周年記念 】あくあ色 3rd Anniversary Live【湊あくあ/ホロライブ】",
    "publishedAt": "2021-08-09T13:19:19Z"
  },
  {
    "videoId": "rY4giBtbtlo",
    "thumbnail": "https://i.ytimg.com/vi/rY4giBtbtlo/mqdefault.jpg",
    "title": "うたああああああああああああ【湊あくあ/ホロライブ】",
    "publishedAt": "2021-08-15T14:04:54Z"
  },
  {
    "videoId": "7Lt-b2Eq99Y",
    "thumbnail": "https://i.ytimg.com/vi/7Lt-b2Eq99Y/mqdefault.jpg",
    "title": "【Minecraft】ハードコアちゃれんじ！一日目【湊あくあ/ホロライブ】",
    "publishedAt": "2021-08-17T18:43:26Z"
  },
  {
    "videoId": "JJ7Ab19-DZg",
    "thumbnail": "https://i.ytimg.com/vi/JJ7Ab19-DZg/mqdefault.jpg",
    "title": "【歌枠】夏だあああああああああああああああああ！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-08-22T17:13:52Z"
  },
  {
    "videoId": "vYHFGPHUchU",
    "thumbnail": "https://i.ytimg.com/vi/vYHFGPHUchU/mqdefault.jpg",
    "title": "【NieR：Automata】これは呪いか。それとも罰か。※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2021-08-28T12:54:41Z"
  },
  {
    "videoId": "hc8RC9qF8ak",
    "thumbnail": "https://i.ytimg.com/vi/hc8RC9qF8ak/mqdefault.jpg",
    "title": "【NieR：Automata】人類に、栄光あれ。※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2021-08-29T10:58:48Z"
  },
  {
    "videoId": "e3yn9O7Pv84",
    "thumbnail": "https://i.ytimg.com/vi/e3yn9O7Pv84/mqdefault.jpg",
    "title": "【Minecraft】遂にネザーへ！ハードコアちゃれんじ２日目！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-08-30T18:09:00Z"
  },
  {
    "videoId": "q2mmOwuhQRc",
    "thumbnail": "https://i.ytimg.com/vi/q2mmOwuhQRc/mqdefault.jpg",
    "title": "【最終回】エンドラ討伐する！ハードコアちゃれんじ３日目！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-08-31T16:17:39Z"
  },
  {
    "videoId": "t5xlmbpB8hA",
    "thumbnail": "https://i.ytimg.com/vi/t5xlmbpB8hA/mqdefault.jpg",
    "title": "【歌枠】うたうよ！みらくる！！KARAOKE~~~♪【湊あくあ/ホロライブ】",
    "publishedAt": "2021-09-01T16:47:30Z"
  },
  {
    "videoId": "-zGFrAnsezQ",
    "thumbnail": "https://i.ytimg.com/vi/-zGFrAnsezQ/mqdefault.jpg",
    "title": "【つぐのひ】びびびび、びびビビッてないよ・・・？！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-09-02T16:22:48Z"
  },
  {
    "videoId": "b58S2Y_YcQo",
    "thumbnail": "https://i.ytimg.com/vi/b58S2Y_YcQo/mqdefault.jpg",
    "title": "【NieR：Automata】Part 1：Weight of the World…※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2021-09-04T09:18:52Z"
  },
  {
    "videoId": "lNs19dEP1SE",
    "thumbnail": "https://i.ytimg.com/vi/lNs19dEP1SE/mqdefault.jpg",
    "title": "【NieR：Automata】今度こそ最終回！続きからクリアまでやる！※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2021-09-04T18:26:44Z"
  },
  {
    "videoId": "j7pM4M9tO70",
    "thumbnail": "https://i.ytimg.com/vi/j7pM4M9tO70/mqdefault.jpg",
    "title": "メンヘラじゃないもん！ /Cover 湊あくあ/紫咲シオン【ホロライブ】",
    "publishedAt": "2021-09-05T13:00:12Z"
  },
  {
    "videoId": "_xL58zG9k5k",
    "thumbnail": "https://i.ytimg.com/vi/_xL58zG9k5k/mqdefault.jpg",
    "title": "【#あくシオ3Dライブ】おうたのはっぴょうかい！【ホロライブ/湊あくあ・紫咲シオン】",
    "publishedAt": "2021-09-05T13:25:33Z"
  },
  {
    "videoId": "eMHsHUk-7ns",
    "thumbnail": "https://i.ytimg.com/vi/eMHsHUk-7ns/mqdefault.jpg",
    "title": "【歌枠】ライブお疲れ様でしたいろいろ歌ったり話す【湊あくあ/ホロライブ】",
    "publishedAt": "2021-09-10T16:24:04Z"
  },
  {
    "videoId": "UOyxej1J2KI",
    "thumbnail": "https://i.ytimg.com/vi/UOyxej1J2KI/mqdefault.jpg",
    "title": "【カメラ料理】Let's cooking！！！！！！！！in オムライス編【湊あくあ/ホロライブ】",
    "publishedAt": "2021-09-11T14:19:10Z"
  },
  {
    "videoId": "Wvpkjkn1yqw",
    "thumbnail": "https://i.ytimg.com/vi/Wvpkjkn1yqw/mqdefault.jpg",
    "title": "【Gartic Phone】マウスでいきます【湊あくあ/ホロライブ】",
    "publishedAt": "2021-09-13T14:27:36Z"
  },
  {
    "videoId": "6YkFUGphuxU",
    "thumbnail": "https://i.ytimg.com/vi/6YkFUGphuxU/mqdefault.jpg",
    "title": "【放送事故】ミュートを忘れ親フラしてしまう萌え声配信者ｗｗｗｗ",
    "publishedAt": "2021-09-15T13:56:12Z"
  },
  {
    "videoId": "uBS7xpLWSNM",
    "thumbnail": "https://i.ytimg.com/vi/uBS7xpLWSNM/mqdefault.jpg",
    "title": "シンデレラ / 湊あくあ(cover)",
    "publishedAt": "2021-09-16T09:00:11Z"
  },
  {
    "videoId": "WIwVn-jByvw",
    "thumbnail": "https://i.ytimg.com/vi/WIwVn-jByvw/mqdefault.jpg",
    "title": "【Minecraft】OCEAN MONUMENT! 4人で神殿攻略！ 🌊 #UMISEA",
    "publishedAt": "2021-09-17T13:20:35Z"
  },
  {
    "videoId": "UXRRjoh9mMk",
    "thumbnail": "https://i.ytimg.com/vi/UXRRjoh9mMk/mqdefault.jpg",
    "title": "【歌枠】歌ってみた投稿＆コラボおつかれさまでした！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-09-20T16:32:29Z"
  },
  {
    "videoId": "425-oc3ZEgg",
    "thumbnail": "https://i.ytimg.com/vi/425-oc3ZEgg/mqdefault.jpg",
    "title": "【ゲリラ】いちおくねんぶりのざつだん【湊あくあ/ホロライブ】",
    "publishedAt": "2021-09-21T11:43:49Z"
  },
  {
    "videoId": "Yp3wIxQUtpA",
    "thumbnail": "https://i.ytimg.com/vi/Yp3wIxQUtpA/mqdefault.jpg",
    "title": "【開封配信】ヴァイスコラボで自分のサイン出るまで開封！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-10-01T12:08:57Z"
  },
  {
    "videoId": "6Wbto57VKWk",
    "thumbnail": "https://i.ytimg.com/vi/6Wbto57VKWk/mqdefault.jpg",
    "title": "うまぴょい伝説 /Cover ホロライブ",
    "publishedAt": "2021-10-03T12:00:12Z"
  },
  {
    "videoId": "D3ll-berrTY",
    "thumbnail": "https://i.ytimg.com/vi/D3ll-berrTY/mqdefault.jpg",
    "title": "【歌枠】歌ってみた動画あげたよおおおお！！KARAOKE♪【湊あくあ/ホロライブ】",
    "publishedAt": "2021-10-03T17:00:48Z"
  },
  {
    "videoId": "7F6_vyyMMrE",
    "thumbnail": "https://i.ytimg.com/vi/7F6_vyyMMrE/mqdefault.jpg",
    "title": "【雑☆談】たいへんなことがおきた！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-10-08T15:49:25Z"
  },
  {
    "videoId": "1OrAfIm7W4E",
    "thumbnail": "https://i.ytimg.com/vi/1OrAfIm7W4E/mqdefault.jpg",
    "title": "【Minecraft】ゲリラあああああああああああああああああ【湊あくあ/ホロライブ】",
    "publishedAt": "2021-10-10T19:08:14Z"
  },
  {
    "videoId": "yQq3KLXypwQ",
    "thumbnail": "https://i.ytimg.com/vi/yQq3KLXypwQ/mqdefault.jpg",
    "title": "【Minecraft】EN鯖へ！！さいとしーいんぐ！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-10-15T15:51:23Z"
  },
  {
    "videoId": "DmURJdzr-Cc",
    "thumbnail": "https://i.ytimg.com/vi/DmURJdzr-Cc/mqdefault.jpg",
    "title": "【歌枠】げりらだがかんけいない！うたう！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-10-17T16:32:53Z"
  },
  {
    "videoId": "ZRORXVf4ers",
    "thumbnail": "https://i.ytimg.com/vi/ZRORXVf4ers/mqdefault.jpg",
    "title": "【ガルパ】湊あくあがガルパとコラボってマ！？【#湊あくあガルパ配信中day1】",
    "publishedAt": "2021-10-22T11:42:14Z"
  },
  {
    "videoId": "HDgGnLYbaD8",
    "thumbnail": "https://i.ytimg.com/vi/HDgGnLYbaD8/mqdefault.jpg",
    "title": "【近況報告】ううううううううう！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-10-28T11:57:45Z"
  },
  {
    "videoId": "IHrFrUhe6AE",
    "thumbnail": "https://i.ytimg.com/vi/IHrFrUhe6AE/mqdefault.jpg",
    "title": "【JRA公式】キリトになって天皇賞・秋(GI)を本気で勝ちに行く！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-10-29T13:45:43Z"
  },
  {
    "videoId": "X3cGbCqErEg",
    "thumbnail": "https://i.ytimg.com/vi/X3cGbCqErEg/mqdefault.jpg",
    "title": "【ガルパ】リズム音痴でもよゆうだよね・・・・？【#湊あくあガルパ配信中day2】",
    "publishedAt": "2021-10-30T11:15:53Z"
  },
  {
    "videoId": "T2Z_07i2LsE",
    "thumbnail": "https://i.ytimg.com/vi/T2Z_07i2LsE/mqdefault.jpg",
    "title": "【#ホロハロウィンAmongUs】あの～・・・天気いいですね・・・【湊あくあ/ホロライブ】",
    "publishedAt": "2021-10-31T16:19:54Z"
  },
  {
    "videoId": "GLAUrRYIpag",
    "thumbnail": "https://i.ytimg.com/vi/GLAUrRYIpag/mqdefault.jpg",
    "title": "【本番】白組しか勝たん！！！！！！！！【#ホロライブ大運動会2021 】",
    "publishedAt": "2021-11-06T10:31:38Z"
  },
  {
    "videoId": "0kGVDYAKcGc",
    "thumbnail": "https://i.ytimg.com/vi/0kGVDYAKcGc/mqdefault.jpg",
    "title": "【#湊あくあ重大発表】3DLIVE！！重大発表！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-11-08T12:57:56Z"
  },
  {
    "videoId": "ZI3ygHZOSDc",
    "thumbnail": "https://i.ytimg.com/vi/ZI3ygHZOSDc/mqdefault.jpg",
    "title": "MINATO AQUA ONEMAN LIVE 2022 \"AQUA IRO IN WONDERLAND\" TEASER MOVIE",
    "publishedAt": "2021-11-18T11:00:30Z"
  },
  {
    "videoId": "YUNlZqgqabQ",
    "thumbnail": "https://i.ytimg.com/vi/YUNlZqgqabQ/mqdefault.jpg",
    "title": "【ゲリラ】寝起き５秒だけど歌っちゃうよおおお！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-11-23T08:27:20Z"
  },
  {
    "videoId": "PIqmgNO3E6E",
    "thumbnail": "https://i.ytimg.com/vi/PIqmgNO3E6E/mqdefault.jpg",
    "title": "すーぱーみらくるはいぱーおしゃべり【湊あくあ/ホロライブ】",
    "publishedAt": "2021-11-25T15:27:54Z"
  },
  {
    "videoId": "oTuDC4fgE9M",
    "thumbnail": "https://i.ytimg.com/vi/oTuDC4fgE9M/mqdefault.jpg",
    "title": "【邪神ころね】ｽｩｰｰｰｰｰ・・・・ゆびゆび・・・・【湊あくあ/ホロライブ】",
    "publishedAt": "2021-11-29T15:52:01Z"
  },
  {
    "videoId": "s_6FlkJS3ew",
    "thumbnail": "https://i.ytimg.com/vi/s_6FlkJS3ew/mqdefault.jpg",
    "title": "【#湊あくあ生誕祭】たんじょうびまで歌ったりする！Singing♪【湊あくあ/ホロライブ】",
    "publishedAt": "2021-11-30T15:50:34Z"
  },
  {
    "videoId": "fXeM0fXvOp8",
    "thumbnail": "https://i.ytimg.com/vi/fXeM0fXvOp8/mqdefault.jpg",
    "title": "【アニメMV】きらきら／湊あくあ",
    "publishedAt": "2021-12-01T12:45:11Z"
  },
  {
    "videoId": "JSitZSYYzfA",
    "thumbnail": "https://i.ytimg.com/vi/JSitZSYYzfA/mqdefault.jpg",
    "title": "【#湊あくあ生誕祭】はじめまして！湊あくあです。【湊あくあ/ホロライブ】",
    "publishedAt": "2021-12-01T13:16:10Z"
  },
  {
    "videoId": "hdqLQDy1vDI",
    "thumbnail": "https://i.ytimg.com/vi/hdqLQDy1vDI/mqdefault.jpg",
    "title": "【同時視聴】あくぼたでArcaneみるよ #あくぼた同時視聴【湊あくあ/獅白ぼたん】",
    "publishedAt": "2021-12-02T15:26:45Z"
  },
  {
    "videoId": "6fYP6oHWUzA",
    "thumbnail": "https://i.ytimg.com/vi/6fYP6oHWUzA/mqdefault.jpg",
    "title": "【歌枠】ラッパーあくたんのカラオケ配信！Singing stream♪【湊あくあ/ホロライブ】",
    "publishedAt": "2021-12-05T17:12:55Z"
  },
  {
    "videoId": "8P94mxV4w0A",
    "thumbnail": "https://i.ytimg.com/vi/8P94mxV4w0A/mqdefault.jpg",
    "title": "【超ゲリラ】今日は休みだからおもいっきりはなそうとおもうっ！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-12-09T07:21:52Z"
  },
  {
    "videoId": "2pYaIr-4pfA",
    "thumbnail": "https://i.ytimg.com/vi/2pYaIr-4pfA/mqdefault.jpg",
    "title": "【アイドルが】誇り高きアイドル／湊あくあ【歌ってみた】",
    "publishedAt": "2021-12-21T11:00:14Z"
  },
  {
    "videoId": "sU2RJ6S2FT4",
    "thumbnail": "https://i.ytimg.com/vi/sU2RJ6S2FT4/mqdefault.jpg",
    "title": "【クリスマス会】陽キャが家にやってきた #地獄のねぎゆー【湊あくあ/大空スバル/桃鈴ねね】",
    "publishedAt": "2021-12-23T15:11:44Z"
  },
  {
    "videoId": "HECDfXo_WRs",
    "thumbnail": "https://i.ytimg.com/vi/HECDfXo_WRs/mqdefault.jpg",
    "title": "【#ホロクリスマス歌枠リレー】なにうたおっかな～～！【湊あくあ/ホロライブ】",
    "publishedAt": "2021-12-25T14:02:42Z"
  },
  {
    "videoId": "NcQQtcg83qs",
    "thumbnail": "https://i.ytimg.com/vi/NcQQtcg83qs/mqdefault.jpg",
    "title": "【年越し】いっしょに２０２２年をむかえる配信【湊あくあ/ホロライブ】",
    "publishedAt": "2021-12-31T15:24:27Z"
  },
  {
    "videoId": "pxzwceVuLk4",
    "thumbnail": "https://i.ytimg.com/vi/pxzwceVuLk4/mqdefault.jpg",
    "title": "【マリオカート8DX】第一回湊あくあコソ練選手権会場【湊あくあ/ホロライブ】",
    "publishedAt": "2022-01-04T16:29:54Z"
  },
  {
    "videoId": "T0W2zNs8-Ns",
    "thumbnail": "https://i.ytimg.com/vi/T0W2zNs8-Ns/mqdefault.jpg",
    "title": "【#ホロお正月CUP2022】予選Bブロック！つよ杯いくぞ！！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-01-07T05:34:27Z"
  },
  {
    "videoId": "SYzi3uZaodY",
    "thumbnail": "https://i.ytimg.com/vi/SYzi3uZaodY/mqdefault.jpg",
    "title": "【ゲリラ】とつぜんすぎるお昼のゆるすぎマイクラ【湊あくあ/ホロライブ】",
    "publishedAt": "2022-01-14T05:49:21Z"
  },
  {
    "videoId": "Tk5nBH-mfIY",
    "thumbnail": "https://i.ytimg.com/vi/Tk5nBH-mfIY/mqdefault.jpg",
    "title": "【歌枠】新年！はじめての歌枠！！♡KARAOKE LIVE♡【湊あくあ/ホロライブ】",
    "publishedAt": "2022-01-14T14:58:32Z"
  },
  {
    "videoId": "NyOqSaCXLlE",
    "thumbnail": "https://i.ytimg.com/vi/NyOqSaCXLlE/mqdefault.jpg",
    "title": "#1【APEX】復活のソロマスターちゃれんじっ！一日目【湊あくあ/ホロライブ】",
    "publishedAt": "2022-01-22T07:03:39Z"
  },
  {
    "videoId": "-cmhzJHYN6E",
    "thumbnail": "https://i.ytimg.com/vi/-cmhzJHYN6E/mqdefault.jpg",
    "title": "#2【APEX】復活のソロマスターちゃれんじっ！二日目【湊あくあ/ホロライブ】",
    "publishedAt": "2022-01-23T08:33:06Z"
  },
  {
    "videoId": "tqeEX-bvHMc",
    "thumbnail": "https://i.ytimg.com/vi/tqeEX-bvHMc/mqdefault.jpg",
    "title": "【歌枠】おしらせがあるよ！うたいます！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-01-23T14:46:21Z"
  },
  {
    "videoId": "4ucFQzVTSrE",
    "thumbnail": "https://i.ytimg.com/vi/4ucFQzVTSrE/mqdefault.jpg",
    "title": "#3【APEX】復活のソロマスターちゃれんじっ！三日目【湊あくあ/ホロライブ】",
    "publishedAt": "2022-01-26T15:57:00Z"
  },
  {
    "videoId": "8D6bGLucsYM",
    "thumbnail": "https://i.ytimg.com/vi/8D6bGLucsYM/mqdefault.jpg",
    "title": "【チラ見せ枠】湊あくあ ワンマンライブ2022「あくあ色 in わんだ～☆らんど♪」【＃湊あくあソロライブ】",
    "publishedAt": "2022-01-28T09:46:43Z"
  },
  {
    "videoId": "yTP5M0ZgjGo",
    "thumbnail": "https://i.ytimg.com/vi/yTP5M0ZgjGo/mqdefault.jpg",
    "title": "#4【APEX】復活のソロマスターちゃれんじっ！四日目【湊あくあ/ホロライブ】",
    "publishedAt": "2022-01-30T09:39:32Z"
  },
  {
    "videoId": "qDdEr7MqwDg",
    "thumbnail": "https://i.ytimg.com/vi/qDdEr7MqwDg/mqdefault.jpg",
    "title": "#6【APEX】復活のソロマスターちゃれんじっ！五日目【湊あくあ/ホロライブ】",
    "publishedAt": "2022-01-31T16:40:00Z"
  },
  {
    "videoId": "19oaAJV24xI",
    "thumbnail": "https://i.ytimg.com/vi/19oaAJV24xI/mqdefault.jpg",
    "title": "#7【APEX】いくぞD２！ソロマスターちゃれんじっ！六日目【湊あくあ/ホロライブ】",
    "publishedAt": "2022-02-01T18:22:58Z"
  },
  {
    "videoId": "AEZYj5j1bQk",
    "thumbnail": "https://i.ytimg.com/vi/AEZYj5j1bQk/mqdefault.jpg",
    "title": "#8【APEX】諦めない！ソロマスターちゃれんじっ！七日目【湊あくあ/ホロライブ】",
    "publishedAt": "2022-02-02T09:46:12Z"
  },
  {
    "videoId": "XHhe9H7PAA8",
    "thumbnail": "https://i.ytimg.com/vi/XHhe9H7PAA8/mqdefault.jpg",
    "title": "#9【APEX】目指せD1！ソロマスターちゃれんじっ！八日目【湊あくあ/ホロライブ】",
    "publishedAt": "2022-02-03T18:34:27Z"
  },
  {
    "videoId": "aGlY6Ueaco0",
    "thumbnail": "https://i.ytimg.com/vi/aGlY6Ueaco0/mqdefault.jpg",
    "title": "#10【APEX】ソロマスターいくまで耐久！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-02-04T12:59:45Z"
  },
  {
    "videoId": "NLPMrKgcI8E",
    "thumbnail": "https://i.ytimg.com/vi/NLPMrKgcI8E/mqdefault.jpg",
    "title": "MinatoAqua | Apex SoloMaster Montage",
    "publishedAt": "2022-02-05T05:22:03Z"
  },
  {
    "videoId": "so992B_VLU4",
    "thumbnail": "https://i.ytimg.com/vi/so992B_VLU4/mqdefault.jpg",
    "title": "【ゲリラ】ソロマス達成！まったりいろいろはなす！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-02-05T13:47:23Z"
  },
  {
    "videoId": "-yl7_T1OMI0",
    "thumbnail": "https://i.ytimg.com/vi/-yl7_T1OMI0/mqdefault.jpg",
    "title": "【歌枠】月曜日をふっとばすわよ！KARAOKE LIVE♪【湊あくあ/ホロライブ】",
    "publishedAt": "2022-02-06T17:58:13Z"
  },
  {
    "videoId": "B-t4TmrpgEc",
    "thumbnail": "https://i.ytimg.com/vi/B-t4TmrpgEc/mqdefault.jpg",
    "title": "【APEX】ソロマス記念｜スパレジェ出るまで回す！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-02-08T15:02:37Z"
  },
  {
    "videoId": "E6LWLQjgynE",
    "thumbnail": "https://i.ytimg.com/vi/E6LWLQjgynE/mqdefault.jpg",
    "title": "神っぽいな / 湊あくあ/天音かなた Cover【ホロライブ】",
    "publishedAt": "2022-02-09T10:00:33Z"
  },
  {
    "videoId": "mMXwPWd-zGs",
    "thumbnail": "https://i.ytimg.com/vi/mMXwPWd-zGs/mqdefault.jpg",
    "title": "【歌枠】明日はバレンタインだ！！！Love Song KARAOKE♪【湊あくあ/ホロライブ】",
    "publishedAt": "2022-02-13T14:11:30Z"
  },
  {
    "videoId": "NQ4NJWTsj4k",
    "thumbnail": "https://i.ytimg.com/vi/NQ4NJWTsj4k/mqdefault.jpg",
    "title": "【カメラ】チョコほしい人～！！！！│Valentine's Day♡【湊あくあ/ホロライブ】",
    "publishedAt": "2022-02-14T11:07:45Z"
  },
  {
    "videoId": "iXY7m84ZEYw",
    "thumbnail": "https://i.ytimg.com/vi/iXY7m84ZEYw/mqdefault.jpg",
    "title": "【ゲリラ】AKUKINは何度でも蘇る―・・・【湊あくあ/ホロライブ】",
    "publishedAt": "2022-02-17T11:58:56Z"
  },
  {
    "videoId": "swX1O_a_vAk",
    "thumbnail": "https://i.ytimg.com/vi/swX1O_a_vAk/mqdefault.jpg",
    "title": "【アニメMV】あいわな／湊あくあ",
    "publishedAt": "2022-02-18T10:00:11Z"
  },
  {
    "videoId": "JBtHHuei1J8",
    "thumbnail": "https://i.ytimg.com/vi/JBtHHuei1J8/mqdefault.jpg",
    "title": "【ゲリラ】すこしだけおはなしします！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-03-18T13:57:08Z"
  },
  {
    "videoId": "pRNu2_jclDc",
    "thumbnail": "https://i.ytimg.com/vi/pRNu2_jclDc/mqdefault.jpg",
    "title": "【歌枠】ライブおつかれさまでした！KARAOKE LIVE♪【湊あくあ/ホロライブ】",
    "publishedAt": "2022-03-21T17:45:26Z"
  },
  {
    "videoId": "AUP3OI9Yhmc",
    "thumbnail": "https://i.ytimg.com/vi/AUP3OI9Yhmc/mqdefault.jpg",
    "title": "点描の唄 /Cover 湊あくあ/猫又おかゆ【ホロライブ】",
    "publishedAt": "2022-03-23T11:00:28Z"
  },
  {
    "videoId": "YgOpBTSTLwE",
    "thumbnail": "https://i.ytimg.com/vi/YgOpBTSTLwE/mqdefault.jpg",
    "title": "【APEX】これが噂の顔合わせってやつ・・・！？【湊あくあ/常闇トワ/星街すいせい】",
    "publishedAt": "2022-03-27T15:50:02Z"
  },
  {
    "videoId": "AqX2bXQU4QY",
    "thumbnail": "https://i.ytimg.com/vi/AqX2bXQU4QY/mqdefault.jpg",
    "title": "【ゲリラ】歌おうと思いましたがしゃべります【湊あくあ/ホロライブ】",
    "publishedAt": "2022-03-30T11:28:27Z"
  },
  {
    "videoId": "Qg9Uj371GaA",
    "thumbnail": "https://i.ytimg.com/vi/Qg9Uj371GaA/mqdefault.jpg",
    "title": "【30分耐久BGM】Aqua Step Allegretto / 湊あくあ【公式】",
    "publishedAt": "2022-04-01T12:11:25Z"
  },
  {
    "videoId": "lwptxmlQtIc",
    "thumbnail": "https://i.ytimg.com/vi/lwptxmlQtIc/mqdefault.jpg",
    "title": "【APEX】３人合わせて！ぽんこｔ・・・Startend！！！【湊あくあ/常闇トワ/星街すいせい】",
    "publishedAt": "2022-04-02T17:14:59Z"
  },
  {
    "videoId": "lz19_O-yPew",
    "thumbnail": "https://i.ytimg.com/vi/lz19_O-yPew/mqdefault.jpg",
    "title": "【APEX】V最協練習カスタム　チャンピオンとった録画【湊あくあ/ホロライブ】",
    "publishedAt": "2022-04-03T12:47:16Z"
  },
  {
    "videoId": "0XdWjfTXodw",
    "thumbnail": "https://i.ytimg.com/vi/0XdWjfTXodw/mqdefault.jpg",
    "title": "【スシロー】すしをたべるぞ！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-04-05T11:28:31Z"
  },
  {
    "videoId": "TDC3NLyKjrg",
    "thumbnail": "https://i.ytimg.com/vi/TDC3NLyKjrg/mqdefault.jpg",
    "title": "【APEX】勝って焼肉食べ放題するんだ！Startend！！！【湊あくあ/常闇トワ/星街すいせい】",
    "publishedAt": "2022-04-08T20:34:18Z"
  },
  {
    "videoId": "HBBnYWjLY-A",
    "thumbnail": "https://i.ytimg.com/vi/HBBnYWjLY-A/mqdefault.jpg",
    "title": "【APEX】最初で最後のStartend！カスタム初日【湊あくあ/常闇トワ/星街すいせい】",
    "publishedAt": "2022-04-11T15:21:00Z"
  },
  {
    "videoId": "QR6vopoYkcI",
    "thumbnail": "https://i.ytimg.com/vi/QR6vopoYkcI/mqdefault.jpg",
    "title": "【APEX】今夜は眠れないStartend！【湊あくあ/常闇トワ/星街すいせい】",
    "publishedAt": "2022-04-14T16:17:51Z"
  },
  {
    "videoId": "XpgSrULHibg",
    "thumbnail": "https://i.ytimg.com/vi/XpgSrULHibg/mqdefault.jpg",
    "title": "アスノヨゾラ哨戒班 ／ Startend cover",
    "publishedAt": "2022-04-16T10:00:50Z"
  },
  {
    "videoId": "d0QUB-aeKvE",
    "thumbnail": "https://i.ytimg.com/vi/d0QUB-aeKvE/mqdefault.jpg",
    "title": "【APEX】前夜祭！最後の練習Startend！【湊あくあ/常闇トワ/星街すいせい】",
    "publishedAt": "2022-04-16T15:37:39Z"
  },
  {
    "videoId": "81wyBhN6Ltk",
    "thumbnail": "https://i.ytimg.com/vi/81wyBhN6Ltk/mqdefault.jpg",
    "title": "【#V最協S4】最初で最後のStartend！【#STAWIN】",
    "publishedAt": "2022-04-17T13:39:24Z"
  },
  {
    "videoId": "nyFr_w-a7Xw",
    "thumbnail": "https://i.ytimg.com/vi/nyFr_w-a7Xw/mqdefault.jpg",
    "title": "【歌枠】ひさしぶりにたくさんうたうよ！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-05-16T12:38:24Z"
  },
  {
    "videoId": "b59kreP24ac",
    "thumbnail": "https://i.ytimg.com/vi/b59kreP24ac/mqdefault.jpg",
    "title": "【歌枠】おひるのおうた！！KARAOKE Singing♪【湊あくあ/ホロライブ】",
    "publishedAt": "2022-05-29T06:39:36Z"
  },
  {
    "videoId": "eAk9Vn4psQI",
    "thumbnail": "https://i.ytimg.com/vi/eAk9Vn4psQI/mqdefault.jpg",
    "title": "【歌ってみた】ぎゅっと。 / 湊あくあ cover",
    "publishedAt": "2022-06-10T11:00:14Z"
  },
  {
    "videoId": "81EYhdvNMms",
    "thumbnail": "https://i.ytimg.com/vi/81EYhdvNMms/mqdefault.jpg",
    "title": "【おじさんと遊ぼう】変な人からリプライがきて困っています。【湊あくあ/ホロライブ】",
    "publishedAt": "2022-06-14T15:25:33Z"
  },
  {
    "videoId": "qWqoW4yW2NU",
    "thumbnail": "https://i.ytimg.com/vi/qWqoW4yW2NU/mqdefault.jpg",
    "title": "【#SAOVS】これは、ゲームであっても遊びではない。【湊あくあ/ホロライブ】",
    "publishedAt": "2022-06-19T11:59:31Z"
  },
  {
    "videoId": "_DeqC97LOLg",
    "thumbnail": "https://i.ytimg.com/vi/_DeqC97LOLg/mqdefault.jpg",
    "title": "おひさしぶりにはなすわよ！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-07-16T13:52:50Z"
  },
  {
    "videoId": "GsIaScJFdMk",
    "thumbnail": "https://i.ytimg.com/vi/GsIaScJFdMk/mqdefault.jpg",
    "title": "【４周年】重大告知たくさん！お祝いするよ！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-08-08T14:21:45Z"
  },
  {
    "videoId": "16WxRVoTAx0",
    "thumbnail": "https://i.ytimg.com/vi/16WxRVoTAx0/mqdefault.jpg",
    "title": "【あくありうむ。主題歌】未だ、青い／湊あくあ【マンガMV】",
    "publishedAt": "2022-08-11T13:00:13Z"
  },
  {
    "videoId": "O4Ip7gZQOts",
    "thumbnail": "https://i.ytimg.com/vi/O4Ip7gZQOts/mqdefault.jpg",
    "title": "【3DLIVE】あくあ色ふぇすてぃばる。【#湊あくあ4周年記念】",
    "publishedAt": "2022-08-11T13:05:40Z"
  },
  {
    "videoId": "gVP3vlN0D8o",
    "thumbnail": "https://i.ytimg.com/vi/gVP3vlN0D8o/mqdefault.jpg",
    "title": "【あくありうむ。】本人が本人を攻略するゲームやるってまじ？【湊あくあ/ホロライブ】",
    "publishedAt": "2022-08-27T16:11:39Z"
  },
  {
    "videoId": "8nCpQFvr-U4",
    "thumbnail": "https://i.ytimg.com/vi/8nCpQFvr-U4/mqdefault.jpg",
    "title": "【大天使が】INTERNET OVERDOSE／湊あくあ【歌ってみた】",
    "publishedAt": "2022-08-29T09:00:14Z"
  },
  {
    "videoId": "BYTP2oLr59Q",
    "thumbnail": "https://i.ytimg.com/vi/BYTP2oLr59Q/mqdefault.jpg",
    "title": "「あくたんのこと好きすぎ☆ソング」 (Solo Live 2022「あくあ色 in わんだ～☆らんど♪」ver.)",
    "publishedAt": "2022-09-05T10:33:52Z"
  },
  {
    "videoId": "5KZlGefCtUo",
    "thumbnail": "https://i.ytimg.com/vi/5KZlGefCtUo/mqdefault.jpg",
    "title": "【歌枠】五億年ぶりにうたうよおおおおお！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-09-10T13:54:02Z"
  },
  {
    "videoId": "ugTie-8HXLw",
    "thumbnail": "https://i.ytimg.com/vi/ugTie-8HXLw/mqdefault.jpg",
    "title": "「uni-birth」 (Solo Live 2022「あくあ色 in わんだ～☆らんど♪」ver.)",
    "publishedAt": "2022-09-21T10:38:56Z"
  },
  {
    "videoId": "iFviFwVe4a8",
    "thumbnail": "https://i.ytimg.com/vi/iFviFwVe4a8/mqdefault.jpg",
    "title": "あたらしい髪形をみんなにみせちゃいます【湊あくあ/ホロライブ】",
    "publishedAt": "2022-09-26T12:15:30Z"
  },
  {
    "videoId": "i-rvC08NHCA",
    "thumbnail": "https://i.ytimg.com/vi/i-rvC08NHCA/mqdefault.jpg",
    "title": "【地獄銭湯】ひとりでおふろはいれるもん・・・・【湊あくあ/ホロライブ】",
    "publishedAt": "2022-10-02T17:01:00Z"
  },
  {
    "videoId": "SUcgqb3IvbU",
    "thumbnail": "https://i.ytimg.com/vi/SUcgqb3IvbU/mqdefault.jpg",
    "title": "【歌枠】新しいお部屋でうきうきでうたっちゃうよ！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-10-08T15:50:15Z"
  },
  {
    "videoId": "osH8YZxFu0U",
    "thumbnail": "https://i.ytimg.com/vi/osH8YZxFu0U/mqdefault.jpg",
    "title": "【SAOVS】言っとくが、わたしはソロだ。【湊あくあ/ホロライブ】",
    "publishedAt": "2022-10-24T11:22:59Z"
  },
  {
    "videoId": "2ZL2dIOgD5E",
    "thumbnail": "https://i.ytimg.com/vi/2ZL2dIOgD5E/mqdefault.jpg",
    "title": "【朝活】🎃はっぴーはろうぃんっ！🎃【湊あくあ/ホロライブ】",
    "publishedAt": "2022-10-30T23:14:52Z"
  },
  {
    "videoId": "fCSYzsbZbyM",
    "thumbnail": "https://i.ytimg.com/vi/fCSYzsbZbyM/mqdefault.jpg",
    "title": "【運動会練習】白組！優勝！しか勝たん！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-10-31T14:37:22Z"
  },
  {
    "videoId": "1N2fktbL1w4",
    "thumbnail": "https://i.ytimg.com/vi/1N2fktbL1w4/mqdefault.jpg",
    "title": "【#ホロライブ運動会2022】たのしかったうんどうかい【湊あくあ/ホロライブ】",
    "publishedAt": "2022-11-06T08:58:37Z"
  },
  {
    "videoId": "14-BZnF9aao",
    "thumbnail": "https://i.ytimg.com/vi/14-BZnF9aao/mqdefault.jpg",
    "title": "【ポケモンSV】最新作！五億年ぶりにポケモンやってみる！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-11-17T15:30:47Z"
  },
  {
    "videoId": "U2N0sUYPNyA",
    "thumbnail": "https://i.ytimg.com/vi/U2N0sUYPNyA/mqdefault.jpg",
    "title": "【ポケモンSV】最新作！五億年ぶりにポケモンやってみる！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-11-18T04:35:37Z"
  },
  {
    "videoId": "btgB01tyMmQ",
    "thumbnail": "https://i.ytimg.com/vi/btgB01tyMmQ/mqdefault.jpg",
    "title": "【ポケモンSV】最新作！ポケモンが辞められなくなった女の末路【湊あくあ/ホロライブ】",
    "publishedAt": "2022-11-18T21:12:02Z"
  },
  {
    "videoId": "-9FX-_ETv7Q",
    "thumbnail": "https://i.ytimg.com/vi/-9FX-_ETv7Q/mqdefault.jpg",
    "title": "【ポケモンSV】最新作！リーグ優勝目指して！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-11-19T22:03:06Z"
  },
  {
    "videoId": "X0VQvXkF1jA",
    "thumbnail": "https://i.ytimg.com/vi/X0VQvXkF1jA/mqdefault.jpg",
    "title": "【ポケモンSV】最終回！ありがとう、ポケモン。【湊あくあ/ホロライブ】",
    "publishedAt": "2022-11-22T00:58:50Z"
  },
  {
    "videoId": "wyOl7wcU07Y",
    "thumbnail": "https://i.ytimg.com/vi/wyOl7wcU07Y/mqdefault.jpg",
    "title": "【＃湊あくあ新衣装】５億年ぶりの新衣装お披露目・・・！！！✨【湊あくあ/ホロライブ】",
    "publishedAt": "2022-11-26T14:15:46Z"
  },
  {
    "videoId": "toGkFD-mg7M",
    "thumbnail": "https://i.ytimg.com/vi/toGkFD-mg7M/mqdefault.jpg",
    "title": "【歌枠】みんなでおたんじょうびをむかえたいっっ！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-11-30T18:10:22Z"
  },
  {
    "videoId": "sA4pyeRU4nc",
    "thumbnail": "https://i.ytimg.com/vi/sA4pyeRU4nc/mqdefault.jpg",
    "title": "【#湊あくあ生誕祭2022】凸　待　ち　~陰キャVSアイドル編~【湊あくあ/ホロライブ】",
    "publishedAt": "2022-12-01T14:24:44Z"
  },
  {
    "videoId": "2ls4yrZRYlQ",
    "thumbnail": "https://i.ytimg.com/vi/2ls4yrZRYlQ/mqdefault.jpg",
    "title": "【歌枠】かわいくうたうよ！KARAOKE LIVE！(⋈◍＞◡＜◍)。✧♡【湊あくあ/ホロライブ】",
    "publishedAt": "2022-12-08T15:53:05Z"
  },
  {
    "videoId": "awHMIHpmeIo",
    "thumbnail": "https://i.ytimg.com/vi/awHMIHpmeIo/mqdefault.jpg",
    "title": "【誕生日】uni-birth／湊あくあ【オリジナル曲】",
    "publishedAt": "2022-12-09T10:00:10Z"
  },
  {
    "videoId": "aIM32qM9ZBE",
    "thumbnail": "https://i.ytimg.com/vi/aIM32qM9ZBE/mqdefault.jpg",
    "title": "【ポケモンSV】ねえねえ、ポケモン交換しよ？【湊あくあ/ホロライブ】",
    "publishedAt": "2022-12-24T11:26:33Z"
  },
  {
    "videoId": "-5pE0rA2dBI",
    "thumbnail": "https://i.ytimg.com/vi/-5pE0rA2dBI/mqdefault.jpg",
    "title": "【 #ホロクリスマス歌枠リレー 】天　使　降　臨【湊あくあ/ホロライブ】",
    "publishedAt": "2022-12-25T14:23:16Z"
  },
  {
    "videoId": "UFKpgozTers",
    "thumbnail": "https://i.ytimg.com/vi/UFKpgozTers/mqdefault.jpg",
    "title": "【陰キャが】可愛くてごめん／湊あくあ【歌ってみた】",
    "publishedAt": "2022-12-30T10:00:08Z"
  },
  {
    "videoId": "fZIPM0GilhE",
    "thumbnail": "https://i.ytimg.com/vi/fZIPM0GilhE/mqdefault.jpg",
    "title": "【カウントダウン】２０２３年！一緒に年越そ～～～！【湊あくあ/ホロライブ】",
    "publishedAt": "2022-12-31T15:39:30Z"
  },
  {
    "videoId": "xmN-iBaQLZY",
    "thumbnail": "https://i.ytimg.com/vi/xmN-iBaQLZY/mqdefault.jpg",
    "title": "【新年】あけおめえええ！お正月衣装2.0をお披露目しちゃう！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-01-03T10:00:18Z"
  },
  {
    "videoId": "c-VhJ6g6W7w",
    "thumbnail": "https://i.ytimg.com/vi/c-VhJ6g6W7w/mqdefault.jpg",
    "title": "【歌枠】おひさしぶりの！うたうよみらくるっ！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-01-22T15:59:50Z"
  },
  {
    "videoId": "0zJQeFyt7mo",
    "thumbnail": "https://i.ytimg.com/vi/0zJQeFyt7mo/mqdefault.jpg",
    "title": "【ポケモンSV】はじめてのレート戦！やるぞおお！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-01-27T16:39:59Z"
  },
  {
    "videoId": "g3bRW0CxHJ0",
    "thumbnail": "https://i.ytimg.com/vi/g3bRW0CxHJ0/mqdefault.jpg",
    "title": "【ポケモンSV】マスターボール級いくまで！やるぞおおお！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-01-29T20:48:19Z"
  },
  {
    "videoId": "rdTyneoVDkc",
    "thumbnail": "https://i.ytimg.com/vi/rdTyneoVDkc/mqdefault.jpg",
    "title": "【メン限】夜撫でるメノウ　歌ってみた Ver.湊あくあ",
    "publishedAt": "2023-02-01T12:10:30Z"
  },
  {
    "videoId": "smE_AseOJg0",
    "thumbnail": "https://i.ytimg.com/vi/smE_AseOJg0/mqdefault.jpg",
    "title": "【HoloCure】は　じ　め　て　の　ほ　ろ　き　ゅ　あ【湊あくあ/ホロライブ】",
    "publishedAt": "2023-02-11T20:43:10Z"
  },
  {
    "videoId": "q_I56SKoMGQ",
    "thumbnail": "https://i.ytimg.com/vi/q_I56SKoMGQ/mqdefault.jpg",
    "title": "ダーリンダンス 湊あくあ×猫又おかゆ(cover)",
    "publishedAt": "2023-02-14T10:00:08Z"
  },
  {
    "videoId": "Ss4-rFyqQlU",
    "thumbnail": "https://i.ytimg.com/vi/Ss4-rFyqQlU/mqdefault.jpg",
    "title": "【ねこの日】にゃんにゃがにゃにゃにゃ～～ん♪KARAOKE🐈【湊あくあ/ホロライブ】",
    "publishedAt": "2023-02-22T16:50:09Z"
  },
  {
    "videoId": "pgvWMKIdbpY",
    "thumbnail": "https://i.ytimg.com/vi/pgvWMKIdbpY/mqdefault.jpg",
    "title": "【Minecraft】た　だ　い　ま　ホ　ロ　鯖【湊あくあ/ホロライブ】",
    "publishedAt": "2023-03-12T16:13:04Z"
  },
  {
    "videoId": "20-e94CSHps",
    "thumbnail": "https://i.ytimg.com/vi/20-e94CSHps/mqdefault.jpg",
    "title": "【ぼっちちゃんVSあくたん】ぼっち・ざ・ろっく！同時視聴／BOCCHI THE ROCK! 【湊あくあ/ホロライブ】",
    "publishedAt": "2023-03-13T15:58:33Z"
  },
  {
    "videoId": "0MuBOJe3HAI",
    "thumbnail": "https://i.ytimg.com/vi/0MuBOJe3HAI/mqdefault.jpg",
    "title": "【陰キャと一緒に】ぼっち・ざ・ろっく！同時視聴／BOCCHI THE ROCK! 【湊あくあ/ホロライブ】",
    "publishedAt": "2023-03-15T15:49:37Z"
  },
  {
    "videoId": "p1lfwyWSGV4",
    "thumbnail": "https://i.ytimg.com/vi/p1lfwyWSGV4/mqdefault.jpg",
    "title": "空奏列車 ／ Startend cover",
    "publishedAt": "2023-03-17T11:00:08Z"
  },
  {
    "videoId": "BFs7ogHNerE",
    "thumbnail": "https://i.ytimg.com/vi/BFs7ogHNerE/mqdefault.jpg",
    "title": "【 振り返り 】hololive 4th fes. ＆ Expoおつかれさまでした！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-03-20T17:51:47Z"
  },
  {
    "videoId": "pZIMAI-Rnuw",
    "thumbnail": "https://i.ytimg.com/vi/pZIMAI-Rnuw/mqdefault.jpg",
    "title": "【Minecraft】どなたか家の地下に住まわせてもらえませんか？【湊あくあ/ホロライブ】",
    "publishedAt": "2023-03-24T16:54:56Z"
  },
  {
    "videoId": "8mfs-004OAs",
    "thumbnail": "https://i.ytimg.com/vi/8mfs-004OAs/mqdefault.jpg",
    "title": "【最終回】ぼっち・ざ・ろっく！同時視聴／BOCCHI THE ROCK!【湊あくあ/ホロライブ】",
    "publishedAt": "2023-03-26T16:12:14Z"
  },
  {
    "videoId": "Sdx8kCr9DvQ",
    "thumbnail": "https://i.ytimg.com/vi/Sdx8kCr9DvQ/mqdefault.jpg",
    "title": "【Minecraft】地　下　帝　国　拡　大【湊あくあ/ホロライブ】",
    "publishedAt": "2023-03-30T19:48:24Z"
  },
  {
    "videoId": "FV5Wrup4aZ8",
    "thumbnail": "https://i.ytimg.com/vi/FV5Wrup4aZ8/mqdefault.jpg",
    "title": "【歌枠】すごく・・・・・えもい・・・うた【湊あくあ/ホロライブ】",
    "publishedAt": "2023-04-02T16:11:02Z"
  },
  {
    "videoId": "Fr1dzS2N9M0",
    "thumbnail": "https://i.ytimg.com/vi/Fr1dzS2N9M0/mqdefault.jpg",
    "title": "【Q REMASTERED】超難問？？？IQ５０００だしよ、、、余裕だよね？【湊あくあ/ホロライブ】",
    "publishedAt": "2023-04-17T18:22:48Z"
  },
  {
    "videoId": "IxJMRaT6iuM",
    "thumbnail": "https://i.ytimg.com/vi/IxJMRaT6iuM/mqdefault.jpg",
    "title": "【歌枠】あたらしい機材でテストはいしん！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-04-22T18:29:00Z"
  },
  {
    "videoId": "4cWokwztucQ",
    "thumbnail": "https://i.ytimg.com/vi/4cWokwztucQ/mqdefault.jpg",
    "title": "【#あくおか真剣勝負】デートをかけた本気の戦い【湊あくあ/猫又おかゆ】",
    "publishedAt": "2023-04-26T13:05:48Z"
  },
  {
    "videoId": "U12gD0IQBII",
    "thumbnail": "https://i.ytimg.com/vi/U12gD0IQBII/mqdefault.jpg",
    "title": "【Minecraft】いっちょ地下もぐりますか！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-04-29T18:39:42Z"
  },
  {
    "videoId": "wzsObRfnyaY",
    "thumbnail": "https://i.ytimg.com/vi/wzsObRfnyaY/mqdefault.jpg",
    "title": "【ゲリラ】まずい！！！！！！！！！！！！！！！！！ #YAGOOと水着配信【湊あくあ/ホロライブ】",
    "publishedAt": "2023-06-01T12:04:38Z"
  },
  {
    "videoId": "Mo24438NriE",
    "thumbnail": "https://i.ytimg.com/vi/Mo24438NriE/mqdefault.jpg",
    "title": "【歌枠】銀河一アイドル！うたっちゃうよおおおお！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-06-04T15:36:50Z"
  },
  {
    "videoId": "JNz4eQAvFUg",
    "thumbnail": "https://i.ytimg.com/vi/JNz4eQAvFUg/mqdefault.jpg",
    "title": "【APEX】５億年ぶりのリハビリじゃああああ！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-06-05T14:27:07Z"
  },
  {
    "videoId": "upWym-nEjiA",
    "thumbnail": "https://i.ytimg.com/vi/upWym-nEjiA/mqdefault.jpg",
    "title": "【APEX】全レジェンドチャンピオン取るまで終われないStartend！【湊あくあ/星街すいせい/常闇トワ】",
    "publishedAt": "2023-06-10T09:35:54Z"
  },
  {
    "videoId": "g1dEsxMggEM",
    "thumbnail": "https://i.ytimg.com/vi/g1dEsxMggEM/mqdefault.jpg",
    "title": "【Golf It!】打ち上げゴルフじゃ！！！！！！！#STAWIN 【湊あくあ/星街すいせい/常闇トワ】",
    "publishedAt": "2023-06-10T15:28:10Z"
  },
  {
    "videoId": "Qyym-6eo1hI",
    "thumbnail": "https://i.ytimg.com/vi/Qyym-6eo1hI/mqdefault.jpg",
    "title": "【Minecraft】おひさしぶりホロ鯖。観光、そして地下帝国へ―・・・【湊あくあ/ホロライブ】",
    "publishedAt": "2023-06-11T17:17:41Z"
  },
  {
    "videoId": "-wNYqH00uwc",
    "thumbnail": "https://i.ytimg.com/vi/-wNYqH00uwc/mqdefault.jpg",
    "title": "【歌枠】陰キャとカラオケに行くとこうなる。【湊あくあ/ホロライブ】",
    "publishedAt": "2023-06-17T16:00:30Z"
  },
  {
    "videoId": "DuMQTnfqhOM",
    "thumbnail": "https://i.ytimg.com/vi/DuMQTnfqhOM/mqdefault.jpg",
    "title": "【夜間警備】あの・・・・はやく・・・・・帰らせて・・・・【湊あくあ/ホロライブ】",
    "publishedAt": "2023-06-18T14:47:03Z"
  },
  {
    "videoId": "Ix5mVmXnpcs",
    "thumbnail": "https://i.ytimg.com/vi/Ix5mVmXnpcs/mqdefault.jpg",
    "title": "【OnlyUp!】頂上へ行くまで終わらない！耐久【湊あくあ/ホロライブ】",
    "publishedAt": "2023-06-19T16:45:37Z"
  },
  {
    "videoId": "QJtYqxTm2os",
    "thumbnail": "https://i.ytimg.com/vi/QJtYqxTm2os/mqdefault.jpg",
    "title": "【Only Up!】RTA試走！目標タイムは1時間！！！！いくぞ！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-06-30T15:57:10Z"
  },
  {
    "videoId": "1aY1LMAsrlA",
    "thumbnail": "https://i.ytimg.com/vi/1aY1LMAsrlA/mqdefault.jpg",
    "title": "【OnlyUp!】RTAちゃれんじ！今日こそクリアする！【湊あくあ/ホロライブ 】",
    "publishedAt": "2023-07-01T05:53:31Z"
  },
  {
    "videoId": "7mBD3drcppQ",
    "thumbnail": "https://i.ytimg.com/vi/7mBD3drcppQ/mqdefault.jpg",
    "title": "【OnlyUp!】RTAちゃれんじ！クリアするまで耐久！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-07-02T11:20:46Z"
  },
  {
    "videoId": "oy_1yj-sUeE",
    "thumbnail": "https://i.ytimg.com/vi/oy_1yj-sUeE/mqdefault.jpg",
    "title": "【OnlyUp!】RTAちゃれんじ！ノーミスで頂上までいく！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-07-02T17:02:20Z"
  },
  {
    "videoId": "2Qq_OzmY_X0",
    "thumbnail": "https://i.ytimg.com/vi/2Qq_OzmY_X0/mqdefault.jpg",
    "title": "【歌枠】さいきんのはやりってなんだろうからおけ【湊あくあ/ホロライブ】",
    "publishedAt": "2023-07-04T16:01:05Z"
  },
  {
    "videoId": "Hx2K7tTnRRk",
    "thumbnail": "https://i.ytimg.com/vi/Hx2K7tTnRRk/mqdefault.jpg",
    "title": "【日本暗記】４７都道府県全部覚えるまで終われない【湊あくあ/ホロライブ】",
    "publishedAt": "2023-07-05T12:54:13Z"
  },
  {
    "videoId": "XmCZv63Eo78",
    "thumbnail": "https://i.ytimg.com/vi/XmCZv63Eo78/mqdefault.jpg",
    "title": "【#あくしお同時視聴 】「貞子DX」ホラー映画ふたりでみるってまじ？【湊あくあ/紫咲シオン】",
    "publishedAt": "2023-07-13T14:23:29Z"
  },
  {
    "videoId": "0tAX8zKK6Qk",
    "thumbnail": "https://i.ytimg.com/vi/0tAX8zKK6Qk/mqdefault.jpg",
    "title": "【#あくトワ１ブロック】あくトワてぇてぇするまで出られない部屋withすいせい【湊あくあ/ホロライブ】",
    "publishedAt": "2023-07-18T19:55:09Z"
  },
  {
    "videoId": "xS1cQERVlbc",
    "thumbnail": "https://i.ytimg.com/vi/xS1cQERVlbc/mqdefault.jpg",
    "title": "( *ᴖ ᗜ ᴖ *)　#shorts",
    "publishedAt": "2023-07-22T06:52:28Z"
  },
  {
    "videoId": "PJTgBdPgdvE",
    "thumbnail": "https://i.ytimg.com/vi/PJTgBdPgdvE/mqdefault.jpg",
    "title": "【#あくたんお部屋きて 】視聴者のオタク部屋へおじゃましま～・・・・す【湊あくあ/ホロライブ】",
    "publishedAt": "2023-07-22T16:15:42Z"
  },
  {
    "videoId": "ohTubFd-blc",
    "thumbnail": "https://i.ytimg.com/vi/ohTubFd-blc/mqdefault.jpg",
    "title": "黒歴史サマー#ホロサマshorts #hololivesummer2023 #shorts",
    "publishedAt": "2023-07-26T03:00:22Z"
  },
  {
    "videoId": "EZCLbzlK6zA",
    "thumbnail": "https://i.ytimg.com/vi/EZCLbzlK6zA/mqdefault.jpg",
    "title": "妄想アスパルテーム／湊あくあ (cover)",
    "publishedAt": "2023-07-28T10:00:07Z"
  },
  {
    "videoId": "lGWeSfeKhhI",
    "thumbnail": "https://i.ytimg.com/vi/lGWeSfeKhhI/mqdefault.jpg",
    "title": "【玉ねぎ】寝起きヤシの木／湊あくあ【歌ってみた】",
    "publishedAt": "2023-08-02T11:00:08Z"
  },
  {
    "videoId": "dPXtNtRua_Y",
    "thumbnail": "https://i.ytimg.com/vi/dPXtNtRua_Y/mqdefault.jpg",
    "title": "【歌枠】新作の歌ってみたあげたからうたうよおおお！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-08-02T16:31:35Z"
  },
  {
    "videoId": "7i8vt_PUyeE",
    "thumbnail": "https://i.ytimg.com/vi/7i8vt_PUyeE/mqdefault.jpg",
    "title": "歌ってみたｵﾆｵﾝ(｢🧅･ω･)｢🧅 #shorts #寝起きヤシの木 #歌ってみた",
    "publishedAt": "2023-08-03T09:21:19Z"
  },
  {
    "videoId": "qHRKZs7BS-U",
    "thumbnail": "https://i.ytimg.com/vi/qHRKZs7BS-U/mqdefault.jpg",
    "title": "【カウントダウン】ついにデビュー５周年をむかえるアイドルです【湊あくあ/ホロライブ】",
    "publishedAt": "2023-08-07T17:42:01Z"
  },
  {
    "videoId": "rUMkXhTbsOY",
    "thumbnail": "https://i.ytimg.com/vi/rUMkXhTbsOY/mqdefault.jpg",
    "title": "【凸待ち】５周年むかえたし今日こそみんなと普通にしゃべるんだ！！！【#湊あくあ5周年】",
    "publishedAt": "2023-08-08T14:46:23Z"
  },
  {
    "videoId": "zkgsBYenpGA",
    "thumbnail": "https://i.ytimg.com/vi/zkgsBYenpGA/mqdefault.jpg",
    "title": "【つぐのひ】船長がホラゲーになったらしいけど一体これは・・・・【湊あくあ/ホロライブ】",
    "publishedAt": "2023-08-12T13:37:06Z"
  },
  {
    "videoId": "S1Ln9-ksIQY",
    "thumbnail": "https://i.ytimg.com/vi/S1Ln9-ksIQY/mqdefault.jpg",
    "title": "【５周年】君の最推しにしてよ！／湊あくあ【オリジナル曲】",
    "publishedAt": "2023-08-15T12:05:10Z"
  },
  {
    "videoId": "c9VW0E2Unl4",
    "thumbnail": "https://i.ytimg.com/vi/c9VW0E2Unl4/mqdefault.jpg",
    "title": "【#⁠湊あくあ5周年LIVE】Dreamy day 【湊あくあ/ホロライブ】",
    "publishedAt": "2023-08-15T12:06:19Z"
  },
  {
    "videoId": "w5HA3IOQB7Q",
    "thumbnail": "https://i.ytimg.com/vi/w5HA3IOQB7Q/mqdefault.jpg",
    "title": "わ #shorts",
    "publishedAt": "2023-08-16T12:49:52Z"
  },
  {
    "videoId": "UMmUzRJDSoo",
    "thumbnail": "https://i.ytimg.com/vi/UMmUzRJDSoo/mqdefault.jpg",
    "title": "【SAOLR】先行プレイ！SAOの最新作ゲームでキリトになる。【湊あくあ/ホロライブ】",
    "publishedAt": "2023-08-18T11:13:30Z"
  },
  {
    "videoId": "ZjtyavTYxn4",
    "thumbnail": "https://i.ytimg.com/vi/ZjtyavTYxn4/mqdefault.jpg",
    "title": "【Ver3.0お披露目】ぬるぬるあくたんみてみて！！！！！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-08-20T14:21:42Z"
  },
  {
    "videoId": "EhMR_DzSb6g",
    "thumbnail": "https://i.ytimg.com/vi/EhMR_DzSb6g/mqdefault.jpg",
    "title": "アイドル／YOASOBI　歌ってみた",
    "publishedAt": "2023-08-22T11:22:09Z"
  },
  {
    "videoId": "RyEiL59qqdI",
    "thumbnail": "https://i.ytimg.com/vi/RyEiL59qqdI/mqdefault.jpg",
    "title": "【歌枠】ホロサマライブおつかれサマー！うたうよおおおお！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-08-27T16:26:00Z"
  },
  {
    "videoId": "wTM-u1QAoRk",
    "thumbnail": "https://i.ytimg.com/vi/wTM-u1QAoRk/mqdefault.jpg",
    "title": "【漢字でGO】ネ○リーグ風漢字クイズ！クリアするまでやる！？【湊あくあ/ホロライブ】",
    "publishedAt": "2023-08-31T12:39:08Z"
  },
  {
    "videoId": "bFRfneWsbHs",
    "thumbnail": "https://i.ytimg.com/vi/bFRfneWsbHs/mqdefault.jpg",
    "title": "【APEX】はじめまして新シーズン！手元ありでやってみる！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-09-01T15:14:40Z"
  },
  {
    "videoId": "d5Ka2I69hUk",
    "thumbnail": "https://i.ytimg.com/vi/d5Ka2I69hUk/mqdefault.jpg",
    "title": "みて！！！！！！！！！！！",
    "publishedAt": "2023-09-02T11:40:24Z"
  },
  {
    "videoId": "UNAUoFlGyvY",
    "thumbnail": "https://i.ytimg.com/vi/UNAUoFlGyvY/mqdefault.jpg",
    "title": "【APEX】スパレジェ引くまで終われないAPEXガチャ！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-09-03T14:35:06Z"
  },
  {
    "videoId": "zUpCmSwPXSY",
    "thumbnail": "https://i.ytimg.com/vi/zUpCmSwPXSY/mqdefault.jpg",
    "title": "湊あくあに関する面白い雑学＜放送事故編＞",
    "publishedAt": "2023-09-08T10:00:50Z"
  },
  {
    "videoId": "O03QXxB3jd0",
    "thumbnail": "https://i.ytimg.com/vi/O03QXxB3jd0/mqdefault.jpg",
    "title": "湊あくあに関する面白い雑学＜陰キャ編＞",
    "publishedAt": "2023-09-09T10:51:52Z"
  },
  {
    "videoId": "L4IEnVzS44w",
    "thumbnail": "https://i.ytimg.com/vi/L4IEnVzS44w/mqdefault.jpg",
    "title": "【歌枠】新3D衣装お披露目！でバラード多めうたわく！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-09-10T17:08:51Z"
  },
  {
    "videoId": "q01VlUxzwYg",
    "thumbnail": "https://i.ytimg.com/vi/q01VlUxzwYg/mqdefault.jpg",
    "title": "【LIVE】私の一番かわいいところ／FRUITS ZIPPER 歌ってみた！",
    "publishedAt": "2023-09-12T10:00:40Z"
  },
  {
    "videoId": "XgndcAhzkTs",
    "thumbnail": "https://i.ytimg.com/vi/XgndcAhzkTs/mqdefault.jpg",
    "title": "IQ5000によるフラッシュ暗算選手権",
    "publishedAt": "2023-09-14T10:35:21Z"
  },
  {
    "videoId": "znQ9i7P_5V4",
    "thumbnail": "https://i.ytimg.com/vi/znQ9i7P_5V4/mqdefault.jpg",
    "title": "【すごい！】ほぼ10分でわかる『ソードアート・オンライン』家庭用ゲームシリーズ【湊あくあ/ホロライブ】",
    "publishedAt": "2023-09-16T10:00:08Z"
  },
  {
    "videoId": "8REKx2ovNRY",
    "thumbnail": "https://i.ytimg.com/vi/8REKx2ovNRY/mqdefault.jpg",
    "title": "Q.Vtuberをやっていてリア友にバレたりしないんですか？",
    "publishedAt": "2023-09-17T10:30:02Z"
  },
  {
    "videoId": "UR8E_mAfkus",
    "thumbnail": "https://i.ytimg.com/vi/UR8E_mAfkus/mqdefault.jpg",
    "title": "【APEX】過去最高難易度！ソロマスターちゃれんじ１日目【湊あくあ/ホロライブ】",
    "publishedAt": "2023-09-18T16:38:32Z"
  },
  {
    "videoId": "adfSsi1hn9c",
    "thumbnail": "https://i.ytimg.com/vi/adfSsi1hn9c/mqdefault.jpg",
    "title": "Q.どうやったらダイエットができますか？",
    "publishedAt": "2023-09-19T10:30:01Z"
  },
  {
    "videoId": "arb8j_r_fww",
    "thumbnail": "https://i.ytimg.com/vi/arb8j_r_fww/mqdefault.jpg",
    "title": "【APEX】アプデ来た！！！！！ソロマスターちゃれんじ！２日目！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-09-20T16:18:46Z"
  },
  {
    "videoId": "7zhz1HaM5tU",
    "thumbnail": "https://i.ytimg.com/vi/7zhz1HaM5tU/mqdefault.jpg",
    "title": "湊あくあのドレミの歌",
    "publishedAt": "2023-09-21T10:30:05Z"
  },
  {
    "videoId": "fknCHCJbRp8",
    "thumbnail": "https://i.ytimg.com/vi/fknCHCJbRp8/mqdefault.jpg",
    "title": "【APEX】魔境のソロマスターちゃれんじっ！３日目！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-09-22T16:21:42Z"
  },
  {
    "videoId": "V8JCsmjQtzo",
    "thumbnail": "https://i.ytimg.com/vi/V8JCsmjQtzo/mqdefault.jpg",
    "title": "【APEX】負けない！！！ソロマスターちゃれんじ！４日目【湊あくあ/ホロライブ】",
    "publishedAt": "2023-09-23T08:57:20Z"
  },
  {
    "videoId": "Dh3IUB3dk6o",
    "thumbnail": "https://i.ytimg.com/vi/Dh3IUB3dk6o/mqdefault.jpg",
    "title": "リコーダー音外したら即終了",
    "publishedAt": "2023-09-24T10:30:07Z"
  },
  {
    "videoId": "_8KaUwmB79k",
    "thumbnail": "https://i.ytimg.com/vi/_8KaUwmB79k/mqdefault.jpg",
    "title": "【APEX】プラチナきた！！！！！！！！ソロマスターちゃれんじ！５日目【湊あくあ/ホロライブ】",
    "publishedAt": "2023-09-25T17:22:59Z"
  },
  {
    "videoId": "NZK0QDEZhcA",
    "thumbnail": "https://i.ytimg.com/vi/NZK0QDEZhcA/mqdefault.jpg",
    "title": "【APEX】目指せダイヤ！！ソロマスターちゃれんじ！６日目【湊あくあ/ホロライブ】",
    "publishedAt": "2023-09-27T16:32:58Z"
  },
  {
    "videoId": "_iHaS6lBSgc",
    "thumbnail": "https://i.ytimg.com/vi/_iHaS6lBSgc/mqdefault.jpg",
    "title": "【スイカゲーム】３０００点以上取るまで終われないスイカゲーム【湊あくあ/ホロライブ】",
    "publishedAt": "2023-09-30T19:04:38Z"
  },
  {
    "videoId": "9zNJIGrFtDg",
    "thumbnail": "https://i.ytimg.com/vi/9zNJIGrFtDg/mqdefault.jpg",
    "title": "【APEX】ダイヤの景色へ！！ソロマスターちゃれんじ！７日目【湊あくあ/ホロライブ】",
    "publishedAt": "2023-10-01T10:51:52Z"
  },
  {
    "videoId": "AUovQV1RBYs",
    "thumbnail": "https://i.ytimg.com/vi/AUovQV1RBYs/mqdefault.jpg",
    "title": "Q.LINEの友達の人数少ないって本当ですか？",
    "publishedAt": "2023-10-02T10:30:02Z"
  },
  {
    "videoId": "Y79MeEDnae0",
    "thumbnail": "https://i.ytimg.com/vi/Y79MeEDnae0/mqdefault.jpg",
    "title": "【APEX】今日こそダイヤへ！ソロマスターちゃれんじ！８日目！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-10-03T14:08:42Z"
  },
  {
    "videoId": "mVbtPVpUVWU",
    "thumbnail": "https://i.ytimg.com/vi/mVbtPVpUVWU/mqdefault.jpg",
    "title": "【ヤバい】だんだんキーがあがる#あくあ色ぱれっと うたってみた結果",
    "publishedAt": "2023-10-05T10:39:51Z"
  },
  {
    "videoId": "MZbvP2-Q6pI",
    "thumbnail": "https://i.ytimg.com/vi/MZbvP2-Q6pI/mqdefault.jpg",
    "title": "【#SAOLR】最新作！遂に発売したSAOのゲームをプレイする！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-10-06T12:39:03Z"
  },
  {
    "videoId": "Ij6BbriloeU",
    "thumbnail": "https://i.ytimg.com/vi/Ij6BbriloeU/mqdefault.jpg",
    "title": "【APEX】ダイヤ祈願！ソロマスターちゃれんじ！９日目【湊あくあ/ホロライブ】",
    "publishedAt": "2023-10-07T12:06:30Z"
  },
  {
    "videoId": "4-3TTGBSnqk",
    "thumbnail": "https://i.ytimg.com/vi/4-3TTGBSnqk/mqdefault.jpg",
    "title": "偏見陰キャアキネーター【これな〜んだ？】",
    "publishedAt": "2023-10-08T10:47:50Z"
  },
  {
    "videoId": "iUF4xe8wHkU",
    "thumbnail": "https://i.ytimg.com/vi/iUF4xe8wHkU/mqdefault.jpg",
    "title": "【APEX】ダイヤⅢめざして！ソロマスターちゃれんじ！１０日目！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-10-12T16:35:26Z"
  },
  {
    "videoId": "jEsy2SstFg4",
    "thumbnail": "https://i.ytimg.com/vi/jEsy2SstFg4/mqdefault.jpg",
    "title": "【APEX】駆け上がる！ソロマスターちゃれんじ！１１日目！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-10-14T14:36:52Z"
  },
  {
    "videoId": "D9ZcWMN0p_Y",
    "thumbnail": "https://i.ytimg.com/vi/D9ZcWMN0p_Y/mqdefault.jpg",
    "title": "【耐久】最終回！ソロマスターいくまで終われないAPEX！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-10-15T13:43:49Z"
  },
  {
    "videoId": "P2JRlW8ShIA",
    "thumbnail": "https://i.ytimg.com/vi/P2JRlW8ShIA/mqdefault.jpg",
    "title": "粛聖!! ロリ神レクイエム☆ 歌ってみた！【あくたん5さい】",
    "publishedAt": "2023-10-16T11:17:43Z"
  },
  {
    "videoId": "PfH3ujl1G24",
    "thumbnail": "https://i.ytimg.com/vi/PfH3ujl1G24/mqdefault.jpg",
    "title": "【最終回】新劇場版APEXソロマスちゃれんじ！ファイナルラストエンド ~ Remember Me ~【湊あくあ/ホロライブ】",
    "publishedAt": "2023-10-20T13:12:58Z"
  },
  {
    "videoId": "isoHzeKjeCY",
    "thumbnail": "https://i.ytimg.com/vi/isoHzeKjeCY/mqdefault.jpg",
    "title": "【最終回】ソロマスター行くまで終われないAPEX！！！！！！ジ・エンド【湊あくあ/ホロライブ】",
    "publishedAt": "2023-10-20T21:43:53Z"
  },
  {
    "videoId": "uWYnnKX9h0E",
    "thumbnail": "https://i.ytimg.com/vi/uWYnnKX9h0E/mqdefault.jpg",
    "title": "衝撃！本当にあった陰キャあるある #shorts",
    "publishedAt": "2023-10-25T10:34:19Z"
  },
  {
    "videoId": "f5y29bL-VmE",
    "thumbnail": "https://i.ytimg.com/vi/f5y29bL-VmE/mqdefault.jpg",
    "title": "【歌枠】おひさしぶりにうたう！！！！お披露目とかお知らせもあるよ！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-10-26T13:28:55Z"
  },
  {
    "videoId": "kbdKjI4Wfvk",
    "thumbnail": "https://i.ytimg.com/vi/kbdKjI4Wfvk/mqdefault.jpg",
    "title": "メイドさんだぞっ☆#shorts",
    "publishedAt": "2023-11-01T10:28:07Z"
  },
  {
    "videoId": "XGeNeLWnYdc",
    "thumbnail": "https://i.ytimg.com/vi/XGeNeLWnYdc/mqdefault.jpg",
    "title": "【可愛く】きゅうくらりん／湊あくあ【歌ってみた】",
    "publishedAt": "2023-11-08T11:00:09Z"
  },
  {
    "videoId": "hAqj1em3cKo",
    "thumbnail": "https://i.ytimg.com/vi/hAqj1em3cKo/mqdefault.jpg",
    "title": "お風呂あがりにドライヤーしながらマシュマロ読む【湊あくあ/ホロライブ】",
    "publishedAt": "2023-11-12T12:21:44Z"
  },
  {
    "videoId": "r4-zZm2v9S8",
    "thumbnail": "https://i.ytimg.com/vi/r4-zZm2v9S8/mqdefault.jpg",
    "title": "Q.あくたんの使ってるデバイス教えてください",
    "publishedAt": "2023-11-16T10:06:38Z"
  },
  {
    "videoId": "GivBs1v2p0U",
    "thumbnail": "https://i.ytimg.com/vi/GivBs1v2p0U/mqdefault.jpg",
    "title": "湊あくあに関するここだけの秘密雑学",
    "publishedAt": "2023-11-17T10:34:23Z"
  },
  {
    "videoId": "5K2NnusLYzs",
    "thumbnail": "https://i.ytimg.com/vi/5K2NnusLYzs/mqdefault.jpg",
    "title": "【#あくしおみこめっと 】わちゃわちゃ人生ゲームコラボ！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-11-20T16:03:49Z"
  },
  {
    "videoId": "_llKiCKJ7mE",
    "thumbnail": "https://i.ytimg.com/vi/_llKiCKJ7mE/mqdefault.jpg",
    "title": "面白いことしま〜〜すwwwwww",
    "publishedAt": "2023-11-22T10:19:24Z"
  },
  {
    "videoId": "GI9UdD01Vzs",
    "thumbnail": "https://i.ytimg.com/vi/GI9UdD01Vzs/mqdefault.jpg",
    "title": "LINEでお母さんにロールキャベツの作り方を教えてもらった結果・・・#shorts",
    "publishedAt": "2023-11-25T10:30:05Z"
  },
  {
    "videoId": "JKIMSo4pXG4",
    "thumbnail": "https://i.ytimg.com/vi/JKIMSo4pXG4/mqdefault.jpg",
    "title": "【歌枠】もうすぐ誕生日！ごきげんでうたっちゃう！！KARAOKE♪【湊あくあ/ホロライブ】",
    "publishedAt": "2023-11-29T16:20:00Z"
  },
  {
    "videoId": "6_Gzn45e23k",
    "thumbnail": "https://i.ytimg.com/vi/6_Gzn45e23k/mqdefault.jpg",
    "title": "【誕生日カウントダウン】誕生日になる瞬間をいっしょにむかえたい！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-11-30T17:35:21Z"
  },
  {
    "videoId": "qfw9z5rLmm4",
    "thumbnail": "https://i.ytimg.com/vi/qfw9z5rLmm4/mqdefault.jpg",
    "title": "【アニメMV】エイムに愛されしガール／湊あくあ",
    "publishedAt": "2023-12-01T11:00:10Z"
  },
  {
    "videoId": "gF1Bp8QEx6w",
    "thumbnail": "https://i.ytimg.com/vi/gF1Bp8QEx6w/mqdefault.jpg",
    "title": "【逆凸】誕生日。ずっと待ってるだけじゃ、ダメなんだ！【湊あくあ／ホロライブ】",
    "publishedAt": "2023-12-01T15:17:33Z"
  },
  {
    "videoId": "MxlX6P-wbfk",
    "thumbnail": "https://i.ytimg.com/vi/MxlX6P-wbfk/mqdefault.jpg",
    "title": "湊あくあのモーニングルーティーン #shorts",
    "publishedAt": "2023-12-03T11:41:00Z"
  },
  {
    "videoId": "CmteyOYDj-g",
    "thumbnail": "https://i.ytimg.com/vi/CmteyOYDj-g/mqdefault.jpg",
    "title": "【ガルパ】視聴者参加型あり！ホロライブコラボ第二弾！！！！！【#ガルパコラボ記念湊あくあ配信中】",
    "publishedAt": "2023-12-06T12:41:57Z"
  },
  {
    "videoId": "iPqNo_raztk",
    "thumbnail": "https://i.ytimg.com/vi/iPqNo_raztk/mqdefault.jpg",
    "title": "【８番出口】無　限　地　下【湊あくあ/ホロライブ】",
    "publishedAt": "2023-12-08T15:46:01Z"
  },
  {
    "videoId": "cbdVsZGmx2k",
    "thumbnail": "https://i.ytimg.com/vi/cbdVsZGmx2k/mqdefault.jpg",
    "title": "絶対に反応しない猫vsかまってほしいあくあ",
    "publishedAt": "2023-12-10T11:54:21Z"
  },
  {
    "videoId": "tO8trDQ6bZM",
    "thumbnail": "https://i.ytimg.com/vi/tO8trDQ6bZM/mqdefault.jpg",
    "title": "【縦型配信】流行りの機能つかってみる！！！#shorts【湊あくあ/ホロライブ】",
    "publishedAt": "2023-12-16T15:57:03Z"
  },
  {
    "videoId": "O8vTSnn5Ujw",
    "thumbnail": "https://i.ytimg.com/vi/O8vTSnn5Ujw/mqdefault.jpg",
    "title": "【オフコラボ】地　獄　の　親　子　面　談【湊あくあ/宝鐘マリン】",
    "publishedAt": "2023-12-23T12:26:42Z"
  },
  {
    "videoId": "smp4oBiKIPs",
    "thumbnail": "https://i.ytimg.com/vi/smp4oBiKIPs/mqdefault.jpg",
    "title": "【有馬記念】今年最後の運試し！！！！！！！！！！！絶対に勝って肉をたべるんだ！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-12-24T07:09:03Z"
  },
  {
    "videoId": "wM6gy5VZ6NI",
    "thumbnail": "https://i.ytimg.com/vi/wM6gy5VZ6NI/mqdefault.jpg",
    "title": "【 #ホロクリスマス歌枠リレー 】クリスマスに大天使あくたん降臨！！【湊あくあ/ホロライブ】",
    "publishedAt": "2023-12-25T12:23:09Z"
  },
  {
    "videoId": "iMP8Vx8cEcI",
    "thumbnail": "https://i.ytimg.com/vi/iMP8Vx8cEcI/mqdefault.jpg",
    "title": "【年越し】ぼっちによるぼっちのためのぼっち年越し【湊あくあ/ホロライブ】",
    "publishedAt": "2023-12-31T16:33:48Z"
  },
  {
    "videoId": "5Sknv5MOBSI",
    "thumbnail": "https://i.ytimg.com/vi/5Sknv5MOBSI/mqdefault.jpg",
    "title": "【ポケカ開封】新年の運試し！ポケカ福袋開封するぞおおおおおお！！！！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-01-02T14:22:50Z"
  },
  {
    "videoId": "8NxM33XCEpw",
    "thumbnail": "https://i.ytimg.com/vi/8NxM33XCEpw/mqdefault.jpg",
    "title": "【歌枠】新年さいしょの歌枠！！縦型でやってみる！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-01-04T15:51:23Z"
  },
  {
    "videoId": "uZO0BhuXfvs",
    "thumbnail": "https://i.ytimg.com/vi/uZO0BhuXfvs/mqdefault.jpg",
    "title": "正月にポケカの福袋開けたら中身がやばすぎたｗｗｗｗｗ",
    "publishedAt": "2024-01-05T11:11:30Z"
  },
  {
    "videoId": "kXjZvS2XBpA",
    "thumbnail": "https://i.ytimg.com/vi/kXjZvS2XBpA/mqdefault.jpg",
    "title": "【 #チームNASS 】新年！五億年ぶりに集まったからゲームする！やよ～【人生ゲーム for Nintendo Switch】",
    "publishedAt": "2024-01-15T15:10:40Z"
  },
  {
    "videoId": "m6WTPjuHxgw",
    "thumbnail": "https://i.ytimg.com/vi/m6WTPjuHxgw/mqdefault.jpg",
    "title": "【モーリーオンライン】母とはじめてのクレーンゲームデート【湊あくあ/宝鐘マリン/ホロライブ】",
    "publishedAt": "2024-01-19T12:25:29Z"
  },
  {
    "videoId": "Bm0XzXV7ZcU",
    "thumbnail": "https://i.ytimg.com/vi/Bm0XzXV7ZcU/mqdefault.jpg",
    "title": "#1【Palworld】ホロ鯖！はじめてのパルワールドだああああああ！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-01-21T12:17:37Z"
  },
  {
    "videoId": "LiFokiohjvA",
    "thumbnail": "https://i.ytimg.com/vi/LiFokiohjvA/mqdefault.jpg",
    "title": "#2【Palworld】うがががががががががが【湊あくあ/ホロライブ】",
    "publishedAt": "2024-01-23T17:14:04Z"
  },
  {
    "videoId": "kZpzN2EMogg",
    "thumbnail": "https://i.ytimg.com/vi/kZpzN2EMogg/mqdefault.jpg",
    "title": "#3【Palworld】ホロ鯖！あてぃし、なんかやっちゃいました？【湊あくあ/ホロライブ】",
    "publishedAt": "2024-01-24T17:45:28Z"
  },
  {
    "videoId": "WaaoNJ7okN8",
    "thumbnail": "https://i.ytimg.com/vi/WaaoNJ7okN8/mqdefault.jpg",
    "title": "#4【パルワールド】伝説の４皇ボス捕獲するぞ！！！！！！！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-01-26T14:39:31Z"
  },
  {
    "videoId": "WxAxQCOCfls",
    "thumbnail": "https://i.ytimg.com/vi/WxAxQCOCfls/mqdefault.jpg",
    "title": "【歌枠】るんるんでうたうよ～～～！KARAOKE LIVE♡【湊あくあ/ホロライブ】",
    "publishedAt": "2024-01-27T12:33:14Z"
  },
  {
    "videoId": "MWQQiBVgrXk",
    "thumbnail": "https://i.ytimg.com/vi/MWQQiBVgrXk/mqdefault.jpg",
    "title": "#5【パルワールド】図鑑をコンプするまで終われない！？！？【湊あくあ/ホロライブ】",
    "publishedAt": "2024-01-28T12:11:21Z"
  },
  {
    "videoId": "HdWuqKyW5is",
    "thumbnail": "https://i.ytimg.com/vi/HdWuqKyW5is/mqdefault.jpg",
    "title": "#6【パルワールド】伝説のパル厳選いくぞ！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-01-30T18:16:31Z"
  },
  {
    "videoId": "3Zvzq-_RHg8",
    "thumbnail": "https://i.ytimg.com/vi/3Zvzq-_RHg8/mqdefault.jpg",
    "title": "【不審者情報】緊急ゲリラ！！！！！不審者がいる！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-02-05T14:52:35Z"
  },
  {
    "videoId": "ADCckZ1bWFQ",
    "thumbnail": "https://i.ytimg.com/vi/ADCckZ1bWFQ/mqdefault.jpg",
    "title": "【Poppy Playtime】かわいい・・・・？ぬいぐるみ・・・・・・？【湊あくあ/ホロライブ】",
    "publishedAt": "2024-02-07T12:41:18Z"
  },
  {
    "videoId": "wVuMxIz-DOw",
    "thumbnail": "https://i.ytimg.com/vi/wVuMxIz-DOw/mqdefault.jpg",
    "title": "【Poppy Playtime2】負けない！泣かない！あきらめない！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-02-08T15:37:59Z"
  },
  {
    "videoId": "a9ICCVCQa9s",
    "thumbnail": "https://i.ytimg.com/vi/a9ICCVCQa9s/mqdefault.jpg",
    "title": "#7【パルワールド】パル無し！全ボス攻略するまで終われない！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-02-10T12:33:58Z"
  },
  {
    "videoId": "bPpWE5hL2YE",
    "thumbnail": "https://i.ytimg.com/vi/bPpWE5hL2YE/mqdefault.jpg",
    "title": "【歌枠】病み上がりだけどうたっちゃう！！！！KARAOKE♡LIVE【湊あくあ/ホロライブ】",
    "publishedAt": "2024-02-21T14:52:13Z"
  },
  {
    "videoId": "wKNuL4M5luY",
    "thumbnail": "https://i.ytimg.com/vi/wKNuL4M5luY/mqdefault.jpg",
    "title": "【衝撃】ミツバチの生態がやばすぎるｗｗｗｗ",
    "publishedAt": "2024-02-22T09:30:30Z"
  },
  {
    "videoId": "opJNnBxOPH0",
    "thumbnail": "https://i.ytimg.com/vi/opJNnBxOPH0/mqdefault.jpg",
    "title": "#1ホロメン、あてぃしのこと・・・・すき？",
    "publishedAt": "2024-02-24T10:01:39Z"
  },
  {
    "videoId": "FVoR5JiZ8Oc",
    "thumbnail": "https://i.ytimg.com/vi/FVoR5JiZ8Oc/mqdefault.jpg",
    "title": "#2あくすいちゃんねる、電撃結婚！？！？",
    "publishedAt": "2024-02-25T10:01:39Z"
  },
  {
    "videoId": "WXyElMlCVxU",
    "thumbnail": "https://i.ytimg.com/vi/WXyElMlCVxU/mqdefault.jpg",
    "title": "#3劇場版あてぃし、正妻戦争始まるー・・・！",
    "publishedAt": "2024-03-02T09:02:36Z"
  },
  {
    "videoId": "WWFJ1hCA6tw",
    "thumbnail": "https://i.ytimg.com/vi/WWFJ1hCA6tw/mqdefault.jpg",
    "title": "#4次回、湊あくあ 氏す。",
    "publishedAt": "2024-03-03T09:02:02Z"
  },
  {
    "videoId": "fe0si3mul_E",
    "thumbnail": "https://i.ytimg.com/vi/fe0si3mul_E/mqdefault.jpg",
    "title": "【#湊あくあビジュメンテ】新しくなったあてぃしをみて！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-03-07T13:26:23Z"
  },
  {
    "videoId": "4v5OKpIPfgg",
    "thumbnail": "https://i.ytimg.com/vi/4v5OKpIPfgg/mqdefault.jpg",
    "title": "【#SAOLR】湊あくあがSAOゲームの世界に！？！？コラボ実装されたってマジ！？【湊あくあ/ホロライブ】",
    "publishedAt": "2024-03-08T12:13:38Z"
  },
  {
    "videoId": "mD6XfLwXZGQ",
    "thumbnail": "https://i.ytimg.com/vi/mD6XfLwXZGQ/mqdefault.jpg",
    "title": "【カメラ枠】ホワイトデーだからみんなにチョコあげる・・・・・！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-03-14T14:53:56Z"
  },
  {
    "videoId": "3TMh5oyvhSI",
    "thumbnail": "https://i.ytimg.com/vi/3TMh5oyvhSI/mqdefault.jpg",
    "title": "【振り返り】hololive 5th fes. Capture the Moment【湊あくあ/ホロライブ】",
    "publishedAt": "2024-03-17T18:22:11Z"
  },
  {
    "videoId": "dXWLm4d0xpM",
    "thumbnail": "https://i.ytimg.com/vi/dXWLm4d0xpM/mqdefault.jpg",
    "title": "ちょっと変わった豆知識を教えてくれるあくばち【ねえ、知ってる？】",
    "publishedAt": "2024-04-02T09:40:00Z"
  },
  {
    "videoId": "UAvBOyK5Bhg",
    "thumbnail": "https://i.ytimg.com/vi/UAvBOyK5Bhg/mqdefault.jpg",
    "title": "【Lethal Company】#ホロカンパニー 初出勤・・・・！！【ホロライブ / 湊あくあ / AZKi / 白上フブキ / 兎田ぺこら】",
    "publishedAt": "2024-04-04T14:48:52Z"
  },
  {
    "videoId": "stcM1jIS8us",
    "thumbnail": "https://i.ytimg.com/vi/stcM1jIS8us/mqdefault.jpg",
    "title": "【スイカゲーム】怪獣とオフコラボでスイカやる【湊あくあ/神楽めあ/ホロライブ】",
    "publishedAt": "2024-04-05T11:18:46Z"
  },
  {
    "videoId": "R71ln2lwQBg",
    "thumbnail": "https://i.ytimg.com/vi/R71ln2lwQBg/mqdefault.jpg",
    "title": "#1【Cities: Skylines】湊あくあ、町長になる。【湊あくあ/ホロライブ】",
    "publishedAt": "2024-04-08T10:50:37Z"
  },
  {
    "videoId": "FcgbSIQk4Ck",
    "thumbnail": "https://i.ytimg.com/vi/FcgbSIQk4Ck/mqdefault.jpg",
    "title": "#2【Cities: Skylines】湊あくあ、市長になる。【湊あくあ/ホロライブ】",
    "publishedAt": "2024-04-12T09:41:15Z"
  },
  {
    "videoId": "XEPb5ErGmeA",
    "thumbnail": "https://i.ytimg.com/vi/XEPb5ErGmeA/mqdefault.jpg",
    "title": "#3【Cities: Skylines】最大都市あてぃシティ【湊あくあ/ホロライブ】",
    "publishedAt": "2024-04-19T06:44:15Z"
  },
  {
    "videoId": "uZohCav0tN0",
    "thumbnail": "https://i.ytimg.com/vi/uZohCav0tN0/mqdefault.jpg",
    "title": "#1【ELDEN RING】はじめてのエルデンリング！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-04-27T14:18:28Z"
  },
  {
    "videoId": "VjXxmiUG-sA",
    "thumbnail": "https://i.ytimg.com/vi/VjXxmiUG-sA/mqdefault.jpg",
    "title": "#2【ELDEN RING】エルデの王に私はなる【湊あくあ/ホロライブ】",
    "publishedAt": "2024-04-28T11:05:53Z"
  },
  {
    "videoId": "Of2GCG0VQ_k",
    "thumbnail": "https://i.ytimg.com/vi/Of2GCG0VQ_k/mqdefault.jpg",
    "title": "#3【ELDEN RING】王の力【湊あくあ/ホロライブ】",
    "publishedAt": "2024-04-29T11:42:58Z"
  },
  {
    "videoId": "mwnZ02-FzdQ",
    "thumbnail": "https://i.ytimg.com/vi/mwnZ02-FzdQ/mqdefault.jpg",
    "title": "【歌枠】だいてんしのうただああああああ！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-01T15:15:39Z"
  },
  {
    "videoId": "0BwYA3sxH6o",
    "thumbnail": "https://i.ytimg.com/vi/0BwYA3sxH6o/mqdefault.jpg",
    "title": "#4【ELDEN RING】エルデンリングを求めて―・・・【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-03T10:53:56Z"
  },
  {
    "videoId": "9Vu0D-oOWjw",
    "thumbnail": "https://i.ytimg.com/vi/9Vu0D-oOWjw/mqdefault.jpg",
    "title": "#5【ELDEN RING】エルデンリングやるよおおおお！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-04T15:31:19Z"
  },
  {
    "videoId": "R91jJfRphgM",
    "thumbnail": "https://i.ytimg.com/vi/R91jJfRphgM/mqdefault.jpg",
    "title": "#6【ELDEN RING】最終回（じゃなかった）！！！！エルデンリングの王になる！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-05T11:30:48Z"
  },
  {
    "videoId": "3Oe6sNbv2TM",
    "thumbnail": "https://i.ytimg.com/vi/3Oe6sNbv2TM/mqdefault.jpg",
    "title": "#7【ELDEN RING】最終回！！！！エルデンリングの王になる！！！！劇場版ファイナルラスト【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-06T08:36:10Z"
  },
  {
    "videoId": "gDheU2cwCpQ",
    "thumbnail": "https://i.ytimg.com/vi/gDheU2cwCpQ/mqdefault.jpg",
    "title": "【#あくぺこ並走対決】岩を転がして頂上目指すゲームで勝負！！！！！！！！！！あく！【ホロライブ/湊あくあ】",
    "publishedAt": "2024-05-07T14:34:40Z"
  },
  {
    "videoId": "PJAHkIBg3p0",
    "thumbnail": "https://i.ytimg.com/vi/PJAHkIBg3p0/mqdefault.jpg",
    "title": "【#あくぺこ並走対決】岩を転がして頂上目指すゲームで勝負！！！！！！！！！！あく！【ホロライブ/湊あくあ】",
    "publishedAt": "2024-05-08T15:19:56Z"
  },
  {
    "videoId": "vwYTxvBANHQ",
    "thumbnail": "https://i.ytimg.com/vi/vwYTxvBANHQ/mqdefault.jpg",
    "title": "【#あくたん200万人】２００万人いくまで耐久歌枠！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-09T12:54:34Z"
  },
  {
    "videoId": "dpwYtITrJv8",
    "thumbnail": "https://i.ytimg.com/vi/dpwYtITrJv8/mqdefault.jpg",
    "title": "【耐久】岩を転がすゲームで頂上目指す！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-10T16:45:31Z"
  },
  {
    "videoId": "O3QEdfbbdJU",
    "thumbnail": "https://i.ytimg.com/vi/O3QEdfbbdJU/mqdefault.jpg",
    "title": "【ELDEN RING】打倒裏ボス！？エルデンリングやるよおおおおおお！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-11T08:54:21Z"
  },
  {
    "videoId": "1yBvIPKMEYk",
    "thumbnail": "https://i.ytimg.com/vi/1yBvIPKMEYk/mqdefault.jpg",
    "title": "#1【Minecraft】ホロ鯖ハードコアマイクラやるぞおおおおおお！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-13T18:31:22Z"
  },
  {
    "videoId": "Vetp5qBD6gg",
    "thumbnail": "https://i.ytimg.com/vi/Vetp5qBD6gg/mqdefault.jpg",
    "title": "#2【Minecraft】ホロ鯖ハードコアマイクラ！！！！！２日目！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-14T16:48:17Z"
  },
  {
    "videoId": "pIe3eeLoKXE",
    "thumbnail": "https://i.ytimg.com/vi/pIe3eeLoKXE/mqdefault.jpg",
    "title": "#3【Minecraft】ホロ鯖ハードコアマイクラ！！！！！３日目！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-15T16:09:10Z"
  },
  {
    "videoId": "ROtF6AIdk_M",
    "thumbnail": "https://i.ytimg.com/vi/ROtF6AIdk_M/mqdefault.jpg",
    "title": "#4【Minecraft】ホロ鯖ハードコアマイクラ！！！！！４日目！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-16T06:38:01Z"
  },
  {
    "videoId": "m3SEzeR9GUA",
    "thumbnail": "https://i.ytimg.com/vi/m3SEzeR9GUA/mqdefault.jpg",
    "title": "#5【Minecraft】死亡・・・・裁判・・・そして・・・・【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-16T17:10:43Z"
  },
  {
    "videoId": "bY4oxROJlKA",
    "thumbnail": "https://i.ytimg.com/vi/bY4oxROJlKA/mqdefault.jpg",
    "title": "#6【Minecraft】転生したら犬だった件【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-17T15:55:33Z"
  },
  {
    "videoId": "6bduhc-6CKY",
    "thumbnail": "https://i.ytimg.com/vi/6bduhc-6CKY/mqdefault.jpg",
    "title": "【学園アイドルマスター】新作アイマスでアイドルをプロデュースする！※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-18T08:43:58Z"
  },
  {
    "videoId": "iOFLSxRDReE",
    "thumbnail": "https://i.ytimg.com/vi/iOFLSxRDReE/mqdefault.jpg",
    "title": "#7【Minecraft】ホロ鯖ハードコアマイクラ！打倒ウィザー！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-18T16:01:55Z"
  },
  {
    "videoId": "YJhhYn1xnnM",
    "thumbnail": "https://i.ytimg.com/vi/YJhhYn1xnnM/mqdefault.jpg",
    "title": "#8【Minecraft】ホロ鯖ハードコアマイクラ！最終回！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-19T13:46:05Z"
  },
  {
    "videoId": "B0o7lM_LMmw",
    "thumbnail": "https://i.ytimg.com/vi/B0o7lM_LMmw/mqdefault.jpg",
    "title": "【歌枠】しっとりバラード多めのえもすぎるうたわく【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-20T13:16:43Z"
  },
  {
    "videoId": "boA5wq6x2KA",
    "thumbnail": "https://i.ytimg.com/vi/boA5wq6x2KA/mqdefault.jpg",
    "title": "#1【FCマリオ】残機０で即終了スーパーマリオブラザーズ【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-21T13:23:01Z"
  },
  {
    "videoId": "No9In7eJgv4",
    "thumbnail": "https://i.ytimg.com/vi/No9In7eJgv4/mqdefault.jpg",
    "title": "【DON'T SCREAM】叫んだら終了するホラゲークリアするまでやる！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-22T12:39:02Z"
  },
  {
    "videoId": "lI4q0N5Ai74",
    "thumbnail": "https://i.ytimg.com/vi/lI4q0N5Ai74/mqdefault.jpg",
    "title": "#2【FCマリオ3】残機０で即終了スーパーマリオブラザーズ3【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-24T12:55:38Z"
  },
  {
    "videoId": "JNpyR3IUg2I",
    "thumbnail": "https://i.ytimg.com/vi/JNpyR3IUg2I/mqdefault.jpg",
    "title": "#3【FCマリオ3】残機０で即終了スーパーマリオブラザーズ3 完結編【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-25T09:51:58Z"
  },
  {
    "videoId": "1w50DQrXDiA",
    "thumbnail": "https://i.ytimg.com/vi/1w50DQrXDiA/mqdefault.jpg",
    "title": "#4【FCマリオ3】残機０で即終了スーパーマリオブラザーズ3 完結編FINAL【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-26T09:00:50Z"
  },
  {
    "videoId": "AttwK3fduOk",
    "thumbnail": "https://i.ytimg.com/vi/AttwK3fduOk/mqdefault.jpg",
    "title": "【緊急ゲリラ】みそきん実食会！！！！！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-26T12:57:51Z"
  },
  {
    "videoId": "8gOsOOGTva4",
    "thumbnail": "https://i.ytimg.com/vi/8gOsOOGTva4/mqdefault.jpg",
    "title": "【 新幹線０号】この新幹線・・・なにかがおかしい・・・【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-27T15:14:22Z"
  },
  {
    "videoId": "Cgd3L1UFvXw",
    "thumbnail": "https://i.ytimg.com/vi/Cgd3L1UFvXw/mqdefault.jpg",
    "title": "【凸待ち】絶対に負けられない地獄のスイカゲーム凸待ち【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-30T12:58:43Z"
  },
  {
    "videoId": "jJA0-XBnNJk",
    "thumbnail": "https://i.ytimg.com/vi/jJA0-XBnNJk/mqdefault.jpg",
    "title": "【スト６】はじめてのストリートファイター６【湊あくあ/ホロライブ】",
    "publishedAt": "2024-05-31T15:30:07Z"
  },
  {
    "videoId": "q-pVpbKINVg",
    "thumbnail": "https://i.ytimg.com/vi/q-pVpbKINVg/mqdefault.jpg",
    "title": "#1【Undertale】完全初見！アンダーテイルやるよおおおおおおお！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-01T12:11:17Z"
  },
  {
    "videoId": "QL96ESf1K4g",
    "thumbnail": "https://i.ytimg.com/vi/QL96ESf1K4g/mqdefault.jpg",
    "title": "#2【Undertale】完全初見！アンダーテイルやるよおおおおおおお！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-01T16:52:52Z"
  },
  {
    "videoId": "QemoHD8xAwk",
    "thumbnail": "https://i.ytimg.com/vi/QemoHD8xAwk/mqdefault.jpg",
    "title": "#3【Undertale】完全初見！アンダーテイルやるよおおおおおおお！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-02T16:59:50Z"
  },
  {
    "videoId": "iyFueWk5qEs",
    "thumbnail": "https://i.ytimg.com/vi/iyFueWk5qEs/mqdefault.jpg",
    "title": "【スト6】ぺこちゃんと10本先取勝負！！！！！！！！あく！【ホロライブ/湊あくあ】",
    "publishedAt": "2024-06-03T16:54:35Z"
  },
  {
    "videoId": "1aC8sy9DjOI",
    "thumbnail": "https://i.ytimg.com/vi/1aC8sy9DjOI/mqdefault.jpg",
    "title": "【#ホロAmongUs】ｱｯﾄﾞﾓｯｺﾝﾁﾊ･･･！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-04T14:31:57Z"
  },
  {
    "videoId": "dqMNybgxiWg",
    "thumbnail": "https://i.ytimg.com/vi/dqMNybgxiWg/mqdefault.jpg",
    "title": "【８番のりば】はじめてのおつかい～電車編～【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-06T12:16:53Z"
  },
  {
    "videoId": "3u2CbahgSFo",
    "thumbnail": "https://i.ytimg.com/vi/3u2CbahgSFo/mqdefault.jpg",
    "title": "【歌枠】アニソン老人会！懐かしのアニソンたくさんうたう！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-07T15:46:14Z"
  },
  {
    "videoId": "-4oD_u11mH4",
    "thumbnail": "https://i.ytimg.com/vi/-4oD_u11mH4/mqdefault.jpg",
    "title": "#4【Undertale】完全初見！アンダーテイルやるよおおおおおおお！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-08T09:55:23Z"
  },
  {
    "videoId": "7d2xDOl_cZE",
    "thumbnail": "https://i.ytimg.com/vi/7d2xDOl_cZE/mqdefault.jpg",
    "title": "#5【Undertale】遂にサンズ戦！アンダーテイルGルートやるよおおおおお！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-09T10:48:06Z"
  },
  {
    "videoId": "K8Pe3uLaZ3M",
    "thumbnail": "https://i.ytimg.com/vi/K8Pe3uLaZ3M/mqdefault.jpg",
    "title": "【スト６】プラチナ目指して！ストリートファイター６【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-11T16:05:24Z"
  },
  {
    "videoId": "c3J-0DZ-Puw",
    "thumbnail": "https://i.ytimg.com/vi/c3J-0DZ-Puw/mqdefault.jpg",
    "title": "【歌枠】告知あり！アニソン老人会！懐かしのアニソンたくさんうたう！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-12T15:13:20Z"
  },
  {
    "videoId": "tdMauXNMe40",
    "thumbnail": "https://i.ytimg.com/vi/tdMauXNMe40/mqdefault.jpg",
    "title": "【#あくあず】湊県あてぃ市【湊あくあ/AZKi/ホロライブ】",
    "publishedAt": "2024-06-13T14:26:48Z"
  },
  {
    "videoId": "LydxNm0P0RA",
    "thumbnail": "https://i.ytimg.com/vi/LydxNm0P0RA/mqdefault.jpg",
    "title": "【original】プリンセス・キャリー【湊あくあ／ホロライブ】",
    "publishedAt": "2024-06-16T12:00:07Z"
  },
  {
    "videoId": "Wk6_soH7ofI",
    "thumbnail": "https://i.ytimg.com/vi/Wk6_soH7ofI/mqdefault.jpg",
    "title": "【#湊あくあ新衣装】新衣装お披露目だああああああああ！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-16T13:52:18Z"
  },
  {
    "videoId": "mDXRa9xiSbw",
    "thumbnail": "https://i.ytimg.com/vi/mDXRa9xiSbw/mqdefault.jpg",
    "title": "#1【ELDEN RING】残機０で即終了エルデンリングでクリア目指す！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-17T13:00:20Z"
  },
  {
    "videoId": "NM5wBYbFuN0",
    "thumbnail": "https://i.ytimg.com/vi/NM5wBYbFuN0/mqdefault.jpg",
    "title": "#2【ELDEN RING】残機０で即終了エルデンリングでクリア目指す！１．５日目【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-17T16:09:09Z"
  },
  {
    "videoId": "E7u-PRMlZV8",
    "thumbnail": "https://i.ytimg.com/vi/E7u-PRMlZV8/mqdefault.jpg",
    "title": "【五目並べ】全CPUに勝つまで終われないアソビ大全【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-18T13:57:54Z"
  },
  {
    "videoId": "16uQSh4v5Kw",
    "thumbnail": "https://i.ytimg.com/vi/16uQSh4v5Kw/mqdefault.jpg",
    "title": "【スト６】プラチナの魔境へ。ストリートファイター６【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-19T16:24:37Z"
  },
  {
    "videoId": "DYNxsLQgucQ",
    "thumbnail": "https://i.ytimg.com/vi/DYNxsLQgucQ/mqdefault.jpg",
    "title": "【歌枠】お披露目あり！可愛い曲やアイドルソングうたう！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-21T15:17:14Z"
  },
  {
    "videoId": "VueywPLwGl0",
    "thumbnail": "https://i.ytimg.com/vi/VueywPLwGl0/mqdefault.jpg",
    "title": "#3【ELDEN RING】残機０で即終了エルデンリングでクリア目指す！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-22T08:38:24Z"
  },
  {
    "videoId": "LGrcDjiOI-U",
    "thumbnail": "https://i.ytimg.com/vi/LGrcDjiOI-U/mqdefault.jpg",
    "title": "【スト６】ダイヤ目指して！ストリートファイター６【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-22T15:49:24Z"
  },
  {
    "videoId": "izswJArUBkA",
    "thumbnail": "https://i.ytimg.com/vi/izswJArUBkA/mqdefault.jpg",
    "title": "#1【Chained Together】誰かが落ちたら連帯責任の鬼畜登りゲーｗｗｗ【湊あくあ/兎田ぺこら/宝鐘マリン/常闇トワ】",
    "publishedAt": "2024-06-24T15:31:22Z"
  },
  {
    "videoId": "G_LLskc8ZP0",
    "thumbnail": "https://i.ytimg.com/vi/G_LLskc8ZP0/mqdefault.jpg",
    "title": "#4【ELDEN RING】〇んだら即終了エルデンリングでクリア目指す！涙の最終回！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-25T11:35:58Z"
  },
  {
    "videoId": "Ba1F7a1D2dM",
    "thumbnail": "https://i.ytimg.com/vi/Ba1F7a1D2dM/mqdefault.jpg",
    "title": "【トロッコ問題】究極の選択！！平和な選択はどこですか？【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-26T13:52:11Z"
  },
  {
    "videoId": "Nkd02kieO04",
    "thumbnail": "https://i.ytimg.com/vi/Nkd02kieO04/mqdefault.jpg",
    "title": "【歌枠】古のニコニコ老人会・・・始まる！！！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-06-27T16:30:03Z"
  },
  {
    "videoId": "1Tnkvq8UcQ8",
    "thumbnail": "https://i.ytimg.com/vi/1Tnkvq8UcQ8/mqdefault.jpg",
    "title": "#2【Chained Together】誰かが落ちたら連帯責任の鬼畜登りゲーでクリア目指す【湊あくあ/兎田ぺこら/宝鐘マリン/常闇トワ】",
    "publishedAt": "2024-06-29T14:33:01Z"
  },
  {
    "videoId": "hqCk9yZSQSk",
    "thumbnail": "https://i.ytimg.com/vi/hqCk9yZSQSk/mqdefault.jpg",
    "title": "【FNAF】Five Nights at Freddy'sビビりながらやってみる・・・・・・・【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-01T15:26:42Z"
  },
  {
    "videoId": "VMV7DahrC6A",
    "thumbnail": "https://i.ytimg.com/vi/VMV7DahrC6A/mqdefault.jpg",
    "title": "【相関図】VSホロメンの相関図つくる！！！！！！！！！！！JP編【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-03T13:41:58Z"
  },
  {
    "videoId": "AdN8bWF97bk",
    "thumbnail": "https://i.ytimg.com/vi/AdN8bWF97bk/mqdefault.jpg",
    "title": "【僕、アルバイトォォ！！】バイト未経験でもがんばるんだ！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-05T12:53:09Z"
  },
  {
    "videoId": "lVjxDWyGlwU",
    "thumbnail": "https://i.ytimg.com/vi/lVjxDWyGlwU/mqdefault.jpg",
    "title": "#3【最終回】Chained Together４人でクリア目指す！！！！！【湊あくあ/兎田ぺこら/宝鐘マリン/常闇トワ】",
    "publishedAt": "2024-07-06T13:43:31Z"
  },
  {
    "videoId": "Ot5nptRAIGk",
    "thumbnail": "https://i.ytimg.com/vi/Ot5nptRAIGk/mqdefault.jpg",
    "title": "【ウツロマユ】怖すぎる和風ホラーゲームをクリアまでやる！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-07T09:39:04Z"
  },
  {
    "videoId": "MtfhX5YiX0M",
    "thumbnail": "https://i.ytimg.com/vi/MtfhX5YiX0M/mqdefault.jpg",
    "title": "【歌枠】１日遅れの七夕！織姫あくたんうたいます！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-08T13:06:33Z"
  },
  {
    "videoId": "XxbvU1jreUo",
    "thumbnail": "https://i.ytimg.com/vi/XxbvU1jreUo/mqdefault.jpg",
    "title": "【マリオメーカー２】５億年ぶりのマリメでホロメンコースやる！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-09T13:55:18Z"
  },
  {
    "videoId": "87vm_Tr7Yj0",
    "thumbnail": "https://i.ytimg.com/vi/87vm_Tr7Yj0/mqdefault.jpg",
    "title": "【スト６】ダイヤ行くまで！ストリートファイター６【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-12T15:46:43Z"
  },
  {
    "videoId": "BmxKZNEjplU",
    "thumbnail": "https://i.ytimg.com/vi/BmxKZNEjplU/mqdefault.jpg",
    "title": "#1【ドラクエⅪ】完全初見！！！！！！ドラゴンクエストXI 過ぎ去りし時を求めてS！！！！※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-13T09:39:34Z"
  },
  {
    "videoId": "vxkk2xnXijc",
    "thumbnail": "https://i.ytimg.com/vi/vxkk2xnXijc/mqdefault.jpg",
    "title": "#2【ドラクエⅪ】完全初見！！！！！！ドラゴンクエストXI 過ぎ去りし時を求めてS！！！！※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-14T10:16:39Z"
  },
  {
    "videoId": "ufReVxCwJ0E",
    "thumbnail": "https://i.ytimg.com/vi/ufReVxCwJ0E/mqdefault.jpg",
    "title": "#3【ドラクエⅪ】人生初！！！！！！ドラゴンクエストXI 過ぎ去りし時を求めてS！！！！※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-15T09:46:57Z"
  },
  {
    "videoId": "wVPDJTbMTGk",
    "thumbnail": "https://i.ytimg.com/vi/wVPDJTbMTGk/mqdefault.jpg",
    "title": "【ドラクエⅪ】カジノきたああああああああああああああああ！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-16T12:12:20Z"
  },
  {
    "videoId": "6vh15KtlzlY",
    "thumbnail": "https://i.ytimg.com/vi/6vh15KtlzlY/mqdefault.jpg",
    "title": "【スト６】ダイヤ帯ランク！！！！！！！ストリートファイター６【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-17T15:45:09Z"
  },
  {
    "videoId": "bzKigEpdEKM",
    "thumbnail": "https://i.ytimg.com/vi/bzKigEpdEKM/mqdefault.jpg",
    "title": "【ファミコン世界大会】世界のアクキン、RTAいきます！！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-19T14:36:16Z"
  },
  {
    "videoId": "G1tfPKen3DM",
    "thumbnail": "https://i.ytimg.com/vi/G1tfPKen3DM/mqdefault.jpg",
    "title": "#4【ドラクエⅪ】人生初！！！！！！ドラゴンクエストXI 過ぎ去りし時を求めてS！！！！※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-20T08:53:01Z"
  },
  {
    "videoId": "PSndTjBn228",
    "thumbnail": "https://i.ytimg.com/vi/PSndTjBn228/mqdefault.jpg",
    "title": "【Euro Truck Simulator 2】無　免　許　運　転【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-22T15:27:03Z"
  },
  {
    "videoId": "ViEgji7Iq_w",
    "thumbnail": "https://i.ytimg.com/vi/ViEgji7Iq_w/mqdefault.jpg",
    "title": "#1【＃ホロARK】ついにやってきた！！！！ホロライブARK開幕！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-23T20:40:14Z"
  },
  {
    "videoId": "VwwqmjSHYac",
    "thumbnail": "https://i.ytimg.com/vi/VwwqmjSHYac/mqdefault.jpg",
    "title": "#2【＃ホロARK】ホロライブARK開幕！！！！！みんなで共同生活だ！！！２日目【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-24T18:45:17Z"
  },
  {
    "videoId": "_HrHXQDgIig",
    "thumbnail": "https://i.ytimg.com/vi/_HrHXQDgIig/mqdefault.jpg",
    "title": "#3【＃ホロARK】ホロライブARK開幕！！！！！みんなで共同生活だ！！！３日目【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-25T19:20:17Z"
  },
  {
    "videoId": "vF72ShQ1yUk",
    "thumbnail": "https://i.ytimg.com/vi/vF72ShQ1yUk/mqdefault.jpg",
    "title": "#4【＃ホロARK】ホロライブARK開幕！！！！！みんなで共同生活だ！！！４日目【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-26T16:48:17Z"
  },
  {
    "videoId": "8CMJanyrzwc",
    "thumbnail": "https://i.ytimg.com/vi/8CMJanyrzwc/mqdefault.jpg",
    "title": "#5【ドラクエⅪ】人生初！！！！！！ドラゴンクエストXI 過ぎ去りし時を求めてS！！！！※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-27T08:05:06Z"
  },
  {
    "videoId": "6zPkgi817A4",
    "thumbnail": "https://i.ytimg.com/vi/6zPkgi817A4/mqdefault.jpg",
    "title": "#6【ドラクエⅪ】人生初！！！！！！ドラゴンクエストXI 過ぎ去りし時を求めてS！！！！※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-28T08:32:02Z"
  },
  {
    "videoId": "tbmayzv37f8",
    "thumbnail": "https://i.ytimg.com/vi/tbmayzv37f8/mqdefault.jpg",
    "title": "#5【＃ホロARK】ホロライブARK開幕！！！！！みんなで共同生活だ！！！６日目【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-28T16:03:27Z"
  },
  {
    "videoId": "w_9sY1a0J7c",
    "thumbnail": "https://i.ytimg.com/vi/w_9sY1a0J7c/mqdefault.jpg",
    "title": "#6【＃ホロARK】ホロライブARK開幕！！！！！みんなで共同生活だ！！！７日目【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-29T15:54:26Z"
  },
  {
    "videoId": "bIcD5CZqtV4",
    "thumbnail": "https://i.ytimg.com/vi/bIcD5CZqtV4/mqdefault.jpg",
    "title": "【朝枠】みんなおはよ～して～～～！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-29T23:23:51Z"
  },
  {
    "videoId": "_aTnUA7eiZM",
    "thumbnail": "https://i.ytimg.com/vi/_aTnUA7eiZM/mqdefault.jpg",
    "title": "#7【＃ホロARK】ホロライブARK最終日！！！！！みんなで共同生活だ！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-07-31T15:14:06Z"
  },
  {
    "videoId": "CNOaXT71Qp4",
    "thumbnail": "https://i.ytimg.com/vi/CNOaXT71Qp4/mqdefault.jpg",
    "title": "【歌枠】アニソン老人会？懐かしい曲多め！で全力で歌う！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-01T16:33:13Z"
  },
  {
    "videoId": "KTcsozGaCJs",
    "thumbnail": "https://i.ytimg.com/vi/KTcsozGaCJs/mqdefault.jpg",
    "title": "#7【ドラクエⅪ】人生初！！！！！！ドラゴンクエストXI 過ぎ去りし時を求めてS！！！！※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-03T11:07:33Z"
  },
  {
    "videoId": "GNZ6A9-SD4U",
    "thumbnail": "https://i.ytimg.com/vi/GNZ6A9-SD4U/mqdefault.jpg",
    "title": "#8【ドラクエⅪ】人生初！！！！！！ドラゴンクエストXI 過ぎ去りし時を求めてS！！！！※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-04T07:55:54Z"
  },
  {
    "videoId": "xRQjXfm5kT4",
    "thumbnail": "https://i.ytimg.com/vi/xRQjXfm5kT4/mqdefault.jpg",
    "title": "【 #ホロマイクラ人狼RPG 】マイクラで人狼ゲームやる！！！！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-04T13:27:52Z"
  },
  {
    "videoId": "MVFB9L4zf90",
    "thumbnail": "https://i.ytimg.com/vi/MVFB9L4zf90/mqdefault.jpg",
    "title": "【スト６】ダイヤ４目指して！！！！！！！ストリートファイター６【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-05T15:24:58Z"
  },
  {
    "videoId": "wor3Qt90Yls",
    "thumbnail": "https://i.ytimg.com/vi/wor3Qt90Yls/mqdefault.jpg",
    "title": "大切なお知らせ（残念なほう）【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-06T11:15:09Z"
  },
  {
    "videoId": "YFHLMYUYGt4",
    "thumbnail": "https://i.ytimg.com/vi/YFHLMYUYGt4/mqdefault.jpg",
    "title": "【カウントダウン】６周年だあああああ！！！！みんなでお祝い！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-07T15:56:52Z"
  },
  {
    "videoId": "lFcB1xKOwEw",
    "thumbnail": "https://i.ytimg.com/vi/lFcB1xKOwEw/mqdefault.jpg",
    "title": "【original】恋愛ストラテジック【湊あくあ／ホロライブ】",
    "publishedAt": "2024-08-08T12:00:07Z"
  },
  {
    "videoId": "MB2bs0G8fdQ",
    "thumbnail": "https://i.ytimg.com/vi/MB2bs0G8fdQ/mqdefault.jpg",
    "title": "【凸待ち】６周年記念に凸待ちしてみる！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-08T13:36:53Z"
  },
  {
    "videoId": "x9uBdJV-M4c",
    "thumbnail": "https://i.ytimg.com/vi/x9uBdJV-M4c/mqdefault.jpg",
    "title": "【スト６】ダイヤ５から！！！！！！！ストリートファイター６【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-09T14:20:29Z"
  },
  {
    "videoId": "BGTRhzXs6p4",
    "thumbnail": "https://i.ytimg.com/vi/BGTRhzXs6p4/mqdefault.jpg",
    "title": "#9【ドラクエⅪ】人生初！！！！！！ドラゴンクエストXI 過ぎ去りし時を求めてS！！！！※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-10T10:14:57Z"
  },
  {
    "videoId": "rdPXdmpcCkM",
    "thumbnail": "https://i.ytimg.com/vi/rdPXdmpcCkM/mqdefault.jpg",
    "title": "【占いの館】ビックゴッドみぉーんがあくぺこを占う！！！【湊あくあ/兎田ぺこら/大神ミオ/ホロライブ】",
    "publishedAt": "2024-08-10T13:08:06Z"
  },
  {
    "videoId": "BAXEH-gleZI",
    "thumbnail": "https://i.ytimg.com/vi/BAXEH-gleZI/mqdefault.jpg",
    "title": "#10【ドラクエⅪ】人生初！！！！！！ドラゴンクエストXI 過ぎ去りし時を求めてS！！！！※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-11T08:35:22Z"
  },
  {
    "videoId": "Lcw7J2s9n2Y",
    "thumbnail": "https://i.ytimg.com/vi/Lcw7J2s9n2Y/mqdefault.jpg",
    "title": "【スト６】マスターいくまで！！！！ストリートファイター６【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-11T15:59:07Z"
  },
  {
    "videoId": "BSSevGZ3W_g",
    "thumbnail": "https://i.ytimg.com/vi/BSSevGZ3W_g/mqdefault.jpg",
    "title": "#11【ドラクエⅪ】！！！！！！ドラゴンクエストXI 過ぎ去りし時を求めてS！！！！※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-12T09:21:04Z"
  },
  {
    "videoId": "uluaa937Cq8",
    "thumbnail": "https://i.ytimg.com/vi/uluaa937Cq8/mqdefault.jpg",
    "title": "【RE：地獄銭湯】発売中止になった怖すぎるホラーゲームやる【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-14T13:42:52Z"
  },
  {
    "videoId": "GbUPDU8Qoj8",
    "thumbnail": "https://i.ytimg.com/vi/GbUPDU8Qoj8/mqdefault.jpg",
    "title": "#12【ドラクエⅪ】最終回！ドラゴンクエストXI 過ぎ去りし時を求めてS！！！！※ネタバレあり【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-17T09:40:30Z"
  },
  {
    "videoId": "ZCT49zxqfJA",
    "thumbnail": "https://i.ytimg.com/vi/ZCT49zxqfJA/mqdefault.jpg",
    "title": "【歌枠】うたいたいきょくいっぱいうたう！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-17T13:56:07Z"
  },
  {
    "videoId": "29o7gd8kgoc",
    "thumbnail": "https://i.ytimg.com/vi/29o7gd8kgoc/mqdefault.jpg",
    "title": "【VALORANT】はじめてのVALORANT！ソロランク認定戦！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-18T07:35:34Z"
  },
  {
    "videoId": "FG7pCu6ka-E",
    "thumbnail": "https://i.ytimg.com/vi/FG7pCu6ka-E/mqdefault.jpg",
    "title": "林檎売りの泡沫少女／湊あくあ×紫咲シオン",
    "publishedAt": "2024-08-18T10:00:07Z"
  },
  {
    "videoId": "eix4JkS3kw8",
    "thumbnail": "https://i.ytimg.com/vi/eix4JkS3kw8/mqdefault.jpg",
    "title": "【#あくしおマリオ並走】絶対に負けられない戦い【湊あくあ/紫咲シオン/ホロライブ】",
    "publishedAt": "2024-08-18T12:29:32Z"
  },
  {
    "videoId": "ocympIBhpVs",
    "thumbnail": "https://i.ytimg.com/vi/ocympIBhpVs/mqdefault.jpg",
    "title": "湊あくあは陰キャなのか？〜痴話喧嘩の場合〜",
    "publishedAt": "2024-08-19T03:00:36Z"
  },
  {
    "videoId": "H_ud1ltAVrc",
    "thumbnail": "https://i.ytimg.com/vi/H_ud1ltAVrc/mqdefault.jpg",
    "title": "【雑談】みんなとおはなししたい！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-19T15:47:42Z"
  },
  {
    "videoId": "h-jHrHLG2eQ",
    "thumbnail": "https://i.ytimg.com/vi/h-jHrHLG2eQ/mqdefault.jpg",
    "title": "星座になれたら／湊あくあ cover",
    "publishedAt": "2024-08-20T10:00:07Z"
  },
  {
    "videoId": "UMiQATGT-74",
    "thumbnail": "https://i.ytimg.com/vi/UMiQATGT-74/mqdefault.jpg",
    "title": "【#あくぽる対談 】暗い話になったら即終了、残機3【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-20T14:57:09Z"
  },
  {
    "videoId": "OCm3YTKz7r4",
    "thumbnail": "https://i.ytimg.com/vi/OCm3YTKz7r4/mqdefault.jpg",
    "title": "【お宝マウンテン】巷で噂のホロライブお宝マウンテンやってみる！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-20T15:34:49Z"
  },
  {
    "videoId": "ojb5M_S77vY",
    "thumbnail": "https://i.ytimg.com/vi/ojb5M_S77vY/mqdefault.jpg",
    "title": "【凸待ち】あの～・・・こんちは～・・・アソビ大全しませんか・・・？【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-21T12:13:47Z"
  },
  {
    "videoId": "ZxN7raRF_24",
    "thumbnail": "https://i.ytimg.com/vi/ZxN7raRF_24/mqdefault.jpg",
    "title": "【Minecraft】ホロ鯖！観光したりふりかえるぞ！！！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-22T15:47:42Z"
  },
  {
    "videoId": "Zb2iHULVZEk",
    "thumbnail": "https://i.ytimg.com/vi/Zb2iHULVZEk/mqdefault.jpg",
    "title": "【カメラ】みんなへおむらいすつくる！！！！！！！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-23T14:18:29Z"
  },
  {
    "videoId": "nOfu3FJbmOE",
    "thumbnail": "https://i.ytimg.com/vi/nOfu3FJbmOE/mqdefault.jpg",
    "title": "湊あくあは陰キャなのか？〜学校に行きたくない場合〜",
    "publishedAt": "2024-08-24T03:00:40Z"
  },
  {
    "videoId": "G0zhonxSxqY",
    "thumbnail": "https://i.ytimg.com/vi/G0zhonxSxqY/mqdefault.jpg",
    "title": "湊あくあは陰キャなのか？〜妄想中の場合〜",
    "publishedAt": "2024-08-24T09:00:13Z"
  },
  {
    "videoId": "XPbFLEloZnQ",
    "thumbnail": "https://i.ytimg.com/vi/XPbFLEloZnQ/mqdefault.jpg",
    "title": "【メン限】ディスコミュ星人　歌ってみた Ver.湊あくあ",
    "publishedAt": "2024-08-24T11:13:24Z"
  },
  {
    "videoId": "zCGJYUi24kM",
    "thumbnail": "https://i.ytimg.com/vi/zCGJYUi24kM/mqdefault.jpg",
    "title": "【メン限】おねがいダーリン　歌ってみた Ver.湊あくあ",
    "publishedAt": "2024-08-24T11:14:13Z"
  },
  {
    "videoId": "_T-1Vvm1fPA",
    "thumbnail": "https://i.ytimg.com/vi/_T-1Vvm1fPA/mqdefault.jpg",
    "title": "快晴 ／ Startend cover",
    "publishedAt": "2024-08-25T10:00:06Z"
  },
  {
    "videoId": "U9paX0Kjt1k",
    "thumbnail": "https://i.ytimg.com/vi/U9paX0Kjt1k/mqdefault.jpg",
    "title": "【#湊あくあわかり手選手権 】湊あくあについて一番知ってるのは誰だ！？【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-25T12:31:32Z"
  },
  {
    "videoId": "YHfc0M3CGw0",
    "thumbnail": "https://i.ytimg.com/vi/YHfc0M3CGw0/mqdefault.jpg",
    "title": "【アニメMV】あくたんのこと好きすぎ☆ソング／湊あくあ short ver.",
    "publishedAt": "2024-08-26T10:00:06Z"
  },
  {
    "videoId": "PIoVY8xcGyY",
    "thumbnail": "https://i.ytimg.com/vi/PIoVY8xcGyY/mqdefault.jpg",
    "title": "【#女子VALOカスタム】みんなでVALORANTやるぞおおおお！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-26T14:35:18Z"
  },
  {
    "videoId": "pAFgy6hLjqc",
    "thumbnail": "https://i.ytimg.com/vi/pAFgy6hLjqc/mqdefault.jpg",
    "title": "今はいいんだよ。／湊あくあ cover",
    "publishedAt": "2024-08-27T11:00:06Z"
  },
  {
    "videoId": "xtYdo3HteYU",
    "thumbnail": "https://i.ytimg.com/vi/xtYdo3HteYU/mqdefault.jpg",
    "title": "【original】キズナトキセキ with hololive JP【湊あくあ／ホロライブ】",
    "publishedAt": "2024-08-27T15:00:07Z"
  },
  {
    "videoId": "izMrbcgKVtY",
    "thumbnail": "https://i.ytimg.com/vi/izMrbcgKVtY/mqdefault.jpg",
    "title": "【Minecraft】ホロメンへ最後のお手紙をかく！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-27T16:41:13Z"
  },
  {
    "videoId": "ERB5O16-SZw",
    "thumbnail": "https://i.ytimg.com/vi/ERB5O16-SZw/mqdefault.jpg",
    "title": "【みんなへ】最後の雑談！！！！【湊あくあ/ホロライブ】",
    "publishedAt": "2024-08-27T17:51:13Z"
  },
  {
    "videoId": "RBBwfP1rtkE",
    "thumbnail": "https://i.ytimg.com/vi/RBBwfP1rtkE/mqdefault.jpg",
    "title": "【original】#きみいろプリンセス【ホロライブ/湊あくあ】",
    "publishedAt": "2024-08-28T09:00:07Z"
  },
  {
    "videoId": "fDtUy1PTor0",
    "thumbnail": "https://i.ytimg.com/vi/fDtUy1PTor0/mqdefault.jpg",
    "title": "【#湊あくあ卒業ライブ】あくあ色に染まれ！／MinatoAqua Graduation LIVE",
    "publishedAt": "2024-08-28T12:56:09Z"
  }
],
  Shion :
  [
  {
    "videoId": "0ngDDHw45AM",
    "thumbnail": "https://i.ytimg.com/vi/0ngDDHw45AM/mqdefault.jpg",
    "title": "【#桐生ココ初配信】はじめまして、人間！ホロライブ【ホロライブ4代目会長】",
    "publishedAt": "2019-12-28T11:04:33Z"
  },
  {
    "videoId": "6Y8cEnbk1I4",
    "thumbnail": "https://i.ytimg.com/vi/6Y8cEnbk1I4/mqdefault.jpg",
    "title": "【#桐生ココ】あさココライブNEWS初回放送12/29【ホロライブ4代目会長】",
    "publishedAt": "2019-12-28T21:51:38Z"
  },
  {
    "videoId": "hj9RVNXrzKo",
    "thumbnail": "https://i.ytimg.com/vi/hj9RVNXrzKo/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！12/30【#ココここ】",
    "publishedAt": "2019-12-29T21:23:53Z"
  },
  {
    "videoId": "q4KXbpc0OOE",
    "thumbnail": "https://i.ytimg.com/vi/q4KXbpc0OOE/mqdefault.jpg",
    "title": "【#桐生ココ】みかじめ雑談！何があっても全部星街すいせいちゃんのせい！【#ココここ】",
    "publishedAt": "2019-12-30T12:02:09Z"
  },
  {
    "videoId": "DWDol8mek0w",
    "thumbnail": "https://i.ytimg.com/vi/DWDol8mek0w/mqdefault.jpg",
    "title": "【#角巻わため】#桐生ココ#ホロライブ4期生初コラボ【#天音かなた】",
    "publishedAt": "2019-12-30T13:09:12Z"
  },
  {
    "videoId": "C-4FQD3d_Ps",
    "thumbnail": "https://i.ytimg.com/vi/C-4FQD3d_Ps/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！12/31【#ココここ】",
    "publishedAt": "2019-12-30T21:51:33Z"
  },
  {
    "videoId": "Trz-Ur8eRaI",
    "thumbnail": "https://i.ytimg.com/vi/Trz-Ur8eRaI/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/1【#ココここ】",
    "publishedAt": "2019-12-31T21:52:22Z"
  },
  {
    "videoId": "zgtjEr_i6Y4",
    "thumbnail": "https://i.ytimg.com/vi/zgtjEr_i6Y4/mqdefault.jpg",
    "title": "【#桐生ココ】ガチ恋！伏見稲荷で初詣デート！【#ココここ】",
    "publishedAt": "2020-01-02T02:09:04Z"
  },
  {
    "videoId": "uyd2Oi0RfXA",
    "thumbnail": "https://i.ytimg.com/vi/uyd2Oi0RfXA/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/3【#ココここ】",
    "publishedAt": "2020-01-02T21:52:36Z"
  },
  {
    "videoId": "8zbBMkOSqhs",
    "thumbnail": "https://i.ytimg.com/vi/8zbBMkOSqhs/mqdefault.jpg",
    "title": "【#角巻わため】#桐生ココ#ホロライブ4期生コラボ 道をつなげ！HEAVE HO【#天音かなた】",
    "publishedAt": "2020-01-03T12:31:05Z"
  },
  {
    "videoId": "9Ib7RAR_2iE",
    "thumbnail": "https://i.ytimg.com/vi/9Ib7RAR_2iE/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/4【#ココここ】",
    "publishedAt": "2020-01-03T21:52:07Z"
  },
  {
    "videoId": "vfAksX6WhME",
    "thumbnail": "https://i.ytimg.com/vi/vfAksX6WhME/mqdefault.jpg",
    "title": "【#桐生ココ】事故物件訪問…！ホラーゲーム初実況！【#ココここ】",
    "publishedAt": "2020-01-04T15:18:04Z"
  },
  {
    "videoId": "LVLYoQPMj1U",
    "thumbnail": "https://i.ytimg.com/vi/LVLYoQPMj1U/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/5【#ココここ】",
    "publishedAt": "2020-01-04T21:51:11Z"
  },
  {
    "videoId": "rSCDDD4l8po",
    "thumbnail": "https://i.ytimg.com/vi/rSCDDD4l8po/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/6【#ココここ】",
    "publishedAt": "2020-01-05T21:24:31Z"
  },
  {
    "videoId": "kpDocyEObpc",
    "thumbnail": "https://i.ytimg.com/vi/kpDocyEObpc/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/7【#ココここ】",
    "publishedAt": "2020-01-06T21:24:43Z"
  },
  {
    "videoId": "Za53d148Qe4",
    "thumbnail": "https://i.ytimg.com/vi/Za53d148Qe4/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/8【#ココここ】",
    "publishedAt": "2020-01-07T21:24:44Z"
  },
  {
    "videoId": "fT5LVs-vO14",
    "thumbnail": "https://i.ytimg.com/vi/fT5LVs-vO14/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/9【#ココここ】",
    "publishedAt": "2020-01-08T21:24:30Z"
  },
  {
    "videoId": "RLIO0XT6vQI",
    "thumbnail": "https://i.ytimg.com/vi/RLIO0XT6vQI/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/10【#ココここ】",
    "publishedAt": "2020-01-09T21:25:09Z"
  },
  {
    "videoId": "1AUemRO1MzA",
    "thumbnail": "https://i.ytimg.com/vi/1AUemRO1MzA/mqdefault.jpg",
    "title": "【#桐生ココ】「龍が如く7 光と闇の行方」体験版あそんでみる！！！【#ココここ】",
    "publishedAt": "2020-01-11T12:07:46Z"
  },
  {
    "videoId": "p1tfqWvopXc",
    "thumbnail": "https://i.ytimg.com/vi/p1tfqWvopXc/mqdefault.jpg",
    "title": "\"Where are you from?\"Japanese for REAL 2020#1(Coco Kiryu's Japanese Class)",
    "publishedAt": "2020-01-12T13:19:33Z"
  },
  {
    "videoId": "ZEmSoGwHIX0",
    "thumbnail": "https://i.ytimg.com/vi/ZEmSoGwHIX0/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/13【#ココここ】",
    "publishedAt": "2020-01-12T21:25:28Z"
  },
  {
    "videoId": "mR4TX8QvD2s",
    "thumbnail": "https://i.ytimg.com/vi/mR4TX8QvD2s/mqdefault.jpg",
    "title": "【#桐生ココ】4期生みんなでMINECRAFTの世界へ【#4期生マイクラ】",
    "publishedAt": "2020-01-13T13:09:22Z"
  },
  {
    "videoId": "ptsD3SUacww",
    "thumbnail": "https://i.ytimg.com/vi/ptsD3SUacww/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/14【#ココここ】",
    "publishedAt": "2020-01-13T21:25:10Z"
  },
  {
    "videoId": "AQKYQqV6Eqo",
    "thumbnail": "https://i.ytimg.com/vi/AQKYQqV6Eqo/mqdefault.jpg",
    "title": "【#桐生ココ】MINECRAFTで初めての家作った！和風建築見ろ【#ココここ】",
    "publishedAt": "2020-01-14T15:17:05Z"
  },
  {
    "videoId": "g0s8gtKpjaM",
    "thumbnail": "https://i.ytimg.com/vi/g0s8gtKpjaM/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/15【#ココここ】",
    "publishedAt": "2020-01-14T21:26:28Z"
  },
  {
    "videoId": "4AuamZPL3Ro",
    "thumbnail": "https://i.ytimg.com/vi/4AuamZPL3Ro/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/16【#ココここ】",
    "publishedAt": "2020-01-15T21:24:52Z"
  },
  {
    "videoId": "hd3MJo0cwys",
    "thumbnail": "https://i.ytimg.com/vi/hd3MJo0cwys/mqdefault.jpg",
    "title": "【#角巻わため】#桐生ココ#PPトリオ 道をつなげ！HEAVE HO再び！【#天音かなた】",
    "publishedAt": "2020-01-16T12:06:06Z"
  },
  {
    "videoId": "ptUTfwk-1bg",
    "thumbnail": "https://i.ytimg.com/vi/ptUTfwk-1bg/mqdefault.jpg",
    "title": "【#桐生ココが如く】龍が如く7！無職上等！成り上がってみせる！【#ココここ】",
    "publishedAt": "2020-01-16T15:18:00Z"
  },
  {
    "videoId": "g09XoDfswZo",
    "thumbnail": "https://i.ytimg.com/vi/g09XoDfswZo/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/17【#ココここ】",
    "publishedAt": "2020-01-16T21:25:07Z"
  },
  {
    "videoId": "db5yKOLnB00",
    "thumbnail": "https://i.ytimg.com/vi/db5yKOLnB00/mqdefault.jpg",
    "title": "【#桐生ココが如く】龍が如く7！はかない恋！夢破れたかなしい若…【見とけ#天音かなた】",
    "publishedAt": "2020-01-17T16:15:36Z"
  },
  {
    "videoId": "qr2FwcfewzE",
    "thumbnail": "https://i.ytimg.com/vi/qr2FwcfewzE/mqdefault.jpg",
    "title": "【#桐生ココが如く】龍が如く7！裏切られた一番！信じられるのは厨二手袋おっさんだけ…【無職いくぞぁ！】",
    "publishedAt": "2020-01-18T15:13:42Z"
  },
  {
    "videoId": "l2_xqVWhxpE",
    "thumbnail": "https://i.ytimg.com/vi/l2_xqVWhxpE/mqdefault.jpg",
    "title": "【#桐生ココ】ホロサーバー作ったよ！ARKでサバイバル生活！始めましょう！【#ココここ】",
    "publishedAt": "2020-01-19T15:05:47Z"
  },
  {
    "videoId": "bHX-HtWZ_OA",
    "thumbnail": "https://i.ytimg.com/vi/bHX-HtWZ_OA/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/20【#ココここ】",
    "publishedAt": "2020-01-19T21:24:32Z"
  },
  {
    "videoId": "w0i2f-w3egw",
    "thumbnail": "https://i.ytimg.com/vi/w0i2f-w3egw/mqdefault.jpg",
    "title": "【#桐生ココが如く】龍が如く7！金もねぇ！居場所もねぇ！おまけに胸には銃創だっ！【瀕死の無職】",
    "publishedAt": "2020-01-20T13:11:38Z"
  },
  {
    "videoId": "3k1L5_tot5U",
    "thumbnail": "https://i.ytimg.com/vi/3k1L5_tot5U/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/21【#ココここ】",
    "publishedAt": "2020-01-20T21:25:20Z"
  },
  {
    "videoId": "WFQNYDHPS6s",
    "thumbnail": "https://i.ytimg.com/vi/WFQNYDHPS6s/mqdefault.jpg",
    "title": "【#桐生ココが如く】屋根付き戸建て！行けるぜハロワ！いけるか無職脱出！？龍が如く7！【見とかんかい#天音かなた】",
    "publishedAt": "2020-01-21T13:42:36Z"
  },
  {
    "videoId": "0Ys96IZPTUI",
    "thumbnail": "https://i.ytimg.com/vi/0Ys96IZPTUI/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/22【#ココここ】",
    "publishedAt": "2020-01-21T21:25:52Z"
  },
  {
    "videoId": "K-PDt7ybLf4",
    "thumbnail": "https://i.ytimg.com/vi/K-PDt7ybLf4/mqdefault.jpg",
    "title": "【#桐生ココが如く】無職脱出！でも着々と敵は増えていき！？そろそろやべぇぞ春日！どうなる龍が如く7！【伝説がここから】",
    "publishedAt": "2020-01-23T16:10:16Z"
  },
  {
    "videoId": "i6fEDcN_tHI",
    "thumbnail": "https://i.ytimg.com/vi/i6fEDcN_tHI/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/24【#ココここ】",
    "publishedAt": "2020-01-23T21:25:47Z"
  },
  {
    "videoId": "E_iWsNcHnYY",
    "thumbnail": "https://i.ytimg.com/vi/E_iWsNcHnYY/mqdefault.jpg",
    "title": "【4期生と一緒に】！hololive 1st fes.『ノンストップ・ストーリー』同時視聴枠！【#とまらないホロライブ】",
    "publishedAt": "2020-01-24T13:08:41Z"
  },
  {
    "videoId": "mrr_Sc9CxWs",
    "thumbnail": "https://i.ytimg.com/vi/mrr_Sc9CxWs/mqdefault.jpg",
    "title": "【#桐生ココ】誰か来るかな？ARKサーバー生活！恐竜時代を生き残れ！【#ココここ】",
    "publishedAt": "2020-01-25T10:46:58Z"
  },
  {
    "videoId": "aEKK1JyLZCk",
    "thumbnail": "https://i.ytimg.com/vi/aEKK1JyLZCk/mqdefault.jpg",
    "title": "【#桐生ココが如く】泡姫を救え！高齢者を食い物にするシノギなど許さない男の龍が如く7！【かかって来いよ】",
    "publishedAt": "2020-01-25T13:38:58Z"
  },
  {
    "videoId": "ZobcsuHdm1o",
    "thumbnail": "https://i.ytimg.com/vi/ZobcsuHdm1o/mqdefault.jpg",
    "title": "【#桐生ココが如く】横浜星龍会にカチコミ！救われた泡姫…しかし救われすぎて退店！やめさせちまったよ！怒られるぞ春日！龍が如く7！【かかって来いよ】",
    "publishedAt": "2020-01-26T16:13:09Z"
  },
  {
    "videoId": "nqWNVpcuSLA",
    "thumbnail": "https://i.ytimg.com/vi/nqWNVpcuSLA/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/27【#ココここ】",
    "publishedAt": "2020-01-26T21:25:16Z"
  },
  {
    "videoId": "KZCL1vF744c",
    "thumbnail": "https://i.ytimg.com/vi/KZCL1vF744c/mqdefault.jpg",
    "title": "【#桐生ココが如く】謎の殺人事件で再び無職に！キャバ嬢、紗栄子も加わり犯人を見つけ出す！次の職場は工場か…龍が如く7！【出てこい犯人】",
    "publishedAt": "2020-01-27T13:12:01Z"
  },
  {
    "videoId": "G7zzkft-LgU",
    "thumbnail": "https://i.ytimg.com/vi/G7zzkft-LgU/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1/28【#ココここ】",
    "publishedAt": "2020-01-27T21:24:33Z"
  },
  {
    "videoId": "ScZ29SwBv0k",
    "thumbnail": "https://i.ytimg.com/vi/ScZ29SwBv0k/mqdefault.jpg",
    "title": "【#桐生ココ】ホラ、助手席に乗って。雑談でもしながら記念日祝おうよ【1か月記念】",
    "publishedAt": "2020-01-28T13:07:18Z"
  },
  {
    "videoId": "UrWeq5Ie0I0",
    "thumbnail": "https://i.ytimg.com/vi/UrWeq5Ie0I0/mqdefault.jpg",
    "title": "【#桐生ココ】ARKの世界で楽しいサバイバル！ひつじよこれが自然界だ【#角巻わため】",
    "publishedAt": "2020-01-28T15:15:27Z"
  },
  {
    "videoId": "ZUOQvvba_Uo",
    "thumbnail": "https://i.ytimg.com/vi/ZUOQvvba_Uo/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1月29日【#ココここ】",
    "publishedAt": "2020-01-28T21:25:56Z"
  },
  {
    "videoId": "KDz-qX8pcSE",
    "thumbnail": "https://i.ytimg.com/vi/KDz-qX8pcSE/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1月30日【#ココここ】",
    "publishedAt": "2020-01-29T21:25:27Z"
  },
  {
    "videoId": "_QquvsiYp_Y",
    "thumbnail": "https://i.ytimg.com/vi/_QquvsiYp_Y/mqdefault.jpg",
    "title": "【#桐生ココ】ARKで借り拠点は完成！ちょっと広い世界を見て回ろうか。【#天音かなた】",
    "publishedAt": "2020-01-30T14:06:01Z"
  },
  {
    "videoId": "s75chznG9bM",
    "thumbnail": "https://i.ytimg.com/vi/s75chznG9bM/mqdefault.jpg",
    "title": "【#桐生ココが如く】中年おっさん工場バイト開始ぃ！しかし何やら怪しいぞこの職場！大丈夫か春日！龍が如く7！【犯人と出会えるか】",
    "publishedAt": "2020-01-30T16:26:35Z"
  },
  {
    "videoId": "dmAoZ-aw8XI",
    "thumbnail": "https://i.ytimg.com/vi/dmAoZ-aw8XI/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！1月31日【#ココここ】",
    "publishedAt": "2020-01-30T21:26:16Z"
  },
  {
    "videoId": "hmhiYrPxZOk",
    "thumbnail": "https://i.ytimg.com/vi/hmhiYrPxZOk/mqdefault.jpg",
    "title": "【コラボ解禁記念】夏色まつりパイセンと初ガチコラボ！2日間寝てない人のガチARK！【#ココ夏】",
    "publishedAt": "2020-02-01T14:13:52Z"
  },
  {
    "videoId": "-DlXxPiDEWk",
    "thumbnail": "https://i.ytimg.com/vi/-DlXxPiDEWk/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月3日【#ココここ】",
    "publishedAt": "2020-02-02T21:25:35Z"
  },
  {
    "videoId": "krpej-JRYng",
    "thumbnail": "https://i.ytimg.com/vi/krpej-JRYng/mqdefault.jpg",
    "title": "【#湊あくあ#兎田ぺこら】#ホロARK廃人勢 の先輩3人と緊急コラボ！大怪鳥TEKケツァルを捕まえろ！【#宝鐘マリン#桐生ココ】",
    "publishedAt": "2020-02-03T10:48:32Z"
  },
  {
    "videoId": "hrTR9VzKWXs",
    "thumbnail": "https://i.ytimg.com/vi/hrTR9VzKWXs/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月4日【#ココここ】",
    "publishedAt": "2020-02-03T21:24:45Z"
  },
  {
    "videoId": "vyG3OXVp888",
    "thumbnail": "https://i.ytimg.com/vi/vyG3OXVp888/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月5日【#ココここ】",
    "publishedAt": "2020-02-04T21:25:27Z"
  },
  {
    "videoId": "RIFCZDsNEvk",
    "thumbnail": "https://i.ytimg.com/vi/RIFCZDsNEvk/mqdefault.jpg",
    "title": "【#桐生ココが如く】長い冷戦、しかし均衡は崩れた！！始まるぞ、スジモン同士の壮大なSMが！龍が如く7！【戦が、始まる】",
    "publishedAt": "2020-02-05T15:14:39Z"
  },
  {
    "videoId": "MfBXNaKSgpI",
    "thumbnail": "https://i.ytimg.com/vi/MfBXNaKSgpI/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月6日【#ココここ】",
    "publishedAt": "2020-02-05T21:26:38Z"
  },
  {
    "videoId": "iVa7nqgLFqw",
    "thumbnail": "https://i.ytimg.com/vi/iVa7nqgLFqw/mqdefault.jpg",
    "title": "【#桐生ココ】7Days to Dieホロサーバー！みんなで地獄に家建てない？【#ゾンビタウンHOLO】",
    "publishedAt": "2020-02-06T13:09:08Z"
  },
  {
    "videoId": "zzf8HYuGoQg",
    "thumbnail": "https://i.ytimg.com/vi/zzf8HYuGoQg/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月7日【#ココここ】",
    "publishedAt": "2020-02-06T21:26:25Z"
  },
  {
    "videoId": "EsgpYdmkQmc",
    "thumbnail": "https://i.ytimg.com/vi/EsgpYdmkQmc/mqdefault.jpg",
    "title": "【#桐生ココ】会長の本気建築はじまる！マップの中心に拠点を建てろ！【#ココここ】",
    "publishedAt": "2020-02-07T03:27:03Z"
  },
  {
    "videoId": "GoHs2Waikuw",
    "thumbnail": "https://i.ytimg.com/vi/GoHs2Waikuw/mqdefault.jpg",
    "title": "【#紫龍組】ため口教室の後は敬語禁止！試される日本語力！7Days to Die！【#ゾンビタウンHOLO】",
    "publishedAt": "2020-02-07T13:39:02Z"
  },
  {
    "videoId": "dJczqL3iV4A",
    "thumbnail": "https://i.ytimg.com/vi/dJczqL3iV4A/mqdefault.jpg",
    "title": "【#PPトリオ】7Days to Die!!おいでよ地獄の森！ゾンビまみれでも生き残れ！【#ゾンビタウンHOLO】",
    "publishedAt": "2020-02-07T15:41:41Z"
  },
  {
    "videoId": "Yeup6caQk1M",
    "thumbnail": "https://i.ytimg.com/vi/Yeup6caQk1M/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月10日【#ココここ】",
    "publishedAt": "2020-02-09T21:25:36Z"
  },
  {
    "videoId": "RkXd__Sd0OM",
    "thumbnail": "https://i.ytimg.com/vi/RkXd__Sd0OM/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月11日【#ココここ】",
    "publishedAt": "2020-02-10T21:26:23Z"
  },
  {
    "videoId": "hJCPtFA_nzA",
    "thumbnail": "https://i.ytimg.com/vi/hJCPtFA_nzA/mqdefault.jpg",
    "title": "【#桐生ココ】神立地見つけたり！効率厨のための拠点づくりおしえちゃるよ【#ココここ】",
    "publishedAt": "2020-02-11T02:47:08Z"
  },
  {
    "videoId": "_i_AxXSfceM",
    "thumbnail": "https://i.ytimg.com/vi/_i_AxXSfceM/mqdefault.jpg",
    "title": "【#祝桐生ココ収益化】この配信でスパチャ解禁！皆様に感謝を込めて…！アイドル桐生ココ…歌います！！！【スパチャ解禁！】",
    "publishedAt": "2020-02-11T13:40:30Z"
  },
  {
    "videoId": "TvMh4B4NQX8",
    "thumbnail": "https://i.ytimg.com/vi/TvMh4B4NQX8/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月12日【#ココここ】",
    "publishedAt": "2020-02-11T21:24:41Z"
  },
  {
    "videoId": "9S0b3TivmDQ",
    "thumbnail": "https://i.ytimg.com/vi/9S0b3TivmDQ/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月13日【#ココここ】",
    "publishedAt": "2020-02-12T21:27:05Z"
  },
  {
    "videoId": "K6ixqa0esVI",
    "thumbnail": "https://i.ytimg.com/vi/K6ixqa0esVI/mqdefault.jpg",
    "title": "【#桐生ココ】現在爆流行り中！ARKのおすすめのサーバ設定おしえるよ！みんなで楽しもう！【#とまらないARK】",
    "publishedAt": "2020-02-12T22:22:50Z"
  },
  {
    "videoId": "NxKui04aVSU",
    "thumbnail": "https://i.ytimg.com/vi/NxKui04aVSU/mqdefault.jpg",
    "title": "【#桐生ココ】建畜生の垂れ流し無言ARK作業配信【#とまらないARK】",
    "publishedAt": "2020-02-13T15:54:35Z"
  },
  {
    "videoId": "0uwXV_ntcgU",
    "thumbnail": "https://i.ytimg.com/vi/0uwXV_ntcgU/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月14日【#ココここ】",
    "publishedAt": "2020-02-13T21:25:10Z"
  },
  {
    "videoId": "8T3WWfMULUM",
    "thumbnail": "https://i.ytimg.com/vi/8T3WWfMULUM/mqdefault.jpg",
    "title": "【#桐生ココが如く】神奈川３大勢力大戦争ぉぉぉぉおお！止められるか春日！？龍が如く7！【戦、激化！】",
    "publishedAt": "2020-02-14T13:08:32Z"
  },
  {
    "videoId": "eD4y0jcoeHw",
    "thumbnail": "https://i.ytimg.com/vi/eD4y0jcoeHw/mqdefault.jpg",
    "title": "【#桐生ココが如く】神奈川３大勢力大戦争ぉぉぉぉおお！止められるか春日！？龍が如く7！【戦、激化！】",
    "publishedAt": "2020-02-14T15:43:01Z"
  },
  {
    "videoId": "59LczRiElhk",
    "thumbnail": "https://i.ytimg.com/vi/59LczRiElhk/mqdefault.jpg",
    "title": "【#桐生ココ】雑談しながら洞窟準備！捕まえるぜ！育てるぜ！バリオニクス！【#とまらないARK】",
    "publishedAt": "2020-02-16T04:14:56Z"
  },
  {
    "videoId": "A95H2M4MbGo",
    "thumbnail": "https://i.ytimg.com/vi/A95H2M4MbGo/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月17日【#ココここ】",
    "publishedAt": "2020-02-16T21:25:57Z"
  },
  {
    "videoId": "su9USkvYmR4",
    "thumbnail": "https://i.ytimg.com/vi/su9USkvYmR4/mqdefault.jpg",
    "title": "【#ぺこみここ夏】Lv.145 Giganotosaurus Taming！時は満ちた。廃人は集まった。行くぞ。【#とまらないARK】",
    "publishedAt": "2020-02-17T15:42:55Z"
  },
  {
    "videoId": "OijulL77BXw",
    "thumbnail": "https://i.ytimg.com/vi/OijulL77BXw/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月18日【#ココここ】",
    "publishedAt": "2020-02-17T21:24:55Z"
  },
  {
    "videoId": "AGGTZ64XEiQ",
    "thumbnail": "https://i.ytimg.com/vi/AGGTZ64XEiQ/mqdefault.jpg",
    "title": "【#桐生ココ】う〇こ凸待ち雑談！ARKで一番大きなう〇こに出会いたい！【#とまらないARK】",
    "publishedAt": "2020-02-17T21:41:38Z"
  },
  {
    "videoId": "_iauGnvq8mk",
    "thumbnail": "https://i.ytimg.com/vi/_iauGnvq8mk/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月19日【#ココここ】",
    "publishedAt": "2020-02-18T21:26:05Z"
  },
  {
    "videoId": "POKdc3q82MQ",
    "thumbnail": "https://i.ytimg.com/vi/POKdc3q82MQ/mqdefault.jpg",
    "title": "【#桐生ココが如く】情報を求めてカチコミ！しかし仲間の裏切りで話が変わってきたぞ！？何が起きているか理解してるか春日？？【仲間か？敵か？】",
    "publishedAt": "2020-02-19T15:35:45Z"
  },
  {
    "videoId": "s5EadiiGaKw",
    "thumbnail": "https://i.ytimg.com/vi/s5EadiiGaKw/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月20日【#ココここ】",
    "publishedAt": "2020-02-19T21:26:03Z"
  },
  {
    "videoId": "mFTp8eS938U",
    "thumbnail": "https://i.ytimg.com/vi/mFTp8eS938U/mqdefault.jpg",
    "title": "【#桐生ココ】洞窟準備の準備！弾量産のために化学作業台がどうしても欲しい！作る！【#とまらないARK】",
    "publishedAt": "2020-02-20T14:15:56Z"
  },
  {
    "videoId": "BVSv0dlT_Yo",
    "thumbnail": "https://i.ytimg.com/vi/BVSv0dlT_Yo/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月21日【#ココここ】",
    "publishedAt": "2020-02-20T21:25:45Z"
  },
  {
    "videoId": "hR9hY_ebcyA",
    "thumbnail": "https://i.ytimg.com/vi/hR9hY_ebcyA/mqdefault.jpg",
    "title": "【#はあココ】I got your back Coco! Defuse the bomb with THE EXPERT Haato!【English Stream】",
    "publishedAt": "2020-02-21T16:08:08Z"
  },
  {
    "videoId": "DFHk6C9ch78",
    "thumbnail": "https://i.ytimg.com/vi/DFHk6C9ch78/mqdefault.jpg",
    "title": "【#ホロARK1番隊】止まるな！生きろ！配信者を守れ！RAGNAROK洞窟攻略いくぞおおおお【#とまらないARK】",
    "publishedAt": "2020-02-22T15:17:51Z"
  },
  {
    "videoId": "ZE-j0-3YJX8",
    "thumbnail": "https://i.ytimg.com/vi/ZE-j0-3YJX8/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月24日【#ココここ】",
    "publishedAt": "2020-02-23T21:27:15Z"
  },
  {
    "videoId": "OARWq8AC8a8",
    "thumbnail": "https://i.ytimg.com/vi/OARWq8AC8a8/mqdefault.jpg",
    "title": "【#CAMP】#湊あくあ#兎田ぺこら 友の腕に命を預ける！手繋ぎ絆ゲーム！#宝鐘マリン#桐生ココ【HEAVE HO】",
    "publishedAt": "2020-02-24T12:17:23Z"
  },
  {
    "videoId": "fPkSVqBpFT8",
    "thumbnail": "https://i.ytimg.com/vi/fPkSVqBpFT8/mqdefault.jpg",
    "title": "【#桐生ココ】26日は洞窟攻略！えっ！？テラーバードが使えそう！？捕まえなきゃ！【#とまらないARK】",
    "publishedAt": "2020-02-24T15:23:39Z"
  },
  {
    "videoId": "MQ7-28plUVQ",
    "thumbnail": "https://i.ytimg.com/vi/MQ7-28plUVQ/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月25日【#ココここ】",
    "publishedAt": "2020-02-24T21:26:52Z"
  },
  {
    "videoId": "49w-a60SXG8",
    "thumbnail": "https://i.ytimg.com/vi/49w-a60SXG8/mqdefault.jpg",
    "title": "【#桐生ココ】明日は洞窟攻略！製作がめんどくさいクライオポッド、量産するぞ！【#とまらないARK】",
    "publishedAt": "2020-02-25T15:33:53Z"
  },
  {
    "videoId": "5E9RJNtSk8U",
    "thumbnail": "https://i.ytimg.com/vi/5E9RJNtSk8U/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月26日【#ココここ】",
    "publishedAt": "2020-02-25T21:25:22Z"
  },
  {
    "videoId": "ZL287oa1Fr0",
    "thumbnail": "https://i.ytimg.com/vi/ZL287oa1Fr0/mqdefault.jpg",
    "title": "【かなしい】えっ！？洞窟間に合わないんですか！？代わりに全員で人狼！？できるのかい！？【#ARK廃人村人狼】",
    "publishedAt": "2020-02-26T15:49:35Z"
  },
  {
    "videoId": "NwPUjto9j_Q",
    "thumbnail": "https://i.ytimg.com/vi/NwPUjto9j_Q/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月27日【#ココここ】",
    "publishedAt": "2020-02-26T21:27:30Z"
  },
  {
    "videoId": "IN4o4j8cqHY",
    "thumbnail": "https://i.ytimg.com/vi/IN4o4j8cqHY/mqdefault.jpg",
    "title": "【#桐生ココ】にほんご勉強雑談　みんなのコメントを、漢字を、もっと読めるようになるのじゃ【#ココここ】",
    "publishedAt": "2020-02-27T15:05:38Z"
  },
  {
    "videoId": "BDJcGH-FC3I",
    "thumbnail": "https://i.ytimg.com/vi/BDJcGH-FC3I/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！2月28日【#ココここ】",
    "publishedAt": "2020-02-27T21:27:58Z"
  },
  {
    "videoId": "EcuBRFN6eyk",
    "thumbnail": "https://i.ytimg.com/vi/EcuBRFN6eyk/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月2日【#ココここ】",
    "publishedAt": "2020-03-01T21:26:22Z"
  },
  {
    "videoId": "eHVQX1gh3eA",
    "thumbnail": "https://i.ytimg.com/vi/eHVQX1gh3eA/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月3日【#ココここ】",
    "publishedAt": "2020-03-02T21:27:41Z"
  },
  {
    "videoId": "Jy7RsvAkntk",
    "thumbnail": "https://i.ytimg.com/vi/Jy7RsvAkntk/mqdefault.jpg",
    "title": "【#桐生ココ】ARKホロ鯖内に英語塾建築する。【#とまらないARK】",
    "publishedAt": "2020-03-03T03:33:30Z"
  },
  {
    "videoId": "FdKrNmYl0yo",
    "thumbnail": "https://i.ytimg.com/vi/FdKrNmYl0yo/mqdefault.jpg",
    "title": "【#桐生ココが如く】おいおいなんだよブリーチジャパン！？いつでも殴っていいただのモブ団体じゃねぇってか！？意外と根深いぞどうする春日！【政治家も関与！？】",
    "publishedAt": "2020-03-03T14:12:44Z"
  },
  {
    "videoId": "vhrg8pvmQiI",
    "thumbnail": "https://i.ytimg.com/vi/vhrg8pvmQiI/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月4日【#ココここ】",
    "publishedAt": "2020-03-03T21:26:50Z"
  },
  {
    "videoId": "mkuzmj4A92M",
    "thumbnail": "https://i.ytimg.com/vi/mkuzmj4A92M/mqdefault.jpg",
    "title": "【#桐生ココ】もらったマシュマロ(メッセージ)にお返事していきたいよ！【#ココここ】",
    "publishedAt": "2020-03-04T15:06:08Z"
  },
  {
    "videoId": "J0f4u4LElKs",
    "thumbnail": "https://i.ytimg.com/vi/J0f4u4LElKs/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月5日【#ココここ】",
    "publishedAt": "2020-03-04T21:27:09Z"
  },
  {
    "videoId": "dTHPnBqGHlQ",
    "thumbnail": "https://i.ytimg.com/vi/dTHPnBqGHlQ/mqdefault.jpg",
    "title": "【めざせ人間】なれるか完璧な\"ニンゲン\"に!?Human Simulatorで超上級人間目指す！【#桐生ココ】",
    "publishedAt": "2020-03-05T12:05:53Z"
  },
  {
    "videoId": "eqynBNhhIpo",
    "thumbnail": "https://i.ytimg.com/vi/eqynBNhhIpo/mqdefault.jpg",
    "title": "【#桐生ココ】洞窟攻略準備！洞窟前の崖を攻略する！安全第一！落下防止！スロープ建築！【#とまらないARK】",
    "publishedAt": "2020-03-05T16:17:27Z"
  },
  {
    "videoId": "v_gjU8RYt4g",
    "thumbnail": "https://i.ytimg.com/vi/v_gjU8RYt4g/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月6日【#ココここ】",
    "publishedAt": "2020-03-05T21:27:57Z"
  },
  {
    "videoId": "QskCyZi5Uoo",
    "thumbnail": "https://i.ytimg.com/vi/QskCyZi5Uoo/mqdefault.jpg",
    "title": "【#桐生ココ】洞窟攻略準備！洞窟前の崖を攻略！スロープ建築2日目ぇぇ！！【#とまらないARK】",
    "publishedAt": "2020-03-06T20:20:41Z"
  },
  {
    "videoId": "yi2vEV9UtO0",
    "thumbnail": "https://i.ytimg.com/vi/yi2vEV9UtO0/mqdefault.jpg",
    "title": "【#ホロARK1番隊】今日で必ず攻略してやる！！RAGNAROK洞窟攻略リベンジじゃい！【#とまらないARK】",
    "publishedAt": "2020-03-07T13:09:26Z"
  },
  {
    "videoId": "HvIjV8zjXWU",
    "thumbnail": "https://i.ytimg.com/vi/HvIjV8zjXWU/mqdefault.jpg",
    "title": "【#桐生ココが如く】龍が如く7レベル上げ&伊勢佐木異人町観光！いろんな経験をして強くならなければ・・・！【#ココここ】",
    "publishedAt": "2020-03-08T08:14:19Z"
  },
  {
    "videoId": "4M-NXG7HMxU",
    "thumbnail": "https://i.ytimg.com/vi/4M-NXG7HMxU/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月9日【#ココここ】",
    "publishedAt": "2020-03-08T21:28:50Z"
  },
  {
    "videoId": "9-xQAOrQxBA",
    "thumbnail": "https://i.ytimg.com/vi/9-xQAOrQxBA/mqdefault.jpg",
    "title": "【#桐生ココ】～いつ寝てるんだドラゴンのまったり生態説明枠&お茶飲み雑談【#ココここ】",
    "publishedAt": "2020-03-09T15:09:27Z"
  },
  {
    "videoId": "tv7CrwCafs0",
    "thumbnail": "https://i.ytimg.com/vi/tv7CrwCafs0/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月10日【#ココここ】",
    "publishedAt": "2020-03-09T21:26:10Z"
  },
  {
    "videoId": "plrv2lW6TA4",
    "thumbnail": "https://i.ytimg.com/vi/plrv2lW6TA4/mqdefault.jpg",
    "title": "【#桐生ココ】Survive this hell...超危険な海中サバイバル！SUBNAUTICAをプレイ！【#ココここ】",
    "publishedAt": "2020-03-10T12:14:46Z"
  },
  {
    "videoId": "bvLgWH-LV90",
    "thumbnail": "https://i.ytimg.com/vi/bvLgWH-LV90/mqdefault.jpg",
    "title": "【#桐生ココ】まだまだ止まらないARK！最強と言われるラグナロクMAPボス討伐を目指す！・・・には準備が必要だぁ！【#とまらないARK】",
    "publishedAt": "2020-03-10T15:32:56Z"
  },
  {
    "videoId": "7mYY8Iqs4mU",
    "thumbnail": "https://i.ytimg.com/vi/7mYY8Iqs4mU/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月11日【#ココここ】",
    "publishedAt": "2020-03-10T21:27:14Z"
  },
  {
    "videoId": "b_CiobMW0RA",
    "thumbnail": "https://i.ytimg.com/vi/b_CiobMW0RA/mqdefault.jpg",
    "title": "【#桐生ココ】朝活ARK！WE NEED Electricity in HOLOLIVE Village!!【#とまらないARK】",
    "publishedAt": "2020-03-11T01:33:31Z"
  },
  {
    "videoId": "Wb7UtyEKrUo",
    "thumbnail": "https://i.ytimg.com/vi/Wb7UtyEKrUo/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月12日【#ココここ】",
    "publishedAt": "2020-03-11T21:27:01Z"
  },
  {
    "videoId": "Zu3FhpAlqRI",
    "thumbnail": "https://i.ytimg.com/vi/Zu3FhpAlqRI/mqdefault.jpg",
    "title": "【#桐生ココ】Project Winter in HOLOLIVE！みんなで騙し合い！？できるかな・・・【初プレイ】",
    "publishedAt": "2020-03-12T12:24:04Z"
  },
  {
    "videoId": "XzK9MpySuz4",
    "thumbnail": "https://i.ytimg.com/vi/XzK9MpySuz4/mqdefault.jpg",
    "title": "【#桐生ココが如く】前回は、負けた。だが、レベルは上げた。かかってこいよチンピラァ！！【出て来い黒幕】",
    "publishedAt": "2020-03-12T15:12:21Z"
  },
  {
    "videoId": "FyuKO3REENA",
    "thumbnail": "https://i.ytimg.com/vi/FyuKO3REENA/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月13日【#ココここ】",
    "publishedAt": "2020-03-12T21:26:33Z"
  },
  {
    "videoId": "o3--dYeAyBI",
    "thumbnail": "https://i.ytimg.com/vi/o3--dYeAyBI/mqdefault.jpg",
    "title": "【#ホロ鯖最終決戦】死んだら即終了ARK！RAGNAROKホロ鯖ボスアリーナを攻略せよ！！【#とまらないARK】",
    "publishedAt": "2020-03-14T12:45:15Z"
  },
  {
    "videoId": "-Hxc7mCM5Gc",
    "thumbnail": "https://i.ytimg.com/vi/-Hxc7mCM5Gc/mqdefault.jpg",
    "title": "【#桐生ココ】オイオイARKのボス一瞬で攻略だよ企画倒れかい【みんなと雑談】",
    "publishedAt": "2020-03-14T16:35:46Z"
  },
  {
    "videoId": "MrlGPXJ2mm8",
    "thumbnail": "https://i.ytimg.com/vi/MrlGPXJ2mm8/mqdefault.jpg",
    "title": "【#ホロ鯖最終決戦】死んだら即終了！Ragnarok ARENA BOSS α ガチ全力挑戦【#とまらないARK】",
    "publishedAt": "2020-03-15T13:40:49Z"
  },
  {
    "videoId": "wxAx_80lQic",
    "thumbnail": "https://i.ytimg.com/vi/wxAx_80lQic/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月16日【#ココここ】",
    "publishedAt": "2020-03-15T21:29:05Z"
  },
  {
    "videoId": "hsLAjK6Tmd8",
    "thumbnail": "https://i.ytimg.com/vi/hsLAjK6Tmd8/mqdefault.jpg",
    "title": "【#桐生ココ】シーモスで海中探検したい！！海中サバイバル！SUBNAUTICA！【#ココここ】",
    "publishedAt": "2020-03-16T13:52:45Z"
  },
  {
    "videoId": "jQfFvUET6z4",
    "thumbnail": "https://i.ytimg.com/vi/jQfFvUET6z4/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月17日【#ココここ】",
    "publishedAt": "2020-03-16T21:25:30Z"
  },
  {
    "videoId": "b9Kl2SUBXx0",
    "thumbnail": "https://i.ytimg.com/vi/b9Kl2SUBXx0/mqdefault.jpg",
    "title": "【#桐生ココ】Almost Quarter Million SUBS!!もうすぐ登録者25万人！みんなでカウントダウンしたい！【#ココここ】",
    "publishedAt": "2020-03-17T11:07:37Z"
  },
  {
    "videoId": "fkyqGbzO9Rg",
    "thumbnail": "https://i.ytimg.com/vi/fkyqGbzO9Rg/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月18日【#ココここ】",
    "publishedAt": "2020-03-17T21:27:12Z"
  },
  {
    "videoId": "JdxYDIpvF14",
    "thumbnail": "https://i.ytimg.com/vi/JdxYDIpvF14/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月19日【#ココここ】",
    "publishedAt": "2020-03-18T21:28:15Z"
  },
  {
    "videoId": "r6v7Oo3NT88",
    "thumbnail": "https://i.ytimg.com/vi/r6v7Oo3NT88/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月20日【#ココここ】",
    "publishedAt": "2020-03-19T21:28:51Z"
  },
  {
    "videoId": "IABaC2abHBQ",
    "thumbnail": "https://i.ytimg.com/vi/IABaC2abHBQ/mqdefault.jpg",
    "title": "【#桐生ココ】RAGNAROK観光地化計画★思い出のドヤづくり！(株)桐生建築【#とまらないARK】",
    "publishedAt": "2020-03-20T05:13:08Z"
  },
  {
    "videoId": "tTNS3NpgfPA",
    "thumbnail": "https://i.ytimg.com/vi/tTNS3NpgfPA/mqdefault.jpg",
    "title": "【#桐生ココが如く】発売したばかりのごくどうの森！組織で裏切り！？組織TOPの趙を救え！【あやまれ】",
    "publishedAt": "2020-03-20T14:38:53Z"
  },
  {
    "videoId": "0C6heVIrvm8",
    "thumbnail": "https://i.ytimg.com/vi/0C6heVIrvm8/mqdefault.jpg",
    "title": "【#桐生ココ】新ARKホロ鯖！ゼロからAberration攻略開始せよ！！！！【#とまらないARK】",
    "publishedAt": "2020-03-21T02:21:24Z"
  },
  {
    "videoId": "0GritZ8rCpg",
    "thumbnail": "https://i.ytimg.com/vi/0GritZ8rCpg/mqdefault.jpg",
    "title": "【#桐生ココ】BANにも負けず！アベレーション攻略開始！【#とまらないARK】",
    "publishedAt": "2020-03-21T07:52:21Z"
  },
  {
    "videoId": "MCzCKpXbIZg",
    "thumbnail": "https://i.ytimg.com/vi/MCzCKpXbIZg/mqdefault.jpg",
    "title": "【#桐生ココ】プレゼント届いたよ！みんな本当にありがとう・・・！～まったりお茶会雑談～【#ココここ】",
    "publishedAt": "2020-03-21T15:33:58Z"
  },
  {
    "videoId": "Yi50I2V7W7E",
    "thumbnail": "https://i.ytimg.com/vi/Yi50I2V7W7E/mqdefault.jpg",
    "title": "【#桐生ココ】ARK Aberration生活やってく！地獄で仲間を増やせ！生き残れ！Survive THIS HELL【#とまらないARK】",
    "publishedAt": "2020-03-21T19:21:31Z"
  },
  {
    "videoId": "p0OKdV0FGts",
    "thumbnail": "https://i.ytimg.com/vi/p0OKdV0FGts/mqdefault.jpg",
    "title": "【#桐生ココ】ホロライブ釣り王単独戦！同時視聴で勝負！高価な魚を釣りたい！【#ごくどうの森】",
    "publishedAt": "2020-03-22T08:05:23Z"
  },
  {
    "videoId": "5VBFz8i2Kws",
    "thumbnail": "https://i.ytimg.com/vi/5VBFz8i2Kws/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月23日【#ココここ】",
    "publishedAt": "2020-03-22T21:32:10Z"
  },
  {
    "videoId": "b1fVcuIC86k",
    "thumbnail": "https://i.ytimg.com/vi/b1fVcuIC86k/mqdefault.jpg",
    "title": "【#桐生ココ】みんな死んだ！もう終わりだ！！でもこれがARK！みんなと協力してABERRATIONで生き残れ！！！【#とまらないARK】",
    "publishedAt": "2020-03-23T13:20:59Z"
  },
  {
    "videoId": "siU1f4LB2yU",
    "thumbnail": "https://i.ytimg.com/vi/siU1f4LB2yU/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月24日【#ココここ】",
    "publishedAt": "2020-03-23T21:55:16Z"
  },
  {
    "videoId": "Yzg42p7nMZo",
    "thumbnail": "https://i.ytimg.com/vi/Yzg42p7nMZo/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月25日【#ココここ】",
    "publishedAt": "2020-03-24T21:26:22Z"
  },
  {
    "videoId": "iCBPsnhZmuQ",
    "thumbnail": "https://i.ytimg.com/vi/iCBPsnhZmuQ/mqdefault.jpg",
    "title": "【#桐生ココ】ARKの地下世界で生き残れ！強力な仲間をテイムせよ！【#とまらないARK】",
    "publishedAt": "2020-03-25T03:58:18Z"
  },
  {
    "videoId": "ii-nS8_g1hM",
    "thumbnail": "https://i.ytimg.com/vi/ii-nS8_g1hM/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月26日【#ココここ】",
    "publishedAt": "2020-03-25T21:26:14Z"
  },
  {
    "videoId": "gbj3_-yXTIM",
    "thumbnail": "https://i.ytimg.com/vi/gbj3_-yXTIM/mqdefault.jpg",
    "title": "【#桐生ココ】海中サバイバルSUBNAUTICA！！シーモス&家建築していく！【#ココここ】",
    "publishedAt": "2020-03-26T12:07:59Z"
  },
  {
    "videoId": "6Z_O6ixXD_M",
    "thumbnail": "https://i.ytimg.com/vi/6Z_O6ixXD_M/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月27日【#ココここ】",
    "publishedAt": "2020-03-26T21:26:31Z"
  },
  {
    "videoId": "2znFcHIzdFE",
    "thumbnail": "https://i.ytimg.com/vi/2znFcHIzdFE/mqdefault.jpg",
    "title": "【#桐生ココ】ARKあさ活再び！みんなと目指せ！背活の質向上！【#とまらないARK】",
    "publishedAt": "2020-03-27T00:13:35Z"
  },
  {
    "videoId": "xcmfGKh7aY0",
    "thumbnail": "https://i.ytimg.com/vi/xcmfGKh7aY0/mqdefault.jpg",
    "title": "\"WTF are you looking at?\"Japanese for REAL 2020#2(Coco Kiryu's Japanese Class)",
    "publishedAt": "2020-03-28T15:43:05Z"
  },
  {
    "videoId": "Fk39HmNqi4c",
    "thumbnail": "https://i.ytimg.com/vi/Fk39HmNqi4c/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月30日【#ココここ】",
    "publishedAt": "2020-03-29T21:27:42Z"
  },
  {
    "videoId": "V3KfGUozY1U",
    "thumbnail": "https://i.ytimg.com/vi/V3KfGUozY1U/mqdefault.jpg",
    "title": "【#桐生ココが如く】新しい仲間が増えた龍が如く7!!ついにオヤジが動く！？大抗争に備えろ！！【#ココここ】",
    "publishedAt": "2020-03-30T14:36:12Z"
  },
  {
    "videoId": "rX1qGeTzPuU",
    "thumbnail": "https://i.ytimg.com/vi/rX1qGeTzPuU/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！3月31日【#ココここ】",
    "publishedAt": "2020-03-30T21:26:55Z"
  },
  {
    "videoId": "fAoNvVCRQ60",
    "thumbnail": "https://i.ytimg.com/vi/fAoNvVCRQ60/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月1日【#ココここ】",
    "publishedAt": "2020-03-31T21:27:44Z"
  },
  {
    "videoId": "DdvxuFBu_WQ",
    "thumbnail": "https://i.ytimg.com/vi/DdvxuFBu_WQ/mqdefault.jpg",
    "title": "【#桐生ココ】やっときた！お給料・・・！などなどみんなに話したいことたくさん！【#ココここ】",
    "publishedAt": "2020-04-01T04:49:23Z"
  },
  {
    "videoId": "viGSXbwRz60",
    "thumbnail": "https://i.ytimg.com/vi/viGSXbwRz60/mqdefault.jpg",
    "title": "【#桐生ココ】ホロ鯖アベレーション！だらだらしゃべる、雑談ARK作業配信【#とまらないARK】",
    "publishedAt": "2020-04-01T08:01:38Z"
  },
  {
    "videoId": "B4gGW3ZXQto",
    "thumbnail": "https://i.ytimg.com/vi/B4gGW3ZXQto/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月2日【#ココここ】",
    "publishedAt": "2020-04-01T21:26:05Z"
  },
  {
    "videoId": "YQI34dDWWUs",
    "thumbnail": "https://i.ytimg.com/vi/YQI34dDWWUs/mqdefault.jpg",
    "title": "【#桐生ココが如く】選挙を潰す！？龍が如く7！表から日本を蹂躙してくる若を止めろ！【#ココここ】",
    "publishedAt": "2020-04-02T13:53:37Z"
  },
  {
    "videoId": "yqJxK9dDNy0",
    "thumbnail": "https://i.ytimg.com/vi/yqJxK9dDNy0/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月3日【#ココここ】",
    "publishedAt": "2020-04-02T21:28:55Z"
  },
  {
    "videoId": "XTh7uQP9QVE",
    "thumbnail": "https://i.ytimg.com/vi/XTh7uQP9QVE/mqdefault.jpg",
    "title": "【#桐生ココが如く】本編以外でも楽しめる！！サブクエ・ミニゲームを満喫するっ！【#ココここ】",
    "publishedAt": "2020-04-03T15:55:37Z"
  },
  {
    "videoId": "T6EGnwmBeIE",
    "thumbnail": "https://i.ytimg.com/vi/T6EGnwmBeIE/mqdefault.jpg",
    "title": "【#桐生ココ】雑談できるほど余裕面でプレイするホラゲ：Palmyra Orphanage【地獄の孤児院】",
    "publishedAt": "2020-04-03T20:14:09Z"
  },
  {
    "videoId": "UFwORUCieJk",
    "thumbnail": "https://i.ytimg.com/vi/UFwORUCieJk/mqdefault.jpg",
    "title": "【#桐生ココが如く】ついに決戦！伝説の兄貴達！勝たせていただきます！！【龍が如く7】",
    "publishedAt": "2020-04-04T14:28:25Z"
  },
  {
    "videoId": "HfrnAGcV4PM",
    "thumbnail": "https://i.ytimg.com/vi/HfrnAGcV4PM/mqdefault.jpg",
    "title": "【#桐生ココ】雑談しながらARKで冒険！桐生建築をすすめろっ！ABERRATION【#とまらないARK】",
    "publishedAt": "2020-04-04T21:09:19Z"
  },
  {
    "videoId": "ZAFyhyY3kOw",
    "thumbnail": "https://i.ytimg.com/vi/ZAFyhyY3kOw/mqdefault.jpg",
    "title": "【#桐生ココ】SUBNAUTICA!!墜落した母船を調べるぞ！！冒険冒険盛りだくさん！！【#ココここ】",
    "publishedAt": "2020-04-04T23:46:08Z"
  },
  {
    "videoId": "vBaGc9NJLD4",
    "thumbnail": "https://i.ytimg.com/vi/vBaGc9NJLD4/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月6日【#ココここ】",
    "publishedAt": "2020-04-05T21:26:41Z"
  },
  {
    "videoId": "lWJwzvLKbZg",
    "thumbnail": "https://i.ytimg.com/vi/lWJwzvLKbZg/mqdefault.jpg",
    "title": "【#桐生ココ】自分のストレスにむきあう。お茶のみ雑談【#ココここ】",
    "publishedAt": "2020-04-06T15:18:22Z"
  },
  {
    "videoId": "Omm_z4XW_gY",
    "thumbnail": "https://i.ytimg.com/vi/Omm_z4XW_gY/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月7日【#ココここ】",
    "publishedAt": "2020-04-06T21:25:44Z"
  },
  {
    "videoId": "YNcagYBDP6c",
    "thumbnail": "https://i.ytimg.com/vi/YNcagYBDP6c/mqdefault.jpg",
    "title": "【#桐生ココ】ARK ABERRATION!! 生活環境は整った！！冒険開始だ！【#とまらないARK】",
    "publishedAt": "2020-04-07T15:15:50Z"
  },
  {
    "videoId": "vOEfxXBliM4",
    "thumbnail": "https://i.ytimg.com/vi/vOEfxXBliM4/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月8日【#ココここ】",
    "publishedAt": "2020-04-07T21:25:50Z"
  },
  {
    "videoId": "1YufyCSVvmg",
    "thumbnail": "https://i.ytimg.com/vi/1YufyCSVvmg/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月9日【#ココここ】",
    "publishedAt": "2020-04-08T21:26:35Z"
  },
  {
    "videoId": "ruHlgNP43TM",
    "thumbnail": "https://i.ytimg.com/vi/ruHlgNP43TM/mqdefault.jpg",
    "title": "【#桐生ココが如く】巨大組織解散！後ろ盾を失った若はキレたオタクの如く！！止めるんだ春日！立候補じゃー！【#龍が如く7】",
    "publishedAt": "2020-04-09T15:33:49Z"
  },
  {
    "videoId": "lBBQyQQouWA",
    "thumbnail": "https://i.ytimg.com/vi/lBBQyQQouWA/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月10日【#ココここ】",
    "publishedAt": "2020-04-09T21:28:30Z"
  },
  {
    "videoId": "I5rtDZZb1Jc",
    "thumbnail": "https://i.ytimg.com/vi/I5rtDZZb1Jc/mqdefault.jpg",
    "title": "【#桐生ココ】ARKアベレーション限定！しかも洞窟にしかいないグローテイルちゃんをテイムしたい！！【#とまらないARK】",
    "publishedAt": "2020-04-10T07:56:59Z"
  },
  {
    "videoId": "1YTaVoujaUU",
    "thumbnail": "https://i.ytimg.com/vi/1YTaVoujaUU/mqdefault.jpg",
    "title": "【#桐生ココが如く】最後に、春日を待ち受けるのは【#龍が如く7】",
    "publishedAt": "2020-04-10T14:02:24Z"
  },
  {
    "videoId": "geyay_c8Ybw",
    "thumbnail": "https://i.ytimg.com/vi/geyay_c8Ybw/mqdefault.jpg",
    "title": "【#地獄凸待ち】28万人記念！初凸待ち！来るまで歌い続けろ！うたへたココ氏の地獄歌枠【#桐生ココ】",
    "publishedAt": "2020-04-11T13:09:49Z"
  },
  {
    "videoId": "n4-jb4qc_zA",
    "thumbnail": "https://i.ytimg.com/vi/n4-jb4qc_zA/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月13日【#ココここ】",
    "publishedAt": "2020-04-12T21:24:17Z"
  },
  {
    "videoId": "I_L7X3KK7h8",
    "thumbnail": "https://i.ytimg.com/vi/I_L7X3KK7h8/mqdefault.jpg",
    "title": "【#桐生ココ】HEAVE HO ソロチャレンジ！仲間なしでどこまでいけるか！？！？【#ココここ】",
    "publishedAt": "2020-04-13T10:48:30Z"
  },
  {
    "videoId": "-yS9UsGfAQ8",
    "thumbnail": "https://i.ytimg.com/vi/-yS9UsGfAQ8/mqdefault.jpg",
    "title": "【#桐生ココ】ARKアベレーション！いくぞ洞窟！攻略だぁ！【#とまらないARK】",
    "publishedAt": "2020-04-13T15:46:44Z"
  },
  {
    "videoId": "RKKRCXtrK3M",
    "thumbnail": "https://i.ytimg.com/vi/RKKRCXtrK3M/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月14日【#ココここ】",
    "publishedAt": "2020-04-13T21:26:34Z"
  },
  {
    "videoId": "XGtPZp7ADYE",
    "thumbnail": "https://i.ytimg.com/vi/XGtPZp7ADYE/mqdefault.jpg",
    "title": "【#桐生ココ】海でも暴れたる！！WoWSで激アツ海上戦だぁ！！【#天音かなた】",
    "publishedAt": "2020-04-14T13:32:50Z"
  },
  {
    "videoId": "K-u-6wuZdSI",
    "thumbnail": "https://i.ytimg.com/vi/K-u-6wuZdSI/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月15日【#ココここ】",
    "publishedAt": "2020-04-14T21:54:35Z"
  },
  {
    "videoId": "FJOGwaitkfI",
    "thumbnail": "https://i.ytimg.com/vi/FJOGwaitkfI/mqdefault.jpg",
    "title": "【#桐生ココ】ARK ABERRATIONで朝活～雑談しながらまったりテイム【#とまらないARK】",
    "publishedAt": "2020-04-15T00:17:19Z"
  },
  {
    "videoId": "Avv6lAEWp5E",
    "thumbnail": "https://i.ytimg.com/vi/Avv6lAEWp5E/mqdefault.jpg",
    "title": "【#桐生ココ】激痛永久脱毛しながらまったりお茶のみ雑談はできるのか【#ココここ】",
    "publishedAt": "2020-04-15T15:16:52Z"
  },
  {
    "videoId": "zx8dB0EksBo",
    "thumbnail": "https://i.ytimg.com/vi/zx8dB0EksBo/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月16日【#ココここ】",
    "publishedAt": "2020-04-15T21:27:40Z"
  },
  {
    "videoId": "n2yIIhJl3mo",
    "thumbnail": "https://i.ytimg.com/vi/n2yIIhJl3mo/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月17日【#ココここ】",
    "publishedAt": "2020-04-16T22:26:08Z"
  },
  {
    "videoId": "0JInFu6fv88",
    "thumbnail": "https://i.ytimg.com/vi/0JInFu6fv88/mqdefault.jpg",
    "title": "【#みこここ】目指せAberrationの下層へ！みこ先輩とロックドレイクの卵GETしてやんよ！【#とまらないARK】",
    "publishedAt": "2020-04-18T11:57:30Z"
  },
  {
    "videoId": "2di61BNqMek",
    "thumbnail": "https://i.ytimg.com/vi/2di61BNqMek/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月20日【#ココここ】",
    "publishedAt": "2020-04-19T21:02:40Z"
  },
  {
    "videoId": "KG-OO8g4v2U",
    "thumbnail": "https://i.ytimg.com/vi/KG-OO8g4v2U/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月21日【#ココここ】",
    "publishedAt": "2020-04-20T21:00:11Z"
  },
  {
    "videoId": "s1xXjd5DPyg",
    "thumbnail": "https://i.ytimg.com/vi/s1xXjd5DPyg/mqdefault.jpg",
    "title": "【#桐生ココが如く】#1龍が如く「極」全てはここから始まった！！伝説の龍のとなれ！©SEGA【#ココここ】",
    "publishedAt": "2020-04-21T07:25:26Z"
  },
  {
    "videoId": "wb16pt573dQ",
    "thumbnail": "https://i.ytimg.com/vi/wb16pt573dQ/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月22日【#ココここ】",
    "publishedAt": "2020-04-21T20:59:08Z"
  },
  {
    "videoId": "bW-DI1gN5Xo",
    "thumbnail": "https://i.ytimg.com/vi/bW-DI1gN5Xo/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月23日【#ココここ】",
    "publishedAt": "2020-04-22T21:03:58Z"
  },
  {
    "videoId": "hq_WQmrZLKs",
    "thumbnail": "https://i.ytimg.com/vi/hq_WQmrZLKs/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月24日【#ココここ】",
    "publishedAt": "2020-04-23T21:25:45Z"
  },
  {
    "videoId": "QtlcX8tWaIY",
    "thumbnail": "https://i.ytimg.com/vi/QtlcX8tWaIY/mqdefault.jpg",
    "title": "【#桐生ココ出所】ホロライブ4代目会長桐生ココ出所＆30万人記念配信【#桐生ココ30万人】",
    "publishedAt": "2020-04-24T12:34:57Z"
  },
  {
    "videoId": "-85a9f5cOsw",
    "thumbnail": "https://i.ytimg.com/vi/-85a9f5cOsw/mqdefault.jpg",
    "title": "【#桐生ココ】ついにメンバーシップ解禁だあああああ！【#ココここ】",
    "publishedAt": "2020-04-25T12:39:11Z"
  },
  {
    "videoId": "yj_red1NFlQ",
    "thumbnail": "https://i.ytimg.com/vi/yj_red1NFlQ/mqdefault.jpg",
    "title": "COCOFFIN DANCE with Live stream restricted Coco",
    "publishedAt": "2020-04-26T21:40:25Z"
  },
  {
    "videoId": "7yyHEh804EA",
    "thumbnail": "https://i.ytimg.com/vi/7yyHEh804EA/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月27日【#ココここ】",
    "publishedAt": "2020-04-26T21:56:24Z"
  },
  {
    "videoId": "gK36NYezT8o",
    "thumbnail": "https://i.ytimg.com/vi/gK36NYezT8o/mqdefault.jpg",
    "title": "【#桐生ココが如く】#2龍が如く極！無実の罪で塀の中へ・・・！桐生一馬。堂島の龍。伝説、始まる。©SEGA【#ココここ】",
    "publishedAt": "2020-04-27T15:35:52Z"
  },
  {
    "videoId": "OVvLDRCG9ho",
    "thumbnail": "https://i.ytimg.com/vi/OVvLDRCG9ho/mqdefault.jpg",
    "title": "【#桐生ココ】ARK Aberration みんなとお話ししながらのんびり建築、そして生活。【#とまらないARK】",
    "publishedAt": "2020-04-28T16:12:52Z"
  },
  {
    "videoId": "ZjKLq_kneBo",
    "thumbnail": "https://i.ytimg.com/vi/ZjKLq_kneBo/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月29日【#ココここ】",
    "publishedAt": "2020-04-28T21:54:49Z"
  },
  {
    "videoId": "h7WJadCWgYY",
    "thumbnail": "https://i.ytimg.com/vi/h7WJadCWgYY/mqdefault.jpg",
    "title": "【#桐生ココ】ARK Aberration まったり生活・・・からの超危険洞窟準備！？【#とまらないARK】",
    "publishedAt": "2020-04-29T10:15:31Z"
  },
  {
    "videoId": "w9J27jUeZEc",
    "thumbnail": "https://i.ytimg.com/vi/w9J27jUeZEc/mqdefault.jpg",
    "title": "【#桐生ココが如く】#3仮出所で大暴れ、久しぶりに会った兄弟のツラは極悪人！？何があった！？龍が如く極！©SEGA【#ココここ】",
    "publishedAt": "2020-04-29T15:29:31Z"
  },
  {
    "videoId": "ta6L-CarI3Q",
    "thumbnail": "https://i.ytimg.com/vi/ta6L-CarI3Q/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！4月30日【#ココここ】",
    "publishedAt": "2020-04-29T21:55:18Z"
  },
  {
    "videoId": "tG9WEpzwLoU",
    "thumbnail": "https://i.ytimg.com/vi/tG9WEpzwLoU/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！5月1日【#ココここ】",
    "publishedAt": "2020-04-30T21:54:21Z"
  },
  {
    "videoId": "XywCjzTjEkg",
    "thumbnail": "https://i.ytimg.com/vi/XywCjzTjEkg/mqdefault.jpg",
    "title": "【#紫龍組】超超超超超初心者のAPEX LEGENDS！！【#ココここ】",
    "publishedAt": "2020-05-01T12:24:07Z"
  },
  {
    "videoId": "OIOQjL-1BD8",
    "thumbnail": "https://i.ytimg.com/vi/OIOQjL-1BD8/mqdefault.jpg",
    "title": "【#桐生ココ】ARK ABERRATION 実は初めてのロックドレイク卵ソロ盗みチャレンジ！【#とまらないARK】",
    "publishedAt": "2020-05-02T06:22:36Z"
  },
  {
    "videoId": "u_gEtaiPD7M",
    "thumbnail": "https://i.ytimg.com/vi/u_gEtaiPD7M/mqdefault.jpg",
    "title": "【#桐生ココが如く】#4龍が如く極！由美を知るという少女遥！行方不明の手掛かりは「アレス」に！？【#ココここ】",
    "publishedAt": "2020-05-03T15:19:33Z"
  },
  {
    "videoId": "VcxeO4YfMXU",
    "thumbnail": "https://i.ytimg.com/vi/VcxeO4YfMXU/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！5月4日【#ココここ】",
    "publishedAt": "2020-05-03T21:57:44Z"
  },
  {
    "videoId": "kRneA_vXqvI",
    "thumbnail": "https://i.ytimg.com/vi/kRneA_vXqvI/mqdefault.jpg",
    "title": "【#桐生ココ】ねぇねぇ、わためぇ。メンバーシップのスタンプ、お互いに1個描き合おうよぉ【#角巻わため】",
    "publishedAt": "2020-05-04T11:06:54Z"
  },
  {
    "videoId": "DHHpbc8NVJE",
    "thumbnail": "https://i.ytimg.com/vi/DHHpbc8NVJE/mqdefault.jpg",
    "title": "【#桐生ココ】#5龍が如く極！最強の情報屋との出会い！いったい由美に何があったのか？！いざ神室町！手掛かりを探せ！【#ココここ】",
    "publishedAt": "2020-05-04T15:49:33Z"
  },
  {
    "videoId": "0j2xLeLCYO8",
    "thumbnail": "https://i.ytimg.com/vi/0j2xLeLCYO8/mqdefault.jpg",
    "title": "【#桐生ココ】初めてのBAN酌ざつだん配信【#ココここ】",
    "publishedAt": "2020-05-04T16:26:28Z"
  },
  {
    "videoId": "1M-H7N8jOJU",
    "thumbnail": "https://i.ytimg.com/vi/1M-H7N8jOJU/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！5月5日【#ココここ】",
    "publishedAt": "2020-05-04T21:55:58Z"
  },
  {
    "videoId": "1rTgSIFtaF0",
    "thumbnail": "https://i.ytimg.com/vi/1rTgSIFtaF0/mqdefault.jpg",
    "title": "【#桐生ココ】ARK ABERRATION in all girls server! PREPARE for CAVE HUNTING【#とまらないARK】",
    "publishedAt": "2020-05-05T09:40:32Z"
  },
  {
    "videoId": "tYGyZKiht18",
    "thumbnail": "https://i.ytimg.com/vi/tYGyZKiht18/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！5月6日【#ココここ】",
    "publishedAt": "2020-05-05T21:55:10Z"
  },
  {
    "videoId": "-1uHw5stqUc",
    "thumbnail": "https://i.ytimg.com/vi/-1uHw5stqUc/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！5月7日【#ココここ】",
    "publishedAt": "2020-05-06T21:54:44Z"
  },
  {
    "videoId": "Y0x4ywaXgAo",
    "thumbnail": "https://i.ytimg.com/vi/Y0x4ywaXgAo/mqdefault.jpg",
    "title": "【#桐生ココ】やっと親戚ドラゴンたち帰った・・・これで安心して雑談・・・え、歌枠？！【#ココここ】",
    "publishedAt": "2020-05-07T15:37:36Z"
  },
  {
    "videoId": "DaANtR4A7_M",
    "thumbnail": "https://i.ytimg.com/vi/DaANtR4A7_M/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！5月8日【#ココここ】",
    "publishedAt": "2020-05-07T21:59:30Z"
  },
  {
    "videoId": "tWFlh5axFfM",
    "thumbnail": "https://i.ytimg.com/vi/tWFlh5axFfM/mqdefault.jpg",
    "title": "【#桐生ココ#潤羽るしあ】ARK ABERRATION！るしあ先輩と下層難関洞窟攻略チャレンジ！！【#とまらないARK】",
    "publishedAt": "2020-05-08T16:35:27Z"
  },
  {
    "videoId": "nh7WPglRAck",
    "thumbnail": "https://i.ytimg.com/vi/nh7WPglRAck/mqdefault.jpg",
    "title": "【#桐生ココが如く】#5.5キャバ中心・サブストーリー・神室町エンジョイ回！龍が如く極！🄫SEGA【#ココここ】",
    "publishedAt": "2020-05-09T14:18:36Z"
  },
  {
    "videoId": "PAK5bkT5ThM",
    "thumbnail": "https://i.ytimg.com/vi/PAK5bkT5ThM/mqdefault.jpg",
    "title": "【#桐生ココ】ARK Aberraton1時間チャレンジ！ロックドレイクの卵、いくつ盗めるか！？【#とまらないARK】",
    "publishedAt": "2020-05-10T10:53:32Z"
  },
  {
    "videoId": "ZbbGAq1oB5w",
    "thumbnail": "https://i.ytimg.com/vi/ZbbGAq1oB5w/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！5月11日【#ココここ】",
    "publishedAt": "2020-05-10T21:55:35Z"
  },
  {
    "videoId": "wjcDrCjZ-iM",
    "thumbnail": "https://i.ytimg.com/vi/wjcDrCjZ-iM/mqdefault.jpg",
    "title": "【#桐生ココが如く】#6龍が如く極！おいおい伊達さん・・・娘さんが呼んでるよ・・・！【Yakuza Kiwami】",
    "publishedAt": "2020-05-11T12:46:35Z"
  },
  {
    "videoId": "QLvNCREjXcc",
    "thumbnail": "https://i.ytimg.com/vi/QLvNCREjXcc/mqdefault.jpg",
    "title": "【#桐生ココ】登録者34万人嬉しいので、みんなでプチ飲み会。【#ココはうす飲み会】",
    "publishedAt": "2020-05-11T15:37:04Z"
  },
  {
    "videoId": "X191q3P4shg",
    "thumbnail": "https://i.ytimg.com/vi/X191q3P4shg/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！5月12日【#ココここ】",
    "publishedAt": "2020-05-11T22:33:01Z"
  },
  {
    "videoId": "SoKve-i6yWA",
    "thumbnail": "https://i.ytimg.com/vi/SoKve-i6yWA/mqdefault.jpg",
    "title": "【#桐生ココ】ARK ABERRATION雑談作業配信。のんびりせいかつ。【#とまらないARK】",
    "publishedAt": "2020-05-12T15:23:02Z"
  },
  {
    "videoId": "bMK-9SC7zeI",
    "thumbnail": "https://i.ytimg.com/vi/bMK-9SC7zeI/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！5月13日【#ココここ】",
    "publishedAt": "2020-05-12T21:27:14Z"
  },
  {
    "videoId": "FAA0KGiY_7I",
    "thumbnail": "https://i.ytimg.com/vi/FAA0KGiY_7I/mqdefault.jpg",
    "title": "MY FIRST \"PORTAL\" PLAYING 初見ポータル！ドラゴンにもできるかな？#桐生ココ",
    "publishedAt": "2020-05-13T13:45:42Z"
  },
  {
    "videoId": "Rs7QcRwbC3E",
    "thumbnail": "https://i.ytimg.com/vi/Rs7QcRwbC3E/mqdefault.jpg",
    "title": "【#桐生ココが如く】#7龍が如く極！ついに刺青の女と水死体・・・何か知ってるのか錦山コラぁ！🄫SEGA【#ココここ】",
    "publishedAt": "2020-05-13T15:07:21Z"
  },
  {
    "videoId": "53dadu7rfJo",
    "thumbnail": "https://i.ytimg.com/vi/53dadu7rfJo/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVE100回目ニュース！5月14日【#ココここ】",
    "publishedAt": "2020-05-13T21:51:18Z"
  },
  {
    "videoId": "lWmyHMSoLQs",
    "thumbnail": "https://i.ytimg.com/vi/lWmyHMSoLQs/mqdefault.jpg",
    "title": "My first time playing H A L F - L I F E 初見ハーフライフやるぞぉぉぉ#桐生ココ",
    "publishedAt": "2020-05-14T15:50:37Z"
  },
  {
    "videoId": "ffJhuD9aXfc",
    "thumbnail": "https://i.ytimg.com/vi/ffJhuD9aXfc/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！5月15日【#ココここ】",
    "publishedAt": "2020-05-14T21:26:45Z"
  },
  {
    "videoId": "Vd6MDg4AX00",
    "thumbnail": "https://i.ytimg.com/vi/Vd6MDg4AX00/mqdefault.jpg",
    "title": "【#桐生ココ】激痛永久脱毛もペヤング獄激辛食べてりゃ無痛で余裕説【#ココここ】",
    "publishedAt": "2020-05-15T14:05:24Z"
  },
  {
    "videoId": "IPBuOzdatf4",
    "thumbnail": "https://i.ytimg.com/vi/IPBuOzdatf4/mqdefault.jpg",
    "title": "【#みこココ】軽率にABERRATIONボスを倒しに行く【#とまらないARK】",
    "publishedAt": "2020-05-16T15:31:22Z"
  },
  {
    "videoId": "r8U03qa1eLQ",
    "thumbnail": "https://i.ytimg.com/vi/r8U03qa1eLQ/mqdefault.jpg",
    "title": "登録者35万人嬉しいのからぷち飲み会でみんなと桐生ココの今後についてダベりたいんだ。",
    "publishedAt": "2020-05-17T15:47:57Z"
  },
  {
    "videoId": "ZJhACUy24ig",
    "thumbnail": "https://i.ytimg.com/vi/ZJhACUy24ig/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！5月18日【#ココここ】",
    "publishedAt": "2020-05-17T21:26:39Z"
  },
  {
    "videoId": "sy06840WQkQ",
    "thumbnail": "https://i.ytimg.com/vi/sy06840WQkQ/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！5月19日【#ココここ】",
    "publishedAt": "2020-05-18T21:56:06Z"
  },
  {
    "videoId": "T81ZhOaU33E",
    "thumbnail": "https://i.ytimg.com/vi/T81ZhOaU33E/mqdefault.jpg",
    "title": "ゲームレベル0のAPEX！へたくそだけど頑張る！！！！【VTuberの桐生ココ】",
    "publishedAt": "2020-05-19T05:49:56Z"
  },
  {
    "videoId": "FRh1TQBBHx0",
    "thumbnail": "https://i.ytimg.com/vi/FRh1TQBBHx0/mqdefault.jpg",
    "title": "ゲームレベル1のAPEX！へたくそだけどチャンピオンしたい！！！！【VTuberの桐生ココ】",
    "publishedAt": "2020-05-19T13:22:36Z"
  },
  {
    "videoId": "VQo72hYM4z0",
    "thumbnail": "https://i.ytimg.com/vi/VQo72hYM4z0/mqdefault.jpg",
    "title": "【#桐生ココが如く】#8龍が如く極！！遥がさらわれた！犯人はラウ・カーロン！？🄫SEGA【#ココここ】",
    "publishedAt": "2020-05-19T15:39:52Z"
  },
  {
    "videoId": "_b-F2Jsi5Fg",
    "thumbnail": "https://i.ytimg.com/vi/_b-F2Jsi5Fg/mqdefault.jpg",
    "title": "ゲームレベル2のAPEX！チャンピオンなるまで終わらない！！！！！【VTuberの桐生ココ】",
    "publishedAt": "2020-05-21T10:40:35Z"
  },
  {
    "videoId": "UY9NsrlgbUc",
    "thumbnail": "https://i.ytimg.com/vi/UY9NsrlgbUc/mqdefault.jpg",
    "title": "まったりみんなでお絵かき雑談しませんか？",
    "publishedAt": "2020-05-21T14:32:47Z"
  },
  {
    "videoId": "-rgamOt_fqg",
    "thumbnail": "https://i.ytimg.com/vi/-rgamOt_fqg/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！5月22日【#ココここ】",
    "publishedAt": "2020-05-21T21:30:32Z"
  },
  {
    "videoId": "rvHz5hMsycE",
    "thumbnail": "https://i.ytimg.com/vi/rvHz5hMsycE/mqdefault.jpg",
    "title": "全然ビビらない無敵VTuberのサクサクげぼやばホラーInfliction",
    "publishedAt": "2020-05-22T17:10:01Z"
  },
  {
    "videoId": "LkeTyFXoiG8",
    "thumbnail": "https://i.ytimg.com/vi/LkeTyFXoiG8/mqdefault.jpg",
    "title": "#ココ夏 まつり先輩に教えてもらってゲームレベルアップを目指す！【VTuberの桐生ココ】",
    "publishedAt": "2020-05-23T15:46:23Z"
  },
  {
    "videoId": "42KxtioGoeU",
    "thumbnail": "https://i.ytimg.com/vi/42KxtioGoeU/mqdefault.jpg",
    "title": "まったくビビらない無敵VTuberのサクサクげぼやばホラーInfliction#2",
    "publishedAt": "2020-05-23T19:56:08Z"
  },
  {
    "videoId": "A8nxd_UUwhQ",
    "thumbnail": "https://i.ytimg.com/vi/A8nxd_UUwhQ/mqdefault.jpg",
    "title": "#マイペース組　APEXコラボ！！みんなで楽しくチャンピオン狙う！！！",
    "publishedAt": "2020-05-24T10:36:08Z"
  },
  {
    "videoId": "QY5Omc7TwzA",
    "thumbnail": "https://i.ytimg.com/vi/QY5Omc7TwzA/mqdefault.jpg",
    "title": "ぐるぐるぴえん(スーパーチャット読みメインの雑談枠です！)",
    "publishedAt": "2020-05-24T16:21:23Z"
  },
  {
    "videoId": "8vB-FZNNFKs",
    "thumbnail": "https://i.ytimg.com/vi/8vB-FZNNFKs/mqdefault.jpg",
    "title": "ロボ子先輩に丁寧に教えてもらうAPEX!!#ロボココ",
    "publishedAt": "2020-05-25T08:32:42Z"
  },
  {
    "videoId": "_pOUglz-kFs",
    "thumbnail": "https://i.ytimg.com/vi/_pOUglz-kFs/mqdefault.jpg",
    "title": "ARKボス戦にむけて。みんなを、子ども達を絶対に死なせないためには。#とまらないARK",
    "publishedAt": "2020-05-26T07:57:15Z"
  },
  {
    "videoId": "xWhpZSObsg4",
    "thumbnail": "https://i.ytimg.com/vi/xWhpZSObsg4/mqdefault.jpg",
    "title": "【#桐生ココが如く】#9どいつもこいつも敵だらけな龍が如く極！政府も地下組織って何だよぉぉ！🄫SEGA【#ココここ】",
    "publishedAt": "2020-05-26T12:28:48Z"
  },
  {
    "videoId": "JU40nV1ive0",
    "thumbnail": "https://i.ytimg.com/vi/JU40nV1ive0/mqdefault.jpg",
    "title": "ゆるさない、もう出ていく　殺意高め雑談枠/VTuber桐生ココぶちぎれ飲み会",
    "publishedAt": "2020-05-26T17:25:33Z"
  },
  {
    "videoId": "WplDA2jVo6E",
    "thumbnail": "https://i.ytimg.com/vi/WplDA2jVo6E/mqdefault.jpg",
    "title": "【#桐生ココが如く】#10龍が如く極、最終章(ネタバレあり！)",
    "publishedAt": "2020-05-28T11:42:47Z"
  },
  {
    "videoId": "iRqbSX23ffg",
    "thumbnail": "https://i.ytimg.com/vi/iRqbSX23ffg/mqdefault.jpg",
    "title": "約30回の引越しガチャ・・・！恐怖の爆死経験を語る・・・！VTuber 桐生ココのためになりすぎる雑談",
    "publishedAt": "2020-05-28T16:22:29Z"
  },
  {
    "videoId": "ilNnHBkZ9kE",
    "thumbnail": "https://i.ytimg.com/vi/ilNnHBkZ9kE/mqdefault.jpg",
    "title": "脱出系ホラーゲーム\"We Went Back\"余裕でやったる",
    "publishedAt": "2020-05-29T14:52:20Z"
  },
  {
    "videoId": "FT8fju9h7-w",
    "thumbnail": "https://i.ytimg.com/vi/FT8fju9h7-w/mqdefault.jpg",
    "title": "【箱おじ】イライラ禁止！笑顔で箱おじ！Boxman's Struggle",
    "publishedAt": "2020-05-29T17:46:41Z"
  },
  {
    "videoId": "ilHWJtsB1tk",
    "thumbnail": "https://i.ytimg.com/vi/ilHWJtsB1tk/mqdefault.jpg",
    "title": "ホロARK最終決戦！！Aberration BOSS戦！！！#ホロARK最終決戦",
    "publishedAt": "2020-05-30T15:14:01Z"
  },
  {
    "videoId": "_vN9qaSyvcs",
    "thumbnail": "https://i.ytimg.com/vi/_vN9qaSyvcs/mqdefault.jpg",
    "title": "圧倒的勝利だい!！ARK ABERRATIONボスお疲れさまでした！",
    "publishedAt": "2020-05-30T17:49:24Z"
  },
  {
    "videoId": "tf5Z3wS-Y-M",
    "thumbnail": "https://i.ytimg.com/vi/tf5Z3wS-Y-M/mqdefault.jpg",
    "title": "PORTAL2ソロプレイ！！VTuber桐生ココのチャレンジ",
    "publishedAt": "2020-05-31T05:43:39Z"
  },
  {
    "videoId": "n0u1BIv3G9A",
    "thumbnail": "https://i.ytimg.com/vi/n0u1BIv3G9A/mqdefault.jpg",
    "title": "OH MY DADDY...　VTuber桐生ココ、かなしみの雑談部屋",
    "publishedAt": "2020-05-31T15:56:28Z"
  },
  {
    "videoId": "lo_vWJvoFzE",
    "thumbnail": "https://i.ytimg.com/vi/lo_vWJvoFzE/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！6月1日【#ココここ】",
    "publishedAt": "2020-05-31T21:32:02Z"
  },
  {
    "videoId": "_4aHMl6oe5c",
    "thumbnail": "https://i.ytimg.com/vi/_4aHMl6oe5c/mqdefault.jpg",
    "title": "#2 IQが試される！？VTuber桐生ココのPORTAL2！",
    "publishedAt": "2020-06-01T14:19:04Z"
  },
  {
    "videoId": "Uh6krIDeAwg",
    "thumbnail": "https://i.ytimg.com/vi/Uh6krIDeAwg/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！6月2日【#ココここ】",
    "publishedAt": "2020-06-01T21:23:32Z"
  },
  {
    "videoId": "006ldwDqZsM",
    "thumbnail": "https://i.ytimg.com/vi/006ldwDqZsM/mqdefault.jpg",
    "title": "【雑談】桐生ココの全力ニート物語～親にバレずにニートになる方法～",
    "publishedAt": "2020-06-02T13:35:12Z"
  },
  {
    "videoId": "UddImjXktL4",
    "thumbnail": "https://i.ytimg.com/vi/UddImjXktL4/mqdefault.jpg",
    "title": "みんなに愛をこめて。お歌を歌う！VTuber 桐生ココ",
    "publishedAt": "2020-06-02T17:35:49Z"
  },
  {
    "videoId": "x9p-EqEmN-o",
    "thumbnail": "https://i.ytimg.com/vi/x9p-EqEmN-o/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！6月3日【#ココここ】",
    "publishedAt": "2020-06-02T21:24:02Z"
  },
  {
    "videoId": "tEEALAm4OoA",
    "thumbnail": "https://i.ytimg.com/vi/tEEALAm4OoA/mqdefault.jpg",
    "title": "【箱おじ】攻略してる動画見たからきっと行ける。Boxman's Struggle　VTuber桐生ココ",
    "publishedAt": "2020-06-03T10:08:19Z"
  },
  {
    "videoId": "vTa2XaHYOMQ",
    "thumbnail": "https://i.ytimg.com/vi/vTa2XaHYOMQ/mqdefault.jpg",
    "title": "ホロARK Aberration!!かかってこいよ最強アルファボス!!!#とまらないARK",
    "publishedAt": "2020-06-04T08:14:33Z"
  },
  {
    "videoId": "fV3oVHdyV7o",
    "thumbnail": "https://i.ytimg.com/vi/fV3oVHdyV7o/mqdefault.jpg",
    "title": "【箱おじ】斜め45°を極めて優勝するBoxman's Struggle　VTuber桐生ココ",
    "publishedAt": "2020-06-04T10:12:35Z"
  },
  {
    "videoId": "Mxo4Jxh4LRg",
    "thumbnail": "https://i.ytimg.com/vi/Mxo4Jxh4LRg/mqdefault.jpg",
    "title": "【Sims4】妄想をカタチに！桐生ココ夢の簡易ホロライブハウス！！",
    "publishedAt": "2020-06-04T14:19:04Z"
  },
  {
    "videoId": "pIOQ2CYOqoo",
    "thumbnail": "https://i.ytimg.com/vi/pIOQ2CYOqoo/mqdefault.jpg",
    "title": "【#桐生ココ】あさココLIVEニュース！6月5日【#ココここ】",
    "publishedAt": "2020-06-04T21:27:19Z"
  },
  {
    "videoId": "5RXEmC0ozUU",
    "thumbnail": "https://i.ytimg.com/vi/5RXEmC0ozUU/mqdefault.jpg",
    "title": "週末だらしゃべ雑談！スタンプつくりながら楽しく話しましょ!VTuber桐生ココ",
    "publishedAt": "2020-06-05T18:32:48Z"
  },
  {
    "videoId": "4b1U6ntRDZM",
    "thumbnail": "https://i.ytimg.com/vi/4b1U6ntRDZM/mqdefault.jpg",
    "title": "#3 IQ3500ドラゴンVTuber桐生ココのPORTAL2！",
    "publishedAt": "2020-06-06T11:15:58Z"
  },
  {
    "videoId": "41hJibGYTgg",
    "thumbnail": "https://i.ytimg.com/vi/41hJibGYTgg/mqdefault.jpg",
    "title": "【Sims4】妄想ホロライブハウスをデザイン！！#桐生ココ VTuber",
    "publishedAt": "2020-06-06T19:18:08Z"
  },
  {
    "videoId": "ltWwAWdsxRc",
    "thumbnail": "https://i.ytimg.com/vi/ltWwAWdsxRc/mqdefault.jpg",
    "title": "【Sims4】妄想ホロライブハウスを建築！バスルームにこだわれ！！#桐生ココ VTuber",
    "publishedAt": "2020-06-07T10:20:19Z"
  },
  {
    "videoId": "ezeBmDFFhDs",
    "thumbnail": "https://i.ytimg.com/vi/ezeBmDFFhDs/mqdefault.jpg",
    "title": "【箱おじ】バスケコートに余裕でたどり着くBoxman's Struggle　VTuber桐生ココ",
    "publishedAt": "2020-06-07T16:08:27Z"
  },
  {
    "videoId": "wm8IKrLNTqM",
    "thumbnail": "https://i.ytimg.com/vi/wm8IKrLNTqM/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月8日【#ココここ】",
    "publishedAt": "2020-06-07T21:26:12Z"
  },
  {
    "videoId": "2cS_vsLYTUo",
    "thumbnail": "https://i.ytimg.com/vi/2cS_vsLYTUo/mqdefault.jpg",
    "title": "【雑談】バンギャ界の意味不明謎ルールを暴露！？VTuber桐生ココの実録話。",
    "publishedAt": "2020-06-08T12:15:18Z"
  },
  {
    "videoId": "_GGUdcDnjTk",
    "thumbnail": "https://i.ytimg.com/vi/_GGUdcDnjTk/mqdefault.jpg",
    "title": "楽しくみんなで歌いましょう！！！Let's sing together MFs",
    "publishedAt": "2020-06-08T17:08:48Z"
  },
  {
    "videoId": "f5S_0sNBFsk",
    "thumbnail": "https://i.ytimg.com/vi/f5S_0sNBFsk/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月9日【#ココここ】",
    "publishedAt": "2020-06-08T21:24:45Z"
  },
  {
    "videoId": "y5MrqcFEcaM",
    "thumbnail": "https://i.ytimg.com/vi/y5MrqcFEcaM/mqdefault.jpg",
    "title": "【Sims4】妄想ホロライブハウス建築！各自配信部屋に着手！！#桐生ココ VTuber",
    "publishedAt": "2020-06-09T10:07:57Z"
  },
  {
    "videoId": "vLJOd2RD8f8",
    "thumbnail": "https://i.ytimg.com/vi/vLJOd2RD8f8/mqdefault.jpg",
    "title": "女子生活向上委員会！有識視聴者に聞いた【こんな野郎には近づくな】特集！VTuber 桐生ココ",
    "publishedAt": "2020-06-09T16:56:33Z"
  },
  {
    "videoId": "vXO2hc0JO0Q",
    "thumbnail": "https://i.ytimg.com/vi/vXO2hc0JO0Q/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月10日【#ココここ】",
    "publishedAt": "2020-06-09T21:25:05Z"
  },
  {
    "videoId": "jMGQIGTJbMs",
    "thumbnail": "https://i.ytimg.com/vi/jMGQIGTJbMs/mqdefault.jpg",
    "title": "【BAR COCO】謎に包まれたママが経営する不思議なBARに、今日も初見のお客さんが・・・",
    "publishedAt": "2020-06-10T17:40:07Z"
  },
  {
    "videoId": "JxkDXEYlg9I",
    "thumbnail": "https://i.ytimg.com/vi/JxkDXEYlg9I/mqdefault.jpg",
    "title": "【DYING:Reborn】魚男の恐怖！余裕でサクサクやったるホラゲ #桐生ココ",
    "publishedAt": "2020-06-11T16:53:46Z"
  },
  {
    "videoId": "C4E96OfUUY4",
    "thumbnail": "https://i.ytimg.com/vi/C4E96OfUUY4/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月12日【#ココここ】",
    "publishedAt": "2020-06-11T21:26:33Z"
  },
  {
    "videoId": "mQawriRdXro",
    "thumbnail": "https://i.ytimg.com/vi/mQawriRdXro/mqdefault.jpg",
    "title": "軽率にうた枠！練習がんばるの！",
    "publishedAt": "2020-06-12T10:40:28Z"
  },
  {
    "videoId": "7A3Zqp3ZHr4",
    "thumbnail": "https://i.ytimg.com/vi/7A3Zqp3ZHr4/mqdefault.jpg",
    "title": "【#桐生ココ】ホロARK新章！！Crystal Isles はじまる！【#とまらないARK】",
    "publishedAt": "2020-06-12T12:57:47Z"
  },
  {
    "videoId": "XFIsu834q6o",
    "thumbnail": "https://i.ytimg.com/vi/XFIsu834q6o/mqdefault.jpg",
    "title": "今週の反省会っ！！と言いながら呑み雑談するんじゃろ？",
    "publishedAt": "2020-06-12T19:26:26Z"
  },
  {
    "videoId": "-d1w5upCPqc",
    "thumbnail": "https://i.ytimg.com/vi/-d1w5upCPqc/mqdefault.jpg",
    "title": "【急募】毎週遊びに来る親戚にやんわり”来んな”と伝える方法",
    "publishedAt": "2020-06-13T18:07:55Z"
  },
  {
    "videoId": "-5bMrCju9QQ",
    "thumbnail": "https://i.ytimg.com/vi/-5bMrCju9QQ/mqdefault.jpg",
    "title": "【ガチ恋】桐生ココと田舎町デート。【#NOSTALGIC TRAIN】",
    "publishedAt": "2020-06-14T07:07:52Z"
  },
  {
    "videoId": "qgIFd6sDrJ8",
    "thumbnail": "https://i.ytimg.com/vi/qgIFd6sDrJ8/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月15日【#ココここ】",
    "publishedAt": "2020-06-14T21:27:44Z"
  },
  {
    "videoId": "AkB7vtqGPGI",
    "thumbnail": "https://i.ytimg.com/vi/AkB7vtqGPGI/mqdefault.jpg",
    "title": "【#みこここ】ARK新MAPで新生活！！協力して生活だぁ！【#とまらないARK】",
    "publishedAt": "2020-06-15T13:02:02Z"
  },
  {
    "videoId": "1BYG1bMe-w0",
    "thumbnail": "https://i.ytimg.com/vi/1BYG1bMe-w0/mqdefault.jpg",
    "title": "【#桐生ココ】激痛永久脱毛も振動マシン乗った時のかゆみでマシになる説【#ココここ】",
    "publishedAt": "2020-06-15T14:16:02Z"
  },
  {
    "videoId": "ZolOBKRH7t8",
    "thumbnail": "https://i.ytimg.com/vi/ZolOBKRH7t8/mqdefault.jpg",
    "title": "【雑談】反省会・・何が悪いのだろう・・",
    "publishedAt": "2020-06-15T17:37:56Z"
  },
  {
    "videoId": "i9n0dOxEwdQ",
    "thumbnail": "https://i.ytimg.com/vi/i9n0dOxEwdQ/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月16日【#ココここ】",
    "publishedAt": "2020-06-15T21:26:46Z"
  },
  {
    "videoId": "wRHZZwXNYgE",
    "thumbnail": "https://i.ytimg.com/vi/wRHZZwXNYgE/mqdefault.jpg",
    "title": "【#ホロARK最終決戦】死んだら即終了！さよならアベレーション最後の戦い！【#とまらないARK】",
    "publishedAt": "2020-06-16T14:19:46Z"
  },
  {
    "videoId": "ezMiRezzaPc",
    "thumbnail": "https://i.ytimg.com/vi/ezMiRezzaPc/mqdefault.jpg",
    "title": "桐生ココ40万人記念＆お誕生日を一緒にカウントダウン！お祝いだ！",
    "publishedAt": "2020-06-16T15:57:29Z"
  },
  {
    "videoId": "cRLuBjH0XAU",
    "thumbnail": "https://i.ytimg.com/vi/cRLuBjH0XAU/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月17日【#ココここ】",
    "publishedAt": "2020-06-16T21:27:53Z"
  },
  {
    "videoId": "KpduGHV1GWo",
    "thumbnail": "https://i.ytimg.com/vi/KpduGHV1GWo/mqdefault.jpg",
    "title": "【作業ARK】拠点をつくれ！原始人卒業だ！【#とまらないARK】",
    "publishedAt": "2020-06-17T13:30:46Z"
  },
  {
    "videoId": "-J7QLibOWkA",
    "thumbnail": "https://i.ytimg.com/vi/-J7QLibOWkA/mqdefault.jpg",
    "title": "【#桐生ココ爆誕祭】お誕生日記念！プレゼント凸待ち！【ホロライブ】",
    "publishedAt": "2020-06-17T14:32:56Z"
  },
  {
    "videoId": "rAcXam8hdVA",
    "thumbnail": "https://i.ytimg.com/vi/rAcXam8hdVA/mqdefault.jpg",
    "title": "ちょっとだけ寝る前にはなしますの",
    "publishedAt": "2020-06-17T17:44:17Z"
  },
  {
    "videoId": "EJD58o_HDJI",
    "thumbnail": "https://i.ytimg.com/vi/EJD58o_HDJI/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月18日【#ココここ】",
    "publishedAt": "2020-06-17T21:26:17Z"
  },
  {
    "videoId": "2rizVm0qwtw",
    "thumbnail": "https://i.ytimg.com/vi/2rizVm0qwtw/mqdefault.jpg",
    "title": "【#妄想ホロライブハウス】同居人・妄想天使の配信部屋を作成せよ！【#Sims4】",
    "publishedAt": "2020-06-18T11:40:38Z"
  },
  {
    "videoId": "BZwLGKvwRt4",
    "thumbnail": "https://i.ytimg.com/vi/BZwLGKvwRt4/mqdefault.jpg",
    "title": "【作業ARK】とにかく、生きる。家を、作る。【#とまらないARK】",
    "publishedAt": "2020-06-18T14:00:04Z"
  },
  {
    "videoId": "BAlZWd4bmM8",
    "thumbnail": "https://i.ytimg.com/vi/BAlZWd4bmM8/mqdefault.jpg",
    "title": "【DYING:Reborn】#2キッチンの恐怖…ビビらせてみろ！脱出ホラゲ！#桐生ココ",
    "publishedAt": "2020-06-18T19:07:39Z"
  },
  {
    "videoId": "8VbxJaxMcjU",
    "thumbnail": "https://i.ytimg.com/vi/8VbxJaxMcjU/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月19日【#ココここ】",
    "publishedAt": "2020-06-18T21:25:51Z"
  },
  {
    "videoId": "jQGzzJh4z1E",
    "thumbnail": "https://i.ytimg.com/vi/jQGzzJh4z1E/mqdefault.jpg",
    "title": "【#妄想ホロライブハウス】疲れた時の癒し！疲労回復部屋を建築せよ！【#Sims4】",
    "publishedAt": "2020-06-20T15:14:17Z"
  },
  {
    "videoId": "3otIrtGGQQE",
    "thumbnail": "https://i.ytimg.com/vi/3otIrtGGQQE/mqdefault.jpg",
    "title": "どうしても話したいので深夜雑談開催してもいいですか？",
    "publishedAt": "2020-06-20T20:33:17Z"
  },
  {
    "videoId": "xroq-LzDLcY",
    "thumbnail": "https://i.ytimg.com/vi/xroq-LzDLcY/mqdefault.jpg",
    "title": "【感謝枠】プレゼントやスパチャ、ありがとう！#桐生ココ",
    "publishedAt": "2020-06-21T11:52:47Z"
  },
  {
    "videoId": "RWsvPR7Hscw",
    "thumbnail": "https://i.ytimg.com/vi/RWsvPR7Hscw/mqdefault.jpg",
    "title": "ジュラシックワールド同時視聴！おうち映画デートじゃ！VTuber 桐生ココ",
    "publishedAt": "2020-06-21T16:39:48Z"
  },
  {
    "videoId": "pKxGB0C15rQ",
    "thumbnail": "https://i.ytimg.com/vi/pKxGB0C15rQ/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月22日【#ココここ】",
    "publishedAt": "2020-06-21T21:34:01Z"
  },
  {
    "videoId": "s5fpLjJIP1o",
    "thumbnail": "https://i.ytimg.com/vi/s5fpLjJIP1o/mqdefault.jpg",
    "title": "【#妄想ホロライブハウス】リッチな庭を整えて充実した生活を！【#Sims4】",
    "publishedAt": "2020-06-22T12:11:37Z"
  },
  {
    "videoId": "VnM9ih_GUXY",
    "thumbnail": "https://i.ytimg.com/vi/VnM9ih_GUXY/mqdefault.jpg",
    "title": "ゲームレベル3のAPEX！1試合で4桁ダメージを出したい！【VTuberの桐生ココ】",
    "publishedAt": "2020-06-22T15:07:13Z"
  },
  {
    "videoId": "kzmnIhPdkU8",
    "thumbnail": "https://i.ytimg.com/vi/kzmnIhPdkU8/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月23日【#ココここ】",
    "publishedAt": "2020-06-22T21:26:28Z"
  },
  {
    "videoId": "Hp8x5uiceIQ",
    "thumbnail": "https://i.ytimg.com/vi/Hp8x5uiceIQ/mqdefault.jpg",
    "title": "桐生ココ重大発表付き雑談！！！",
    "publishedAt": "2020-06-23T16:09:57Z"
  },
  {
    "videoId": "R0nOfXW21K8",
    "thumbnail": "https://i.ytimg.com/vi/R0nOfXW21K8/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月24日【#ココここ】",
    "publishedAt": "2020-06-23T21:24:56Z"
  },
  {
    "videoId": "7Yj4fR9Dh-s",
    "thumbnail": "https://i.ytimg.com/vi/7Yj4fR9Dh-s/mqdefault.jpg",
    "title": "【ARK】空飛ぶ家を作るんだ！！！！！【#とまらないARK】",
    "publishedAt": "2020-06-24T11:16:21Z"
  },
  {
    "videoId": "tg1jR0PfNeM",
    "thumbnail": "https://i.ytimg.com/vi/tg1jR0PfNeM/mqdefault.jpg",
    "title": "【歌枠】伸びしろしかないッ！！桐生ココと楽しく一緒に歌おう！",
    "publishedAt": "2020-06-24T15:19:24Z"
  },
  {
    "videoId": "LPCn9vm5HuY",
    "thumbnail": "https://i.ytimg.com/vi/LPCn9vm5HuY/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月25日【#ココここ】",
    "publishedAt": "2020-06-24T21:24:29Z"
  },
  {
    "videoId": "QtBULnu-IWw",
    "thumbnail": "https://i.ytimg.com/vi/QtBULnu-IWw/mqdefault.jpg",
    "title": "【ARK】空に住む、その夢をかなえるために。【#とまらないARK】",
    "publishedAt": "2020-06-25T12:57:18Z"
  },
  {
    "videoId": "1x1W_oJwpf0",
    "thumbnail": "https://i.ytimg.com/vi/1x1W_oJwpf0/mqdefault.jpg",
    "title": "【勝利会見】圧勝したぜやったー！ほめてください！！！",
    "publishedAt": "2020-06-25T17:57:42Z"
  },
  {
    "videoId": "bTZV-vgy2bE",
    "thumbnail": "https://i.ytimg.com/vi/bTZV-vgy2bE/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月26日【#ココここ】",
    "publishedAt": "2020-06-25T21:26:51Z"
  },
  {
    "videoId": "TYRLTeVdjC0",
    "thumbnail": "https://i.ytimg.com/vi/TYRLTeVdjC0/mqdefault.jpg",
    "title": "【ARK】トロペオちゃんをテイムしたい！！！！【#とまらないARK】",
    "publishedAt": "2020-06-26T10:37:05Z"
  },
  {
    "videoId": "uRb1MPPz7IQ",
    "thumbnail": "https://i.ytimg.com/vi/uRb1MPPz7IQ/mqdefault.jpg",
    "title": "命のたまごを優しく守るゲーム。egg is broken. heart is too.",
    "publishedAt": "2020-06-26T17:21:01Z"
  },
  {
    "videoId": "9a7_lq72xlk",
    "thumbnail": "https://i.ytimg.com/vi/9a7_lq72xlk/mqdefault.jpg",
    "title": "【#桐生ココ3D】桐生ココ3Dお披露目！#ホロふぉーす始動！ 【#JointhefutureJP】",
    "publishedAt": "2020-06-27T13:06:14Z"
  },
  {
    "videoId": "TQCzBVUEpy4",
    "thumbnail": "https://i.ytimg.com/vi/TQCzBVUEpy4/mqdefault.jpg",
    "title": "【#桐生ココ3D振り返り】3Dお披露目お疲れさ・・・え！ムービードスはまずいっすよ！",
    "publishedAt": "2020-06-28T09:01:30Z"
  },
  {
    "videoId": "D5aK9sR2pZA",
    "thumbnail": "https://i.ytimg.com/vi/D5aK9sR2pZA/mqdefault.jpg",
    "title": "【#桐生ココ】デビュー半年記念！初配信同時視聴で振り返り・・・【うわぁぁぁ】",
    "publishedAt": "2020-06-28T14:53:58Z"
  },
  {
    "videoId": "3YXI583Bl3o",
    "thumbnail": "https://i.ytimg.com/vi/3YXI583Bl3o/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月29日【#ココここ】",
    "publishedAt": "2020-06-28T21:27:42Z"
  },
  {
    "videoId": "gIqxMwnUtiA",
    "thumbnail": "https://i.ytimg.com/vi/gIqxMwnUtiA/mqdefault.jpg",
    "title": "The Evil Within 2 【精神的恐怖の世界へ】サイコブレイク２",
    "publishedAt": "2020-06-29T18:03:41Z"
  },
  {
    "videoId": "YfibSE3P5Ig",
    "thumbnail": "https://i.ytimg.com/vi/YfibSE3P5Ig/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！6月30日【#ココここ】",
    "publishedAt": "2020-06-29T21:26:47Z"
  },
  {
    "videoId": "txo92QUk4Ow",
    "thumbnail": "https://i.ytimg.com/vi/txo92QUk4Ow/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！7月1日【#ココここ】",
    "publishedAt": "2020-06-30T21:26:59Z"
  },
  {
    "videoId": "jox89zWmK5Y",
    "thumbnail": "https://i.ytimg.com/vi/jox89zWmK5Y/mqdefault.jpg",
    "title": "#2 The Evil Within 2 【精神世界へ娘を探すパパ】サイコブレイク２",
    "publishedAt": "2020-07-01T03:18:13Z"
  },
  {
    "videoId": "cAY_GfnNuwU",
    "thumbnail": "https://i.ytimg.com/vi/cAY_GfnNuwU/mqdefault.jpg",
    "title": "【#桐生ココ】勝手に英訳したSSSを勝手に全部解説！【#ココここ】",
    "publishedAt": "2020-07-01T16:42:07Z"
  },
  {
    "videoId": "1ae9Zdv14TQ",
    "thumbnail": "https://i.ytimg.com/vi/1ae9Zdv14TQ/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！7月2日【#ココここ】",
    "publishedAt": "2020-07-01T21:25:28Z"
  },
  {
    "videoId": "UDu93lzNWe4",
    "thumbnail": "https://i.ytimg.com/vi/UDu93lzNWe4/mqdefault.jpg",
    "title": "#3 The Evil Within 2 【瞬間移動ジジイを倒せ】サイコブレイク２",
    "publishedAt": "2020-07-02T00:15:49Z"
  },
  {
    "videoId": "zXLLkR9USDI",
    "thumbnail": "https://i.ytimg.com/vi/zXLLkR9USDI/mqdefault.jpg",
    "title": "【#ARKSurvivalEvolved】トロペオで空を爆走！！ワイバン卵を盗むぜ！【#とまらないARK】",
    "publishedAt": "2020-07-02T15:34:48Z"
  },
  {
    "videoId": "R5BjQipbOYU",
    "thumbnail": "https://i.ytimg.com/vi/R5BjQipbOYU/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！7月3日【#ココここ】",
    "publishedAt": "2020-07-02T21:27:02Z"
  },
  {
    "videoId": "M6VGrK-_KpE",
    "thumbnail": "https://i.ytimg.com/vi/M6VGrK-_KpE/mqdefault.jpg",
    "title": "#4 The Evil Within 2 【変態芸術家を弱らせる】サイコブレイク２",
    "publishedAt": "2020-07-03T01:20:22Z"
  },
  {
    "videoId": "3uZXjqSD5WQ",
    "thumbnail": "https://i.ytimg.com/vi/3uZXjqSD5WQ/mqdefault.jpg",
    "title": "【#ARKSurvivalEvolved】水着だ！花火だ！夏イベエンジョイ！【#とまらないARK】",
    "publishedAt": "2020-07-03T19:13:05Z"
  },
  {
    "videoId": "S0Awp5Wzgp0",
    "thumbnail": "https://i.ytimg.com/vi/S0Awp5Wzgp0/mqdefault.jpg",
    "title": "伸びしろを感じるッ！歌枠ッ！#桐生ココ",
    "publishedAt": "2020-07-04T12:52:42Z"
  },
  {
    "videoId": "MMQRx4pKUho",
    "thumbnail": "https://i.ytimg.com/vi/MMQRx4pKUho/mqdefault.jpg",
    "title": "初代ジュラシックパーク同時視聴！おうち映画デートしよ！VTuber 桐生ココ",
    "publishedAt": "2020-07-04T17:11:16Z"
  },
  {
    "videoId": "rNij1w5Rqak",
    "thumbnail": "https://i.ytimg.com/vi/rNij1w5Rqak/mqdefault.jpg",
    "title": "みかじめ雑談～地獄の週末編～",
    "publishedAt": "2020-07-05T16:26:22Z"
  },
  {
    "videoId": "s7FFQOP2rHk",
    "thumbnail": "https://i.ytimg.com/vi/s7FFQOP2rHk/mqdefault.jpg",
    "title": "【#桐生ココ】新あさココLIVE(ver.2.0)！7月6日【#ココここ】",
    "publishedAt": "2020-07-05T21:28:01Z"
  },
  {
    "videoId": "7x87M3lrWgI",
    "thumbnail": "https://i.ytimg.com/vi/7x87M3lrWgI/mqdefault.jpg",
    "title": "#5 The Evil Within 2 【変態芸術家の次は変態牧師！？】サイコブレイク２",
    "publishedAt": "2020-07-06T01:38:57Z"
  },
  {
    "videoId": "wkl17vtHVo8",
    "thumbnail": "https://i.ytimg.com/vi/wkl17vtHVo8/mqdefault.jpg",
    "title": "【#ARKSurvivalEvolved】ARK内夏祭りをしたい！テキ屋の準備編！【#とまらないARK】",
    "publishedAt": "2020-07-06T18:45:03Z"
  },
  {
    "videoId": "vGkhmA9eQXc",
    "thumbnail": "https://i.ytimg.com/vi/vGkhmA9eQXc/mqdefault.jpg",
    "title": "#4 IQ3500ドラゴンVTuber桐生ココのPORTAL2！",
    "publishedAt": "2020-07-07T17:55:01Z"
  },
  {
    "videoId": "zyx0yjCtNdU",
    "thumbnail": "https://i.ytimg.com/vi/zyx0yjCtNdU/mqdefault.jpg",
    "title": "【#ARKSurvivalEvolved】EXTINXTIONへ遠征！はく製がほしい！！【#とまらないARK】",
    "publishedAt": "2020-07-08T11:18:40Z"
  },
  {
    "videoId": "cTh21wVoPiU",
    "thumbnail": "https://i.ytimg.com/vi/cTh21wVoPiU/mqdefault.jpg",
    "title": "登録者45万人ありがとう！感謝の気持ちを歌と伸びしろで表す！！#桐生ココ",
    "publishedAt": "2020-07-08T18:31:19Z"
  },
  {
    "videoId": "30f3_DMQDt4",
    "thumbnail": "https://i.ytimg.com/vi/30f3_DMQDt4/mqdefault.jpg",
    "title": "【#桐生ココ】テキ屋ココ！ARK夏祭り会場を設営！【#とまらないARK】",
    "publishedAt": "2020-07-09T13:17:17Z"
  },
  {
    "videoId": "Cvp4qzil7IE",
    "thumbnail": "https://i.ytimg.com/vi/Cvp4qzil7IE/mqdefault.jpg",
    "title": "【#妄想ホロライブハウス】生活編！ホロハウスの経済を守れ！【#Sims4】",
    "publishedAt": "2020-07-10T15:08:43Z"
  },
  {
    "videoId": "vuIcc-6Vhwo",
    "thumbnail": "https://i.ytimg.com/vi/vuIcc-6Vhwo/mqdefault.jpg",
    "title": "BAR COCO…開店…(まったり雑談です)",
    "publishedAt": "2020-07-10T22:11:18Z"
  },
  {
    "videoId": "s-OgsOXiKFE",
    "thumbnail": "https://i.ytimg.com/vi/s-OgsOXiKFE/mqdefault.jpg",
    "title": "【#桐生ココの怖い話】ASMR怪談話‥‥【ヘッドホン推奨】",
    "publishedAt": "2020-07-11T13:06:11Z"
  },
  {
    "videoId": "CxBacnJJRL4",
    "thumbnail": "https://i.ytimg.com/vi/CxBacnJJRL4/mqdefault.jpg",
    "title": "【#7dtd】怖くて見れない、知らない自分の姿【#桐生ココ】",
    "publishedAt": "2020-07-12T06:55:00Z"
  },
  {
    "videoId": "feqCYoYYHI0",
    "thumbnail": "https://i.ytimg.com/vi/feqCYoYYHI0/mqdefault.jpg",
    "title": "ゲームレベル4のAPEX！スナイパーを目指したい！！【VTuberの桐生ココ】",
    "publishedAt": "2020-07-13T08:42:05Z"
  },
  {
    "videoId": "sTEwp_gFPpA",
    "thumbnail": "https://i.ytimg.com/vi/sTEwp_gFPpA/mqdefault.jpg",
    "title": "出来ていなかった分のお礼＆まったり雑談",
    "publishedAt": "2020-07-13T17:48:34Z"
  },
  {
    "videoId": "v20qZl5u9xc",
    "thumbnail": "https://i.ytimg.com/vi/v20qZl5u9xc/mqdefault.jpg",
    "title": "【#桐生ココ】画質向上！やっと2PCで配信じゃい！【#とまらないARK】",
    "publishedAt": "2020-07-15T12:27:33Z"
  },
  {
    "videoId": "xBejn0RlfV8",
    "thumbnail": "https://i.ytimg.com/vi/xBejn0RlfV8/mqdefault.jpg",
    "title": "【#たまココ脱毛】激痛脱毛も2人でやれば痛み分散する説",
    "publishedAt": "2020-07-15T14:09:38Z"
  },
  {
    "videoId": "WTlyGbwo3Mc",
    "thumbnail": "https://i.ytimg.com/vi/WTlyGbwo3Mc/mqdefault.jpg",
    "title": "まったり、お休み中にあったことなど雑談しましょ。",
    "publishedAt": "2020-07-17T17:56:41Z"
  },
  {
    "videoId": "vZ68rrQV0aM",
    "thumbnail": "https://i.ytimg.com/vi/vZ68rrQV0aM/mqdefault.jpg",
    "title": "【DYING:Reborn】#3 通気口を抜けて…ついに出会うか！？魚男！#桐生ココ",
    "publishedAt": "2020-07-18T12:11:36Z"
  },
  {
    "videoId": "bh78v2Ey_xo",
    "thumbnail": "https://i.ytimg.com/vi/bh78v2Ey_xo/mqdefault.jpg",
    "title": "【#桐生ココ】卵運搬RTA！！！1時間以内に1面クリア！【egg is broken. heart is too.】",
    "publishedAt": "2020-07-19T02:07:23Z"
  },
  {
    "videoId": "_iPfuJG0sZo",
    "thumbnail": "https://i.ytimg.com/vi/_iPfuJG0sZo/mqdefault.jpg",
    "title": "スパチャのお礼枠です！",
    "publishedAt": "2020-07-19T17:15:55Z"
  },
  {
    "videoId": "LYS7ZTyMtf4",
    "thumbnail": "https://i.ytimg.com/vi/LYS7ZTyMtf4/mqdefault.jpg",
    "title": "【#桐生ココ】高レベルを探せ！マナガルムテイム！(2PC配信だよ！)【#とまらないARK】",
    "publishedAt": "2020-07-19T17:57:44Z"
  },
  {
    "videoId": "Uqpib8zRGGs",
    "thumbnail": "https://i.ytimg.com/vi/Uqpib8zRGGs/mqdefault.jpg",
    "title": "【#桐生ココ】謎ホラゲ・・・ぴえん・・・【#PIEN】",
    "publishedAt": "2020-07-20T13:30:53Z"
  },
  {
    "videoId": "XqBaMgD19N4",
    "thumbnail": "https://i.ytimg.com/vi/XqBaMgD19N4/mqdefault.jpg",
    "title": "【#桐生ココ】クロスARKせいかつ。(2PC配信だよ！)【#とまらないARK】",
    "publishedAt": "2020-07-20T16:18:54Z"
  },
  {
    "videoId": "DEz6_UnkNPU",
    "thumbnail": "https://i.ytimg.com/vi/DEz6_UnkNPU/mqdefault.jpg",
    "title": "和製ホラーゲーム！！Missing Children | 行方不明を初見プレイ！VTuber 桐生ココ",
    "publishedAt": "2020-07-21T16:41:25Z"
  },
  {
    "videoId": "9d6ycvo-aJA",
    "thumbnail": "https://i.ytimg.com/vi/9d6ycvo-aJA/mqdefault.jpg",
    "title": "【#桐生ココ】初めての壺おじ【#Gettingoverit】",
    "publishedAt": "2020-07-22T15:30:32Z"
  },
  {
    "videoId": "PpxKf7trW9w",
    "thumbnail": "https://i.ytimg.com/vi/PpxKf7trW9w/mqdefault.jpg",
    "title": "【#桐生ココ】予備知識ゼロからはじめるマイクラ生活！【なんもわからん】",
    "publishedAt": "2020-07-23T15:46:41Z"
  },
  {
    "videoId": "tTyLbWrGKNs",
    "thumbnail": "https://i.ytimg.com/vi/tTyLbWrGKNs/mqdefault.jpg",
    "title": "海外ホロライブファンよ、お前らの行動はバレている",
    "publishedAt": "2020-07-24T04:03:11Z"
  },
  {
    "videoId": "sgcoyPcw50k",
    "thumbnail": "https://i.ytimg.com/vi/sgcoyPcw50k/mqdefault.jpg",
    "title": "スーパーチャットお読みする感謝の枠です！",
    "publishedAt": "2020-07-24T10:01:25Z"
  },
  {
    "videoId": "69mhTtfhVio",
    "thumbnail": "https://i.ytimg.com/vi/69mhTtfhVio/mqdefault.jpg",
    "title": "【雀魂】初めての麻雀配信！少しはわかるけど、初めからやってみよう！桐生ココ",
    "publishedAt": "2020-07-24T12:10:32Z"
  },
  {
    "videoId": "5FtqR7oRTJA",
    "thumbnail": "https://i.ytimg.com/vi/5FtqR7oRTJA/mqdefault.jpg",
    "title": "【#桐生ココ】びっくりポイントはもうわかってるぜ夜勤事件【かかってこいや】",
    "publishedAt": "2020-07-24T14:48:28Z"
  },
  {
    "videoId": "Pq8Us9f8d1M",
    "thumbnail": "https://i.ytimg.com/vi/Pq8Us9f8d1M/mqdefault.jpg",
    "title": "【#妄想ホロライブハウス】ニートが食って寝てを繰り返した結果・・・！【#Sims4】",
    "publishedAt": "2020-07-25T12:23:34Z"
  },
  {
    "videoId": "_oJZg2p-HHA",
    "thumbnail": "https://i.ytimg.com/vi/_oJZg2p-HHA/mqdefault.jpg",
    "title": "【World of Warships】アズールレーンWoWsコラボだい！！！【桐生ココ/ホロライブ4期生】",
    "publishedAt": "2020-07-25T14:29:13Z"
  },
  {
    "videoId": "2-zb2AJATnc",
    "thumbnail": "https://i.ytimg.com/vi/2-zb2AJATnc/mqdefault.jpg",
    "title": "桐生ココの伸びしろ歌枠！日本の曲限定で歌う！",
    "publishedAt": "2020-07-26T18:19:52Z"
  },
  {
    "videoId": "9vG-4Pw3IhU",
    "thumbnail": "https://i.ytimg.com/vi/9vG-4Pw3IhU/mqdefault.jpg",
    "title": "【#桐生ココ】建築、繁殖、そしてついにスコーチドアースへ！【#とまらないARK】",
    "publishedAt": "2020-07-27T14:47:10Z"
  },
  {
    "videoId": "EQnIg2_MWGg",
    "thumbnail": "https://i.ytimg.com/vi/EQnIg2_MWGg/mqdefault.jpg",
    "title": "【#桐生ココ】最近のこと！雑談しましょうみなさんで！【だらだら雑談枠】",
    "publishedAt": "2020-07-28T12:09:59Z"
  },
  {
    "videoId": "QIKbBPU5qG0",
    "thumbnail": "https://i.ytimg.com/vi/QIKbBPU5qG0/mqdefault.jpg",
    "title": "【#かなココARK】砂漠攻略のために、準備せよ！【#とまらないARK】",
    "publishedAt": "2020-07-28T18:04:02Z"
  },
  {
    "videoId": "5rYcQjZiN_I",
    "thumbnail": "https://i.ytimg.com/vi/5rYcQjZiN_I/mqdefault.jpg",
    "title": "【#桐生ココ】農業開始！天空城を彩るために・・・！【#とまらないARK】",
    "publishedAt": "2020-07-29T12:38:41Z"
  },
  {
    "videoId": "YURh1p7oKEA",
    "thumbnail": "https://i.ytimg.com/vi/YURh1p7oKEA/mqdefault.jpg",
    "title": "皆さんに感謝をする時間。",
    "publishedAt": "2020-07-29T17:11:01Z"
  },
  {
    "videoId": "gnYLxwCkb-k",
    "thumbnail": "https://i.ytimg.com/vi/gnYLxwCkb-k/mqdefault.jpg",
    "title": "【#桐生ココ】麻雀の役を覚えたい！まったり練習【雀魂】",
    "publishedAt": "2020-07-30T11:38:51Z"
  },
  {
    "videoId": "6BPEY1Z9l0M",
    "thumbnail": "https://i.ytimg.com/vi/6BPEY1Z9l0M/mqdefault.jpg",
    "title": "【#桐生ココ】PPD雑談【パパドラゴン暴走中】",
    "publishedAt": "2020-08-01T16:17:49Z"
  },
  {
    "videoId": "IWSPX9FJpXA",
    "thumbnail": "https://i.ytimg.com/vi/IWSPX9FJpXA/mqdefault.jpg",
    "title": "海外ホロライブファンめ、またやったな reddit meme review",
    "publishedAt": "2020-08-02T02:58:50Z"
  },
  {
    "videoId": "CluLRRz4usM",
    "thumbnail": "https://i.ytimg.com/vi/CluLRRz4usM/mqdefault.jpg",
    "title": "【#はあココPORTAL2】名作ポータル2！！協力頭脳プレイじゃい！！",
    "publishedAt": "2020-08-02T08:02:18Z"
  },
  {
    "videoId": "hA6WnL7erk0",
    "thumbnail": "https://i.ytimg.com/vi/hA6WnL7erk0/mqdefault.jpg",
    "title": "【#桐生ココ】激アツ海上戦！World of Warships！！【#WoWs】",
    "publishedAt": "2020-08-02T17:06:51Z"
  },
  {
    "videoId": "kqHTeyHV5xU",
    "thumbnail": "https://i.ytimg.com/vi/kqHTeyHV5xU/mqdefault.jpg",
    "title": "【#桐生ココ】50万人カウントダウン緊急ゲリラ歌枠",
    "publishedAt": "2020-08-03T04:14:46Z"
  },
  {
    "videoId": "mfdrEMOXtJA",
    "thumbnail": "https://i.ytimg.com/vi/mfdrEMOXtJA/mqdefault.jpg",
    "title": "【#桐生ココ】なにもわからない初心者のマイクラ【なんもわからん】",
    "publishedAt": "2020-08-03T16:45:33Z"
  },
  {
    "videoId": "JWNZxuMaZhs",
    "thumbnail": "https://i.ytimg.com/vi/JWNZxuMaZhs/mqdefault.jpg",
    "title": "【#桐生ココ】卵運搬RTA！！1時間以内に2面クリア！【egg is broken. heart is too.】",
    "publishedAt": "2020-08-04T16:21:51Z"
  },
  {
    "videoId": "7zafxGmwmIo",
    "thumbnail": "https://i.ytimg.com/vi/7zafxGmwmIo/mqdefault.jpg",
    "title": "【#桐生ココ】視聴者参加型！ガチンコ勝負で1位目指す！【雀魂】",
    "publishedAt": "2020-08-05T06:52:06Z"
  },
  {
    "videoId": "dkI3zXpQEgs",
    "thumbnail": "https://i.ytimg.com/vi/dkI3zXpQEgs/mqdefault.jpg",
    "title": "【#桐生ココ】２回目の壺おじで難所を超えたる【#Gettingoverit】",
    "publishedAt": "2020-08-05T18:22:15Z"
  },
  {
    "videoId": "D3Am7jKBCng",
    "thumbnail": "https://i.ytimg.com/vi/D3Am7jKBCng/mqdefault.jpg",
    "title": "【#桐生ココ】いざ！ホロ視聴者サーバーへ！【#とまらないARK】",
    "publishedAt": "2020-08-06T16:03:29Z"
  },
  {
    "videoId": "CqNTi1Xmydg",
    "thumbnail": "https://i.ytimg.com/vi/CqNTi1Xmydg/mqdefault.jpg",
    "title": "【雑談】今日のすごいことあったんだ聞いて・・・！【#桐生ココ】",
    "publishedAt": "2020-08-07T16:12:40Z"
  },
  {
    "videoId": "ItSjTYgUuOo",
    "thumbnail": "https://i.ytimg.com/vi/ItSjTYgUuOo/mqdefault.jpg",
    "title": "【#桐生ココ】ランダム戦を蹂躙する！かかってこい！【#WoWs】",
    "publishedAt": "2020-08-08T11:10:17Z"
  },
  {
    "videoId": "hlU_nWxPDhI",
    "thumbnail": "https://i.ytimg.com/vi/hlU_nWxPDhI/mqdefault.jpg",
    "title": "Are ya SHITPOSTING son?? / Reddit MEME review",
    "publishedAt": "2020-08-09T02:58:50Z"
  },
  {
    "videoId": "rRCFiefXUXY",
    "thumbnail": "https://i.ytimg.com/vi/rRCFiefXUXY/mqdefault.jpg",
    "title": "祝★入居★ココを簡易ホロライブハウスとする。",
    "publishedAt": "2020-08-10T14:56:36Z"
  },
  {
    "videoId": "ZNMnDD66ux4",
    "thumbnail": "https://i.ytimg.com/vi/ZNMnDD66ux4/mqdefault.jpg",
    "title": "【#桐生ココ】ランプ越えたんで壺上層階とか余裕なのですね",
    "publishedAt": "2020-08-11T14:16:10Z"
  },
  {
    "videoId": "gb9qAFkRLT4",
    "thumbnail": "https://i.ytimg.com/vi/gb9qAFkRLT4/mqdefault.jpg",
    "title": "ストレスの発散のいい方法を教えよう、歌さ！",
    "publishedAt": "2020-08-11T18:56:10Z"
  },
  {
    "videoId": "-7jmkQDXb2Y",
    "thumbnail": "https://i.ytimg.com/vi/-7jmkQDXb2Y/mqdefault.jpg",
    "title": "【#ARK】スコーチドアース全洞窟攻略RTA with天音かなた/アキロゼ/癒月ちょこ",
    "publishedAt": "2020-08-12T16:36:45Z"
  },
  {
    "videoId": "dAteKWOKTOw",
    "thumbnail": "https://i.ytimg.com/vi/dAteKWOKTOw/mqdefault.jpg",
    "title": "【#いながわココじ】初心者麻雀！高い点数の役をめざして！【#雀魂】",
    "publishedAt": "2020-08-13T11:59:50Z"
  },
  {
    "videoId": "MhDOaynWH8Q",
    "thumbnail": "https://i.ytimg.com/vi/MhDOaynWH8Q/mqdefault.jpg",
    "title": "【#桐生ココ】カニノケンカでガチファイト【大乱闘】",
    "publishedAt": "2020-08-13T17:13:55Z"
  },
  {
    "videoId": "Mgea4k_ir5Y",
    "thumbnail": "https://i.ytimg.com/vi/Mgea4k_ir5Y/mqdefault.jpg",
    "title": "【#桐生ココ】地獄耐久に備える！まったり準備作業雑談【#とまらないARK】",
    "publishedAt": "2020-08-14T21:31:50Z"
  },
  {
    "videoId": "u3wO7wY14lM",
    "thumbnail": "https://i.ytimg.com/vi/u3wO7wY14lM/mqdefault.jpg",
    "title": "I KNOW YOU WANT THIS / Reddit MEME review",
    "publishedAt": "2020-08-16T04:09:38Z"
  },
  {
    "videoId": "809wiuXtFKY",
    "thumbnail": "https://i.ytimg.com/vi/809wiuXtFKY/mqdefault.jpg",
    "title": "【#桐生ココ】Fall Guys初プレイ！",
    "publishedAt": "2020-08-16T17:54:36Z"
  },
  {
    "videoId": "AWl5xCFBXEw",
    "thumbnail": "https://i.ytimg.com/vi/AWl5xCFBXEw/mqdefault.jpg",
    "title": "【#桐生ココ】BAR COCO開店～悩める大人の憩いの場～",
    "publishedAt": "2020-08-17T16:23:15Z"
  },
  {
    "videoId": "CjZ6KMULOb4",
    "thumbnail": "https://i.ytimg.com/vi/CjZ6KMULOb4/mqdefault.jpg",
    "title": "【#Fall Guys】めんたいココ、TOPへのたび【#桐生ココ】",
    "publishedAt": "2020-08-18T13:49:20Z"
  },
  {
    "videoId": "2rOsa2StCAg",
    "thumbnail": "https://i.ytimg.com/vi/2rOsa2StCAg/mqdefault.jpg",
    "title": "【#いながわココじの怖い話】ASMR怪談話‥其の二‥【ヘッドホン推奨】",
    "publishedAt": "2020-08-20T14:10:12Z"
  },
  {
    "videoId": "dwkrad77nOU",
    "thumbnail": "https://i.ytimg.com/vi/dwkrad77nOU/mqdefault.jpg",
    "title": "【#かなココ同居】引っ越し完了！緊急ざつだん！【#桐生ココ#天音かなた】",
    "publishedAt": "2020-08-20T16:08:12Z"
  },
  {
    "videoId": "iNjS1MIvb70",
    "thumbnail": "https://i.ytimg.com/vi/iNjS1MIvb70/mqdefault.jpg",
    "title": "【#桐生ココ】55万人記念緊急クエスト！FPS初心者⁉うるせぇ55キルしろ！【APEX】",
    "publishedAt": "2020-08-22T03:10:46Z"
  },
  {
    "videoId": "MvRBckns4nU",
    "thumbnail": "https://i.ytimg.com/vi/MvRBckns4nU/mqdefault.jpg",
    "title": "【#桐生ココ】ARKクリスタルアイルズ全恐竜集め耐久！【#とまらないARK】",
    "publishedAt": "2020-08-22T19:59:04Z"
  },
  {
    "videoId": "HSN24g8LDMQ",
    "thumbnail": "https://i.ytimg.com/vi/HSN24g8LDMQ/mqdefault.jpg",
    "title": "【#桐生ココ】ARKクリスタルアイルズ全恐竜集め耐久その２【#とまらないARK】",
    "publishedAt": "2020-08-23T15:20:34Z"
  },
  {
    "videoId": "l9WW65H2MYI",
    "thumbnail": "https://i.ytimg.com/vi/l9WW65H2MYI/mqdefault.jpg",
    "title": "SOMEONE DIDN'T STOP SHITPOSTING / Reddit MEME review#クソ#shit",
    "publishedAt": "2020-08-24T04:12:51Z"
  },
  {
    "videoId": "_wZB2vmqPuU",
    "thumbnail": "https://i.ytimg.com/vi/_wZB2vmqPuU/mqdefault.jpg",
    "title": "【#マリココ3D】船長、一緒に踊りましょう？【3D配信】",
    "publishedAt": "2020-08-24T13:01:51Z"
  },
  {
    "videoId": "7euDRog2k7k",
    "thumbnail": "https://i.ytimg.com/vi/7euDRog2k7k/mqdefault.jpg",
    "title": "【世界一雑談】世界一の女になった#桐生ココ【アルティメット感謝】",
    "publishedAt": "2020-08-25T13:15:05Z"
  },
  {
    "videoId": "HJwDlSX_9Zw",
    "thumbnail": "https://i.ytimg.com/vi/HJwDlSX_9Zw/mqdefault.jpg",
    "title": "【#桐生ココ】ARKクリスタルアイルズ全恐竜集め耐久その３【#とまらないARK】",
    "publishedAt": "2020-08-25T19:41:58Z"
  },
  {
    "videoId": "lR28nJWXayY",
    "thumbnail": "https://i.ytimg.com/vi/lR28nJWXayY/mqdefault.jpg",
    "title": "【#桐生ココ】ARKクリスタルアイルズ全恐竜集め耐久その４【#とまらないARK】",
    "publishedAt": "2020-08-26T23:54:19Z"
  },
  {
    "videoId": "sJ2cIyrM46s",
    "thumbnail": "https://i.ytimg.com/vi/sJ2cIyrM46s/mqdefault.jpg",
    "title": "【#桐生ココ#癒月ちょこ】ホロハウス女子会だぁ！【#天音かなた#アキロゼ】",
    "publishedAt": "2020-08-27T15:11:27Z"
  },
  {
    "videoId": "dyGt5580PYI",
    "thumbnail": "https://i.ytimg.com/vi/dyGt5580PYI/mqdefault.jpg",
    "title": "【#桐生ココ】世界一伸びしろを感じる歌枠",
    "publishedAt": "2020-08-28T15:07:11Z"
  },
  {
    "videoId": "Nbd42KJHQpQ",
    "thumbnail": "https://i.ytimg.com/vi/Nbd42KJHQpQ/mqdefault.jpg",
    "title": "【#桐生ココ】ARKクリスタルアイルズ全恐竜集め耐久その５【#とまらないARK】",
    "publishedAt": "2020-08-29T14:53:49Z"
  },
  {
    "videoId": "NKvXKpltIys",
    "thumbnail": "https://i.ytimg.com/vi/NKvXKpltIys/mqdefault.jpg",
    "title": "【#桐生ココ】ヤケ酒のココママ、みんなの鬱憤で気力回復を図る",
    "publishedAt": "2020-08-29T18:45:19Z"
  },
  {
    "videoId": "J0cMTULJSks",
    "thumbnail": "https://i.ytimg.com/vi/J0cMTULJSks/mqdefault.jpg",
    "title": "クソ投稿止まらず!!NON STOP SHITPOSTING / Reddit MEME review",
    "publishedAt": "2020-08-30T04:05:18Z"
  },
  {
    "videoId": "AvqeCDDm_Vg",
    "thumbnail": "https://i.ytimg.com/vi/AvqeCDDm_Vg/mqdefault.jpg",
    "title": "【#WoWS】World of Warshipsで視聴者参加型海戦！！【ホロライブ】",
    "publishedAt": "2020-08-30T13:29:22Z"
  },
  {
    "videoId": "UWiFPJr4cO4",
    "thumbnail": "https://i.ytimg.com/vi/UWiFPJr4cO4/mqdefault.jpg",
    "title": "【#Fall Guys】トップをとりたい！！！二人でだ！【#ロボココ】",
    "publishedAt": "2020-08-31T15:22:49Z"
  },
  {
    "videoId": "BoYkAOCMKN8",
    "thumbnail": "https://i.ytimg.com/vi/BoYkAOCMKN8/mqdefault.jpg",
    "title": "【#桐生ココ】ARKクリスタルアイルズ全恐竜集め耐久その６【#とまらないARK】",
    "publishedAt": "2020-08-31T22:26:16Z"
  },
  {
    "videoId": "kNQddErI6Q8",
    "thumbnail": "https://i.ytimg.com/vi/kNQddErI6Q8/mqdefault.jpg",
    "title": "【#カニノケンカ】孤独なカニの本気の戦い・・・！【#桐生ココ】",
    "publishedAt": "2020-09-02T10:15:08Z"
  },
  {
    "videoId": "_Mcv2B9gKno",
    "thumbnail": "https://i.ytimg.com/vi/_Mcv2B9gKno/mqdefault.jpg",
    "title": "【#桐生ココ】9月になったねぇ～雑談だねぇ～",
    "publishedAt": "2020-09-02T14:58:24Z"
  },
  {
    "videoId": "cEjYaAw1P-0",
    "thumbnail": "https://i.ytimg.com/vi/cEjYaAw1P-0/mqdefault.jpg",
    "title": "【#桐生ココ】ARKクリスタルアイルズ全恐竜集め耐久その７【#とまらないARK】",
    "publishedAt": "2020-09-02T23:03:03Z"
  },
  {
    "videoId": "h6i8Bmvzopc",
    "thumbnail": "https://i.ytimg.com/vi/h6i8Bmvzopc/mqdefault.jpg",
    "title": "【#FallGuys】そろそろ勝利が欲しい！..Am I winning dad?【#桐生ココ】",
    "publishedAt": "2020-09-03T15:57:16Z"
  },
  {
    "videoId": "QIbt7cMq6Fk",
    "thumbnail": "https://i.ytimg.com/vi/QIbt7cMq6Fk/mqdefault.jpg",
    "title": "【#MrPresident】SPココ宙を舞う！大統領を守れ！【＃桐生ココ】",
    "publishedAt": "2020-09-04T12:11:40Z"
  },
  {
    "videoId": "Wu6xTHpcgXo",
    "thumbnail": "https://i.ytimg.com/vi/Wu6xTHpcgXo/mqdefault.jpg",
    "title": "高級ベッドでお休み雑談・・・zzz　#桐生ココ",
    "publishedAt": "2020-09-04T17:54:01Z"
  },
  {
    "videoId": "QrLkcjb1yjM",
    "thumbnail": "https://i.ytimg.com/vi/QrLkcjb1yjM/mqdefault.jpg",
    "title": "ちょっとした全種テイム裏側",
    "publishedAt": "2020-09-05T10:23:16Z"
  },
  {
    "videoId": "9Pg9WRPN5Ro",
    "thumbnail": "https://i.ytimg.com/vi/9Pg9WRPN5Ro/mqdefault.jpg",
    "title": "【#桐生ココ】ARKクリスタルアイルズ全恐竜集め最終戦【#とまらないARK】",
    "publishedAt": "2020-09-05T17:58:03Z"
  },
  {
    "videoId": "gOY45tCOfvg",
    "thumbnail": "https://i.ytimg.com/vi/gOY45tCOfvg/mqdefault.jpg",
    "title": "またやってるぜクソ投稿！GOD u  guys never stop shitposting / Reddit MEME review",
    "publishedAt": "2020-09-06T04:18:06Z"
  },
  {
    "videoId": "fnagdqYiExA",
    "thumbnail": "https://i.ytimg.com/vi/fnagdqYiExA/mqdefault.jpg",
    "title": "【#ホロ視聴者ARK鯖凸】みんなの建築みせて！サーバー訪問再び！【#桐生ココ】",
    "publishedAt": "2020-09-06T17:09:12Z"
  },
  {
    "videoId": "ED9Cqc9ZgE8",
    "thumbnail": "https://i.ytimg.com/vi/ED9Cqc9ZgE8/mqdefault.jpg",
    "title": "【#MrPresident】SPココが大統領を守る！超難度ステージいくぜ【＃桐生ココ】",
    "publishedAt": "2020-09-07T10:07:44Z"
  },
  {
    "videoId": "Ad-vot_uAnw",
    "thumbnail": "https://i.ytimg.com/vi/Ad-vot_uAnw/mqdefault.jpg",
    "title": "superchatいただいた感謝です！みんな、ありがとう・・・！",
    "publishedAt": "2020-09-07T18:06:12Z"
  },
  {
    "videoId": "jwZiLQUjYsE",
    "thumbnail": "https://i.ytimg.com/vi/jwZiLQUjYsE/mqdefault.jpg",
    "title": "【#MrPresident】SPココ働く！これが最終ステージか！？【＃桐生ココ】",
    "publishedAt": "2020-09-08T11:08:32Z"
  },
  {
    "videoId": "PKfdS1KvHAs",
    "thumbnail": "https://i.ytimg.com/vi/PKfdS1KvHAs/mqdefault.jpg",
    "title": "【#桐生ココ】まったり作業！はく製博物館作り！【#とまらないARK】",
    "publishedAt": "2020-09-08T19:51:00Z"
  },
  {
    "videoId": "cQk-l2M1gCU",
    "thumbnail": "https://i.ytimg.com/vi/cQk-l2M1gCU/mqdefault.jpg",
    "title": "【#桐生ココ】登録者60万人緊急カウントダウンしたぁぁぁい！",
    "publishedAt": "2020-09-09T06:24:57Z"
  },
  {
    "videoId": "KszKb72miv4",
    "thumbnail": "https://i.ytimg.com/vi/KszKb72miv4/mqdefault.jpg",
    "title": "【#桐生ココ】そんなに上手くはないけれど。【歌枠】",
    "publishedAt": "2020-09-09T16:31:31Z"
  },
  {
    "videoId": "hOhhba54ALY",
    "thumbnail": "https://i.ytimg.com/vi/hOhhba54ALY/mqdefault.jpg",
    "title": "【#マイエクササイズ】腹筋【#桐生ココ】",
    "publishedAt": "2020-09-10T12:00:17Z"
  },
  {
    "videoId": "KKqlIvwtlwA",
    "thumbnail": "https://i.ytimg.com/vi/KKqlIvwtlwA/mqdefault.jpg",
    "title": "【#桐生ココ】55万人記念緊急クエスト！FPS初心者⁉うるせぇ55キルしろ！【APEX】",
    "publishedAt": "2020-09-10T22:08:20Z"
  },
  {
    "videoId": "0Ba5wL1nU0I",
    "thumbnail": "https://i.ytimg.com/vi/0Ba5wL1nU0I/mqdefault.jpg",
    "title": "pizza party guys!【#桐生ココ】",
    "publishedAt": "2020-09-11T17:02:20Z"
  },
  {
    "videoId": "f2Vrz8xpi2s",
    "thumbnail": "https://i.ytimg.com/vi/f2Vrz8xpi2s/mqdefault.jpg",
    "title": "【#Craftopia】クラフトピア初プレイだ！【#桐生ココ】",
    "publishedAt": "2020-09-12T13:09:39Z"
  },
  {
    "videoId": "ZM49rWeOv2g",
    "thumbnail": "https://i.ytimg.com/vi/ZM49rWeOv2g/mqdefault.jpg",
    "title": "今後の活動について作戦会議だ・・・！【#桐生ココ】",
    "publishedAt": "2020-09-12T16:21:50Z"
  },
  {
    "videoId": "59YIGtnyefQ",
    "thumbnail": "https://i.ytimg.com/vi/59YIGtnyefQ/mqdefault.jpg",
    "title": "PEOPLE SHITTING ONLINE / Reddit MEME review",
    "publishedAt": "2020-09-13T04:17:29Z"
  },
  {
    "videoId": "hELbga7HjFw",
    "thumbnail": "https://i.ytimg.com/vi/hELbga7HjFw/mqdefault.jpg",
    "title": "【歌枠】JUDY AND MARYの曲だけ！【#桐生ココ】",
    "publishedAt": "2020-09-13T13:05:10Z"
  },
  {
    "videoId": "HdaVqL5Zogs",
    "thumbnail": "https://i.ytimg.com/vi/HdaVqL5Zogs/mqdefault.jpg",
    "title": "スパーチャットへのお礼の枠です！",
    "publishedAt": "2020-09-13T16:32:06Z"
  },
  {
    "videoId": "m1D40_SGGhw",
    "thumbnail": "https://i.ytimg.com/vi/m1D40_SGGhw/mqdefault.jpg",
    "title": "【#たまココ脱毛】激痛脱毛も視聴者のアイタタエピソードで相殺できる説",
    "publishedAt": "2020-09-14T14:06:42Z"
  },
  {
    "videoId": "7KHibdKaMWg",
    "thumbnail": "https://i.ytimg.com/vi/7KHibdKaMWg/mqdefault.jpg",
    "title": "#FallGuys 1位拝ませろ！I need to win dad【#桐生ココ】",
    "publishedAt": "2020-09-15T12:08:52Z"
  },
  {
    "videoId": "yXQVBgHpK9o",
    "thumbnail": "https://i.ytimg.com/vi/yXQVBgHpK9o/mqdefault.jpg",
    "title": "しょぼしょぼん",
    "publishedAt": "2020-09-15T13:28:01Z"
  },
  {
    "videoId": "6fC1-7OY6Gc",
    "thumbnail": "https://i.ytimg.com/vi/6fC1-7OY6Gc/mqdefault.jpg",
    "title": "【#桐生ココ】CRYSTAL ISLESの全生物をはく製に！【#とまらないARK】",
    "publishedAt": "2020-09-17T13:31:26Z"
  },
  {
    "videoId": "93VzknCm7YM",
    "thumbnail": "https://i.ytimg.com/vi/93VzknCm7YM/mqdefault.jpg",
    "title": "【#桐生ココ】CRYSTAL ISLESの全生物をはく製に！【#とまらないARK】",
    "publishedAt": "2020-09-17T18:56:27Z"
  },
  {
    "videoId": "9IYmZ6_e1is",
    "thumbnail": "https://i.ytimg.com/vi/9IYmZ6_e1is/mqdefault.jpg",
    "title": "\"Have a nice day!\"Japanese for REAL 2020#3(Coco Kiryu's Japanese Class)",
    "publishedAt": "2020-09-18T12:30:03Z"
  },
  {
    "videoId": "4ax0CF-w7uo",
    "thumbnail": "https://i.ytimg.com/vi/4ax0CF-w7uo/mqdefault.jpg",
    "title": "【#WoWS】トランスフォーマーコラボぉぉ！視聴者参加型海上戦だ！",
    "publishedAt": "2020-09-18T14:09:19Z"
  },
  {
    "videoId": "8HQywCN3Ms0",
    "thumbnail": "https://i.ytimg.com/vi/8HQywCN3Ms0/mqdefault.jpg",
    "title": "お礼をする枠です！みんな本当につもありがとう！",
    "publishedAt": "2020-09-18T16:56:54Z"
  },
  {
    "videoId": "yjFm2qsp3Qg",
    "thumbnail": "https://i.ytimg.com/vi/yjFm2qsp3Qg/mqdefault.jpg",
    "title": "【#Craftopia】クラフトピアで生活！！原始人を卒業したい！【#桐生ココ】",
    "publishedAt": "2020-09-19T15:19:17Z"
  },
  {
    "videoId": "s-6nBOmOkYo",
    "thumbnail": "https://i.ytimg.com/vi/s-6nBOmOkYo/mqdefault.jpg",
    "title": "LOOK AT THOSE SHITPOSTS / Reddit MEME review by桐生ココ",
    "publishedAt": "2020-09-20T04:06:21Z"
  },
  {
    "videoId": "OxPnmI4asJs",
    "thumbnail": "https://i.ytimg.com/vi/OxPnmI4asJs/mqdefault.jpg",
    "title": "にほんごの歌練習！Singing Japanese Songs!＃桐生ココ",
    "publishedAt": "2020-09-20T13:13:35Z"
  },
  {
    "videoId": "nKEo1ivjPBo",
    "thumbnail": "https://i.ytimg.com/vi/nKEo1ivjPBo/mqdefault.jpg",
    "title": "🍺まったり呑み＆雑談🍺chit chat stream",
    "publishedAt": "2020-09-20T16:43:40Z"
  },
  {
    "videoId": "CqY-yyNC4-k",
    "thumbnail": "https://i.ytimg.com/vi/CqY-yyNC4-k/mqdefault.jpg",
    "title": "あさココLIVE 9/21 #asacoco",
    "publishedAt": "2020-09-20T21:27:49Z"
  },
  {
    "videoId": "qYsOvTwIxpc",
    "thumbnail": "https://i.ytimg.com/vi/qYsOvTwIxpc/mqdefault.jpg",
    "title": "【#Craftopia】目指せ！神様のいる！？浮島！【#桐生ココ】",
    "publishedAt": "2020-09-22T12:42:34Z"
  },
  {
    "videoId": "7_7X3szrSDg",
    "thumbnail": "https://i.ytimg.com/vi/7_7X3szrSDg/mqdefault.jpg",
    "title": "ちょとだけざつだん！chitchat",
    "publishedAt": "2020-09-22T15:48:33Z"
  },
  {
    "videoId": "IVRnQtefKno",
    "thumbnail": "https://i.ytimg.com/vi/IVRnQtefKno/mqdefault.jpg",
    "title": "あさココLIVE 9/23 #asacoco",
    "publishedAt": "2020-09-22T21:23:37Z"
  },
  {
    "videoId": "zH7xnkf8sis",
    "thumbnail": "https://i.ytimg.com/vi/zH7xnkf8sis/mqdefault.jpg",
    "title": "THE WORLD'S WORST CLIMBER世界一下手くそな壺おじ#桐生ココ",
    "publishedAt": "2020-09-23T16:14:23Z"
  },
  {
    "videoId": "7H0xQLDjOr8",
    "thumbnail": "https://i.ytimg.com/vi/7H0xQLDjOr8/mqdefault.jpg",
    "title": "ARKやりたいけどできなかった詫び雑談",
    "publishedAt": "2020-09-24T16:24:28Z"
  },
  {
    "videoId": "w66x87VSQRc",
    "thumbnail": "https://i.ytimg.com/vi/w66x87VSQRc/mqdefault.jpg",
    "title": "あさココLIVE 9/25 #asacoco",
    "publishedAt": "2020-09-24T21:25:57Z"
  },
  {
    "videoId": "YgK2dFBrrDQ",
    "thumbnail": "https://i.ytimg.com/vi/YgK2dFBrrDQ/mqdefault.jpg",
    "title": "World's WORST CLIMBER: Getting Over It with Benett Foddy 世界一下手くそ壺",
    "publishedAt": "2020-09-25T15:37:49Z"
  },
  {
    "videoId": "hame787QiwY",
    "thumbnail": "https://i.ytimg.com/vi/hame787QiwY/mqdefault.jpg",
    "title": "【#桐生ココ】雑談！【Chitchat】",
    "publishedAt": "2020-09-26T18:00:08Z"
  },
  {
    "videoId": "Gy_d3GfMrJs",
    "thumbnail": "https://i.ytimg.com/vi/Gy_d3GfMrJs/mqdefault.jpg",
    "title": "reddit shitposters never stop!!!",
    "publishedAt": "2020-09-27T04:04:35Z"
  },
  {
    "videoId": "kHsCSYBBSFc",
    "thumbnail": "https://i.ytimg.com/vi/kHsCSYBBSFc/mqdefault.jpg",
    "title": "あさココLIVE 10/19 #asacoco",
    "publishedAt": "2020-10-18T21:23:43Z"
  },
  {
    "videoId": "4cvJDOdqAm0",
    "thumbnail": "https://i.ytimg.com/vi/4cvJDOdqAm0/mqdefault.jpg",
    "title": "I'M BACK",
    "publishedAt": "2020-10-19T14:12:16Z"
  },
  {
    "videoId": "CSzsKsi_1Vk",
    "thumbnail": "https://i.ytimg.com/vi/CSzsKsi_1Vk/mqdefault.jpg",
    "title": "あさココLIVE 10/21 #asacoco",
    "publishedAt": "2020-10-20T21:25:29Z"
  },
  {
    "videoId": "fuGp_HRO_CY",
    "thumbnail": "https://i.ytimg.com/vi/fuGp_HRO_CY/mqdefault.jpg",
    "title": "CAN HAACHAMA REVIEW ENGLISH MEMES??#はあココ",
    "publishedAt": "2020-10-21T15:03:46Z"
  },
  {
    "videoId": "uArytUL2h7c",
    "thumbnail": "https://i.ytimg.com/vi/uArytUL2h7c/mqdefault.jpg",
    "title": "【壺男】BATTLE!!!! VS KANATA　1時間併走バトル【桐生ココ/ホロライブ4期生】",
    "publishedAt": "2020-10-22T10:18:16Z"
  },
  {
    "videoId": "MPf-lXsTkbg",
    "thumbnail": "https://i.ytimg.com/vi/MPf-lXsTkbg/mqdefault.jpg",
    "title": "TWO ENGLISH EXPERTS, EASY GAME#はあココマリングリッシュ",
    "publishedAt": "2020-10-22T14:25:49Z"
  },
  {
    "videoId": "RPEntBOmgi4",
    "thumbnail": "https://i.ytimg.com/vi/RPEntBOmgi4/mqdefault.jpg",
    "title": "あさココLIVE 10/23 #asacoco",
    "publishedAt": "2020-10-22T21:25:42Z"
  },
  {
    "videoId": "v26c9YJTp4c",
    "thumbnail": "https://i.ytimg.com/vi/v26c9YJTp4c/mqdefault.jpg",
    "title": "Kiryu Coco ver.2.0 ??????今夜何かが、起こる??????",
    "publishedAt": "2020-10-23T14:07:56Z"
  },
  {
    "videoId": "FafMfA8t3Y4",
    "thumbnail": "https://i.ytimg.com/vi/FafMfA8t3Y4/mqdefault.jpg",
    "title": "ライブもあるんだ！歌からにげるな！！",
    "publishedAt": "2020-10-23T16:12:33Z"
  },
  {
    "videoId": "NuRq18SIN40",
    "thumbnail": "https://i.ytimg.com/vi/NuRq18SIN40/mqdefault.jpg",
    "title": "CHIT CHAT COFFEE TIME TALK[雑談]",
    "publishedAt": "2020-10-24T14:41:47Z"
  },
  {
    "videoId": "BdYTQhkg4IE",
    "thumbnail": "https://i.ytimg.com/vi/BdYTQhkg4IE/mqdefault.jpg",
    "title": "reddit shit STRIKES AGAIN",
    "publishedAt": "2020-10-25T04:05:20Z"
  },
  {
    "videoId": "FtUri64J4a8",
    "thumbnail": "https://i.ytimg.com/vi/FtUri64J4a8/mqdefault.jpg",
    "title": "FALL GUYS SEASON2！！新しいステージ！？楽しみ！#桐生ココ",
    "publishedAt": "2020-10-25T16:05:37Z"
  },
  {
    "videoId": "OCGCgUmpd8k",
    "thumbnail": "https://i.ytimg.com/vi/OCGCgUmpd8k/mqdefault.jpg",
    "title": "あさココLIVE 10/26 #asacoco",
    "publishedAt": "2020-10-25T21:29:08Z"
  },
  {
    "videoId": "BJyz9KqRKiU",
    "thumbnail": "https://i.ytimg.com/vi/BJyz9KqRKiU/mqdefault.jpg",
    "title": "🍺TALK🍺雑談🍺",
    "publishedAt": "2020-10-27T15:07:21Z"
  },
  {
    "videoId": "aw2hQLq_Ldc",
    "thumbnail": "https://i.ytimg.com/vi/aw2hQLq_Ldc/mqdefault.jpg",
    "title": "🎤初🎤アニメソング縛り歌枠！SINGING ANIME SONGS ONLY🎵",
    "publishedAt": "2020-10-28T12:10:51Z"
  },
  {
    "videoId": "I_FiI-6rbH8",
    "thumbnail": "https://i.ytimg.com/vi/I_FiI-6rbH8/mqdefault.jpg",
    "title": "あさココLIVE 10/30 #asacoco",
    "publishedAt": "2020-10-29T21:24:14Z"
  },
  {
    "videoId": "5xl_1kbw3Iw",
    "thumbnail": "https://i.ytimg.com/vi/5xl_1kbw3Iw/mqdefault.jpg",
    "title": "PRO Golf Player COCO ゴルフじゃい！#桐生ココ",
    "publishedAt": "2020-10-30T15:14:38Z"
  },
  {
    "videoId": "PHHVa-puhwM",
    "thumbnail": "https://i.ytimg.com/vi/PHHVa-puhwM/mqdefault.jpg",
    "title": "【Terraria/テラリア】　DIGGGGGGG!!!!　【初プレイ!!】",
    "publishedAt": "2020-10-31T15:07:50Z"
  },
  {
    "videoId": "BXnDzBSnHlA",
    "thumbnail": "https://i.ytimg.com/vi/BXnDzBSnHlA/mqdefault.jpg",
    "title": "OH NO!! reddit shitposters are back!!",
    "publishedAt": "2020-11-01T04:07:21Z"
  },
  {
    "videoId": "prim4U5D6r0",
    "thumbnail": "https://i.ytimg.com/vi/prim4U5D6r0/mqdefault.jpg",
    "title": "【hair removal】激痛脱毛も苦手な歌枠と同時にやれば苦痛倍増でわけわからん#桐生ココ",
    "publishedAt": "2020-11-01T12:06:59Z"
  },
  {
    "videoId": "KjKB2Z75Dd4",
    "thumbnail": "https://i.ytimg.com/vi/KjKB2Z75Dd4/mqdefault.jpg",
    "title": "【The Fast And The Furious】Movie Watch-along!! 映画同時視聴しよう！",
    "publishedAt": "2020-11-01T16:15:28Z"
  },
  {
    "videoId": "fL2y1pdgiIQ",
    "thumbnail": "https://i.ytimg.com/vi/fL2y1pdgiIQ/mqdefault.jpg",
    "title": "あさココLIVE 11/2 #asacoco",
    "publishedAt": "2020-11-01T21:23:55Z"
  },
  {
    "videoId": "G-l9DHJAbrg",
    "thumbnail": "https://i.ytimg.com/vi/G-l9DHJAbrg/mqdefault.jpg",
    "title": "【Terraria/テラリア】IRON DIGGGGGGER",
    "publishedAt": "2020-11-02T17:01:43Z"
  },
  {
    "videoId": "hQgKs-CuG3o",
    "thumbnail": "https://i.ytimg.com/vi/hQgKs-CuG3o/mqdefault.jpg",
    "title": "WELCOME TO [ BAR COCO ] …おつかれさま雑談",
    "publishedAt": "2020-11-03T16:04:19Z"
  },
  {
    "videoId": "bpYJ6bzkmgs",
    "thumbnail": "https://i.ytimg.com/vi/bpYJ6bzkmgs/mqdefault.jpg",
    "title": "あさココLIVE 11/4 #asacoco",
    "publishedAt": "2020-11-03T21:28:11Z"
  },
  {
    "videoId": "03Hh2HWDoSY",
    "thumbnail": "https://i.ytimg.com/vi/03Hh2HWDoSY/mqdefault.jpg",
    "title": "WHAT THE GOLF??? ゴルフとは⛳#桐生ココ",
    "publishedAt": "2020-11-05T13:33:03Z"
  },
  {
    "videoId": "3sS2Qa-hGuc",
    "thumbnail": "https://i.ytimg.com/vi/3sS2Qa-hGuc/mqdefault.jpg",
    "title": "AMONG US!!!!!!!! for the first time",
    "publishedAt": "2020-11-05T15:38:16Z"
  },
  {
    "videoId": "JMwTIuhtNPM",
    "thumbnail": "https://i.ytimg.com/vi/JMwTIuhtNPM/mqdefault.jpg",
    "title": "あさココLIVE 11/6 #asacoco",
    "publishedAt": "2020-11-05T21:27:24Z"
  },
  {
    "videoId": "acluPLpA3V0",
    "thumbnail": "https://i.ytimg.com/vi/acluPLpA3V0/mqdefault.jpg",
    "title": "🎤う　た　の　鍛　錬　SINGING LIKE A PRO",
    "publishedAt": "2020-11-06T14:33:51Z"
  },
  {
    "videoId": "z7eBFOnLqYY",
    "thumbnail": "https://i.ytimg.com/vi/z7eBFOnLqYY/mqdefault.jpg",
    "title": "🔴AMONG US IQ3500 PLAY #Hololive #kiryucoco",
    "publishedAt": "2020-11-06T17:42:40Z"
  },
  {
    "videoId": "-wz7XS-3n9M",
    "thumbnail": "https://i.ytimg.com/vi/-wz7XS-3n9M/mqdefault.jpg",
    "title": "🔴MINECRAFT　まじわからないHELP ME",
    "publishedAt": "2020-11-07T02:42:25Z"
  },
  {
    "videoId": "EdrsR1LJ5qY",
    "thumbnail": "https://i.ytimg.com/vi/EdrsR1LJ5qY/mqdefault.jpg",
    "title": "週末雑談！🍺CHITCHAT TALK🍺#桐生ココ",
    "publishedAt": "2020-11-07T17:17:41Z"
  },
  {
    "videoId": "NdQxt14cFs8",
    "thumbnail": "https://i.ytimg.com/vi/NdQxt14cFs8/mqdefault.jpg",
    "title": "🌳テラリア/Terraria🌳 家🏠完成！？HOME RENOVATION!!",
    "publishedAt": "2020-11-08T11:22:01Z"
  },
  {
    "videoId": "f5x3j3PB69U",
    "thumbnail": "https://i.ytimg.com/vi/f5x3j3PB69U/mqdefault.jpg",
    "title": "🔴MINECRAFT⛏　ホロ鯖生活　下級者編",
    "publishedAt": "2020-11-08T16:28:26Z"
  },
  {
    "videoId": "zpr-SLXQPSo",
    "thumbnail": "https://i.ytimg.com/vi/zpr-SLXQPSo/mqdefault.jpg",
    "title": "あさココLIVE 11/9 #asacoco",
    "publishedAt": "2020-11-08T21:31:47Z"
  },
  {
    "videoId": "YtTzGMcdwMs",
    "thumbnail": "https://i.ytimg.com/vi/YtTzGMcdwMs/mqdefault.jpg",
    "title": "🔴Phasmophobia　初プレイ！#はあココ#Hololive",
    "publishedAt": "2020-11-09T11:17:00Z"
  },
  {
    "videoId": "aBB-9XRxJB4",
    "thumbnail": "https://i.ytimg.com/vi/aBB-9XRxJB4/mqdefault.jpg",
    "title": "🔴Terraria/テラリア🌳　地底探検！掘り師となる⛏#Hololive #桐生ココ",
    "publishedAt": "2020-11-09T18:55:00Z"
  },
  {
    "videoId": "KVlLoCB0XpE",
    "thumbnail": "https://i.ytimg.com/vi/KVlLoCB0XpE/mqdefault.jpg",
    "title": "🔴MINECRAFT ホロ鯖の地下には何がある！？素材集め！",
    "publishedAt": "2020-11-11T16:41:32Z"
  },
  {
    "videoId": "57UPiBQYBwA",
    "thumbnail": "https://i.ytimg.com/vi/57UPiBQYBwA/mqdefault.jpg",
    "title": "JUST SOME ANIME GIRL SINGING",
    "publishedAt": "2020-11-12T04:12:33Z"
  },
  {
    "videoId": "6zwsdEg4Ld8",
    "thumbnail": "https://i.ytimg.com/vi/6zwsdEg4Ld8/mqdefault.jpg",
    "title": "[ 信者専用 ] 寝る前に桐生ココの可愛い顔をみるだけの配信",
    "publishedAt": "2020-11-12T15:25:32Z"
  },
  {
    "videoId": "ML3ngBlXDcg",
    "thumbnail": "https://i.ytimg.com/vi/ML3ngBlXDcg/mqdefault.jpg",
    "title": "🔴🌳Terraria/テラリア🌳　新しいバイオームを探検だ！",
    "publishedAt": "2020-11-13T16:31:05Z"
  },
  {
    "videoId": "fDQpvy5pH8k",
    "thumbnail": "https://i.ytimg.com/vi/fDQpvy5pH8k/mqdefault.jpg",
    "title": "[VISAGE]👻Friday 13th、ホラゲをやらないなんて　#Hololive",
    "publishedAt": "2020-11-14T10:35:54Z"
  },
  {
    "videoId": "CdlFgI7ZN2A",
    "thumbnail": "https://i.ytimg.com/vi/CdlFgI7ZN2A/mqdefault.jpg",
    "title": "ワイルド・スピードX2同時視聴！2FAST 2FURIOUS 🚘movie watcha long",
    "publishedAt": "2020-11-14T18:02:05Z"
  },
  {
    "videoId": "GBEdNLKJHc8",
    "thumbnail": "https://i.ytimg.com/vi/GBEdNLKJHc8/mqdefault.jpg",
    "title": "REDDIT SHITPOST REVIEW with DOUBLE BOING BOINGS",
    "publishedAt": "2020-11-15T04:09:24Z"
  },
  {
    "videoId": "rnkULdMlXoE",
    "thumbnail": "https://i.ytimg.com/vi/rnkULdMlXoE/mqdefault.jpg",
    "title": "🔴ARK ほぼすべての動物を失ったでござる",
    "publishedAt": "2020-11-15T11:34:35Z"
  },
  {
    "videoId": "-F2f5nNlCH8",
    "thumbnail": "https://i.ytimg.com/vi/-F2f5nNlCH8/mqdefault.jpg",
    "title": "🔴MINECRAFT ネザー探検する！！NETHER? WHAT'S THAT?",
    "publishedAt": "2020-11-16T16:39:25Z"
  },
  {
    "videoId": "fffXpLYlaKY",
    "thumbnail": "https://i.ytimg.com/vi/fffXpLYlaKY/mqdefault.jpg",
    "title": "🔴Among Us 視聴者参加型ガチ対決！VS viewers #桐生ココ#Hololive",
    "publishedAt": "2020-11-17T16:27:49Z"
  },
  {
    "videoId": "6Jdn7o3eSrU",
    "thumbnail": "https://i.ytimg.com/vi/6Jdn7o3eSrU/mqdefault.jpg",
    "title": "【歌耐久】目指せ登録者800,000人！🎤Sing till I reach 800k!!🎵",
    "publishedAt": "2020-11-18T13:33:23Z"
  },
  {
    "videoId": "k3QbSbvwHKU",
    "thumbnail": "https://i.ytimg.com/vi/k3QbSbvwHKU/mqdefault.jpg",
    "title": "[CHIT CHAT] ねるまえざつだん！#桐生ココ",
    "publishedAt": "2020-11-18T15:23:36Z"
  },
  {
    "videoId": "IxB-CY2q3qA",
    "thumbnail": "https://i.ytimg.com/vi/IxB-CY2q3qA/mqdefault.jpg",
    "title": "【ARK Survival Evolved】家の建築開始！🏠House Builder Coco#桐生ココ",
    "publishedAt": "2020-11-20T15:28:04Z"
  },
  {
    "videoId": "SWpPbTcXST0",
    "thumbnail": "https://i.ytimg.com/vi/SWpPbTcXST0/mqdefault.jpg",
    "title": "[CHIT CHAT🍺]がんばったんだ運動会！お疲れ様雑談！🍺",
    "publishedAt": "2020-11-21T15:03:43Z"
  },
  {
    "videoId": "Yhs7yQcmj8I",
    "thumbnail": "https://i.ytimg.com/vi/Yhs7yQcmj8I/mqdefault.jpg",
    "title": "ワイルド・スピードX3 東京ドリフト同時視聴！🚘Tokyo Drift Movie Watch along!#桐生ココ",
    "publishedAt": "2020-11-22T17:23:11Z"
  },
  {
    "videoId": "ijspYzqNjug",
    "thumbnail": "https://i.ytimg.com/vi/ijspYzqNjug/mqdefault.jpg",
    "title": "🎤のびしろ歌枠🎶singing stream #桐生ココ",
    "publishedAt": "2020-11-23T16:55:29Z"
  },
  {
    "videoId": "3V2gNu3dM30",
    "thumbnail": "https://i.ytimg.com/vi/3V2gNu3dM30/mqdefault.jpg",
    "title": "【ARK】エクス内でマイホーム建築！豪邸じゃ！🏠[COCONSTRUCTION]",
    "publishedAt": "2020-11-24T16:45:50Z"
  },
  {
    "videoId": "IM2nIunXUDk",
    "thumbnail": "https://i.ytimg.com/vi/IM2nIunXUDk/mqdefault.jpg",
    "title": "🔴MINECRAFT🏠 マイホーム建築・・・！HOME BUILDER COCO⛏️",
    "publishedAt": "2020-11-26T18:07:10Z"
  },
  {
    "videoId": "yxkcGX9dAVQ",
    "thumbnail": "https://i.ytimg.com/vi/yxkcGX9dAVQ/mqdefault.jpg",
    "title": "COCO IS BACK!!",
    "publishedAt": "2020-12-14T15:08:27Z"
  },
  {
    "videoId": "gO7rlY-tI5M",
    "thumbnail": "https://i.ytimg.com/vi/gO7rlY-tI5M/mqdefault.jpg",
    "title": "【#桐生ココ】最近あったこと、いろいろ話したい！【雑談】",
    "publishedAt": "2020-12-15T16:09:00Z"
  },
  {
    "videoId": "WYkl7XEiS6k",
    "thumbnail": "https://i.ytimg.com/vi/WYkl7XEiS6k/mqdefault.jpg",
    "title": "【#桐生ココ】伸びしろしか感じない【歌枠】",
    "publishedAt": "2020-12-16T16:29:17Z"
  },
  {
    "videoId": "na11tWnBVHU",
    "thumbnail": "https://i.ytimg.com/vi/na11tWnBVHU/mqdefault.jpg",
    "title": "【ホラーゲーム】DAT HOUSE ON THE HILL 【#桐生ココ】",
    "publishedAt": "2020-12-17T18:04:36Z"
  },
  {
    "videoId": "isUvfnsoH9A",
    "thumbnail": "https://i.ytimg.com/vi/isUvfnsoH9A/mqdefault.jpg",
    "title": "【緊急雑談】パパざつetc【#桐生ココ】",
    "publishedAt": "2020-12-19T14:11:14Z"
  },
  {
    "videoId": "WlE6c_euBoI",
    "thumbnail": "https://i.ytimg.com/vi/WlE6c_euBoI/mqdefault.jpg",
    "title": "REDDIT \"SHUBARAMAZING\" SHITPOST REVIEW",
    "publishedAt": "2020-12-20T04:14:55Z"
  },
  {
    "videoId": "LMKuxjUIsEw",
    "thumbnail": "https://i.ytimg.com/vi/LMKuxjUIsEw/mqdefault.jpg",
    "title": "【建築見せて】ARK Extinction 視聴者サーバー凸！【#桐生ココ】",
    "publishedAt": "2020-12-20T15:03:53Z"
  },
  {
    "videoId": "XlXylLeELrM",
    "thumbnail": "https://i.ytimg.com/vi/XlXylLeELrM/mqdefault.jpg",
    "title": "あしたは…ライブ…zzz 【BED TIME TALK】",
    "publishedAt": "2020-12-20T15:58:29Z"
  },
  {
    "videoId": "sXNVF-OXXJk",
    "thumbnail": "https://i.ytimg.com/vi/sXNVF-OXXJk/mqdefault.jpg",
    "title": "ありがとう2nd Fes!! ライブ直後の振り返り配信！#こえていくホロライブ",
    "publishedAt": "2020-12-22T16:39:37Z"
  },
  {
    "videoId": "X5T9FiKE4ho",
    "thumbnail": "https://i.ytimg.com/vi/X5T9FiKE4ho/mqdefault.jpg",
    "title": "【オフコラボ】はあちゃま初訪問！ようこそかなココハウスへ！【#かなココっちゃま】",
    "publishedAt": "2020-12-23T12:06:21Z"
  },
  {
    "videoId": "ccSMrIp3MQs",
    "thumbnail": "https://i.ytimg.com/vi/ccSMrIp3MQs/mqdefault.jpg",
    "title": "GIMME🎁ARK SANTA!!!🎄Happy Christmas!",
    "publishedAt": "2020-12-24T13:41:38Z"
  },
  {
    "videoId": "U8n0iUXal9Q",
    "thumbnail": "https://i.ytimg.com/vi/U8n0iUXal9Q/mqdefault.jpg",
    "title": "はあちゃまはガチ寝起きでもはあちゃまっちゃまーなのか？？#はあココ",
    "publishedAt": "2020-12-25T00:26:03Z"
  },
  {
    "videoId": "8Odt3B33Aww",
    "thumbnail": "https://i.ytimg.com/vi/8Odt3B33Aww/mqdefault.jpg",
    "title": "くりすます歌れー",
    "publishedAt": "2020-12-25T16:05:15Z"
  },
  {
    "videoId": "jognpOE6BVw",
    "thumbnail": "https://i.ytimg.com/vi/jognpOE6BVw/mqdefault.jpg",
    "title": "[7days to die] かかってこい超難関クエスト！ [桐生ココ]",
    "publishedAt": "2020-12-26T16:22:56Z"
  },
  {
    "videoId": "2XcM4VtELBw",
    "thumbnail": "https://i.ytimg.com/vi/2XcM4VtELBw/mqdefault.jpg",
    "title": "【#桐生ココ】もうすぐ、いちねん。おはなし、しましょう【雑談】",
    "publishedAt": "2020-12-27T15:40:25Z"
  },
  {
    "videoId": "h70bLgQgOTk",
    "thumbnail": "https://i.ytimg.com/vi/h70bLgQgOTk/mqdefault.jpg",
    "title": "【#桐生ココ1周年】踊れドラゴン【#Coco1stAnniversary】",
    "publishedAt": "2020-12-28T12:06:25Z"
  },
  {
    "videoId": "RolqAvXJ6-A",
    "thumbnail": "https://i.ytimg.com/vi/RolqAvXJ6-A/mqdefault.jpg",
    "title": "1周年の感想✨雑談✨Backstageの話も！",
    "publishedAt": "2020-12-29T16:07:17Z"
  },
  {
    "videoId": "BrGDzR0xtZQ",
    "thumbnail": "https://i.ytimg.com/vi/BrGDzR0xtZQ/mqdefault.jpg",
    "title": "【ARK】ボッス戦の戦力を集めろぉ！Prepare for battle!",
    "publishedAt": "2020-12-30T12:22:41Z"
  },
  {
    "videoId": "JGkCXn02f4E",
    "thumbnail": "https://i.ytimg.com/vi/JGkCXn02f4E/mqdefault.jpg",
    "title": "【ARK】Crystal Isles γBOSS初挑戦！【#年末ARKボス戦】",
    "publishedAt": "2020-12-30T12:49:00Z"
  },
  {
    "videoId": "6LVVRBFbh5Q",
    "thumbnail": "https://i.ytimg.com/vi/6LVVRBFbh5Q/mqdefault.jpg",
    "title": "【応援感謝枠】スーパーチャット、年賀状、お手紙、声援【ありがとう】",
    "publishedAt": "2020-12-30T16:23:41Z"
  },
  {
    "videoId": "sGXTpOF-kOQ",
    "thumbnail": "https://i.ytimg.com/vi/sGXTpOF-kOQ/mqdefault.jpg",
    "title": "[FAST&FURIOUS MAX]ワイルドスピードMAX🚘映画同時視聴🍿[MOVIE WATCH ALONG]",
    "publishedAt": "2020-12-31T14:22:35Z"
  },
  {
    "videoId": "zkVVxooZlPs",
    "thumbnail": "https://i.ytimg.com/vi/zkVVxooZlPs/mqdefault.jpg",
    "title": "脱毛の痛みと涙と苦しみをぶつけて作る豚汁が、旨くないはずがない。",
    "publishedAt": "2020-12-31T16:07:24Z"
  },
  {
    "videoId": "9-miUIbhZc4",
    "thumbnail": "https://i.ytimg.com/vi/9-miUIbhZc4/mqdefault.jpg",
    "title": "【#ホロライブ正月衣装】お正月衣装お披露目🐉【桐生ココ/ホロライブ】",
    "publishedAt": "2021-01-01T04:32:40Z"
  },
  {
    "videoId": "KZK0GMfFz9A",
    "thumbnail": "https://i.ytimg.com/vi/KZK0GMfFz9A/mqdefault.jpg",
    "title": "#1【#桐生ココが如く】龍が如く4、全力プレイ。【© SEGA】※ネタバレあり",
    "publishedAt": "2021-01-01T14:54:09Z"
  },
  {
    "videoId": "z32zCYDt3M0",
    "thumbnail": "https://i.ytimg.com/vi/z32zCYDt3M0/mqdefault.jpg",
    "title": "【#桐生ココ】さようなら、たつのこたちよ【あいしてんで】",
    "publishedAt": "2021-01-02T16:37:53Z"
  },
  {
    "videoId": "3QlkGUiNjaQ",
    "thumbnail": "https://i.ytimg.com/vi/3QlkGUiNjaQ/mqdefault.jpg",
    "title": "REVIEWING SHITS FROM REDDIT with a ”DEVIL”",
    "publishedAt": "2021-01-03T04:07:49Z"
  },
  {
    "videoId": "qDjKE3HVPJk",
    "thumbnail": "https://i.ytimg.com/vi/qDjKE3HVPJk/mqdefault.jpg",
    "title": "[Terraria] Digging something rare [Deeper!]",
    "publishedAt": "2021-01-04T08:20:16Z"
  },
  {
    "videoId": "TtdLsqNvwjA",
    "thumbnail": "https://i.ytimg.com/vi/TtdLsqNvwjA/mqdefault.jpg",
    "title": "#2【#桐生ココが如く】龍が如く4、全力プレイ。【© SEGA】※ネタバレあり",
    "publishedAt": "2021-01-04T13:15:26Z"
  },
  {
    "videoId": "ouX9aCIo5bw",
    "thumbnail": "https://i.ytimg.com/vi/ouX9aCIo5bw/mqdefault.jpg",
    "title": "#3【#桐生ココが如く】龍が如く4、全力プレイ。【© SEGA】取り直し枠※ネタバレあり",
    "publishedAt": "2021-01-04T16:45:34Z"
  },
  {
    "videoId": "iGSqeCtCfSo",
    "thumbnail": "https://i.ytimg.com/vi/iGSqeCtCfSo/mqdefault.jpg",
    "title": "[ARK Survival Evolved] Extiction Cave! 装備を揃えて洞窟凸！[#桐生ココ]",
    "publishedAt": "2021-01-05T11:27:30Z"
  },
  {
    "videoId": "dSA3TOTGmCM",
    "thumbnail": "https://i.ytimg.com/vi/dSA3TOTGmCM/mqdefault.jpg",
    "title": "【#桐生ココ】今年も伸びしろを伸ばす🐉🎤【歌枠】",
    "publishedAt": "2021-01-05T15:10:40Z"
  },
  {
    "videoId": "61qgV6ZfqH4",
    "thumbnail": "https://i.ytimg.com/vi/61qgV6ZfqH4/mqdefault.jpg",
    "title": "#4【龍が如く4】冴島大河編はじまる！【#桐生ココが如く】※ネタバレあり",
    "publishedAt": "2021-01-06T16:28:44Z"
  },
  {
    "videoId": "yCEzW4MbgIU",
    "thumbnail": "https://i.ytimg.com/vi/yCEzW4MbgIU/mqdefault.jpg",
    "title": "[MINECRAFT] 地下冒険の始まりだ！！[桐生ココ]",
    "publishedAt": "2021-01-07T15:49:08Z"
  },
  {
    "videoId": "miy1O9QZcKM",
    "thumbnail": "https://i.ytimg.com/vi/miy1O9QZcKM/mqdefault.jpg",
    "title": "🐉登録者89.3万人耐久歌枠🎤【達成したら重大発表あり】",
    "publishedAt": "2021-01-08T13:44:44Z"
  },
  {
    "videoId": "jLIJA5AaaQA",
    "thumbnail": "https://i.ytimg.com/vi/jLIJA5AaaQA/mqdefault.jpg",
    "title": "#5【龍が如く4】真島吾郎の真実、今明かされる【#桐生ココが如く】※ネタバレあり",
    "publishedAt": "2021-01-09T12:36:48Z"
  },
  {
    "videoId": "-xhrVSWAHQ8",
    "thumbnail": "https://i.ytimg.com/vi/-xhrVSWAHQ8/mqdefault.jpg",
    "title": "【#桐生ココ】いただいたスーパーチャット読みます【感謝】",
    "publishedAt": "2021-01-09T15:56:59Z"
  },
  {
    "videoId": "WhUHsPReW7E",
    "thumbnail": "https://i.ytimg.com/vi/WhUHsPReW7E/mqdefault.jpg",
    "title": "\"SH----  SEISO MEME REVIEW with SORA senpai!!",
    "publishedAt": "2021-01-10T04:07:29Z"
  },
  {
    "videoId": "aOdm770E9Fw",
    "thumbnail": "https://i.ytimg.com/vi/aOdm770E9Fw/mqdefault.jpg",
    "title": "TADADA--DA--DA--DA--DADADA🎶～🎵～🎶",
    "publishedAt": "2021-01-10T06:01:08Z"
  },
  {
    "videoId": "TjsM6kKeP5M",
    "thumbnail": "https://i.ytimg.com/vi/TjsM6kKeP5M/mqdefault.jpg",
    "title": "[Terraria] A Dungeon Dragon !?",
    "publishedAt": "2021-01-11T08:38:10Z"
  },
  {
    "videoId": "I_XQoq7G-7w",
    "thumbnail": "https://i.ytimg.com/vi/I_XQoq7G-7w/mqdefault.jpg",
    "title": "🎵SHAKE🎵DA🎵BADONKADONK",
    "publishedAt": "2021-01-11T08:45:38Z"
  },
  {
    "videoId": "0vPy9nkf8l4",
    "thumbnail": "https://i.ytimg.com/vi/0vPy9nkf8l4/mqdefault.jpg",
    "title": "【初心者雀士ココ】近代麻雀玄武杯、優勝する【龍が如く4©SEGA】",
    "publishedAt": "2021-01-11T19:03:49Z"
  },
  {
    "videoId": "g2XpJkjkoFI",
    "thumbnail": "https://i.ytimg.com/vi/g2XpJkjkoFI/mqdefault.jpg",
    "title": "ガチ恋！！2021初詣デート！！！",
    "publishedAt": "2021-01-12T16:15:12Z"
  },
  {
    "videoId": "iuxQqgJnk4g",
    "thumbnail": "https://i.ytimg.com/vi/iuxQqgJnk4g/mqdefault.jpg",
    "title": "DooDooDoo～～🎵",
    "publishedAt": "2021-01-13T08:14:21Z"
  },
  {
    "videoId": "jttpZLc7vQs",
    "thumbnail": "https://i.ytimg.com/vi/jttpZLc7vQs/mqdefault.jpg",
    "title": "FLEXIBLE COCO and KANATA",
    "publishedAt": "2021-01-14T06:50:32Z"
  },
  {
    "videoId": "IyYKR9hdegc",
    "thumbnail": "https://i.ytimg.com/vi/IyYKR9hdegc/mqdefault.jpg",
    "title": "#6【龍が如く4】谷村ポリココ、25年前の真実を暴く【#桐生ココが如く】※ネタバレあり",
    "publishedAt": "2021-01-14T15:37:44Z"
  },
  {
    "videoId": "Ci_lf4eGZ48",
    "thumbnail": "https://i.ytimg.com/vi/Ci_lf4eGZ48/mqdefault.jpg",
    "title": "TADADA--DA--DA--🎵",
    "publishedAt": "2021-01-14T20:47:19Z"
  },
  {
    "videoId": "quf66yb4Eek",
    "thumbnail": "https://i.ytimg.com/vi/quf66yb4Eek/mqdefault.jpg",
    "title": "[Terraria] BUZZZZZZZZZZZZZ",
    "publishedAt": "2021-01-15T05:29:41Z"
  },
  {
    "videoId": "PODD5AbaoYI",
    "thumbnail": "https://i.ytimg.com/vi/PODD5AbaoYI/mqdefault.jpg",
    "title": "【箱おじ】BOXMAN'S STRUGGLE～軽快なジャズを添えて～【#桐生ココ】",
    "publishedAt": "2021-01-15T15:24:09Z"
  },
  {
    "videoId": "sliMmBsUB4s",
    "thumbnail": "https://i.ytimg.com/vi/sliMmBsUB4s/mqdefault.jpg",
    "title": "うわぁぁああ",
    "publishedAt": "2021-01-16T01:37:24Z"
  },
  {
    "videoId": "kIt73fddlIU",
    "thumbnail": "https://i.ytimg.com/vi/kIt73fddlIU/mqdefault.jpg",
    "title": "#7【龍が如く4】桐生一馬再び神室町へ！【#桐生ココが如く】※ネタバレあり",
    "publishedAt": "2021-01-16T06:31:01Z"
  },
  {
    "videoId": "fr_OCV00_EY",
    "thumbnail": "https://i.ytimg.com/vi/fr_OCV00_EY/mqdefault.jpg",
    "title": "~~~🎵~~~！？",
    "publishedAt": "2021-01-16T07:38:52Z"
  },
  {
    "videoId": "E3-fLdKyvts",
    "thumbnail": "https://i.ytimg.com/vi/E3-fLdKyvts/mqdefault.jpg",
    "title": "When the MINECRAFT VILLAGER ATTAC",
    "publishedAt": "2021-01-16T12:34:35Z"
  },
  {
    "videoId": "jvzIQJRhIb0",
    "thumbnail": "https://i.ytimg.com/vi/jvzIQJRhIb0/mqdefault.jpg",
    "title": "Reddit Shitpost Review with Suisei!!",
    "publishedAt": "2021-01-17T04:08:54Z"
  },
  {
    "videoId": "FabpEfr5wD0",
    "thumbnail": "https://i.ytimg.com/vi/FabpEfr5wD0/mqdefault.jpg",
    "title": "WHY YOUTUBE? Lemme read my superchats!",
    "publishedAt": "2021-01-17T15:59:04Z"
  },
  {
    "videoId": "ramrXKvE-JY",
    "thumbnail": "https://i.ytimg.com/vi/ramrXKvE-JY/mqdefault.jpg",
    "title": "PEE---P✨",
    "publishedAt": "2021-01-18T11:30:21Z"
  },
  {
    "videoId": "5P9skO8lBzE",
    "thumbnail": "https://i.ytimg.com/vi/5P9skO8lBzE/mqdefault.jpg",
    "title": "FALL GUYS SEASON3👑新シーズンだ！次こそ優勝！#桐生ココ",
    "publishedAt": "2021-01-18T16:33:37Z"
  },
  {
    "videoId": "oN-V7oR9URA",
    "thumbnail": "https://i.ytimg.com/vi/oN-V7oR9URA/mqdefault.jpg",
    "title": "🎶Da Ba Dee DA DA🎶",
    "publishedAt": "2021-01-18T17:20:33Z"
  },
  {
    "videoId": "wPYMQ7zyt9M",
    "thumbnail": "https://i.ytimg.com/vi/wPYMQ7zyt9M/mqdefault.jpg",
    "title": "BAR COCO ～ココママ2021相談室～ #桐生ココ",
    "publishedAt": "2021-01-19T07:22:17Z"
  },
  {
    "videoId": "_NZqUZ7F2yc",
    "thumbnail": "https://i.ytimg.com/vi/_NZqUZ7F2yc/mqdefault.jpg",
    "title": "伸びしろ歌枠！！！頑張れ歌え！！🎶＃桐生ココ",
    "publishedAt": "2021-01-19T16:45:46Z"
  },
  {
    "videoId": "_vZSOSkOuyg",
    "thumbnail": "https://i.ytimg.com/vi/_vZSOSkOuyg/mqdefault.jpg",
    "title": "【初心者雀士ココ】近代麻雀玄武杯、1位とるまでやめられない【龍が如く4©SEGA】",
    "publishedAt": "2021-01-20T16:35:14Z"
  },
  {
    "videoId": "e8ocwWD7Dr4",
    "thumbnail": "https://i.ytimg.com/vi/e8ocwWD7Dr4/mqdefault.jpg",
    "title": "When a good dose of asacoco goes Brrrrrr🎶～🎶",
    "publishedAt": "2021-01-20T16:44:54Z"
  },
  {
    "videoId": "aSF38_xuZ5U",
    "thumbnail": "https://i.ytimg.com/vi/aSF38_xuZ5U/mqdefault.jpg",
    "title": "#8【龍が如く4】4人の最後の戦いが、今【#桐生ココが如く】※ネタバレあり",
    "publishedAt": "2021-01-21T13:53:45Z"
  },
  {
    "videoId": "KIvILyyD1Xc",
    "thumbnail": "https://i.ytimg.com/vi/KIvILyyD1Xc/mqdefault.jpg",
    "title": "WTF R U LOOKING AT",
    "publishedAt": "2021-01-21T22:05:37Z"
  },
  {
    "videoId": "Myvj9otIjyw",
    "thumbnail": "https://i.ytimg.com/vi/Myvj9otIjyw/mqdefault.jpg",
    "title": "🎶When an Idol slays a Triple somethin'",
    "publishedAt": "2021-01-21T22:23:36Z"
  },
  {
    "videoId": "vk2bvVB4QLo",
    "thumbnail": "https://i.ytimg.com/vi/vk2bvVB4QLo/mqdefault.jpg",
    "title": "SHAKE DAT ASS",
    "publishedAt": "2021-01-22T09:30:01Z"
  },
  {
    "videoId": "k0cJoA66l1E",
    "thumbnail": "https://i.ytimg.com/vi/k0cJoA66l1E/mqdefault.jpg",
    "title": "CHIT CHAT 雑談　いろいろ話そう✨",
    "publishedAt": "2021-01-23T11:09:03Z"
  },
  {
    "videoId": "zF3M2SJ__18",
    "thumbnail": "https://i.ytimg.com/vi/zF3M2SJ__18/mqdefault.jpg",
    "title": "#1【龍が如く3】カタギとして、沖縄で生きる。※ネタバレあり",
    "publishedAt": "2021-01-23T17:37:09Z"
  },
  {
    "videoId": "KvE1OLop8j4",
    "thumbnail": "https://i.ytimg.com/vi/KvE1OLop8j4/mqdefault.jpg",
    "title": "DOO LUU DOO～～🎵",
    "publishedAt": "2021-01-23T17:56:09Z"
  },
  {
    "videoId": "sRVpQ-zTcrc",
    "thumbnail": "https://i.ytimg.com/vi/sRVpQ-zTcrc/mqdefault.jpg",
    "title": "Reddit Shitpost Review with Polka!",
    "publishedAt": "2021-01-24T04:07:39Z"
  },
  {
    "videoId": "7Aaaxp_J8mI",
    "thumbnail": "https://i.ytimg.com/vi/7Aaaxp_J8mI/mqdefault.jpg",
    "title": "[FAST&FURIOUS MEGA MAX]ワイルドスピードﾒｶﾞﾏｯｸｽ🚘映画同時視聴🍿[MOVIE WATCH ALONG]",
    "publishedAt": "2021-01-24T15:53:08Z"
  },
  {
    "videoId": "WojNYdXH_XE",
    "thumbnail": "https://i.ytimg.com/vi/WojNYdXH_XE/mqdefault.jpg",
    "title": "[Terraria] GOING HIGH!!!",
    "publishedAt": "2021-01-26T04:07:00Z"
  },
  {
    "videoId": "1-6LJieBz8U",
    "thumbnail": "https://i.ytimg.com/vi/1-6LJieBz8U/mqdefault.jpg",
    "title": "🎵WIGGLE?",
    "publishedAt": "2021-01-26T09:36:46Z"
  },
  {
    "videoId": "951Qit-x8pA",
    "thumbnail": "https://i.ytimg.com/vi/951Qit-x8pA/mqdefault.jpg",
    "title": "#2【龍が如く3】平和な生活を守るために。※ネタバレあり",
    "publishedAt": "2021-01-26T17:02:55Z"
  },
  {
    "videoId": "WinQpGPnSdI",
    "thumbnail": "https://i.ytimg.com/vi/WinQpGPnSdI/mqdefault.jpg",
    "title": "SLAMMIN",
    "publishedAt": "2021-01-29T16:28:14Z"
  },
  {
    "videoId": "aSDdkqpPsdE",
    "thumbnail": "https://i.ytimg.com/vi/aSDdkqpPsdE/mqdefault.jpg",
    "title": "コメントの指示に2時間絶対服従したらこうなった【#桐生ココ】",
    "publishedAt": "2021-01-29T16:44:49Z"
  },
  {
    "videoId": "SyyEyLSCL64",
    "thumbnail": "https://i.ytimg.com/vi/SyyEyLSCL64/mqdefault.jpg",
    "title": "【マイクラ】3時間コメントの指示だけで動いたらどこまでいける⁉【指示クラ】",
    "publishedAt": "2021-01-30T11:10:01Z"
  },
  {
    "videoId": "1Mm2VgxI-nA",
    "thumbnail": "https://i.ytimg.com/vi/1Mm2VgxI-nA/mqdefault.jpg",
    "title": "Reddit Shitpost Review with Pekora senpai! ホロライブ/桐生ココ/兎田ぺこら",
    "publishedAt": "2021-01-31T04:07:39Z"
  },
  {
    "videoId": "62Z8dsmzkS8",
    "thumbnail": "https://i.ytimg.com/vi/62Z8dsmzkS8/mqdefault.jpg",
    "title": "【ASMR】サラウンド脱毛【ホロライブ/桐生ココ】",
    "publishedAt": "2021-02-01T15:10:13Z"
  },
  {
    "videoId": "C5l9qpQOeTg",
    "thumbnail": "https://i.ytimg.com/vi/C5l9qpQOeTg/mqdefault.jpg",
    "title": "WHEN I HURT MY NECK SO BAD I CAN'T EVEN NECKDANCE",
    "publishedAt": "2021-02-01T16:00:06Z"
  },
  {
    "videoId": "E3M6nvk_hO0",
    "thumbnail": "https://i.ytimg.com/vi/E3M6nvk_hO0/mqdefault.jpg",
    "title": "🔴SUPERLIMINAL♙ 桐生ココ/ホロライブ",
    "publishedAt": "2021-02-03T17:10:29Z"
  },
  {
    "videoId": "pJSLYM-VUTA",
    "thumbnail": "https://i.ytimg.com/vi/pJSLYM-VUTA/mqdefault.jpg",
    "title": "#3【龍が如く3】神室町大乱闘じゃい！【桐生ココが如く】※ネタバレあり",
    "publishedAt": "2021-02-04T17:09:07Z"
  },
  {
    "videoId": "TYs6erA38Dc",
    "thumbnail": "https://i.ytimg.com/vi/TYs6erA38Dc/mqdefault.jpg",
    "title": "BAR COCO~ココママのだらしゃべ相談室~",
    "publishedAt": "2021-02-05T17:33:28Z"
  },
  {
    "videoId": "8UCeu-Exzjo",
    "thumbnail": "https://i.ytimg.com/vi/8UCeu-Exzjo/mqdefault.jpg",
    "title": "[ARK] 　戦　力　増　強　[桐生ココ/ホロライブ]",
    "publishedAt": "2021-02-06T15:38:18Z"
  },
  {
    "videoId": "ie5oTaH3nAk",
    "thumbnail": "https://i.ytimg.com/vi/ie5oTaH3nAk/mqdefault.jpg",
    "title": "Reddit Shitpost Review with Mio senpai!",
    "publishedAt": "2021-02-07T04:08:29Z"
  },
  {
    "videoId": "wiD08NsCdrc",
    "thumbnail": "https://i.ytimg.com/vi/wiD08NsCdrc/mqdefault.jpg",
    "title": "✨BIG✨REVEAL✨お披露目✨お待たせ✨桐生ココ2.0",
    "publishedAt": "2021-02-07T12:05:12Z"
  },
  {
    "videoId": "-2GVHe7E7dE",
    "thumbnail": "https://i.ytimg.com/vi/-2GVHe7E7dE/mqdefault.jpg",
    "title": "ねるまえ雑談 [ CHIT CHAT]桐生ココ",
    "publishedAt": "2021-02-07T15:24:30Z"
  },
  {
    "videoId": "9d83low7w1w",
    "thumbnail": "https://i.ytimg.com/vi/9d83low7w1w/mqdefault.jpg",
    "title": "#4【龍が如く3】沖縄のあさがおへ！みんな元気だったか？【桐生ココが如く】※ネタバレあり",
    "publishedAt": "2021-02-08T17:18:19Z"
  },
  {
    "videoId": "hf3hZ-lBJMU",
    "thumbnail": "https://i.ytimg.com/vi/hf3hZ-lBJMU/mqdefault.jpg",
    "title": "[ARK] ぶっこわ巣 [アキロゼ/桐生ココ]",
    "publishedAt": "2021-02-10T11:25:07Z"
  },
  {
    "videoId": "ntccEaPrl3o",
    "thumbnail": "https://i.ytimg.com/vi/ntccEaPrl3o/mqdefault.jpg",
    "title": "I DANCE",
    "publishedAt": "2021-02-12T04:27:37Z"
  },
  {
    "videoId": "kHJ0Ru7xzpM",
    "thumbnail": "https://i.ytimg.com/vi/kHJ0Ru7xzpM/mqdefault.jpg",
    "title": "FALLOUT4 !!!!! NUKA COOOOOLA!!",
    "publishedAt": "2021-02-13T06:12:15Z"
  },
  {
    "videoId": "BiMaOp8qWkg",
    "thumbnail": "https://i.ytimg.com/vi/BiMaOp8qWkg/mqdefault.jpg",
    "title": "FALLOUT4 Yay! It's the end of the world!",
    "publishedAt": "2021-02-13T06:34:29Z"
  },
  {
    "videoId": "T0MFrKxRdKo",
    "thumbnail": "https://i.ytimg.com/vi/T0MFrKxRdKo/mqdefault.jpg",
    "title": "MINECRAFT FOR BACKSEATERS [指示厨クラフト]",
    "publishedAt": "2021-02-13T14:24:40Z"
  },
  {
    "videoId": "wDh0RdwpBJY",
    "thumbnail": "https://i.ytimg.com/vi/wDh0RdwpBJY/mqdefault.jpg",
    "title": "Reddit shitpost review with DAT BITCH",
    "publishedAt": "2021-02-14T04:14:53Z"
  },
  {
    "videoId": "skeC80CGejI",
    "thumbnail": "https://i.ytimg.com/vi/skeC80CGejI/mqdefault.jpg",
    "title": "[NEW COSTUME]✨アイドル衣装お披露目✨[SUPER IDOL]",
    "publishedAt": "2021-02-15T12:45:17Z"
  },
  {
    "videoId": "QGP9FFan1JM",
    "thumbnail": "https://i.ytimg.com/vi/QGP9FFan1JM/mqdefault.jpg",
    "title": "【 #ホロふぉーす​アイドル衣装​  プレミア公開を同時視聴！】",
    "publishedAt": "2021-02-15T13:00:42Z"
  },
  {
    "videoId": "0lNFmvFmJxw",
    "thumbnail": "https://i.ytimg.com/vi/0lNFmvFmJxw/mqdefault.jpg",
    "title": "CHIT CHAT ねるまえざつだん！",
    "publishedAt": "2021-02-15T17:43:24Z"
  },
  {
    "videoId": "_v3xmF1UPFs",
    "thumbnail": "https://i.ytimg.com/vi/_v3xmF1UPFs/mqdefault.jpg",
    "title": "【龍が如く3】峯よ【最終章】※ネタバレあり",
    "publishedAt": "2021-02-16T12:50:41Z"
  },
  {
    "videoId": "Pvn8fhuLDRo",
    "thumbnail": "https://i.ytimg.com/vi/Pvn8fhuLDRo/mqdefault.jpg",
    "title": "1M!!!!????",
    "publishedAt": "2021-02-17T09:07:02Z"
  },
  {
    "videoId": "h0h_jfz4SY8",
    "thumbnail": "https://i.ytimg.com/vi/h0h_jfz4SY8/mqdefault.jpg",
    "title": "Road to 1M with YouTube-kun",
    "publishedAt": "2021-02-17T09:38:10Z"
  },
  {
    "videoId": "8t4UljPlVeE",
    "thumbnail": "https://i.ytimg.com/vi/8t4UljPlVeE/mqdefault.jpg",
    "title": "歌えアイドル桐生ココ！　SING IT!!!🎤",
    "publishedAt": "2021-02-19T18:18:38Z"
  },
  {
    "videoId": "evVu6fPjbfw",
    "thumbnail": "https://i.ytimg.com/vi/evVu6fPjbfw/mqdefault.jpg",
    "title": "桐生ココアイドル衣装 [IDOL COSTUME BTS] 撮影オフショット✨",
    "publishedAt": "2021-02-20T08:17:57Z"
  },
  {
    "videoId": "Ja5iteRSjfg",
    "thumbnail": "https://i.ytimg.com/vi/Ja5iteRSjfg/mqdefault.jpg",
    "title": "Reddit shitpost review with badonked Noel paisen!!",
    "publishedAt": "2021-02-21T04:11:48Z"
  },
  {
    "videoId": "Ezs9kJI8f90",
    "thumbnail": "https://i.ytimg.com/vi/Ezs9kJI8f90/mqdefault.jpg",
    "title": "[マイクラ]うさ建⛏️初出勤✨My First day at WERK⛏️[桐生ココ]",
    "publishedAt": "2021-02-23T17:23:08Z"
  },
  {
    "videoId": "XzD-Ms5ukLE",
    "thumbnail": "https://i.ytimg.com/vi/XzD-Ms5ukLE/mqdefault.jpg",
    "title": "超久々に体調を崩してしまった話。【ホロライブ/桐生ココ】",
    "publishedAt": "2021-02-26T13:35:03Z"
  },
  {
    "videoId": "VooLzUEf5Wg",
    "thumbnail": "https://i.ytimg.com/vi/VooLzUEf5Wg/mqdefault.jpg",
    "title": "SLEEP WELL COCO  桐生ココ/ホロライブ",
    "publishedAt": "2021-02-27T03:52:20Z"
  },
  {
    "videoId": "WOoQzNWaqTY",
    "thumbnail": "https://i.ytimg.com/vi/WOoQzNWaqTY/mqdefault.jpg",
    "title": "MY FIRST EVER MARIO🍄マジガチ初見マリオ【桐生ココ/ホロライブ】",
    "publishedAt": "2021-02-27T17:12:05Z"
  },
  {
    "videoId": "XzAmDamARYY",
    "thumbnail": "https://i.ytimg.com/vi/XzAmDamARYY/mqdefault.jpg",
    "title": "【JURASSIC SHARK】ジュラシックシャーク🦈映画同時視聴！【Movie watchalong!】",
    "publishedAt": "2021-02-28T14:57:29Z"
  },
  {
    "videoId": "3haunPebls8",
    "thumbnail": "https://i.ytimg.com/vi/3haunPebls8/mqdefault.jpg",
    "title": "初見マリオだけどWORLD2を乗り越えたい【桐生ココ/ホロライブ】",
    "publishedAt": "2021-03-01T16:25:24Z"
  },
  {
    "videoId": "WzkpOwxo2ho",
    "thumbnail": "https://i.ytimg.com/vi/WzkpOwxo2ho/mqdefault.jpg",
    "title": "GMMF💓あさごはんつくるよ！🍳💓桐生ココ/ホロライブ",
    "publishedAt": "2021-03-01T21:21:55Z"
  },
  {
    "videoId": "Aj11HLWkKg0",
    "thumbnail": "https://i.ytimg.com/vi/Aj11HLWkKg0/mqdefault.jpg",
    "title": "【龍が如く7インターナショナル】本日発売！早速プレイしてみる！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-03-02T15:37:49Z"
  },
  {
    "videoId": "-NCFs971EEc",
    "thumbnail": "https://i.ytimg.com/vi/-NCFs971EEc/mqdefault.jpg",
    "title": "🍸----BAR COCO OPENS----🍸桐生ココ/ホロライブ",
    "publishedAt": "2021-03-03T16:52:57Z"
  },
  {
    "videoId": "pbaFa86jPeA",
    "thumbnail": "https://i.ytimg.com/vi/pbaFa86jPeA/mqdefault.jpg",
    "title": "✨あんこ―――る✨歌枠！！🎤【桐生ココ/ホロライブ】",
    "publishedAt": "2021-03-04T14:02:55Z"
  },
  {
    "videoId": "4evxvPGz6gQ",
    "thumbnail": "https://i.ytimg.com/vi/4evxvPGz6gQ/mqdefault.jpg",
    "title": "OPPAI REALITY CHECK 桐生ココ/天音かなた/ホロライブ",
    "publishedAt": "2021-03-05T14:20:19Z"
  },
  {
    "videoId": "UrasgZej4jo",
    "thumbnail": "https://i.ytimg.com/vi/UrasgZej4jo/mqdefault.jpg",
    "title": "[FALLOUT4] GIMME BACK MY SON!!!!!!!",
    "publishedAt": "2021-03-06T09:30:02Z"
  },
  {
    "videoId": "PjXVRABfP7Q",
    "thumbnail": "https://i.ytimg.com/vi/PjXVRABfP7Q/mqdefault.jpg",
    "title": "#1【龍が如くOF THE END】神室町がゾンビまみれに！？【桐生ココ/ホロライブ】※ネタバレあり",
    "publishedAt": "2021-03-06T12:10:47Z"
  },
  {
    "videoId": "CQdJ41bi990",
    "thumbnail": "https://i.ytimg.com/vi/CQdJ41bi990/mqdefault.jpg",
    "title": "Superchat reading & CHIT CHAT【感謝】",
    "publishedAt": "2021-03-07T09:56:58Z"
  },
  {
    "videoId": "Ddq9kBdbLGQ",
    "thumbnail": "https://i.ytimg.com/vi/Ddq9kBdbLGQ/mqdefault.jpg",
    "title": "#2【龍が如くOF THE END】神室町がこわれちゃうよぉ！！【桐生ココ/ホロライブ】※ネタバレあり",
    "publishedAt": "2021-03-07T14:30:54Z"
  },
  {
    "videoId": "-hvLAbkJYAU",
    "thumbnail": "https://i.ytimg.com/vi/-hvLAbkJYAU/mqdefault.jpg",
    "title": "【マリオカート8DX】はじめてだから姫プしろ【視聴者参加型】桐生ココ",
    "publishedAt": "2021-03-08T15:14:20Z"
  },
  {
    "videoId": "SerXt3Xk250",
    "thumbnail": "https://i.ytimg.com/vi/SerXt3Xk250/mqdefault.jpg",
    "title": "[マイクラ]うさ建⛏️続・地下労働⛏️[桐生ココ]",
    "publishedAt": "2021-03-09T06:39:23Z"
  },
  {
    "videoId": "6CVeFQiED8o",
    "thumbnail": "https://i.ytimg.com/vi/6CVeFQiED8o/mqdefault.jpg",
    "title": "#3【龍が如くOF THE END】狩る者・真島吾朗始動！！【桐生ココ/ホロライブ】※ネタバレあり",
    "publishedAt": "2021-03-09T12:09:37Z"
  },
  {
    "videoId": "YEJ8oQOBXBs",
    "thumbnail": "https://i.ytimg.com/vi/YEJ8oQOBXBs/mqdefault.jpg",
    "title": "[FALLOUT4] CATCH DAT KIDNAPPER!!!!!!!!!!",
    "publishedAt": "2021-03-10T08:35:42Z"
  },
  {
    "videoId": "uSXTDCWjA3A",
    "thumbnail": "https://i.ytimg.com/vi/uSXTDCWjA3A/mqdefault.jpg",
    "title": "【龍が如く7インターナショナル】フル英語音声春日、またしても無職に！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-03-12T12:40:34Z"
  },
  {
    "videoId": "3XgDCh3O49M",
    "thumbnail": "https://i.ytimg.com/vi/3XgDCh3O49M/mqdefault.jpg",
    "title": "🍸----BAR COCO----🍸晩酌お悩み相談室　桐生ココ/ホロライブ",
    "publishedAt": "2021-03-12T16:41:51Z"
  },
  {
    "videoId": "oteljbr-jUs",
    "thumbnail": "https://i.ytimg.com/vi/oteljbr-jUs/mqdefault.jpg",
    "title": "みんなが頑張って私を1位にするマリオカート8DX",
    "publishedAt": "2021-03-13T08:05:55Z"
  },
  {
    "videoId": "EmBycwxevI8",
    "thumbnail": "https://i.ytimg.com/vi/EmBycwxevI8/mqdefault.jpg",
    "title": "初心者ドラゴン娘、ウマ娘トレーナーデビュー！！！",
    "publishedAt": "2021-03-13T15:50:31Z"
  },
  {
    "videoId": "-PGS7q5euwo",
    "thumbnail": "https://i.ytimg.com/vi/-PGS7q5euwo/mqdefault.jpg",
    "title": "Reddit shitpost review NANORAAAAAAAAA!!!!!",
    "publishedAt": "2021-03-14T04:09:31Z"
  },
  {
    "videoId": "xhIpartjm6c",
    "thumbnail": "https://i.ytimg.com/vi/xhIpartjm6c/mqdefault.jpg",
    "title": "ホロAMONG US!! 桐生ココ視点",
    "publishedAt": "2021-03-14T16:30:40Z"
  },
  {
    "videoId": "RtWybPq-T3U",
    "thumbnail": "https://i.ytimg.com/vi/RtWybPq-T3U/mqdefault.jpg",
    "title": "かかってこいよ！タイタン戦じゃ！！ARK: Survival Evolved [桐生ココ/ホロライブ]",
    "publishedAt": "2021-03-16T14:21:59Z"
  },
  {
    "videoId": "0Nz294ElMqw",
    "thumbnail": "https://i.ytimg.com/vi/0Nz294ElMqw/mqdefault.jpg",
    "title": "【お絵かき】メンバーシップスタンプ増やしたい！【紙絵師】",
    "publishedAt": "2021-03-17T12:08:44Z"
  },
  {
    "videoId": "sr4iFhvz5Ls",
    "thumbnail": "https://i.ytimg.com/vi/sr4iFhvz5Ls/mqdefault.jpg",
    "title": "【ミホノブルボン】ミ゛ホ゛ノ゛フ゛ル゛ホ゛ン゛ッ【ミホノブルボン】",
    "publishedAt": "2021-03-18T16:14:23Z"
  },
  {
    "videoId": "CpRvflsQtNE",
    "thumbnail": "https://i.ytimg.com/vi/CpRvflsQtNE/mqdefault.jpg",
    "title": "[FALLOUT4] 行け！パワーアーマー！！[桐生ココ/ホロライブ]",
    "publishedAt": "2021-03-20T16:29:30Z"
  },
  {
    "videoId": "uVVpqm5VHiA",
    "thumbnail": "https://i.ytimg.com/vi/uVVpqm5VHiA/mqdefault.jpg",
    "title": "歌枠🎤伸びしろを披露。",
    "publishedAt": "2021-03-20T17:02:07Z"
  },
  {
    "videoId": "OWvEG82V7UM",
    "thumbnail": "https://i.ytimg.com/vi/OWvEG82V7UM/mqdefault.jpg",
    "title": "Reddit shitpost review with Okayu senpai!",
    "publishedAt": "2021-03-21T04:05:27Z"
  },
  {
    "videoId": "kixEahvWPiI",
    "thumbnail": "https://i.ytimg.com/vi/kixEahvWPiI/mqdefault.jpg",
    "title": "【映画同時視聴】HK 変態仮面【桐生ココ】",
    "publishedAt": "2021-03-21T16:08:48Z"
  },
  {
    "videoId": "t55zz84TuS4",
    "thumbnail": "https://i.ytimg.com/vi/t55zz84TuS4/mqdefault.jpg",
    "title": "【マイクラ】ドット絵に初挑戦！！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-03-23T17:25:56Z"
  },
  {
    "videoId": "BfUMvLAN-a8",
    "thumbnail": "https://i.ytimg.com/vi/BfUMvLAN-a8/mqdefault.jpg",
    "title": "【空気読み。３】あ～読めますね、手に取るように読めます【桐生ココ】",
    "publishedAt": "2021-03-24T12:25:08Z"
  },
  {
    "videoId": "eymnX-JI8Zc",
    "thumbnail": "https://i.ytimg.com/vi/eymnX-JI8Zc/mqdefault.jpg",
    "title": "【マイクラ】巨大ドット絵を建築！！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-03-25T12:14:15Z"
  },
  {
    "videoId": "FZj32UQsF8Y",
    "thumbnail": "https://i.ytimg.com/vi/FZj32UQsF8Y/mqdefault.jpg",
    "title": "【マイクラ】巨大ドット絵を建築！！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-03-25T17:05:47Z"
  },
  {
    "videoId": "qGVmLyBo2HI",
    "thumbnail": "https://i.ytimg.com/vi/qGVmLyBo2HI/mqdefault.jpg",
    "title": "【 MONSTER HUNTER RISE 】太古のハンター蘇る【 桐生ココ/ホロライブ】",
    "publishedAt": "2021-03-26T14:23:21Z"
  },
  {
    "videoId": "QwUqx2xoHCA",
    "thumbnail": "https://i.ytimg.com/vi/QwUqx2xoHCA/mqdefault.jpg",
    "title": "#4【龍が如くOF THE END】真島の兄貴、ゾンビに…！？【桐生ココ/ホロライブ】※ネタバレあり",
    "publishedAt": "2021-03-27T13:54:01Z"
  },
  {
    "videoId": "FOYt25Sv6po",
    "thumbnail": "https://i.ytimg.com/vi/FOYt25Sv6po/mqdefault.jpg",
    "title": "Reddit TRUE SEISO shitpost review with...",
    "publishedAt": "2021-03-28T04:04:49Z"
  },
  {
    "videoId": "qduJr1B1LN0",
    "thumbnail": "https://i.ytimg.com/vi/qduJr1B1LN0/mqdefault.jpg",
    "title": "【あさココPP漫才reddit歌枠】100万人記念！【BARCOCO凸待ち脱毛料理】",
    "publishedAt": "2021-03-28T14:20:01Z"
  },
  {
    "videoId": "BqhPE3hY264",
    "thumbnail": "https://i.ytimg.com/vi/BqhPE3hY264/mqdefault.jpg",
    "title": "かなココ漫才：\"桐生ココ\"",
    "publishedAt": "2021-03-29T01:10:41Z"
  },
  {
    "videoId": "KeDXk9OJ6bw",
    "thumbnail": "https://i.ytimg.com/vi/KeDXk9OJ6bw/mqdefault.jpg",
    "title": "ココおねいさんといっしょ【Old MacDonald】",
    "publishedAt": "2021-03-29T04:17:48Z"
  },
  {
    "videoId": "cp7Ycj1PE9I",
    "thumbnail": "https://i.ytimg.com/vi/cp7Ycj1PE9I/mqdefault.jpg",
    "title": "【マイクラ】初めてのドット絵！今日で完成！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-03-29T18:22:41Z"
  },
  {
    "videoId": "5gVkixM42g8",
    "thumbnail": "https://i.ytimg.com/vi/5gVkixM42g8/mqdefault.jpg",
    "title": "ねるまえ雑談！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-03-31T16:24:46Z"
  },
  {
    "videoId": "69ZUKNoN_Eo",
    "thumbnail": "https://i.ytimg.com/vi/69ZUKNoN_Eo/mqdefault.jpg",
    "title": "【マリオ】４面クリア目指すんだ！！桐生ココ/ホロライブ",
    "publishedAt": "2021-04-03T19:22:36Z"
  },
  {
    "videoId": "dm6ktkSJmCY",
    "thumbnail": "https://i.ytimg.com/vi/dm6ktkSJmCY/mqdefault.jpg",
    "title": "凸待ち Reddit Shitpost Review!!誰もこなかったらBEST GIRL",
    "publishedAt": "2021-04-04T03:11:59Z"
  },
  {
    "videoId": "gpsAazLejEY",
    "thumbnail": "https://i.ytimg.com/vi/gpsAazLejEY/mqdefault.jpg",
    "title": "【モンハンRISE】コラボに向けて古の知識を更新せよ！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-05T15:48:08Z"
  },
  {
    "videoId": "cS-p7qaayGE",
    "thumbnail": "https://i.ytimg.com/vi/cS-p7qaayGE/mqdefault.jpg",
    "title": "【マイクラ】うさ建新入社員の便所労働【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-06T07:44:06Z"
  },
  {
    "videoId": "bJGH2BfSQ1w",
    "thumbnail": "https://i.ytimg.com/vi/bJGH2BfSQ1w/mqdefault.jpg",
    "title": "【BAR COCO】ココママと晩酌。",
    "publishedAt": "2021-04-06T15:40:03Z"
  },
  {
    "videoId": "qWrmTtfUtQc",
    "thumbnail": "https://i.ytimg.com/vi/qWrmTtfUtQc/mqdefault.jpg",
    "title": "【KARAOKE】SINGING IDOL!!!【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-07T05:52:36Z"
  },
  {
    "videoId": "MuLHTdfUjiU",
    "thumbnail": "https://i.ytimg.com/vi/MuLHTdfUjiU/mqdefault.jpg",
    "title": "【マリオ】6面クリアやるぞぉぉぉぉ！！桐生ココ/ホロライブ",
    "publishedAt": "2021-04-07T13:57:15Z"
  },
  {
    "videoId": "MI2viqJb9us",
    "thumbnail": "https://i.ytimg.com/vi/MI2viqJb9us/mqdefault.jpg",
    "title": "【Monster Hunter RISE】いにしえプレイ更新中【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-08T13:22:07Z"
  },
  {
    "videoId": "3ZBATHjvnK8",
    "thumbnail": "https://i.ytimg.com/vi/3ZBATHjvnK8/mqdefault.jpg",
    "title": "【影廊】逃げろ！！！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-08T17:24:37Z"
  },
  {
    "videoId": "L8Q4PfhDIlA",
    "thumbnail": "https://i.ytimg.com/vi/L8Q4PfhDIlA/mqdefault.jpg",
    "title": "【モンハンRISE】里クエガンガンすすめる！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-09T10:58:44Z"
  },
  {
    "videoId": "CLx2fQvWFC8",
    "thumbnail": "https://i.ytimg.com/vi/CLx2fQvWFC8/mqdefault.jpg",
    "title": "【ARK】ARK視聴者サーバー復活！～reddit shit post を添えて～",
    "publishedAt": "2021-04-09T12:13:15Z"
  },
  {
    "videoId": "VY6JnkYUiYU",
    "thumbnail": "https://i.ytimg.com/vi/VY6JnkYUiYU/mqdefault.jpg",
    "title": "[ FALLOUT4 ] 敵本陣へカチコミじゃい！！[桐生ココ/ホロライブ]",
    "publishedAt": "2021-04-10T10:54:55Z"
  },
  {
    "videoId": "h0IHfKtLOcE",
    "thumbnail": "https://i.ytimg.com/vi/h0IHfKtLOcE/mqdefault.jpg",
    "title": "BIGG REVEAL",
    "publishedAt": "2021-04-10T12:47:29Z"
  },
  {
    "videoId": "RtY7ayP-n3M",
    "thumbnail": "https://i.ytimg.com/vi/RtY7ayP-n3M/mqdefault.jpg",
    "title": "【モンハンRISE】最終学歴MHP3のいにしえプレイ【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-10T18:11:49Z"
  },
  {
    "videoId": "Fyd6quCBX34",
    "thumbnail": "https://i.ytimg.com/vi/Fyd6quCBX34/mqdefault.jpg",
    "title": "I SMELL SHITPOSTS REDDIT!!!!!",
    "publishedAt": "2021-04-11T04:08:27Z"
  },
  {
    "videoId": "4W611JDSivE",
    "thumbnail": "https://i.ytimg.com/vi/4W611JDSivE/mqdefault.jpg",
    "title": "SHITPOST REVIEWバックステージ(直後)",
    "publishedAt": "2021-04-11T04:32:18Z"
  },
  {
    "videoId": "SUN2jEYdJtc",
    "thumbnail": "https://i.ytimg.com/vi/SUN2jEYdJtc/mqdefault.jpg",
    "title": "[ FALLOUT4 ] 息子と母のものがたり。[桐生ココ/ホロライブ]",
    "publishedAt": "2021-04-11T11:03:52Z"
  },
  {
    "videoId": "MgyBFCj-XBU",
    "thumbnail": "https://i.ytimg.com/vi/MgyBFCj-XBU/mqdefault.jpg",
    "title": "【モンハンライズ】オフ狩り行こうぜ！！！！【桐生ココ/白上フブキ/アキロゼ/角巻わため】",
    "publishedAt": "2021-04-12T15:51:55Z"
  },
  {
    "videoId": "fXmJlXeMdXM",
    "thumbnail": "https://i.ytimg.com/vi/fXmJlXeMdXM/mqdefault.jpg",
    "title": "【モンハンライズ】上位モンスターきたあああ【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-13T11:05:55Z"
  },
  {
    "videoId": "canGFqQEt64",
    "thumbnail": "https://i.ytimg.com/vi/canGFqQEt64/mqdefault.jpg",
    "title": "【雑談】タコパとかとかデートとかした話！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-13T17:53:08Z"
  },
  {
    "videoId": "X4w883zT8Js",
    "thumbnail": "https://i.ytimg.com/vi/X4w883zT8Js/mqdefault.jpg",
    "title": "【モンハンライズ】上位装備がないときつい【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-15T12:13:57Z"
  },
  {
    "videoId": "FjSaOjpfLgs",
    "thumbnail": "https://i.ytimg.com/vi/FjSaOjpfLgs/mqdefault.jpg",
    "title": "【桐生ココ】ＳＩＮＧ　ＩＴ　ＢＡＢＹ！【歌う】",
    "publishedAt": "2021-04-15T15:57:50Z"
  },
  {
    "videoId": "EG1N7RqOhQA",
    "thumbnail": "https://i.ytimg.com/vi/EG1N7RqOhQA/mqdefault.jpg",
    "title": "【モンハンライズ】目指せ全身上位装備！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-16T11:15:44Z"
  },
  {
    "videoId": "Az2PjLiGLH4",
    "thumbnail": "https://i.ytimg.com/vi/Az2PjLiGLH4/mqdefault.jpg",
    "title": "【影廊】逃　 げ　 る【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-16T17:18:29Z"
  },
  {
    "videoId": "BpKvu5VQpf4",
    "thumbnail": "https://i.ytimg.com/vi/BpKvu5VQpf4/mqdefault.jpg",
    "title": "きっと、うまくいく【映画同時視聴】",
    "publishedAt": "2021-04-17T15:56:10Z"
  },
  {
    "videoId": "bQFjNuUCtoI",
    "thumbnail": "https://i.ytimg.com/vi/bQFjNuUCtoI/mqdefault.jpg",
    "title": "REDDIT SHITPOST REVIEW with our dear doggo!",
    "publishedAt": "2021-04-18T04:06:26Z"
  },
  {
    "videoId": "4LQLRQPuZMM",
    "thumbnail": "https://i.ytimg.com/vi/4LQLRQPuZMM/mqdefault.jpg",
    "title": "【マイクラ】寝ながら　さぎょ　おしずかに",
    "publishedAt": "2021-04-18T11:11:54Z"
  },
  {
    "videoId": "slHzt7mCLY8",
    "thumbnail": "https://i.ytimg.com/vi/slHzt7mCLY8/mqdefault.jpg",
    "title": "【かなココ】上位モンスター狩りに行こうぜ！【ししらみ】",
    "publishedAt": "2021-04-20T14:17:52Z"
  },
  {
    "videoId": "CUayZQ4sxGQ",
    "thumbnail": "https://i.ytimg.com/vi/CUayZQ4sxGQ/mqdefault.jpg",
    "title": "【雑談】おはなししたい！女子会話✨",
    "publishedAt": "2021-04-20T18:25:26Z"
  },
  {
    "videoId": "20d7-LNaqcY",
    "thumbnail": "https://i.ytimg.com/vi/20d7-LNaqcY/mqdefault.jpg",
    "title": "【モンハンライズ】強く、なる！【ノエココかなるし】",
    "publishedAt": "2021-04-21T14:37:57Z"
  },
  {
    "videoId": "HBkJE0ZR35I",
    "thumbnail": "https://i.ytimg.com/vi/HBkJE0ZR35I/mqdefault.jpg",
    "title": "【新衣装】桐生ココ！新しい服！お披露目ぇ！！！【#新衣装桐生ココ】",
    "publishedAt": "2021-04-23T17:01:22Z"
  },
  {
    "videoId": "nMSK83e3Tw0",
    "thumbnail": "https://i.ytimg.com/vi/nMSK83e3Tw0/mqdefault.jpg",
    "title": "REDDIT SHITPOST REVIEW with KANATAN!",
    "publishedAt": "2021-04-25T04:05:59Z"
  },
  {
    "videoId": "lcvSgblcG4A",
    "thumbnail": "https://i.ytimg.com/vi/lcvSgblcG4A/mqdefault.jpg",
    "title": "【マイクラ】巨大建築の準備をまったりしよう！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-25T18:33:18Z"
  },
  {
    "videoId": "DPb638J0oz0",
    "thumbnail": "https://i.ytimg.com/vi/DPb638J0oz0/mqdefault.jpg",
    "title": "【マイクラ】はい。【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-26T17:20:41Z"
  },
  {
    "videoId": "uqabmlcQiho",
    "thumbnail": "https://i.ytimg.com/vi/uqabmlcQiho/mqdefault.jpg",
    "title": "Oh NO !!!!!!",
    "publishedAt": "2021-04-27T07:17:10Z"
  },
  {
    "videoId": "7LIs0PjbT4g",
    "thumbnail": "https://i.ytimg.com/vi/7LIs0PjbT4g/mqdefault.jpg",
    "title": "【モンハンライズ】★7チャレンジだぁ！！！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-27T17:45:47Z"
  },
  {
    "videoId": "yUjdAPR4Lx8",
    "thumbnail": "https://i.ytimg.com/vi/yUjdAPR4Lx8/mqdefault.jpg",
    "title": "新衣装桐生ココがげぼかわなだけの短い配信【グリーンバック素材】",
    "publishedAt": "2021-04-28T11:57:02Z"
  },
  {
    "videoId": "LWa8V9Aww1g",
    "thumbnail": "https://i.ytimg.com/vi/LWa8V9Aww1g/mqdefault.jpg",
    "title": "WANNA KNOW?",
    "publishedAt": "2021-04-28T16:25:39Z"
  },
  {
    "videoId": "6hd0I7CT1B4",
    "thumbnail": "https://i.ytimg.com/vi/6hd0I7CT1B4/mqdefault.jpg",
    "title": "【脱毛BAR COCO】脱毛しながら飲めるBAR【桐生ココ/ホロライブ】",
    "publishedAt": "2021-04-28T16:30:25Z"
  },
  {
    "videoId": "v7Ll1gvuloE",
    "thumbnail": "https://i.ytimg.com/vi/v7Ll1gvuloE/mqdefault.jpg",
    "title": "【duolingo】日本の人には簡単！？スペイン語にチャレンジ！【桐生ココ】",
    "publishedAt": "2021-04-29T04:02:09Z"
  },
  {
    "videoId": "0nnalTsRP1c",
    "thumbnail": "https://i.ytimg.com/vi/0nnalTsRP1c/mqdefault.jpg",
    "title": "#5【龍が如くOF THE END】関西の龍きたああ🐲【桐生ココ/ホロライブ】※ネタバレあり",
    "publishedAt": "2021-04-29T16:44:39Z"
  },
  {
    "videoId": "L3hAfpxRWQk",
    "thumbnail": "https://i.ytimg.com/vi/L3hAfpxRWQk/mqdefault.jpg",
    "title": "【duolingo】スペイン語de旅行!!🛫【桐生ココ】",
    "publishedAt": "2021-04-30T04:23:25Z"
  },
  {
    "videoId": "tKCFi9SJJFM",
    "thumbnail": "https://i.ytimg.com/vi/tKCFi9SJJFM/mqdefault.jpg",
    "title": "スペイン語で\"飲む\"は、BEBO",
    "publishedAt": "2021-04-30T06:50:13Z"
  },
  {
    "videoId": "2lC3prJYbOQ",
    "thumbnail": "https://i.ytimg.com/vi/2lC3prJYbOQ/mqdefault.jpg",
    "title": "【目指せ110万人】伸びしろ歌カウントダウン！【桐生ココ】",
    "publishedAt": "2021-04-30T11:52:03Z"
  },
  {
    "videoId": "yJvFn_7fL2k",
    "thumbnail": "https://i.ytimg.com/vi/yJvFn_7fL2k/mqdefault.jpg",
    "title": "#6【龍が如くOF THE END】甘美な死とは【桐生ココ/ホロライブ】※ネタバレあり",
    "publishedAt": "2021-04-30T20:16:58Z"
  },
  {
    "videoId": "IBNuaGdlJzE",
    "thumbnail": "https://i.ytimg.com/vi/IBNuaGdlJzE/mqdefault.jpg",
    "title": "【モンハンライズ】アプデ後初プレイ★HR上げたい【桐生ココ/ホロライブ】",
    "publishedAt": "2021-05-01T10:39:50Z"
  },
  {
    "videoId": "yr6T7mcfh4U",
    "thumbnail": "https://i.ytimg.com/vi/yr6T7mcfh4U/mqdefault.jpg",
    "title": "みんなのおかげで110万人💓感謝のスパチャ読み＆雑談！",
    "publishedAt": "2021-05-01T13:48:48Z"
  },
  {
    "videoId": "N8L4xAaGKxw",
    "thumbnail": "https://i.ytimg.com/vi/N8L4xAaGKxw/mqdefault.jpg",
    "title": "雑談＆スパチャ読み💓",
    "publishedAt": "2021-05-01T16:18:30Z"
  },
  {
    "videoId": "GhiPYhgsaVM",
    "thumbnail": "https://i.ytimg.com/vi/GhiPYhgsaVM/mqdefault.jpg",
    "title": "REDDIT SHITPOST REVIEW with LAMY!",
    "publishedAt": "2021-05-02T04:11:17Z"
  },
  {
    "videoId": "7qbGxzHCJAQ",
    "thumbnail": "https://i.ytimg.com/vi/7qbGxzHCJAQ/mqdefault.jpg",
    "title": "【モンハンライズ】急務！コラボまでにHRを上げろ！！",
    "publishedAt": "2021-05-02T12:38:42Z"
  },
  {
    "videoId": "EXOXmwVpu64",
    "thumbnail": "https://i.ytimg.com/vi/EXOXmwVpu64/mqdefault.jpg",
    "title": "【かなココししラミ】みんなでたのしく！【桐生ココ視点】",
    "publishedAt": "2021-05-02T16:15:46Z"
  },
  {
    "videoId": "imRmQw25KLU",
    "thumbnail": "https://i.ytimg.com/vi/imRmQw25KLU/mqdefault.jpg",
    "title": "【duolingo】目指せスペイン語マスター！【桐生ココ】",
    "publishedAt": "2021-05-03T04:28:40Z"
  },
  {
    "videoId": "GR83g-cXfRI",
    "thumbnail": "https://i.ytimg.com/vi/GR83g-cXfRI/mqdefault.jpg",
    "title": "【MINECRAFT】ゆっくり巨大建築しようやぁ【桐生ココ】",
    "publishedAt": "2021-05-03T17:29:42Z"
  },
  {
    "videoId": "VtJaDPoagGM",
    "thumbnail": "https://i.ytimg.com/vi/VtJaDPoagGM/mqdefault.jpg",
    "title": "【MINECRAFT】巨大YAGOO完成目指すんじゃぁあ【桐生ココ】",
    "publishedAt": "2021-05-04T17:04:16Z"
  },
  {
    "videoId": "N264SgsxeX0",
    "thumbnail": "https://i.ytimg.com/vi/N264SgsxeX0/mqdefault.jpg",
    "title": "【モンハンライズ】4期生みんなで狩りだぁ【桐生ココ視点】",
    "publishedAt": "2021-05-05T14:16:59Z"
  },
  {
    "videoId": "p33MZpAIfAA",
    "thumbnail": "https://i.ytimg.com/vi/p33MZpAIfAA/mqdefault.jpg",
    "title": "【slither.io】初めてのミミズびよーーーーーーーーん【桐生ココ/ホロライブ】",
    "publishedAt": "2021-05-07T16:25:25Z"
  },
  {
    "videoId": "lFnAkfnc68A",
    "thumbnail": "https://i.ytimg.com/vi/lFnAkfnc68A/mqdefault.jpg",
    "title": "REDDIT SHITPOST REVIEW with BOTAN!",
    "publishedAt": "2021-05-09T04:08:52Z"
  },
  {
    "videoId": "NCq9K4ql47Y",
    "thumbnail": "https://i.ytimg.com/vi/NCq9K4ql47Y/mqdefault.jpg",
    "title": "【duolingo】超初心者のスペイン語勉強！✏【桐生ココ】",
    "publishedAt": "2021-05-15T04:56:10Z"
  },
  {
    "videoId": "nDXtELgYMGA",
    "thumbnail": "https://i.ytimg.com/vi/nDXtELgYMGA/mqdefault.jpg",
    "title": "【雑談】すんごいのみろ【桐生ココ/ホロライブ】",
    "publishedAt": "2021-05-15T17:46:38Z"
  },
  {
    "videoId": "RH2Z7jP8fbY",
    "thumbnail": "https://i.ytimg.com/vi/RH2Z7jP8fbY/mqdefault.jpg",
    "title": "REDDIT SHITPOST REVIEW with husbando...?",
    "publishedAt": "2021-05-16T04:18:00Z"
  },
  {
    "videoId": "O-qj4xaTH70",
    "thumbnail": "https://i.ytimg.com/vi/O-qj4xaTH70/mqdefault.jpg",
    "title": "SINGING.....🎵",
    "publishedAt": "2021-05-16T13:36:32Z"
  },
  {
    "videoId": "hgIhAh72zJs",
    "thumbnail": "https://i.ytimg.com/vi/hgIhAh72zJs/mqdefault.jpg",
    "title": "【あつまれどうぶつの森】初めての無人島？生活！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-05-16T16:03:52Z"
  },
  {
    "videoId": "H6S4Jr2oA2A",
    "thumbnail": "https://i.ytimg.com/vi/H6S4Jr2oA2A/mqdefault.jpg",
    "title": "【あつまれどうぶつの森】今日で5000マイル返済ッ！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-05-17T17:48:25Z"
  },
  {
    "videoId": "h0spe3scsOM",
    "thumbnail": "https://i.ytimg.com/vi/h0spe3scsOM/mqdefault.jpg",
    "title": "【slither.io】へたくそミミズ道🐉長さ1万耐久【桐生ココ/ホロライブ】",
    "publishedAt": "2021-05-19T00:23:52Z"
  },
  {
    "videoId": "XTcDzLCeaXQ",
    "thumbnail": "https://i.ytimg.com/vi/XTcDzLCeaXQ/mqdefault.jpg",
    "title": "【BAR COCO】ココママと楽しいお酒を【マシュマロ晩酌】",
    "publishedAt": "2021-05-19T16:47:25Z"
  },
  {
    "videoId": "JEmGGXAdKOE",
    "thumbnail": "https://i.ytimg.com/vi/JEmGGXAdKOE/mqdefault.jpg",
    "title": "スパチャ読み感謝雑談＆オルタナティブ同時視聴",
    "publishedAt": "2021-05-21T11:19:06Z"
  },
  {
    "videoId": "PV8s0vkBvNM",
    "thumbnail": "https://i.ytimg.com/vi/PV8s0vkBvNM/mqdefault.jpg",
    "title": "【犬鳴トンネル】げぼこわホラゲ【桐生ココ/ホロライブ】",
    "publishedAt": "2021-05-21T15:20:01Z"
  },
  {
    "videoId": "sZSt0B7PaqQ",
    "thumbnail": "https://i.ytimg.com/vi/sZSt0B7PaqQ/mqdefault.jpg",
    "title": "【ウマ娘】ナリタブライアンを神引き＆初育成！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-05-22T18:00:43Z"
  },
  {
    "videoId": "YTTnA4MQkg0",
    "thumbnail": "https://i.ytimg.com/vi/YTTnA4MQkg0/mqdefault.jpg",
    "title": "REDDIT SHITPOST REVIEW with Calli",
    "publishedAt": "2021-05-23T04:10:22Z"
  },
  {
    "videoId": "AJK9MVMVP_s",
    "thumbnail": "https://i.ytimg.com/vi/AJK9MVMVP_s/mqdefault.jpg",
    "title": "【マイクラ】うさ建出勤！べんじょ！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-05-24T14:22:56Z"
  },
  {
    "videoId": "_bpxBguuIEs",
    "thumbnail": "https://i.ytimg.com/vi/_bpxBguuIEs/mqdefault.jpg",
    "title": "【マリオカート8DX】視聴者参加型！3位以内目指す！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-05-25T17:12:13Z"
  },
  {
    "videoId": "ShtOgoWj7_4",
    "thumbnail": "https://i.ytimg.com/vi/ShtOgoWj7_4/mqdefault.jpg",
    "title": "【あつまれどうぶつの森】マイホームでさらに借金生活ぅぅ【桐生ココ/ホロライブ】",
    "publishedAt": "2021-05-27T15:13:42Z"
  },
  {
    "videoId": "ulEXGKj4ioI",
    "thumbnail": "https://i.ytimg.com/vi/ulEXGKj4ioI/mqdefault.jpg",
    "title": "【君・・・】マッチングアプリで出会い厨してみた【写真と違わない？】桐生ココ",
    "publishedAt": "2021-05-28T16:15:15Z"
  },
  {
    "videoId": "v8g_rPCaaic",
    "thumbnail": "https://i.ytimg.com/vi/v8g_rPCaaic/mqdefault.jpg",
    "title": "【モンハンライズ】アプデきた！超初見バルファルク狩りじゃ！！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-05-29T18:23:16Z"
  },
  {
    "videoId": "CjKTHQhOR_I",
    "thumbnail": "https://i.ytimg.com/vi/CjKTHQhOR_I/mqdefault.jpg",
    "title": "REDDIT MEME REVIEW with MOONA!",
    "publishedAt": "2021-05-30T04:08:45Z"
  },
  {
    "videoId": "w8asvUNkerM",
    "thumbnail": "https://i.ytimg.com/vi/w8asvUNkerM/mqdefault.jpg",
    "title": "【雑談】いろいろあっただな！【桐生ココ】",
    "publishedAt": "2021-05-31T16:23:02Z"
  },
  {
    "videoId": "eowuilXIdGo",
    "thumbnail": "https://i.ytimg.com/vi/eowuilXIdGo/mqdefault.jpg",
    "title": "【モンハンライズ】#かなココとモンハン　視聴者参加型狩り！【桐生ココ/天音かなた】",
    "publishedAt": "2021-06-01T07:17:36Z"
  },
  {
    "videoId": "BTuQwGztgaw",
    "thumbnail": "https://i.ytimg.com/vi/BTuQwGztgaw/mqdefault.jpg",
    "title": "【ウマ娘】エアグルーヴちゃん神引きする！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-01T16:10:01Z"
  },
  {
    "videoId": "2ds6W8tK3Ns",
    "thumbnail": "https://i.ytimg.com/vi/2ds6W8tK3Ns/mqdefault.jpg",
    "title": "【マイクラ】ウサ建夏祭りの準備をしなきゃぁ！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-03T07:27:37Z"
  },
  {
    "videoId": "Y_q1L9Kv03o",
    "thumbnail": "https://i.ytimg.com/vi/Y_q1L9Kv03o/mqdefault.jpg",
    "title": "【SIMS4】かなココハウスを再現！？続・妄想ホロハウス！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-03T18:42:10Z"
  },
  {
    "videoId": "Y5TtoyvSZcs",
    "thumbnail": "https://i.ytimg.com/vi/Y5TtoyvSZcs/mqdefault.jpg",
    "title": "ようつべグルグルハズレ枠の為中止",
    "publishedAt": "2021-06-04T13:18:32Z"
  },
  {
    "videoId": "jS3AsDT0M7Q",
    "thumbnail": "https://i.ytimg.com/vi/jS3AsDT0M7Q/mqdefault.jpg",
    "title": "【Minecraft】ウサ建屋台🍉初めての旗づくり！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-04T17:28:44Z"
  },
  {
    "videoId": "i4eSifxlKCg",
    "thumbnail": "https://i.ytimg.com/vi/i4eSifxlKCg/mqdefault.jpg",
    "title": "【BAR COCO🍸】1週間お疲れ様、さぁママと楽しく呑みましょう🍻【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-05T16:49:35Z"
  },
  {
    "videoId": "sUEOzhkOSAk",
    "thumbnail": "https://i.ytimg.com/vi/sUEOzhkOSAk/mqdefault.jpg",
    "title": "REDDIT MEME REVIEW with...Luna, Towa and Kanata!",
    "publishedAt": "2021-06-06T04:06:00Z"
  },
  {
    "videoId": "IpeQYlRdDko",
    "thumbnail": "https://i.ytimg.com/vi/IpeQYlRdDko/mqdefault.jpg",
    "title": "【いただきストリートDQ＆FF】わちゃわちゃ資産争奪戦！【#アキるしかなココ】",
    "publishedAt": "2021-06-06T17:05:36Z"
  },
  {
    "videoId": "0Rm8uKYa51w",
    "thumbnail": "https://i.ytimg.com/vi/0Rm8uKYa51w/mqdefault.jpg",
    "title": "【モンハンライズ】狩りだ狩りだ狩りだーー！【#バカタレドラゴンズ】",
    "publishedAt": "2021-06-07T17:53:59Z"
  },
  {
    "videoId": "6Q-fX1E6B_s",
    "thumbnail": "https://i.ytimg.com/vi/6Q-fX1E6B_s/mqdefault.jpg",
    "title": "桐生ココからみなさんへ大切なお知らせ",
    "publishedAt": "2021-06-09T03:16:18Z"
  },
  {
    "videoId": "_ooeKl7Eq5I",
    "thumbnail": "https://i.ytimg.com/vi/_ooeKl7Eq5I/mqdefault.jpg",
    "title": "【雑談】近況報告っ！雑談☕【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-09T13:12:10Z"
  },
  {
    "videoId": "tzXmZIEfJn4",
    "thumbnail": "https://i.ytimg.com/vi/tzXmZIEfJn4/mqdefault.jpg",
    "title": "【マイクラ】4期生ピクセルアート！💗思い出を作ろう💗【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-10T12:46:40Z"
  },
  {
    "videoId": "DoJbyF_mb8M",
    "thumbnail": "https://i.ytimg.com/vi/DoJbyF_mb8M/mqdefault.jpg",
    "title": "【Quest Rooms】死のゲームのはじまりだぜ💩【#バカタレドラゴンズ】",
    "publishedAt": "2021-06-11T10:45:22Z"
  },
  {
    "videoId": "S1Kx7Hc018c",
    "thumbnail": "https://i.ytimg.com/vi/S1Kx7Hc018c/mqdefault.jpg",
    "title": "【晩酌雑談】まぁゆっくり話そうや🍻【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-11T19:15:03Z"
  },
  {
    "videoId": "ZoO6WijuXB4",
    "thumbnail": "https://i.ytimg.com/vi/ZoO6WijuXB4/mqdefault.jpg",
    "title": "【歌枠】楽しく歌おう♪伸びしろ伸ばそう♪【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-12T16:24:42Z"
  },
  {
    "videoId": "5OgO3PDI3ko",
    "thumbnail": "https://i.ytimg.com/vi/5OgO3PDI3ko/mqdefault.jpg",
    "title": "REDDIT SHITPOST REVIEW with... AMELIA!",
    "publishedAt": "2021-06-13T04:12:34Z"
  },
  {
    "videoId": "_cv1CwIkGxQ",
    "thumbnail": "https://i.ytimg.com/vi/_cv1CwIkGxQ/mqdefault.jpg",
    "title": "【マイクラ】4期生ピクセル作り💗わためぇ💗【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-13T17:53:34Z"
  },
  {
    "videoId": "9Q7SzZ1RNqo",
    "thumbnail": "https://i.ytimg.com/vi/9Q7SzZ1RNqo/mqdefault.jpg",
    "title": "【カウントダウン】3502歳のお誕生日を一緒に迎えてよね！！🐉🎁",
    "publishedAt": "2021-06-16T15:40:00Z"
  },
  {
    "videoId": "SwodJntnYBg",
    "thumbnail": "https://i.ytimg.com/vi/SwodJntnYBg/mqdefault.jpg",
    "title": "【#桐生ココ生誕祭】あさココLIVEニュース？6月17日【#HappyBdayCoco】🐉",
    "publishedAt": "2021-06-17T12:17:27Z"
  },
  {
    "videoId": "Fbr5CeK8CSE",
    "thumbnail": "https://i.ytimg.com/vi/Fbr5CeK8CSE/mqdefault.jpg",
    "title": "おいおいおいおい",
    "publishedAt": "2021-06-18T16:21:49Z"
  },
  {
    "videoId": "stromNFvVIQ",
    "thumbnail": "https://i.ytimg.com/vi/stromNFvVIQ/mqdefault.jpg",
    "title": "【スーパーボンバーマンRオンライン】戦じゃぁ！オラオラオラ～💣【#バカタレドラゴンズ】",
    "publishedAt": "2021-06-19T10:29:22Z"
  },
  {
    "videoId": "eRG5U7xt170",
    "thumbnail": "https://i.ytimg.com/vi/eRG5U7xt170/mqdefault.jpg",
    "title": "せくしー足組み☆",
    "publishedAt": "2021-06-19T11:07:56Z"
  },
  {
    "videoId": "U0uNaGMCY4s",
    "thumbnail": "https://i.ytimg.com/vi/U0uNaGMCY4s/mqdefault.jpg",
    "title": "Reddit Shitpost Review with kusogaki Shion!",
    "publishedAt": "2021-06-20T04:09:44Z"
  },
  {
    "videoId": "Hax9u8qPpB8",
    "thumbnail": "https://i.ytimg.com/vi/Hax9u8qPpB8/mqdefault.jpg",
    "title": "【マイクラ】思い出のピクセルアートすすめましょ【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-20T17:38:40Z"
  },
  {
    "videoId": "klX-l3hj8jo",
    "thumbnail": "https://i.ytimg.com/vi/klX-l3hj8jo/mqdefault.jpg",
    "title": "【#ホロAmongUs】ま　け　ん　ぞ【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-21T16:00:30Z"
  },
  {
    "videoId": "jB48OrSwapc",
    "thumbnail": "https://i.ytimg.com/vi/jB48OrSwapc/mqdefault.jpg",
    "title": "【いただきストリートDQ＆FF】覚悟ッ！🎲破産覚悟のガチぼこ再戦！💰【#アキるしかなココ】",
    "publishedAt": "2021-06-22T13:30:19Z"
  },
  {
    "videoId": "fiWdXnXw_zA",
    "thumbnail": "https://i.ytimg.com/vi/fiWdXnXw_zA/mqdefault.jpg",
    "title": "新衣装をお披露目してしまうのです！#桐生ココ新衣装",
    "publishedAt": "2021-06-23T16:43:24Z"
  },
  {
    "videoId": "4U8bLa6egiU",
    "thumbnail": "https://i.ytimg.com/vi/4U8bLa6egiU/mqdefault.jpg",
    "title": "【マイクラ】高みの見物台をスピード作成！ #うさ建ステージリレー【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-24T11:37:00Z"
  },
  {
    "videoId": "MVIWU6Ni-eQ",
    "thumbnail": "https://i.ytimg.com/vi/MVIWU6Ni-eQ/mqdefault.jpg",
    "title": "【#キセキ結び】18:00公開MV同時視聴✨【4期オリジナルソング】",
    "publishedAt": "2021-06-25T09:37:40Z"
  },
  {
    "videoId": "vjWbEkOkSms",
    "thumbnail": "https://i.ytimg.com/vi/vjWbEkOkSms/mqdefault.jpg",
    "title": "【 #VSホロカート 】奇跡を信じる🏆【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-25T12:32:21Z"
  },
  {
    "videoId": "g17btQ_W5Sk",
    "thumbnail": "https://i.ytimg.com/vi/g17btQ_W5Sk/mqdefault.jpg",
    "title": "【BARCOCO🍸】1杯目は、ココママの奢り。【マシュマロ雑談】",
    "publishedAt": "2021-06-26T16:49:14Z"
  },
  {
    "videoId": "r2oJYmXHYZs",
    "thumbnail": "https://i.ytimg.com/vi/r2oJYmXHYZs/mqdefault.jpg",
    "title": "REDDIT SHITPOST REVIEW -last meme!- with KUSO TORI KIARA!",
    "publishedAt": "2021-06-27T03:26:58Z"
  },
  {
    "videoId": "khRDaLiyGdA",
    "thumbnail": "https://i.ytimg.com/vi/khRDaLiyGdA/mqdefault.jpg",
    "title": "【オリジナル曲】Weather Hackers☆ / 桐生ココ",
    "publishedAt": "2021-06-27T15:00:11Z"
  },
  {
    "videoId": "a_Z5MobpBJo",
    "thumbnail": "https://i.ytimg.com/vi/a_Z5MobpBJo/mqdefault.jpg",
    "title": "【マイクラ】#うさ建夏祭り 何も考えずに楽しもう！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-27T15:29:54Z"
  },
  {
    "videoId": "f_djNpDqm3Q",
    "thumbnail": "https://i.ytimg.com/vi/f_djNpDqm3Q/mqdefault.jpg",
    "title": "ファンサ／桐生ココ cover 【歌ってみた】",
    "publishedAt": "2021-06-28T13:00:12Z"
  },
  {
    "videoId": "3khjT094-PY",
    "thumbnail": "https://i.ytimg.com/vi/3khjT094-PY/mqdefault.jpg",
    "title": "【歌枠】登録者130万人カウントダウン✨いけーっ！！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-28T13:27:25Z"
  },
  {
    "videoId": "8a3to2eVtGk",
    "thumbnail": "https://i.ytimg.com/vi/8a3to2eVtGk/mqdefault.jpg",
    "title": "【雑談】楽しんでいるか！たつのこ達🐉！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-28T15:45:31Z"
  },
  {
    "videoId": "PqTA58UkGkA",
    "thumbnail": "https://i.ytimg.com/vi/PqTA58UkGkA/mqdefault.jpg",
    "title": "【YAGOO】桐生会事務所に社長を呼び出してみた【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-29T13:00:13Z"
  },
  {
    "videoId": "T2cKoToVJaI",
    "thumbnail": "https://i.ytimg.com/vi/T2cKoToVJaI/mqdefault.jpg",
    "title": "【ARK】視聴者サーバー訪問！＆みんなで遊ぼ！【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-30T15:01:29Z"
  },
  {
    "videoId": "Zxlq78SZC58",
    "thumbnail": "https://i.ytimg.com/vi/Zxlq78SZC58/mqdefault.jpg",
    "title": "【雑談】YAGOO呼び出し裏話などまったり💗【桐生ココ/ホロライブ】",
    "publishedAt": "2021-06-30T17:10:17Z"
  },
  {
    "videoId": "Z139LhmhIQw",
    "thumbnail": "https://i.ytimg.com/vi/Z139LhmhIQw/mqdefault.jpg",
    "title": "【料理配信】かなココ朝食クッキング【桐生ココ/天音かなた】",
    "publishedAt": "2021-07-01T01:48:28Z"
  },
  {
    "videoId": "3McazDzNuO4",
    "thumbnail": "https://i.ytimg.com/vi/3McazDzNuO4/mqdefault.jpg",
    "title": "【マイクラ】最後の4期コラボ🐉楽しもう！【＃ほろふぉーす】",
    "publishedAt": "2021-07-01T04:24:30Z"
  },
  {
    "videoId": "IhiievWaZMI",
    "thumbnail": "https://i.ytimg.com/vi/IhiievWaZMI/mqdefault.jpg",
    "title": "卒業。　#桐生ココ卒業LIVE #GoodbyeCoco",
    "publishedAt": "2021-07-01T13:11:09Z"
  },
  {
    "videoId": "LT__We9HFYU",
    "thumbnail": "https://i.ytimg.com/vi/LT__We9HFYU/mqdefault.jpg",
    "title": "Weather Hackers☆ / 桐生ココ 卒業ライブver【#桐生ココ卒業LIVE】",
    "publishedAt": "2021-07-02T15:00:12Z"
  }
],
  Subaru :
  [
  {
    "videoId": "qrZtEACCwIU",
    "thumbnail": "https://i.ytimg.com/vi/qrZtEACCwIU/mqdefault.jpg",
    "title": "【ガチ恋】どぅーまいべすと！歌ってみた！【ぢろ】",
    "publishedAt": "2020-01-18T13:00:09Z"
  },
  {
    "videoId": "I4wouNP9EC8",
    "thumbnail": "https://i.ytimg.com/vi/I4wouNP9EC8/mqdefault.jpg",
    "title": "【体験】コスプレカフェに母ちゃんと行ったら軍人に根性叩き直されたの巻【 レポート】",
    "publishedAt": "2020-01-29T15:37:03Z"
  },
  {
    "videoId": "tUD46kVJH58",
    "thumbnail": "https://i.ytimg.com/vi/tUD46kVJH58/mqdefault.jpg",
    "title": "【初心者🔰】ティラノサウルスの神になる！！！！！【ARK】",
    "publishedAt": "2020-01-31T16:33:18Z"
  },
  {
    "videoId": "KNVM-Ka-qa0",
    "thumbnail": "https://i.ytimg.com/vi/KNVM-Ka-qa0/mqdefault.jpg",
    "title": "【初地獄】会って０秒で即コラボ？！ホロライブ明るいメンヘラ組お見合い企画【 #トワスバ 】",
    "publishedAt": "2020-02-01T12:10:59Z"
  },
  {
    "videoId": "8iXGFVfKYgc",
    "thumbnail": "https://i.ytimg.com/vi/8iXGFVfKYgc/mqdefault.jpg",
    "title": "【UNDERTALE】Pルートで号泣するだけのスバル 【初見Pルート攻略】",
    "publishedAt": "2020-02-06T14:35:02Z"
  },
  {
    "videoId": "MndFEme2vlM",
    "thumbnail": "https://i.ytimg.com/vi/MndFEme2vlM/mqdefault.jpg",
    "title": "【ARK】最早なんでもいいからテイムしたいスバルさま【ホロ鯖】",
    "publishedAt": "2020-02-06T16:42:40Z"
  },
  {
    "videoId": "Zac38GLwLPg",
    "thumbnail": "https://i.ytimg.com/vi/Zac38GLwLPg/mqdefault.jpg",
    "title": "【人生初】あつめろどうぶつの森　初日【どうぶつの森シリーズ】",
    "publishedAt": "2020-03-19T17:35:24Z"
  },
  {
    "videoId": "7X2l2X3UtWE",
    "thumbnail": "https://i.ytimg.com/vi/7X2l2X3UtWE/mqdefault.jpg",
    "title": "【視聴者参加型】あつ森のスバルの家を0から視聴者がコーディネートする企画【アイドルの部屋公開】",
    "publishedAt": "2020-03-31T14:14:23Z"
  },
  {
    "videoId": "j7pscvBhPWc",
    "thumbnail": "https://i.ytimg.com/vi/j7pscvBhPWc/mqdefault.jpg",
    "title": "【視聴者参加型】大空家テトリス大会練習日記！！プレイ時間20時間目【ガチ練枠】",
    "publishedAt": "2020-04-02T11:37:57Z"
  },
  {
    "videoId": "PG9Htrxb1i4",
    "thumbnail": "https://i.ytimg.com/vi/PG9Htrxb1i4/mqdefault.jpg",
    "title": "【ホラゲー】steam評価🌟10？！MadFatherする！！1日目【ホロライブ/大空スバル】",
    "publishedAt": "2020-04-30T13:15:04Z"
  },
  {
    "videoId": "rhIoSNoCI6c",
    "thumbnail": "https://i.ytimg.com/vi/rhIoSNoCI6c/mqdefault.jpg",
    "title": "【ホラゲー】steam評価🌟10？！MadFatherする！！2日目【ホロライブ/大空スバル】",
    "publishedAt": "2020-05-05T10:57:01Z"
  },
  {
    "videoId": "5yj-K9ybHBQ",
    "thumbnail": "https://i.ytimg.com/vi/5yj-K9ybHBQ/mqdefault.jpg",
    "title": "【祝四周年】視聴者参加ソーセージレジェンド大会！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-05-10T13:46:49Z"
  },
  {
    "videoId": "AhBUH10655I",
    "thumbnail": "https://i.ytimg.com/vi/AhBUH10655I/mqdefault.jpg",
    "title": "【初見実況#1】ニーアオートマタ：NieR:Automata【ホロライブ/大空スバル】",
    "publishedAt": "2020-05-17T08:52:02Z"
  },
  {
    "videoId": "OmscV_eTkLo",
    "thumbnail": "https://i.ytimg.com/vi/OmscV_eTkLo/mqdefault.jpg",
    "title": "【初見実況#2】ニーアオートマタ：NieR:Automata【ホロライブ/大空スバル】",
    "publishedAt": "2020-05-20T13:37:14Z"
  },
  {
    "videoId": "7WZUqtnSahw",
    "thumbnail": "https://i.ytimg.com/vi/7WZUqtnSahw/mqdefault.jpg",
    "title": "【ホラゲー】steam評価🌟10？！MadFatherする！！最終回【ホロライブ/大空スバル】",
    "publishedAt": "2020-05-22T14:27:25Z"
  },
  {
    "videoId": "bv18ednRKsk",
    "thumbnail": "https://i.ytimg.com/vi/bv18ednRKsk/mqdefault.jpg",
    "title": "【初見実況#3】ニーアオートマタ【ホロライブ/大空スバル】",
    "publishedAt": "2020-05-23T11:34:04Z"
  },
  {
    "videoId": "wDw_Jh7COUM",
    "thumbnail": "https://i.ytimg.com/vi/wDw_Jh7COUM/mqdefault.jpg",
    "title": "【初見実況#４】2ルート目！！ニーアオートマタ【ホロライブ/大空スバル】",
    "publishedAt": "2020-05-24T13:10:27Z"
  },
  {
    "videoId": "CilmeyFFZVg",
    "thumbnail": "https://i.ytimg.com/vi/CilmeyFFZVg/mqdefault.jpg",
    "title": "【初見実況#5】2ルート目！！ニーアオートマタ【ホロライブ/大空スバル】",
    "publishedAt": "2020-05-27T14:31:17Z"
  },
  {
    "videoId": "_9wjzXgUNZg",
    "thumbnail": "https://i.ytimg.com/vi/_9wjzXgUNZg/mqdefault.jpg",
    "title": "【初見実況#6】2ルート目！！ニーアオートマタ：NieR:Automata【ホロライブ/大空スバル】",
    "publishedAt": "2020-05-30T11:30:28Z"
  },
  {
    "videoId": "ThtcrBgB4KY",
    "thumbnail": "https://i.ytimg.com/vi/ThtcrBgB4KY/mqdefault.jpg",
    "title": "【初見実況#7】3ルート目！！ニーアオートマタ：NieR:Automata【ホロライブ/大空スバル】",
    "publishedAt": "2020-05-31T15:03:02Z"
  },
  {
    "videoId": "cU3-w6Mlbu4",
    "thumbnail": "https://i.ytimg.com/vi/cU3-w6Mlbu4/mqdefault.jpg",
    "title": "【DM雑談】あなたの推し布教の仕方教えてください！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-03T12:40:48Z"
  },
  {
    "videoId": "p7MHDoDgNJE",
    "thumbnail": "https://i.ytimg.com/vi/p7MHDoDgNJE/mqdefault.jpg",
    "title": "【初体験レポ】他称陽キャが人生初ソロでアニメイトに行った結果【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-04T13:30:07Z"
  },
  {
    "videoId": "Teyrh2YgkMc",
    "thumbnail": "https://i.ytimg.com/vi/Teyrh2YgkMc/mqdefault.jpg",
    "title": "【これが】ホロライブVtuberのリアルな1日レポート！？大空スバルの場合【リアルだ】",
    "publishedAt": "2020-06-05T14:46:39Z"
  },
  {
    "videoId": "bmwV1JGEGMU",
    "thumbnail": "https://i.ytimg.com/vi/bmwV1JGEGMU/mqdefault.jpg",
    "title": "【まったり雑談】06/06  おはようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-06T02:59:33Z"
  },
  {
    "videoId": "HNkd9KYdORo",
    "thumbnail": "https://i.ytimg.com/vi/HNkd9KYdORo/mqdefault.jpg",
    "title": "【まったり雑談】06/07  スバルの陽キャの歴史のぞいてく？？【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-07T07:58:54Z"
  },
  {
    "videoId": "3cO6p2413f0",
    "thumbnail": "https://i.ytimg.com/vi/3cO6p2413f0/mqdefault.jpg",
    "title": "【視聴者参加型】IQ５憶のスバルと学力バトルッス！！！！【クイズバトルオンライン】",
    "publishedAt": "2020-06-09T12:25:29Z"
  },
  {
    "videoId": "ksrSUoMrQBg",
    "thumbnail": "https://i.ytimg.com/vi/ksrSUoMrQBg/mqdefault.jpg",
    "title": "【雑談】家族のおもしろエピソード雑談！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-10T11:24:51Z"
  },
  {
    "videoId": "wXxrf7NOzmA",
    "thumbnail": "https://i.ytimg.com/vi/wXxrf7NOzmA/mqdefault.jpg",
    "title": "【 #ホロワードウルフ 】ワードウルフホロライブ！！！！！！【勝！！！！！】",
    "publishedAt": "2020-06-11T15:26:45Z"
  },
  {
    "videoId": "zs47h3uXbYg",
    "thumbnail": "https://i.ytimg.com/vi/zs47h3uXbYg/mqdefault.jpg",
    "title": "【 #100均ホロライブ 】メンバーの私物を見抜け！！！！100均ホロライブ！！！【yhea!!】",
    "publishedAt": "2020-06-12T14:15:08Z"
  },
  {
    "videoId": "Qa6NQVmTPt0",
    "thumbnail": "https://i.ytimg.com/vi/Qa6NQVmTPt0/mqdefault.jpg",
    "title": "【まったり雑談】06/13  おあようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-13T03:15:16Z"
  },
  {
    "videoId": "kVnUHnz8mcc",
    "thumbnail": "https://i.ytimg.com/vi/kVnUHnz8mcc/mqdefault.jpg",
    "title": "【 #WWhololive 】ワールドワイドホロライブ！！国際交流するッス！！！【日本語放送】",
    "publishedAt": "2020-06-13T11:16:06Z"
  },
  {
    "videoId": "3w2zCBc304M",
    "thumbnail": "https://i.ytimg.com/vi/3w2zCBc304M/mqdefault.jpg",
    "title": "【やるぞ】第5回ソーセージレジェンド大会大空スバル杯【神ゲー】",
    "publishedAt": "2020-06-14T15:40:04Z"
  },
  {
    "videoId": "m_7wMJfMKiQ",
    "thumbnail": "https://i.ytimg.com/vi/m_7wMJfMKiQ/mqdefault.jpg",
    "title": "【雑談】スバルの１番の闇期、小学校時代のぞいてく？？？？【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-18T13:57:42Z"
  },
  {
    "videoId": "DK_JVq6qXTk",
    "thumbnail": "https://i.ytimg.com/vi/DK_JVq6qXTk/mqdefault.jpg",
    "title": "【Citiies Skyline】スバル市長！！ホロライブシティ作るッス！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-19T12:35:23Z"
  },
  {
    "videoId": "BNNUSaKxQZc",
    "thumbnail": "https://i.ytimg.com/vi/BNNUSaKxQZc/mqdefault.jpg",
    "title": "【まったり雑談】06/20  おあようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-20T04:09:35Z"
  },
  {
    "videoId": "xxBVoLB6eMA",
    "thumbnail": "https://i.ytimg.com/vi/xxBVoLB6eMA/mqdefault.jpg",
    "title": "【 #ホロライブFAMS 】嘘を真実に変えろ！エイプリルフールゲーム【嘘つき人狼】",
    "publishedAt": "2020-06-20T14:32:56Z"
  },
  {
    "videoId": "AdyTUvrpMuk",
    "thumbnail": "https://i.ytimg.com/vi/AdyTUvrpMuk/mqdefault.jpg",
    "title": "【初見実況】アサシンクリード4！！！やる！！！！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-21T08:25:00Z"
  },
  {
    "videoId": "56e4tcsyHlI",
    "thumbnail": "https://i.ytimg.com/vi/56e4tcsyHlI/mqdefault.jpg",
    "title": "【アｱｱｱｱｱｱｱｱｱｱ】うたう【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-23T13:06:55Z"
  },
  {
    "videoId": "QvaYA-6BvJw",
    "thumbnail": "https://i.ytimg.com/vi/QvaYA-6BvJw/mqdefault.jpg",
    "title": "【初見実況#２】アサシンクリード4！！！やる！！！！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-24T14:09:21Z"
  },
  {
    "videoId": "apnpllIWDsE",
    "thumbnail": "https://i.ytimg.com/vi/apnpllIWDsE/mqdefault.jpg",
    "title": "【DM雑談】俺の！私の！！おすすめオタ活！！～日常に推しを添えて～【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-25T14:43:09Z"
  },
  {
    "videoId": "t-Y-UnC2HQo",
    "thumbnail": "https://i.ytimg.com/vi/t-Y-UnC2HQo/mqdefault.jpg",
    "title": "【うたみた】恋の魔法【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-26T13:30:04Z"
  },
  {
    "videoId": "Z3sPjFphtAk",
    "thumbnail": "https://i.ytimg.com/vi/Z3sPjFphtAk/mqdefault.jpg",
    "title": "【まったり雑談】06/27  おあようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-27T02:27:08Z"
  },
  {
    "videoId": "n5gjfie8sQY",
    "thumbnail": "https://i.ytimg.com/vi/n5gjfie8sQY/mqdefault.jpg",
    "title": "【俺の話を 】#ホロライバーの主張 【聞け】",
    "publishedAt": "2020-06-27T11:59:11Z"
  },
  {
    "videoId": "HpmNOPEWFCI",
    "thumbnail": "https://i.ytimg.com/vi/HpmNOPEWFCI/mqdefault.jpg",
    "title": "【初見実況#３】アサシンクリード4！！！やる！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-28T10:07:11Z"
  },
  {
    "videoId": "yU1l7Ek9eZk",
    "thumbnail": "https://i.ytimg.com/vi/yU1l7Ek9eZk/mqdefault.jpg",
    "title": "【視聴者参加型】第二回！IQ５憶のスバルと学力バトルッス！！！！【クイズバトルオンライン】",
    "publishedAt": "2020-06-28T13:38:25Z"
  },
  {
    "videoId": "X6uHxzwMTnU",
    "thumbnail": "https://i.ytimg.com/vi/X6uHxzwMTnU/mqdefault.jpg",
    "title": "【Citiies Skyline】スバル市長！！関所で経済を立て直すッス！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-06-30T16:42:43Z"
  },
  {
    "videoId": "ljPIJJ9Y09U",
    "thumbnail": "https://i.ytimg.com/vi/ljPIJJ9Y09U/mqdefault.jpg",
    "title": "【おはなし】生誕祭前の雑談&振り返り放送【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-01T16:47:18Z"
  },
  {
    "videoId": "ODT0DOpfU-0",
    "thumbnail": "https://i.ytimg.com/vi/ODT0DOpfU-0/mqdefault.jpg",
    "title": "【 #大空スバル誕生日 】第一回大空スバル印象調査会【17.2さい！】",
    "publishedAt": "2020-07-02T12:18:24Z"
  },
  {
    "videoId": "DQETgdpr3Jo",
    "thumbnail": "https://i.ytimg.com/vi/DQETgdpr3Jo/mqdefault.jpg",
    "title": "【まったり雑談】07/04  おあようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-04T03:04:55Z"
  },
  {
    "videoId": "t1D3O5RC_vc",
    "thumbnail": "https://i.ytimg.com/vi/t1D3O5RC_vc/mqdefault.jpg",
    "title": "【 #大空家ユメグラ 】大空家といく！ユメノグラフィア DAY２～大空スバル編～【地獄】",
    "publishedAt": "2020-07-04T11:13:49Z"
  },
  {
    "videoId": "4yVUd5HOujM",
    "thumbnail": "https://i.ytimg.com/vi/4yVUd5HOujM/mqdefault.jpg",
    "title": "【初見実況#４】アサシンクリード4！！！やる！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-05T08:19:21Z"
  },
  {
    "videoId": "LsfdQaQk-C0",
    "thumbnail": "https://i.ytimg.com/vi/LsfdQaQk-C0/mqdefault.jpg",
    "title": "【ホロ鯖】初心者です優しくしてくださいARK【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-05T16:22:40Z"
  },
  {
    "videoId": "_HIdx0oZBnA",
    "thumbnail": "https://i.ytimg.com/vi/_HIdx0oZBnA/mqdefault.jpg",
    "title": "【Cities Skyline】スバル市長！！街にできたよ「罪と罰」！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-07T13:43:02Z"
  },
  {
    "videoId": "ZG86bIdRGrQ",
    "thumbnail": "https://i.ytimg.com/vi/ZG86bIdRGrQ/mqdefault.jpg",
    "title": "【たのじみ！！】プレゼントをあける会【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-08T13:10:00Z"
  },
  {
    "videoId": "xoM3nc6wP_Y",
    "thumbnail": "https://i.ytimg.com/vi/xoM3nc6wP_Y/mqdefault.jpg",
    "title": "【ホロ鯖】ホロ鯖ARK！！！かかってこいや亀！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-09T13:21:42Z"
  },
  {
    "videoId": "fwoCE-VJcq4",
    "thumbnail": "https://i.ytimg.com/vi/fwoCE-VJcq4/mqdefault.jpg",
    "title": "【雑談】超高速ましゅまろぱくぱく【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-10T13:48:18Z"
  },
  {
    "videoId": "ALccXArqFgw",
    "thumbnail": "https://i.ytimg.com/vi/ALccXArqFgw/mqdefault.jpg",
    "title": "【まったり雑談】07/11  おあようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-11T02:58:51Z"
  },
  {
    "videoId": "3bOlvSFrLnQ",
    "thumbnail": "https://i.ytimg.com/vi/3bOlvSFrLnQ/mqdefault.jpg",
    "title": "【初見実況#５】アサシンクリード4！！！やる！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-11T07:17:55Z"
  },
  {
    "videoId": "Om7gt-53kls",
    "thumbnail": "https://i.ytimg.com/vi/Om7gt-53kls/mqdefault.jpg",
    "title": "【初見実況#６】アサシンクリード4！！！やる！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-12T07:53:58Z"
  },
  {
    "videoId": "Lk47ccdfZ34",
    "thumbnail": "https://i.ytimg.com/vi/Lk47ccdfZ34/mqdefault.jpg",
    "title": "【ホラゲー】🥺🥺🥺🥺PI🥺🥺🥺🥺E🥺🥺🥺🥺N🥺🥺🥺🥺【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-12T14:13:37Z"
  },
  {
    "videoId": "-UxagU_fWOg",
    "thumbnail": "https://i.ytimg.com/vi/-UxagU_fWOg/mqdefault.jpg",
    "title": "【ホロ鯖】ホロ鯖ARK！！！空を舞うミオスバ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-14T15:51:05Z"
  },
  {
    "videoId": "3bbRdHvB43A",
    "thumbnail": "https://i.ytimg.com/vi/3bbRdHvB43A/mqdefault.jpg",
    "title": "【Cities Skyline】スバル市長！！街につくるよ「羅生門」！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-15T14:35:52Z"
  },
  {
    "videoId": "c9LR0w0A2M8",
    "thumbnail": "https://i.ytimg.com/vi/c9LR0w0A2M8/mqdefault.jpg",
    "title": "【ホロ鯖】橋建築の為の！！！！！！ソロトリケラトプステイム！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-16T13:42:00Z"
  },
  {
    "videoId": "2Nckiit-KL8",
    "thumbnail": "https://i.ytimg.com/vi/2Nckiit-KL8/mqdefault.jpg",
    "title": "【神ゲー】第六回ソセレ大会！！！！！まとめてかかってこいや！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-17T13:10:53Z"
  },
  {
    "videoId": "jzO5fGXCboQ",
    "thumbnail": "https://i.ytimg.com/vi/jzO5fGXCboQ/mqdefault.jpg",
    "title": "【まったり雑談】07/17  おあようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-18T03:03:56Z"
  },
  {
    "videoId": "eDNZ5vb9CwU",
    "thumbnail": "https://i.ytimg.com/vi/eDNZ5vb9CwU/mqdefault.jpg",
    "title": "【初見実況#７】アサシンクリード4！！！やる！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-18T06:48:28Z"
  },
  {
    "videoId": "aeE04GlIHFg",
    "thumbnail": "https://i.ytimg.com/vi/aeE04GlIHFg/mqdefault.jpg",
    "title": "【初見実況#最終回】アサシンクリード4！！！やる！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-19T11:02:27Z"
  },
  {
    "videoId": "nObC4TiZV2A",
    "thumbnail": "https://i.ytimg.com/vi/nObC4TiZV2A/mqdefault.jpg",
    "title": "【DM雑談】テーマ：推しに対してテンション上がりまくった話【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-22T15:02:54Z"
  },
  {
    "videoId": "RJz-6qEHTPU",
    "thumbnail": "https://i.ytimg.com/vi/RJz-6qEHTPU/mqdefault.jpg",
    "title": "【ホロ鯖】湾岸橋建築する！！原油も探す！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-23T13:41:27Z"
  },
  {
    "videoId": "0U5yFRYj1dE",
    "thumbnail": "https://i.ytimg.com/vi/0U5yFRYj1dE/mqdefault.jpg",
    "title": "【ホラゲー】だーくでぃせぷしょんすばる【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-24T12:41:02Z"
  },
  {
    "videoId": "1OrAf8Be59I",
    "thumbnail": "https://i.ytimg.com/vi/1OrAf8Be59I/mqdefault.jpg",
    "title": "【まったり雑談】07/25  おあようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-25T03:01:47Z"
  },
  {
    "videoId": "si58qqiUy-4",
    "thumbnail": "https://i.ytimg.com/vi/si58qqiUy-4/mqdefault.jpg",
    "title": "【#IOSB】イオフィ先生のお絵描き教室【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-25T12:14:20Z"
  },
  {
    "videoId": "u6eskcH_XWA",
    "thumbnail": "https://i.ytimg.com/vi/u6eskcH_XWA/mqdefault.jpg",
    "title": "【Slither.io】みみずすばる【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-27T12:22:23Z"
  },
  {
    "videoId": "Hl2Z74Nrijg",
    "thumbnail": "https://i.ytimg.com/vi/Hl2Z74Nrijg/mqdefault.jpg",
    "title": "【ホロ鯖】目指せ初のカワウソテイム！！！！！！！【ホロライブ】",
    "publishedAt": "2020-07-29T11:47:59Z"
  },
  {
    "videoId": "cvBYDNkElPE",
    "thumbnail": "https://i.ytimg.com/vi/cvBYDNkElPE/mqdefault.jpg",
    "title": "【ホラゲー】都市伝説を暴くすばる！！！！！！！！！【流行り神警視庁怪異事件ファイル】",
    "publishedAt": "2020-07-30T12:08:39Z"
  },
  {
    "videoId": "1enadukImzU",
    "thumbnail": "https://i.ytimg.com/vi/1enadukImzU/mqdefault.jpg",
    "title": "【Half-Life2】ガバエイムでもエイリアンに勝ちたいすばる！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-07-31T13:14:32Z"
  },
  {
    "videoId": "fxa-s5M9u1c",
    "thumbnail": "https://i.ytimg.com/vi/fxa-s5M9u1c/mqdefault.jpg",
    "title": "【まったり雑談】8/1  おあようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-01T03:02:40Z"
  },
  {
    "videoId": "qV2FQ0NbwA0",
    "thumbnail": "https://i.ytimg.com/vi/qV2FQ0NbwA0/mqdefault.jpg",
    "title": "【ホラゲー】都市伝説を暴くすばる！！！「コックリさん」編【流行り神警視庁怪異事件ファイル】",
    "publishedAt": "2020-08-01T10:10:18Z"
  },
  {
    "videoId": "oqyaM6YGcG8",
    "thumbnail": "https://i.ytimg.com/vi/oqyaM6YGcG8/mqdefault.jpg",
    "title": "【ホロ鯖】毛皮装備がほしいすばる！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-01T13:03:41Z"
  },
  {
    "videoId": "TxN_7Uyr6Bc",
    "thumbnail": "https://i.ytimg.com/vi/TxN_7Uyr6Bc/mqdefault.jpg",
    "title": "【ホラゲー】都市伝説を暴くすばる！！！！！「鬼」編！！！！【流行り神警視庁怪異事件ファイル】",
    "publishedAt": "2020-08-02T11:27:07Z"
  },
  {
    "videoId": "m3vzhh7lNiI",
    "thumbnail": "https://i.ytimg.com/vi/m3vzhh7lNiI/mqdefault.jpg",
    "title": "【ホラゲー】だーくでぃせぷしょんすばる　STAGE3【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-03T14:01:38Z"
  },
  {
    "videoId": "hLepFFILEQI",
    "thumbnail": "https://i.ytimg.com/vi/hLepFFILEQI/mqdefault.jpg",
    "title": "【#スバルーナ】遊び大全コラボ【ス虐の時代終了！！！】",
    "publishedAt": "2020-08-04T13:19:01Z"
  },
  {
    "videoId": "FKFsPlZWl4s",
    "thumbnail": "https://i.ytimg.com/vi/FKFsPlZWl4s/mqdefault.jpg",
    "title": "【#100均ホロライブ】メンバーの私物を見抜け！！！！100均ホロライブ！！！【第二弾】",
    "publishedAt": "2020-08-06T12:10:26Z"
  },
  {
    "videoId": "qUGFieucenY",
    "thumbnail": "https://i.ytimg.com/vi/qUGFieucenY/mqdefault.jpg",
    "title": "【まったり雑談】8/8  おあようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-08T03:21:01Z"
  },
  {
    "videoId": "urRlD3Ahpfc",
    "thumbnail": "https://i.ytimg.com/vi/urRlD3Ahpfc/mqdefault.jpg",
    "title": "【 #ホロワードウルフ 】ホロライブワードウルフ！！！【やる！！！】",
    "publishedAt": "2020-08-09T15:06:53Z"
  },
  {
    "videoId": "Jiak2fgPtFY",
    "thumbnail": "https://i.ytimg.com/vi/Jiak2fgPtFY/mqdefault.jpg",
    "title": "【ホラゲー】都市伝説を暴くすばる！！！！！最終話！！！！【流行り神警視庁怪異事件ファイル】",
    "publishedAt": "2020-08-10T08:40:50Z"
  },
  {
    "videoId": "LdCaj6upIkw",
    "thumbnail": "https://i.ytimg.com/vi/LdCaj6upIkw/mqdefault.jpg",
    "title": "【ホロ鯖ARK】アキ先輩と恐竜戦闘訓練する！！！！！！！【ホロライブ/大空スバル視点】",
    "publishedAt": "2020-08-10T16:14:05Z"
  },
  {
    "videoId": "Nqjuz5KW42M",
    "thumbnail": "https://i.ytimg.com/vi/Nqjuz5KW42M/mqdefault.jpg",
    "title": "【Dark Deception】庭師を今日こそクリアするすばる【地獄の3面】",
    "publishedAt": "2020-08-12T15:01:19Z"
  },
  {
    "videoId": "oL2roCXTwIQ",
    "thumbnail": "https://i.ytimg.com/vi/oL2roCXTwIQ/mqdefault.jpg",
    "title": "【ホロ鯖ARK】モンボ作り1日目！！セメント収集の巻！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-13T15:11:29Z"
  },
  {
    "videoId": "S1xpYQolEcw",
    "thumbnail": "https://i.ytimg.com/vi/S1xpYQolEcw/mqdefault.jpg",
    "title": "【かかってこいや】fall guys すばる【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-14T15:37:11Z"
  },
  {
    "videoId": "86cmQAjOAcI",
    "thumbnail": "https://i.ytimg.com/vi/86cmQAjOAcI/mqdefault.jpg",
    "title": "【まったり雑談】8/15  おあようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-15T03:12:51Z"
  },
  {
    "videoId": "gxTEEv_iY6w",
    "thumbnail": "https://i.ytimg.com/vi/gxTEEv_iY6w/mqdefault.jpg",
    "title": "【初見実況】ピクミンすばる【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-15T12:02:35Z"
  },
  {
    "videoId": "U_jXcPc0wnY",
    "thumbnail": "https://i.ytimg.com/vi/U_jXcPc0wnY/mqdefault.jpg",
    "title": "【初見実況】ピクミンすばる２【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-16T09:16:27Z"
  },
  {
    "videoId": "m8UYEgrDaJw",
    "thumbnail": "https://i.ytimg.com/vi/m8UYEgrDaJw/mqdefault.jpg",
    "title": "【ホロ鯖ARK】モンボ作り2日目！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-19T15:09:07Z"
  },
  {
    "videoId": "DGNFcG2ay3Y",
    "thumbnail": "https://i.ytimg.com/vi/DGNFcG2ay3Y/mqdefault.jpg",
    "title": "【初見実況】ピクミンすばる３【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-20T12:08:34Z"
  },
  {
    "videoId": "gWzzJhYEhz8",
    "thumbnail": "https://i.ytimg.com/vi/gWzzJhYEhz8/mqdefault.jpg",
    "title": "【かかってこいや】1位取れない鳥はただの🦆！fall guys すばる【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-20T14:53:27Z"
  },
  {
    "videoId": "eGulJ9Qouao",
    "thumbnail": "https://i.ytimg.com/vi/eGulJ9Qouao/mqdefault.jpg",
    "title": "【まったり雑談】おやすみスバル（仮）【投稿は概要欄から！】",
    "publishedAt": "2020-08-21T14:47:21Z"
  },
  {
    "videoId": "G_i0mD3l0r4",
    "thumbnail": "https://i.ytimg.com/vi/G_i0mD3l0r4/mqdefault.jpg",
    "title": "【まったり雑談】8/21  おあようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-22T03:13:34Z"
  },
  {
    "videoId": "gp6lG3zaBis",
    "thumbnail": "https://i.ytimg.com/vi/gp6lG3zaBis/mqdefault.jpg",
    "title": "【初見実況】ピクミンすばる４【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-23T09:38:01Z"
  },
  {
    "videoId": "5SZfqFFt8lY",
    "thumbnail": "https://i.ytimg.com/vi/5SZfqFFt8lY/mqdefault.jpg",
    "title": "【うた】DEATH【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-23T13:58:42Z"
  },
  {
    "videoId": "zxnb5ua2Q1I",
    "thumbnail": "https://i.ytimg.com/vi/zxnb5ua2Q1I/mqdefault.jpg",
    "title": "【雑談】1人暮らしってYABEEEEEEEEEEEEEEEEEEEEEE【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-27T12:44:08Z"
  },
  {
    "videoId": "BRnvHFwJc7E",
    "thumbnail": "https://i.ytimg.com/vi/BRnvHFwJc7E/mqdefault.jpg",
    "title": "【恐怖！】本当にあった怖い黒歴史2020【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-28T13:06:07Z"
  },
  {
    "videoId": "SkFXpefqqtg",
    "thumbnail": "https://i.ytimg.com/vi/SkFXpefqqtg/mqdefault.jpg",
    "title": "【まったり雑談】8/29  おあようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-29T03:21:44Z"
  },
  {
    "videoId": "kvXLvllXero",
    "thumbnail": "https://i.ytimg.com/vi/kvXLvllXero/mqdefault.jpg",
    "title": "【初見実況】スーパーマリオサンシャイン☼スバル１【ホロライブ/大空スバル】",
    "publishedAt": "2020-08-29T14:49:32Z"
  },
  {
    "videoId": "BqfNwHhOFMk",
    "thumbnail": "https://i.ytimg.com/vi/BqfNwHhOFMk/mqdefault.jpg",
    "title": "【ホロ鯖】あやスバホロ鯖新拠点探しマイクラ【復興】",
    "publishedAt": "2020-08-30T07:38:15Z"
  },
  {
    "videoId": "9B5hPscY_uE",
    "thumbnail": "https://i.ytimg.com/vi/9B5hPscY_uE/mqdefault.jpg",
    "title": "【ホロ鯖ARK】レベリング！！いくぞ初レッドウッド！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-01T13:15:36Z"
  },
  {
    "videoId": "Hr550c2DcrQ",
    "thumbnail": "https://i.ytimg.com/vi/Hr550c2DcrQ/mqdefault.jpg",
    "title": "【Dark Deception】アヒルステージを30分で攻略しピエロとタイマンはるすばる！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-02T12:48:36Z"
  },
  {
    "videoId": "Gi8PlCytuWQ",
    "thumbnail": "https://i.ytimg.com/vi/Gi8PlCytuWQ/mqdefault.jpg",
    "title": "【ホロ鯖】マイクラ建築るすばる【復興】",
    "publishedAt": "2020-09-02T18:11:08Z"
  },
  {
    "videoId": "zrkgOjhFn9Q",
    "thumbnail": "https://i.ytimg.com/vi/zrkgOjhFn9Q/mqdefault.jpg",
    "title": "【かかってこいや】1位をとるすばる【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-03T14:51:02Z"
  },
  {
    "videoId": "k9YpEb-yOb8",
    "thumbnail": "https://i.ytimg.com/vi/k9YpEb-yOb8/mqdefault.jpg",
    "title": "【圧倒的強さ】マリオカート8DX！！すーぱー稲妻すばる杯マリカ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-04T12:10:40Z"
  },
  {
    "videoId": "_6vPWBswiqQ",
    "thumbnail": "https://i.ytimg.com/vi/_6vPWBswiqQ/mqdefault.jpg",
    "title": "【まったり雑談】9/04  おあようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-05T03:47:41Z"
  },
  {
    "videoId": "ZupcIawbO-Q",
    "thumbnail": "https://i.ytimg.com/vi/ZupcIawbO-Q/mqdefault.jpg",
    "title": "【ホロ鯖ARK】ティタノ準備【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-05T08:59:43Z"
  },
  {
    "videoId": "qvfXxbkNa9Y",
    "thumbnail": "https://i.ytimg.com/vi/qvfXxbkNa9Y/mqdefault.jpg",
    "title": "【ホロ鯖ARK】ティタノテイム！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-05T17:41:33Z"
  },
  {
    "videoId": "C6WTR7KpbpI",
    "thumbnail": "https://i.ytimg.com/vi/C6WTR7KpbpI/mqdefault.jpg",
    "title": "【ホラゲー？】INSIDE【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-08T15:21:48Z"
  },
  {
    "videoId": "aJKpWSKdv3A",
    "thumbnail": "https://i.ytimg.com/vi/aJKpWSKdv3A/mqdefault.jpg",
    "title": "【最終回】INSIDE【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-09T14:09:37Z"
  },
  {
    "videoId": "zK5IGA4e7mc",
    "thumbnail": "https://i.ytimg.com/vi/zK5IGA4e7mc/mqdefault.jpg",
    "title": "【ホロ鯖】マイクラ建築るすばる2【復興】",
    "publishedAt": "2020-09-10T17:26:19Z"
  },
  {
    "videoId": "92pRbco8wdM",
    "thumbnail": "https://i.ytimg.com/vi/92pRbco8wdM/mqdefault.jpg",
    "title": "【まったり雑談】9/12  おあようスバル with ちょこ先生【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-12T02:18:39Z"
  },
  {
    "videoId": "5H-8jvKZOLA",
    "thumbnail": "https://i.ytimg.com/vi/5H-8jvKZOLA/mqdefault.jpg",
    "title": "【】はなす【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-13T17:48:04Z"
  },
  {
    "videoId": "XEj2gQcchGo",
    "thumbnail": "https://i.ytimg.com/vi/XEj2gQcchGo/mqdefault.jpg",
    "title": "【ホロ鯖】すばるのマイクラすーぱーつよつよ大作戦！！！その１！！！【復興】",
    "publishedAt": "2020-09-14T13:22:47Z"
  },
  {
    "videoId": "mDAcd8I-xgw",
    "thumbnail": "https://i.ytimg.com/vi/mDAcd8I-xgw/mqdefault.jpg",
    "title": "【#大空スバル２周年】はなす【持つべきものは友】",
    "publishedAt": "2020-09-16T14:57:00Z"
  },
  {
    "videoId": "m6PwPaV8WXI",
    "thumbnail": "https://i.ytimg.com/vi/m6PwPaV8WXI/mqdefault.jpg",
    "title": "【ホロ鯖】すばるのマイクラすーぱーつよつよ大作戦！！！その2！！！【復興】",
    "publishedAt": "2020-09-18T13:52:39Z"
  },
  {
    "videoId": "7IXAobPoevw",
    "thumbnail": "https://i.ytimg.com/vi/7IXAobPoevw/mqdefault.jpg",
    "title": "【まったり雑談】9/19  おあようスバル 【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-20T04:18:15Z"
  },
  {
    "videoId": "PQuPPOgpmJI",
    "thumbnail": "https://i.ytimg.com/vi/PQuPPOgpmJI/mqdefault.jpg",
    "title": "【初見実況】ゼルダの伝説・風のタクトやる！！！！The Legend of Zelda: The Wind Waker【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-20T09:13:48Z"
  },
  {
    "videoId": "6ckYPirMSsI",
    "thumbnail": "https://i.ytimg.com/vi/6ckYPirMSsI/mqdefault.jpg",
    "title": "【初見実況】#２ゼルダの伝説・風のタクトやる！！！！The Legend of Zelda: The Wind Waker【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-21T08:58:25Z"
  },
  {
    "videoId": "vlugkj33H5g",
    "thumbnail": "https://i.ytimg.com/vi/vlugkj33H5g/mqdefault.jpg",
    "title": "【MINECRAFT】ゆる雑談！ダイヤなどをまったりあつめるすばる【ホロラブ/大空スバル】",
    "publishedAt": "2020-09-22T02:57:39Z"
  },
  {
    "videoId": "n731qqx3Cgw",
    "thumbnail": "https://i.ytimg.com/vi/n731qqx3Cgw/mqdefault.jpg",
    "title": "【 #生スバル 】ふぉーるがいずすばる【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-23T14:10:39Z"
  },
  {
    "videoId": "KmcAK3fLZAE",
    "thumbnail": "https://i.ytimg.com/vi/KmcAK3fLZAE/mqdefault.jpg",
    "title": "【 #生スバル 】トラップを作ってしゅばしゅばしたいすばる【MINECRAFT】",
    "publishedAt": "2020-09-24T13:52:56Z"
  },
  {
    "videoId": "-N8WvjpU20Q",
    "thumbnail": "https://i.ytimg.com/vi/-N8WvjpU20Q/mqdefault.jpg",
    "title": "【まったり雑談】9/26  おあようスバル 【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-26T03:55:36Z"
  },
  {
    "videoId": "zOBhKOFl-5Y",
    "thumbnail": "https://i.ytimg.com/vi/zOBhKOFl-5Y/mqdefault.jpg",
    "title": "【初見実況】#3 ゼルダの伝説・風のタクトやる！！ヤバい森にいく！！！The Legend of Zelda: The Wind Waker【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-26T08:34:16Z"
  },
  {
    "videoId": "aWB-jC_b-Ag",
    "thumbnail": "https://i.ytimg.com/vi/aWB-jC_b-Ag/mqdefault.jpg",
    "title": "【 #生スバル 】TNTを作ってしゅばしゅばしたいすばる【MINECRAFT】",
    "publishedAt": "2020-09-26T17:45:17Z"
  },
  {
    "videoId": "-yquNvFEy54",
    "thumbnail": "https://i.ytimg.com/vi/-yquNvFEy54/mqdefault.jpg",
    "title": "【初見実況】#4 ゼルダの伝説・風のタクトやる！ジャブー様探し！！！！The Legend of Zelda: The Wind Waker【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-27T05:51:53Z"
  },
  {
    "videoId": "NZFhRWoq_Yc",
    "thumbnail": "https://i.ytimg.com/vi/NZFhRWoq_Yc/mqdefault.jpg",
    "title": "【初見実況】#4.5　ゼルダの伝説・風のタクトやる！！！！The Legend of Zelda: The Wind Waker【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-27T08:46:39Z"
  },
  {
    "videoId": "gKHM5r2EWAE",
    "thumbnail": "https://i.ytimg.com/vi/gKHM5r2EWAE/mqdefault.jpg",
    "title": "【 #生スバル 】第１回はじめてのポーション作りでしゅばしゅばすばる【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-28T15:36:19Z"
  },
  {
    "videoId": "qCFjIIdEMrU",
    "thumbnail": "https://i.ytimg.com/vi/qCFjIIdEMrU/mqdefault.jpg",
    "title": "【#生スバル】おうた【ホロライブ/大空スバル】",
    "publishedAt": "2020-09-29T15:16:51Z"
  },
  {
    "videoId": "2k0tu4a7mPU",
    "thumbnail": "https://i.ytimg.com/vi/2k0tu4a7mPU/mqdefault.jpg",
    "title": "【Chapter３】Dark Diception ピエルステージ攻略すばる【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-01T13:08:13Z"
  },
  {
    "videoId": "OtkXf-ktPew",
    "thumbnail": "https://i.ytimg.com/vi/OtkXf-ktPew/mqdefault.jpg",
    "title": "【Chapter３】Dark Deception ピエルステージRTA!!リベンジすばる【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-02T15:47:47Z"
  },
  {
    "videoId": "sofYlrHvWdQ",
    "thumbnail": "https://i.ytimg.com/vi/sofYlrHvWdQ/mqdefault.jpg",
    "title": "【週末雑談】10/03  おあようスバル 【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-03T04:18:44Z"
  },
  {
    "videoId": "MuLAU7p6Se4",
    "thumbnail": "https://i.ytimg.com/vi/MuLAU7p6Se4/mqdefault.jpg",
    "title": "【初見実況】#5　ゼルダの伝説・風のタクトやる！！！！The Legend of Zelda: The Wind Waker【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-04T09:20:30Z"
  },
  {
    "videoId": "rfn7z8BOYn4",
    "thumbnail": "https://i.ytimg.com/vi/rfn7z8BOYn4/mqdefault.jpg",
    "title": "【#生スバル】RFA!!!最強負荷30で地獄をのぞいてみるすばる【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-04T13:05:52Z"
  },
  {
    "videoId": "iOHLC-WKUk0",
    "thumbnail": "https://i.ytimg.com/vi/iOHLC-WKUk0/mqdefault.jpg",
    "title": "【 #生スバル 】2期生コラボたのしかったね雑談【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-06T15:20:42Z"
  },
  {
    "videoId": "zoKEvUhVca0",
    "thumbnail": "https://i.ytimg.com/vi/zoKEvUhVca0/mqdefault.jpg",
    "title": "【#生スバル】大空建設の本拠地をつくるぞ！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-08T14:11:06Z"
  },
  {
    "videoId": "ZkPTEZKkz3E",
    "thumbnail": "https://i.ytimg.com/vi/ZkPTEZKkz3E/mqdefault.jpg",
    "title": "【ホラゲー】INFLICTIONこわそう【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-09T15:49:04Z"
  },
  {
    "videoId": "8n8O6R7skxY",
    "thumbnail": "https://i.ytimg.com/vi/8n8O6R7skxY/mqdefault.jpg",
    "title": "【週末雑談】10/10  おそようスバル 【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-10T10:55:42Z"
  },
  {
    "videoId": "czdJAMqyABQ",
    "thumbnail": "https://i.ytimg.com/vi/czdJAMqyABQ/mqdefault.jpg",
    "title": "【初見実況】#6　ゼルダの伝説・風のタクトやる！！！！The Legend of Zelda: The Wind Waker【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-11T09:01:15Z"
  },
  {
    "videoId": "haIPZgRCMSQ",
    "thumbnail": "https://i.ytimg.com/vi/haIPZgRCMSQ/mqdefault.jpg",
    "title": "【#生スバル】しゅばしゅばしゅばしゅば！！！！！！！マイクラ【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-13T11:11:42Z"
  },
  {
    "videoId": "-cSmli64VK8",
    "thumbnail": "https://i.ytimg.com/vi/-cSmli64VK8/mqdefault.jpg",
    "title": "【#生スバル】大空建設の本拠地をつくるぞ！！パート２！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-13T13:35:26Z"
  },
  {
    "videoId": "oiyvXoh9gXs",
    "thumbnail": "https://i.ytimg.com/vi/oiyvXoh9gXs/mqdefault.jpg",
    "title": "【くじびき】スバちょこルーナ地獄くじ引き大会こらぼ【ホロライブ】",
    "publishedAt": "2020-10-15T14:01:38Z"
  },
  {
    "videoId": "4-PfeuZjlm0",
    "thumbnail": "https://i.ytimg.com/vi/4-PfeuZjlm0/mqdefault.jpg",
    "title": "【週末雑談】10/16  おそようスバル 【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-17T04:25:18Z"
  },
  {
    "videoId": "Nce15Hihpog",
    "thumbnail": "https://i.ytimg.com/vi/Nce15Hihpog/mqdefault.jpg",
    "title": "【おはなし】いろいろ振り返り雑談【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-20T13:56:27Z"
  },
  {
    "videoId": "_Od94_41hXQ",
    "thumbnail": "https://i.ytimg.com/vi/_Od94_41hXQ/mqdefault.jpg",
    "title": "【#生スバル】リベンジリベンジ！！！パート3！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-21T12:03:41Z"
  },
  {
    "videoId": "kVRn7CH5JqU",
    "thumbnail": "https://i.ytimg.com/vi/kVRn7CH5JqU/mqdefault.jpg",
    "title": "【視聴者参加】初心者AMONG US！！！！！UBARU！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-22T15:55:59Z"
  },
  {
    "videoId": "ZpsN-jbGi1E",
    "thumbnail": "https://i.ytimg.com/vi/ZpsN-jbGi1E/mqdefault.jpg",
    "title": "【発狂】マリメ２あんま分らんけどホロメンのコースくらい余裕余裕【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-23T12:07:35Z"
  },
  {
    "videoId": "xP_uAeVFWoQ",
    "thumbnail": "https://i.ytimg.com/vi/xP_uAeVFWoQ/mqdefault.jpg",
    "title": "【発狂】マリメ２あんま分らんけどホロメンのコースくらい余裕余裕【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-23T14:10:25Z"
  },
  {
    "videoId": "lDeDiXW4voE",
    "thumbnail": "https://i.ytimg.com/vi/lDeDiXW4voE/mqdefault.jpg",
    "title": "【初見実況】#7　最難関？！風の神殿攻略！！ゼルダの伝説・風のタクトやる！！！！The Legend of Zelda: The Wind Waker【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-25T10:23:03Z"
  },
  {
    "videoId": "Bi-BcuyEHNA",
    "thumbnail": "https://i.ytimg.com/vi/Bi-BcuyEHNA/mqdefault.jpg",
    "title": "【#雑ホロAmongUs】宇 宙 人 狼 開 催 !!【大空スバル/ホロライブ】",
    "publishedAt": "2020-10-27T15:01:12Z"
  },
  {
    "videoId": "w0S3hO3TP0A",
    "thumbnail": "https://i.ytimg.com/vi/w0S3hO3TP0A/mqdefault.jpg",
    "title": "【大空建設】今度こそやってやるちゅば！！！！！！！！！！！！！！！！【大空スバル/ホロライブ】",
    "publishedAt": "2020-10-28T12:12:21Z"
  },
  {
    "videoId": "7cI1pXkCQMI",
    "thumbnail": "https://i.ytimg.com/vi/7cI1pXkCQMI/mqdefault.jpg",
    "title": "【大空建設】今度こそやってやるちゅば！！！！！！パート２！！！！！！！！！！【大空スバル/ホロライブ】",
    "publishedAt": "2020-10-28T19:39:54Z"
  },
  {
    "videoId": "WpdfPInCT0E",
    "thumbnail": "https://i.ytimg.com/vi/WpdfPInCT0E/mqdefault.jpg",
    "title": "【地獄再び】スバちょこルーナ地獄くじ引き大会こらぼ【ホロライブ】",
    "publishedAt": "2020-10-29T15:19:52Z"
  },
  {
    "videoId": "yoVDYMcXbOI",
    "thumbnail": "https://i.ytimg.com/vi/yoVDYMcXbOI/mqdefault.jpg",
    "title": "【】おうた【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-30T13:52:38Z"
  },
  {
    "videoId": "P-yiBSu0Xqc",
    "thumbnail": "https://i.ytimg.com/vi/P-yiBSu0Xqc/mqdefault.jpg",
    "title": "【週末雑談】10/31  おそようスバル　はっぴーはろうぃん！ 【ホロライブ/大空スバル】",
    "publishedAt": "2020-10-31T10:51:27Z"
  },
  {
    "videoId": "bKw5YpARzk8",
    "thumbnail": "https://i.ytimg.com/vi/bKw5YpARzk8/mqdefault.jpg",
    "title": "【初見実況】#8　激ヤバ！！タライとホース集め！ゼルダの伝説・風のタクトやる！！！！The Legend of Zelda: The Wind Waker【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-01T07:50:00Z"
  },
  {
    "videoId": "kUevy1wQUZQ",
    "thumbnail": "https://i.ytimg.com/vi/kUevy1wQUZQ/mqdefault.jpg",
    "title": "【初見実況】#9　チンクルに負けるな！タライとホース集め！ゼルダの伝説・風のタクトやる！！！！The Legend of Zelda: The Wind Waker【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-03T10:51:42Z"
  },
  {
    "videoId": "-hsbE0066jU",
    "thumbnail": "https://i.ytimg.com/vi/-hsbE0066jU/mqdefault.jpg",
    "title": "【Phasmophobia】心霊調査ELITE部隊/大空スバル視点【#ホロライブFAMS】",
    "publishedAt": "2020-11-03T13:39:57Z"
  },
  {
    "videoId": "D6dGUmIAgzw",
    "thumbnail": "https://i.ytimg.com/vi/D6dGUmIAgzw/mqdefault.jpg",
    "title": "【#ポンホロAmongUs】ポン ホロ 人 狼 開 催 !!【大空スバル/ホロライブ】",
    "publishedAt": "2020-11-04T14:23:31Z"
  },
  {
    "videoId": "QFrn35kL5Q8",
    "thumbnail": "https://i.ytimg.com/vi/QFrn35kL5Q8/mqdefault.jpg",
    "title": "【50万人記念】高速ましゅまろQ&A大会！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-04T19:10:25Z"
  },
  {
    "videoId": "IMy0NOlwXfQ",
    "thumbnail": "https://i.ytimg.com/vi/IMy0NOlwXfQ/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル特別版？！バージョン2.0大発表～～～！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-07T02:29:32Z"
  },
  {
    "videoId": "wo8G_bUR1XQ",
    "thumbnail": "https://i.ytimg.com/vi/wo8G_bUR1XQ/mqdefault.jpg",
    "title": "【初見実況】#10　最終回！！ゼルダの伝説・風のタクトやる！！！！The Legend of Zelda: The Wind Waker【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-07T09:29:29Z"
  },
  {
    "videoId": "ItspEsuPNzA",
    "thumbnail": "https://i.ytimg.com/vi/ItspEsuPNzA/mqdefault.jpg",
    "title": "【#生スバル】スバ温泉のランドマークタワ脚編しゅば！！！MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-08T10:02:32Z"
  },
  {
    "videoId": "tzuC7QIxzkw",
    "thumbnail": "https://i.ytimg.com/vi/tzuC7QIxzkw/mqdefault.jpg",
    "title": "【#生スバル】paper.Please でお仕事するしゅば～～【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-09T16:35:54Z"
  },
  {
    "videoId": "sUMSFgNs_HM",
    "thumbnail": "https://i.ytimg.com/vi/sUMSFgNs_HM/mqdefault.jpg",
    "title": "【#生スバル】スバ温泉のランドマークタワー建築するしゅば！！！MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-10T17:44:23Z"
  },
  {
    "videoId": "AQxZ_7uRMXA",
    "thumbnail": "https://i.ytimg.com/vi/AQxZ_7uRMXA/mqdefault.jpg",
    "title": "【週末雑談】11/14  おはようスバル　【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-14T02:40:47Z"
  },
  {
    "videoId": "J5K50nujEnk",
    "thumbnail": "https://i.ytimg.com/vi/J5K50nujEnk/mqdefault.jpg",
    "title": "【#生スバル】スバ温泉のランドマークタワー完成させるしゅば！！！MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-14T10:41:46Z"
  },
  {
    "videoId": "CpY7BmxU1G0",
    "thumbnail": "https://i.ytimg.com/vi/CpY7BmxU1G0/mqdefault.jpg",
    "title": "【#生スバル】最終回！！！！スバ温泉のランドマークタワー完成させるしゅば！！！MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-14T17:10:33Z"
  },
  {
    "videoId": "rOraWNXUl-Y",
    "thumbnail": "https://i.ytimg.com/vi/rOraWNXUl-Y/mqdefault.jpg",
    "title": "【#１】ゼルダの伝説時のオカリナ:The Legend of Zelda: Ocarina of Time【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-15T06:52:42Z"
  },
  {
    "videoId": "xVLPBn6NBPI",
    "thumbnail": "https://i.ytimg.com/vi/xVLPBn6NBPI/mqdefault.jpg",
    "title": "【#宇宙ホロ人狼】AMONG US でやるしゅばなあああああ！！！【大空スバル/ホロライブ】",
    "publishedAt": "2020-11-15T14:51:11Z"
  },
  {
    "videoId": "PJEQw_pnqeA",
    "thumbnail": "https://i.ytimg.com/vi/PJEQw_pnqeA/mqdefault.jpg",
    "title": "【#ホロ幽霊調査隊】幽霊なんて余裕しゅば～～～～～～！！！：Phasmophobia【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-17T13:59:51Z"
  },
  {
    "videoId": "eNrCZaI5OIA",
    "thumbnail": "https://i.ytimg.com/vi/eNrCZaI5OIA/mqdefault.jpg",
    "title": "【#生スバル】第七回ソーセージレジェンド大会：SAUSAGE LEGEND【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-19T13:56:44Z"
  },
  {
    "videoId": "-o9zZ_32nUk",
    "thumbnail": "https://i.ytimg.com/vi/-o9zZ_32nUk/mqdefault.jpg",
    "title": "【週末雑談】11/21  うんどうかいたのしかったねスバル　【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-21T14:06:57Z"
  },
  {
    "videoId": "RbVC7zXyZpw",
    "thumbnail": "https://i.ytimg.com/vi/RbVC7zXyZpw/mqdefault.jpg",
    "title": "【#２】ゼルダの伝説時のオカリナ:The Legend of Zelda: Ocarina of Time【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-22T09:02:00Z"
  },
  {
    "videoId": "NylncBBRObw",
    "thumbnail": "https://i.ytimg.com/vi/NylncBBRObw/mqdefault.jpg",
    "title": "【視聴者参加型】大空建築 入社試験しゅば！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-22T14:38:31Z"
  },
  {
    "videoId": "6_WeWBviZLY",
    "thumbnail": "https://i.ytimg.com/vi/6_WeWBviZLY/mqdefault.jpg",
    "title": "【】おうた【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-25T15:35:42Z"
  },
  {
    "videoId": "7_gZBFAXAug",
    "thumbnail": "https://i.ytimg.com/vi/7_gZBFAXAug/mqdefault.jpg",
    "title": "【GTAV】車で大暴走やるしゅば！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-26T13:39:46Z"
  },
  {
    "videoId": "k5T1i-IHpoU",
    "thumbnail": "https://i.ytimg.com/vi/k5T1i-IHpoU/mqdefault.jpg",
    "title": "【週末雑談】11/28  おはようスバル　【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-28T02:11:04Z"
  },
  {
    "videoId": "-j5bpk0eFYg",
    "thumbnail": "https://i.ytimg.com/vi/-j5bpk0eFYg/mqdefault.jpg",
    "title": "【#3】ゼルダの伝説時のオカリナ:The Legend of Zelda: Ocarina of Time【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-28T08:55:55Z"
  },
  {
    "videoId": "jbncrFRrnDQ",
    "thumbnail": "https://i.ytimg.com/vi/jbncrFRrnDQ/mqdefault.jpg",
    "title": "【スパイ映画】キングスマン同時視聴会：Kingsman: The Secret Service【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-28T13:32:25Z"
  },
  {
    "videoId": "lMJD_8S47gs",
    "thumbnail": "https://i.ytimg.com/vi/lMJD_8S47gs/mqdefault.jpg",
    "title": "【#4】ゼルダの伝説時のオカリナ:The Legend of Zelda: Ocarina of Time【ホロライブ/大空スバル】",
    "publishedAt": "2020-11-29T09:16:36Z"
  },
  {
    "videoId": "xnrCB2r3oiU",
    "thumbnail": "https://i.ytimg.com/vi/xnrCB2r3oiU/mqdefault.jpg",
    "title": "【#生スバル】どろぼうしゃんスバル：Thief Simulator【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-02T14:15:31Z"
  },
  {
    "videoId": "XirNF9RzvIs",
    "thumbnail": "https://i.ytimg.com/vi/XirNF9RzvIs/mqdefault.jpg",
    "title": "【#生スバル】yabai【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-03T13:21:57Z"
  },
  {
    "videoId": "NVtaw4ql1J0",
    "thumbnail": "https://i.ytimg.com/vi/NVtaw4ql1J0/mqdefault.jpg",
    "title": "【#生スバル】おやすみスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-04T16:56:04Z"
  },
  {
    "videoId": "3Et1ae9PuOg",
    "thumbnail": "https://i.ytimg.com/vi/3Et1ae9PuOg/mqdefault.jpg",
    "title": "【#5】ゼルダの伝説時のオカリナ:The Legend of Zelda: Ocarina of Time【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-05T08:08:54Z"
  },
  {
    "videoId": "RLzWfwLCD30",
    "thumbnail": "https://i.ytimg.com/vi/RLzWfwLCD30/mqdefault.jpg",
    "title": "【#生スバル】ポンコツじゃない！！ＩＱ5億の学力をみよ！！！：Academic Ability Test【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-07T14:16:15Z"
  },
  {
    "videoId": "XC9LpjeZrhA",
    "thumbnail": "https://i.ytimg.com/vi/XC9LpjeZrhA/mqdefault.jpg",
    "title": "【#生スバル】全自動炭焼きかまど！！！！すみじろう！！！！！つくる！【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-08T12:12:36Z"
  },
  {
    "videoId": "NblFY3rx1YE",
    "thumbnail": "https://i.ytimg.com/vi/NblFY3rx1YE/mqdefault.jpg",
    "title": "【#生スバル】お泊りしたから雑談～～～！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-10T13:37:00Z"
  },
  {
    "videoId": "vXAw-cZ6ryg",
    "thumbnail": "https://i.ytimg.com/vi/vXAw-cZ6ryg/mqdefault.jpg",
    "title": "【#生スバル】視聴者分の１を探せ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-11T14:14:14Z"
  },
  {
    "videoId": "YL5O6R0Kmhs",
    "thumbnail": "https://i.ytimg.com/vi/YL5O6R0Kmhs/mqdefault.jpg",
    "title": "【#6】行くぞ難関！水の神殿！！！ゼルダの伝説時のオカリナ:The Legend of Zelda: Ocarina of Time【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-12T09:36:37Z"
  },
  {
    "videoId": "SEec24EgOxw",
    "thumbnail": "https://i.ytimg.com/vi/SEec24EgOxw/mqdefault.jpg",
    "title": "【#7】今日こそクリアするぞ！水の神殿！！！ゼルダの伝説時のオカリナ:The Legend of Zelda: Ocarina of Time【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-13T08:23:55Z"
  },
  {
    "videoId": "mNZf8hFDedw",
    "thumbnail": "https://i.ytimg.com/vi/mNZf8hFDedw/mqdefault.jpg",
    "title": "【#生スバル】ママになりたいスバル！！：Mother Simulator【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-15T12:06:25Z"
  },
  {
    "videoId": "iwjlQI4rkKA",
    "thumbnail": "https://i.ytimg.com/vi/iwjlQI4rkKA/mqdefault.jpg",
    "title": "【#１】初めての！！！グランブルーファンタジー！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-16T15:20:57Z"
  },
  {
    "videoId": "N4nZ52k4lhw",
    "thumbnail": "https://i.ytimg.com/vi/N4nZ52k4lhw/mqdefault.jpg",
    "title": "【60万人記念】ぶっちゃけマシュマロ大会+ぷち逆凸～！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-18T14:13:35Z"
  },
  {
    "videoId": "OzRL8xm_Oa8",
    "thumbnail": "https://i.ytimg.com/vi/OzRL8xm_Oa8/mqdefault.jpg",
    "title": "【】おはようスバル：定期雑談【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-19T03:25:40Z"
  },
  {
    "videoId": "eEPgsTllQiQ",
    "thumbnail": "https://i.ytimg.com/vi/eEPgsTllQiQ/mqdefault.jpg",
    "title": "【#8】ホラー？！墓場のダンジョン！！ゼルダの伝説時のオカリナ:The Legend of Zelda: Ocarina of Time【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-19T07:24:29Z"
  },
  {
    "videoId": "4fufXOKhPps",
    "thumbnail": "https://i.ytimg.com/vi/4fufXOKhPps/mqdefault.jpg",
    "title": "【#9】リベンジ！！！墓場のボンゴボンゴ！！！ゼルダの伝説時のオカリナ:The Legend of Zelda: Ocarina of Time【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-20T08:14:35Z"
  },
  {
    "videoId": "kgr-yWszxfw",
    "thumbnail": "https://i.ytimg.com/vi/kgr-yWszxfw/mqdefault.jpg",
    "title": "【#生スバル】2ndふぇすありがとうございました！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-23T12:05:03Z"
  },
  {
    "videoId": "v4ePgw3qMZo",
    "thumbnail": "https://i.ytimg.com/vi/v4ePgw3qMZo/mqdefault.jpg",
    "title": "【#２】はじめてのぐらぶるっ！初めてのガチャピン！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-23T15:17:21Z"
  },
  {
    "videoId": "-X-tWOFR1t8",
    "thumbnail": "https://i.ytimg.com/vi/-X-tWOFR1t8/mqdefault.jpg",
    "title": "【#生スバル】メリークリスマス！！！マインクラフト！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-24T14:39:53Z"
  },
  {
    "videoId": "PZcLFXRskso",
    "thumbnail": "https://i.ytimg.com/vi/PZcLFXRskso/mqdefault.jpg",
    "title": "【#ホロライブクリスマス】ホロライブクリスマス歌！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-25T09:02:06Z"
  },
  {
    "videoId": "me4hAMZkI70",
    "thumbnail": "https://i.ytimg.com/vi/me4hAMZkI70/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-26T03:58:43Z"
  },
  {
    "videoId": "S7vNhtz0H8o",
    "thumbnail": "https://i.ytimg.com/vi/S7vNhtz0H8o/mqdefault.jpg",
    "title": "【#10】いくぜ！！！！砂漠の神殿！！！！ゼルダの伝説時のオカリナ:The Legend of Zelda: Ocarina of Time【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-26T08:28:10Z"
  },
  {
    "videoId": "3aup9bkCh3I",
    "thumbnail": "https://i.ytimg.com/vi/3aup9bkCh3I/mqdefault.jpg",
    "title": "【最終回】ガノンドロフ討伐！！！ゼルダの伝説時のオカリナ:The Legend of Zelda: Ocarina of Time【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-27T09:24:13Z"
  },
  {
    "videoId": "SD89bWoUYWo",
    "thumbnail": "https://i.ytimg.com/vi/SD89bWoUYWo/mqdefault.jpg",
    "title": "【リズム天国】リズムにのるぜええええええええ【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-28T14:23:17Z"
  },
  {
    "videoId": "zHFC_ZKUITM",
    "thumbnail": "https://i.ytimg.com/vi/zHFC_ZKUITM/mqdefault.jpg",
    "title": "【#３】なんか新ガチャが来るらしいぞ！！！！！：GRANBLUE FANTASY【ホロライブ/大空スバル】",
    "publishedAt": "2020-12-31T04:29:32Z"
  },
  {
    "videoId": "5-DJxNOHIrs",
    "thumbnail": "https://i.ytimg.com/vi/5-DJxNOHIrs/mqdefault.jpg",
    "title": "【#生スバル】正月運試し！ソセレ！！！！後半ゲストあり？！？！？！：SausageLegend【レート：1000~】",
    "publishedAt": "2021-01-01T11:19:33Z"
  },
  {
    "videoId": "ABgstfN5viI",
    "thumbnail": "https://i.ytimg.com/vi/ABgstfN5viI/mqdefault.jpg",
    "title": "🍉【#生スバル】正月運試し！ソセレ！！！！後半ゲストあり？！？！？！：SausageLegend【レート：100~】 🍉",
    "publishedAt": "2021-01-01T12:11:19Z"
  },
  {
    "videoId": "FICUlVwL_9c",
    "thumbnail": "https://i.ytimg.com/vi/FICUlVwL_9c/mqdefault.jpg",
    "title": "【雑談】あけた～～～！！！！やった～～！！！！【】",
    "publishedAt": "2021-01-01T15:40:28Z"
  },
  {
    "videoId": "0zirp371ZXs",
    "thumbnail": "https://i.ytimg.com/vi/0zirp371ZXs/mqdefault.jpg",
    "title": "【#１】怖い月がやってくる？！？シリーズ難関！ムジュラの仮面【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-02T09:29:56Z"
  },
  {
    "videoId": "2D9u_lKeNKA",
    "thumbnail": "https://i.ytimg.com/vi/2D9u_lKeNKA/mqdefault.jpg",
    "title": "【#2】怖い月がやってくる？！？シリーズ難関！ムジュラの仮面【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-03T08:12:32Z"
  },
  {
    "videoId": "uCx_dHfisKI",
    "thumbnail": "https://i.ytimg.com/vi/uCx_dHfisKI/mqdefault.jpg",
    "title": "【#生スバル】視聴者参加型マリカー！！かかってこいやぁ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-03T11:07:15Z"
  },
  {
    "videoId": "DWD8Kji1-q0",
    "thumbnail": "https://i.ytimg.com/vi/DWD8Kji1-q0/mqdefault.jpg",
    "title": "【ホラゲー】この家なんかおかしいぞ！！！！House on the Hill【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-05T16:10:59Z"
  },
  {
    "videoId": "Pbderb4EHC8",
    "thumbnail": "https://i.ytimg.com/vi/Pbderb4EHC8/mqdefault.jpg",
    "title": "【#生スバル】マリカ大会前ガチ練習：視聴者参加型スナイプ歓迎【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-06T11:35:35Z"
  },
  {
    "videoId": "3VH_dPFUEa4",
    "thumbnail": "https://i.ytimg.com/vi/3VH_dPFUEa4/mqdefault.jpg",
    "title": "【#生スバル】FALL GUYS SUBARU：新シーズン来てたらしい！！【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-07T11:33:15Z"
  },
  {
    "videoId": "OLd5osYw8_g",
    "thumbnail": "https://i.ytimg.com/vi/OLd5osYw8_g/mqdefault.jpg",
    "title": "【#４】ガチャピンとムックに会いたいグランブルーファンタジースバル：GRANBLUE FANTASY【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-07T13:57:03Z"
  },
  {
    "videoId": "hUYBu5TY5uA",
    "thumbnail": "https://i.ytimg.com/vi/hUYBu5TY5uA/mqdefault.jpg",
    "title": "【#生スバル】映画オタクとみるエイリアン２：alian2 the theatrical (1986：137minutes)【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-08T14:50:31Z"
  },
  {
    "videoId": "0Qv9v0QYei4",
    "thumbnail": "https://i.ytimg.com/vi/0Qv9v0QYei4/mqdefault.jpg",
    "title": "【】おはようスバル【】",
    "publishedAt": "2021-01-09T03:13:34Z"
  },
  {
    "videoId": "puxgwmeJZhk",
    "thumbnail": "https://i.ytimg.com/vi/puxgwmeJZhk/mqdefault.jpg",
    "title": "【#3】ムジュラの仮面やる！！！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-09T08:16:56Z"
  },
  {
    "videoId": "kmNJpxY8lrQ",
    "thumbnail": "https://i.ytimg.com/vi/kmNJpxY8lrQ/mqdefault.jpg",
    "title": "【#４】スノーヘッドの神殿！！ムジュラの仮面！！：The Legend of Zelda: Majora's Mask【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-10T08:54:22Z"
  },
  {
    "videoId": "GpqsMTUmjB0",
    "thumbnail": "https://i.ytimg.com/vi/GpqsMTUmjB0/mqdefault.jpg",
    "title": "【 #雑ホロ杯 /マリカDX8​】行くぞおおおおおおおおお！！【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-10T13:09:08Z"
  },
  {
    "videoId": "xhQc8VsXkWY",
    "thumbnail": "https://i.ytimg.com/vi/xhQc8VsXkWY/mqdefault.jpg",
    "title": "【#おかあくすば】おかゆあくあすばる合同練習会【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-10T17:20:00Z"
  },
  {
    "videoId": "OrR_qVytQ74",
    "thumbnail": "https://i.ytimg.com/vi/OrR_qVytQ74/mqdefault.jpg",
    "title": "【#ホロお正月CUP​】がんばる！！！！！！！！！！！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-11T14:03:48Z"
  },
  {
    "videoId": "nW_iu41RoEQ",
    "thumbnail": "https://i.ytimg.com/vi/nW_iu41RoEQ/mqdefault.jpg",
    "title": "【#ホロL4D2】８人対戦Ｌ４Ｄ２で大暴れするちゅば！！！！！！！！【ＦＡＭＳ視点】",
    "publishedAt": "2021-01-12T14:35:18Z"
  },
  {
    "videoId": "G3oe0xYs9DQ",
    "thumbnail": "https://i.ytimg.com/vi/G3oe0xYs9DQ/mqdefault.jpg",
    "title": "【#５】明かされる最推しの過去？！：GRANBLUE FANTASY【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-14T14:07:45Z"
  },
  {
    "videoId": "YiS-Uo2krN0",
    "thumbnail": "https://i.ytimg.com/vi/YiS-Uo2krN0/mqdefault.jpg",
    "title": "【#生スバル】３Ｄおやすみすばる：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-15T14:32:50Z"
  },
  {
    "videoId": "0KLnCy691Ts",
    "thumbnail": "https://i.ytimg.com/vi/0KLnCy691Ts/mqdefault.jpg",
    "title": "【#5】海の神殿にいくぞ！！！ムジュラの仮面！！：The Legend of Zelda: Majora's Mask【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-17T09:21:35Z"
  },
  {
    "videoId": "zA9P6LGLDSw",
    "thumbnail": "https://i.ytimg.com/vi/zA9P6LGLDSw/mqdefault.jpg",
    "title": "【ミオスバ】初心忘れるべからず【今日地獄です】",
    "publishedAt": "2021-01-20T13:14:36Z"
  },
  {
    "videoId": "ujtn9sZdcWQ",
    "thumbnail": "https://i.ytimg.com/vi/ujtn9sZdcWQ/mqdefault.jpg",
    "title": "【#６】霧の島ガロンゾ？いくちゅば！！：GRANBLUE FANTASY【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-21T14:02:35Z"
  },
  {
    "videoId": "v-hFx0gSMNw",
    "thumbnail": "https://i.ytimg.com/vi/v-hFx0gSMNw/mqdefault.jpg",
    "title": "【#生スバル】おはようすばる雑談：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-23T03:34:55Z"
  },
  {
    "videoId": "02WC5ZNwaIw",
    "thumbnail": "https://i.ytimg.com/vi/02WC5ZNwaIw/mqdefault.jpg",
    "title": "【#6】グレートベイの神殿攻略！！：The Legend of Zelda: Majora's Mask【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-23T08:46:29Z"
  },
  {
    "videoId": "SStQvFj42nw",
    "thumbnail": "https://i.ytimg.com/vi/SStQvFj42nw/mqdefault.jpg",
    "title": "【#7】仮面集めーー！！！！：The Legend of Zelda: Majora's Mask【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-24T08:53:20Z"
  },
  {
    "videoId": "6U0pTdoOjiA",
    "thumbnail": "https://i.ytimg.com/vi/6U0pTdoOjiA/mqdefault.jpg",
    "title": "【MINECRAFT】やばい・・・【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-26T15:15:51Z"
  },
  {
    "videoId": "2AaCaCoRMB0",
    "thumbnail": "https://i.ytimg.com/vi/2AaCaCoRMB0/mqdefault.jpg",
    "title": "【#７】明かされるラカムの過去！？：GRANBLUE FANTASY【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-28T15:04:47Z"
  },
  {
    "videoId": "rA5MQyrW0EY",
    "thumbnail": "https://i.ytimg.com/vi/rA5MQyrW0EY/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：ＦＲＥＥＴＡＬＫ【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-30T03:25:28Z"
  },
  {
    "videoId": "b2lVLn-z5yM",
    "thumbnail": "https://i.ytimg.com/vi/b2lVLn-z5yM/mqdefault.jpg",
    "title": "【#8】最難関？！谷で神殿をみつけよ！：The Legend of Zelda: Majora's Mask【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-30T09:20:16Z"
  },
  {
    "videoId": "hcjnO7-Y2GI",
    "thumbnail": "https://i.ytimg.com/vi/hcjnO7-Y2GI/mqdefault.jpg",
    "title": "【#9】最難関？！ロックビル！！！：The Legend of Zelda: Majora's Mask【ホロライブ/大空スバル】",
    "publishedAt": "2021-01-31T08:54:34Z"
  },
  {
    "videoId": "sDYIpRyEvNo",
    "thumbnail": "https://i.ytimg.com/vi/sDYIpRyEvNo/mqdefault.jpg",
    "title": "【MINECRAFT】やばい・・・Part2【ホロライブ/大空スバル】",
    "publishedAt": "2021-02-02T15:03:14Z"
  },
  {
    "videoId": "MhRRfZHevug",
    "thumbnail": "https://i.ytimg.com/vi/MhRRfZHevug/mqdefault.jpg",
    "title": "【MINECRAFT】やばい・・・part3【ホロライブ/大空スバル】",
    "publishedAt": "2021-02-03T13:53:16Z"
  },
  {
    "videoId": "qUB3ps86mOE",
    "thumbnail": "https://i.ytimg.com/vi/qUB3ps86mOE/mqdefault.jpg",
    "title": "【#８】黒騎士逮捕ってマジ？：GRANBLUE FANTASY【ホロライブ/大空スバル】",
    "publishedAt": "2021-02-05T13:30:21Z"
  },
  {
    "videoId": "07AzK6levMM",
    "thumbnail": "https://i.ytimg.com/vi/07AzK6levMM/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル！：Free Talk【大空スバル/ホロライブ】",
    "publishedAt": "2021-02-06T03:14:24Z"
  },
  {
    "videoId": "LDp7tPX1yrU",
    "thumbnail": "https://i.ytimg.com/vi/LDp7tPX1yrU/mqdefault.jpg",
    "title": "【#10】仮面集める！！！：The Legend of Zelda: Majora's Mask【ホロライブ/大空スバル】",
    "publishedAt": "2021-02-06T08:24:09Z"
  },
  {
    "videoId": "k8QM0GXYuDQ",
    "thumbnail": "https://i.ytimg.com/vi/k8QM0GXYuDQ/mqdefault.jpg",
    "title": "【#生スバル】70万登録感謝祭！！！ふりーだむ！【ホロライブ/大空スバル】",
    "publishedAt": "2021-02-08T15:52:26Z"
  },
  {
    "videoId": "RtNh2VNJm-I",
    "thumbnail": "https://i.ytimg.com/vi/RtNh2VNJm-I/mqdefault.jpg",
    "title": "【#アイドルデス】Bloom!アイドルDEATH GAME【ホロライブ】",
    "publishedAt": "2021-02-09T15:41:56Z"
  },
  {
    "videoId": "pGdfRRUGbzI",
    "thumbnail": "https://i.ytimg.com/vi/pGdfRRUGbzI/mqdefault.jpg",
    "title": "【#９】頼む…服を着ててくれ…ラビ島編！：GRANBLUE FANTASY【ホロライブ/大空スバル】",
    "publishedAt": "2021-02-10T14:09:36Z"
  },
  {
    "videoId": "qWetncnJG_M",
    "thumbnail": "https://i.ytimg.com/vi/qWetncnJG_M/mqdefault.jpg",
    "title": "【MINECRAFT】そろそろ納品？！台所と脱衣所つくるぞ！！【ホロライブ/大空スバル】",
    "publishedAt": "2021-02-12T16:37:00Z"
  },
  {
    "videoId": "9G9_dcjYN1E",
    "thumbnail": "https://i.ytimg.com/vi/9G9_dcjYN1E/mqdefault.jpg",
    "title": "【#１１】最終回！！！！！！！！！：The Legend of Zelda: Majora's Mask【ホロライブ/大空スバル】",
    "publishedAt": "2021-02-13T09:36:29Z"
  },
  {
    "videoId": "ryUa-7_ylUo",
    "thumbnail": "https://i.ytimg.com/vi/ryUa-7_ylUo/mqdefault.jpg",
    "title": "【】おはようスバル：FREE TALK【】",
    "publishedAt": "2021-02-14T03:29:23Z"
  },
  {
    "videoId": "L9TxWjDrZoM",
    "thumbnail": "https://i.ytimg.com/vi/L9TxWjDrZoM/mqdefault.jpg",
    "title": "【#生スバル】グリームニルガチャ：GRANBLUE FANTASY【ホロライブ/大空スバル】",
    "publishedAt": "2021-02-14T14:26:49Z"
  },
  {
    "videoId": "3gOhLstrTvs",
    "thumbnail": "https://i.ytimg.com/vi/3gOhLstrTvs/mqdefault.jpg",
    "title": "【#生スバル】ライブ直前！？DEATHルーレットASMR💛【ホロライブ/大空スバル】",
    "publishedAt": "2021-02-16T12:44:49Z"
  },
  {
    "videoId": "bRXQwAGNCso",
    "thumbnail": "https://i.ytimg.com/vi/bRXQwAGNCso/mqdefault.jpg",
    "title": "【※告知有】Bloombありがとうございましあ！！：thanks for Bloom!【】",
    "publishedAt": "2021-02-18T10:04:59Z"
  },
  {
    "videoId": "_mggdfxxEmQ",
    "thumbnail": "https://i.ytimg.com/vi/_mggdfxxEmQ/mqdefault.jpg",
    "title": "【#生スバル】スバるしマイクラ！！！！：rusia&subaru minecraft【ホロライブ/大空スバル】",
    "publishedAt": "2021-02-18T13:48:48Z"
  },
  {
    "videoId": "d6ouim9ZsyI",
    "thumbnail": "https://i.ytimg.com/vi/d6ouim9ZsyI/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-02-20T04:14:59Z"
  },
  {
    "videoId": "e92qKH9kpEU",
    "thumbnail": "https://i.ytimg.com/vi/e92qKH9kpEU/mqdefault.jpg",
    "title": "【初見実況】零～眞紅の蝶～をするスバル：PROJECT ZERO 2 Wii EDITION【ホロライブ/大空スバル】",
    "publishedAt": "2021-02-20T09:31:14Z"
  },
  {
    "videoId": "08g-NSTNPVY",
    "thumbnail": "https://i.ytimg.com/vi/08g-NSTNPVY/mqdefault.jpg",
    "title": "【#２】零～眞紅の蝶～をするスバル：PROJECT ZERO 2 Wii EDITION【初見実況】",
    "publishedAt": "2021-02-21T09:23:26Z"
  },
  {
    "videoId": "toQoiiwyGjU",
    "thumbnail": "https://i.ytimg.com/vi/toQoiiwyGjU/mqdefault.jpg",
    "title": "ランダムスバル：ramdom subaru",
    "publishedAt": "2021-02-21T13:13:15Z"
  },
  {
    "videoId": "8WzZjLlVOpc",
    "thumbnail": "https://i.ytimg.com/vi/8WzZjLlVOpc/mqdefault.jpg",
    "title": "【♯生スバル】今日はバナナでキメる：Sausage  Legend【レート1000↑】",
    "publishedAt": "2021-02-25T12:37:44Z"
  },
  {
    "videoId": "j4dX1wGpMjc",
    "thumbnail": "https://i.ytimg.com/vi/j4dX1wGpMjc/mqdefault.jpg",
    "title": "初期スバル：Pure SUBARU",
    "publishedAt": "2021-02-26T09:56:13Z"
  },
  {
    "videoId": "Y2g-ucwPcrw",
    "thumbnail": "https://i.ytimg.com/vi/Y2g-ucwPcrw/mqdefault.jpg",
    "title": "【♯生スバル】おはようスバル：Free  Talk【ホロライブ：大空スバル】",
    "publishedAt": "2021-02-27T03:22:29Z"
  },
  {
    "videoId": "1FcShCHRS8o",
    "thumbnail": "https://i.ytimg.com/vi/1FcShCHRS8o/mqdefault.jpg",
    "title": "【#３】零～眞紅の蝶～をするスバル：PROJECT ZERO 2 Wii EDITION【初見実況】",
    "publishedAt": "2021-02-27T06:20:47Z"
  },
  {
    "videoId": "F6n6x-8ZBBU",
    "thumbnail": "https://i.ytimg.com/vi/F6n6x-8ZBBU/mqdefault.jpg",
    "title": "【♯10】オルキスちゃんを救いたい：GRANBLUE FANTASY【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-02T11:08:16Z"
  },
  {
    "videoId": "SiXUqwCTmuA",
    "thumbnail": "https://i.ytimg.com/vi/SiXUqwCTmuA/mqdefault.jpg",
    "title": "【運営公認】秘密を暴け！大空スバル探偵事務所！：OOZORA Detective agency investigate the secrets of the Hololive audition🐣",
    "publishedAt": "2021-03-03T12:08:23Z"
  },
  {
    "videoId": "HI9HKcUf51k",
    "thumbnail": "https://i.ytimg.com/vi/HI9HKcUf51k/mqdefault.jpg",
    "title": "【#生スバル】おやすみスバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-06T15:43:42Z"
  },
  {
    "videoId": "SSPtVsGRcjI",
    "thumbnail": "https://i.ytimg.com/vi/SSPtVsGRcjI/mqdefault.jpg",
    "title": "【#生スバル】つぐのひすばる：TUGUNOHI【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-07T16:19:30Z"
  },
  {
    "videoId": "qQdHnA2-O_Y",
    "thumbnail": "https://i.ytimg.com/vi/qQdHnA2-O_Y/mqdefault.jpg",
    "title": "【#１】完全初見！！アンダーテールする！！！：UNDERTALE【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-09T12:49:19Z"
  },
  {
    "videoId": "pWhfMalZMaw",
    "thumbnail": "https://i.ytimg.com/vi/pWhfMalZMaw/mqdefault.jpg",
    "title": "【#２】完全初見！アンダーテール：UNDERTALE【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-09T12:57:25Z"
  },
  {
    "videoId": "eEA5zA0GkfM",
    "thumbnail": "https://i.ytimg.com/vi/eEA5zA0GkfM/mqdefault.jpg",
    "title": "【#ホロ鳥 / #holobirds】KFP3号店作るちゅば！！！！：MINE CRAFT【大空スバル視点】",
    "publishedAt": "2021-03-11T14:39:29Z"
  },
  {
    "videoId": "YIpJ_x76xhg",
    "thumbnail": "https://i.ytimg.com/vi/YIpJ_x76xhg/mqdefault.jpg",
    "title": "【#生スバル】１時間で何キロやせる！？リングフィットアドベンチャー！：Ring Fit Adventure【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-12T13:29:06Z"
  },
  {
    "videoId": "TxhywIY2QHw",
    "thumbnail": "https://i.ytimg.com/vi/TxhywIY2QHw/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-13T03:19:29Z"
  },
  {
    "videoId": "85sC99YUkt4",
    "thumbnail": "https://i.ytimg.com/vi/85sC99YUkt4/mqdefault.jpg",
    "title": "【#最終回】零～眞紅の蝶～をするスバル：PROJECT ZERO 2 Wii EDITION【初見実況】",
    "publishedAt": "2021-03-13T10:07:19Z"
  },
  {
    "videoId": "zrIDw5iR2x0",
    "thumbnail": "https://i.ytimg.com/vi/zrIDw5iR2x0/mqdefault.jpg",
    "title": "【♯12】お覚悟！！！フリーシア&マリス！！！！：GRANBLUE FANTASY【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-14T09:15:47Z"
  },
  {
    "videoId": "tWG53VJzPHg",
    "thumbnail": "https://i.ytimg.com/vi/tWG53VJzPHg/mqdefault.jpg",
    "title": "【#ミオスバ】第1回　俺の考えるホロライブ最強企画【大空スバル/大神ミオ】",
    "publishedAt": "2021-03-16T14:14:36Z"
  },
  {
    "videoId": "rRhLCP2ykig",
    "thumbnail": "https://i.ytimg.com/vi/rRhLCP2ykig/mqdefault.jpg",
    "title": "【#生スバル】アイドルのレッスンってなにすんの？：What are you doing in idol lessons?【ホロリブ/大空スバル】",
    "publishedAt": "2021-03-18T13:16:28Z"
  },
  {
    "videoId": "CHvZk19prog",
    "thumbnail": "https://i.ytimg.com/vi/CHvZk19prog/mqdefault.jpg",
    "title": "【#生スバル】マイクラおさんぽ建築スバル：MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-19T14:27:21Z"
  },
  {
    "videoId": "1fT_wz7X8TM",
    "thumbnail": "https://i.ytimg.com/vi/1fT_wz7X8TM/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-20T03:22:35Z"
  },
  {
    "videoId": "3m9OsJ3n3gQ",
    "thumbnail": "https://i.ytimg.com/vi/3m9OsJ3n3gQ/mqdefault.jpg",
    "title": "【♯13】グラブル100連ガチャ！：GRANBLUE FANTASY【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-20T05:52:42Z"
  },
  {
    "videoId": "GctNU3HG2SQ",
    "thumbnail": "https://i.ytimg.com/vi/GctNU3HG2SQ/mqdefault.jpg",
    "title": "【大空スバル視点】女登呂温泉・湯けむり殺人事件【ホロミス劇場】",
    "publishedAt": "2021-03-20T12:40:07Z"
  },
  {
    "videoId": "UhlKk6lxUOw",
    "thumbnail": "https://i.ytimg.com/vi/UhlKk6lxUOw/mqdefault.jpg",
    "title": "【♯14】とりまトッポブで！スバル！！！！：GRANBLUE FANTASY【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-21T07:55:08Z"
  },
  {
    "videoId": "qfq5Ve_Ir4Y",
    "thumbnail": "https://i.ytimg.com/vi/qfq5Ve_Ir4Y/mqdefault.jpg",
    "title": "【#３】完全初見！アンダーテール：UNDERTALE【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-22T13:52:04Z"
  },
  {
    "videoId": "sz_Ela139rU",
    "thumbnail": "https://i.ytimg.com/vi/sz_Ela139rU/mqdefault.jpg",
    "title": "【#最終回】完全初見！トリエル生存ルート！：UNDERTALE【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-22T14:39:47Z"
  },
  {
    "videoId": "BBRoezXqI3k",
    "thumbnail": "https://i.ytimg.com/vi/BBRoezXqI3k/mqdefault.jpg",
    "title": "【#生スバル】空気読みスバル：Air Reaging Game【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-23T13:44:46Z"
  },
  {
    "videoId": "lVxMMjDpJVs",
    "thumbnail": "https://i.ytimg.com/vi/lVxMMjDpJVs/mqdefault.jpg",
    "title": "【80万人記念】大空警察！！：OOZORA Police【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-24T13:48:03Z"
  },
  {
    "videoId": "y4ibE6Cl8hs",
    "thumbnail": "https://i.ytimg.com/vi/y4ibE6Cl8hs/mqdefault.jpg",
    "title": "【※ネタバレ有】絶体絶命都市２すばる：Raw Danger２【#生スバル】",
    "publishedAt": "2021-03-25T13:26:50Z"
  },
  {
    "videoId": "zpDBzH5NRqw",
    "thumbnail": "https://i.ytimg.com/vi/zpDBzH5NRqw/mqdefault.jpg",
    "title": "【】おはようスバル：FREE TALK【】",
    "publishedAt": "2021-03-27T03:46:38Z"
  },
  {
    "videoId": "6jyuDNoiDwk",
    "thumbnail": "https://i.ytimg.com/vi/6jyuDNoiDwk/mqdefault.jpg",
    "title": "【※ネタバレ有】絶体絶命都市２すばる：Raw Danger２【#生スバル​】",
    "publishedAt": "2021-03-27T09:11:35Z"
  },
  {
    "videoId": "5EqyRq_LxCw",
    "thumbnail": "https://i.ytimg.com/vi/5EqyRq_LxCw/mqdefault.jpg",
    "title": "【※ネタバレ有】絶体絶命都市２すばる：Raw Danger２【#生スバル​】",
    "publishedAt": "2021-03-28T08:07:27Z"
  },
  {
    "videoId": "7S9XOJEzjao",
    "thumbnail": "https://i.ytimg.com/vi/7S9XOJEzjao/mqdefault.jpg",
    "title": "【#生スバル】帰ってきた！！！！！視聴者分の１！！！【ホロライブ/大空スバル】",
    "publishedAt": "2021-03-31T12:52:35Z"
  },
  {
    "videoId": "VFQzN4iAmtI",
    "thumbnail": "https://i.ytimg.com/vi/VFQzN4iAmtI/mqdefault.jpg",
    "title": "【】すばるの！全部ホントニュース！【】",
    "publishedAt": "2021-04-01T12:45:03Z"
  },
  {
    "videoId": "VW6SVPIiIvU",
    "thumbnail": "https://i.ytimg.com/vi/VW6SVPIiIvU/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-03T04:16:42Z"
  },
  {
    "videoId": "TGOenZUIxd4",
    "thumbnail": "https://i.ytimg.com/vi/TGOenZUIxd4/mqdefault.jpg",
    "title": "【#生スバル】バイオハザード7：RESIDENT EVIL 7 biohazard【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-04T09:51:50Z"
  },
  {
    "videoId": "0pEHPCJMQ08",
    "thumbnail": "https://i.ytimg.com/vi/0pEHPCJMQ08/mqdefault.jpg",
    "title": "【#生スバル】バイオハザード7：RESIDENT EVIL 7 biohazard【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-05T14:35:28Z"
  },
  {
    "videoId": "eCk6rDLSBvs",
    "thumbnail": "https://i.ytimg.com/vi/eCk6rDLSBvs/mqdefault.jpg",
    "title": "【#生スバル】カプとれでクレーンゲームすばう/Game Center Crane Games【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-06T12:39:00Z"
  },
  {
    "videoId": "9FiX3Cjny4E",
    "thumbnail": "https://i.ytimg.com/vi/9FiX3Cjny4E/mqdefault.jpg",
    "title": "【#生スバル】バイオハザード7最終回：RESIDENT EVIL 7 biohazard【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-08T16:30:46Z"
  },
  {
    "videoId": "8OHLlG2aQTs",
    "thumbnail": "https://i.ytimg.com/vi/8OHLlG2aQTs/mqdefault.jpg",
    "title": "【#ホロAmongUs​​​】まじでやばいすばう【ホロライブ/大空スバル視点】",
    "publishedAt": "2021-04-09T14:54:49Z"
  },
  {
    "videoId": "cTyPT0Zk4-M",
    "thumbnail": "https://i.ytimg.com/vi/cTyPT0Zk4-M/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-10T03:32:43Z"
  },
  {
    "videoId": "dNM_iJCGRDQ",
    "thumbnail": "https://i.ytimg.com/vi/dNM_iJCGRDQ/mqdefault.jpg",
    "title": "【♯15】リーシャと共に！！おひさし本編：GRANBLUE FANTASY【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-10T09:14:08Z"
  },
  {
    "videoId": "lHtlf0dygPM",
    "thumbnail": "https://i.ytimg.com/vi/lHtlf0dygPM/mqdefault.jpg",
    "title": "【#１】鬼畜ゲー？！最難関Gルート耐久！：UNDERTALE【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-12T19:51:40Z"
  },
  {
    "videoId": "kKwSqs5rZjI",
    "thumbnail": "https://i.ytimg.com/vi/kKwSqs5rZjI/mqdefault.jpg",
    "title": "【#生スバル】初見実況！ロックマン２すばる！：Megaman【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-13T11:04:59Z"
  },
  {
    "videoId": "Vzrq6ehJ_Oc",
    "thumbnail": "https://i.ytimg.com/vi/Vzrq6ehJ_Oc/mqdefault.jpg",
    "title": "【#生スバル​】バイオハザード7DLC Not a Hero：RESIDENT EVIL 7 biohazard【※ネタバレ有】",
    "publishedAt": "2021-04-16T13:31:28Z"
  },
  {
    "videoId": "g5LH-XPQ_oQ",
    "thumbnail": "https://i.ytimg.com/vi/g5LH-XPQ_oQ/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-17T03:44:02Z"
  },
  {
    "videoId": "GfYmvsRLAcE",
    "thumbnail": "https://i.ytimg.com/vi/GfYmvsRLAcE/mqdefault.jpg",
    "title": "【#生スバル】リベンジ！！ロックマン２すばる！：Megaman【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-17T13:13:47Z"
  },
  {
    "videoId": "cHDeTO2Bj0Q",
    "thumbnail": "https://i.ytimg.com/vi/cHDeTO2Bj0Q/mqdefault.jpg",
    "title": "【#生スバル】ロックマン２すばる！クリアまで！！：Megaman【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-18T11:22:23Z"
  },
  {
    "videoId": "bir5v6ey1P4",
    "thumbnail": "https://i.ytimg.com/vi/bir5v6ey1P4/mqdefault.jpg",
    "title": "【#生スバル】ロックマン２すばる！まじで最後！！！！！！：Megaman【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-18T12:52:43Z"
  },
  {
    "videoId": "Cq2U6XE8Y68",
    "thumbnail": "https://i.ytimg.com/vi/Cq2U6XE8Y68/mqdefault.jpg",
    "title": "【#最終回】鬼畜ゲー？！最難関Gルート耐久！本当の本当の最後！：UNDERTALE【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-20T13:25:32Z"
  },
  {
    "videoId": "33Rdd1PHRkU",
    "thumbnail": "https://i.ytimg.com/vi/33Rdd1PHRkU/mqdefault.jpg",
    "title": "【#２】鬼畜ゲー？！最難関Gルート耐久！：UNDERTALE【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-20T18:56:16Z"
  },
  {
    "videoId": "WkOCD9o5EAM",
    "thumbnail": "https://i.ytimg.com/vi/WkOCD9o5EAM/mqdefault.jpg",
    "title": "【】うおおおおおおおおおおおおお/my voice is.........【】",
    "publishedAt": "2021-04-26T12:45:59Z"
  },
  {
    "videoId": "STmEvp2WTxc",
    "thumbnail": "https://i.ytimg.com/vi/STmEvp2WTxc/mqdefault.jpg",
    "title": "【#生スバル】バイオハザード7DLC END OF ZOE：RESIDENT EVIL 7 biohazard DLC【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-27T13:46:31Z"
  },
  {
    "videoId": "9Z81DQCERtU",
    "thumbnail": "https://i.ytimg.com/vi/9Z81DQCERtU/mqdefault.jpg",
    "title": "【#16】1章終盤！第三勢力登場？！なんだおめえら！！！！/gran blue fantasy【ホロライブ/大空スバル】",
    "publishedAt": "2021-04-29T13:30:52Z"
  },
  {
    "videoId": "pcpVmdvLGlk",
    "thumbnail": "https://i.ytimg.com/vi/pcpVmdvLGlk/mqdefault.jpg",
    "title": "【#生スバル】うま娘が気になりすぎてガチ乗馬しにいったしゅばああああああレポ！！！！/Horseback riding experience report【】",
    "publishedAt": "2021-04-30T14:42:55Z"
  },
  {
    "videoId": "zgzMM3B9YeY",
    "thumbnail": "https://i.ytimg.com/vi/zgzMM3B9YeY/mqdefault.jpg",
    "title": "【】おはすば【】",
    "publishedAt": "2021-05-01T01:32:35Z"
  },
  {
    "videoId": "ESu_muCBq6k",
    "thumbnail": "https://i.ytimg.com/vi/ESu_muCBq6k/mqdefault.jpg",
    "title": "【#生スバル】完全初見！？ウマ娘しゅばああああああああああ/UMAMUSUME【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-01T06:05:10Z"
  },
  {
    "videoId": "ji4eRk5WuxA",
    "thumbnail": "https://i.ytimg.com/vi/ji4eRk5WuxA/mqdefault.jpg",
    "title": "【#生スバル】完全初見！？ウマ娘しゅばああああああああああ/UMAMUSUME【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-01T09:32:47Z"
  },
  {
    "videoId": "lsygJhiTx2s",
    "thumbnail": "https://i.ytimg.com/vi/lsygJhiTx2s/mqdefault.jpg",
    "title": "【#生スバル】らいすしゃわ～～～～～～わ～～～～！！！！：UMA MUSUME【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-02T08:09:56Z"
  },
  {
    "videoId": "VSLp--YmgPQ",
    "thumbnail": "https://i.ytimg.com/vi/VSLp--YmgPQ/mqdefault.jpg",
    "title": "【】歯の痛みをモンスターにぶつけるモンハンゲリラしゅばああああああああああああああ【】",
    "publishedAt": "2021-05-04T11:04:58Z"
  },
  {
    "videoId": "yzVS_fl9rSU",
    "thumbnail": "https://i.ytimg.com/vi/yzVS_fl9rSU/mqdefault.jpg",
    "title": "【#生スバル】お兄様！お姉さま大集合！！！行くぞ！！日経賞！！！/ UMAMUSUME【ホロライブ】",
    "publishedAt": "2021-05-05T09:11:42Z"
  },
  {
    "videoId": "4FpQSnIs26k",
    "thumbnail": "https://i.ytimg.com/vi/4FpQSnIs26k/mqdefault.jpg",
    "title": "【#生スバル】おかころの間に割り込みたいスバル：モーリーオンライン：claw machine game【たのじみ！！】",
    "publishedAt": "2021-05-07T13:08:48Z"
  },
  {
    "videoId": "04Ic6Bl1glg",
    "thumbnail": "https://i.ytimg.com/vi/04Ic6Bl1glg/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-08T03:23:28Z"
  },
  {
    "videoId": "ruYrvVFdij4",
    "thumbnail": "https://i.ytimg.com/vi/ruYrvVFdij4/mqdefault.jpg",
    "title": "【#１】完全初見！悪魔退治やるしゅばああああああ！！！：DMC３【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-08T06:44:21Z"
  },
  {
    "videoId": "P0Fq-bKdNro",
    "thumbnail": "https://i.ytimg.com/vi/P0Fq-bKdNro/mqdefault.jpg",
    "title": "【#２】リベンジやるしゅばああああああ！！Duck May Cry！：DMC３【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-09T08:20:43Z"
  },
  {
    "videoId": "gLuIiQPfHQE",
    "thumbnail": "https://i.ytimg.com/vi/gLuIiQPfHQE/mqdefault.jpg",
    "title": "【#生スバル】布教凸待ち/TOTUMACHI【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-12T16:33:05Z"
  },
  {
    "videoId": "cNqbcr8jNHo",
    "thumbnail": "https://i.ytimg.com/vi/cNqbcr8jNHo/mqdefault.jpg",
    "title": "【#生スバル】まいくらしゅばあああああああああああああ/マイクラ【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-13T12:05:50Z"
  },
  {
    "videoId": "pGdQB7nPOi8",
    "thumbnail": "https://i.ytimg.com/vi/pGdQB7nPOi8/mqdefault.jpg",
    "title": "【視聴者参加型】クイズバトルオンラインで勝負ちゅばあああああああああああああ！！！！！！！！！【】",
    "publishedAt": "2021-05-14T12:51:21Z"
  },
  {
    "videoId": "pWY59Zu13XI",
    "thumbnail": "https://i.ytimg.com/vi/pWY59Zu13XI/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-15T03:22:44Z"
  },
  {
    "videoId": "HaKW7hxQJYM",
    "thumbnail": "https://i.ytimg.com/vi/HaKW7hxQJYM/mqdefault.jpg",
    "title": "【#最終回】続きやるしゅばああああああ！！Duck May Cry！：DMC３【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-15T11:51:16Z"
  },
  {
    "videoId": "8J30L8myCKc",
    "thumbnail": "https://i.ytimg.com/vi/8J30L8myCKc/mqdefault.jpg",
    "title": "【#17】グラブル第一章！完結！！！！！：granblue fantasy story【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-16T11:01:15Z"
  },
  {
    "videoId": "ZF08XhEAvmg",
    "thumbnail": "https://i.ytimg.com/vi/ZF08XhEAvmg/mqdefault.jpg",
    "title": "【#holounggas #holobirds #ホロ鳥】鳥山（bird mountain）つくるしゅばあああああ！！！！/Reine&Subaru Minecraft【大空スバル視点】",
    "publishedAt": "2021-05-18T14:03:08Z"
  },
  {
    "videoId": "yp19LT9qJe4",
    "thumbnail": "https://i.ytimg.com/vi/yp19LT9qJe4/mqdefault.jpg",
    "title": "【#生スバル】2年間でスバ友はどう変わった？！リスナー調査しゅば！！！！：subaru lisner Reserch!!!!!!【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-20T13:56:02Z"
  },
  {
    "videoId": "K6kJV6b3eqs",
    "thumbnail": "https://i.ytimg.com/vi/K6kJV6b3eqs/mqdefault.jpg",
    "title": "【#生スバル】すいません！機材トラブルで来週になります！！！！：sausage legend【レート：1000↑】",
    "publishedAt": "2021-05-21T12:25:38Z"
  },
  {
    "videoId": "xAh1qYk6Wsc",
    "thumbnail": "https://i.ytimg.com/vi/xAh1qYk6Wsc/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-22T03:07:29Z"
  },
  {
    "videoId": "aqbZ5jk5Tg0",
    "thumbnail": "https://i.ytimg.com/vi/aqbZ5jk5Tg0/mqdefault.jpg",
    "title": "【#生スバル】バイオハザードヴィレッジ：Resident Evil Village【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-22T10:56:48Z"
  },
  {
    "videoId": "PuvM9PNM8vI",
    "thumbnail": "https://i.ytimg.com/vi/PuvM9PNM8vI/mqdefault.jpg",
    "title": "【#2】バイオハザードヴィレッジ：Resident Evil Village【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-23T10:58:41Z"
  },
  {
    "videoId": "5jyLefFYPyM",
    "thumbnail": "https://i.ytimg.com/vi/5jyLefFYPyM/mqdefault.jpg",
    "title": "【#生スバル】こっちが本当！第十回ソーセージレジェンド大会！！！：sausage legend【レート：1000↑】",
    "publishedAt": "2021-05-24T12:08:18Z"
  },
  {
    "videoId": "Oj1dunXOn3g",
    "thumbnail": "https://i.ytimg.com/vi/Oj1dunXOn3g/mqdefault.jpg",
    "title": "【#最終回】バイオハザードヴィレッジ：Resident Evil Village【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-24T16:26:10Z"
  },
  {
    "videoId": "ByESAQZnQXk",
    "thumbnail": "https://i.ytimg.com/vi/ByESAQZnQXk/mqdefault.jpg",
    "title": "【#大空スバル新衣装】90万人記念新衣装大発表会/NEW OUT FIT【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-26T13:08:54Z"
  },
  {
    "videoId": "kdI0vBpWFkQ",
    "thumbnail": "https://i.ytimg.com/vi/kdI0vBpWFkQ/mqdefault.jpg",
    "title": "【#ポントーク】ギリギリ！！！PONトーク！！！！！！/PON TALK【ホロライブ/みこスバ】",
    "publishedAt": "2021-05-28T12:18:43Z"
  },
  {
    "videoId": "u0GBcKzkZcs",
    "thumbnail": "https://i.ytimg.com/vi/u0GBcKzkZcs/mqdefault.jpg",
    "title": "【#生スバル】おはスバ/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2021-05-29T02:46:29Z"
  },
  {
    "videoId": "r1Saj9-GHhg",
    "thumbnail": "https://i.ytimg.com/vi/r1Saj9-GHhg/mqdefault.jpg",
    "title": "【#１】DQシリーズ完全初見！ドラゴンクエスト8！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-05-29T08:21:32Z"
  },
  {
    "videoId": "Ov6KR0htGYA",
    "thumbnail": "https://i.ytimg.com/vi/Ov6KR0htGYA/mqdefault.jpg",
    "title": "【#2】DQシリーズ完全初見！ドラゴンクエスト8！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-05-30T09:55:31Z"
  },
  {
    "videoId": "m9IQH5WIGuQ",
    "thumbnail": "https://i.ytimg.com/vi/m9IQH5WIGuQ/mqdefault.jpg",
    "title": "【#生スバル】ハリーポッター賢者の石同時視聴会：Harry Potter and the Philosopher's Stone movie party!【ホロライブ/大空スバル】",
    "publishedAt": "2021-06-01T15:12:12Z"
  },
  {
    "videoId": "0y3CkFyPcW4",
    "thumbnail": "https://i.ytimg.com/vi/0y3CkFyPcW4/mqdefault.jpg",
    "title": "【#スバちょこルーナ】地獄くじ引き？！足つぼダンス？！？かかってこいや！！！！:subachocoruna 3D stream【ホロライブ】",
    "publishedAt": "2021-06-03T12:08:24Z"
  },
  {
    "videoId": "8uB_hqKNF5k",
    "thumbnail": "https://i.ytimg.com/vi/8uB_hqKNF5k/mqdefault.jpg",
    "title": "【#生スバル】びっくり系ホラゲー/Horror game【ホロライブ/大空スバル】",
    "publishedAt": "2021-06-04T12:08:51Z"
  },
  {
    "videoId": "YFXr_KJapHI",
    "thumbnail": "https://i.ytimg.com/vi/YFXr_KJapHI/mqdefault.jpg",
    "title": "【#生スバル】おはスバ/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2021-06-05T03:09:51Z"
  },
  {
    "videoId": "bIhIq8f5gjM",
    "thumbnail": "https://i.ytimg.com/vi/bIhIq8f5gjM/mqdefault.jpg",
    "title": "【#3】DQシリーズ完全初見！ドラゴンクエスト8！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-06-05T09:08:49Z"
  },
  {
    "videoId": "6oeLAo6DFHI",
    "thumbnail": "https://i.ytimg.com/vi/6oeLAo6DFHI/mqdefault.jpg",
    "title": "【#4】DQシリーズ完全初見！ドラゴンクエスト8！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-06-06T10:26:16Z"
  },
  {
    "videoId": "RoFhQcpJ_l4",
    "thumbnail": "https://i.ytimg.com/vi/RoFhQcpJ_l4/mqdefault.jpg",
    "title": "【#生スバル】クリアまで！！びっくり系ホラゲー/Horror game【ホロライブ/大空スバル】",
    "publishedAt": "2021-06-08T13:37:47Z"
  },
  {
    "videoId": "zxVPdZjZS7U",
    "thumbnail": "https://i.ytimg.com/vi/zxVPdZjZS7U/mqdefault.jpg",
    "title": "【#生スバル】The Henry Stickminであそぶしゅばあああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2021-06-11T14:49:35Z"
  },
  {
    "videoId": "gh57KeYIdWU",
    "thumbnail": "https://i.ytimg.com/vi/gh57KeYIdWU/mqdefault.jpg",
    "title": "【】free talk/おはスバ【】",
    "publishedAt": "2021-06-12T03:20:32Z"
  },
  {
    "videoId": "GZIdmAhkGwQ",
    "thumbnail": "https://i.ytimg.com/vi/GZIdmAhkGwQ/mqdefault.jpg",
    "title": "【#5】DQシリーズ完全初見！ドラゴンクエスト8！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-06-12T09:55:42Z"
  },
  {
    "videoId": "zwSPBv7W2HI",
    "thumbnail": "https://i.ytimg.com/vi/zwSPBv7W2HI/mqdefault.jpg",
    "title": "【#6】DQシリーズ完全初見！ドラゴンクエスト8！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-06-13T12:04:32Z"
  },
  {
    "videoId": "gM2oV5F9XEk",
    "thumbnail": "https://i.ytimg.com/vi/gM2oV5F9XEk/mqdefault.jpg",
    "title": "【#すばおかみょーん】地獄なりきりUNO【ホロライブ】",
    "publishedAt": "2021-06-14T12:30:43Z"
  },
  {
    "videoId": "AFq464pVltU",
    "thumbnail": "https://i.ytimg.com/vi/AFq464pVltU/mqdefault.jpg",
    "title": "【#生スバル】なんかやばいスタジオでアニメのED収録してきたぞレポ！！：Report on the recording of the anime ED【ホロライブ/大空スバル】",
    "publishedAt": "2021-06-15T12:44:14Z"
  },
  {
    "videoId": "8lLTNBX1U_M",
    "thumbnail": "https://i.ytimg.com/vi/8lLTNBX1U_M/mqdefault.jpg",
    "title": "【#生スバル】夏祭り会場みにいくぞ！！！！mine craft！！【ホロライブ/大空スバル】",
    "publishedAt": "2021-06-16T13:23:33Z"
  },
  {
    "videoId": "y7WHzskFGfM",
    "thumbnail": "https://i.ytimg.com/vi/y7WHzskFGfM/mqdefault.jpg",
    "title": "【#7】DQシリーズ完全初見！ドラゴンクエスト8！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-06-19T08:58:42Z"
  },
  {
    "videoId": "3Y3CXVZf7SE",
    "thumbnail": "https://i.ytimg.com/vi/3Y3CXVZf7SE/mqdefault.jpg",
    "title": "【#生スバル】NieR Re[in]carnation初見実況するしゅばああああああああああああああああ【ホロライブ/大空スバル】",
    "publishedAt": "2021-06-19T12:50:41Z"
  },
  {
    "videoId": "_fHT34m5W4U",
    "thumbnail": "https://i.ytimg.com/vi/_fHT34m5W4U/mqdefault.jpg",
    "title": "【】free talk/おはスバ【】",
    "publishedAt": "2021-06-20T04:17:06Z"
  },
  {
    "videoId": "-ixsnZp-E1s",
    "thumbnail": "https://i.ytimg.com/vi/-ixsnZp-E1s/mqdefault.jpg",
    "title": "【#イカロスジェットコースター】大清楚アイドルなら常識クイズも余裕しゅば！！！！！スバトワコラボ！/Common sense quiz subatowa【ホロライブ】",
    "publishedAt": "2021-06-22T12:35:39Z"
  },
  {
    "videoId": "69G424cBzms",
    "thumbnail": "https://i.ytimg.com/vi/69G424cBzms/mqdefault.jpg",
    "title": "【#大空建設】夏祭り準備みんなでするしゅばああああああああああ！！minecraft 【大空スバル視点】",
    "publishedAt": "2021-06-23T12:42:52Z"
  },
  {
    "videoId": "c6YxMrWaLRE",
    "thumbnail": "https://i.ytimg.com/vi/c6YxMrWaLRE/mqdefault.jpg",
    "title": "【#8】DQシリーズ完全初見！ドラゴンクエスト8！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-06-26T10:47:23Z"
  },
  {
    "videoId": "2ywSWONXIrM",
    "thumbnail": "https://i.ytimg.com/vi/2ywSWONXIrM/mqdefault.jpg",
    "title": "【#9】DQシリーズ完全初見！ドラゴンクエスト8！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-06-27T10:59:38Z"
  },
  {
    "videoId": "Bj1jshJaSDY",
    "thumbnail": "https://i.ytimg.com/vi/Bj1jshJaSDY/mqdefault.jpg",
    "title": "【#うさ建夏祭り】夏祭りみんなでいくしゅばああああああああああああ！minecraft 【大空スバル視点】",
    "publishedAt": "2021-06-27T15:10:12Z"
  },
  {
    "videoId": "6a1dDxIsd6Y",
    "thumbnail": "https://i.ytimg.com/vi/6a1dDxIsd6Y/mqdefault.jpg",
    "title": "【#ホロプラ】第１部！！視聴者参加型アイドルP対決？！アイプラするちゅばああああ！！！！【IDOLY PRIDE/大空スバル】",
    "publishedAt": "2021-06-28T04:07:30Z"
  },
  {
    "videoId": "sN9-I9XkcsY",
    "thumbnail": "https://i.ytimg.com/vi/sN9-I9XkcsY/mqdefault.jpg",
    "title": "【IDOLY PRIDE】第２部！！アイプラするちゅばああああああああ！！！！！！【#ホロプラ/大空スバル】",
    "publishedAt": "2021-06-28T14:15:32Z"
  },
  {
    "videoId": "GbTdxtWMrsU",
    "thumbnail": "https://i.ytimg.com/vi/GbTdxtWMrsU/mqdefault.jpg",
    "title": "【#生スバル】罰ゲーム！！！需要？！？知らねぇ！！！ガチASMR地獄配信！！！！：DEATH ASMR stream【】",
    "publishedAt": "2021-06-30T14:10:58Z"
  },
  {
    "videoId": "I8Q7nMijBys",
    "thumbnail": "https://i.ytimg.com/vi/I8Q7nMijBys/mqdefault.jpg",
    "title": "【#おたおめスバル】おたんじょうび！！！！！！！！！！HAPPY BIRTH DAY SUBARU!!!【見てみな、飛ぶぞ】",
    "publishedAt": "2021-07-02T12:13:20Z"
  },
  {
    "videoId": "BrUuY9wrCdA",
    "thumbnail": "https://i.ytimg.com/vi/BrUuY9wrCdA/mqdefault.jpg",
    "title": "【#生スバル】free talk/おはスバ【ホロライブ/大空スバル】",
    "publishedAt": "2021-07-03T03:37:58Z"
  },
  {
    "videoId": "rJJTJA_T_b0",
    "thumbnail": "https://i.ytimg.com/vi/rJJTJA_T_b0/mqdefault.jpg",
    "title": "【#10】DQシリーズ完全初見！ドラゴンクエスト8！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-07-03T10:50:21Z"
  },
  {
    "videoId": "NidpuUfzfrQ",
    "thumbnail": "https://i.ytimg.com/vi/NidpuUfzfrQ/mqdefault.jpg",
    "title": "【#11】DQシリーズ完全初見！ドラゴンクエスト8！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-07-04T10:44:11Z"
  },
  {
    "videoId": "v_jVJt5ub1o",
    "thumbnail": "https://i.ytimg.com/vi/v_jVJt5ub1o/mqdefault.jpg",
    "title": "【料理配信】人生初？！揚げバター作るしゅば！！！！！！！！！！！！/Cooking fried butter First time in my life【】",
    "publishedAt": "2021-07-08T12:07:20Z"
  },
  {
    "videoId": "N16A2XNu0L4",
    "thumbnail": "https://i.ytimg.com/vi/N16A2XNu0L4/mqdefault.jpg",
    "title": "【#大空警察】第２回大空警察しゅばあああああああああああああ/OOZORA POLICE【逮捕しゅば！！！】",
    "publishedAt": "2021-07-09T13:15:53Z"
  },
  {
    "videoId": "td5_LE8Ccj8",
    "thumbnail": "https://i.ytimg.com/vi/td5_LE8Ccj8/mqdefault.jpg",
    "title": "【#12】DQシリーズ完全初見！ラストダンジョン！！！ドラゴンクエスト8！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-07-10T10:16:21Z"
  },
  {
    "videoId": "PT58tchood4",
    "thumbnail": "https://i.ytimg.com/vi/PT58tchood4/mqdefault.jpg",
    "title": "【#本編最終回】DQシリーズ完全初見！クリアするぞ！！！！！！！ドラゴンクエスト8！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-07-10T14:42:02Z"
  },
  {
    "videoId": "vnaW6DJc-Zc",
    "thumbnail": "https://i.ytimg.com/vi/vnaW6DJc-Zc/mqdefault.jpg",
    "title": "【#生スバル】free talk/おはスバ【ホロライブ/大空スバル】",
    "publishedAt": "2021-07-11T03:10:22Z"
  },
  {
    "videoId": "a7QdcTjK2PI",
    "thumbnail": "https://i.ytimg.com/vi/a7QdcTjK2PI/mqdefault.jpg",
    "title": "【#生スバル】free talk/おはスバ【ホロライブ/大空スバル】",
    "publishedAt": "2021-07-17T04:39:02Z"
  },
  {
    "videoId": "Kk9Kq-cfBdg",
    "thumbnail": "https://i.ytimg.com/vi/Kk9Kq-cfBdg/mqdefault.jpg",
    "title": "【観覧注意】顕微鏡配信しゅばあああああああ！！！！/Stream to see the micro world with a microscope【ホロライブ/大空スバル】",
    "publishedAt": "2021-07-18T07:10:35Z"
  },
  {
    "videoId": "cQgLAgOLh74",
    "thumbnail": "https://i.ytimg.com/vi/cQgLAgOLh74/mqdefault.jpg",
    "title": "【#生スバル】悪い子はいねえか～～！！！！大空警察パトロールちゅば！！/MINE CRAFT【大空スバル/ホロライブ】",
    "publishedAt": "2021-07-20T13:11:03Z"
  },
  {
    "videoId": "cPxE14YqJKE",
    "thumbnail": "https://i.ytimg.com/vi/cPxE14YqJKE/mqdefault.jpg",
    "title": "【視聴者参加】みんなはどっち派？！アンケートで決着をつけるしゅばああああああああああ！！！！！！！！/Let`s QUESTIONNAIRE‼‼‼【Viewer participation type】",
    "publishedAt": "2021-07-21T15:10:09Z"
  },
  {
    "videoId": "Zdy7fPogJvI",
    "thumbnail": "https://i.ytimg.com/vi/Zdy7fPogJvI/mqdefault.jpg",
    "title": "【#生スバル】おきれますように！！！　おはスバ！/FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-07-24T02:16:39Z"
  },
  {
    "videoId": "YhRKFUCooik",
    "thumbnail": "https://i.ytimg.com/vi/YhRKFUCooik/mqdefault.jpg",
    "title": "【#クリア後裏ルート】DQシリーズ完全初見！裏ルートいくぞ！！！ドラゴンクエスト8！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-07-24T10:34:35Z"
  },
  {
    "videoId": "FrIeQGmkY58",
    "thumbnail": "https://i.ytimg.com/vi/FrIeQGmkY58/mqdefault.jpg",
    "title": "【#生スバル】初見実況！！俺たちの！！！！！レンジャーサインしゅば！！！：GRANBLUE FANTASY【ホロライブ/大空スバル】",
    "publishedAt": "2021-07-25T08:23:18Z"
  },
  {
    "videoId": "Wz6Os0EzyRM",
    "thumbnail": "https://i.ytimg.com/vi/Wz6Os0EzyRM/mqdefault.jpg",
    "title": "【#ババドナ】無音の世界？！大声出したら即終了！！/If you shout out, it will end immediately【ホロライブ/大空スバル】",
    "publishedAt": "2021-07-27T13:11:19Z"
  },
  {
    "videoId": "GXJGd8WmEto",
    "thumbnail": "https://i.ytimg.com/vi/GXJGd8WmEto/mqdefault.jpg",
    "title": "【#ババドナ】無音の世界？！大声出したら即終了！！/If you shout out, it will end immediately【ホロライブ/大空スバル】",
    "publishedAt": "2021-07-27T14:24:15Z"
  },
  {
    "videoId": "zPCYveAOQJI",
    "thumbnail": "https://i.ytimg.com/vi/zPCYveAOQJI/mqdefault.jpg",
    "title": "【#すばちょこるなたん】ぼたん教官によるスバちょこルーナCoD【大空スバル視点】",
    "publishedAt": "2021-07-28T15:46:46Z"
  },
  {
    "videoId": "m42ycks1Qls",
    "thumbnail": "https://i.ytimg.com/vi/m42ycks1Qls/mqdefault.jpg",
    "title": "【#生スバル】おはスバ！/FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-07-31T02:11:32Z"
  },
  {
    "videoId": "R937dYOC4Mw",
    "thumbnail": "https://i.ytimg.com/vi/R937dYOC4Mw/mqdefault.jpg",
    "title": "【#1】完全初見！！！！初代FF７！！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-08-01T10:10:25Z"
  },
  {
    "videoId": "fZY0dD3PxMU",
    "thumbnail": "https://i.ytimg.com/vi/fZY0dD3PxMU/mqdefault.jpg",
    "title": "【#subamoon】視聴者参加！ムーナとお絵描き伝言ゲームするしゅばああああ！！！/MOONA collabo【ホロライブ】",
    "publishedAt": "2021-08-01T12:16:17Z"
  },
  {
    "videoId": "1boT3h-dw1k",
    "thumbnail": "https://i.ytimg.com/vi/1boT3h-dw1k/mqdefault.jpg",
    "title": "【#生スバル】夏休みホラー：人生初青鬼：AOONI【ホロライブ/大空スバル】",
    "publishedAt": "2021-08-04T15:09:26Z"
  },
  {
    "videoId": "H_jf6Z-6C3Y",
    "thumbnail": "https://i.ytimg.com/vi/H_jf6Z-6C3Y/mqdefault.jpg",
    "title": "【#生スバル】第１１回ソーセージレジェンド大会：SAUSAGE LEGEND【ホロライブ/大空スバル】",
    "publishedAt": "2021-08-05T14:39:21Z"
  },
  {
    "videoId": "vjbcPzja8NU",
    "thumbnail": "https://i.ytimg.com/vi/vjbcPzja8NU/mqdefault.jpg",
    "title": "【#生スバル】1日警察署長するしゅばあああ！！！！：Police Simulator: Patrol Officers【ホロライブ/大空スバル】",
    "publishedAt": "2021-08-06T12:50:09Z"
  },
  {
    "videoId": "tLzXVo8ZCIM",
    "thumbnail": "https://i.ytimg.com/vi/tLzXVo8ZCIM/mqdefault.jpg",
    "title": "【#生スバル】夏休みスペシャル！ゲスト有！？おはスバ！/FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-08-07T02:12:21Z"
  },
  {
    "videoId": "SgPvXloCWGY",
    "thumbnail": "https://i.ytimg.com/vi/SgPvXloCWGY/mqdefault.jpg",
    "title": "【#2】完全初見！！！！初代FF７！！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-08-07T20:25:24Z"
  },
  {
    "videoId": "3bB4MHeQ1Ns",
    "thumbnail": "https://i.ytimg.com/vi/3bB4MHeQ1Ns/mqdefault.jpg",
    "title": "【#3】完全初見！！！！初代FF７！！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-08-08T09:56:33Z"
  },
  {
    "videoId": "cXL6F8J-GXo",
    "thumbnail": "https://i.ytimg.com/vi/cXL6F8J-GXo/mqdefault.jpg",
    "title": "【#生スバル】夏だからスーパーボール作るしゅばああああああああああ！！/making Bouncy ball 【ホロライブ/大空スバル】",
    "publishedAt": "2021-08-10T13:15:37Z"
  },
  {
    "videoId": "BdF90qYNVOo",
    "thumbnail": "https://i.ytimg.com/vi/BdF90qYNVOo/mqdefault.jpg",
    "title": "【#ホロ怖】本当にあったホロライブの怖い話/Scary stories about holo-lives that really happened【ホロライブ】",
    "publishedAt": "2021-08-11T14:21:11Z"
  },
  {
    "videoId": "gbgdZM0qN3Y",
    "thumbnail": "https://i.ytimg.com/vi/gbgdZM0qN3Y/mqdefault.jpg",
    "title": "【#生スバル】夏休みスペシャル！ゲスト有！？おはスバ！/FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-08-14T02:21:12Z"
  },
  {
    "videoId": "DYJNpeexpcM",
    "thumbnail": "https://i.ytimg.com/vi/DYJNpeexpcM/mqdefault.jpg",
    "title": "【#4】完全初見！！！！初代FF７！！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-08-14T09:58:49Z"
  },
  {
    "videoId": "rKuEaGccFV8",
    "thumbnail": "https://i.ytimg.com/vi/rKuEaGccFV8/mqdefault.jpg",
    "title": "【#5】完全初見！！！！初代FF７！！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-08-15T10:11:04Z"
  },
  {
    "videoId": "26WKk3kl700",
    "thumbnail": "https://i.ytimg.com/vi/26WKk3kl700/mqdefault.jpg",
    "title": "【 #スバちょこるなたん 】ＣＯＤでゾンビ倒すしゅばああああああああああああああああ！！！！： Call of Duty：BOCW【大空スバル/ホロライブ】",
    "publishedAt": "2021-08-16T16:58:57Z"
  },
  {
    "videoId": "m5goge3MhKY",
    "thumbnail": "https://i.ytimg.com/vi/m5goge3MhKY/mqdefault.jpg",
    "title": "【#生スバル】夏だね♡花火打ち上げ会場：Fireworks Mania【ホロライブ/大空スバル】",
    "publishedAt": "2021-08-18T13:28:48Z"
  },
  {
    "videoId": "W1MNp6HHwCg",
    "thumbnail": "https://i.ytimg.com/vi/W1MNp6HHwCg/mqdefault.jpg",
    "title": "【 #スバちょこるなたん 】ＣＯＤでゾンビ倒すしゅばあああああリベンジあああああああああああ！！！！： Call of Duty：BOCW【大空スバル/ホロライブ】",
    "publishedAt": "2021-08-19T16:43:12Z"
  },
  {
    "videoId": "0Op5oxqqFL4",
    "thumbnail": "https://i.ytimg.com/vi/0Op5oxqqFL4/mqdefault.jpg",
    "title": "【#生スバル】ぼっこぼこにしてやるしゅばあああああああ！！！！！視聴者参加型マリカ/Viewer participation type Mario Kart【ホロライブ/大空スバル】",
    "publishedAt": "2021-08-20T12:03:28Z"
  },
  {
    "videoId": "sYUkxO05w-I",
    "thumbnail": "https://i.ytimg.com/vi/sYUkxO05w-I/mqdefault.jpg",
    "title": "【#生スバル】夏休みスペシャル！ゲスト有！？おはスバ！/FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-08-21T02:10:46Z"
  },
  {
    "videoId": "GjLN9uRAmgU",
    "thumbnail": "https://i.ytimg.com/vi/GjLN9uRAmgU/mqdefault.jpg",
    "title": "【#7】完全初見！！超えるぞ！！！！雪原！！！初代FF７！！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-08-22T08:06:04Z"
  },
  {
    "videoId": "9kvMkzJr_l8",
    "thumbnail": "https://i.ytimg.com/vi/9kvMkzJr_l8/mqdefault.jpg",
    "title": "【GARTIC PHONE】みんなでお絵描きやるしゅばああああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2021-08-22T14:48:00Z"
  },
  {
    "videoId": "V4GGxWUfFXw",
    "thumbnail": "https://i.ytimg.com/vi/V4GGxWUfFXw/mqdefault.jpg",
    "title": "【視聴者参加】素人がスマブラした結果/Super Smash Bros.【ホロライブ/大空スバル】",
    "publishedAt": "2021-08-24T15:58:08Z"
  },
  {
    "videoId": "pcSoZnE2FBs",
    "thumbnail": "https://i.ytimg.com/vi/pcSoZnE2FBs/mqdefault.jpg",
    "title": "【#生スバル】夏休みホラー！！！！つぐのひの新作やるしゅばあああああああああ！！！！！/horror game【ホロライブ/大空スバル】",
    "publishedAt": "2021-08-26T13:15:33Z"
  },
  {
    "videoId": "eOdf9W-80fk",
    "thumbnail": "https://i.ytimg.com/vi/eOdf9W-80fk/mqdefault.jpg",
    "title": "【#ゆるホロチームカート】ホロメンでチーム対抗マリカバトルするしゅばあああああああああああああ！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2021-08-27T13:18:08Z"
  },
  {
    "videoId": "Dx-0rKjfhuk",
    "thumbnail": "https://i.ytimg.com/vi/Dx-0rKjfhuk/mqdefault.jpg",
    "title": "【#6】完全初見！！いくぞ！！古代種の神殿！！！！初代FF７！！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-08-27T15:24:23Z"
  },
  {
    "videoId": "RFQgzhBubTo",
    "thumbnail": "https://i.ytimg.com/vi/RFQgzhBubTo/mqdefault.jpg",
    "title": "【#8】完全初見！！スバウド探しに行くぞ！！！！！初代FF７！！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-08-28T10:25:24Z"
  },
  {
    "videoId": "Fe3dS4m2trc",
    "thumbnail": "https://i.ytimg.com/vi/Fe3dS4m2trc/mqdefault.jpg",
    "title": "【#9】完全初見！！初代FF７！！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-08-29T10:21:53Z"
  },
  {
    "videoId": "qT-ZzEHfw2s",
    "thumbnail": "https://i.ytimg.com/vi/qT-ZzEHfw2s/mqdefault.jpg",
    "title": "【#生スバル】ドキドキ！！NGなし？！マシュマロトーク！！！！/NO NG！！！Question tournament！！！【ホロライブ/大空スバル】",
    "publishedAt": "2021-08-31T14:14:45Z"
  },
  {
    "videoId": "s7yGgpPUz-0",
    "thumbnail": "https://i.ytimg.com/vi/s7yGgpPUz-0/mqdefault.jpg",
    "title": "【#生スバル】夜の街をパトロールするしゅばああああああああああああああああああああ！！！！！/police simulator【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-01T14:55:29Z"
  },
  {
    "videoId": "-RKYVgVwkb8",
    "thumbnail": "https://i.ytimg.com/vi/-RKYVgVwkb8/mqdefault.jpg",
    "title": "【#スバおかおっぱぴー】おかうと‼‼あつまれ‼メイドインワリオ：Wario Ware, Inc. Mega Party Game$ with OKAYU【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-02T12:12:43Z"
  },
  {
    "videoId": "uRR9vnZ_DmA",
    "thumbnail": "https://i.ytimg.com/vi/uRR9vnZ_DmA/mqdefault.jpg",
    "title": "【#生スバル】スバルってホラゲー中何db出てんの？検証するぞ！！！！！！/Emily Wants to Play【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-03T13:23:29Z"
  },
  {
    "videoId": "NoBkt5wobrU",
    "thumbnail": "https://i.ytimg.com/vi/NoBkt5wobrU/mqdefault.jpg",
    "title": "【#生スバル】まだまだ！夏休みスペシャル！？ゲスト有！？おはスバ！/FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-04T02:12:36Z"
  },
  {
    "videoId": "ndoC4OH3cbc",
    "thumbnail": "https://i.ytimg.com/vi/ndoC4OH3cbc/mqdefault.jpg",
    "title": "【#10】最終回間近？！完全初見！！初代FF７！！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-09-04T09:43:59Z"
  },
  {
    "videoId": "i3GEk9TcB40",
    "thumbnail": "https://i.ytimg.com/vi/i3GEk9TcB40/mqdefault.jpg",
    "title": "【#最終回】完全初見！！初代FF７！！！！【ホロライブ/大空スバル】※ネタバレあり",
    "publishedAt": "2021-09-05T09:14:42Z"
  },
  {
    "videoId": "9lmJg0a-YW8",
    "thumbnail": "https://i.ytimg.com/vi/9lmJg0a-YW8/mqdefault.jpg",
    "title": "【#スバちょこるなたん】地獄大くじ引き大会【ホロライブ】",
    "publishedAt": "2021-09-07T12:03:08Z"
  },
  {
    "videoId": "sWvQ1yQOX6o",
    "thumbnail": "https://i.ytimg.com/vi/sWvQ1yQOX6o/mqdefault.jpg",
    "title": "【#生スバル】ハリーポッターと秘密の部屋同時視聴会！！！/Harry Potter and the Chamber of Secrets【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-08T16:48:52Z"
  },
  {
    "videoId": "9s11-3U_0U8",
    "thumbnail": "https://i.ytimg.com/vi/9s11-3U_0U8/mqdefault.jpg",
    "title": "【#生スバル】重大告知有！！！おはスバ！/FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-11T04:16:00Z"
  },
  {
    "videoId": "yZNw_r_Y2kA",
    "thumbnail": "https://i.ytimg.com/vi/yZNw_r_Y2kA/mqdefault.jpg",
    "title": "【#生スバル】アドベントチルドレンコンプリート同時視聴会/FINAL FANTASY VII ADVENT CHILDREN COMPLETE【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-11T08:46:28Z"
  },
  {
    "videoId": "hhVy80ZxIKo",
    "thumbnail": "https://i.ytimg.com/vi/hhVy80ZxIKo/mqdefault.jpg",
    "title": "【#生スバル】シリーズ完全初見！！！！！mother２！！！！！/EarthBound【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-12T09:07:32Z"
  },
  {
    "videoId": "OtcN-V3_jr8",
    "thumbnail": "https://i.ytimg.com/vi/OtcN-V3_jr8/mqdefault.jpg",
    "title": "【】マジですまん悲しいお知らせ【】",
    "publishedAt": "2021-09-14T11:14:55Z"
  },
  {
    "videoId": "Npa15IaXv9I",
    "thumbnail": "https://i.ytimg.com/vi/Npa15IaXv9I/mqdefault.jpg",
    "title": "【視聴者参加】セフィロス解禁！！チーム乱闘？！初心者エンジョイわいわいスマブラ！！！/Super Smash Bros.【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-15T13:09:45Z"
  },
  {
    "videoId": "bWXmTyubBeE",
    "thumbnail": "https://i.ytimg.com/vi/bWXmTyubBeE/mqdefault.jpg",
    "title": "【#生スバル】スバルの素！1時間ノープラン雑談【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-16T12:24:02Z"
  },
  {
    "videoId": "iQYCu_a6eSo",
    "thumbnail": "https://i.ytimg.com/vi/iQYCu_a6eSo/mqdefault.jpg",
    "title": "【 #ホロ地球防衛隊】地球防衛軍5みんなでするしゅばあああああああ！！！！！：Earth Defense Force 5【大空スバル視点】",
    "publishedAt": "2021-09-17T11:15:25Z"
  },
  {
    "videoId": "FiUMy_htQD0",
    "thumbnail": "https://i.ytimg.com/vi/FiUMy_htQD0/mqdefault.jpg",
    "title": "【#生スバル】大空探偵事務所：ホロのマネージャー調査編：OOZORA detective：Solve the mystery of the hololive manager!【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-17T15:21:47Z"
  },
  {
    "videoId": "3qhw9dGnobg",
    "thumbnail": "https://i.ytimg.com/vi/3qhw9dGnobg/mqdefault.jpg",
    "title": "【#生スバル】おはスバ！/FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-18T02:17:15Z"
  },
  {
    "videoId": "6TXuYTPp7N4",
    "thumbnail": "https://i.ytimg.com/vi/6TXuYTPp7N4/mqdefault.jpg",
    "title": "【#2】シリーズ完全初見！！！！！mother２！！！！！/EarthBound【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-18T09:26:18Z"
  },
  {
    "videoId": "_ymzFDKSmg8",
    "thumbnail": "https://i.ytimg.com/vi/_ymzFDKSmg8/mqdefault.jpg",
    "title": "【#3】シリーズ完全初見！！！！！mother２！！！！！/EarthBound【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-19T09:17:53Z"
  },
  {
    "videoId": "IbtSdflEebg",
    "thumbnail": "https://i.ytimg.com/vi/IbtSdflEebg/mqdefault.jpg",
    "title": "【#スバちょこるなたん】ゾンビぶっ倒すしゅばあああああああああ！！！！：WATCH DOGS LEGION【大空スバル視点】",
    "publishedAt": "2021-09-21T14:21:43Z"
  },
  {
    "videoId": "dQ1pQ6nOzCE",
    "thumbnail": "https://i.ytimg.com/vi/dQ1pQ6nOzCE/mqdefault.jpg",
    "title": "【#生スバル】告知有？！ワンチャンまじで凸待ちO？！；；ソセレ凸待ち！！！：SAUSAGE LEGEND【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-22T13:46:29Z"
  },
  {
    "videoId": "90ilZPcR3Jg",
    "thumbnail": "https://i.ytimg.com/vi/90ilZPcR3Jg/mqdefault.jpg",
    "title": "【#スバちょこるなたん】L4D2でチームワークをみせてやるしゅばあああああ！！！！！：Left 4 Dead 2【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-23T13:57:17Z"
  },
  {
    "videoId": "74wD6IXwpQo",
    "thumbnail": "https://i.ytimg.com/vi/74wD6IXwpQo/mqdefault.jpg",
    "title": "【#１】初見実況カスタムロボV2させてくださいおねがいします！！！！！！！：CUSTOM ROBO V2【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-24T14:10:10Z"
  },
  {
    "videoId": "bm79RjIbMKA",
    "thumbnail": "https://i.ytimg.com/vi/bm79RjIbMKA/mqdefault.jpg",
    "title": "【#生スバル】おはスバ！/FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-25T02:10:36Z"
  },
  {
    "videoId": "nnGC2h5cK5c",
    "thumbnail": "https://i.ytimg.com/vi/nnGC2h5cK5c/mqdefault.jpg",
    "title": "【#4】シリーズ完全初見！！！！！mother２！！！！！/EarthBound【ホロライブ/大空スバル】",
    "publishedAt": "2021-09-25T11:17:49Z"
  },
  {
    "videoId": "R_OjqP8Et3w",
    "thumbnail": "https://i.ytimg.com/vi/R_OjqP8Et3w/mqdefault.jpg",
    "title": "【#２】初見実況カスタムロボV2させてくださいおねがいします！！！！！！！：CUSTOM ROBO V2【ホロライブ】",
    "publishedAt": "2021-09-29T14:55:54Z"
  },
  {
    "videoId": "ByQZhUyftBk",
    "thumbnail": "https://i.ytimg.com/vi/ByQZhUyftBk/mqdefault.jpg",
    "title": "【#生スバル】ずっっっとやりたかったリトルナイトメアするしゅばあああああああああああ！！！：LITTLE NIGHTMARES【ネタバレあり】",
    "publishedAt": "2021-09-30T16:24:43Z"
  },
  {
    "videoId": "jj0ZbUKpBTs",
    "thumbnail": "https://i.ytimg.com/vi/jj0ZbUKpBTs/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル/FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-02T02:13:58Z"
  },
  {
    "videoId": "xdB40PK5CCI",
    "thumbnail": "https://i.ytimg.com/vi/xdB40PK5CCI/mqdefault.jpg",
    "title": "【#5】シリーズ完全初見！！！！！mother２！！！！！/EarthBound【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-02T09:48:06Z"
  },
  {
    "videoId": "XAKpXPc0eh8",
    "thumbnail": "https://i.ytimg.com/vi/XAKpXPc0eh8/mqdefault.jpg",
    "title": "【#6】シリーズ完全初見！！！！！mother２！！！！！/EarthBound【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-03T10:03:56Z"
  },
  {
    "videoId": "9TuoUTu_Qvk",
    "thumbnail": "https://i.ytimg.com/vi/9TuoUTu_Qvk/mqdefault.jpg",
    "title": "【シャニマス】新人Pの大空スバルです！！！かなたPよろしくお願いします！！！！！/THE IDOLM@STER SHINY COLORS【ホロライブ】",
    "publishedAt": "2021-10-05T12:42:58Z"
  },
  {
    "videoId": "gFUpshFisw0",
    "thumbnail": "https://i.ytimg.com/vi/gFUpshFisw0/mqdefault.jpg",
    "title": "【#生スバル】めちゃめちゃ久しぶりのマイクラっするしゅばああああ！！！！！！/MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-06T14:04:03Z"
  },
  {
    "videoId": "mhvHZpK-9Ss",
    "thumbnail": "https://i.ytimg.com/vi/mhvHZpK-9Ss/mqdefault.jpg",
    "title": "【#大空スバル３周年】おまたせ！今日はたのしんでってな～！！！！：SUBARU 3rd anniversary Live【ホロライブ】",
    "publishedAt": "2021-10-07T13:10:00Z"
  },
  {
    "videoId": "W3vEoLgGxfw",
    "thumbnail": "https://i.ytimg.com/vi/W3vEoLgGxfw/mqdefault.jpg",
    "title": "【#３】カスタムロボV2やるしゅばああああああああああああああ/CUSTOM ROBO V2【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-08T14:43:20Z"
  },
  {
    "videoId": "8GoeyH0_2qg",
    "thumbnail": "https://i.ytimg.com/vi/8GoeyH0_2qg/mqdefault.jpg",
    "title": "【#生スバル】3周年ライブあざました！！！！！おはすば！/Free Talk about 3D live【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-09T05:22:16Z"
  },
  {
    "videoId": "v31p5uJLAQ0",
    "thumbnail": "https://i.ytimg.com/vi/v31p5uJLAQ0/mqdefault.jpg",
    "title": "【#最終回】シリーズ完全初見！！！！！mother２！！！！！/EarthBound【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-10T10:40:39Z"
  },
  {
    "videoId": "EGgV3ZxzY48",
    "thumbnail": "https://i.ytimg.com/vi/EGgV3ZxzY48/mqdefault.jpg",
    "title": "【#スバルーナ】ヴァイスシュヴァルツ初開封対決！！！！！！！：Subaluna Card Opening Showdown【ホロライブ】",
    "publishedAt": "2021-10-12T12:05:53Z"
  },
  {
    "videoId": "p9gcnFmaPrQ",
    "thumbnail": "https://i.ytimg.com/vi/p9gcnFmaPrQ/mqdefault.jpg",
    "title": "【視聴者参加】方言マリオカート1時間以内に1位目指すしゅばああああああああああああああああああああ！！！！！：Mario Cart【】",
    "publishedAt": "2021-10-14T13:29:31Z"
  },
  {
    "videoId": "8wUiBGD5rqE",
    "thumbnail": "https://i.ytimg.com/vi/8wUiBGD5rqE/mqdefault.jpg",
    "title": "【#生スバル】おはすば/free talk【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-16T04:21:29Z"
  },
  {
    "videoId": "VHJiG3a-UFA",
    "thumbnail": "https://i.ytimg.com/vi/VHJiG3a-UFA/mqdefault.jpg",
    "title": "【#４】カスタムロボV2やるしゅばああああああああああああああ/CUSTOM ROBO V2【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-17T09:54:49Z"
  },
  {
    "videoId": "FFDWylrdAIo",
    "thumbnail": "https://i.ytimg.com/vi/FFDWylrdAIo/mqdefault.jpg",
    "title": "【#カプとれ】地元最強のクレーン捌きをみるしゅばああああああああああ！！！！/crane game【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-18T12:05:59Z"
  },
  {
    "videoId": "oobz3zom2s8",
    "thumbnail": "https://i.ytimg.com/vi/oobz3zom2s8/mqdefault.jpg",
    "title": "【#生スバル】おはようございます！！！！！マイクラするしゅばあああああああ！！！！！：MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-20T15:44:45Z"
  },
  {
    "videoId": "1sp9H3t8-Os",
    "thumbnail": "https://i.ytimg.com/vi/1sp9H3t8-Os/mqdefault.jpg",
    "title": "【#５】カスタムロボV2やるしゅばああああああああああああああ/CUSTOM ROBO V2【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-21T14:39:24Z"
  },
  {
    "videoId": "_Sn1iVjaN5c",
    "thumbnail": "https://i.ytimg.com/vi/_Sn1iVjaN5c/mqdefault.jpg",
    "title": "【ご褒美】ポケモンセンターで爆買いしてきたしゅばああああああああああああああ！！！！/Open pokemon goods【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-22T13:12:04Z"
  },
  {
    "videoId": "mIVZ2RbcMLY",
    "thumbnail": "https://i.ytimg.com/vi/mIVZ2RbcMLY/mqdefault.jpg",
    "title": "【#生スバル】おはすば/free talk【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-23T02:17:23Z"
  },
  {
    "videoId": "hVqKC-KAVMQ",
    "thumbnail": "https://i.ytimg.com/vi/hVqKC-KAVMQ/mqdefault.jpg",
    "title": "【#１】シリーズ初見！！！龍が如く極するしゅばああああああああああああ！！！！！！：YAKUZA KIWAMI【※ネタバレあり】",
    "publishedAt": "2021-10-23T11:03:12Z"
  },
  {
    "videoId": "yRBQUCG-ZX8",
    "thumbnail": "https://i.ytimg.com/vi/yRBQUCG-ZX8/mqdefault.jpg",
    "title": "【#２】シリーズ初見！！！龍が如く極するしゅばああああああああああああ！！！！！！：YAKUZA KIWAMI【※ネタバレあり】",
    "publishedAt": "2021-10-24T08:21:34Z"
  },
  {
    "videoId": "YSowdwODds4",
    "thumbnail": "https://i.ytimg.com/vi/YSowdwODds4/mqdefault.jpg",
    "title": "【#生スバル】マーベルのド新作ゲームプレイするしゅばあああああああああああ！！！！！！！：Marvel’s Guardians of the Galaxy game 【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-26T16:25:00Z"
  },
  {
    "videoId": "g05bmY0mkG4",
    "thumbnail": "https://i.ytimg.com/vi/g05bmY0mkG4/mqdefault.jpg",
    "title": "【#生スバル】マイクラするしゅばあああああああああああああああああああ！！！！！：MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-28T12:35:35Z"
  },
  {
    "videoId": "tIh3jv3GMuQ",
    "thumbnail": "https://i.ytimg.com/vi/tIh3jv3GMuQ/mqdefault.jpg",
    "title": "【#生スバル】おはすば/free talk【ホロライブ/大空スバル】",
    "publishedAt": "2021-10-30T02:12:55Z"
  },
  {
    "videoId": "4iAiwgEcTmg",
    "thumbnail": "https://i.ytimg.com/vi/4iAiwgEcTmg/mqdefault.jpg",
    "title": "【#３】シリーズ初見！！！龍が如く極するしゅばああああああああああああ！！！！！！：YAKUZA KIWAMI【※ネタバレあり】",
    "publishedAt": "2021-10-30T10:22:02Z"
  },
  {
    "videoId": "3wjfIrofYOU",
    "thumbnail": "https://i.ytimg.com/vi/3wjfIrofYOU/mqdefault.jpg",
    "title": "【#４】シリーズ初見！！！龍が如く極するしゅばああああああああああああ！！！！！！：YAKUZA KIWAMI【※ネタバレあり】",
    "publishedAt": "2021-10-31T11:35:24Z"
  },
  {
    "videoId": "mrG9WZGGS8Y",
    "thumbnail": "https://i.ytimg.com/vi/mrG9WZGGS8Y/mqdefault.jpg",
    "title": "【#生スバル】ホロライブ運動会！いくぞ白Aチーム！！！ぷち練習会！：MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2021-11-02T12:27:52Z"
  },
  {
    "videoId": "seJ0RcOWbOw",
    "thumbnail": "https://i.ytimg.com/vi/seJ0RcOWbOw/mqdefault.jpg",
    "title": "【#最終回】旅立ち編最終回！？カスタムロボV2やるしゅばああああああああああああああ/CUSTOM ROBO V2【ホロライブ/大空スバル】",
    "publishedAt": "2021-11-02T16:54:55Z"
  },
  {
    "videoId": "rlpDf4q_zNY",
    "thumbnail": "https://i.ytimg.com/vi/rlpDf4q_zNY/mqdefault.jpg",
    "title": "【#生スバル】みんなでゆる練習するしゅばあああああああああ！！！！！！/MINE CFAFT【ホロライブ/大空スバル】",
    "publishedAt": "2021-11-03T13:55:40Z"
  },
  {
    "videoId": "yGPHk99eAtI",
    "thumbnail": "https://i.ytimg.com/vi/yGPHk99eAtI/mqdefault.jpg",
    "title": "【#生スバル】みんなでゆる練習するしゅばあああああああああ！！！！！！/MINE CFAFT【ホロライブ/大空スバル】",
    "publishedAt": "2021-11-05T13:20:00Z"
  },
  {
    "videoId": "EaqSdZEje8A",
    "thumbnail": "https://i.ytimg.com/vi/EaqSdZEje8A/mqdefault.jpg",
    "title": "【本番】白Aチーム！！！いくぞおおおおおおおおおお！！！！！【#ホロライブ大運動会2021】",
    "publishedAt": "2021-11-06T13:07:29Z"
  },
  {
    "videoId": "iEte0-sMB1g",
    "thumbnail": "https://i.ytimg.com/vi/iEte0-sMB1g/mqdefault.jpg",
    "title": "【#５】シリーズ初見！！！龍が如く極するしゅばああああああああああああ！！！！！！：YAKUZA KIWAMI【※ネタバレあり】",
    "publishedAt": "2021-11-07T08:33:40Z"
  },
  {
    "videoId": "63In3FNJXqE",
    "thumbnail": "https://i.ytimg.com/vi/63In3FNJXqE/mqdefault.jpg",
    "title": "【#生スバル】邪神こおねってマジ？【ホロライブ/大空スバル】",
    "publishedAt": "2021-11-09T13:32:44Z"
  },
  {
    "videoId": "KHPgVajIF90",
    "thumbnail": "https://i.ytimg.com/vi/KHPgVajIF90/mqdefault.jpg",
    "title": "【#すばおかみょーん】カービィのエアライドこらぼ　Kirby Airride【ホロライブ】",
    "publishedAt": "2021-11-11T12:07:34Z"
  },
  {
    "videoId": "1MeNYU7nTqE",
    "thumbnail": "https://i.ytimg.com/vi/1MeNYU7nTqE/mqdefault.jpg",
    "title": "【#生スバル】何デシベルでる？深夜放送するしゅばあああああ！！！The Radio Station 【ホロライブ/大空スバル】",
    "publishedAt": "2021-11-12T14:07:47Z"
  },
  {
    "videoId": "GzIg-QK98Tk",
    "thumbnail": "https://i.ytimg.com/vi/GzIg-QK98Tk/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-11-13T02:22:01Z"
  },
  {
    "videoId": "-ZP3iin5Vps",
    "thumbnail": "https://i.ytimg.com/vi/-ZP3iin5Vps/mqdefault.jpg",
    "title": "【#６】シリーズ初見！！！龍が如く極するしゅばああああああああああああ！！！！！！：YAKUZA KIWAMI【※ネタバレあり】",
    "publishedAt": "2021-11-13T12:08:47Z"
  },
  {
    "videoId": "M3VEvtY6bos",
    "thumbnail": "https://i.ytimg.com/vi/M3VEvtY6bos/mqdefault.jpg",
    "title": "【#７サブクエ回】シリーズ初見！！！龍が如く極するしゅばああああああああああああ！！！！！！：YAKUZA KIWAMI【※ネタバレあり】",
    "publishedAt": "2021-11-14T11:11:49Z"
  },
  {
    "videoId": "PrnIOGFWyf4",
    "thumbnail": "https://i.ytimg.com/vi/PrnIOGFWyf4/mqdefault.jpg",
    "title": "【視聴者参加】方言スマブラで大暴れしゅばああああああああああああああああああ！！！！/Super Smash Bros.【ホロライブ/大空スバル】",
    "publishedAt": "2021-11-16T14:33:37Z"
  },
  {
    "videoId": "FWw47ZJFQo0",
    "thumbnail": "https://i.ytimg.com/vi/FWw47ZJFQo0/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-11-20T02:15:17Z"
  },
  {
    "videoId": "WY_jHQRXzBc",
    "thumbnail": "https://i.ytimg.com/vi/WY_jHQRXzBc/mqdefault.jpg",
    "title": "【#８最終回】シリーズ初見！！！龍が如く極するしゅばああああああああああああ！！！！！！：YAKUZA KIWAMI【※ネタバレあり】",
    "publishedAt": "2021-11-20T11:52:43Z"
  },
  {
    "videoId": "6snI-di3kew",
    "thumbnail": "https://i.ytimg.com/vi/6snI-di3kew/mqdefault.jpg",
    "title": "【#１】龍が如く零やるしゅばあああああああああああああああああ！！！！：YAKUZA ZERO【※ネタバレ有り】",
    "publishedAt": "2021-11-21T08:08:14Z"
  },
  {
    "videoId": "kuTCOXsADzE",
    "thumbnail": "https://i.ytimg.com/vi/kuTCOXsADzE/mqdefault.jpg",
    "title": "【＃1】ポケモンやるしゅばああああああああああああ【＃スバおか対決 /ホロライブ】",
    "publishedAt": "2021-11-22T14:39:20Z"
  },
  {
    "videoId": "PgeNy-fWH0U",
    "thumbnail": "https://i.ytimg.com/vi/PgeNy-fWH0U/mqdefault.jpg",
    "title": "【＃2】ポケモンやるしゅばああああああああああああ【＃スバおか対決 /ホロライブ】",
    "publishedAt": "2021-11-24T16:58:33Z"
  },
  {
    "videoId": "uLEhg_vK2BY",
    "thumbnail": "https://i.ytimg.com/vi/uLEhg_vK2BY/mqdefault.jpg",
    "title": "【#生スバル】バス運転？？？任せるしゅばああああああああああ！！：Bus Simulator 18【ホロライブ/大空スバル】",
    "publishedAt": "2021-11-25T12:12:04Z"
  },
  {
    "videoId": "Gd3S68KwQeE",
    "thumbnail": "https://i.ytimg.com/vi/Gd3S68KwQeE/mqdefault.jpg",
    "title": "【＃３】ポケモンやるしゅばああああああああああああ【＃スバおか対決 /ホロライブ】",
    "publishedAt": "2021-11-25T17:13:50Z"
  },
  {
    "videoId": "dAVG3KEB6Zs",
    "thumbnail": "https://i.ytimg.com/vi/dAVG3KEB6Zs/mqdefault.jpg",
    "title": "【#サブクエ回】龍が如く極・ポケサーするしゅばああああああああああああ！！！！！！：YAKUZA KIWAMI【※ネタバレあり】",
    "publishedAt": "2021-11-26T15:47:41Z"
  },
  {
    "videoId": "OsV_LY_9os4",
    "thumbnail": "https://i.ytimg.com/vi/OsV_LY_9os4/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-11-27T02:10:20Z"
  },
  {
    "videoId": "8OpK9PzesJ0",
    "thumbnail": "https://i.ytimg.com/vi/8OpK9PzesJ0/mqdefault.jpg",
    "title": "【#２】龍が如く零やるしゅばあああああああああああああああああ！！！！：YAKUZA ZERO【※ネタバレ有り】",
    "publishedAt": "2021-11-27T10:41:53Z"
  },
  {
    "videoId": "dJdTh7M-qHM",
    "thumbnail": "https://i.ytimg.com/vi/dJdTh7M-qHM/mqdefault.jpg",
    "title": "【#3】龍が如く零やるしゅばあああああああああああああああああ！！！！：YAKUZA ZERO【※ネタバレ有り】",
    "publishedAt": "2021-11-28T08:56:15Z"
  },
  {
    "videoId": "pz4HBCRNyfM",
    "thumbnail": "https://i.ytimg.com/vi/pz4HBCRNyfM/mqdefault.jpg",
    "title": "【＃４】ポケモンやるしゅばああああああああああああ【＃スバおか対決 /ホロライブ】",
    "publishedAt": "2021-12-01T17:36:42Z"
  },
  {
    "videoId": "uoOXrneAGzE",
    "thumbnail": "https://i.ytimg.com/vi/uoOXrneAGzE/mqdefault.jpg",
    "title": "【#そらとしゅば】大先輩とマブになりたいが緊張が止まらないすばる：SORA collabo stream【ホロライブ】",
    "publishedAt": "2021-12-02T12:11:34Z"
  },
  {
    "videoId": "U5mcjbvfAFc",
    "thumbnail": "https://i.ytimg.com/vi/U5mcjbvfAFc/mqdefault.jpg",
    "title": "【＃5】ポケモンやるしゅばああああああああああああ【＃スバおか対決 /ホロライブ】",
    "publishedAt": "2021-12-02T17:34:12Z"
  },
  {
    "videoId": "2lvB1BVnhLE",
    "thumbnail": "https://i.ytimg.com/vi/2lvB1BVnhLE/mqdefault.jpg",
    "title": "【#サブクエ回】龍が如く極・ポケサーするしゅばああああああああああああ！！！！！！：YAKUZA KIWAMI【※ネタバレあり】",
    "publishedAt": "2021-12-03T17:10:01Z"
  },
  {
    "videoId": "f10sZc90cpI",
    "thumbnail": "https://i.ytimg.com/vi/f10sZc90cpI/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-12-04T02:15:10Z"
  },
  {
    "videoId": "HvT930tZ2Dc",
    "thumbnail": "https://i.ytimg.com/vi/HvT930tZ2Dc/mqdefault.jpg",
    "title": "【#4】龍が如く零やるしゅばあああああああああああああああああ！！！！：YAKUZA ZERO【※ネタバレ有り】",
    "publishedAt": "2021-12-04T07:57:23Z"
  },
  {
    "videoId": "L2IUKJU8-U4",
    "thumbnail": "https://i.ytimg.com/vi/L2IUKJU8-U4/mqdefault.jpg",
    "title": "【#5】龍が如く零やるしゅばあああああああああああああああああ！！！！：YAKUZA ZERO【※ネタバレ有り】",
    "publishedAt": "2021-12-05T11:26:03Z"
  },
  {
    "videoId": "OUXO7m0R9pI",
    "thumbnail": "https://i.ytimg.com/vi/OUXO7m0R9pI/mqdefault.jpg",
    "title": "【#6】ポケモンやるしゅばああああああああああああ【＃スバおか対決 /ホロライブ】",
    "publishedAt": "2021-12-07T15:35:57Z"
  },
  {
    "videoId": "GSNTsfyVu2Q",
    "thumbnail": "https://i.ytimg.com/vi/GSNTsfyVu2Q/mqdefault.jpg",
    "title": "【地獄】#ホロ声真似へたくそ王 ：poor voice imitation tournament【ホロライブ】",
    "publishedAt": "2021-12-08T15:26:24Z"
  },
  {
    "videoId": "DICbpsbeNrU",
    "thumbnail": "https://i.ytimg.com/vi/DICbpsbeNrU/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-12-11T02:06:53Z"
  },
  {
    "videoId": "s2Fiq8wGHpw",
    "thumbnail": "https://i.ytimg.com/vi/s2Fiq8wGHpw/mqdefault.jpg",
    "title": "【#6】龍が如く零やるしゅばあああああああああああああああああ！！！！：YAKUZA ZERO【※ネタバレ有り】",
    "publishedAt": "2021-12-11T09:59:02Z"
  },
  {
    "videoId": "TblrlmrYUkc",
    "thumbnail": "https://i.ytimg.com/vi/TblrlmrYUkc/mqdefault.jpg",
    "title": "【#7】龍が如く零やるしゅばあああああああああああああああああ！！！！：YAKUZA ZERO【※ネタバレ有り】",
    "publishedAt": "2021-12-12T08:49:10Z"
  },
  {
    "videoId": "2fBNSkxrxEw",
    "thumbnail": "https://i.ytimg.com/vi/2fBNSkxrxEw/mqdefault.jpg",
    "title": "【#ノエスバ】ノエスバ関係性リセットオフコラボ：Noel Subaru  OFF collabo【ホロライブ】",
    "publishedAt": "2021-12-13T14:04:17Z"
  },
  {
    "videoId": "2CBuAwcfeMY",
    "thumbnail": "https://i.ytimg.com/vi/2CBuAwcfeMY/mqdefault.jpg",
    "title": "【#7】ポケモンやるしゅばああああああああああああ【＃スバおか対決 /ホロライブ】",
    "publishedAt": "2021-12-15T14:35:18Z"
  },
  {
    "videoId": "KNrHY_Xdj9M",
    "thumbnail": "https://i.ytimg.com/vi/KNrHY_Xdj9M/mqdefault.jpg",
    "title": "【#メスキング回】龍が如く極・ポケサーするしゅばああああああああああああ！！！！！！：YAKUZA KIWAMI【※ネタバレあり】",
    "publishedAt": "2021-12-17T15:46:50Z"
  },
  {
    "videoId": "JwDuKIJVFCc",
    "thumbnail": "https://i.ytimg.com/vi/JwDuKIJVFCc/mqdefault.jpg",
    "title": "【#生スバル】おはようスバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-12-18T02:14:19Z"
  },
  {
    "videoId": "iNp0swicG_w",
    "thumbnail": "https://i.ytimg.com/vi/iNp0swicG_w/mqdefault.jpg",
    "title": "【#8】龍が如く零やるしゅばあああああああああああああああああ！！！！：YAKUZA ZERO【※ネタバレ有り】",
    "publishedAt": "2021-12-18T11:41:35Z"
  },
  {
    "videoId": "EYXMRDQWmlU",
    "thumbnail": "https://i.ytimg.com/vi/EYXMRDQWmlU/mqdefault.jpg",
    "title": "【#生スバル】宇宙食食べるしゅばあああああああああああああああ！！！！：Eat space food 【ホロライブ/大空スバル】",
    "publishedAt": "2021-12-21T12:05:26Z"
  },
  {
    "videoId": "IPaD9XK_yFU",
    "thumbnail": "https://i.ytimg.com/vi/IPaD9XK_yFU/mqdefault.jpg",
    "title": "【#8】ポケモンやるしゅばああああああああああああ【＃スバおか対決 /ホロライブ】",
    "publishedAt": "2021-12-22T13:02:51Z"
  },
  {
    "videoId": "oWa0mJ7QqaU",
    "thumbnail": "https://i.ytimg.com/vi/oWa0mJ7QqaU/mqdefault.jpg",
    "title": "【#新スバせか】新すばらしきこのせかいするしゅばああああああああああああああああああ！！！！！！！！【】",
    "publishedAt": "2021-12-22T15:33:25Z"
  },
  {
    "videoId": "xSAKDhyy87M",
    "thumbnail": "https://i.ytimg.com/vi/xSAKDhyy87M/mqdefault.jpg",
    "title": "【#生スバル】クリスマス？ソセレするけど？視聴者参加型＆ホロメン凸待ち：Sausage Legend【ホロライブ/大空スバル】",
    "publishedAt": "2021-12-24T15:02:14Z"
  },
  {
    "videoId": "-KCfXXJpWCc",
    "thumbnail": "https://i.ytimg.com/vi/-KCfXXJpWCc/mqdefault.jpg",
    "title": "【#生スバル】おはようメリクリスバル：Merry Christmas FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2021-12-25T03:42:00Z"
  },
  {
    "videoId": "WL1eGrp2xr8",
    "thumbnail": "https://i.ytimg.com/vi/WL1eGrp2xr8/mqdefault.jpg",
    "title": "【#9】龍が如く零やるしゅばあああああああああああああああああ！！！！：YAKUZA ZERO【※ネタバレ有り】",
    "publishedAt": "2021-12-25T06:05:58Z"
  },
  {
    "videoId": "-DN_oRkSNmI",
    "thumbnail": "https://i.ytimg.com/vi/-DN_oRkSNmI/mqdefault.jpg",
    "title": "【#ホロクリスマス歌枠リレー】クリスマスうた：sing【ホロライブ/大空スバル】",
    "publishedAt": "2021-12-25T08:22:22Z"
  },
  {
    "videoId": "UDUSsv6fswE",
    "thumbnail": "https://i.ytimg.com/vi/UDUSsv6fswE/mqdefault.jpg",
    "title": "【#生スバル】クリスマスパーティー：Christmas party【ホロライブ/大空スバル】",
    "publishedAt": "2021-12-25T13:35:41Z"
  },
  {
    "videoId": "tkKBey7fBeY",
    "thumbnail": "https://i.ytimg.com/vi/tkKBey7fBeY/mqdefault.jpg",
    "title": "【#本編最終回】龍が如く零やるしゅばあああああああああああああああああ！！！！：YAKUZA ZERO【※ネタバレ有り】",
    "publishedAt": "2021-12-26T12:34:39Z"
  },
  {
    "videoId": "h-O3Lr_rDDY",
    "thumbnail": "https://i.ytimg.com/vi/h-O3Lr_rDDY/mqdefault.jpg",
    "title": "【#ホロ2期生】おくれてきた！ちょこスバあく＋？？？？クリパ！！！！！！！【奇跡】",
    "publishedAt": "2021-12-26T15:12:28Z"
  },
  {
    "videoId": "rUZyo-6izxk",
    "thumbnail": "https://i.ytimg.com/vi/rUZyo-6izxk/mqdefault.jpg",
    "title": "【#生スバル】グロ注意！冬ホラーOUT LAST 2うわああああああああああああああああああああ！！！！：Grotesque expression attention【ホロライブ/大空スバル】",
    "publishedAt": "2021-12-28T13:38:28Z"
  },
  {
    "videoId": "Ew0gkuFEnE0",
    "thumbnail": "https://i.ytimg.com/vi/Ew0gkuFEnE0/mqdefault.jpg",
    "title": "【#9】ポケモンやるしゅばああああああああああああ【＃スバおか対決 /ホロライブ】",
    "publishedAt": "2021-12-29T12:07:35Z"
  },
  {
    "videoId": "5JoVRH05Wi0",
    "thumbnail": "https://i.ytimg.com/vi/5JoVRH05Wi0/mqdefault.jpg",
    "title": "【#生スバル】グロ注意！冬ホラーOUT LAST 2うわああああああああああああああああああああ！！！！：Grotesque expression attention【ホロライブ/大空スバル】",
    "publishedAt": "2021-12-30T16:25:41Z"
  },
  {
    "videoId": "MDbfNeKsXeg",
    "thumbnail": "https://i.ytimg.com/vi/MDbfNeKsXeg/mqdefault.jpg",
    "title": "【#生スバル】あけましておめでとうスバル：HAPPY NEW YEAR!!! FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-01-01T03:46:09Z"
  },
  {
    "videoId": "yqdzPK9qf0U",
    "thumbnail": "https://i.ytimg.com/vi/yqdzPK9qf0U/mqdefault.jpg",
    "title": "【#スバおかおっぱぴー】新年運試し？！？レトロゲーム福袋大開封会！！！：New Year's Luck Test !!!Game Fukubukuro Grand Opening Party",
    "publishedAt": "2022-01-01T12:07:33Z"
  },
  {
    "videoId": "uO8a7-GZ7l4",
    "thumbnail": "https://i.ytimg.com/vi/uO8a7-GZ7l4/mqdefault.jpg",
    "title": "【#フブとしゅば】大先輩とマブになりたいが緊張が止まらないすばる：FUBUKI collabo stream【ホロライブ】",
    "publishedAt": "2022-01-03T14:22:39Z"
  },
  {
    "videoId": "KtZFrS8Whpk",
    "thumbnail": "https://i.ytimg.com/vi/KtZFrS8Whpk/mqdefault.jpg",
    "title": "【#生スバル】マリカ大会近いのでポケサーすっぞ！！！！！！！！：YAKUZA０【ホロライブ/大空スバル】",
    "publishedAt": "2022-01-04T14:42:51Z"
  },
  {
    "videoId": "4XVUwiVXQz0",
    "thumbnail": "https://i.ytimg.com/vi/4XVUwiVXQz0/mqdefault.jpg",
    "title": "【#ゆるホロチームカート】パッションマリオカートやるぞ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-01-06T07:10:51Z"
  },
  {
    "videoId": "6tg9WQ-D3ck",
    "thumbnail": "https://i.ytimg.com/vi/6tg9WQ-D3ck/mqdefault.jpg",
    "title": "【#生スバル】たのむクリアさせてくれ、そしてBANはやめてくれout last2！！！！！ 【ホロライブ/大空スバル】",
    "publishedAt": "2022-01-06T13:47:22Z"
  },
  {
    "videoId": "0ekldQm3URg",
    "thumbnail": "https://i.ytimg.com/vi/0ekldQm3URg/mqdefault.jpg",
    "title": "【#ホロお正月CUP2022】がんばるぞ！！！！！！！！！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-01-07T06:34:35Z"
  },
  {
    "videoId": "0tTX7QECIKU",
    "thumbnail": "https://i.ytimg.com/vi/0tTX7QECIKU/mqdefault.jpg",
    "title": "【#ホロお正月CUP2022】つよ杯がんばるぞ！！！！！！！！！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-01-07T08:15:02Z"
  },
  {
    "videoId": "ZSA3Xc4Us14",
    "thumbnail": "https://i.ytimg.com/vi/ZSA3Xc4Us14/mqdefault.jpg",
    "title": "【#生スバル】恐竜捕まえに行くぞ！！！！！！！！！！！：ARK【ホロライブ/大空スバル視点】",
    "publishedAt": "2022-01-07T16:05:37Z"
  },
  {
    "videoId": "T_k7r9HK-Bg",
    "thumbnail": "https://i.ytimg.com/vi/T_k7r9HK-Bg/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-01-08T02:09:04Z"
  },
  {
    "videoId": "Y7Yd8MvDebk",
    "thumbnail": "https://i.ytimg.com/vi/Y7Yd8MvDebk/mqdefault.jpg",
    "title": "【#10】クリア目指して！！！！！！！ポケモンやるしゅばああああああああああああ【＃スバおか対決 /ホロライブ】",
    "publishedAt": "2022-01-08T10:57:01Z"
  },
  {
    "videoId": "CANkSiNiRJg",
    "thumbnail": "https://i.ytimg.com/vi/CANkSiNiRJg/mqdefault.jpg",
    "title": "【#10】目指せ！！！！殿堂入り！！！ポケモンやるしゅばああああああああああああ【＃スバおか対決 /ホロライブ】",
    "publishedAt": "2022-01-09T13:17:27Z"
  },
  {
    "videoId": "PwwgiBtSfeQ",
    "thumbnail": "https://i.ytimg.com/vi/PwwgiBtSfeQ/mqdefault.jpg",
    "title": "【#STBL】FPS初心者だけどL4D2やるしゅばあああああああああああああああああああああああああ！！！！！【大空スバル視点】",
    "publishedAt": "2022-01-12T15:13:29Z"
  },
  {
    "videoId": "A3mNr1Quzq4",
    "thumbnail": "https://i.ytimg.com/vi/A3mNr1Quzq4/mqdefault.jpg",
    "title": "【#生スバル】神室町最速はすばるしゅばああああああああああああああ！！！！！：YAKUZA0【ホロライブ/大空スバル】",
    "publishedAt": "2022-01-13T15:01:41Z"
  },
  {
    "videoId": "TlONYP6P-PI",
    "thumbnail": "https://i.ytimg.com/vi/TlONYP6P-PI/mqdefault.jpg",
    "title": "【#生スバル】大空スバルイメージアンケートしたら衝撃の結果に涙が止まらない2022：image survey project 【ホロライブ】",
    "publishedAt": "2022-01-14T13:37:44Z"
  },
  {
    "videoId": "fhNf2lY9bXo",
    "thumbnail": "https://i.ytimg.com/vi/fhNf2lY9bXo/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-01-15T03:31:04Z"
  },
  {
    "videoId": "WChoKbAI7XU",
    "thumbnail": "https://i.ytimg.com/vi/WChoKbAI7XU/mqdefault.jpg",
    "title": "【#１】龍が如く極２やるしゅばあああああああああああああ！！！：YAKUZA KIWAMI２【※ネタバレあり】",
    "publishedAt": "2022-01-16T07:03:35Z"
  },
  {
    "videoId": "2_eoDs7dINQ",
    "thumbnail": "https://i.ytimg.com/vi/2_eoDs7dINQ/mqdefault.jpg",
    "title": "【#生スバル】Vリスナーの推し活お悩みに大空スバルが回答！！：A consultation room for Vtuber listeners.【ホロライブ】",
    "publishedAt": "2022-01-18T12:11:43Z"
  },
  {
    "videoId": "zsYfT6T4V6A",
    "thumbnail": "https://i.ytimg.com/vi/zsYfT6T4V6A/mqdefault.jpg",
    "title": "【＃スバおか対決 】これが本当の最終決戦しゅばあああああ！！！！：pokemon【ホロライブ】",
    "publishedAt": "2022-01-19T12:32:40Z"
  },
  {
    "videoId": "OvV0d81LjVM",
    "thumbnail": "https://i.ytimg.com/vi/OvV0d81LjVM/mqdefault.jpg",
    "title": "【#生スバル】恐竜より人間が怖い！！！！！！！！！：ARK【ホロライブ】",
    "publishedAt": "2022-01-21T14:24:40Z"
  },
  {
    "videoId": "OMRoLDdYyLM",
    "thumbnail": "https://i.ytimg.com/vi/OMRoLDdYyLM/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-01-22T02:14:36Z"
  },
  {
    "videoId": "X1ExCWlORxo",
    "thumbnail": "https://i.ytimg.com/vi/X1ExCWlORxo/mqdefault.jpg",
    "title": "【#２】龍が如く極２やるしゅばあああああああああああああ！！！：YAKUZA KIWAMI２【※ネタバレあり】",
    "publishedAt": "2022-01-22T09:09:43Z"
  },
  {
    "videoId": "xLLyTYIODQ0",
    "thumbnail": "https://i.ytimg.com/vi/xLLyTYIODQ0/mqdefault.jpg",
    "title": "【#３】龍が如く極２やるしゅばあああああああああああああ！！！：YAKUZA KIWAMI２【※ネタバレあり】",
    "publishedAt": "2022-01-23T10:12:56Z"
  },
  {
    "videoId": "ks6KoxWnkdk",
    "thumbnail": "https://i.ytimg.com/vi/ks6KoxWnkdk/mqdefault.jpg",
    "title": "【#生スバル】なんとかして生き残りたい！！！！！：ARK【ホロライブ】",
    "publishedAt": "2022-01-25T14:23:32Z"
  },
  {
    "videoId": "BxgLYIMe5Lc",
    "thumbnail": "https://i.ytimg.com/vi/BxgLYIMe5Lc/mqdefault.jpg",
    "title": "【】uta/sing song【】",
    "publishedAt": "2022-01-28T08:15:45Z"
  },
  {
    "videoId": "56d1YI8ObFU",
    "thumbnail": "https://i.ytimg.com/vi/56d1YI8ObFU/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-01-29T02:07:11Z"
  },
  {
    "videoId": "LE8V5iNemBA",
    "thumbnail": "https://i.ytimg.com/vi/LE8V5iNemBA/mqdefault.jpg",
    "title": "【#ホロライブレトロゲーム部】マ　リ　オ　６　４　ク　リ　ア　耐　久/Mario 64 with OKAYU【ホロライブ】",
    "publishedAt": "2022-01-29T14:51:07Z"
  },
  {
    "videoId": "BaflqQJYpoA",
    "thumbnail": "https://i.ytimg.com/vi/BaflqQJYpoA/mqdefault.jpg",
    "title": "【#４】龍が如く極２やるしゅばあああああああああああああ！！！：YAKUZA KIWAMI２【※ネタバレあり】",
    "publishedAt": "2022-01-30T08:29:18Z"
  },
  {
    "videoId": "_2SfN4TLVYs",
    "thumbnail": "https://i.ytimg.com/vi/_2SfN4TLVYs/mqdefault.jpg",
    "title": "【#生スバル】視聴者参加型！！！スマブラするしゅばあああああああああああ！！！！：Smash Brothers【ホロライブ】",
    "publishedAt": "2022-02-01T13:27:23Z"
  },
  {
    "videoId": "FXaV1tbQZg0",
    "thumbnail": "https://i.ytimg.com/vi/FXaV1tbQZg0/mqdefault.jpg",
    "title": "【#生スバル】寿司屋昴しゅばあああああああああああああああああ！！！！！Cooking Sushi 【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-03T14:11:27Z"
  },
  {
    "videoId": "ccbG1oyHdeE",
    "thumbnail": "https://i.ytimg.com/vi/ccbG1oyHdeE/mqdefault.jpg",
    "title": "【ホロARK】第一話　土の味と友の絆：Episode 1 The taste of soil and the bond of friends【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-04T14:11:22Z"
  },
  {
    "videoId": "jsfktTyZtiw",
    "thumbnail": "https://i.ytimg.com/vi/jsfktTyZtiw/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-05T02:08:06Z"
  },
  {
    "videoId": "RZnmkn8zZAU",
    "thumbnail": "https://i.ytimg.com/vi/RZnmkn8zZAU/mqdefault.jpg",
    "title": "【#6】龍が如く極２やるしゅばあああああああああああああ！！！：YAKUZA KIWAMI２【※ネタバレあり】",
    "publishedAt": "2022-02-05T08:05:34Z"
  },
  {
    "videoId": "qDZt6QzbS88",
    "thumbnail": "https://i.ytimg.com/vi/qDZt6QzbS88/mqdefault.jpg",
    "title": "【#7】龍が如く極２やるしゅばあああああああああああああ！！！：YAKUZA KIWAMI２【※ネタバレあり】",
    "publishedAt": "2022-02-06T10:14:25Z"
  },
  {
    "videoId": "WF1G8UTN5n4",
    "thumbnail": "https://i.ytimg.com/vi/WF1G8UTN5n4/mqdefault.jpg",
    "title": "【ホロARK】第二話　２匹の龍💛：Episode 2  Two dragons💛【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-08T15:53:34Z"
  },
  {
    "videoId": "ZofvzxSk0pA",
    "thumbnail": "https://i.ytimg.com/vi/ZofvzxSk0pA/mqdefault.jpg",
    "title": "【#すばちょこるなたん】全肯定APEX！！！！！！！！！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-09T14:09:48Z"
  },
  {
    "videoId": "8KQkYtE5uYU",
    "thumbnail": "https://i.ytimg.com/vi/8KQkYtE5uYU/mqdefault.jpg",
    "title": "【#１】完全初見のCLANNAD同時試聴会：CLANNAD watch party!!!【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-11T07:42:01Z"
  },
  {
    "videoId": "Wen0oouwXUA",
    "thumbnail": "https://i.ytimg.com/vi/Wen0oouwXUA/mqdefault.jpg",
    "title": "【#シンクロニクル】章の終わりに誰かが死ぬってマジ？！？【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-11T14:28:23Z"
  },
  {
    "videoId": "dhTIzXp1NK8",
    "thumbnail": "https://i.ytimg.com/vi/dhTIzXp1NK8/mqdefault.jpg",
    "title": "【#8】龍が如く極２やるしゅばあああああああああああああ！！！：YAKUZA KIWAMI２【※ネタバレあり】",
    "publishedAt": "2022-02-12T08:34:56Z"
  },
  {
    "videoId": "RVwu0YlvqDk",
    "thumbnail": "https://i.ytimg.com/vi/RVwu0YlvqDk/mqdefault.jpg",
    "title": "【#9】龍が如く極２やるしゅばあああああああああああああ！！！：YAKUZA KIWAMI２【※ネタバレあり】",
    "publishedAt": "2022-02-13T10:07:54Z"
  },
  {
    "videoId": "zxBAmyNtcLw",
    "thumbnail": "https://i.ytimg.com/vi/zxBAmyNtcLw/mqdefault.jpg",
    "title": "【#生スバル】ソーセージレジェンド２が遂にでたしゅばあああああああああああああああああ！！！！！！：Sausage Legend2【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-14T14:23:10Z"
  },
  {
    "videoId": "FSrtTu13ftg",
    "thumbnail": "https://i.ytimg.com/vi/FSrtTu13ftg/mqdefault.jpg",
    "title": "【#スバルとリィンカネ】NieR Re[in]carnationの新ストーリーするしゅばああああああああああああ！！！！！！【】",
    "publishedAt": "2022-02-18T12:38:51Z"
  },
  {
    "videoId": "zzEttU56YKE",
    "thumbnail": "https://i.ytimg.com/vi/zzEttU56YKE/mqdefault.jpg",
    "title": "【#２】完全初見のCLANNAD同時試聴会：CLANNAD watch party!!!【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-18T15:40:10Z"
  },
  {
    "videoId": "YiDJCl62eVE",
    "thumbnail": "https://i.ytimg.com/vi/YiDJCl62eVE/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-19T04:03:36Z"
  },
  {
    "videoId": "aPB6jZ3cqZg",
    "thumbnail": "https://i.ytimg.com/vi/aPB6jZ3cqZg/mqdefault.jpg",
    "title": "【 #常MOS 】漂流生活やるしゅばああああああああああああああああ：Raft【 ホロライブ/大空スバル視点】",
    "publishedAt": "2022-02-21T12:00:30Z"
  },
  {
    "videoId": "b5djTDjlTNM",
    "thumbnail": "https://i.ytimg.com/vi/b5djTDjlTNM/mqdefault.jpg",
    "title": "Fantastic future/大空スバル(cover) -VARK LIVE version",
    "publishedAt": "2022-02-21T12:30:14Z"
  },
  {
    "videoId": "FmTM-vgVSpU",
    "thumbnail": "https://i.ytimg.com/vi/FmTM-vgVSpU/mqdefault.jpg",
    "title": "【#生スバル】龍が如く極２　キ ャ バ ク ラ 経 営 最 終 回：YAKUZA KIWAMI 2【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-21T14:52:13Z"
  },
  {
    "videoId": "XxllYuYEur4",
    "thumbnail": "https://i.ytimg.com/vi/XxllYuYEur4/mqdefault.jpg",
    "title": "【#ホロライブヘブバンWEEK】最上の切なさってマジ？！ヘブンバーンズレッドするしゅばああああ！！！！：HEAVEN BURNS RED【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-23T13:03:59Z"
  },
  {
    "videoId": "LIScEtJUJu0",
    "thumbnail": "https://i.ytimg.com/vi/LIScEtJUJu0/mqdefault.jpg",
    "title": "【#生スバル】炎の料理人クッキングファイター好するしゅばああああああ！！！！！！！：Cooking Fighter HAO【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-24T12:37:39Z"
  },
  {
    "videoId": "OaohXbY4MZE",
    "thumbnail": "https://i.ytimg.com/vi/OaohXbY4MZE/mqdefault.jpg",
    "title": "【#３】完全初見のCLANNAD同時試聴会：CLANNAD watch party!!!【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-25T15:43:20Z"
  },
  {
    "videoId": "6l0WA2FzxHo",
    "thumbnail": "https://i.ytimg.com/vi/6l0WA2FzxHo/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-02-26T02:09:58Z"
  },
  {
    "videoId": "ABZ--Z-rdc4",
    "thumbnail": "https://i.ytimg.com/vi/ABZ--Z-rdc4/mqdefault.jpg",
    "title": "【#生スバル】復活のおはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-03-12T02:11:42Z"
  },
  {
    "videoId": "qw20SKNcweU",
    "thumbnail": "https://i.ytimg.com/vi/qw20SKNcweU/mqdefault.jpg",
    "title": "【#生スバル】ホワイト電脳戦機ーバーチャロン　マスターピースするしゅばあああああああああああああ！！！！：CYBER TROOPERS VIRTUAL-ON【ホロライブ/大空スバル】",
    "publishedAt": "2022-03-14T14:47:33Z"
  },
  {
    "videoId": "mE3Cf8M3Mf4",
    "thumbnail": "https://i.ytimg.com/vi/mE3Cf8M3Mf4/mqdefault.jpg",
    "title": "【#生スバル】ずっとやりたかったバンパイアサバイバーズするしゅばああああああああ！！！！：Vampire Survivors【ホロライブ/大空スバル】",
    "publishedAt": "2022-03-16T15:55:05Z"
  },
  {
    "videoId": "Uk6LDY6QI9w",
    "thumbnail": "https://i.ytimg.com/vi/Uk6LDY6QI9w/mqdefault.jpg",
    "title": "【METAL SLUG ATTACK】メタルスラッグアタックするしゅばああああああああ！！！！：METAL SLUG ATTACK【ホロライブ：大空スバル】",
    "publishedAt": "2022-03-17T13:20:17Z"
  },
  {
    "videoId": "cYFfCrDo854",
    "thumbnail": "https://i.ytimg.com/vi/cYFfCrDo854/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-03-20T01:04:47Z"
  },
  {
    "videoId": "E9VAkJTaLPE",
    "thumbnail": "https://i.ytimg.com/vi/E9VAkJTaLPE/mqdefault.jpg",
    "title": "【#４】完全初見のCLANNAD同時試聴会：CLANNAD watch party!!!【ホロライブ/大空スバル】",
    "publishedAt": "2022-03-20T14:38:54Z"
  },
  {
    "videoId": "MEjq9Vg1Cd0",
    "thumbnail": "https://i.ytimg.com/vi/MEjq9Vg1Cd0/mqdefault.jpg",
    "title": "【#生スバル】炎の料理人クッキングファイター好するしゅばああああああ！！！！！！！：Cooking Fighter HAO【ホロライブ/大空スバル】",
    "publishedAt": "2022-03-21T13:47:11Z"
  },
  {
    "videoId": "abs2Kvd_JkE",
    "thumbnail": "https://i.ytimg.com/vi/abs2Kvd_JkE/mqdefault.jpg",
    "title": "【#生スバル】ライトニングウィンナー出すしゅばあああああああ！！！！！！/Sausage Legend2【ホロライブ/大空スバル】",
    "publishedAt": "2022-03-24T15:04:01Z"
  },
  {
    "videoId": "p4woPgCM17c",
    "thumbnail": "https://i.ytimg.com/vi/p4woPgCM17c/mqdefault.jpg",
    "title": "【#５】無印最終回まで！完全初見のCLANNAD同時試聴会：CLANNAD watch party!!!【ホロライブ/大空スバル】",
    "publishedAt": "2022-03-25T15:24:27Z"
  },
  {
    "videoId": "ryI4LbqWKTM",
    "thumbnail": "https://i.ytimg.com/vi/ryI4LbqWKTM/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-03-26T02:22:00Z"
  },
  {
    "videoId": "NPK2sIDwwvE",
    "thumbnail": "https://i.ytimg.com/vi/NPK2sIDwwvE/mqdefault.jpg",
    "title": "【#１】クライシスコアやるしゅばあああああああああああああ！！！：CRISIS CORE -FINAL FANTASY VII-【ホロライブ/大空スバル】",
    "publishedAt": "2022-03-26T08:29:44Z"
  },
  {
    "videoId": "DZ6brFJUMD4",
    "thumbnail": "https://i.ytimg.com/vi/DZ6brFJUMD4/mqdefault.jpg",
    "title": "【#２】クライシスコアやるしゅばあああああああああああああ！！！：CRISIS CORE -FINAL FANTASY VII-【※ネタバレ有り】",
    "publishedAt": "2022-03-27T05:35:46Z"
  },
  {
    "videoId": "alqpZS_E7bc",
    "thumbnail": "https://i.ytimg.com/vi/alqpZS_E7bc/mqdefault.jpg",
    "title": "【#生スバル】バンパイアサバイバーで初クリア目指すしゅばああああああああああああ！！！！：VAMPIRE SURVIVORS【ホロライブ/大空スバル】",
    "publishedAt": "2022-03-29T13:42:02Z"
  },
  {
    "videoId": "DyqYSXDzblA",
    "thumbnail": "https://i.ytimg.com/vi/DyqYSXDzblA/mqdefault.jpg",
    "title": "【#ゆるホロチームカート】みんなでマリオカートするしゅばああああああああああああ！！！！：Mario Cart【大空スバル視点】",
    "publishedAt": "2022-03-30T15:00:07Z"
  },
  {
    "videoId": "izGlURXOBoU",
    "thumbnail": "https://i.ytimg.com/vi/izGlURXOBoU/mqdefault.jpg",
    "title": "【バビロンズフォール】新作のゲームをみんなでするしゅばあああああああ！！！！：BABYLON‘S FALL　【大空スバル視点/※ネタバレあり】",
    "publishedAt": "2022-03-31T11:58:08Z"
  },
  {
    "videoId": "UWPWAIajyjU",
    "thumbnail": "https://i.ytimg.com/vi/UWPWAIajyjU/mqdefault.jpg",
    "title": "【#６】完全初見のCLANNAD After同時試聴会：CLANNAD watch party!!!【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-01T14:09:18Z"
  },
  {
    "videoId": "GRDVLbr1XVQ",
    "thumbnail": "https://i.ytimg.com/vi/GRDVLbr1XVQ/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-02T02:14:41Z"
  },
  {
    "videoId": "xHYewDnrBJc",
    "thumbnail": "https://i.ytimg.com/vi/xHYewDnrBJc/mqdefault.jpg",
    "title": "【#３】クライシスコアやるしゅばあああああああああああああ！！！：CRISIS CORE -FINAL FANTASY VII-【※ネタバレ有り】",
    "publishedAt": "2022-04-02T09:19:08Z"
  },
  {
    "videoId": "YSZHFPVeIJ8",
    "thumbnail": "https://i.ytimg.com/vi/YSZHFPVeIJ8/mqdefault.jpg",
    "title": "【#４】クライシスコアやるしゅばあああああああああああああ！！！：CRISIS CORE -FINAL FANTASY VII-【※ネタバレ有り】",
    "publishedAt": "2022-04-03T08:29:36Z"
  },
  {
    "videoId": "I5ICk5mjOkk",
    "thumbnail": "https://i.ytimg.com/vi/I5ICk5mjOkk/mqdefault.jpg",
    "title": "【#最終回】炎の料理人クッキングファイター好するしゅばああああああ！！！！！！！：Cooking Fighter HAO【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-05T14:47:03Z"
  },
  {
    "videoId": "zxBkcRq0P8g",
    "thumbnail": "https://i.ytimg.com/vi/zxBkcRq0P8g/mqdefault.jpg",
    "title": "【#生スバル】大　空　警　察　出　動　準備編😁👍：MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-06T14:40:25Z"
  },
  {
    "videoId": "P7hsYZr2Kec",
    "thumbnail": "https://i.ytimg.com/vi/P7hsYZr2Kec/mqdefault.jpg",
    "title": "【#生スバル】閉店するしゅばああああああああああああああああああああ！！！！！：The Closing Shift【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-07T15:10:01Z"
  },
  {
    "videoId": "_2H9pk4ifng",
    "thumbnail": "https://i.ytimg.com/vi/_2H9pk4ifng/mqdefault.jpg",
    "title": "【#７】完全初見のCLANNAD After&番外編同時試聴会：CLANNAD watch party!!!【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-08T15:04:07Z"
  },
  {
    "videoId": "MFBWrGjvz2s",
    "thumbnail": "https://i.ytimg.com/vi/MFBWrGjvz2s/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-09T02:09:02Z"
  },
  {
    "videoId": "5Mzvn3DV77c",
    "thumbnail": "https://i.ytimg.com/vi/5Mzvn3DV77c/mqdefault.jpg",
    "title": "【#最終回】クライシスコアやるしゅばあああああああああああああ！！！：CRISIS CORE -FINAL FANTASY VII-【※ネタバレ有り】",
    "publishedAt": "2022-04-09T12:51:45Z"
  },
  {
    "videoId": "jUoMzohASVA",
    "thumbnail": "https://i.ytimg.com/vi/jUoMzohASVA/mqdefault.jpg",
    "title": "【#１】FF7リメイクするしゅばあああああああああああああ！！！：FINAL FANTASY VII REMAKE【※ネタバレあり】",
    "publishedAt": "2022-04-10T08:45:19Z"
  },
  {
    "videoId": "DUfE90Uqzqs",
    "thumbnail": "https://i.ytimg.com/vi/DUfE90Uqzqs/mqdefault.jpg",
    "title": "【HOLOTORI】みんなでお絵描き伝言ゲームするしゅばああああああああああああああああああああああああ！！！！！:Gartic Phone【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-10T15:31:33Z"
  },
  {
    "videoId": "4l-ic3PwKi0",
    "thumbnail": "https://i.ytimg.com/vi/4l-ic3PwKi0/mqdefault.jpg",
    "title": "【#生スバル】MIMIZU世界一目指すしゅばあああああああああああああああああああああ！！！！！！：slither.io【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-12T13:06:10Z"
  },
  {
    "videoId": "2aIg8kE-WuY",
    "thumbnail": "https://i.ytimg.com/vi/2aIg8kE-WuY/mqdefault.jpg",
    "title": "【#生スバル】罪を裁く場所つくるぞ！！！！！！！！！：MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-14T12:42:51Z"
  },
  {
    "videoId": "H8irmQkE_FU",
    "thumbnail": "https://i.ytimg.com/vi/H8irmQkE_FU/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-16T02:10:15Z"
  },
  {
    "videoId": "akgwLjoXDHM",
    "thumbnail": "https://i.ytimg.com/vi/akgwLjoXDHM/mqdefault.jpg",
    "title": "【#２】FF7リメイクするしゅばあああああああああああああ！！！：FINAL FANTASY VII REMAKE【※ネタバレあり】",
    "publishedAt": "2022-04-16T10:00:59Z"
  },
  {
    "videoId": "kWSjswn1eqw",
    "thumbnail": "https://i.ytimg.com/vi/kWSjswn1eqw/mqdefault.jpg",
    "title": "【#３】FF7リメイクするしゅばあああああああああああああ！！！：FINAL FANTASY VII REMAKE【※ネタバレあり】",
    "publishedAt": "2022-04-17T10:58:24Z"
  },
  {
    "videoId": "MTpKegpY5ec",
    "thumbnail": "https://i.ytimg.com/vi/MTpKegpY5ec/mqdefault.jpg",
    "title": "【#生スバル】視聴者参加？！ツインスティックでバーチャロンするしゅばああああああああああああああ！！！！：CYBER TROOPERS VIRTUAL-ON【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-19T14:09:57Z"
  },
  {
    "videoId": "E3Yw0k9T7fU",
    "thumbnail": "https://i.ytimg.com/vi/E3Yw0k9T7fU/mqdefault.jpg",
    "title": "【#生スバル】NGなし？！マシュマロ質問大回答会！！！！！：No NG!! question!!!【ホロっライブ/大空スバル】",
    "publishedAt": "2022-04-20T14:22:10Z"
  },
  {
    "videoId": "cnR8ncN-ZIU",
    "thumbnail": "https://i.ytimg.com/vi/cnR8ncN-ZIU/mqdefault.jpg",
    "title": "【#８】完全初見のCLANNAD After同時試聴会：CLANNAD watch party!!!【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-22T15:48:19Z"
  },
  {
    "videoId": "i35f4gucnHs",
    "thumbnail": "https://i.ytimg.com/vi/i35f4gucnHs/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-23T02:13:22Z"
  },
  {
    "videoId": "I2e-GN68Css",
    "thumbnail": "https://i.ytimg.com/vi/I2e-GN68Css/mqdefault.jpg",
    "title": "【#４】FF7リメイクするしゅばあああああああああああああ！！！：FINAL FANTASY VII REMAKE【※ネタバレあり】",
    "publishedAt": "2022-04-23T10:03:11Z"
  },
  {
    "videoId": "Ze6OoLLwy2s",
    "thumbnail": "https://i.ytimg.com/vi/Ze6OoLLwy2s/mqdefault.jpg",
    "title": "【#５】FF7リメイクするしゅばあああああああああああああ！！！：FINAL FANTASY VII REMAKE【※ネタバレあり】",
    "publishedAt": "2022-04-24T09:59:16Z"
  },
  {
    "videoId": "x_WQrN7q6iE",
    "thumbnail": "https://i.ytimg.com/vi/x_WQrN7q6iE/mqdefault.jpg",
    "title": "【#９】完全初見のCLANNAD After同時試聴会：CLANNAD watch party!!!【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-29T15:33:44Z"
  },
  {
    "videoId": "TmiRa_kfNKw",
    "thumbnail": "https://i.ytimg.com/vi/TmiRa_kfNKw/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-04-30T02:08:47Z"
  },
  {
    "videoId": "oe5D227RvEY",
    "thumbnail": "https://i.ytimg.com/vi/oe5D227RvEY/mqdefault.jpg",
    "title": "【#6】FF7リメイクするしゅばあああああああああああああ！！！：FINAL FANTASY VII REMAKE【※ネタバレあり】",
    "publishedAt": "2022-04-30T10:27:48Z"
  },
  {
    "videoId": "Lv0GlVjjEfw",
    "thumbnail": "https://i.ytimg.com/vi/Lv0GlVjjEfw/mqdefault.jpg",
    "title": "【#7】FF7リメイクするしゅばあああああああああああああ！！！：FINAL FANTASY VII REMAKE【※ネタバレあり】",
    "publishedAt": "2022-05-01T11:41:06Z"
  },
  {
    "videoId": "OPMr4RDhuZg",
    "thumbnail": "https://i.ytimg.com/vi/OPMr4RDhuZg/mqdefault.jpg",
    "title": "【#ホロGGW】スバルチームぷちインタビュー！！：Subaru Team Mini interview  Party【ホロライブ/大空スバル】",
    "publishedAt": "2022-05-03T15:09:00Z"
  },
  {
    "videoId": "hC2jsfIfSwQ",
    "thumbnail": "https://i.ytimg.com/vi/hC2jsfIfSwQ/mqdefault.jpg",
    "title": "【#ホロGGW】練習するしゅばああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-05-04T14:00:00Z"
  },
  {
    "videoId": "FXCn3sf9LZU",
    "thumbnail": "https://i.ytimg.com/vi/FXCn3sf9LZU/mqdefault.jpg",
    "title": "【#ホロライブレトロゲーム部】星のカービィスーパーデラックスクリア耐久：Kirby Super Star Clear Durability【ホロライブ】",
    "publishedAt": "2022-05-05T13:15:56Z"
  },
  {
    "videoId": "aaGLEQdby2Q",
    "thumbnail": "https://i.ytimg.com/vi/aaGLEQdby2Q/mqdefault.jpg",
    "title": "【#ホロGGW】合同練習するしゅばああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-05-06T13:06:31Z"
  },
  {
    "videoId": "-BPEIrRSoPY",
    "thumbnail": "https://i.ytimg.com/vi/-BPEIrRSoPY/mqdefault.jpg",
    "title": "【#最終回】完全初見のCLANNAD After同時試聴会：CLANNAD watch party!!!【ホロライブ/大空スバル】",
    "publishedAt": "2022-05-06T16:37:14Z"
  },
  {
    "videoId": "qOT1xawSjzc",
    "thumbnail": "https://i.ytimg.com/vi/qOT1xawSjzc/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-05-07T02:09:17Z"
  },
  {
    "videoId": "NeE7SuCf8oA",
    "thumbnail": "https://i.ytimg.com/vi/NeE7SuCf8oA/mqdefault.jpg",
    "title": "【#8】FF7リメイクするしゅばあああああああああああああ！！！：FINAL FANTASY VII REMAKE【※ネタバレあり】",
    "publishedAt": "2022-05-07T08:35:37Z"
  },
  {
    "videoId": "yjMKzQOGAOU",
    "thumbnail": "https://i.ytimg.com/vi/yjMKzQOGAOU/mqdefault.jpg",
    "title": "【#ホロGGW】いよいよ本番！！！頑張るぞ！！！！！！！！！！！【チームスターアニマル】",
    "publishedAt": "2022-05-08T15:38:18Z"
  },
  {
    "videoId": "C1gBBrwUu-M",
    "thumbnail": "https://i.ytimg.com/vi/C1gBBrwUu-M/mqdefault.jpg",
    "title": "【#生スバル】ファン対抗！？視聴者参加お絵描きの森するしゅばあああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-05-10T15:41:03Z"
  },
  {
    "videoId": "8fZk0krv6Lg",
    "thumbnail": "https://i.ytimg.com/vi/8fZk0krv6Lg/mqdefault.jpg",
    "title": "【#生スバル】Nintendo Switch Sportsで優勝するしゅばああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-05-11T13:34:07Z"
  },
  {
    "videoId": "Ewja5Asuc8Y",
    "thumbnail": "https://i.ytimg.com/vi/Ewja5Asuc8Y/mqdefault.jpg",
    "title": "【大空スバル視点】地球防衛するしゅばああああああああああああああああああ！！！！！！！：EDF【#ホロ地球防衛隊】",
    "publishedAt": "2022-05-12T14:41:16Z"
  },
  {
    "videoId": "fv1CfrzSt_w",
    "thumbnail": "https://i.ytimg.com/vi/fv1CfrzSt_w/mqdefault.jpg",
    "title": "【#9】FF7リメイクするしゅばあああああああああああああ！！！：FINAL FANTASY VII REMAKE【※ネタバレあり】",
    "publishedAt": "2022-05-14T11:01:25Z"
  },
  {
    "videoId": "7fdpm_F89os",
    "thumbnail": "https://i.ytimg.com/vi/7fdpm_F89os/mqdefault.jpg",
    "title": "【#最終回】FF7リメイクするしゅばあああああああああああああ！！！：FINAL FANTASY VII REMAKE【※ネタバレあり】",
    "publishedAt": "2022-05-15T13:04:32Z"
  },
  {
    "videoId": "45sm2PGki6M",
    "thumbnail": "https://i.ytimg.com/vi/45sm2PGki6M/mqdefault.jpg",
    "title": "【#生スバル】心拍数ホラゲーDBDするしゅばあああああああああああああああああ！！！！！：Dead By Daylight【】",
    "publishedAt": "2022-05-18T12:11:36Z"
  },
  {
    "videoId": "ONf2HcPX8uo",
    "thumbnail": "https://i.ytimg.com/vi/ONf2HcPX8uo/mqdefault.jpg",
    "title": "【#生スバル】8位以下で地獄の過去ツイート公開マリオカートしゅばあああああああああああああああああ！！！！！：MarioKart8【ホロライブ/大空スバル】",
    "publishedAt": "2022-05-19T12:40:27Z"
  },
  {
    "videoId": "FUdAY4LTBlk",
    "thumbnail": "https://i.ytimg.com/vi/FUdAY4LTBlk/mqdefault.jpg",
    "title": "【#生スバル】アニメグレンラガン同時試聴会第１話～：anime GURREN LAGANN watch party episode1【ホロライブ/大空スバル】",
    "publishedAt": "2022-05-20T14:39:50Z"
  },
  {
    "videoId": "Vlcl27pd2Gg",
    "thumbnail": "https://i.ytimg.com/vi/Vlcl27pd2Gg/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-05-21T02:10:01Z"
  },
  {
    "videoId": "pzc8Fg4Viwk",
    "thumbnail": "https://i.ytimg.com/vi/pzc8Fg4Viwk/mqdefault.jpg",
    "title": "【#ユフィ編】FF7リメイク ユフィ編するしゅばあああああああああああああ！！！：FINAL FANTASY VII REMAKE YUFFIE DLC【※ネタバレあり】",
    "publishedAt": "2022-05-21T09:59:32Z"
  },
  {
    "videoId": "GGNABUe5bU0",
    "thumbnail": "https://i.ytimg.com/vi/GGNABUe5bU0/mqdefault.jpg",
    "title": "【#ユフィ編完結】FF7リメイク ユフィ編するしゅばあああああああああああああ！！！：FINAL FANTASY VII REMAKE YUFFIE DLC【※ネタバレあり】",
    "publishedAt": "2022-05-22T10:04:50Z"
  },
  {
    "videoId": "a74gzcoJEPQ",
    "thumbnail": "https://i.ytimg.com/vi/a74gzcoJEPQ/mqdefault.jpg",
    "title": "【#ミオスバ】死の電話がかかってくるらしいめちゃこわホラーするしゅばあああああああああああああああああ！！！！！：Is Simon There?【ホロライブ】",
    "publishedAt": "2022-05-24T15:40:36Z"
  },
  {
    "videoId": "Bk9BB0eV-YA",
    "thumbnail": "https://i.ytimg.com/vi/Bk9BB0eV-YA/mqdefault.jpg",
    "title": "【#生スバル】cooking simulatorで料理に挑戦しゅばあああああああああああ！！！！！：cooking simulator【ホロライブ/大空スバル】",
    "publishedAt": "2022-05-25T12:12:31Z"
  },
  {
    "videoId": "BCVIbjYrzpc",
    "thumbnail": "https://i.ytimg.com/vi/BCVIbjYrzpc/mqdefault.jpg",
    "title": "【】 uuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuta【】",
    "publishedAt": "2022-05-27T12:07:11Z"
  },
  {
    "videoId": "rOuiAh0qxnY",
    "thumbnail": "https://i.ytimg.com/vi/rOuiAh0qxnY/mqdefault.jpg",
    "title": "【#生スバル】アニメグレンラガン同時試聴会第6話～第9話：anime GURREN LAGANN watch party episode1【ホロライブ/大空スバル】",
    "publishedAt": "2022-05-27T15:39:00Z"
  },
  {
    "videoId": "_BHC4h38z-s",
    "thumbnail": "https://i.ytimg.com/vi/_BHC4h38z-s/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-05-28T02:11:27Z"
  },
  {
    "videoId": "oyxvhJW1Cf8",
    "thumbnail": "https://i.ytimg.com/vi/oyxvhJW1Cf8/mqdefault.jpg",
    "title": "【#1】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-05-29T09:25:18Z"
  },
  {
    "videoId": "SZ0pD_Od9Fs",
    "thumbnail": "https://i.ytimg.com/vi/SZ0pD_Od9Fs/mqdefault.jpg",
    "title": "【#生スバル 】モンスターファーム２するしゅばあああああああああああああああああああ！！！！：Monster Farm1&2DX【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-01T15:26:12Z"
  },
  {
    "videoId": "pHk1wXMm0EY",
    "thumbnail": "https://i.ytimg.com/vi/pHk1wXMm0EY/mqdefault.jpg",
    "title": "【#生スバル】第１回！世界のお菓子展覧会！世界中のお菓子を食べつくすしゅばあああああああああああ！！！！：Tasting of sweets from around the world Ep1",
    "publishedAt": "2022-06-02T08:46:33Z"
  },
  {
    "videoId": "GlPqoYfw2Hk",
    "thumbnail": "https://i.ytimg.com/vi/GlPqoYfw2Hk/mqdefault.jpg",
    "title": "【#生スバル 】大空市長爆誕しゅばあああああああああああああああああ！！！！！！/Cities: Skylines【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-03T08:36:10Z"
  },
  {
    "videoId": "J8m1FgA6PpQ",
    "thumbnail": "https://i.ytimg.com/vi/J8m1FgA6PpQ/mqdefault.jpg",
    "title": "【#生スバル】アニメグレンラガン同時試聴会第10話～：anime GURREN LAGANN watch party episode10【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-03T15:27:50Z"
  },
  {
    "videoId": "nxsELnSlRB8",
    "thumbnail": "https://i.ytimg.com/vi/nxsELnSlRB8/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-04T02:12:49Z"
  },
  {
    "videoId": "_5Oa2kR_7go",
    "thumbnail": "https://i.ytimg.com/vi/_5Oa2kR_7go/mqdefault.jpg",
    "title": "【#2】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-06-04T08:44:30Z"
  },
  {
    "videoId": "NU2p1wDzX20",
    "thumbnail": "https://i.ytimg.com/vi/NU2p1wDzX20/mqdefault.jpg",
    "title": "【#3】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-06-05T09:48:02Z"
  },
  {
    "videoId": "u5qkBaBwaHE",
    "thumbnail": "https://i.ytimg.com/vi/u5qkBaBwaHE/mqdefault.jpg",
    "title": "【#生スバル 】大空市長今日も張り切ってお仕事しゅばあああああああああああああああああ！！！！！！/Cities: Skylines【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-08T14:23:13Z"
  },
  {
    "videoId": "WffpjOkTAIk",
    "thumbnail": "https://i.ytimg.com/vi/WffpjOkTAIk/mqdefault.jpg",
    "title": "【#生スバル】視聴者参加型ソーセージレジェンド２凸待ち：ＳＡＵＳＡＧＥ ＬＥＧＥＮＤ２【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-09T13:59:52Z"
  },
  {
    "videoId": "MWIzI8dvCiw",
    "thumbnail": "https://i.ytimg.com/vi/MWIzI8dvCiw/mqdefault.jpg",
    "title": "【#スバルーナ】2人で何個取れるか競争しゅばあああああああああああああああ！！！！：モーリーオンライン【ホロライブ】",
    "publishedAt": "2022-06-10T12:07:51Z"
  },
  {
    "videoId": "ysLmxr_aHqw",
    "thumbnail": "https://i.ytimg.com/vi/ysLmxr_aHqw/mqdefault.jpg",
    "title": "【#生スバル】アニメグレンラガン同時試聴会第14話～第17話：anime GURREN LAGANN watch party episode1【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-10T15:44:32Z"
  },
  {
    "videoId": "FjgnOvSFiTA",
    "thumbnail": "https://i.ytimg.com/vi/FjgnOvSFiTA/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-11T03:33:22Z"
  },
  {
    "videoId": "LVKnyb-r8u8",
    "thumbnail": "https://i.ytimg.com/vi/LVKnyb-r8u8/mqdefault.jpg",
    "title": "【#4】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-06-12T09:55:48Z"
  },
  {
    "videoId": "W87VcqF2d7A",
    "thumbnail": "https://i.ytimg.com/vi/W87VcqF2d7A/mqdefault.jpg",
    "title": "【#スバラミ】ラミィとスバルの子育てモンスターファーム：Monster Farm1&2DX【ホロライブ】",
    "publishedAt": "2022-06-14T13:40:49Z"
  },
  {
    "videoId": "hy2XE0gion8",
    "thumbnail": "https://i.ytimg.com/vi/hy2XE0gion8/mqdefault.jpg",
    "title": "【#生スバル 】第２回世界のお菓子展覧会しゅばあああああああああああああああ！！！！：Tasting of sweets from around the world Ep2",
    "publishedAt": "2022-06-15T14:10:18Z"
  },
  {
    "videoId": "maj1PKvnr0Y",
    "thumbnail": "https://i.ytimg.com/vi/maj1PKvnr0Y/mqdefault.jpg",
    "title": "【#生スバル】アニメグレンラガン同時試聴会第18話～第20話：anime GURREN LAGANN watch party episode1【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-17T15:53:13Z"
  },
  {
    "videoId": "ynU0nyI0y-k",
    "thumbnail": "https://i.ytimg.com/vi/ynU0nyI0y-k/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-18T02:09:08Z"
  },
  {
    "videoId": "Ajm613vfGw8",
    "thumbnail": "https://i.ytimg.com/vi/Ajm613vfGw8/mqdefault.jpg",
    "title": "【#5】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-06-18T09:07:53Z"
  },
  {
    "videoId": "8SJ52KW1SuE",
    "thumbnail": "https://i.ytimg.com/vi/8SJ52KW1SuE/mqdefault.jpg",
    "title": "【#6】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-06-19T09:32:45Z"
  },
  {
    "videoId": "wfFo-glKSAg",
    "thumbnail": "https://i.ytimg.com/vi/wfFo-glKSAg/mqdefault.jpg",
    "title": "【#生スバル】大空スバルにみんなのおススメを布教する会開催しゅばああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-21T16:00:35Z"
  },
  {
    "videoId": "OkCDeseuzSE",
    "thumbnail": "https://i.ytimg.com/vi/OkCDeseuzSE/mqdefault.jpg",
    "title": "【#スバルーナ】『カプコン ファイティング コレクション』発売記念？！？格闘ゲームでバトルしゅばあああああああああああああああああ！！！！【ホロライブ】",
    "publishedAt": "2022-06-24T12:21:00Z"
  },
  {
    "videoId": "IdIl5gdb1ho",
    "thumbnail": "https://i.ytimg.com/vi/IdIl5gdb1ho/mqdefault.jpg",
    "title": "【#生スバル】怒りのスマブラしゅばあああああああああああああああああああああああああああああああああああ【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-24T12:33:13Z"
  },
  {
    "videoId": "5ZOSqcCv1mY",
    "thumbnail": "https://i.ytimg.com/vi/5ZOSqcCv1mY/mqdefault.jpg",
    "title": "【#最終回】アニメグレンラガン同時試聴会第23話～最終話：anime GURREN LAGANN watch party episode1【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-24T16:05:28Z"
  },
  {
    "videoId": "jAozullMQio",
    "thumbnail": "https://i.ytimg.com/vi/jAozullMQio/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-25T02:08:44Z"
  },
  {
    "videoId": "HjuaZLnm5Dw",
    "thumbnail": "https://i.ytimg.com/vi/HjuaZLnm5Dw/mqdefault.jpg",
    "title": "【#7】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-06-25T08:54:12Z"
  },
  {
    "videoId": "QqXFh0x6gqU",
    "thumbnail": "https://i.ytimg.com/vi/QqXFh0x6gqU/mqdefault.jpg",
    "title": "【#8】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-06-26T08:45:07Z"
  },
  {
    "videoId": "AvidiKGqU9o",
    "thumbnail": "https://i.ytimg.com/vi/AvidiKGqU9o/mqdefault.jpg",
    "title": "【#生スバル】生‘‘き‘‘た‘‘い‘‘！！！！！！HOLOCUREEEEEEEEEEEEEEEEEEEEEEEEEEEEE！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-28T14:15:05Z"
  },
  {
    "videoId": "fZLhCj55JIA",
    "thumbnail": "https://i.ytimg.com/vi/fZLhCj55JIA/mqdefault.jpg",
    "title": "【#生スバル】おはスバ出張版しゅばあああああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-06-30T12:41:04Z"
  },
  {
    "videoId": "FOAiBX7fjVg",
    "thumbnail": "https://i.ytimg.com/vi/FOAiBX7fjVg/mqdefault.jpg",
    "title": "【#生スバル】銀魂同時試聴1話～4話：Gin tama Watch party Ep1~Ep4【ホロライブ/大空スバル】",
    "publishedAt": "2022-07-01T15:39:02Z"
  },
  {
    "videoId": "Kz8ortzjAZs",
    "thumbnail": "https://i.ytimg.com/vi/Kz8ortzjAZs/mqdefault.jpg",
    "title": "【#9】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-07-02T09:35:23Z"
  },
  {
    "videoId": "5R0Xoou1pNE",
    "thumbnail": "https://i.ytimg.com/vi/5R0Xoou1pNE/mqdefault.jpg",
    "title": "【#大空スバル生誕祭】大空スバル生誕祭2022！！！１７.４才おめでとうしゅばあああああああああああああああああ！！！！Subaru Happy Birth Day Stream【】",
    "publishedAt": "2022-07-02T13:08:10Z"
  },
  {
    "videoId": "PecpfjJ02W4",
    "thumbnail": "https://i.ytimg.com/vi/PecpfjJ02W4/mqdefault.jpg",
    "title": "【#生スバル 】おさんぽスバル in Mine Craft【ホロライブ/大空スバル】",
    "publishedAt": "2022-07-05T14:05:58Z"
  },
  {
    "videoId": "t-iW-81JaKU",
    "thumbnail": "https://i.ytimg.com/vi/t-iW-81JaKU/mqdefault.jpg",
    "title": "間違えたら即終了？！スバトワ絆クイズ！！！！：If you get it wrong, it's over immediately? SubaTowa Bonding Quiz: ！！！！",
    "publishedAt": "2022-07-06T13:55:03Z"
  },
  {
    "videoId": "3CqKF3HXCBg",
    "thumbnail": "https://i.ytimg.com/vi/3CqKF3HXCBg/mqdefault.jpg",
    "title": "【#生スバル 】七夕ASMR？…余裕ですが…【ホロライブ/大空スバル】",
    "publishedAt": "2022-07-07T12:05:48Z"
  },
  {
    "videoId": "yyz1iq3cQOU",
    "thumbnail": "https://i.ytimg.com/vi/yyz1iq3cQOU/mqdefault.jpg",
    "title": "【#生スバル】STEINS;GATE同時視聴会しゅばああああああああ！！！！：STEINS;GATE watch party【ホロライブ/大空スバル】",
    "publishedAt": "2022-07-08T15:31:34Z"
  },
  {
    "videoId": "cL9Rvw2GMMA",
    "thumbnail": "https://i.ytimg.com/vi/cL9Rvw2GMMA/mqdefault.jpg",
    "title": "【#生スバル】おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-07-09T02:07:44Z"
  },
  {
    "videoId": "k1MMRPiTVKs",
    "thumbnail": "https://i.ytimg.com/vi/k1MMRPiTVKs/mqdefault.jpg",
    "title": "【#10】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-07-09T09:22:52Z"
  },
  {
    "videoId": "ntiem_MHgto",
    "thumbnail": "https://i.ytimg.com/vi/ntiem_MHgto/mqdefault.jpg",
    "title": "【#11】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-07-10T11:17:50Z"
  },
  {
    "videoId": "9S-czmjweQA",
    "thumbnail": "https://i.ytimg.com/vi/9S-czmjweQA/mqdefault.jpg",
    "title": "【#生スバル】視聴者参加 FALL GUYSで優勝しゅばああああああああああああああああああああああああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-07-12T12:09:19Z"
  },
  {
    "videoId": "5eZDfdKuBqo",
    "thumbnail": "https://i.ytimg.com/vi/5eZDfdKuBqo/mqdefault.jpg",
    "title": "【#生スバル】噂の神ゲー？！？メタルスラッグ３やるしゅばああああああああああああああ！！！！！！/METAL SLUG３【ホロライブ/大空スバル】",
    "publishedAt": "2022-07-13T14:38:15Z"
  },
  {
    "videoId": "vQ4E1xV1hhU",
    "thumbnail": "https://i.ytimg.com/vi/vQ4E1xV1hhU/mqdefault.jpg",
    "title": "【#生スバル】STEINS;GATE同時視聴会しゅばああああああああ！！！！：STEINS;GATE watch party【ホロライブ/大空スバル】",
    "publishedAt": "2022-07-15T15:34:32Z"
  },
  {
    "videoId": "7nKGoC7esNA",
    "thumbnail": "https://i.ytimg.com/vi/7nKGoC7esNA/mqdefault.jpg",
    "title": "【#生スバル】新コーナーにゲスト有！？！おはすば！スバル：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2022-07-16T02:07:37Z"
  },
  {
    "videoId": "GNt1QTLLBt0",
    "thumbnail": "https://i.ytimg.com/vi/GNt1QTLLBt0/mqdefault.jpg",
    "title": "【#12】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-07-16T09:00:09Z"
  },
  {
    "videoId": "nqTY0dp3aXU",
    "thumbnail": "https://i.ytimg.com/vi/nqTY0dp3aXU/mqdefault.jpg",
    "title": "【#13】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-07-17T07:13:57Z"
  },
  {
    "videoId": "ncz6yx5frEM",
    "thumbnail": "https://i.ytimg.com/vi/ncz6yx5frEM/mqdefault.jpg",
    "title": "【#生スバル】ガチホラーってまじ！？！ホロライブERRORやるしゅばあああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-07-21T12:19:36Z"
  },
  {
    "videoId": "Uv0ntqQqsJw",
    "thumbnail": "https://i.ytimg.com/vi/Uv0ntqQqsJw/mqdefault.jpg",
    "title": "【#生スバル】STEINS;GATE同時視聴会しゅばああああああああ！！！！：STEINS;GATE watch party【ホロライブ/大空スバル】",
    "publishedAt": "2022-07-22T15:31:27Z"
  },
  {
    "videoId": "HfnuYnTkVAU",
    "thumbnail": "https://i.ytimg.com/vi/HfnuYnTkVAU/mqdefault.jpg",
    "title": "【#14】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-07-23T10:04:59Z"
  },
  {
    "videoId": "PQ-Zzs2IWlk",
    "thumbnail": "https://i.ytimg.com/vi/PQ-Zzs2IWlk/mqdefault.jpg",
    "title": "【#15】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-07-24T06:13:36Z"
  },
  {
    "videoId": "8WzGSGJam-k",
    "thumbnail": "https://i.ytimg.com/vi/8WzGSGJam-k/mqdefault.jpg",
    "title": "【カプコンアーケード2ndスタジアム】レトロゲーム部でカプスタ２するしゅばあああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-07-26T12:09:49Z"
  },
  {
    "videoId": "oz_2j7KJVcQ",
    "thumbnail": "https://i.ytimg.com/vi/oz_2j7KJVcQ/mqdefault.jpg",
    "title": "【#生スバル】黒歴史選手権/Everyone talks about their embarrassing memories.【ホロライブ】",
    "publishedAt": "2022-07-26T15:20:31Z"
  },
  {
    "videoId": "-v16NkyDMNo",
    "thumbnail": "https://i.ytimg.com/vi/-v16NkyDMNo/mqdefault.jpg",
    "title": "【#SMOK】勝手に格付けランキングするしゅばああああああああああ！！！【ホロライブ】",
    "publishedAt": "2022-07-28T12:05:56Z"
  },
  {
    "videoId": "JW8ocFohng0",
    "thumbnail": "https://i.ytimg.com/vi/JW8ocFohng0/mqdefault.jpg",
    "title": "【#生スバル】おはすば！【ホロライブ/大空スバル】",
    "publishedAt": "2022-07-30T02:08:48Z"
  },
  {
    "videoId": "NwFtlZHS9QA",
    "thumbnail": "https://i.ytimg.com/vi/NwFtlZHS9QA/mqdefault.jpg",
    "title": "【#最終回？】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-07-30T08:19:14Z"
  },
  {
    "videoId": "zw-86QLwP20",
    "thumbnail": "https://i.ytimg.com/vi/zw-86QLwP20/mqdefault.jpg",
    "title": "【#ガチ最終回】テイルズ オブ ジアビス するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-07-31T09:10:27Z"
  },
  {
    "videoId": "_3VqdZxO_ZM",
    "thumbnail": "https://i.ytimg.com/vi/_3VqdZxO_ZM/mqdefault.jpg",
    "title": "【#生スバル】おさんぽマイクラしゅばああああああああああああ！！！！/MINE CRAFT【ホロライブ】",
    "publishedAt": "2022-08-02T12:35:53Z"
  },
  {
    "videoId": "EvtLAOqI-50",
    "thumbnail": "https://i.ytimg.com/vi/EvtLAOqI-50/mqdefault.jpg",
    "title": "【#生スバル】STEINS;GATE同時視聴会しゅばああああああああ！！！！：STEINS;GATE watch party【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-02T15:16:45Z"
  },
  {
    "videoId": "0v0L5ApgdOQ",
    "thumbnail": "https://i.ytimg.com/vi/0v0L5ApgdOQ/mqdefault.jpg",
    "title": "【#生スバル】話題の新作ホラゲー！！！！死体に憑りつく悪魔をぶっ倒そう！！！！！！！！！！：THE MORTUARY ASSISTANT【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-04T15:24:11Z"
  },
  {
    "videoId": "vOQHuvVG2EI",
    "thumbnail": "https://i.ytimg.com/vi/vOQHuvVG2EI/mqdefault.jpg",
    "title": "【#生スバル】大空カスタマーサポートセンター：Ozora Customer Support Center【ホロライブ】",
    "publishedAt": "2022-08-05T12:45:15Z"
  },
  {
    "videoId": "XBxpvYp8m_Q",
    "thumbnail": "https://i.ytimg.com/vi/XBxpvYp8m_Q/mqdefault.jpg",
    "title": "【#生スバル】STEINS;GATE同時視聴会しゅばああああああああ！！！！：STEINS;GATE watch party【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-05T14:57:14Z"
  },
  {
    "videoId": "WYsYXANf3eI",
    "thumbnail": "https://i.ytimg.com/vi/WYsYXANf3eI/mqdefault.jpg",
    "title": "【#生スバル】OPAYO！！！！おはしゅば雑談しゅばああああああああああああああ！！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-06T02:14:22Z"
  },
  {
    "videoId": "iAjlxb84tJo",
    "thumbnail": "https://i.ytimg.com/vi/iAjlxb84tJo/mqdefault.jpg",
    "title": "【#1】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-08-06T10:57:51Z"
  },
  {
    "videoId": "9GG0Ct0haz8",
    "thumbnail": "https://i.ytimg.com/vi/9GG0Ct0haz8/mqdefault.jpg",
    "title": "【#2】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-08-07T10:02:41Z"
  },
  {
    "videoId": "XOpVHH83y-k",
    "thumbnail": "https://i.ytimg.com/vi/XOpVHH83y-k/mqdefault.jpg",
    "title": "【#生スバル】初RUSTするしゅばあああああああああああああ！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-10T16:28:02Z"
  },
  {
    "videoId": "SZ4Skr3ZZRE",
    "thumbnail": "https://i.ytimg.com/vi/SZ4Skr3ZZRE/mqdefault.jpg",
    "title": "【#最終回】STEINS;GATE同時視聴会しゅばああああああああ！！！！：STEINS;GATE watch party【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-12T15:17:27Z"
  },
  {
    "videoId": "UEUn7frEWLM",
    "thumbnail": "https://i.ytimg.com/vi/UEUn7frEWLM/mqdefault.jpg",
    "title": "【#生スバル】水着解禁？！おはスバ雑談しゅばああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-13T02:06:24Z"
  },
  {
    "videoId": "aeJHB_Q2pFE",
    "thumbnail": "https://i.ytimg.com/vi/aeJHB_Q2pFE/mqdefault.jpg",
    "title": "【#3】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-08-13T11:00:11Z"
  },
  {
    "videoId": "gyOdvC871M4",
    "thumbnail": "https://i.ytimg.com/vi/gyOdvC871M4/mqdefault.jpg",
    "title": "【#4】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-08-14T10:22:32Z"
  },
  {
    "videoId": "1KbkjgnZpUI",
    "thumbnail": "https://i.ytimg.com/vi/1KbkjgnZpUI/mqdefault.jpg",
    "title": "【#スバちょこるなたん】古代のピラミッドでサバイバルホラーしゅばあああああああああああああ！！！：FOREWARNED【大空スバル視点】",
    "publishedAt": "2022-08-16T14:37:06Z"
  },
  {
    "videoId": "xpUxUx3hlRA",
    "thumbnail": "https://i.ytimg.com/vi/xpUxUx3hlRA/mqdefault.jpg",
    "title": "【#生スバル】メル先輩がレイドにくるらしいからヤベえしゅばああああああああああ！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-17T12:07:18Z"
  },
  {
    "videoId": "4p526WgrsYA",
    "thumbnail": "https://i.ytimg.com/vi/4p526WgrsYA/mqdefault.jpg",
    "title": "【#生スバル】銃をうつれんしゅう：RUST【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-18T16:09:46Z"
  },
  {
    "videoId": "nysKtgJxgn0",
    "thumbnail": "https://i.ytimg.com/vi/nysKtgJxgn0/mqdefault.jpg",
    "title": "【#生スバル】真夏の祭典？！水着ソセレガチャってどういうことだってばよ引くしかないしゅばあああああああああ！！！！！！！：Sausage Legend GACHA【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-19T12:03:16Z"
  },
  {
    "videoId": "f4mB82tVMyI",
    "thumbnail": "https://i.ytimg.com/vi/f4mB82tVMyI/mqdefault.jpg",
    "title": "【#生スバル】コードギアス反逆のルルーシュ同時試聴：CODE GEASS Lelouch of the Rebellion【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-19T15:23:15Z"
  },
  {
    "videoId": "irPvuVBqgeo",
    "thumbnail": "https://i.ytimg.com/vi/irPvuVBqgeo/mqdefault.jpg",
    "title": "【#生スバル】浴衣解禁？！おはスバ雑談しゅばああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-20T02:05:55Z"
  },
  {
    "videoId": "DbGJThp08Cg",
    "thumbnail": "https://i.ytimg.com/vi/DbGJThp08Cg/mqdefault.jpg",
    "title": "【#5】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-08-20T11:23:12Z"
  },
  {
    "videoId": "hgth9gre9Ic",
    "thumbnail": "https://i.ytimg.com/vi/hgth9gre9Ic/mqdefault.jpg",
    "title": "【#6】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-08-21T10:51:03Z"
  },
  {
    "videoId": "EciuDfykn4U",
    "thumbnail": "https://i.ytimg.com/vi/EciuDfykn4U/mqdefault.jpg",
    "title": "【】ANIME Song☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻sing【】",
    "publishedAt": "2022-08-23T12:16:50Z"
  },
  {
    "videoId": "VZDJ31wnQ0Y",
    "thumbnail": "https://i.ytimg.com/vi/VZDJ31wnQ0Y/mqdefault.jpg",
    "title": "【Gartic Phone】スターアニマル復活‼みんなでお絵描きバトルしゅばああああああああああ！！【ホロライブ / 大空スバル】",
    "publishedAt": "2022-08-24T13:04:15Z"
  },
  {
    "videoId": "Bw3uU1jvv-c",
    "thumbnail": "https://i.ytimg.com/vi/Bw3uU1jvv-c/mqdefault.jpg",
    "title": "【#生スバル】テイルズ オブ ジアビス 裏ボス攻略するしゅばあああああああああああああ！！！！！！：TALES OF THE ABYSS【ネタバレあり】",
    "publishedAt": "2022-08-25T15:56:05Z"
  },
  {
    "videoId": "ou3CIVxwpHU",
    "thumbnail": "https://i.ytimg.com/vi/ou3CIVxwpHU/mqdefault.jpg",
    "title": "【#生スバル】コードギアス反逆のルルーシュ同時試聴：CODE GEASS Lelouch of the Rebellion【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-26T15:47:03Z"
  },
  {
    "videoId": "jaVCwKfiNOI",
    "thumbnail": "https://i.ytimg.com/vi/jaVCwKfiNOI/mqdefault.jpg",
    "title": "【#7】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-08-27T10:37:20Z"
  },
  {
    "videoId": "w7z1APT9I8Y",
    "thumbnail": "https://i.ytimg.com/vi/w7z1APT9I8Y/mqdefault.jpg",
    "title": "【#8】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-08-28T08:42:15Z"
  },
  {
    "videoId": "hi8sVp_Phy4",
    "thumbnail": "https://i.ytimg.com/vi/hi8sVp_Phy4/mqdefault.jpg",
    "title": "【#ホロ鯖夏祭り】夏祭りいっしょまわろ～～～～：summer festival Mine Craft【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-29T13:02:34Z"
  },
  {
    "videoId": "gAAlSNY8p6s",
    "thumbnail": "https://i.ytimg.com/vi/gAAlSNY8p6s/mqdefault.jpg",
    "title": "【#ホロRUSTチーム戦 】銃をうつれんしゅう本番：RUST【ホロライブ/大空スバル】",
    "publishedAt": "2022-08-30T14:00:01Z"
  },
  {
    "videoId": "GBqR3Py852I",
    "thumbnail": "https://i.ytimg.com/vi/GBqR3Py852I/mqdefault.jpg",
    "title": "【#生スバル】コードギアス反逆のルルーシュ同時試聴：CODE GEASS Lelouch of the Rebellion【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-02T15:43:53Z"
  },
  {
    "videoId": "ST0v0nWMapY",
    "thumbnail": "https://i.ytimg.com/vi/ST0v0nWMapY/mqdefault.jpg",
    "title": "【#生スバル】復活のツイッター探偵！おはスバ雑談しゅばああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-03T02:09:14Z"
  },
  {
    "videoId": "dOP-OURGwnk",
    "thumbnail": "https://i.ytimg.com/vi/dOP-OURGwnk/mqdefault.jpg",
    "title": "【#9】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-09-03T11:11:16Z"
  },
  {
    "videoId": "xA2P4vnbemk",
    "thumbnail": "https://i.ytimg.com/vi/xA2P4vnbemk/mqdefault.jpg",
    "title": "【#10】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-09-04T09:25:01Z"
  },
  {
    "videoId": "mNMNvpo3pv4",
    "thumbnail": "https://i.ytimg.com/vi/mNMNvpo3pv4/mqdefault.jpg",
    "title": "【#生スバル】タイタンフォール２に思わせた雑談：Titanfall 2【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-06T14:26:19Z"
  },
  {
    "videoId": "sDLAJQDUsn8",
    "thumbnail": "https://i.ytimg.com/vi/sDLAJQDUsn8/mqdefault.jpg",
    "title": "【#生スバル】大空スバルは萌えてみたい：【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-07T11:05:49Z"
  },
  {
    "videoId": "AXMtC56Wc_c",
    "thumbnail": "https://i.ytimg.com/vi/AXMtC56Wc_c/mqdefault.jpg",
    "title": "【#生スバル】タイタンフォール２させてください：Titanfall 2【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-07T16:36:35Z"
  },
  {
    "videoId": "1WWY0adbEbc",
    "thumbnail": "https://i.ytimg.com/vi/1WWY0adbEbc/mqdefault.jpg",
    "title": "【#最終回】タイタンフォール２させてください：Titanfall 2【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-08T17:09:04Z"
  },
  {
    "videoId": "ZjkHqG5Nhmo",
    "thumbnail": "https://i.ytimg.com/vi/ZjkHqG5Nhmo/mqdefault.jpg",
    "title": "【#生スバル】コードギアス反逆のルルーシュ同時試聴：CODE GEASS Lelouch of the Rebellion【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-09T15:49:11Z"
  },
  {
    "videoId": "HurttQDjflo",
    "thumbnail": "https://i.ytimg.com/vi/HurttQDjflo/mqdefault.jpg",
    "title": "【#生スバル】謝罪会見スペシャル！！おはスバ雑談しゅばああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-10T02:07:34Z"
  },
  {
    "videoId": "iqVO12RbVT0",
    "thumbnail": "https://i.ytimg.com/vi/iqVO12RbVT0/mqdefault.jpg",
    "title": "【#11】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-09-10T09:53:03Z"
  },
  {
    "videoId": "eN5l09D0TXQ",
    "thumbnail": "https://i.ytimg.com/vi/eN5l09D0TXQ/mqdefault.jpg",
    "title": "【#12】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-09-11T10:58:41Z"
  },
  {
    "videoId": "4e7LRSB39mU",
    "thumbnail": "https://i.ytimg.com/vi/4e7LRSB39mU/mqdefault.jpg",
    "title": "【#生スバル】ほろきゅあ～～～～～～！！！！！！！！！！！！：holocure【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-13T15:16:47Z"
  },
  {
    "videoId": "aKigAkDrqBM",
    "thumbnail": "https://i.ytimg.com/vi/aKigAkDrqBM/mqdefault.jpg",
    "title": "【#生スバル】顕微鏡で月の石とかトリケラトプスの歯とかミオシャの猫の毛とかをみよう！！：Let's look at moonstones under the microscope!【大空スバル】",
    "publishedAt": "2022-09-14T14:41:01Z"
  },
  {
    "videoId": "o-V3-2PDknA",
    "thumbnail": "https://i.ytimg.com/vi/o-V3-2PDknA/mqdefault.jpg",
    "title": "【#最終回】コードギアス反逆のルルーシュ同時試聴：CODE GEASS Lelouch of the Rebellion【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-15T15:37:46Z"
  },
  {
    "videoId": "RRsw5tT8BJI",
    "thumbnail": "https://i.ytimg.com/vi/RRsw5tT8BJI/mqdefault.jpg",
    "title": "【オリジナル曲】ぷ・れ・あ・で・す！【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-16T12:05:13Z"
  },
  {
    "videoId": "193Z1QR7GhY",
    "thumbnail": "https://i.ytimg.com/vi/193Z1QR7GhY/mqdefault.jpg",
    "title": "【#大空スバル４周年】４周年ってマジ？！？！？！？！？！！？？！！？？！: oozorasubaru 4 anniversary【ホロライブ】",
    "publishedAt": "2022-09-16T12:05:53Z"
  },
  {
    "videoId": "NZIErVvjjFs",
    "thumbnail": "https://i.ytimg.com/vi/NZIErVvjjFs/mqdefault.jpg",
    "title": "【#13】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-09-17T11:39:39Z"
  },
  {
    "videoId": "uwmW5pxCSwQ",
    "thumbnail": "https://i.ytimg.com/vi/uwmW5pxCSwQ/mqdefault.jpg",
    "title": "【#14】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-09-18T10:56:37Z"
  },
  {
    "videoId": "cHxU5t4VWyI",
    "thumbnail": "https://i.ytimg.com/vi/cHxU5t4VWyI/mqdefault.jpg",
    "title": "【#生スバル】フリーやりたい放題雑談：Freedam free chat【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-20T13:52:08Z"
  },
  {
    "videoId": "9KvAxqwO524",
    "thumbnail": "https://i.ytimg.com/vi/9KvAxqwO524/mqdefault.jpg",
    "title": "【】 Song☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻☻sing【】",
    "publishedAt": "2022-09-21T12:17:56Z"
  },
  {
    "videoId": "zEhrRlv0CyQ",
    "thumbnail": "https://i.ytimg.com/vi/zEhrRlv0CyQ/mqdefault.jpg",
    "title": "【R2】コードギアス反逆のルルーシュR２同時試聴：CODE GEASS Lelouch of the Rebellion【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-23T15:51:39Z"
  },
  {
    "videoId": "68y7cwWW11U",
    "thumbnail": "https://i.ytimg.com/vi/68y7cwWW11U/mqdefault.jpg",
    "title": "【#生スバル】ディズニーシーに行ってきたぞ！！！おはスバ雑談しゅばああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-24T02:10:18Z"
  },
  {
    "videoId": "pke6yq1bi4Y",
    "thumbnail": "https://i.ytimg.com/vi/pke6yq1bi4Y/mqdefault.jpg",
    "title": "【#15】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-09-24T10:02:20Z"
  },
  {
    "videoId": "mdqvJeHzGMY",
    "thumbnail": "https://i.ytimg.com/vi/mdqvJeHzGMY/mqdefault.jpg",
    "title": "【#16】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-09-25T08:27:46Z"
  },
  {
    "videoId": "oUFZ7551X3c",
    "thumbnail": "https://i.ytimg.com/vi/oUFZ7551X3c/mqdefault.jpg",
    "title": "【#生スバル】祭壇？！痛バッグ？！自作グッズ？！！みんなのオタ活大集合しゅばあああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-27T14:00:34Z"
  },
  {
    "videoId": "UXvTyuxoeGc",
    "thumbnail": "https://i.ytimg.com/vi/UXvTyuxoeGc/mqdefault.jpg",
    "title": "【#生スバル】メタルスラッグするしゅばあああああああああああああああ！！！！：METAL SLUG【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-28T12:20:27Z"
  },
  {
    "videoId": "j4yVt0n1YPs",
    "thumbnail": "https://i.ytimg.com/vi/j4yVt0n1YPs/mqdefault.jpg",
    "title": "【R2】コードギアス反逆のルルーシュR２同時試聴：CODE GEASS Lelouch of the Rebellion【ホロライブ/大空スバル】",
    "publishedAt": "2022-09-30T13:45:03Z"
  },
  {
    "videoId": "mXN3jJyMMeo",
    "thumbnail": "https://i.ytimg.com/vi/mXN3jJyMMeo/mqdefault.jpg",
    "title": "【#生スバル】おはスバ雑談しゅばああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-10-01T02:11:05Z"
  },
  {
    "videoId": "SNUnCoMecww",
    "thumbnail": "https://i.ytimg.com/vi/SNUnCoMecww/mqdefault.jpg",
    "title": "【#17】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-10-01T10:09:20Z"
  },
  {
    "videoId": "Jueb2S53FHs",
    "thumbnail": "https://i.ytimg.com/vi/Jueb2S53FHs/mqdefault.jpg",
    "title": "【#18】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-10-02T08:59:25Z"
  },
  {
    "videoId": "B6TMSG_MaGQ",
    "thumbnail": "https://i.ytimg.com/vi/B6TMSG_MaGQ/mqdefault.jpg",
    "title": "【#今聞けホロライブ】今さら聞けない？！ホロライブ！！！みこミオスバ編【ホロライブ】",
    "publishedAt": "2022-10-04T12:12:45Z"
  },
  {
    "videoId": "UsUAxx7Sfb4",
    "thumbnail": "https://i.ytimg.com/vi/UsUAxx7Sfb4/mqdefault.jpg",
    "title": "【#ガーディアンテイルズ for NINTENDO SWITCH】世界1100万DL？！話題のドット絵アクションRPGをプレイしゅばあああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2022-10-05T12:06:48Z"
  },
  {
    "videoId": "X1lM2ch4uF8",
    "thumbnail": "https://i.ytimg.com/vi/X1lM2ch4uF8/mqdefault.jpg",
    "title": "【R2】コードギアス反逆のルルーシュR２同時試聴：CODE GEASS Lelouch of the Rebellion【ホロライブ/大空スバル】",
    "publishedAt": "2022-10-06T16:03:01Z"
  },
  {
    "videoId": "26mahROBKmk",
    "thumbnail": "https://i.ytimg.com/vi/26mahROBKmk/mqdefault.jpg",
    "title": "【#ホロスプラ部】スプラトゥーン３やるしゅばああああああああああああああああああああああああああああああああああああああ！！！！！！：Splatoon3【ホロライブ/大空スバル】",
    "publishedAt": "2022-10-07T14:03:19Z"
  },
  {
    "videoId": "d-epwhZHYuk",
    "thumbnail": "https://i.ytimg.com/vi/d-epwhZHYuk/mqdefault.jpg",
    "title": "【#生スバル】おはスバ雑談しゅばああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-10-08T02:20:30Z"
  },
  {
    "videoId": "DiZswm7tobw",
    "thumbnail": "https://i.ytimg.com/vi/DiZswm7tobw/mqdefault.jpg",
    "title": "【#19】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-10-08T11:27:25Z"
  },
  {
    "videoId": "SHFq56k4FCM",
    "thumbnail": "https://i.ytimg.com/vi/SHFq56k4FCM/mqdefault.jpg",
    "title": "【#生スバル】初見ガンエボするしゅばあああああああああああああああああああああああああ！！！！：GUNDAM EVOLUTION【ホロライブ/大空スバル】",
    "publishedAt": "2022-10-12T14:16:12Z"
  },
  {
    "videoId": "GSWCvww_LDE",
    "thumbnail": "https://i.ytimg.com/vi/GSWCvww_LDE/mqdefault.jpg",
    "title": "【#スバちょこルーナ】すばちょこるーなオフコラボ２周年しゅばあああああああああああああああ！！！！【ホロライブ】",
    "publishedAt": "2022-10-13T13:05:09Z"
  },
  {
    "videoId": "RTBfR3Nqx8w",
    "thumbnail": "https://i.ytimg.com/vi/RTBfR3Nqx8w/mqdefault.jpg",
    "title": "【#生スバル】おはスバ雑談しゅばああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-10-15T02:16:49Z"
  },
  {
    "videoId": "RH1CN_rM_A4",
    "thumbnail": "https://i.ytimg.com/vi/RH1CN_rM_A4/mqdefault.jpg",
    "title": "【#20】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-10-15T10:59:08Z"
  },
  {
    "videoId": "10RovHEKFK0",
    "thumbnail": "https://i.ytimg.com/vi/10RovHEKFK0/mqdefault.jpg",
    "title": "【#最終回？】ペルソナ４ザ・ゴールデンやるしゅばあああああああああああああああああああ！！！！：Persona4 The golden【ネタバレ有り】",
    "publishedAt": "2022-10-16T12:52:18Z"
  },
  {
    "videoId": "wGVnxsxUokU",
    "thumbnail": "https://i.ytimg.com/vi/wGVnxsxUokU/mqdefault.jpg",
    "title": "【#生スバル】ホ　ロ　ラ　イ　ブ　検　定【ホロライブ/大空スバル】",
    "publishedAt": "2022-10-19T14:00:52Z"
  },
  {
    "videoId": "cvWU1pP8-ls",
    "thumbnail": "https://i.ytimg.com/vi/cvWU1pP8-ls/mqdefault.jpg",
    "title": "【#生スバル】心拍数測定？！？地　獄　銭　湯【ホロライブ/大空スバル】",
    "publishedAt": "2022-10-20T14:33:30Z"
  },
  {
    "videoId": "wUEN1KE2ZcU",
    "thumbnail": "https://i.ytimg.com/vi/wUEN1KE2ZcU/mqdefault_live.jpg",
    "title": "【　】お知らせ掲示板【　】",
    "publishedAt": "2022-10-21T04:37:22Z"
  },
  {
    "videoId": "Wqb6c11joa4",
    "thumbnail": "https://i.ytimg.com/vi/Wqb6c11joa4/mqdefault.jpg",
    "title": "【R2】コードギアス反逆のルルーシュR２同時試聴：CODE GEASS Lelouch of the Rebellion【ホロライブ/大空スバル】",
    "publishedAt": "2022-10-21T15:30:38Z"
  },
  {
    "videoId": "4pyYxdhCiU0",
    "thumbnail": "https://i.ytimg.com/vi/4pyYxdhCiU0/mqdefault.jpg",
    "title": "【#生スバル】 初見NEEDY GIRL OVERDOSEするしゅばあああああああああああああああああ！！！！！/【ホロライブ/大空スバル】",
    "publishedAt": "2022-10-25T15:50:06Z"
  },
  {
    "videoId": "E2NoVyfZHl8",
    "thumbnail": "https://i.ytimg.com/vi/E2NoVyfZHl8/mqdefault.jpg",
    "title": "【最終回】コードギアス反逆のルルーシュR２同時試聴：CODE GEASS Lelouch of the Rebellion【ホロライブ/大空スバル】",
    "publishedAt": "2022-10-28T15:25:50Z"
  },
  {
    "videoId": "8iQFBPivaYM",
    "thumbnail": "https://i.ytimg.com/vi/8iQFBPivaYM/mqdefault.jpg",
    "title": "【#生スバル】JUDGE EYES：死神の遺言 Remasteredするしゅばあああああああああああああああああ！！！！！！【※ネタバレあり】",
    "publishedAt": "2022-10-30T09:58:22Z"
  },
  {
    "videoId": "PmsUIC-lnc8",
    "thumbnail": "https://i.ytimg.com/vi/PmsUIC-lnc8/mqdefault.jpg",
    "title": "【#黄組WIN】運動会練習するしゅばああああああああああああああああああ！！！！！：team yellow【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-01T12:14:49Z"
  },
  {
    "videoId": "-hbYeSy6dU0",
    "thumbnail": "https://i.ytimg.com/vi/-hbYeSy6dU0/mqdefault.jpg",
    "title": "【#生スバル】おやすみスバル：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-01T15:27:28Z"
  },
  {
    "videoId": "den-Hn1szMA",
    "thumbnail": "https://i.ytimg.com/vi/den-Hn1szMA/mqdefault.jpg",
    "title": "【#生スバル】あくありうむするしゅばああああああああああああああああああ！！！！！/【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-02T14:59:43Z"
  },
  {
    "videoId": "cU8P9Qg-IrU",
    "thumbnail": "https://i.ytimg.com/vi/cU8P9Qg-IrU/mqdefault.jpg",
    "title": "【#生スバル】TIGER & BUNNY 同時視聴会/ TIGER & BUNNY watch party!【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-04T15:14:48Z"
  },
  {
    "videoId": "UDG0u4qznU0",
    "thumbnail": "https://i.ytimg.com/vi/UDG0u4qznU0/mqdefault.jpg",
    "title": "【#生スバル】ゲスト有？！？運動会スペシャル！！！！！！おはスバ雑談しゅばあああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-05T02:10:33Z"
  },
  {
    "videoId": "4HoLwEKlstw",
    "thumbnail": "https://i.ytimg.com/vi/4HoLwEKlstw/mqdefault.jpg",
    "title": "【#2】JUDGE EYES：死神の遺言 Remasteredするしゅばあああああああああああああああああ！！！！！！【※ネタバレあり】",
    "publishedAt": "2022-11-05T09:41:38Z"
  },
  {
    "videoId": "Wh-RIZq3GMQ",
    "thumbnail": "https://i.ytimg.com/vi/Wh-RIZq3GMQ/mqdefault.jpg",
    "title": "【#生スバル】塊魂アンコールするしゅばああああああああああああああああああ！！！！：Katamari Damacy【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-08T12:19:35Z"
  },
  {
    "videoId": "GS8hzC-yXYg",
    "thumbnail": "https://i.ytimg.com/vi/GS8hzC-yXYg/mqdefault.jpg",
    "title": "【#生スバル】絶対にあくあを攻略したい あくありうむ。リベンジマッチしゅばあああああああああああ！！！/aquarium【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-09T15:32:30Z"
  },
  {
    "videoId": "1mraThzMXf8",
    "thumbnail": "https://i.ytimg.com/vi/1mraThzMXf8/mqdefault.jpg",
    "title": "【#生スバル】なんでもするスバル。万屋スバル！！！！！：I do everything！！！！ YOROZUYA Subaru！！！！！【】",
    "publishedAt": "2022-11-10T13:52:46Z"
  },
  {
    "videoId": "bppdgqxbyaE",
    "thumbnail": "https://i.ytimg.com/vi/bppdgqxbyaE/mqdefault.jpg",
    "title": "【#生スバル】TIGER & BUNNY 同時視聴会/ TIGER & BUNNY watch party!【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-11T15:26:12Z"
  },
  {
    "videoId": "wmMPY080gTw",
    "thumbnail": "https://i.ytimg.com/vi/wmMPY080gTw/mqdefault.jpg",
    "title": "【#生スバル】発表あり！！！！おはスバ雑談しゅばあああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-12T02:11:07Z"
  },
  {
    "videoId": "qm7ktppDi9g",
    "thumbnail": "https://i.ytimg.com/vi/qm7ktppDi9g/mqdefault.jpg",
    "title": "【#3】JUDGE EYES：死神の遺言 Remasteredするしゅばあああああああああああああああああ！！！！！！【※ネタバレあり】",
    "publishedAt": "2022-11-12T09:39:38Z"
  },
  {
    "videoId": "9vy3Dm5Bs4I",
    "thumbnail": "https://i.ytimg.com/vi/9vy3Dm5Bs4I/mqdefault.jpg",
    "title": "【カメラ枠】(拷問？)何か食べたら君の負け💛高カロリー限定深夜飯テロ【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-15T15:16:37Z"
  },
  {
    "videoId": "_w-0dqNjYvo",
    "thumbnail": "https://i.ytimg.com/vi/_w-0dqNjYvo/mqdefault.jpg",
    "title": "【#ミオみこスバ】ミオみこスバっと解決！！お悩み相談所！！！【ホロライブ】",
    "publishedAt": "2022-11-16T13:16:40Z"
  },
  {
    "videoId": "oQJIYvOtr9M",
    "thumbnail": "https://i.ytimg.com/vi/oQJIYvOtr9M/mqdefault.jpg",
    "title": "【#ノエスバ】ノエスバお泊り会【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-17T13:09:32Z"
  },
  {
    "videoId": "vM1wGPZDVfI",
    "thumbnail": "https://i.ytimg.com/vi/vM1wGPZDVfI/mqdefault.jpg",
    "title": "【#生スバル】TIGER & BUNNY 同時視聴会/ TIGER & BUNNY watch party!【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-18T15:45:30Z"
  },
  {
    "videoId": "5QsCks3QFFo",
    "thumbnail": "https://i.ytimg.com/vi/5QsCks3QFFo/mqdefault.jpg",
    "title": "【#生スバル】おはスバ雑談しゅばあああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-19T02:11:59Z"
  },
  {
    "videoId": "In5Mtsmt5Wg",
    "thumbnail": "https://i.ytimg.com/vi/In5Mtsmt5Wg/mqdefault.jpg",
    "title": "【#4】JUDGE EYES：死神の遺言 Remasteredするしゅばあああああああああああああああああ！！！！！！【※ネタバレあり】",
    "publishedAt": "2022-11-19T09:52:56Z"
  },
  {
    "videoId": "b-0boDo3zjM",
    "thumbnail": "https://i.ytimg.com/vi/b-0boDo3zjM/mqdefault.jpg",
    "title": "【#5】JUDGE EYES：死神の遺言 Remasteredするしゅばあああああああああああああああああ！！！！！！【※ネタバレあり】",
    "publishedAt": "2022-11-20T09:24:26Z"
  },
  {
    "videoId": "n6yep2gl1HY",
    "thumbnail": "https://i.ytimg.com/vi/n6yep2gl1HY/mqdefault.jpg",
    "title": "【#大空スバル４周年】新衣装お披露目！！！！！４周年ありがとうございました！！！！！！！！：NEW 3D COSTUME !!! 4th anniversary Live【ホロライブ】",
    "publishedAt": "2022-11-20T13:19:19Z"
  },
  {
    "videoId": "ZDDKXO6A_xM",
    "thumbnail": "https://i.ytimg.com/vi/ZDDKXO6A_xM/mqdefault.jpg",
    "title": "【#生スバル】4周年ライブ生誕秘話しゅばああああああああ！！！！",
    "publishedAt": "2022-11-22T12:13:00Z"
  },
  {
    "videoId": "0uj6A1SHK6w",
    "thumbnail": "https://i.ytimg.com/vi/0uj6A1SHK6w/mqdefault.jpg",
    "title": "【#生スバル】絶叫禁止？！？フブちゃんとThe back room 1998` するしゅばああああああああああああああ！！！！！/with Fubuki horror game【ホロライブ】",
    "publishedAt": "2022-11-24T12:09:24Z"
  },
  {
    "videoId": "EHOBFQBQu6c",
    "thumbnail": "https://i.ytimg.com/vi/EHOBFQBQu6c/mqdefault.jpg",
    "title": "【#生スバル】TIGER & BUNNY 同時視聴会/ TIGER & BUNNY watch party!【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-25T15:44:53Z"
  },
  {
    "videoId": "xzY35hvVD0I",
    "thumbnail": "https://i.ytimg.com/vi/xzY35hvVD0I/mqdefault.jpg",
    "title": "【#生スバル】おはしゅばああああああああああああ/OHASUBA Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-26T01:51:29Z"
  },
  {
    "videoId": "4K7TviAWW2Q",
    "thumbnail": "https://i.ytimg.com/vi/4K7TviAWW2Q/mqdefault.jpg",
    "title": "【#6】JUDGE EYES：死神の遺言 Remasteredするしゅばあああああああああああああああああ！！！！！！【※ネタバレあり】",
    "publishedAt": "2022-11-26T14:10:07Z"
  },
  {
    "videoId": "3kQpOdzRR-c",
    "thumbnail": "https://i.ytimg.com/vi/3kQpOdzRR-c/mqdefault.jpg",
    "title": "【若干カメラ枠】聖★ホロライブ女子高フリーダム雑談/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-29T12:04:03Z"
  },
  {
    "videoId": "zN3eBbfCWo4",
    "thumbnail": "https://i.ytimg.com/vi/zN3eBbfCWo4/mqdefault.jpg",
    "title": "【#生スバル】ずっとやりたかったポケモンやるしゅばああああああああああああああああああああああああああああ！！！！！/Pokémon Scarlet【ホロライブ/大空スバル】",
    "publishedAt": "2022-11-30T17:47:08Z"
  },
  {
    "videoId": "7iyjBQ5Rsfs",
    "thumbnail": "https://i.ytimg.com/vi/7iyjBQ5Rsfs/mqdefault.jpg",
    "title": "【#生スバル】TIGER & BUNNY 同時視聴会/ TIGER & BUNNY watch party!【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-02T15:19:04Z"
  },
  {
    "videoId": "k2WUwC1PaMs",
    "thumbnail": "https://i.ytimg.com/vi/k2WUwC1PaMs/mqdefault.jpg",
    "title": "【#生スバル】お客様ご来店？！？おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-03T02:46:16Z"
  },
  {
    "videoId": "K9E6bNQZDik",
    "thumbnail": "https://i.ytimg.com/vi/K9E6bNQZDik/mqdefault.jpg",
    "title": "【#7】JUDGE EYES：死神の遺言 Remasteredするしゅばあああああああああああああああああ！！！！！！【※ネタバレあり】",
    "publishedAt": "2022-12-03T10:12:54Z"
  },
  {
    "videoId": "SBSEP28EK7w",
    "thumbnail": "https://i.ytimg.com/vi/SBSEP28EK7w/mqdefault.jpg",
    "title": "【#8】JUDGE EYES：死神の遺言 Remasteredするしゅばあああああああああああああああああ！！！！！！【※ネタバレあり】",
    "publishedAt": "2022-12-04T10:37:47Z"
  },
  {
    "videoId": "LXkdPwK4sEQ",
    "thumbnail": "https://i.ytimg.com/vi/LXkdPwK4sEQ/mqdefault.jpg",
    "title": "【#2】ずっとやりたかったポケモンやるしゅばああああああああああああああああああああああああああああ！！！！！/Pokémon Scarlet【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-06T16:57:34Z"
  },
  {
    "videoId": "FyYpyHpH9vE",
    "thumbnail": "https://i.ytimg.com/vi/FyYpyHpH9vE/mqdefault.jpg",
    "title": "【#ババドナ】サクラ大戦～熱き血潮に～で遊んでみるしゅばあああああああああああああああああ！！！！！【※ネタバレあり】",
    "publishedAt": "2022-12-07T15:52:04Z"
  },
  {
    "videoId": "y4Kge5TGLyA",
    "thumbnail": "https://i.ytimg.com/vi/y4Kge5TGLyA/mqdefault.jpg",
    "title": "【視聴者参加】８　位　以　下　で　増　殖　マ　リ　オ　カ　ー　ト / Mario Kart with more Subaru in 8th place and below.【】",
    "publishedAt": "2022-12-09T11:03:24Z"
  },
  {
    "videoId": "f7l_oGe8VA4",
    "thumbnail": "https://i.ytimg.com/vi/f7l_oGe8VA4/mqdefault.jpg",
    "title": "【#最終回】TIGER & BUNNY 同時視聴会/ TIGER & BUNNY watch party!【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-09T14:54:02Z"
  },
  {
    "videoId": "t82V4OoIk7g",
    "thumbnail": "https://i.ytimg.com/vi/t82V4OoIk7g/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-10T02:09:52Z"
  },
  {
    "videoId": "4ZtNeT61nnw",
    "thumbnail": "https://i.ytimg.com/vi/4ZtNeT61nnw/mqdefault.jpg",
    "title": "【#生スバル】クライシス コア –ファイナルファンタジーVII- リユニオンするしゅばあああああああ！！！/CRISIS CORE -FINAL FANTASY VII- REUNION 【2章まで】",
    "publishedAt": "2022-12-10T07:39:04Z"
  },
  {
    "videoId": "CiiQ5Ol6iY0",
    "thumbnail": "https://i.ytimg.com/vi/CiiQ5Ol6iY0/mqdefault.jpg",
    "title": "【#最終回】JUDGE EYES：死神の遺言 Remasteredするしゅばあああああああああああああああああ！！！！！！【※ネタバレあり】",
    "publishedAt": "2022-12-11T04:26:18Z"
  },
  {
    "videoId": "6JPCqDuIPPE",
    "thumbnail": "https://i.ytimg.com/vi/6JPCqDuIPPE/mqdefault.jpg",
    "title": "【#最終回】JUDGE EYES：死神の遺言 Remasteredするしゅばあああああああああああああああああ！！！！！！【※ネタバレあり】",
    "publishedAt": "2022-12-11T09:11:08Z"
  },
  {
    "videoId": "OjVYtizH0ks",
    "thumbnail": "https://i.ytimg.com/vi/OjVYtizH0ks/mqdefault.jpg",
    "title": "【#3】ずっとやりたかったポケモンやるしゅばああああああああああああああああああああああああああああ！！！！！/Pokémon Scarlet【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-13T16:29:34Z"
  },
  {
    "videoId": "XojVrO1P9bg",
    "thumbnail": "https://i.ytimg.com/vi/XojVrO1P9bg/mqdefault.jpg",
    "title": "【#生スバル】JUDGE EYES：死神の遺言 Remastered　変　態　三　銃　士　イ　ベ　ン　ト　【※ネタバレあり】",
    "publishedAt": "2022-12-15T15:36:46Z"
  },
  {
    "videoId": "EfxMBsriR4o",
    "thumbnail": "https://i.ytimg.com/vi/EfxMBsriR4o/mqdefault.jpg",
    "title": "【視聴者参加】メガトン級ムサシXみんなでするしゅばああああああああああああああああああ！！！！！！：audience participation【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-16T11:07:39Z"
  },
  {
    "videoId": "VhoHFTrxdCc",
    "thumbnail": "https://i.ytimg.com/vi/VhoHFTrxdCc/mqdefault.jpg",
    "title": "【＃生スバル】ふりーだむ雑談！　風邪に気をつけようの巻 FreeeTalk【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-20T14:16:10Z"
  },
  {
    "videoId": "6_xcLeig6G8",
    "thumbnail": "https://i.ytimg.com/vi/6_xcLeig6G8/mqdefault.jpg",
    "title": "【#4】ずっとやりたかったポケモンやるしゅばああああああああああああああああああああああああああああ！！！！！/Pokémon Scarlet【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-21T15:24:35Z"
  },
  {
    "videoId": "cRS5-9QP-W4",
    "thumbnail": "https://i.ytimg.com/vi/cRS5-9QP-W4/mqdefault.jpg",
    "title": "【#映画回】TIGER & BUNNY 同時視聴会/ TIGER & BUNNY watch party!【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-22T13:19:08Z"
  },
  {
    "videoId": "Um9HWsNr6Qk",
    "thumbnail": "https://i.ytimg.com/vi/Um9HWsNr6Qk/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-24T02:14:35Z"
  },
  {
    "videoId": "ERilmwLQuPU",
    "thumbnail": "https://i.ytimg.com/vi/ERilmwLQuPU/mqdefault.jpg",
    "title": "【#スバおかクリスマス】クリスマスだ！！RPGだ！！！！！！！ライブアライブリメイクだ！！！！！！！！！！！：LIVE A LIVE【※ネタバレ有】",
    "publishedAt": "2022-12-24T11:24:18Z"
  },
  {
    "videoId": "J7msYQWvwPM",
    "thumbnail": "https://i.ytimg.com/vi/J7msYQWvwPM/mqdefault.jpg",
    "title": "【#スバおかクリスマス】クリスマスだ！！RPGだ！！！！！！！ライブアライブリメイクだ！！！！！！！！！！！：LIVE A LIVE【※ネタバレ有】",
    "publishedAt": "2022-12-25T13:40:55Z"
  },
  {
    "videoId": "BT--UK1M8hE",
    "thumbnail": "https://i.ytimg.com/vi/BT--UK1M8hE/mqdefault.jpg",
    "title": "【#5】ずっとやりたかったポケモンやるしゅばああああああああああああああああああああああああああああ！！！！！/Pokémon Scarlet【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-27T19:04:07Z"
  },
  {
    "videoId": "qyOXwlUspHg",
    "thumbnail": "https://i.ytimg.com/vi/qyOXwlUspHg/mqdefault.jpg",
    "title": "【＃生スバル】スバルの小屋　ゲスト：そら/Sora Suba Free Talk【ホロライブ】",
    "publishedAt": "2022-12-28T12:13:12Z"
  },
  {
    "videoId": "X5vPahVZMvY",
    "thumbnail": "https://i.ytimg.com/vi/X5vPahVZMvY/mqdefault.jpg",
    "title": "【＃ホロライブの壺】妖精さん達がお悩み解決！！！！！ホロライバーの主張！！！！！！！【ホロライブ】",
    "publishedAt": "2022-12-29T12:05:15Z"
  },
  {
    "videoId": "IEzLd0w55_8",
    "thumbnail": "https://i.ytimg.com/vi/IEzLd0w55_8/mqdefault.jpg",
    "title": "【＃ホロゾディア】１年に１度2期生コラボ: hololive 2nd collabo 【ホロライブ】",
    "publishedAt": "2022-12-29T14:21:33Z"
  },
  {
    "videoId": "ZaWtre_QPew",
    "thumbnail": "https://i.ytimg.com/vi/ZaWtre_QPew/mqdefault.jpg",
    "title": "【＃生スバル】大空スバルアワード2022：Oozora Subaru Award 2022【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-30T12:48:14Z"
  },
  {
    "videoId": "NJGOsk3Fkag",
    "thumbnail": "https://i.ytimg.com/vi/NJGOsk3Fkag/mqdefault.jpg",
    "title": "【＃生スバル】ガンソード同時視聴会しゅばああああああああああああああ：GUN×SWORD watch party【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-30T15:15:58Z"
  },
  {
    "videoId": "JuRZNsVqDOg",
    "thumbnail": "https://i.ytimg.com/vi/JuRZNsVqDOg/mqdefault.jpg",
    "title": "【#生スバル】良いお年をおはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2022-12-31T03:56:13Z"
  },
  {
    "videoId": "Z9c6H_RhJ9o",
    "thumbnail": "https://i.ytimg.com/vi/Z9c6H_RhJ9o/mqdefault.jpg",
    "title": "【＃生スバル】新年一発目のご挨拶？！？！？告知なし人徳凸待ちしゅばあああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-01T15:06:06Z"
  },
  {
    "videoId": "IgTHshqyQT4",
    "thumbnail": "https://i.ytimg.com/vi/IgTHshqyQT4/mqdefault.jpg",
    "title": "【#ホロライブレトロゲーム部】正月だ！！RPGだ！！！！！！！ライブアライブリメイクだ！！！！！！近未来編だ！！！！！：LIVE A LIVE【※ネタバレ有】",
    "publishedAt": "2023-01-03T08:45:15Z"
  },
  {
    "videoId": "N3n46Y70Zc4",
    "thumbnail": "https://i.ytimg.com/vi/N3n46Y70Zc4/mqdefault.jpg",
    "title": "【#6】ずっとやりたかったポケモンやるしゅばああああああああああああああああああああああああああああ！！！！！/Pokémon Scarlet【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-05T16:51:20Z"
  },
  {
    "videoId": "nE5fNmlLQ4E",
    "thumbnail": "https://i.ytimg.com/vi/nE5fNmlLQ4E/mqdefault.jpg",
    "title": "【閲覧注意】大　会　前　日　増　殖　マ　リ　オ　カ　ー　ト / Mario Kart with more Subaru in 8th place and below.【】",
    "publishedAt": "2023-01-06T12:13:00Z"
  },
  {
    "videoId": "RkFSzRWAuwM",
    "thumbnail": "https://i.ytimg.com/vi/RkFSzRWAuwM/mqdefault.jpg",
    "title": "【＃生スバル】ガンソード同時視聴会しゅばああああああああああああああ：GUN×SWORD watch party【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-06T13:44:44Z"
  },
  {
    "videoId": "FBax7qdGG_k",
    "thumbnail": "https://i.ytimg.com/vi/FBax7qdGG_k/mqdefault.jpg",
    "title": "【#生スバル】新年１発目は新表情公開？！？おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-07T03:09:11Z"
  },
  {
    "videoId": "23IsrR71Nc0",
    "thumbnail": "https://i.ytimg.com/vi/23IsrR71Nc0/mqdefault.jpg",
    "title": "【#ホロお正月CUP2023】いよいよお正月CUP本番！！！！頑張るしゅばあああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-07T07:28:14Z"
  },
  {
    "videoId": "l1i8PSCp2w0",
    "thumbnail": "https://i.ytimg.com/vi/l1i8PSCp2w0/mqdefault.jpg",
    "title": "【#ホロお正月CUP2023】いよいよお正月CUP本戦！！！！頑張るしゅばあああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-07T09:00:17Z"
  },
  {
    "videoId": "tvhPYJcSj5I",
    "thumbnail": "https://i.ytimg.com/vi/tvhPYJcSj5I/mqdefault.jpg",
    "title": "【＃生スバル】ガンソード同時視聴会しゅばああああああああああああああ：GUN×SWORD watch party【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-07T12:55:51Z"
  },
  {
    "videoId": "iOry4yS1SRw",
    "thumbnail": "https://i.ytimg.com/vi/iOry4yS1SRw/mqdefault.jpg",
    "title": "【＃生スバル】つぐのひ新作！！！バイトリーダー大空スバルしゅばあああああああああああああああああ！！！！：horror game【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-08T18:02:49Z"
  },
  {
    "videoId": "_BVhj4jAScg",
    "thumbnail": "https://i.ytimg.com/vi/_BVhj4jAScg/mqdefault.jpg",
    "title": "【#常mos 】常　M　O　S　大　富　豪　バ　ト　ル /Career Poker【ホロライブ】",
    "publishedAt": "2023-01-10T12:33:40Z"
  },
  {
    "videoId": "c61elwTbz0E",
    "thumbnail": "https://i.ytimg.com/vi/c61elwTbz0E/mqdefault.jpg",
    "title": "【＃生スバル】GeoGuessrの奇才、大空スバルしゅばあああああああああああああああああああああああああ！！！！！！（日本限定）【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-12T12:09:54Z"
  },
  {
    "videoId": "lYbhYxJl6p8",
    "thumbnail": "https://i.ytimg.com/vi/lYbhYxJl6p8/mqdefault.jpg",
    "title": "【#7】ずっとやりたかったポケモンやるしゅばああああああああああああああああああああああああああああ！！！！！/Pokémon Scarlet【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-12T17:59:56Z"
  },
  {
    "videoId": "Frcbtev_PvY",
    "thumbnail": "https://i.ytimg.com/vi/Frcbtev_PvY/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-14T03:15:43Z"
  },
  {
    "videoId": "NAny_01xLzc",
    "thumbnail": "https://i.ytimg.com/vi/NAny_01xLzc/mqdefault.jpg",
    "title": "【#ホロライブレトロゲーム部】正月だ！！RPGだ！！！！！！！ライブアライブリメイクだ！！！！！！中世編だ！！！！！：LIVE A LIVE【※ネタバレ有】",
    "publishedAt": "2023-01-14T09:21:34Z"
  },
  {
    "videoId": "bN755bCir7I",
    "thumbnail": "https://i.ytimg.com/vi/bN755bCir7I/mqdefault.jpg",
    "title": "【#8】ずっとやりたかったポケモンやるしゅばああああああああああああああああああああああああああああ！！！：レジェンドルートクリア回/Pokémon Scarlet【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-15T12:06:55Z"
  },
  {
    "videoId": "KeXVEVbYXJI",
    "thumbnail": "https://i.ytimg.com/vi/KeXVEVbYXJI/mqdefault.jpg",
    "title": "【＃生スバル】ありったけの夢！！！ワンピーススクラッチで新年運試ししゅばああああああああああああああああああああああああああ！！！：Scratch cards【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-17T13:00:51Z"
  },
  {
    "videoId": "UpJn5YTpYvo",
    "thumbnail": "https://i.ytimg.com/vi/UpJn5YTpYvo/mqdefault.jpg",
    "title": "【＃スバルの小屋】スバルの小屋　ゲスト：AZKiちゃん！/AZKi Suba Free Talk【ホロライブ】【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-18T12:18:22Z"
  },
  {
    "videoId": "xrfkxQdspBQ",
    "thumbnail": "https://i.ytimg.com/vi/xrfkxQdspBQ/mqdefault.jpg",
    "title": "【#超速GP3周年】ミニ四駆超速グランプリで大暴れしゅばああああああああああああああああ！！！！：:MINI 4WD HYPER DASH GRAND PRIX【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-19T11:30:28Z"
  },
  {
    "videoId": "QHyL5eFdjM0",
    "thumbnail": "https://i.ytimg.com/vi/QHyL5eFdjM0/mqdefault.jpg",
    "title": "【#生スバル】ホロ共通テストするしゅばああああああああああああああああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-19T15:48:47Z"
  },
  {
    "videoId": "VU2K_IXn-TI",
    "thumbnail": "https://i.ytimg.com/vi/VU2K_IXn-TI/mqdefault.jpg",
    "title": "【＃生スバル】ガンソード同時視聴会しゅばああああああああああああああ：GUN×SWORD watch party【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-20T15:50:02Z"
  },
  {
    "videoId": "A2a920mQ0Rs",
    "thumbnail": "https://i.ytimg.com/vi/A2a920mQ0Rs/mqdefault.jpg",
    "title": "【#生スバル】３D新衣装お家３D！おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-21T02:17:47Z"
  },
  {
    "videoId": "44VqJr1rxtg",
    "thumbnail": "https://i.ytimg.com/vi/44VqJr1rxtg/mqdefault.jpg",
    "title": "【#最終回？】ずっとやりたかったポケモンやるしゅばああああああああああああああああああああああああああああ！！！四天王撃破＆パルデアの大穴/Pokémon Scarlet【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-21T12:21:24Z"
  },
  {
    "videoId": "IB0pfmOkCmE",
    "thumbnail": "https://i.ytimg.com/vi/IB0pfmOkCmE/mqdefault.jpg",
    "title": "【#ホロライブレトロゲーム部】ライブアライブリメイクだ！！！！！！最終回だ！！！！！：LIVE A LIVE【※ネタバレ有】",
    "publishedAt": "2023-01-22T12:16:00Z"
  },
  {
    "videoId": "p8zzL7zgx6Q",
    "thumbnail": "https://i.ytimg.com/vi/p8zzL7zgx6Q/mqdefault.jpg",
    "title": "【＃生スバル】おさんぽスバル/MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-24T15:17:46Z"
  },
  {
    "videoId": "ZEgqraEAfOc",
    "thumbnail": "https://i.ytimg.com/vi/ZEgqraEAfOc/mqdefault.jpg",
    "title": "【＃生スバル】ポルカに布教してもらった十三機兵防衛圏をプレイしてみるしゅばああああああああああああああああああ！！！！：13 Sentinels: Aegis Rim【ネタバレあり】",
    "publishedAt": "2023-01-26T17:33:14Z"
  },
  {
    "videoId": "eWRwoOWX28M",
    "thumbnail": "https://i.ytimg.com/vi/eWRwoOWX28M/mqdefault.jpg",
    "title": "【GeoGuessr】ぺこらチームVSスバルチームでジオゲッサー勝負！！！！！！！しゅば！【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-27T14:00:25Z"
  },
  {
    "videoId": "QtbpN86qRxk",
    "thumbnail": "https://i.ytimg.com/vi/QtbpN86qRxk/mqdefault.jpg",
    "title": "【＃生スバル】ガンソード同時視聴会しゅばああああああああああああああ：GUN×SWORD watch party【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-27T15:36:19Z"
  },
  {
    "videoId": "ZHGYq7PFxCc",
    "thumbnail": "https://i.ytimg.com/vi/ZHGYq7PFxCc/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-28T02:14:26Z"
  },
  {
    "videoId": "KYFGtecz0RY",
    "thumbnail": "https://i.ytimg.com/vi/KYFGtecz0RY/mqdefault.jpg",
    "title": "【#ガチ最終回】ずっとやりたかったポケモンやるしゅばああああああああああああああああああああああああああああ！！！真エンディング/Pokémon Scarlet【ホロライブ/大空スバル】",
    "publishedAt": "2023-01-28T11:30:21Z"
  },
  {
    "videoId": "AtehpQzkuNQ",
    "thumbnail": "https://i.ytimg.com/vi/AtehpQzkuNQ/mqdefault.jpg",
    "title": "【#2】ポルカに布教してもらった十三機兵防衛圏をプレイしてみるしゅばああああああああああああああああああ！！！！：13 Sentinels: Aegis Rim【ネタバレあり】",
    "publishedAt": "2023-01-29T10:14:15Z"
  },
  {
    "videoId": "C8WU__KYRSw",
    "thumbnail": "https://i.ytimg.com/vi/C8WU__KYRSw/mqdefault.jpg",
    "title": "【#超速GP3周年】視聴者対戦？！ミニ四駆 超速グランプリでスバルーナ対決しゅばあああああああああああああああああ！！！！/MINI 4WD HYPER DASH GRAND PRIX【ホロライブ】",
    "publishedAt": "2023-02-02T12:32:21Z"
  },
  {
    "videoId": "9jAvReB_6xA",
    "thumbnail": "https://i.ytimg.com/vi/9jAvReB_6xA/mqdefault.jpg",
    "title": "【＃生スバル】初見！！！！東方風神録しゅばあああああああああああああああああ？！？！？？！【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-03T12:25:23Z"
  },
  {
    "videoId": "sYJrfqhOKkk",
    "thumbnail": "https://i.ytimg.com/vi/sYJrfqhOKkk/mqdefault.jpg",
    "title": "【＃生スバル】ガンソード同時視聴会しゅばああああああああああああああ：GUN×SWORD watch party【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-03T15:21:57Z"
  },
  {
    "videoId": "PyU_pqrhLy0",
    "thumbnail": "https://i.ytimg.com/vi/PyU_pqrhLy0/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-04T02:14:27Z"
  },
  {
    "videoId": "JQI3T5YfCRo",
    "thumbnail": "https://i.ytimg.com/vi/JQI3T5YfCRo/mqdefault.jpg",
    "title": "【#3】ポルカに布教してもらった十三機兵防衛圏をプレイしてみるしゅばああああああああああああああああああ！！！！：13 Sentinels: Aegis Rim【ネタバレあり】",
    "publishedAt": "2023-02-04T08:49:46Z"
  },
  {
    "videoId": "wKk7sG0Ygic",
    "thumbnail": "https://i.ytimg.com/vi/wKk7sG0Ygic/mqdefault.jpg",
    "title": "【#4】ポルカに布教してもらった十三機兵防衛圏をプレイしてみるしゅばああああああああああああああああああ！！！！：13 Sentinels: Aegis Rim【ネタバレあり】",
    "publishedAt": "2023-02-05T10:38:12Z"
  },
  {
    "videoId": "oCXeDh41WEo",
    "thumbnail": "https://i.ytimg.com/vi/oCXeDh41WEo/mqdefault.jpg",
    "title": "【＃生スバル】初見！！！人生初アーマードコアフォーアンサーやってみるしゅばああああああああああああああああ！！！！！！：ARMORED CORE for Answer【ネタバレあり】",
    "publishedAt": "2023-02-07T14:05:33Z"
  },
  {
    "videoId": "lxGpknC6Yhw",
    "thumbnail": "https://i.ytimg.com/vi/lxGpknC6Yhw/mqdefault.jpg",
    "title": "【＃生スバル】ホグワーツレガシーやるしゅばあああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-08T15:01:54Z"
  },
  {
    "videoId": "PGmckmZYI2Y",
    "thumbnail": "https://i.ytimg.com/vi/PGmckmZYI2Y/mqdefault.jpg",
    "title": "【＃生スバル】東方クリアしたい大空すばるしゅばあああああああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-09T16:48:01Z"
  },
  {
    "videoId": "KHkVMqcGRUE",
    "thumbnail": "https://i.ytimg.com/vi/KHkVMqcGRUE/mqdefault.jpg",
    "title": "【＃最終回】ガンソード同時視聴会しゅばああああああああああああああ：GUN×SWORD watch party【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-10T15:26:54Z"
  },
  {
    "videoId": "TxuZlaB3FZY",
    "thumbnail": "https://i.ytimg.com/vi/TxuZlaB3FZY/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-11T02:11:30Z"
  },
  {
    "videoId": "08Gmq5YF0NM",
    "thumbnail": "https://i.ytimg.com/vi/08Gmq5YF0NM/mqdefault.jpg",
    "title": "【#5】ポルカに布教してもらった十三機兵防衛圏をプレイしてみるしゅばああああああああああああああああああ！！！！：13 Sentinels: Aegis Rim【ネタバレあり】",
    "publishedAt": "2023-02-11T10:13:15Z"
  },
  {
    "videoId": "zuBbagH1_7k",
    "thumbnail": "https://i.ytimg.com/vi/zuBbagH1_7k/mqdefault.jpg",
    "title": "【#6】ポルカに布教してもらった十三機兵防衛圏をプレイしてみるしゅばああああああああああああああああああ！！！！：13 Sentinels: Aegis Rim【ネタバレあり】",
    "publishedAt": "2023-02-12T09:59:11Z"
  },
  {
    "videoId": "kGCJuuSFpbM",
    "thumbnail": "https://i.ytimg.com/vi/kGCJuuSFpbM/mqdefault.jpg",
    "title": "【＃生スバル】大空警察2023～！OOZORA POLICE2023【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-13T13:54:50Z"
  },
  {
    "videoId": "4dGyYniQE4I",
    "thumbnail": "https://i.ytimg.com/vi/4dGyYniQE4I/mqdefault.jpg",
    "title": "【＃生スバル】あの人が大空スバルをプロデュース？！？！バレンタインASMRしゅばああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-14T14:14:52Z"
  },
  {
    "videoId": "xjNDDJFJugE",
    "thumbnail": "https://i.ytimg.com/vi/xjNDDJFJugE/mqdefault.jpg",
    "title": "【＃生スバル】HoloCureやるしゅばあああああああああああああああああああああああああああああああああ！！！！！！：Holo Cure【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-15T16:48:09Z"
  },
  {
    "videoId": "iuCzwXnsAb8",
    "thumbnail": "https://i.ytimg.com/vi/iuCzwXnsAb8/mqdefault.jpg",
    "title": "【＃生スバル】人生初ジョジョ見てみるしゅばあああああああああああああああああああ！！！！！：watching party JOJO【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-17T15:31:43Z"
  },
  {
    "videoId": "wqrcU_Qp_l8",
    "thumbnail": "https://i.ytimg.com/vi/wqrcU_Qp_l8/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-18T02:28:39Z"
  },
  {
    "videoId": "a7ENIcXK_iY",
    "thumbnail": "https://i.ytimg.com/vi/a7ENIcXK_iY/mqdefault.jpg",
    "title": "【#7】ポルカに布教してもらった十三機兵防衛圏をプレイしてみるしゅばああああああああああああああああああ！！！！：13 Sentinels: Aegis Rim【ネタバレあり】",
    "publishedAt": "2023-02-18T09:10:13Z"
  },
  {
    "videoId": "UyDj_B8bBxQ",
    "thumbnail": "https://i.ytimg.com/vi/UyDj_B8bBxQ/mqdefault.jpg",
    "title": "【#8】ポルカに布教してもらった十三機兵防衛圏をプレイしてみるしゅばああああああああああああああああああ！！！！：13 Sentinels: Aegis Rim【ネタバレあり】",
    "publishedAt": "2023-02-19T09:04:20Z"
  },
  {
    "videoId": "BUUh92PozDM",
    "thumbnail": "https://i.ytimg.com/vi/BUUh92PozDM/mqdefault.jpg",
    "title": "【＃生スバル】モニターがぶっ壊れたからマシュマロたべるにゃん♡♡ヤケクソです【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-22T15:39:35Z"
  },
  {
    "videoId": "d9V_BwdYXh0",
    "thumbnail": "https://i.ytimg.com/vi/d9V_BwdYXh0/mqdefault.jpg",
    "title": "【＃生スバル】お散歩するしゅばああああああああああああああああああああああああああ！！！！！！！/MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-23T14:20:04Z"
  },
  {
    "videoId": "VUZnQPtt794",
    "thumbnail": "https://i.ytimg.com/vi/VUZnQPtt794/mqdefault.jpg",
    "title": "【＃生スバル】人生初ジョジョ見てみるしゅばあああああああああああああああああああ！！！！！：watching party JOJO【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-24T14:12:43Z"
  },
  {
    "videoId": "nL8TjxJiLn0",
    "thumbnail": "https://i.ytimg.com/vi/nL8TjxJiLn0/mqdefault.jpg",
    "title": "【＃生スバル】人生初ジョジョ見てみるしゅばあああああああああああああああああああ！！！！！：watching party JOJO【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-24T15:45:51Z"
  },
  {
    "videoId": "BpCqb2zQiM4",
    "thumbnail": "https://i.ytimg.com/vi/BpCqb2zQiM4/mqdefault.jpg",
    "title": "【#9】ポルカに布教してもらった十三機兵防衛圏をプレイしてみるしゅばああああああああああああああああああ！！！！：13 Sentinels: Aegis Rim【ネタバレあり】",
    "publishedAt": "2023-02-25T10:05:01Z"
  },
  {
    "videoId": "T9z-ykDQkU4",
    "thumbnail": "https://i.ytimg.com/vi/T9z-ykDQkU4/mqdefault.jpg",
    "title": "【#最終回】ポルカに布教してもらった十三機兵防衛圏をプレイしてみるしゅばああああああああああああああああああ！！！！：13 Sentinels: Aegis Rim【ネタバレあり】",
    "publishedAt": "2023-02-26T11:50:51Z"
  },
  {
    "videoId": "-7gl7GWoJzE",
    "thumbnail": "https://i.ytimg.com/vi/-7gl7GWoJzE/mqdefault.jpg",
    "title": "【#陰の実力者になりたくて】陰の実力者になりたくて！見てみるしゅばあああああああ！！！！：The Eminence in Shadow 3. watching party!【ホロライブ/大空スバル】",
    "publishedAt": "2023-02-28T12:03:00Z"
  },
  {
    "videoId": "LnWpniDikzg",
    "thumbnail": "https://i.ytimg.com/vi/LnWpniDikzg/mqdefault.jpg",
    "title": "【#1ブロSMOK】１ブロックからはじまる、SMOK生活#03 /MINECRAFT【ホロライブ】",
    "publishedAt": "2023-03-01T16:10:39Z"
  },
  {
    "videoId": "UuwK0TWxF-k",
    "thumbnail": "https://i.ytimg.com/vi/UuwK0TWxF-k/mqdefault.jpg",
    "title": "【#ホロライブポンコツ麻雀部】ホロライブ初心者カオス麻雀【ホロライブ/大空スバル枠】",
    "publishedAt": "2023-03-02T12:38:34Z"
  },
  {
    "videoId": "uAnBsm7tBs4",
    "thumbnail": "https://i.ytimg.com/vi/uAnBsm7tBs4/mqdefault.jpg",
    "title": "【＃生スバル】人生初ジョジョ見てみるしゅばあああああああああああああああああああ！！！！！：watching party JOJO【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-03T15:05:41Z"
  },
  {
    "videoId": "dP5hHJ4irEQ",
    "thumbnail": "https://i.ytimg.com/vi/dP5hHJ4irEQ/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-04T02:20:28Z"
  },
  {
    "videoId": "Lwn5h4evXBE",
    "thumbnail": "https://i.ytimg.com/vi/Lwn5h4evXBE/mqdefault.jpg",
    "title": "【＃生スバル】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-04T10:29:00Z"
  },
  {
    "videoId": "F5nG51DXVCM",
    "thumbnail": "https://i.ytimg.com/vi/F5nG51DXVCM/mqdefault.jpg",
    "title": "【＃2】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-05T11:05:18Z"
  },
  {
    "videoId": "tMnDul9mnsw",
    "thumbnail": "https://i.ytimg.com/vi/tMnDul9mnsw/mqdefault.jpg",
    "title": "【#生スバル】#歌枠から逃げるな！　：sing song【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-08T12:10:58Z"
  },
  {
    "videoId": "ROWmAL5fW0E",
    "thumbnail": "https://i.ytimg.com/vi/ROWmAL5fW0E/mqdefault.jpg",
    "title": "【#L5vision】レベルファイブ 新作発表会みるしゅばあああああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-09T11:38:19Z"
  },
  {
    "videoId": "vep5k-IT3rc",
    "thumbnail": "https://i.ytimg.com/vi/vep5k-IT3rc/mqdefault.jpg",
    "title": "【＃生スバル】お散歩するしゅばああああああああああああああああああああああああああ！！！！！！！/MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-09T15:37:56Z"
  },
  {
    "videoId": "IKk6ow0d1pk",
    "thumbnail": "https://i.ytimg.com/vi/IKk6ow0d1pk/mqdefault.jpg",
    "title": "【＃生スバル】お散歩するしゅばああああああああああああああああああああああああああ！！！！！！！/MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-10T13:09:33Z"
  },
  {
    "videoId": "_lkxK67WWwA",
    "thumbnail": "https://i.ytimg.com/vi/_lkxK67WWwA/mqdefault.jpg",
    "title": "【＃生スバル】人生初ジョジョ見てみるしゅばあああああああああああああああああああ！！！！！：watching party JOJO【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-10T15:28:09Z"
  },
  {
    "videoId": "oUrg1mfGzRo",
    "thumbnail": "https://i.ytimg.com/vi/oUrg1mfGzRo/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-11T02:17:09Z"
  },
  {
    "videoId": "9_0GMtzGRrg",
    "thumbnail": "https://i.ytimg.com/vi/9_0GMtzGRrg/mqdefault.jpg",
    "title": "【＃3 】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空ス バル】",
    "publishedAt": "2023-03-11T10:01:37Z"
  },
  {
    "videoId": "EZypYJVllWk",
    "thumbnail": "https://i.ytimg.com/vi/EZypYJVllWk/mqdefault.jpg",
    "title": "【＃4 】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空ス バル】",
    "publishedAt": "2023-03-12T10:29:33Z"
  },
  {
    "videoId": "fp6l92a0oXQ",
    "thumbnail": "https://i.ytimg.com/vi/fp6l92a0oXQ/mqdefault.jpg",
    "title": "【＃1】バイオハザード HDリマスターするしゅばああああああああああああああああああああああああああああ！！！！！！！ /  biohazard　HD REMASTER【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-14T15:14:36Z"
  },
  {
    "videoId": "guVvCCkAhFQ",
    "thumbnail": "https://i.ytimg.com/vi/guVvCCkAhFQ/mqdefault.jpg",
    "title": "【＃2】バイオハザード HDリマスターするしゅばああああああああああああああああああああああああああああ！！！！！！！ /  biohazard　HD REMASTER【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-15T16:14:42Z"
  },
  {
    "videoId": "wENQ8I5KRQw",
    "thumbnail": "https://i.ytimg.com/vi/wENQ8I5KRQw/mqdefault.jpg",
    "title": "【#1ブロSMOK】１ブロックからはじまる、SMOK生活#最終回？ /MINECRAFT【ホロライブ】",
    "publishedAt": "2023-03-16T13:52:23Z"
  },
  {
    "videoId": "kQx-UrkMsKA",
    "thumbnail": "https://i.ytimg.com/vi/kQx-UrkMsKA/mqdefault.jpg",
    "title": "【＃生スバル】ライブ感想枠しゅばあああああああああああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-19T14:03:17Z"
  },
  {
    "videoId": "V8hT4eil708",
    "thumbnail": "https://i.ytimg.com/vi/V8hT4eil708/mqdefault.jpg",
    "title": "【＃生スバル】人生初ジョジョ見てみるしゅばあああああああああああああああああああ！！！！！：watching party JOJO【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-19T17:13:22Z"
  },
  {
    "videoId": "UaOp96sVEsg",
    "thumbnail": "https://i.ytimg.com/vi/UaOp96sVEsg/mqdefault.jpg",
    "title": "【＃生スバル】お散歩するしゅばああああああああああああああああああああああああああ！！！！！！！/MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-21T16:04:22Z"
  },
  {
    "videoId": "puNX_86hAM0",
    "thumbnail": "https://i.ytimg.com/vi/puNX_86hAM0/mqdefault.jpg",
    "title": "【＃3】バイオハザード HDリマスターするしゅばああああああああああああああああああああああああああああ！！！！！！！ /  biohazard　HD REMASTER【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-22T15:25:39Z"
  },
  {
    "videoId": "HwjyF3CWt2Y",
    "thumbnail": "https://i.ytimg.com/vi/HwjyF3CWt2Y/mqdefault.jpg",
    "title": "【#生スバル】スバルとサシで深夜ラーメン行かん？？？？？？？？？？？？怖くないよ【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-23T12:14:35Z"
  },
  {
    "videoId": "1ZrIb0DEmnY",
    "thumbnail": "https://i.ytimg.com/vi/1ZrIb0DEmnY/mqdefault.jpg",
    "title": "【＃２部最終回】人生初ジョジョ見てみるしゅばあああああああああああああああああああ！！！！！：watching party JOJO【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-24T15:02:49Z"
  },
  {
    "videoId": "KK4Hnoes_dI",
    "thumbnail": "https://i.ytimg.com/vi/KK4Hnoes_dI/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-25T02:16:36Z"
  },
  {
    "videoId": "dgIMqIs8gRg",
    "thumbnail": "https://i.ytimg.com/vi/dgIMqIs8gRg/mqdefault.jpg",
    "title": "【＃5】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空ス バル】",
    "publishedAt": "2023-03-25T08:58:22Z"
  },
  {
    "videoId": "FXdVvDXLjU4",
    "thumbnail": "https://i.ytimg.com/vi/FXdVvDXLjU4/mqdefault.jpg",
    "title": "【＃4】アチアチバイオハザード HDリマスターするしゅばああああああああああああああああああああああああ！！！！！！！ /  biohazard　HD REMASTER【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-29T17:09:58Z"
  },
  {
    "videoId": "pyn_4RYyiR0",
    "thumbnail": "https://i.ytimg.com/vi/pyn_4RYyiR0/mqdefault.jpg",
    "title": "【物理３０点】 Q REMASTEREDするしゅばああああああああああああああああああああああああああああああああああああ！！！！！/Q REMASTERED【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-30T13:55:01Z"
  },
  {
    "videoId": "kRDhErdUp8s",
    "thumbnail": "https://i.ytimg.com/vi/kRDhErdUp8s/mqdefault.jpg",
    "title": "【＃生スバル】コマンドー同時視聴しゅばああああああああああああああああああああああ！！！！！：Commando watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-03-31T15:18:04Z"
  },
  {
    "videoId": "o94aTV_YvFk",
    "thumbnail": "https://i.ytimg.com/vi/o94aTV_YvFk/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-01T02:16:53Z"
  },
  {
    "videoId": "zCaE2JfzhRs",
    "thumbnail": "https://i.ytimg.com/vi/zCaE2JfzhRs/mqdefault.jpg",
    "title": "【＃6】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空ス バル】",
    "publishedAt": "2023-04-01T10:06:22Z"
  },
  {
    "videoId": "KFY3QyYWb2Q",
    "thumbnail": "https://i.ytimg.com/vi/KFY3QyYWb2Q/mqdefault.jpg",
    "title": "【＃7】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空ス バル】",
    "publishedAt": "2023-04-02T10:40:33Z"
  },
  {
    "videoId": "Qrk_7-OWftM",
    "thumbnail": "https://i.ytimg.com/vi/Qrk_7-OWftM/mqdefault.jpg",
    "title": "【＃最終回？】アチアチバイオハザード HDリマスターするしゅばああああああああああああああああああああああああ！！！！！！！ / biohazard　HD REMASTER【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-04T18:24:19Z"
  },
  {
    "videoId": "zS4mZxMasCE",
    "thumbnail": "https://i.ytimg.com/vi/zS4mZxMasCE/mqdefault.jpg",
    "title": "【＃スバころ】あらよ～～～～VSしゅば！！！！！！！！！ぷよテトコラボ/Puyo Puyo Tetris【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-05T12:15:53Z"
  },
  {
    "videoId": "UQv3jMMU0M0",
    "thumbnail": "https://i.ytimg.com/vi/UQv3jMMU0M0/mqdefault.jpg",
    "title": "【＃生スバル】お散歩するしゅばああああああああああああああああああああああああああ！！！！！！！/MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-05T16:39:02Z"
  },
  {
    "videoId": "2VuviBCZKVM",
    "thumbnail": "https://i.ytimg.com/vi/2VuviBCZKVM/mqdefault.jpg",
    "title": "【＃スバルの小屋】スバルの小屋　ゲスト：WATAMEちゃん！/WATAME Suba Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-06T13:14:38Z"
  },
  {
    "videoId": "_yn-9k6o_I8",
    "thumbnail": "https://i.ytimg.com/vi/_yn-9k6o_I8/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-08T02:18:53Z"
  },
  {
    "videoId": "S1FFtni7wGc",
    "thumbnail": "https://i.ytimg.com/vi/S1FFtni7wGc/mqdefault.jpg",
    "title": "【＃8】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空ス バル】",
    "publishedAt": "2023-04-08T10:59:15Z"
  },
  {
    "videoId": "jcZ4ngwBJkA",
    "thumbnail": "https://i.ytimg.com/vi/jcZ4ngwBJkA/mqdefault.jpg",
    "title": "【＃9】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空ス バル】",
    "publishedAt": "2023-04-09T09:13:58Z"
  },
  {
    "videoId": "nF8IWjDg1DQ",
    "thumbnail": "https://i.ytimg.com/vi/nF8IWjDg1DQ/mqdefault.jpg",
    "title": "【＃生スバル】視聴者参加！！！ぷよテト大会練習しゅばああああああああああああああああああああああああああああああああ！！！！：Puyo Puyo Tetris 2【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-12T13:48:37Z"
  },
  {
    "videoId": "zK_aDGrDQe0",
    "thumbnail": "https://i.ytimg.com/vi/zK_aDGrDQe0/mqdefault.jpg",
    "title": "【＃生スバル】マイクラするしゅばあああああああああああああああああああああああああああああああああ！！！！！！/mine craft【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-13T17:53:49Z"
  },
  {
    "videoId": "qipCUWZWkdM",
    "thumbnail": "https://i.ytimg.com/vi/qipCUWZWkdM/mqdefault.jpg",
    "title": "【＃生スバル】プロメア同時視聴：PROMARE watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-14T16:07:44Z"
  },
  {
    "videoId": "mRaaOzUhsN0",
    "thumbnail": "https://i.ytimg.com/vi/mRaaOzUhsN0/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-15T02:39:21Z"
  },
  {
    "videoId": "PpIJ-Zgm7f8",
    "thumbnail": "https://i.ytimg.com/vi/PpIJ-Zgm7f8/mqdefault.jpg",
    "title": "【＃10】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空ス バル】",
    "publishedAt": "2023-04-15T09:09:51Z"
  },
  {
    "videoId": "7gBnc41imTE",
    "thumbnail": "https://i.ytimg.com/vi/7gBnc41imTE/mqdefault.jpg",
    "title": "【＃11】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空ス バル】",
    "publishedAt": "2023-04-16T10:31:28Z"
  },
  {
    "videoId": "_b3WcdNWPGQ",
    "thumbnail": "https://i.ytimg.com/vi/_b3WcdNWPGQ/mqdefault.jpg",
    "title": "【＃生スバル】闇古戦場にむけてレナ先生とグラブルしゅばああああああああああああああああああああああああああああ！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-18T12:43:29Z"
  },
  {
    "videoId": "OJaM_GWW1kU",
    "thumbnail": "https://i.ytimg.com/vi/OJaM_GWW1kU/mqdefault.jpg",
    "title": "【＃生スバル】バイオハザードR2するしゅばああああああああああああああああああああああああああ！！！！！！：BIOHAZARD RE:2【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-19T14:56:42Z"
  },
  {
    "videoId": "mZrCdYLcW3c",
    "thumbnail": "https://i.ytimg.com/vi/mZrCdYLcW3c/mqdefault.jpg",
    "title": "【＃生スバル】古戦場1日目！！！みんな（？）で肉集めしゅばあああああああああああああああああああああああああああ！！！！！！！：Granblue Fantasy【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-20T12:38:41Z"
  },
  {
    "videoId": "5z3_ZU0Z-6Q",
    "thumbnail": "https://i.ytimg.com/vi/5z3_ZU0Z-6Q/mqdefault.jpg",
    "title": "【＃生スバル】氷菓同時視聴会しゅばあああああああああああああああああああああああああああああああああ！！！！：The niece of time watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-21T15:44:42Z"
  },
  {
    "videoId": "eYLRN_Wfv_I",
    "thumbnail": "https://i.ytimg.com/vi/eYLRN_Wfv_I/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-22T02:48:03Z"
  },
  {
    "videoId": "61AANaiSvtE",
    "thumbnail": "https://i.ytimg.com/vi/61AANaiSvtE/mqdefault.jpg",
    "title": "【＃12】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空ス バル】",
    "publishedAt": "2023-04-22T12:39:21Z"
  },
  {
    "videoId": "l06dT08YgiE",
    "thumbnail": "https://i.ytimg.com/vi/l06dT08YgiE/mqdefault.jpg",
    "title": "【＃13】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空ス バル】",
    "publishedAt": "2023-04-23T10:39:03Z"
  },
  {
    "videoId": "Fu7JpfpKDgA",
    "thumbnail": "https://i.ytimg.com/vi/Fu7JpfpKDgA/mqdefault.jpg",
    "title": "【＃2】バイオハザードR2するしゅばああああああああああああああああああああああああああ！！！！！！：BIOHAZARD RE:2【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-25T13:25:57Z"
  },
  {
    "videoId": "GoWTWxl0lWE",
    "thumbnail": "https://i.ytimg.com/vi/GoWTWxl0lWE/mqdefault.jpg",
    "title": "【#にじホロぶる団 】古戦場最終日！！！みんな（？）で頑張るしゅばあああああああああああああああああああああああああああ！！！！！！！：Granblue Fantasy【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-26T13:45:48Z"
  },
  {
    "videoId": "3zg4RPvuevM",
    "thumbnail": "https://i.ytimg.com/vi/3zg4RPvuevM/mqdefault.jpg",
    "title": "【＃生スバル】マイクラするしゅばあああああああああああああああああああああああああああああああああ！！！！！！/mine craft【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-27T13:14:36Z"
  },
  {
    "videoId": "DWHlItCw_TY",
    "thumbnail": "https://i.ytimg.com/vi/DWHlItCw_TY/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-29T02:11:17Z"
  },
  {
    "videoId": "r-CPWlyXd5w",
    "thumbnail": "https://i.ytimg.com/vi/r-CPWlyXd5w/mqdefault.jpg",
    "title": "【＃14】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空ス バル】",
    "publishedAt": "2023-04-29T09:33:51Z"
  },
  {
    "videoId": "q-nfWrq_nhw",
    "thumbnail": "https://i.ytimg.com/vi/q-nfWrq_nhw/mqdefault.jpg",
    "title": "【＃ホロドロケイ】ドロケイするしゅばあああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-04-29T12:58:42Z"
  },
  {
    "videoId": "YisP4zQR_co",
    "thumbnail": "https://i.ytimg.com/vi/YisP4zQR_co/mqdefault.jpg",
    "title": "【＃最終回】テイルズオブシンフォニアするしゅばああああああああああああああああああああああああああ！！！！！！/ Tales of Symphonia Chronicles【ホロライブ/大空ス バル】",
    "publishedAt": "2023-04-30T09:37:51Z"
  },
  {
    "videoId": "nMEXKRTOY6o",
    "thumbnail": "https://i.ytimg.com/vi/nMEXKRTOY6o/mqdefault.jpg",
    "title": "【#生スバル】ソーセージレジェンドガチャ！！！&視聴者対戦しゅばああああああああああああああああ！！！！！/ＳＡＵＳＡＧＥ ＬＥＧＥＮＤ２【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-03T14:50:27Z"
  },
  {
    "videoId": "62LXDmC7TxQ",
    "thumbnail": "https://i.ytimg.com/vi/62LXDmC7TxQ/mqdefault.jpg",
    "title": "【＃スバルの小屋】スバルの小屋ゴールデンスペシャル！！！　ゲスト：にじさんじ 夜見れなちゃん！/Rena Suba Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-04T12:12:18Z"
  },
  {
    "videoId": "wdkzk3Xy6zE",
    "thumbnail": "https://i.ytimg.com/vi/wdkzk3Xy6zE/mqdefault.jpg",
    "title": "【＃生スバル】氷菓同時視聴会しゅばあああああああああああああああああああああああああああああああああ！！！！：The niece of time watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-05T15:25:08Z"
  },
  {
    "videoId": "8vERos0sVd0",
    "thumbnail": "https://i.ytimg.com/vi/8vERos0sVd0/mqdefault.jpg",
    "title": "【＃3】バイオハザードRE2するしゅばああああああああああああああああああああああああああ！！！！！！：BIOHAZARD RE:2【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-10T15:48:48Z"
  },
  {
    "videoId": "Yyr7nWnneRA",
    "thumbnail": "https://i.ytimg.com/vi/Yyr7nWnneRA/mqdefault.jpg",
    "title": "【＃生スバル】ホロの格ゲーするしゅばあああああああああああああああああああああああああ！！！！！！：Idol showdown【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-11T16:07:59Z"
  },
  {
    "videoId": "gu8Dcauc-Rs",
    "thumbnail": "https://i.ytimg.com/vi/gu8Dcauc-Rs/mqdefault.jpg",
    "title": "【＃生スバル】氷菓同時視聴会しゅばあああああああああああああああああああああああああああああああああ！！！！：The niece of time watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-12T16:30:29Z"
  },
  {
    "videoId": "Lh1T_-DkGOg",
    "thumbnail": "https://i.ytimg.com/vi/Lh1T_-DkGOg/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-13T02:43:48Z"
  },
  {
    "videoId": "gZteRLDxg8g",
    "thumbnail": "https://i.ytimg.com/vi/gZteRLDxg8g/mqdefault.jpg",
    "title": "【＃生スバル】視聴者対戦凸待ち！！！！ホロの格ゲーするしゅばあああああああああああああああああああああああああ！！！！！！：Idol showdown【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-13T14:20:15Z"
  },
  {
    "videoId": "0boeYVTXdbs",
    "thumbnail": "https://i.ytimg.com/vi/0boeYVTXdbs/mqdefault.jpg",
    "title": "【＃生スバル】おさんぽスバルしゅばああああああああああああああああああああああああああああああ！！！！！！/mine craft【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-14T13:57:22Z"
  },
  {
    "videoId": "eQrISULN588",
    "thumbnail": "https://i.ytimg.com/vi/eQrISULN588/mqdefault.jpg",
    "title": "【＃生スバル】個人的重大発表２つあるしゅばああああああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-15T13:22:39Z"
  },
  {
    "videoId": "Igzi2WeCK-k",
    "thumbnail": "https://i.ytimg.com/vi/Igzi2WeCK-k/mqdefault.jpg",
    "title": "【＃スバルの小屋】スバルの小屋にフブちゃんが来てくれるしゅばああああああああ！！！　ゲスト：フブキちゃん！/Fubu Suba Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-16T12:19:46Z"
  },
  {
    "videoId": "uaWlGuBaFEg",
    "thumbnail": "https://i.ytimg.com/vi/uaWlGuBaFEg/mqdefault.jpg",
    "title": "【#ホロライブソセレ大会】ENJOY！！！ホロライブソーセージレジェンド大会：Hololive Sausage Legend2 Competition【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-17T12:22:51Z"
  },
  {
    "videoId": "aarmTwoB3xY",
    "thumbnail": "https://i.ytimg.com/vi/aarmTwoB3xY/mqdefault.jpg",
    "title": "【＃生スバル】氷菓同時視聴会しゅばあああああああああああああああああああああああああああああああああ！！！！：The niece of time watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-19T12:56:20Z"
  },
  {
    "videoId": "D8byNrZipXw",
    "thumbnail": "https://i.ytimg.com/vi/D8byNrZipXw/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-20T02:23:27Z"
  },
  {
    "videoId": "HLefdZhQDd0",
    "thumbnail": "https://i.ytimg.com/vi/HLefdZhQDd0/mqdefault.jpg",
    "title": "【＃生スバル】ファイナルファンタジー X HD Remasterをプレイするしゅばああああああああああああああああ！！！！！：FINAL FANTASY X【※ネタバレあり】",
    "publishedAt": "2023-05-20T10:14:01Z"
  },
  {
    "videoId": "CyUze57L3SU",
    "thumbnail": "https://i.ytimg.com/vi/CyUze57L3SU/mqdefault.jpg",
    "title": "【＃2】ファイナルファンタジー X HD Remasterをプレイするしゅばああああああああああああああああ！！！！！：FINAL FANTASY X【※ネタバレあり】",
    "publishedAt": "2023-05-21T09:14:55Z"
  },
  {
    "videoId": "DCZQVoOQE9o",
    "thumbnail": "https://i.ytimg.com/vi/DCZQVoOQE9o/mqdefault.jpg",
    "title": "【#大空スバル新衣装】新衣装おひろめしゅばあああああああああああああああああああああああ！！！！/NEW outfit【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-23T11:11:11Z"
  },
  {
    "videoId": "o2s1Q-NqngI",
    "thumbnail": "https://i.ytimg.com/vi/o2s1Q-NqngI/mqdefault.jpg",
    "title": "【#大空スバル新衣装】新衣装おひろめしゅばあああああああああああああああああああああああ！！！！/NEW outfit【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-23T12:04:54Z"
  },
  {
    "videoId": "zBGf7g-Up-I",
    "thumbnail": "https://i.ytimg.com/vi/zBGf7g-Up-I/mqdefault.jpg",
    "title": "【＃4】バイオハザードRE2するしゅばああああああああああああああああああああああああああ！！！！！！：BIOHAZARD RE:2【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-24T15:44:27Z"
  },
  {
    "videoId": "9ELtHxCAnDw",
    "thumbnail": "https://i.ytimg.com/vi/9ELtHxCAnDw/mqdefault.jpg",
    "title": "【＃生スバル】噂のPineapple on pizzaするしゅばあああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-25T15:17:10Z"
  },
  {
    "videoId": "yG5qsmvoMyQ",
    "thumbnail": "https://i.ytimg.com/vi/yG5qsmvoMyQ/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-27T02:23:53Z"
  },
  {
    "videoId": "KpwbkIZppYM",
    "thumbnail": "https://i.ytimg.com/vi/KpwbkIZppYM/mqdefault.jpg",
    "title": "【＃3】ファイナルファンタジー X HD Remasterをプレイするしゅばああああああああああああああああ！！！！！：FINAL FANTASY X【※ネタバレあり】",
    "publishedAt": "2023-05-27T09:07:45Z"
  },
  {
    "videoId": "KCjOY_j7u1g",
    "thumbnail": "https://i.ytimg.com/vi/KCjOY_j7u1g/mqdefault.jpg",
    "title": "【＃生スバル】ダンジョンに出会いを求めるのは間違っているだろうかを同時視聴するしゅばああああああああああ：WATCHING PARTY【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-27T13:18:43Z"
  },
  {
    "videoId": "LJlLzdD1Yio",
    "thumbnail": "https://i.ytimg.com/vi/LJlLzdD1Yio/mqdefault.jpg",
    "title": "【＃4】ファイナルファンタジー X HD Remasterをプレイするしゅばああああああああああああああああ！！！！！：FINAL FANTASY X【※ネタバレあり】",
    "publishedAt": "2023-05-28T09:57:32Z"
  },
  {
    "videoId": "KXkZQZK3x9M",
    "thumbnail": "https://i.ytimg.com/vi/KXkZQZK3x9M/mqdefault.jpg",
    "title": "【＃生スバル】氷菓同時視聴会しゅばあああああああああああああああああああああああああああああああああ！！！！：The niece of time watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-28T14:48:29Z"
  },
  {
    "videoId": "qiNG-rw-sHs",
    "thumbnail": "https://i.ytimg.com/vi/qiNG-rw-sHs/mqdefault.jpg",
    "title": "【＃5】バイオハザードRE2するしゅばああああああああああああああああああああああああああ！！！！！！：BIOHAZARD RE:2【ホロライブ/大空スバル】",
    "publishedAt": "2023-05-31T13:11:47Z"
  },
  {
    "videoId": "kXAyQw1eQfQ",
    "thumbnail": "https://i.ytimg.com/vi/kXAyQw1eQfQ/mqdefault.jpg",
    "title": "【#生スバル】魔法少女まどか☆マギカ同時視聴：Puella Magi Madoka Magica【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-02T15:21:55Z"
  },
  {
    "videoId": "6NjrjnmJE8A",
    "thumbnail": "https://i.ytimg.com/vi/6NjrjnmJE8A/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-03T03:39:35Z"
  },
  {
    "videoId": "G5XBvgJumyw",
    "thumbnail": "https://i.ytimg.com/vi/G5XBvgJumyw/mqdefault.jpg",
    "title": "【＃5】ファイナルファンタジー X HD Remasterをプレイするしゅばああああああああああああああああ！！！！！：FINAL FANTASY X【※ネタバレあり】",
    "publishedAt": "2023-06-04T10:51:17Z"
  },
  {
    "videoId": "yBupMmq-R6U",
    "thumbnail": "https://i.ytimg.com/vi/yBupMmq-R6U/mqdefault.jpg",
    "title": "【＃生スバル】ブラッククローバーモバイル 魔法帝への道 The Opening of Fateをプレイしてみるしゅばあああああああああああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-05T07:40:31Z"
  },
  {
    "videoId": "OejpEdEfrv8",
    "thumbnail": "https://i.ytimg.com/vi/OejpEdEfrv8/mqdefault.jpg",
    "title": "【＃生スバル】１時間でとにかく太れ！！！！！！！！！！！！：Fatten up anyway in an hour!【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-06T12:11:27Z"
  },
  {
    "videoId": "yUutOyGYMBg",
    "thumbnail": "https://i.ytimg.com/vi/yUutOyGYMBg/mqdefault.jpg",
    "title": "【＃レオン編最終回】バイオハザードRE2するしゅばああああああああああああああああああああああああああ！！！！！！：BIOHAZARD RE:2【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-07T13:45:35Z"
  },
  {
    "videoId": "VmxZGswcis4",
    "thumbnail": "https://i.ytimg.com/vi/VmxZGswcis4/mqdefault.jpg",
    "title": "【#２】魔法少女まどか☆マギカ同時視聴：Puella Magi Madoka Magica【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-09T15:31:38Z"
  },
  {
    "videoId": "bA_y-z8dAzs",
    "thumbnail": "https://i.ytimg.com/vi/bA_y-z8dAzs/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-10T02:28:48Z"
  },
  {
    "videoId": "TovI5WuPAPg",
    "thumbnail": "https://i.ytimg.com/vi/TovI5WuPAPg/mqdefault.jpg",
    "title": "【＃6】ファイナルファンタジー X HD Remasterをプレイするしゅばああああああああああああああああ！！！！！：FINAL FANTASY X【※ネタバレあり】",
    "publishedAt": "2023-06-10T11:22:15Z"
  },
  {
    "videoId": "Wh9ZrpN5ug4",
    "thumbnail": "https://i.ytimg.com/vi/Wh9ZrpN5ug4/mqdefault.jpg",
    "title": "【＃7】ファイナルファンタジー X HD Remasterをプレイするしゅばああああああああああああああああ！！！！！：FINAL FANTASY X【※ネタバレあり】",
    "publishedAt": "2023-06-11T11:04:28Z"
  },
  {
    "videoId": "63D9hox2Q6o",
    "thumbnail": "https://i.ytimg.com/vi/63D9hox2Q6o/mqdefault.jpg",
    "title": "【＃すばちょこるなたん】お化け屋敷でゴミ掃除しゅばああああああああああああああああああああああああああああああ！！！！！：Paranormal Cleanup【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-13T12:09:38Z"
  },
  {
    "videoId": "vtIvn4A6vm0",
    "thumbnail": "https://i.ytimg.com/vi/vtIvn4A6vm0/mqdefault.jpg",
    "title": "【＃生スバル】歌わくしゅばああああああああああああああああああああああああああああああああああああああああああああああああ【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-14T14:26:09Z"
  },
  {
    "videoId": "kJAGpXb-Ddw",
    "thumbnail": "https://i.ytimg.com/vi/kJAGpXb-Ddw/mqdefault.jpg",
    "title": "【＃クレア編】バイオハザードRE2するしゅばああああああああああああああああああああああああああ！！！！！！：BIOHAZARD RE:2【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-15T16:58:02Z"
  },
  {
    "videoId": "UidzV-1M0Ic",
    "thumbnail": "https://i.ytimg.com/vi/UidzV-1M0Ic/mqdefault.jpg",
    "title": "【#最終回】魔法少女まどか☆マギカ同時視聴：Puella Magi Madoka Magica【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-16T13:24:09Z"
  },
  {
    "videoId": "4YuxhJC_mEk",
    "thumbnail": "https://i.ytimg.com/vi/4YuxhJC_mEk/mqdefault.jpg",
    "title": "【#最終回】魔法少女まどか☆マギカ同時視聴：Puella Magi Madoka Magica【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-16T16:16:44Z"
  },
  {
    "videoId": "sKa4XYS5Ra4",
    "thumbnail": "https://i.ytimg.com/vi/sKa4XYS5Ra4/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-17T02:16:25Z"
  },
  {
    "videoId": "OKLkz6dFOrY",
    "thumbnail": "https://i.ytimg.com/vi/OKLkz6dFOrY/mqdefault.jpg",
    "title": "【＃8】ファイナルファンタジー X HD Remasterをプレイするしゅばああああああああああああああああ！！！！！：FINAL FANTASY X【※ネタバレあり】",
    "publishedAt": "2023-06-17T08:38:04Z"
  },
  {
    "videoId": "N1pUN_BUfyw",
    "thumbnail": "https://i.ytimg.com/vi/N1pUN_BUfyw/mqdefault.jpg",
    "title": "【＃9】ファイナルファンタジー X HD Remasterをプレイするしゅばああああああああああああああああ！！！！！：FINAL FANTASY X【※ネタバレあり】",
    "publishedAt": "2023-06-18T11:20:18Z"
  },
  {
    "videoId": "HtIt4Auar14",
    "thumbnail": "https://i.ytimg.com/vi/HtIt4Auar14/mqdefault.jpg",
    "title": "【＃生スバル】夜間警備するしゅばああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-20T15:08:01Z"
  },
  {
    "videoId": "EswFCIYOeSg",
    "thumbnail": "https://i.ytimg.com/vi/EswFCIYOeSg/mqdefault.jpg",
    "title": "【＃クレア編】バイオハザードRE2するしゅばああああああああああああああああああああああああああ！！！！！！：BIOHAZARD RE:2【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-22T16:20:11Z"
  },
  {
    "videoId": "vMrNlJga_14",
    "thumbnail": "https://i.ytimg.com/vi/vMrNlJga_14/mqdefault.jpg",
    "title": "【#生スバル】劇場版 魔法少女まどか☆マギカ　叛逆の物語　見るしゅばああああ：Puella Magi Madoka Magica The Movie -Rebellion-【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-23T15:39:35Z"
  },
  {
    "videoId": "RVn7OiwJtjY",
    "thumbnail": "https://i.ytimg.com/vi/RVn7OiwJtjY/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-24T02:27:53Z"
  },
  {
    "videoId": "YsXBxQPFdns",
    "thumbnail": "https://i.ytimg.com/vi/YsXBxQPFdns/mqdefault.jpg",
    "title": "【＃10】ファイナルファンタジー X HD Remasterをプレイするしゅばああああああああああああああああ！！！！！：FINAL FANTASY X【※ネタバレあり】",
    "publishedAt": "2023-06-24T11:13:49Z"
  },
  {
    "videoId": "nebak0Ae3fU",
    "thumbnail": "https://i.ytimg.com/vi/nebak0Ae3fU/mqdefault.jpg",
    "title": "【＃11】ファイナルファンタジー X HD Remasterをプレイするしゅばああああああああああああああああ！！！！！：FINAL FANTASY X【※ネタバレあり】",
    "publishedAt": "2023-06-25T10:21:40Z"
  },
  {
    "videoId": "Kx5frPW1Jog",
    "thumbnail": "https://i.ytimg.com/vi/Kx5frPW1Jog/mqdefault.jpg",
    "title": "【＃生スバル】シークレットゲストとマリオ1面クリアし告知？せよ！！！！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-27T11:56:51Z"
  },
  {
    "videoId": "7mfrD0trqb8",
    "thumbnail": "https://i.ytimg.com/vi/7mfrD0trqb8/mqdefault.jpg",
    "title": "【＃生スバル】カードショップに行ってきたしゅばあああああああああああああああああ！！！/I went to the card store! Experience Report【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-28T13:48:25Z"
  },
  {
    "videoId": "KCD30KXfSmc",
    "thumbnail": "https://i.ytimg.com/vi/KCD30KXfSmc/mqdefault.jpg",
    "title": "【＃クレア編最終回】バイオハザードRE2するしゅばああああああああああああああああああああああああああ！！！！！！：BIOHAZARD RE:2【ホロライブ/大空スバル】",
    "publishedAt": "2023-06-29T16:36:11Z"
  },
  {
    "videoId": "zi_IwMrQwTg",
    "thumbnail": "https://i.ytimg.com/vi/zi_IwMrQwTg/mqdefault.jpg",
    "title": "【＃生スバル】名探偵コナン迷宮の十字路同時視聴会：Detective Conan Crossroad in the Ancient Capital watching party!!【大空スバル】",
    "publishedAt": "2023-06-30T15:18:15Z"
  },
  {
    "videoId": "hd5Kj4WA-r8",
    "thumbnail": "https://i.ytimg.com/vi/hd5Kj4WA-r8/mqdefault.jpg",
    "title": "【#生スバル】おはスバしゅばああああああああああああああああああああああ！！！！/Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-01T02:29:39Z"
  },
  {
    "videoId": "NuS9YZzoXtQ",
    "thumbnail": "https://i.ytimg.com/vi/NuS9YZzoXtQ/mqdefault.jpg",
    "title": "【＃真最終回】ファイナルファンタジー X HD Remasterをプレイするしゅばああああああああああああああああ！！！！！：FINAL FANTASY X【※ネタバレあり】",
    "publishedAt": "2023-07-01T08:50:41Z"
  },
  {
    "videoId": "X4FhJ6f9gW8",
    "thumbnail": "https://i.ytimg.com/vi/X4FhJ6f9gW8/mqdefault.jpg",
    "title": "【ネタバレあり】ペルソナ5 ザ・ロイヤル: P5R【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-02T09:36:24Z"
  },
  {
    "videoId": "KH33LaO1mNM",
    "thumbnail": "https://i.ytimg.com/vi/KH33LaO1mNM/mqdefault.jpg",
    "title": "【歌ってみた】愛言葉Ⅳ【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-02T12:30:11Z"
  },
  {
    "videoId": "HfzH5gC7gic",
    "thumbnail": "https://i.ytimg.com/vi/HfzH5gC7gic/mqdefault.jpg",
    "title": "【＃大空スバル生誕祭2023】おたんじょうび【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-02T12:36:59Z"
  },
  {
    "videoId": "_3-RmfrkNjw",
    "thumbnail": "https://i.ytimg.com/vi/_3-RmfrkNjw/mqdefault.jpg",
    "title": "【#生スバル】ホロサマ！！！食べたことがないものに挑戦するしゅばあああああああああ！！！！！：Try something you've never eaten before【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-04T13:19:01Z"
  },
  {
    "videoId": "AZBIaAC0cw0",
    "thumbnail": "https://i.ytimg.com/vi/AZBIaAC0cw0/mqdefault.jpg",
    "title": "【#生スバル】龍が如く３をやるしゅばあああああああああああああああああああああああ！！！！！！YAKUZA３【ネタバレ有り】",
    "publishedAt": "2023-07-05T14:57:21Z"
  },
  {
    "videoId": "9CsdLyx_u70",
    "thumbnail": "https://i.ytimg.com/vi/9CsdLyx_u70/mqdefault.jpg",
    "title": "【#生スバル】遊戯王アニクロ2023 & オリパ開封しゅばあああああああああああああああああああああ！！！！：YU-GI-OH!【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-06T13:12:37Z"
  },
  {
    "videoId": "vk0pOU_qxU0",
    "thumbnail": "https://i.ytimg.com/vi/vk0pOU_qxU0/mqdefault.jpg",
    "title": "【＃生スバル】Re:ゼロから始める異世界生活 同時視聴：Re:ZERO -Starting Life in Another World watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-07T15:19:22Z"
  },
  {
    "videoId": "sXv1i_eCfTk",
    "thumbnail": "https://i.ytimg.com/vi/sXv1i_eCfTk/mqdefault.jpg",
    "title": "【＃生スバル】おはすば雑談！しゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-08T02:19:36Z"
  },
  {
    "videoId": "Zg8c-p0EXX4",
    "thumbnail": "https://i.ytimg.com/vi/Zg8c-p0EXX4/mqdefault.jpg",
    "title": "【＃2】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-07-08T11:06:50Z"
  },
  {
    "videoId": "amxvtUT9G_s",
    "thumbnail": "https://i.ytimg.com/vi/amxvtUT9G_s/mqdefault.jpg",
    "title": "【＃3】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-07-09T11:52:22Z"
  },
  {
    "videoId": "Z_5FPdpqVuc",
    "thumbnail": "https://i.ytimg.com/vi/Z_5FPdpqVuc/mqdefault.jpg",
    "title": "【#2】龍が如く３をやるしゅばあああああああああああああああああああああああ！！！！！！YAKUZA３【ネタバレ有り】",
    "publishedAt": "2023-07-11T15:20:12Z"
  },
  {
    "videoId": "H2FcAu0Gwkc",
    "thumbnail": "https://i.ytimg.com/vi/H2FcAu0Gwkc/mqdefault.jpg",
    "title": "【カメラ枠】ホロサマ！！夏の自由研究？！？フェルト人形を制作せよ！！！！！！： Make a felt doll !!!【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-13T12:48:45Z"
  },
  {
    "videoId": "Ioc7eT_HuLQ",
    "thumbnail": "https://i.ytimg.com/vi/Ioc7eT_HuLQ/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-15T02:16:31Z"
  },
  {
    "videoId": "TAyGIxaTFv4",
    "thumbnail": "https://i.ytimg.com/vi/TAyGIxaTFv4/mqdefault.jpg",
    "title": "【＃4】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-07-15T11:23:51Z"
  },
  {
    "videoId": "8uZlp_6mOy4",
    "thumbnail": "https://i.ytimg.com/vi/8uZlp_6mOy4/mqdefault.jpg",
    "title": "【＃5】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-07-16T12:06:52Z"
  },
  {
    "videoId": "3RwWE-EYc50",
    "thumbnail": "https://i.ytimg.com/vi/3RwWE-EYc50/mqdefault.jpg",
    "title": "【#3】龍が如く３をやるしゅばあああああああああああああああああああああああ！！！！！！YAKUZA３【ネタバレ有り】",
    "publishedAt": "2023-07-18T16:12:08Z"
  },
  {
    "videoId": "TjumjiDU40k",
    "thumbnail": "https://i.ytimg.com/vi/TjumjiDU40k/mqdefault.jpg",
    "title": "【＃生スバル】Re:ゼロから始める異世界生活 同時視聴：Re:ZERO -Starting Life in Another World watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-21T13:05:44Z"
  },
  {
    "videoId": "aXvpL5-XyXQ",
    "thumbnail": "https://i.ytimg.com/vi/aXvpL5-XyXQ/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-22T02:08:43Z"
  },
  {
    "videoId": "5UbRSs9YLq0",
    "thumbnail": "https://i.ytimg.com/vi/5UbRSs9YLq0/mqdefault.jpg",
    "title": "【＃6】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-07-22T07:26:47Z"
  },
  {
    "videoId": "N35-EP19HFQ",
    "thumbnail": "https://i.ytimg.com/vi/N35-EP19HFQ/mqdefault.jpg",
    "title": "【＃7】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-07-23T06:35:56Z"
  },
  {
    "videoId": "bayi4EmlrhM",
    "thumbnail": "https://i.ytimg.com/vi/bayi4EmlrhM/mqdefault.jpg",
    "title": "【#4】龍が如く３をやるしゅばあああああああああああああああああああああああ！！！！！！YAKUZA３【ネタバレ有り】",
    "publishedAt": "2023-07-25T16:05:23Z"
  },
  {
    "videoId": "99GXdTDRTy8",
    "thumbnail": "https://i.ytimg.com/vi/99GXdTDRTy8/mqdefault.jpg",
    "title": "【＃生スバル】ホロライブあるある討論会？！しゅばあああああああああ！！！/ things hololive member do【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-26T15:22:25Z"
  },
  {
    "videoId": "iIniQmz1RHc",
    "thumbnail": "https://i.ytimg.com/vi/iIniQmz1RHc/mqdefault.jpg",
    "title": "【バイオハザードRE２】The豆腐Survivorチャレンジしゅばああああああああああああ！！！！/BIOHAZARD RE:2【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-27T13:16:00Z"
  },
  {
    "videoId": "uCX9ou3MhPw",
    "thumbnail": "https://i.ytimg.com/vi/uCX9ou3MhPw/mqdefault.jpg",
    "title": "【＃生スバル】Re:ゼロから始める異世界生活 同時視聴：Re:ZERO -Starting Life in Another World watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-28T13:12:15Z"
  },
  {
    "videoId": "hRhARDeyooQ",
    "thumbnail": "https://i.ytimg.com/vi/hRhARDeyooQ/mqdefault.jpg",
    "title": "【＃8】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-07-30T09:04:02Z"
  },
  {
    "videoId": "0ZSnVjrZA_Q",
    "thumbnail": "https://i.ytimg.com/vi/0ZSnVjrZA_Q/mqdefault.jpg",
    "title": "【 #ホロサマ歌枠リレー 】夏だ～～～～！！！水着歌枠しゅばああああああああああああああああああ！！！！！！：sing song【ホロライブ/大空スバル】",
    "publishedAt": "2023-07-30T09:41:30Z"
  },
  {
    "videoId": "BjKXNqD-Wuc",
    "thumbnail": "https://i.ytimg.com/vi/BjKXNqD-Wuc/mqdefault.jpg",
    "title": "【＃生スバル】朗報：11時間寝ました！！！！！雑談：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-01T12:03:07Z"
  },
  {
    "videoId": "Dut9AA-RrNI",
    "thumbnail": "https://i.ytimg.com/vi/Dut9AA-RrNI/mqdefault.jpg",
    "title": "【#5】龍が如く３をやるしゅばあああああああああああああああああああああああ！！！！！！YAKUZA３【ネタバレ有り】",
    "publishedAt": "2023-08-01T16:53:19Z"
  },
  {
    "videoId": "rejUl-8YRkE",
    "thumbnail": "https://i.ytimg.com/vi/rejUl-8YRkE/mqdefault.jpg",
    "title": "【＃生スバル】飯テロバトル！？最強の卵かけご飯を作るしゅばああああああああああああああああ！！！：TKG【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-02T14:08:05Z"
  },
  {
    "videoId": "rOaYlqnIe10",
    "thumbnail": "https://i.ytimg.com/vi/rOaYlqnIe10/mqdefault.jpg",
    "title": "【#ユメステ/視聴者様参加型】ワールドダイスター夢のステラリウム　やるしゅばああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-04T12:41:10Z"
  },
  {
    "videoId": "PgLclaWArig",
    "thumbnail": "https://i.ytimg.com/vi/PgLclaWArig/mqdefault.jpg",
    "title": "【＃生スバル】Re:ゼロから始める異世界生活 同時視聴：Re:ZERO -Starting Life in Another World watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-04T15:51:53Z"
  },
  {
    "videoId": "RWQPUPEddg0",
    "thumbnail": "https://i.ytimg.com/vi/RWQPUPEddg0/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-05T02:16:48Z"
  },
  {
    "videoId": "fE9BELxO-PM",
    "thumbnail": "https://i.ytimg.com/vi/fE9BELxO-PM/mqdefault.jpg",
    "title": "【＃9】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-08-05T10:15:06Z"
  },
  {
    "videoId": "QrYRIQoe1Ao",
    "thumbnail": "https://i.ytimg.com/vi/QrYRIQoe1Ao/mqdefault.jpg",
    "title": "【＃10】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-08-06T10:35:40Z"
  },
  {
    "videoId": "dePCa2ci-zY",
    "thumbnail": "https://i.ytimg.com/vi/dePCa2ci-zY/mqdefault.jpg",
    "title": "【＃生スバル】入国審査しゅばああああああああああああああああああああああ：Contraband Police【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-08T12:04:13Z"
  },
  {
    "videoId": "jnJGGxfxPnc",
    "thumbnail": "https://i.ytimg.com/vi/jnJGGxfxPnc/mqdefault.jpg",
    "title": "【＃スバルの小屋】スバルの小屋　ゲスト：アキちゃん！/AKIchan Suba Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-09T12:08:39Z"
  },
  {
    "videoId": "7um-JJT7zvY",
    "thumbnail": "https://i.ytimg.com/vi/7um-JJT7zvY/mqdefault.jpg",
    "title": "【#6】龍が如く３をやるしゅばあああああああああああああああああああああああ！！！！！！YAKUZA３【ネタバレ有り】",
    "publishedAt": "2023-08-10T17:13:46Z"
  },
  {
    "videoId": "pJd231U3kyQ",
    "thumbnail": "https://i.ytimg.com/vi/pJd231U3kyQ/mqdefault.jpg",
    "title": "【＃生スバル】1時間でお買い物！！！！ゲームショッピングしゅばあああああああああああああああ！！！！：steam shopping【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-11T12:48:13Z"
  },
  {
    "videoId": "FiFN7UwHl9A",
    "thumbnail": "https://i.ytimg.com/vi/FiFN7UwHl9A/mqdefault.jpg",
    "title": "【＃生スバル】Re:ゼロから始める異世界生活 同時視聴：Re:ZERO -Starting Life in Another World watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-11T16:07:47Z"
  },
  {
    "videoId": "NNNzIrX3hUs",
    "thumbnail": "https://i.ytimg.com/vi/NNNzIrX3hUs/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-12T02:19:44Z"
  },
  {
    "videoId": "RL_-2iJrd-w",
    "thumbnail": "https://i.ytimg.com/vi/RL_-2iJrd-w/mqdefault.jpg",
    "title": "【＃11】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-08-12T11:25:12Z"
  },
  {
    "videoId": "eutOiM2gXtA",
    "thumbnail": "https://i.ytimg.com/vi/eutOiM2gXtA/mqdefault.jpg",
    "title": "合言葉Ⅳ歌ってみたよ〜！#shorts  #生スバル",
    "publishedAt": "2023-08-12T11:38:42Z"
  },
  {
    "videoId": "Hb5HqITbXNg",
    "thumbnail": "https://i.ytimg.com/vi/Hb5HqITbXNg/mqdefault.jpg",
    "title": "【＃12】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-08-13T10:51:57Z"
  },
  {
    "videoId": "-YRLfUtJpJU",
    "thumbnail": "https://i.ytimg.com/vi/-YRLfUtJpJU/mqdefault.jpg",
    "title": "【#最終回】龍が如く３をやるしゅばあああああああああああああああああああああああ！！！！！！YAKUZA３【ネタバレ有り】",
    "publishedAt": "2023-08-15T16:22:33Z"
  },
  {
    "videoId": "2qJ31ypiMiQ",
    "thumbnail": "https://i.ytimg.com/vi/2qJ31ypiMiQ/mqdefault.jpg",
    "title": "【＃生スバル】美魔女の真実やるしゅばああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-16T14:54:26Z"
  },
  {
    "videoId": "9U7F1bJ7Gqo",
    "thumbnail": "https://i.ytimg.com/vi/9U7F1bJ7Gqo/mqdefault.jpg",
    "title": "スバルのビーチバレー特訓！ #ホロサマshorts #hololivesummer2023 #shorts",
    "publishedAt": "2023-08-17T10:00:06Z"
  },
  {
    "videoId": "9UikVi8HEOI",
    "thumbnail": "https://i.ytimg.com/vi/9UikVi8HEOI/mqdefault.jpg",
    "title": "【＃生スバル】HOLOCUREやるしゅばあああああああああああああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-17T16:24:49Z"
  },
  {
    "videoId": "Y-sqB6K4Ogc",
    "thumbnail": "https://i.ytimg.com/vi/Y-sqB6K4Ogc/mqdefault.jpg",
    "title": "【＃スバちょこルーナ】ホロ鯖夏祭り！！！/MineCraft【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-18T12:10:27Z"
  },
  {
    "videoId": "h9jx-Bbh_uM",
    "thumbnail": "https://i.ytimg.com/vi/h9jx-Bbh_uM/mqdefault.jpg",
    "title": "【＃生スバル】Re:ゼロから始める異世界生活 同時視聴：Re:ZERO -Starting Life in Another World watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-18T15:35:23Z"
  },
  {
    "videoId": "UkCaOsYWWCw",
    "thumbnail": "https://i.ytimg.com/vi/UkCaOsYWWCw/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-19T02:18:49Z"
  },
  {
    "videoId": "BTEAtc7SO98",
    "thumbnail": "https://i.ytimg.com/vi/BTEAtc7SO98/mqdefault.jpg",
    "title": "【＃13】※初手爆音注意 ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-08-19T11:10:21Z"
  },
  {
    "videoId": "yRKKjpTKASE",
    "thumbnail": "https://i.ytimg.com/vi/yRKKjpTKASE/mqdefault.jpg",
    "title": "【＃14】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-08-20T10:18:53Z"
  },
  {
    "videoId": "cxMvRWAjVwM",
    "thumbnail": "https://i.ytimg.com/vi/cxMvRWAjVwM/mqdefault.jpg",
    "title": "【＃生スバル】遊戯王！！！マイデッキ公開しゅばあああああああああああああああああああああああああああ！！！！！：YU-GI-OH【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-21T13:29:23Z"
  },
  {
    "videoId": "tBsyHEiwwrc",
    "thumbnail": "https://i.ytimg.com/vi/tBsyHEiwwrc/mqdefault.jpg",
    "title": "【#ホロ鯖夏祭り2023】ホロ鯖夏祭りしゅばああああああああああああああああああああああああああああああ！！！！！/MIN CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-29T14:17:34Z"
  },
  {
    "videoId": "Pmjx3EgHgKA",
    "thumbnail": "https://i.ytimg.com/vi/Pmjx3EgHgKA/mqdefault.jpg",
    "title": "【＃生スバル】噂のホラゲー？！？！パラソーシャルしゅばあああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-08-30T15:13:34Z"
  },
  {
    "videoId": "lHuZQXUtLNo",
    "thumbnail": "https://i.ytimg.com/vi/lHuZQXUtLNo/mqdefault.jpg",
    "title": "#ピーマン体操 踊ってみたよ～！🫑🫑🫑 #shorts  #踊ってみた",
    "publishedAt": "2023-08-31T11:00:41Z"
  },
  {
    "videoId": "mW6orwC-ak4",
    "thumbnail": "https://i.ytimg.com/vi/mW6orwC-ak4/mqdefault.jpg",
    "title": "バトンキャッチチャレンジ！👀🌟　#shorts",
    "publishedAt": "2023-09-01T10:00:12Z"
  },
  {
    "videoId": "2yYOqmZY51A",
    "thumbnail": "https://i.ytimg.com/vi/2yYOqmZY51A/mqdefault.jpg",
    "title": "【＃生スバル】今日は映画ポケモンミュウツーの逆襲をみるしゅばああああああああああ：watching party Pokémon: Mewtwo Strikes Back!【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-01T15:14:50Z"
  },
  {
    "videoId": "-mbG8cYHEzk",
    "thumbnail": "https://i.ytimg.com/vi/-mbG8cYHEzk/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-02T02:24:10Z"
  },
  {
    "videoId": "DlrMlk6de1A",
    "thumbnail": "https://i.ytimg.com/vi/DlrMlk6de1A/mqdefault.jpg",
    "title": "【＃15】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-09-02T10:47:23Z"
  },
  {
    "videoId": "Fb7anEFZbYM",
    "thumbnail": "https://i.ytimg.com/vi/Fb7anEFZbYM/mqdefault.jpg",
    "title": "【＃16】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-09-03T11:28:41Z"
  },
  {
    "videoId": "DkdOJBF8V6E",
    "thumbnail": "https://i.ytimg.com/vi/DkdOJBF8V6E/mqdefault.jpg",
    "title": "【#ダンクロ 】ダンジョンに出会いを求めるのは間違っているだろうか～バトルクロニクル～ プレイしてみるしゅば！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-05T11:30:44Z"
  },
  {
    "videoId": "Gn_2KN-vE8c",
    "thumbnail": "https://i.ytimg.com/vi/Gn_2KN-vE8c/mqdefault.jpg",
    "title": "【#ホロライブレトロゲーム部】クロックタワークリアまでするしゅばああああああああああああああああああああ【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-05T17:07:23Z"
  },
  {
    "videoId": "Qgb2fDiTFcs",
    "thumbnail": "https://i.ytimg.com/vi/Qgb2fDiTFcs/mqdefault.jpg",
    "title": "【＃大空警察】大空警察プチ裁判 IN MINE CRAFT / OOZORA PORICE MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-06T11:59:02Z"
  },
  {
    "videoId": "1e7RJS9fWAE",
    "thumbnail": "https://i.ytimg.com/vi/1e7RJS9fWAE/mqdefault.jpg",
    "title": "#アイドル 踊ってみたよ〜！#shorts #short #踊ってみた",
    "publishedAt": "2023-09-08T10:00:11Z"
  },
  {
    "videoId": "oZJ61UHxT0c",
    "thumbnail": "https://i.ytimg.com/vi/oZJ61UHxT0c/mqdefault.jpg",
    "title": "【#FF7EC】FINAL FANTASY VII EVER CRISISやるしゅばああああああああああああああああああ！！！！！ 【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-08T13:59:54Z"
  },
  {
    "videoId": "JPbM3GxsmfI",
    "thumbnail": "https://i.ytimg.com/vi/JPbM3GxsmfI/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-09T02:25:42Z"
  },
  {
    "videoId": "toZCwMgELTc",
    "thumbnail": "https://i.ytimg.com/vi/toZCwMgELTc/mqdefault.jpg",
    "title": "【＃17】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-09-09T10:20:47Z"
  },
  {
    "videoId": "ZJ-Je8uvmjw",
    "thumbnail": "https://i.ytimg.com/vi/ZJ-Je8uvmjw/mqdefault.jpg",
    "title": "【＃18】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-09-10T11:05:45Z"
  },
  {
    "videoId": "tZPXOHPYmCU",
    "thumbnail": "https://i.ytimg.com/vi/tZPXOHPYmCU/mqdefault.jpg",
    "title": "【#スバちょこるなたん】 京まふ！！！！どたばた京都旅行レポート！！！！！！：KYOTO travel report【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-12T12:07:52Z"
  },
  {
    "videoId": "KshhoL1V16s",
    "thumbnail": "https://i.ytimg.com/vi/KshhoL1V16s/mqdefault.jpg",
    "title": "【＃生スバル】漢字でGOOOOOOOOOOOOOOOOOOOOOOOOOOO/ KANJI de GO【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-14T13:41:44Z"
  },
  {
    "videoId": "RlVXck8KA44",
    "thumbnail": "https://i.ytimg.com/vi/RlVXck8KA44/mqdefault.jpg",
    "title": "【＃生スバル】ルギア爆誕同時視聴 / Pokemon Revelation Lugia watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-15T14:56:40Z"
  },
  {
    "videoId": "9FGBBXUQmhA",
    "thumbnail": "https://i.ytimg.com/vi/9FGBBXUQmhA/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-16T02:26:05Z"
  },
  {
    "videoId": "umscBrSO_q0",
    "thumbnail": "https://i.ytimg.com/vi/umscBrSO_q0/mqdefault.jpg",
    "title": "【＃19】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-09-16T08:50:32Z"
  },
  {
    "videoId": "0PmmRv34mqk",
    "thumbnail": "https://i.ytimg.com/vi/0PmmRv34mqk/mqdefault.jpg",
    "title": "【＃大空スバル５周年】５年間を一挙振り返り！大空スバル年表しゅばあああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-16T13:29:12Z"
  },
  {
    "videoId": "lgR4W_5GaH8",
    "thumbnail": "https://i.ytimg.com/vi/lgR4W_5GaH8/mqdefault.jpg",
    "title": "【＃20】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-09-17T11:08:48Z"
  },
  {
    "videoId": "NBDM7Acjzws",
    "thumbnail": "https://i.ytimg.com/vi/NBDM7Acjzws/mqdefault.jpg",
    "title": "まだまだ暑いね…👒🌟😳 #shorts  #short",
    "publishedAt": "2023-09-19T12:10:00Z"
  },
  {
    "videoId": "bLnXDkg21Ho",
    "thumbnail": "https://i.ytimg.com/vi/bLnXDkg21Ho/mqdefault.jpg",
    "title": "【#SMOK】嘘発見器？！？友情崩壊？！？！ドキドキSMOK！！！！！！！！/ lie detector【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-19T12:15:48Z"
  },
  {
    "videoId": "sARYPxqrIOQ",
    "thumbnail": "https://i.ytimg.com/vi/sARYPxqrIOQ/mqdefault.jpg",
    "title": "【#生スバル】ありったけのダイヤかき集め / MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-20T16:06:53Z"
  },
  {
    "videoId": "C3pBUL-o-qI",
    "thumbnail": "https://i.ytimg.com/vi/C3pBUL-o-qI/mqdefault.jpg",
    "title": "【#常MOS】RAFTで大海原へ出発しゅばあああああああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-21T15:16:00Z"
  },
  {
    "videoId": "KzWCZTmho-M",
    "thumbnail": "https://i.ytimg.com/vi/KzWCZTmho-M/mqdefault.jpg",
    "title": "美少女無罪♡パイレーツ 踊ってみたよ～！🏴‍☠️ #shorts  #short",
    "publishedAt": "2023-09-22T11:00:08Z"
  },
  {
    "videoId": "fx-NYIR_7-E",
    "thumbnail": "https://i.ytimg.com/vi/fx-NYIR_7-E/mqdefault.jpg",
    "title": "【＃生スバル】逆境無頼カイジ！同時視聴しゅばあああああああああああああ！！！！\\　Ultimate Survivor, Kaiji watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-22T15:33:16Z"
  },
  {
    "videoId": "ovbwnXKV9JA",
    "thumbnail": "https://i.ytimg.com/vi/ovbwnXKV9JA/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-23T02:21:19Z"
  },
  {
    "videoId": "s77A9FR5ob4",
    "thumbnail": "https://i.ytimg.com/vi/s77A9FR5ob4/mqdefault.jpg",
    "title": "【＃21】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-09-23T10:41:47Z"
  },
  {
    "videoId": "qT6rnU6voTY",
    "thumbnail": "https://i.ytimg.com/vi/qT6rnU6voTY/mqdefault.jpg",
    "title": "【＃22】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-09-24T10:29:28Z"
  },
  {
    "videoId": "yziqF2EA9mg",
    "thumbnail": "https://i.ytimg.com/vi/yziqF2EA9mg/mqdefault.jpg",
    "title": "【テイルズ オブ アライズ】今日からはじめる？！？テイルズ オブ アライズ！！！大布教大会しゅばあああああああああああ！！！！！！ / Tales of ARISE 【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-26T12:26:12Z"
  },
  {
    "videoId": "jvA-L51yi30",
    "thumbnail": "https://i.ytimg.com/vi/jvA-L51yi30/mqdefault.jpg",
    "title": "【＃生スバル】１時間アルバイト！！３０ダイヤを掘り出せ！！！！！！！/Mine Craft【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-26T16:03:56Z"
  },
  {
    "videoId": "mTKHzf3mMlQ",
    "thumbnail": "https://i.ytimg.com/vi/mTKHzf3mMlQ/mqdefault.jpg",
    "title": "【＃生スバル】ARMORED CORE VI FIRES OF RUBICON やるしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2023-09-27T16:09:04Z"
  },
  {
    "videoId": "rCa7vwRGS4A",
    "thumbnail": "https://i.ytimg.com/vi/rCa7vwRGS4A/mqdefault.jpg",
    "title": "【＃エンジェルヘブン】笑ってはいけないホログラ＆ショート【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-28T12:12:58Z"
  },
  {
    "videoId": "96my7Hk4_1E",
    "thumbnail": "https://i.ytimg.com/vi/96my7Hk4_1E/mqdefault.jpg",
    "title": "【＃生スバル】借金返済/Mine Craft【ホロライブ/大空スバル】",
    "publishedAt": "2023-09-29T15:51:10Z"
  },
  {
    "videoId": "hR8HIoIrIMI",
    "thumbnail": "https://i.ytimg.com/vi/hR8HIoIrIMI/mqdefault.jpg",
    "title": "【＃23】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-09-30T09:39:41Z"
  },
  {
    "videoId": "--f6JS_P69Q",
    "thumbnail": "https://i.ytimg.com/vi/--f6JS_P69Q/mqdefault.jpg",
    "title": "【＃24】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-10-01T11:17:33Z"
  },
  {
    "videoId": "MkDAlj9-1DA",
    "thumbnail": "https://i.ytimg.com/vi/MkDAlj9-1DA/mqdefault.jpg",
    "title": "【＃２】ARMORED CORE VI FIRES OF RUBICON やるしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2023-10-05T16:10:19Z"
  },
  {
    "videoId": "qwIozYbBUIk",
    "thumbnail": "https://i.ytimg.com/vi/qwIozYbBUIk/mqdefault.jpg",
    "title": "【＃2】逆境無頼カイジ！同時視聴しゅばあああああああああああああ！！！！\\　Ultimate Survivor, Kaiji watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-06T16:15:44Z"
  },
  {
    "videoId": "qw1vZ0NxWw4",
    "thumbnail": "https://i.ytimg.com/vi/qw1vZ0NxWw4/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-07T02:27:50Z"
  },
  {
    "videoId": "MVAlkZogzQY",
    "thumbnail": "https://i.ytimg.com/vi/MVAlkZogzQY/mqdefault.jpg",
    "title": "【＃25 ?!】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-10-07T11:06:06Z"
  },
  {
    "videoId": "P63uhAAn8Sg",
    "thumbnail": "https://i.ytimg.com/vi/P63uhAAn8Sg/mqdefault.jpg",
    "title": "【＃26】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-10-08T10:56:14Z"
  },
  {
    "videoId": "qQ7EtEvfpPY",
    "thumbnail": "https://i.ytimg.com/vi/qQ7EtEvfpPY/mqdefault.jpg",
    "title": "【＃生スバル】スイカゲームするしゅばああああああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-10T14:51:25Z"
  },
  {
    "videoId": "iLPrahZZAqE",
    "thumbnail": "https://i.ytimg.com/vi/iLPrahZZAqE/mqdefault.jpg",
    "title": "【＃生スバル】陰の実力者になりたくてマスターオブガーデンにねねちが実装？！プレイするしゅばああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-11T12:56:33Z"
  },
  {
    "videoId": "gxO4AS2ebCM",
    "thumbnail": "https://i.ytimg.com/vi/gxO4AS2ebCM/mqdefault.jpg",
    "title": "【＃生スバル】ストリートファイター ６やるしゅばあああああああああああああああああああ！！！！！/STREET FIGHTER 6【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-11T16:03:52Z"
  },
  {
    "videoId": "WyCGT5nwz08",
    "thumbnail": "https://i.ytimg.com/vi/WyCGT5nwz08/mqdefault.jpg",
    "title": "【＃生スバル】ARMORED CORE VI FIRES OF RUBICON やるしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2023-10-12T16:23:21Z"
  },
  {
    "videoId": "NBP1gEnIC3k",
    "thumbnail": "https://i.ytimg.com/vi/NBP1gEnIC3k/mqdefault.jpg",
    "title": "【＃3】逆境無頼カイジ！同時視聴しゅばあああああああああああああ！！！！\\　Ultimate Survivor, Kaiji watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-13T15:03:59Z"
  },
  {
    "videoId": "P1V2FMHI8UI",
    "thumbnail": "https://i.ytimg.com/vi/P1V2FMHI8UI/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-14T02:10:43Z"
  },
  {
    "videoId": "Vzuahjps-v0",
    "thumbnail": "https://i.ytimg.com/vi/Vzuahjps-v0/mqdefault.jpg",
    "title": "【＃27】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-10-14T11:05:49Z"
  },
  {
    "videoId": "MC3AUbUifVw",
    "thumbnail": "https://i.ytimg.com/vi/MC3AUbUifVw/mqdefault.jpg",
    "title": "【＃28】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-10-15T09:41:14Z"
  },
  {
    "videoId": "IScUl3Ja8wk",
    "thumbnail": "https://i.ytimg.com/vi/IScUl3Ja8wk/mqdefault.jpg",
    "title": "【#生スバル】ホロのスイカをプレイするしゅばあああああああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-17T13:37:16Z"
  },
  {
    "videoId": "X37lQH4xVkc",
    "thumbnail": "https://i.ytimg.com/vi/X37lQH4xVkc/mqdefault.jpg",
    "title": "【#ホロライブ大運動会2023】みんなで運動会会場を見に行こう～～～～～～～！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-19T13:42:27Z"
  },
  {
    "videoId": "dxqLkVTV6zI",
    "thumbnail": "https://i.ytimg.com/vi/dxqLkVTV6zI/mqdefault.jpg",
    "title": "【＃5】逆境無頼カイジ！同時視聴しゅばあああああああああああああ！！！！\\　Ultimate Survivor, Kaiji watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-20T13:00:44Z"
  },
  {
    "videoId": "3mBVdIJ3v84",
    "thumbnail": "https://i.ytimg.com/vi/3mBVdIJ3v84/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-21T02:15:24Z"
  },
  {
    "videoId": "SlOFpVPboBk",
    "thumbnail": "https://i.ytimg.com/vi/SlOFpVPboBk/mqdefault.jpg",
    "title": "【＃29】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-10-21T10:12:28Z"
  },
  {
    "videoId": "KKABitbFMWw",
    "thumbnail": "https://i.ytimg.com/vi/KKABitbFMWw/mqdefault.jpg",
    "title": "【＃30】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-10-22T10:56:54Z"
  },
  {
    "videoId": "lrAtobqcjFM",
    "thumbnail": "https://i.ytimg.com/vi/lrAtobqcjFM/mqdefault.jpg",
    "title": "【＃生スバル】ぺこちゃんと10本先取勝負！！！！！！！！！！！！！しゅば！/STREET FIGHTER 6【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-24T13:37:54Z"
  },
  {
    "videoId": "r-pqYefnc68",
    "thumbnail": "https://i.ytimg.com/vi/r-pqYefnc68/mqdefault.jpg",
    "title": "【＃生スバル】utawaku!!!!!!!!【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-25T12:46:48Z"
  },
  {
    "videoId": "Ewu5rgNxkuA",
    "thumbnail": "https://i.ytimg.com/vi/Ewu5rgNxkuA/mqdefault.jpg",
    "title": "【＃３】ARMORED CORE VI FIRES OF RUBICON やるしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2023-10-25T16:56:54Z"
  },
  {
    "videoId": "3IzuA3Pw0ck",
    "thumbnail": "https://i.ytimg.com/vi/3IzuA3Pw0ck/mqdefault.jpg",
    "title": "【#ホロライブ大運動会2023】みんなで運動会会場で体育館つくりしゅば～～～～～～～～～！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-26T14:08:25Z"
  },
  {
    "videoId": "ZfhkTd1VpzE",
    "thumbnail": "https://i.ytimg.com/vi/ZfhkTd1VpzE/mqdefault.jpg",
    "title": "【＃4】逆境無頼カイジ！同時視聴しゅばあああああああああああああ！！！！\\　Ultimate Survivor, Kaiji watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-27T13:03:52Z"
  },
  {
    "videoId": "JaouY76EIMU",
    "thumbnail": "https://i.ytimg.com/vi/JaouY76EIMU/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-28T02:23:03Z"
  },
  {
    "videoId": "aRI7fr_fPxA",
    "thumbnail": "https://i.ytimg.com/vi/aRI7fr_fPxA/mqdefault.jpg",
    "title": "【＃31】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-10-28T10:49:00Z"
  },
  {
    "videoId": "-cIfR_Wa7ZI",
    "thumbnail": "https://i.ytimg.com/vi/-cIfR_Wa7ZI/mqdefault.jpg",
    "title": "【＃32】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-10-29T10:46:09Z"
  },
  {
    "videoId": "pQk-ReQh4b4",
    "thumbnail": "https://i.ytimg.com/vi/pQk-ReQh4b4/mqdefault.jpg",
    "title": "【＃生スバル】目指せ！！！プラチナチャレンジしゅばあああああああああああ！！！！！/ STREET FIGHTER 6【ホロライブ/大空スバル】",
    "publishedAt": "2023-10-31T12:07:15Z"
  },
  {
    "videoId": "JZxtA_zer3Y",
    "thumbnail": "https://i.ytimg.com/vi/JZxtA_zer3Y/mqdefault.jpg",
    "title": "【＃スバルの小屋】スバルの小屋　ゲスト：ロボちゃん！/Robo-chan Suba Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-01T11:02:46Z"
  },
  {
    "videoId": "YdqFtQBlqSQ",
    "thumbnail": "https://i.ytimg.com/vi/YdqFtQBlqSQ/mqdefault.jpg",
    "title": "【＃生スバル】マルちゃんZUBAAAN！とのコラボ衣装お披露目？！？しゅばあああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-02T12:07:42Z"
  },
  {
    "videoId": "p0BFcTof8tM",
    "thumbnail": "https://i.ytimg.com/vi/p0BFcTof8tM/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-04T02:16:07Z"
  },
  {
    "videoId": "Y4hThlzy1KI",
    "thumbnail": "https://i.ytimg.com/vi/Y4hThlzy1KI/mqdefault.jpg",
    "title": "【#ホロライブ大運動会2023】振り返りトークしゅばあああああああああああああ！！！！！【ホロライブ】",
    "publishedAt": "2023-11-04T16:06:03Z"
  },
  {
    "videoId": "CwPlY3uVcbY",
    "thumbnail": "https://i.ytimg.com/vi/CwPlY3uVcbY/mqdefault.jpg",
    "title": "【＃最終回】ペルソナ5 ザ・ロイヤルやるしゅばあああああああああああああああああああああああ！！！！: P5R【※ネタバレあり】",
    "publishedAt": "2023-11-05T14:18:12Z"
  },
  {
    "videoId": "TwNy09GiY04",
    "thumbnail": "https://i.ytimg.com/vi/TwNy09GiY04/mqdefault.jpg",
    "title": "【＃生スバル】目指せ！！！プラチナ３チャレンジしゅばあああああああああああ！！！！！/ STREET FIGHTER 6【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-07T13:11:36Z"
  },
  {
    "videoId": "HjtyPzZwhsE",
    "thumbnail": "https://i.ytimg.com/vi/HjtyPzZwhsE/mqdefault.jpg",
    "title": "【＃５】ARMORED CORE VI FIRES OF RUBICON やるしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2023-11-07T16:39:03Z"
  },
  {
    "videoId": "6p701p9stxQ",
    "thumbnail": "https://i.ytimg.com/vi/6p701p9stxQ/mqdefault.jpg",
    "title": "【#生スバル】お手軽簡単！！！超高カロリーレシピを食べてみるシュバあああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-09T13:07:59Z"
  },
  {
    "videoId": "h5sbTXEez-Q",
    "thumbnail": "https://i.ytimg.com/vi/h5sbTXEez-Q/mqdefault.jpg",
    "title": "【＃6】逆境無頼カイジ！同時視聴しゅばあああああああああああああ！！！！\\　Ultimate Survivor, Kaiji watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-10T14:37:49Z"
  },
  {
    "videoId": "MVWrgZS8K7Q",
    "thumbnail": "https://i.ytimg.com/vi/MVWrgZS8K7Q/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-11T02:38:16Z"
  },
  {
    "videoId": "lbUOWkQPfMI",
    "thumbnail": "https://i.ytimg.com/vi/lbUOWkQPfMI/mqdefault.jpg",
    "title": "【＃生スバル】龍が如く４ / YAKUZA 4【※ネタバレあり】",
    "publishedAt": "2023-11-12T08:42:11Z"
  },
  {
    "videoId": "hYFf4XWTLzo",
    "thumbnail": "https://i.ytimg.com/vi/hYFf4XWTLzo/mqdefault.jpg",
    "title": "【＃生スバル】目指せ！！！ダイヤランクチャレンジしゅばあああああああああああ！！！！！/ STREET FIGHTER 6【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-15T17:41:06Z"
  },
  {
    "videoId": "iZWv8IdotEc",
    "thumbnail": "https://i.ytimg.com/vi/iZWv8IdotEc/mqdefault.jpg",
    "title": "すきっちゅーの！ 踊ってみたよ🌟　#踊ってみた  #shorts  #short",
    "publishedAt": "2023-11-16T11:00:39Z"
  },
  {
    "videoId": "1CrA6tXGDoc",
    "thumbnail": "https://i.ytimg.com/vi/1CrA6tXGDoc/mqdefault.jpg",
    "title": "【＃６】ARMORED CORE VI FIRES OF RUBICON やるしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2023-11-16T17:00:15Z"
  },
  {
    "videoId": "6u1SMjzPR8o",
    "thumbnail": "https://i.ytimg.com/vi/6u1SMjzPR8o/mqdefault.jpg",
    "title": "【＃7】逆境無頼カイジ！同時視聴しゅばあああああああああああああ！！！！\\　Ultimate Survivor, Kaiji watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-17T15:36:59Z"
  },
  {
    "videoId": "B2Y0kFSrS1Y",
    "thumbnail": "https://i.ytimg.com/vi/B2Y0kFSrS1Y/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-18T02:10:52Z"
  },
  {
    "videoId": "DbKcNho15tM",
    "thumbnail": "https://i.ytimg.com/vi/DbKcNho15tM/mqdefault.jpg",
    "title": "【＃２】龍が如く４しゅばあああああああああああああああああああああ！！！！！！！ / YAKUZA 4【※ネタバレあり】",
    "publishedAt": "2023-11-18T10:22:20Z"
  },
  {
    "videoId": "KrGDZlswEfk",
    "thumbnail": "https://i.ytimg.com/vi/KrGDZlswEfk/mqdefault.jpg",
    "title": "【＃3】龍が如く４するしゅばあああああああああああああああ！！！！！！ / YAKUZA 4【※ネタバレあり】",
    "publishedAt": "2023-11-19T09:42:24Z"
  },
  {
    "videoId": "5T1Fu7s5hOc",
    "thumbnail": "https://i.ytimg.com/vi/5T1Fu7s5hOc/mqdefault.jpg",
    "title": "【＃スバルの小屋】スバルの小屋　ゲスト：ねねち！/NENECHI Suba Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-22T12:05:06Z"
  },
  {
    "videoId": "cEGSODvLz_g",
    "thumbnail": "https://i.ytimg.com/vi/cEGSODvLz_g/mqdefault.jpg",
    "title": "【＃生スバル】目指せプラチナ５！！！ダイヤランクチャレンジその２しゅばあああああああああああ！！！！！/ STREET FIGHTER 6【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-22T16:59:37Z"
  },
  {
    "videoId": "y1L1Myb_0OE",
    "thumbnail": "https://i.ytimg.com/vi/y1L1Myb_0OE/mqdefault.jpg",
    "title": "【＃生スバル】３年ぶり？！ボーイッシュ対談【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-23T12:09:12Z"
  },
  {
    "videoId": "06Sq5VcLTJs",
    "thumbnail": "https://i.ytimg.com/vi/06Sq5VcLTJs/mqdefault.jpg",
    "title": "【＃8】逆境無頼カイジ！同時視聴しゅばあああああああああああああ！！！！\\　Ultimate Survivor, Kaiji watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-24T15:05:42Z"
  },
  {
    "videoId": "o0biagpCtiA",
    "thumbnail": "https://i.ytimg.com/vi/o0biagpCtiA/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-25T02:17:29Z"
  },
  {
    "videoId": "l4nPRyIzW2k",
    "thumbnail": "https://i.ytimg.com/vi/l4nPRyIzW2k/mqdefault.jpg",
    "title": "【＃4】龍が如く４するしゅばあああああああああああああああ！！！！！！ / YAKUZA 4【※ネタバレあり】",
    "publishedAt": "2023-11-25T09:18:26Z"
  },
  {
    "videoId": "qpcS4Lf-yik",
    "thumbnail": "https://i.ytimg.com/vi/qpcS4Lf-yik/mqdefault.jpg",
    "title": "【＃5】龍が如く４するしゅばあああああああああああああああ！！！！！！ / YAKUZA 4【※ネタバレあり】",
    "publishedAt": "2023-11-26T08:47:38Z"
  },
  {
    "videoId": "urNPgbIj7y0",
    "thumbnail": "https://i.ytimg.com/vi/urNPgbIj7y0/mqdefault.jpg",
    "title": "【】昭和のおもちゃ大展覧会 / Experience Japanese Showa Toys【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-29T15:37:09Z"
  },
  {
    "videoId": "j_uai_Tgn0U",
    "thumbnail": "https://i.ytimg.com/vi/j_uai_Tgn0U/mqdefault.jpg",
    "title": "【＃生スバル】目指せダイヤランク！！！ダイヤランクチャレンジその３しゅばあああああああああああ！！！！！/ STREET FIGHTER 6【ホロライブ/大空スバル】",
    "publishedAt": "2023-11-30T16:39:18Z"
  },
  {
    "videoId": "TTrE4PQpKyI",
    "thumbnail": "https://i.ytimg.com/vi/TTrE4PQpKyI/mqdefault.jpg",
    "title": "【＃9】逆境無頼カイジ！同時視聴しゅばあああああああああああああ！！！！\\　Ultimate Survivor, Kaiji watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-01T13:52:56Z"
  },
  {
    "videoId": "KSjydwsyUMQ",
    "thumbnail": "https://i.ytimg.com/vi/KSjydwsyUMQ/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-02T02:11:32Z"
  },
  {
    "videoId": "M1LILQ4je_o",
    "thumbnail": "https://i.ytimg.com/vi/M1LILQ4je_o/mqdefault.jpg",
    "title": "【＃生スバル】最新作！ペルソナ５ タクティカ を遊ばせて頂く…！！！しゅばああああああああああああああああああああああああ　/　PERSONA 5 TACTICA【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-02T07:37:03Z"
  },
  {
    "videoId": "Bi4Lt-CTBWw",
    "thumbnail": "https://i.ytimg.com/vi/Bi4Lt-CTBWw/mqdefault.jpg",
    "title": "【＃７】ARMORED CORE VI FIRES OF RUBICON やるしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2023-12-02T10:06:07Z"
  },
  {
    "videoId": "g8FhRTTGq1g",
    "thumbnail": "https://i.ytimg.com/vi/g8FhRTTGq1g/mqdefault.jpg",
    "title": "【＃8】ARMORED CORE VI FIRES OF RUBICON やるしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2023-12-02T15:56:03Z"
  },
  {
    "videoId": "ASilezET3Js",
    "thumbnail": "https://i.ytimg.com/vi/ASilezET3Js/mqdefault.jpg",
    "title": "【＃6】龍が如く４するしゅばあああああああああああああああ！！！！！！ / YAKUZA 4【※ネタバレあり】",
    "publishedAt": "2023-12-03T08:37:57Z"
  },
  {
    "videoId": "n6RUktXlOh4",
    "thumbnail": "https://i.ytimg.com/vi/n6RUktXlOh4/mqdefault.jpg",
    "title": "【＃生スバル】ホロパレードするしゅばああああああああああああああああああ！！！！！ / holoparade【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-05T15:27:40Z"
  },
  {
    "videoId": "Q0AoS87jR6A",
    "thumbnail": "https://i.ytimg.com/vi/Q0AoS87jR6A/mqdefault.jpg",
    "title": "【＃スバルの小屋】スバルの小屋　ゲスト：ポルカ！【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-06T12:03:47Z"
  },
  {
    "videoId": "8m9UJizeO7U",
    "thumbnail": "https://i.ytimg.com/vi/8m9UJizeO7U/mqdefault.jpg",
    "title": "【＃生スバル】噂のゲーム！8番出口をプレイするしゅばああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-07T16:00:35Z"
  },
  {
    "videoId": "u8eQfFuzvs8",
    "thumbnail": "https://i.ytimg.com/vi/u8eQfFuzvs8/mqdefault.jpg",
    "title": "【＃最終回】逆境無頼カイジ！同時視聴しゅばあああああああああああああ！！！！\\　Ultimate Survivor, Kaiji watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-08T14:36:56Z"
  },
  {
    "videoId": "Q5TGcPdK0sc",
    "thumbnail": "https://i.ytimg.com/vi/Q5TGcPdK0sc/mqdefault.jpg",
    "title": "【＃生スバル】雑談！おはスバしゅばあああああああああああああああああ！！：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-09T02:11:42Z"
  },
  {
    "videoId": "YZUP_1WfRM0",
    "thumbnail": "https://i.ytimg.com/vi/YZUP_1WfRM0/mqdefault.jpg",
    "title": "【＃最終回】龍が如く４するしゅばあああああああああああああああ！！！！！！ / YAKUZA 4【※ネタバレあり】",
    "publishedAt": "2023-12-09T10:47:38Z"
  },
  {
    "videoId": "JHFIIDZUQps",
    "thumbnail": "https://i.ytimg.com/vi/JHFIIDZUQps/mqdefault.jpg",
    "title": "【＃生スバル】龍が如く５やるしゅばあああああああああああああああああああああああああああああ！！！！！：YAKUZA５【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-10T09:51:42Z"
  },
  {
    "videoId": "aBZDcg3a38E",
    "thumbnail": "https://i.ytimg.com/vi/aBZDcg3a38E/mqdefault.jpg",
    "title": "【#ゆるホロチームカート】ゆるホロマリカしゅばああああああああああああああああああああああ！！！！ / Mario Kart 8 Deluxe【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-12T13:24:48Z"
  },
  {
    "videoId": "E1EVjTK3LvY",
    "thumbnail": "https://i.ytimg.com/vi/E1EVjTK3LvY/mqdefault.jpg",
    "title": "【#生スバル】最新ホラゲ！！！ウツロマユするしゅばあああああああああああああああああ！！！！/ - Hollow Cocoon -【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-13T17:51:34Z"
  },
  {
    "videoId": "PMC3ScGSUzo",
    "thumbnail": "https://i.ytimg.com/vi/PMC3ScGSUzo/mqdefault.jpg",
    "title": "【＃生スバル】カイジ人生逆転ゲーム！同時視聴しゅばあああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-15T15:56:11Z"
  },
  {
    "videoId": "54XRDfaIqd4",
    "thumbnail": "https://i.ytimg.com/vi/54XRDfaIqd4/mqdefault.jpg",
    "title": "【＃２】龍が如く５やるしゅばあああああああああああああああああああああああああああああ！！！！！：YAKUZA５【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-16T09:22:33Z"
  },
  {
    "videoId": "iCK1u3op5AY",
    "thumbnail": "https://i.ytimg.com/vi/iCK1u3op5AY/mqdefault.jpg",
    "title": "【#生スバル】チラズアートさん新作ホラゲ！！自撮やるしゅばああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-16T14:51:35Z"
  },
  {
    "videoId": "VoctpvYXFZ8",
    "thumbnail": "https://i.ytimg.com/vi/VoctpvYXFZ8/mqdefault.jpg",
    "title": "【＃３】龍が如く５やるしゅばあああああああああああああああああああああああああああああ！！！！！：YAKUZA５【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-17T09:10:39Z"
  },
  {
    "videoId": "3OX6xeVZmcs",
    "thumbnail": "https://i.ytimg.com/vi/3OX6xeVZmcs/mqdefault.jpg",
    "title": "さくゆいたいそう踊ってみた！🐼👻 #shorts  #short #踊ってみた",
    "publishedAt": "2023-12-19T11:08:00Z"
  },
  {
    "videoId": "vN7pk89iLOg",
    "thumbnail": "https://i.ytimg.com/vi/vN7pk89iLOg/mqdefault.jpg",
    "title": "【#生スバル】マシュマロ雑談会～！！！！/Free talk【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-20T13:24:25Z"
  },
  {
    "videoId": "yyGncuWAY_Q",
    "thumbnail": "https://i.ytimg.com/vi/yyGncuWAY_Q/mqdefault.jpg",
    "title": "大空スバル×dアニメストア同時視聴会【大空スバル/ホロライブ】",
    "publishedAt": "2023-12-21T13:21:26Z"
  },
  {
    "videoId": "WQdxnbcdMos",
    "thumbnail": "https://i.ytimg.com/vi/WQdxnbcdMos/mqdefault.jpg",
    "title": "【#生スバル】くりすますちょくぜん？！おはすば！！！！！ / OHASHUBA！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-23T02:09:20Z"
  },
  {
    "videoId": "fZK0ISWv3nQ",
    "thumbnail": "https://i.ytimg.com/vi/fZK0ISWv3nQ/mqdefault.jpg",
    "title": "いっしょに祝おう～！メリークリスマス！！🎄🎁🎅🏻✨️ #shorts  #short  #xmas",
    "publishedAt": "2023-12-23T14:59:08Z"
  },
  {
    "videoId": "vAvYZZYJ9D0",
    "thumbnail": "https://i.ytimg.com/vi/vAvYZZYJ9D0/mqdefault.jpg",
    "title": "【#ホロクリスマス歌枠リレー 】メリークリスマスしゅばあああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-25T10:02:12Z"
  },
  {
    "videoId": "HAp1eXd3SUg",
    "thumbnail": "https://i.ytimg.com/vi/HAp1eXd3SUg/mqdefault.jpg",
    "title": "Hoshimatic Projectのトランプ大好きteam B です！ 応援よろしくお願いします！！💃🕺💃 #shorts  #short",
    "publishedAt": "2023-12-25T13:30:07Z"
  },
  {
    "videoId": "NN11GcPdj6U",
    "thumbnail": "https://i.ytimg.com/vi/NN11GcPdj6U/mqdefault.jpg",
    "title": "【#スバおかおっぱっぴー 】スバおかマリカー/suba oka Mario Kart 8 Deluxe【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-28T15:45:57Z"
  },
  {
    "videoId": "qCS5wZ5GgRU",
    "thumbnail": "https://i.ytimg.com/vi/qCS5wZ5GgRU/mqdefault.jpg",
    "title": "【#２】進撃の巨人同時視聴しゅば！！！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-29T15:33:20Z"
  },
  {
    "videoId": "phFcbHoKdfk",
    "thumbnail": "https://i.ytimg.com/vi/phFcbHoKdfk/mqdefault.jpg",
    "title": "【#生スバル】年末だ！！！！！おはすば！！！！！ / OHASHUBA！！！【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-30T02:13:15Z"
  },
  {
    "videoId": "pnV_LL_HeX4",
    "thumbnail": "https://i.ytimg.com/vi/pnV_LL_HeX4/mqdefault.jpg",
    "title": "【＃4】龍が如く５やるしゅばあああああああああああああああああああああああああああああ！！！！！：YAKUZA５【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-30T09:13:33Z"
  },
  {
    "videoId": "JQpi7iiR5lc",
    "thumbnail": "https://i.ytimg.com/vi/JQpi7iiR5lc/mqdefault.jpg",
    "title": "【＃ホロライブの壺】妖精さん達がお悩み解決！！！！！ホロライバーの主張！！！！！！！【ホロライブ】",
    "publishedAt": "2023-12-30T12:14:34Z"
  },
  {
    "videoId": "EctK8aqf084",
    "thumbnail": "https://i.ytimg.com/vi/EctK8aqf084/mqdefault.jpg",
    "title": "【＃5】龍が如く５やるしゅばあああああああああああああああああああああああああああああ！！！！！：YAKUZA５【ホロライブ/大空スバル】",
    "publishedAt": "2023-12-31T09:36:31Z"
  },
  {
    "videoId": "8kKYocXRAxM",
    "thumbnail": "https://i.ytimg.com/vi/8kKYocXRAxM/mqdefault.jpg",
    "title": "【#生スバル】元日！！！！！ドラクエ１クリア耐久～！！！！！！/ Dragon Warrior ※ネタバレあり【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-01T07:27:22Z"
  },
  {
    "videoId": "ebKaS2tFYms",
    "thumbnail": "https://i.ytimg.com/vi/ebKaS2tFYms/mqdefault.jpg",
    "title": "【#生スバル】ドラクエ１クリア耐久～！！！！！！/ Dragon Warrior ※ネタバレあり【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-02T10:31:57Z"
  },
  {
    "videoId": "iZ6-EPaYDtE",
    "thumbnail": "https://i.ytimg.com/vi/iZ6-EPaYDtE/mqdefault.jpg",
    "title": "【#れなスバ】お正月！！遊戯王福袋開封企画しゅばあああああああああああああああ！！！！/ Yu-Gi-Oh! lucky bag【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-02T12:06:46Z"
  },
  {
    "videoId": "2Uzn84_gLtU",
    "thumbnail": "https://i.ytimg.com/vi/2Uzn84_gLtU/mqdefault.jpg",
    "title": "【#生スバル】だれか…誰かスバルに新年の挨拶をさせてくれ…！！！…新春告知なし地獄凸待ち 【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-04T14:16:58Z"
  },
  {
    "videoId": "a1zSAoPNmRE",
    "thumbnail": "https://i.ytimg.com/vi/a1zSAoPNmRE/mqdefault.jpg",
    "title": "【#３】進撃の巨人同時視聴しゅば！！！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-05T14:52:35Z"
  },
  {
    "videoId": "nvnpK3uLjBE",
    "thumbnail": "https://i.ytimg.com/vi/nvnpK3uLjBE/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！切り抜き禁止でおねがいします～！【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-06T02:19:31Z"
  },
  {
    "videoId": "GL9GmFuNS10",
    "thumbnail": "https://i.ytimg.com/vi/GL9GmFuNS10/mqdefault.jpg",
    "title": "【＃6】龍が如く５やるしゅばあああああああああああああああああああああああああああああ！！！！！：YAKUZA５【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-06T10:52:49Z"
  },
  {
    "videoId": "V9_vOnwwuP0",
    "thumbnail": "https://i.ytimg.com/vi/V9_vOnwwuP0/mqdefault.jpg",
    "title": "【＃7】龍が如く５やるしゅばあああああああああああああああああああああああああああああ！！！！！：YAKUZA５【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-07T06:10:56Z"
  },
  {
    "videoId": "Tu-uR0pSNvI",
    "thumbnail": "https://i.ytimg.com/vi/Tu-uR0pSNvI/mqdefault.jpg",
    "title": "【 #ホロお正月CUP2024 】マリカ大会予選Bがんばるしゅばああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-07T09:25:08Z"
  },
  {
    "videoId": "_4BV36nFZgQ",
    "thumbnail": "https://i.ytimg.com/vi/_4BV36nFZgQ/mqdefault.jpg",
    "title": "【 #ホロお正月CUP2024 】マリカ大会つよ杯がんばるしゅばああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-08T11:42:44Z"
  },
  {
    "videoId": "kUbJVFkrLyk",
    "thumbnail": "https://i.ytimg.com/vi/kUbJVFkrLyk/mqdefault.jpg",
    "title": "【#生スバル】最近あったこといろいろ！！！！限界フリーダム雑談！！！！！！！！！ / Free talk【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-10T13:37:52Z"
  },
  {
    "videoId": "HSCk2eEJ1V0",
    "thumbnail": "https://i.ytimg.com/vi/HSCk2eEJ1V0/mqdefault.jpg",
    "title": "【#ババドナ】ついにあのセカワー実況するしゅばあああああああああああああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-11T13:31:47Z"
  },
  {
    "videoId": "1_2O74AL7oo",
    "thumbnail": "https://i.ytimg.com/vi/1_2O74AL7oo/mqdefault.jpg",
    "title": "【#４】進撃の巨人同時視聴しゅば！！！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-12T12:58:41Z"
  },
  {
    "videoId": "qzldoFdPBbo",
    "thumbnail": "https://i.ytimg.com/vi/qzldoFdPBbo/mqdefault.jpg",
    "title": "【＃生スバル】今日は久しぶりのスト６！！！！！ダイヤ２目指すぞ～～～～！！！！！！ / street fighter 6【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-16T13:03:55Z"
  },
  {
    "videoId": "IMggtlWPCqM",
    "thumbnail": "https://i.ytimg.com/vi/IMggtlWPCqM/mqdefault.jpg",
    "title": "【＃前半】エオルゼアの大地に降り立つしゅばあああああ！！！！！ファイナルファンタジーXIV(FF14)【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-18T06:00:03Z"
  },
  {
    "videoId": "stpMxuv0VmE",
    "thumbnail": "https://i.ytimg.com/vi/stpMxuv0VmE/mqdefault.jpg",
    "title": "【ネタバレあり】【＃生スバル】人生初MMO！！！FF14！！！リスナーさんと一緒にイフリート討伐するしゅばあああああああ！！！！：FFⅩⅣ【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-18T12:10:51Z"
  },
  {
    "videoId": "DS7HVHZLKro",
    "thumbnail": "https://i.ytimg.com/vi/DS7HVHZLKro/mqdefault.jpg",
    "title": "【＃すばちょこるなたん】海外で今大流行中のLethal Companyするしゅばああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-18T15:49:58Z"
  },
  {
    "videoId": "tI7Y6XZwdvg",
    "thumbnail": "https://i.ytimg.com/vi/tI7Y6XZwdvg/mqdefault.jpg",
    "title": "【＃後半】オブパワー、ダンジョンデビューしゅばああああ！！！！！ファイナルファンタジーXIV(FF14)【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-19T06:00:14Z"
  },
  {
    "videoId": "d5xBXQ54LQ4",
    "thumbnail": "https://i.ytimg.com/vi/d5xBXQ54LQ4/mqdefault.jpg",
    "title": "【#５】進撃の巨人同時視聴しゅば！！！season1 ep20から最後まで！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-19T14:06:16Z"
  },
  {
    "videoId": "-wFQx9FirUA",
    "thumbnail": "https://i.ytimg.com/vi/-wFQx9FirUA/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-20T02:14:34Z"
  },
  {
    "videoId": "QWVOZgsz7tg",
    "thumbnail": "https://i.ytimg.com/vi/QWVOZgsz7tg/mqdefault.jpg",
    "title": "【＃8】龍が如く５やるしゅばあああああああああああああああああああああああああああああ！！！！！：YAKUZA５【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-20T09:18:02Z"
  },
  {
    "videoId": "O3atYuCrK5Y",
    "thumbnail": "https://i.ytimg.com/vi/O3atYuCrK5Y/mqdefault.jpg",
    "title": "【＃9】龍が如く５やるしゅばあああああああああああああああああああああああああああああ！！！！！：YAKUZA５【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-21T10:38:55Z"
  },
  {
    "videoId": "t8b6kgtagUo",
    "thumbnail": "https://i.ytimg.com/vi/t8b6kgtagUo/mqdefault.jpg",
    "title": "【グロ注意】最強スマホホラゲ！？呪巣 -怨ノ章-ミオスバホラーナイト【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-23T12:39:23Z"
  },
  {
    "videoId": "Dxc0lNTB_KU",
    "thumbnail": "https://i.ytimg.com/vi/Dxc0lNTB_KU/mqdefault.jpg",
    "title": "【#生スバル】遂にログイン成功；；ホロ鯖初パルワールドしゅばあああああああああああああああああああああああ！！！！ / Palworld 【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-24T16:39:05Z"
  },
  {
    "videoId": "r2SVF6mKXuU",
    "thumbnail": "https://i.ytimg.com/vi/r2SVF6mKXuU/mqdefault.jpg",
    "title": "【#生スバル】お願いしますダイヤ２行かせてくださいおねがいおねがいおねがいおねがいおねがいおねがいおねがいおねがいおねがいおねがい/street fighter 6【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-25T12:54:54Z"
  },
  {
    "videoId": "3bsiG0KyA7E",
    "thumbnail": "https://i.ytimg.com/vi/3bsiG0KyA7E/mqdefault.jpg",
    "title": "【#生スバル】初ボス討伐！！！！ホロ鯖パルワールドしゅばあああああああああああああああああああああああ！！！！ / Palworld 【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-25T15:56:09Z"
  },
  {
    "videoId": "K8zSXNJXBEc",
    "thumbnail": "https://i.ytimg.com/vi/K8zSXNJXBEc/mqdefault.jpg",
    "title": "#MOTTAI 制服で踊ってみた〰️！‪⸜‪‪‪‪‪︎🐣⸝‬‪‪ #shorts #short #踊ってみた",
    "publishedAt": "2024-01-26T11:00:17Z"
  },
  {
    "videoId": "fX1Ik6ESlpg",
    "thumbnail": "https://i.ytimg.com/vi/fX1Ik6ESlpg/mqdefault.jpg",
    "title": "【#生スバル】進撃の巨人同時視聴しゅば！！！season2 Ep1から！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-26T15:00:39Z"
  },
  {
    "videoId": "NxUlKcyB6lM",
    "thumbnail": "https://i.ytimg.com/vi/NxUlKcyB6lM/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-27T02:15:16Z"
  },
  {
    "videoId": "ANMa8P-ZvSg",
    "thumbnail": "https://i.ytimg.com/vi/ANMa8P-ZvSg/mqdefault.jpg",
    "title": "【＃10】龍が如く５やるしゅばあああああああああああああああああああああああああああああ！！！！！：YAKUZA５【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-27T10:34:05Z"
  },
  {
    "videoId": "kGehAY5GOA4",
    "thumbnail": "https://i.ytimg.com/vi/kGehAY5GOA4/mqdefault.jpg",
    "title": "【＃11】龍が如く５やるしゅばあああああああああああああああああああああああああああああ！！！！！：YAKUZA５【ホロライブ/大空スバル】",
    "publishedAt": "2024-01-28T09:41:52Z"
  },
  {
    "videoId": "ZKg4XX73zqk",
    "thumbnail": "https://i.ytimg.com/vi/ZKg4XX73zqk/mqdefault.jpg",
    "title": "#愛包ダンスホール 踊ってみたよ〰️！🥧 #踊ってみた #shorts #short",
    "publishedAt": "2024-01-31T11:22:12Z"
  },
  {
    "videoId": "XP_ZY9LOzco",
    "thumbnail": "https://i.ytimg.com/vi/XP_ZY9LOzco/mqdefault.jpg",
    "title": "【＃スバぼた】ついにスバぼたスト６やるしゅばああああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-02T12:11:14Z"
  },
  {
    "videoId": "Sagvq_8FpsU",
    "thumbnail": "https://i.ytimg.com/vi/Sagvq_8FpsU/mqdefault.jpg",
    "title": "【#6】進撃の巨人同時視聴しゅば！！！season2 Ep34から！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-02T15:10:22Z"
  },
  {
    "videoId": "OlxCG2d2bm0",
    "thumbnail": "https://i.ytimg.com/vi/OlxCG2d2bm0/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-03T02:11:47Z"
  },
  {
    "videoId": "Iwu4cHZPn4c",
    "thumbnail": "https://i.ytimg.com/vi/Iwu4cHZPn4c/mqdefault.jpg",
    "title": "【＃1２】龍が如く５やるしゅばあああああああああああああああああああああああああああああ！！！！！：YAKUZA５【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-03T09:34:24Z"
  },
  {
    "videoId": "VcDJtlDMDVI",
    "thumbnail": "https://i.ytimg.com/vi/VcDJtlDMDVI/mqdefault.jpg",
    "title": "【＃ホロトランプ王】トランプ最弱は誰だ？！ガチンコ遊び大全トランプバトル！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-03T14:15:59Z"
  },
  {
    "videoId": "RWcV8Ayb6jE",
    "thumbnail": "https://i.ytimg.com/vi/RWcV8Ayb6jE/mqdefault.jpg",
    "title": "【＃最終回】龍が如く５やるしゅばあああああああああああああああああああああああああああああ！！！！！：YAKUZA５【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-04T12:50:08Z"
  },
  {
    "videoId": "xBSgFCpbYnY",
    "thumbnail": "https://i.ytimg.com/vi/xBSgFCpbYnY/mqdefault.jpg",
    "title": "【＃スバちょこるなたん】すばちょこるなたん３D！！！重大告知あり！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-06T13:06:10Z"
  },
  {
    "videoId": "-o1zaPYUXZ4",
    "thumbnail": "https://i.ytimg.com/vi/-o1zaPYUXZ4/mqdefault.jpg",
    "title": "【#生スバル】スト６殴り愛！！！！！！！！魂の１０先コラボ / street fighter 6【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-07T15:28:52Z"
  },
  {
    "videoId": "zwN7V5NdI04",
    "thumbnail": "https://i.ytimg.com/vi/zwN7V5NdI04/mqdefault.jpg",
    "title": "【＃生スバル】たまにはゆっくり雑談しよ～～～～～～～～～～！！！！！！！！！！！！！ / Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-08T12:24:28Z"
  },
  {
    "videoId": "0fc-lEvy2Yg",
    "thumbnail": "https://i.ytimg.com/vi/0fc-lEvy2Yg/mqdefault.jpg",
    "title": "【ヘブバン2周年】 ヘブンバーンズレッドとAngel Beats!のコラボイベントをプレイしてみるしゅばあああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-09T12:04:29Z"
  },
  {
    "videoId": "mkVUKEfcvHQ",
    "thumbnail": "https://i.ytimg.com/vi/mkVUKEfcvHQ/mqdefault.jpg",
    "title": "【#7】進撃の巨人同時視聴しゅば！！！OVA・season3から！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-09T15:06:30Z"
  },
  {
    "videoId": "IjaOXj-xpkI",
    "thumbnail": "https://i.ytimg.com/vi/IjaOXj-xpkI/mqdefault.jpg",
    "title": "【#生スバル】METAL GEAR SOLIDやるしゅばああああああああ！！！/METAL GEAR SOLID【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-10T13:57:10Z"
  },
  {
    "videoId": "wckHtrY-xuc",
    "thumbnail": "https://i.ytimg.com/vi/wckHtrY-xuc/mqdefault.jpg",
    "title": "【＃生スバル】不　審　者　情　報　【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-11T12:28:25Z"
  },
  {
    "videoId": "ndz7Q4GBhgo",
    "thumbnail": "https://i.ytimg.com/vi/ndz7Q4GBhgo/mqdefault.jpg",
    "title": "モア！ジャンプ！モア！踊ってみたよ❣️ハッピーバレンタイン！🍓🍫✨️ #shorts #short #踊ってみた",
    "publishedAt": "2024-02-14T11:00:43Z"
  },
  {
    "videoId": "rFuHdwIKhtQ",
    "thumbnail": "https://i.ytimg.com/vi/rFuHdwIKhtQ/mqdefault.jpg",
    "title": "【＃生スバル】みんなにチョコつくり！！！うまくできるかは知らぬ【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-14T13:22:36Z"
  },
  {
    "videoId": "OliZi5qDnXI",
    "thumbnail": "https://i.ytimg.com/vi/OliZi5qDnXI/mqdefault.jpg",
    "title": "【#8】進撃の巨人同時視聴しゅば！！！season3から！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-16T14:31:04Z"
  },
  {
    "videoId": "cpkXE0_W3OA",
    "thumbnail": "https://i.ytimg.com/vi/cpkXE0_W3OA/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-17T02:27:35Z"
  },
  {
    "videoId": "mxzjnsO-dBw",
    "thumbnail": "https://i.ytimg.com/vi/mxzjnsO-dBw/mqdefault.jpg",
    "title": "【#最終回】METAL GEAR SOLIDやるしゅばああああああああ！！！/METAL GEAR SOLID【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-17T10:19:17Z"
  },
  {
    "videoId": "PHPWFt6d5TM",
    "thumbnail": "https://i.ytimg.com/vi/PHPWFt6d5TM/mqdefault.jpg",
    "title": "【#生スバル】神ゲーと噂の『ネタバレが激しすぎるＲＰＧ―最後の敵の正体は勇者の父―』をプレイするしゅばあああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-18T09:31:03Z"
  },
  {
    "videoId": "2_r68HfDR9Q",
    "thumbnail": "https://i.ytimg.com/vi/2_r68HfDR9Q/mqdefault.jpg",
    "title": "【遊戯王】マスターデュエルでぺこちゃんと視聴者とデュエル！しゅばあああああああああああああ！！/ MASTER DUEL【ホロライブ / 大空スバル】",
    "publishedAt": "2024-02-20T14:27:20Z"
  },
  {
    "videoId": "DJu6T7iX7fQ",
    "thumbnail": "https://i.ytimg.com/vi/DJu6T7iX7fQ/mqdefault.jpg",
    "title": "【＃スバルの小屋】スバルの小屋　ゲスト：ノエル！/NOEL Suba Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-21T12:04:02Z"
  },
  {
    "videoId": "ROWwXfMZQbc",
    "thumbnail": "https://i.ytimg.com/vi/ROWwXfMZQbc/mqdefault.jpg",
    "title": "【#9】進撃の巨人同時視聴しゅば！！！season3 ep48から！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-23T15:14:12Z"
  },
  {
    "videoId": "YNRqGn5YzLQ",
    "thumbnail": "https://i.ytimg.com/vi/YNRqGn5YzLQ/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-24T02:48:49Z"
  },
  {
    "videoId": "gKMkzgmPKE4",
    "thumbnail": "https://i.ytimg.com/vi/gKMkzgmPKE4/mqdefault.jpg",
    "title": "【#生スバル】METAL GEAR SOLID 2 SONS OF LIBERTY やるしゅばああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-24T09:41:54Z"
  },
  {
    "videoId": "4s5zX8agiB8",
    "thumbnail": "https://i.ytimg.com/vi/4s5zX8agiB8/mqdefault.jpg",
    "title": "【#2】METAL GEAR SOLID 2 SONS OF LIBERTY やるしゅばああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-25T08:34:19Z"
  },
  {
    "videoId": "GEgMPHX6_c8",
    "thumbnail": "https://i.ytimg.com/vi/GEgMPHX6_c8/mqdefault.jpg",
    "title": "【 #大空スバル５周年 】大空スバル５周年記念ライブ ～ 5th Anniversary Live Stellar Symphony ～【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-25T13:02:28Z"
  },
  {
    "videoId": "aP6JtCkATA8",
    "thumbnail": "https://i.ytimg.com/vi/aP6JtCkATA8/mqdefault.jpg",
    "title": "【#生スバル】５周年ライブありがとうございました！！！裏話など～～～！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-02-27T17:27:38Z"
  },
  {
    "videoId": "wDoRy-9JXM0",
    "thumbnail": "https://i.ytimg.com/vi/wDoRy-9JXM0/mqdefault.jpg",
    "title": "【実験】ホロライブ本社にノートを１ヶ月放置しておいたら…？ / If you leave a notebook at the Hololive headquarters for a month...?",
    "publishedAt": "2024-02-29T14:18:42Z"
  },
  {
    "videoId": "QsMDNc2WkeI",
    "thumbnail": "https://i.ytimg.com/vi/QsMDNc2WkeI/mqdefault.jpg",
    "title": "【#10】進撃の巨人同時視聴しゅば！！！season3 ep56から最後まで！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-01T15:17:09Z"
  },
  {
    "videoId": "goliPVGUcVw",
    "thumbnail": "https://i.ytimg.com/vi/goliPVGUcVw/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-02T02:16:20Z"
  },
  {
    "videoId": "3XWgDV1DtQ8",
    "thumbnail": "https://i.ytimg.com/vi/3XWgDV1DtQ8/mqdefault.jpg",
    "title": "【#3】METAL GEAR SOLID 2 SONS OF LIBERTY やるしゅばああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-02T10:39:27Z"
  },
  {
    "videoId": "MHE1-ofu97w",
    "thumbnail": "https://i.ytimg.com/vi/MHE1-ofu97w/mqdefault.jpg",
    "title": "【#4】METAL GEAR SOLID 2 SONS OF LIBERTY やるしゅばああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-03T09:09:26Z"
  },
  {
    "videoId": "TfDnuWKJvBs",
    "thumbnail": "https://i.ytimg.com/vi/TfDnuWKJvBs/mqdefault.jpg",
    "title": "【実験】27億のスタジオにノートを１ヶ月放置しておいたら…？ / If you leave a notebook at the Hololive Studio for a month...?",
    "publishedAt": "2024-03-05T12:16:02Z"
  },
  {
    "videoId": "9EfuAuvObFA",
    "thumbnail": "https://i.ytimg.com/vi/9EfuAuvObFA/mqdefault.jpg",
    "title": "【#生スバル】ホラゲー迷宮校舎するしゅばあああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-07T16:15:24Z"
  },
  {
    "videoId": "8oHaszW5aY4",
    "thumbnail": "https://i.ytimg.com/vi/8oHaszW5aY4/mqdefault.jpg",
    "title": "【#10】進撃の巨人同時視聴しゅば！！！The Final Season ep60から！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-08T15:13:57Z"
  },
  {
    "videoId": "397hWc4-DmI",
    "thumbnail": "https://i.ytimg.com/vi/397hWc4-DmI/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-09T02:15:28Z"
  },
  {
    "videoId": "lx6ZTHSrS54",
    "thumbnail": "https://i.ytimg.com/vi/lx6ZTHSrS54/mqdefault.jpg",
    "title": "【#生スバル】 METAL GEAR SOLID 3 SNAKE EATER やるしゅばああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-09T09:27:22Z"
  },
  {
    "videoId": "4CEYLNGdkZo",
    "thumbnail": "https://i.ytimg.com/vi/4CEYLNGdkZo/mqdefault.jpg",
    "title": "【#2】 METAL GEAR SOLID 3 SNAKE EATER やるしゅばああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-10T10:33:49Z"
  },
  {
    "videoId": "LdOpwr_i6sw",
    "thumbnail": "https://i.ytimg.com/vi/LdOpwr_i6sw/mqdefault.jpg",
    "title": "【オリジナル曲】Stellar Symphony【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-11T13:00:24Z"
  },
  {
    "videoId": "vGpQk-xhvrc",
    "thumbnail": "https://i.ytimg.com/vi/vGpQk-xhvrc/mqdefault.jpg",
    "title": "【#生スバル】トロッコ大爆発問題 しゅばあああああああああああああああああああああああああ！！！！/ Trolley Question of Armageddon.【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-12T12:53:25Z"
  },
  {
    "videoId": "OS2H1Z_M0jw",
    "thumbnail": "https://i.ytimg.com/vi/OS2H1Z_M0jw/mqdefault.jpg",
    "title": "【#わたスバ】幽霊アパートの謎に迫れ！！！！わためと開発中止になったクソ怖ホラゲーSupernormal【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-14T13:03:17Z"
  },
  {
    "videoId": "5QZCysfk_Sw",
    "thumbnail": "https://i.ytimg.com/vi/5QZCysfk_Sw/mqdefault.jpg",
    "title": "明日はいよいよ5thフェスだ〰️！🥳✨️ #shorts  #short  # #vtuber",
    "publishedAt": "2024-03-15T03:18:14Z"
  },
  {
    "videoId": "818K9pvQczc",
    "thumbnail": "https://i.ytimg.com/vi/818K9pvQczc/mqdefault.jpg",
    "title": "【＃生スバル】おやすば【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-15T12:46:54Z"
  },
  {
    "videoId": "dL-XZhtgsUM",
    "thumbnail": "https://i.ytimg.com/vi/dL-XZhtgsUM/mqdefault.jpg",
    "title": "【#12】進撃の巨人同時視聴しゅば！！！The Final Season ep68から！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-15T15:02:05Z"
  },
  {
    "videoId": "TprwtnyzUVw",
    "thumbnail": "https://i.ytimg.com/vi/TprwtnyzUVw/mqdefault.jpg",
    "title": "【#生スバル】5th Fes応援＆感想枠しゅばあああああああああ！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-17T16:32:52Z"
  },
  {
    "videoId": "n8jSscFWM4s",
    "thumbnail": "https://i.ytimg.com/vi/n8jSscFWM4s/mqdefault.jpg",
    "title": "【＃生スバル】急募新ブラマジガール！！！！！遊戯王大開封祭り時代 / YU-GI-OH!【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-19T13:40:49Z"
  },
  {
    "videoId": "Yp_wy1zqdOI",
    "thumbnail": "https://i.ytimg.com/vi/Yp_wy1zqdOI/mqdefault.jpg",
    "title": "【#生スバル】ホラゲー！！！娘の部屋 / A Shut-in Daughter【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-20T14:23:20Z"
  },
  {
    "videoId": "A0vNbSSWpNY",
    "thumbnail": "https://i.ytimg.com/vi/A0vNbSSWpNY/mqdefault.jpg",
    "title": "【#生スバル】ChatGPT（AI）に「真実」を聞く配信【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-21T12:43:17Z"
  },
  {
    "videoId": "CjC2mv6SQAk",
    "thumbnail": "https://i.ytimg.com/vi/CjC2mv6SQAk/mqdefault.jpg",
    "title": "【#13】進撃の巨人同時視聴しゅば！！！The Final Season ep72から！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-22T15:37:06Z"
  },
  {
    "videoId": "fyXsWV5hTsE",
    "thumbnail": "https://i.ytimg.com/vi/fyXsWV5hTsE/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-23T02:08:48Z"
  },
  {
    "videoId": "rcVXivYs5bc",
    "thumbnail": "https://i.ytimg.com/vi/rcVXivYs5bc/mqdefault.jpg",
    "title": "【#3】 METAL GEAR SOLID 3 SNAKE EATER やるしゅばああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-23T09:33:26Z"
  },
  {
    "videoId": "rGXXgHlTY7U",
    "thumbnail": "https://i.ytimg.com/vi/rGXXgHlTY7U/mqdefault.jpg",
    "title": "【#4】 METAL GEAR SOLID 3 SNAKE EATER やるしゅばああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-24T10:58:53Z"
  },
  {
    "videoId": "JNZh6YGocaU",
    "thumbnail": "https://i.ytimg.com/vi/JNZh6YGocaU/mqdefault.jpg",
    "title": "【＃生スバル】新幹線０号【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-26T15:51:26Z"
  },
  {
    "videoId": "I9m1Bj9pb0o",
    "thumbnail": "https://i.ytimg.com/vi/I9m1Bj9pb0o/mqdefault.jpg",
    "title": "【＃生スバル】スバルの小屋　ゲスト：フレア！/Flare Suba Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-27T12:05:34Z"
  },
  {
    "videoId": "9ehyKHmLcqw",
    "thumbnail": "https://i.ytimg.com/vi/9ehyKHmLcqw/mqdefault.jpg",
    "title": "【＃生スバル】全CPUに勝って誰かにバトンを回すまで終われない五目並べ【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-28T12:31:52Z"
  },
  {
    "videoId": "pBvTIoC9gLY",
    "thumbnail": "https://i.ytimg.com/vi/pBvTIoC9gLY/mqdefault.jpg",
    "title": "【#14】進撃の巨人同時視聴しゅば！！！The Final Season ep72から！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-29T14:42:29Z"
  },
  {
    "videoId": "X1bG3-2_1ig",
    "thumbnail": "https://i.ytimg.com/vi/X1bG3-2_1ig/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-30T02:29:12Z"
  },
  {
    "videoId": "aeh5fs6iG8M",
    "thumbnail": "https://i.ytimg.com/vi/aeh5fs6iG8M/mqdefault.jpg",
    "title": "【#5】 METAL GEAR SOLID 3 SNAKE EATER やるしゅばああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-03-30T08:38:05Z"
  },
  {
    "videoId": "5laO6_3SmaI",
    "thumbnail": "https://i.ytimg.com/vi/5laO6_3SmaI/mqdefault.jpg",
    "title": "【TABS】戦いだあああああああああああああああああああああああああああああああ！！！！/ Totally Accurate Battle Simulator 【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-02T12:03:33Z"
  },
  {
    "videoId": "3ro_QElo65Y",
    "thumbnail": "https://i.ytimg.com/vi/3ro_QElo65Y/mqdefault.jpg",
    "title": "【#ホロ迷宮校舎】迷宮校舎コラボで大暴れしゅばああああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-02T14:56:19Z"
  },
  {
    "videoId": "ERV98-IYzQQ",
    "thumbnail": "https://i.ytimg.com/vi/ERV98-IYzQQ/mqdefault.jpg",
    "title": "【#生スバル】世界一の泥棒におれはなる / Thief Simulator 2【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-04T13:41:29Z"
  },
  {
    "videoId": "f14ILXKs5VM",
    "thumbnail": "https://i.ytimg.com/vi/f14ILXKs5VM/mqdefault.jpg",
    "title": "【#15】進撃の巨人同時視聴しゅば！！！The Final Season ep84から！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-05T14:04:21Z"
  },
  {
    "videoId": "jFJQ5qwep8A",
    "thumbnail": "https://i.ytimg.com/vi/jFJQ5qwep8A/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-06T02:33:54Z"
  },
  {
    "videoId": "TBiVWvA5xiQ",
    "thumbnail": "https://i.ytimg.com/vi/TBiVWvA5xiQ/mqdefault.jpg",
    "title": "【#生スバル】 FINAL FANTASY VII REBIRTH するしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2024-04-06T09:44:41Z"
  },
  {
    "videoId": "agpMD7eYXuQ",
    "thumbnail": "https://i.ytimg.com/vi/agpMD7eYXuQ/mqdefault.jpg",
    "title": "【#2】 FINAL FANTASY VII REBIRTH するしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2024-04-07T10:59:57Z"
  },
  {
    "videoId": "jPJ8yYa8JnY",
    "thumbnail": "https://i.ytimg.com/vi/jPJ8yYa8JnY/mqdefault.jpg",
    "title": "【#ババドナ】とっとこハム太郎３らぶらぶ大冒険でちゅ♡するしゅばあああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-09T13:03:43Z"
  },
  {
    "videoId": "t5POQgOZ1qU",
    "thumbnail": "https://i.ytimg.com/vi/t5POQgOZ1qU/mqdefault.jpg",
    "title": "【＃生スバル】スバルの小屋　ゲスト：ころね！/Korone Suba Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-10T12:03:49Z"
  },
  {
    "videoId": "SYscjMa3tnM",
    "thumbnail": "https://i.ytimg.com/vi/SYscjMa3tnM/mqdefault.jpg",
    "title": "【#最終回】進撃の巨人同時視聴しゅば！！！The Final Season 放送版完結編！：Attack on Titan watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-12T16:12:02Z"
  },
  {
    "videoId": "vQqdEr9IUPI",
    "thumbnail": "https://i.ytimg.com/vi/vQqdEr9IUPI/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-13T02:26:23Z"
  },
  {
    "videoId": "M6Qp0tJnOl4",
    "thumbnail": "https://i.ytimg.com/vi/M6Qp0tJnOl4/mqdefault.jpg",
    "title": "【#3】 FINAL FANTASY VII REBIRTH するしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2024-04-13T09:43:05Z"
  },
  {
    "videoId": "mZM0Z6d6a18",
    "thumbnail": "https://i.ytimg.com/vi/mZM0Z6d6a18/mqdefault.jpg",
    "title": "【#4】 FINAL FANTASY VII REBIRTH するしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2024-04-14T09:28:05Z"
  },
  {
    "videoId": "sp9UV6YSbsI",
    "thumbnail": "https://i.ytimg.com/vi/sp9UV6YSbsI/mqdefault.jpg",
    "title": "【#生スバル】ホラゲーSILENT HILL: The Short Messageするしゅばああああああああああああああああああああ！！！！【ネタバレあり】",
    "publishedAt": "2024-04-16T14:19:38Z"
  },
  {
    "videoId": "M893vKcRe1w",
    "thumbnail": "https://i.ytimg.com/vi/M893vKcRe1w/mqdefault.jpg",
    "title": "【#生スバル】進撃の巨人のゲームするしゅばあああああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-17T14:47:55Z"
  },
  {
    "videoId": "KVIjv7hWD6Y",
    "thumbnail": "https://i.ytimg.com/vi/KVIjv7hWD6Y/mqdefault.jpg",
    "title": "#bbbbダンス 踊ってみたよ～！🪄︎︎✨ #shorts  #short  #踊ってみた",
    "publishedAt": "2024-04-19T10:34:03Z"
  },
  {
    "videoId": "cKou-f-ztBA",
    "thumbnail": "https://i.ytimg.com/vi/cKou-f-ztBA/mqdefault.jpg",
    "title": "【#生スバル】ジョジョ３部同時視聴 / watching party JoJo's Bizarre Adventure: Part 3--Stardust Crusaders【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-19T15:02:45Z"
  },
  {
    "videoId": "axSwNmIUdco",
    "thumbnail": "https://i.ytimg.com/vi/axSwNmIUdco/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-20T02:36:29Z"
  },
  {
    "videoId": "WcDs_RqcaaU",
    "thumbnail": "https://i.ytimg.com/vi/WcDs_RqcaaU/mqdefault.jpg",
    "title": "【#5】 FINAL FANTASY VII REBIRTH するしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2024-04-20T10:17:11Z"
  },
  {
    "videoId": "zm81XfkV_7w",
    "thumbnail": "https://i.ytimg.com/vi/zm81XfkV_7w/mqdefault.jpg",
    "title": "【#6】 FINAL FANTASY VII REBIRTH するしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2024-04-21T10:21:05Z"
  },
  {
    "videoId": "EWMw7dUKtzk",
    "thumbnail": "https://i.ytimg.com/vi/EWMw7dUKtzk/mqdefault.jpg",
    "title": "【#生スバル】恐い動画撮って心霊系youtuberになるしゅばああああああああああああああ！！！！！ / Content Warning",
    "publishedAt": "2024-04-23T12:12:57Z"
  },
  {
    "videoId": "_TzHDQ9pWPg",
    "thumbnail": "https://i.ytimg.com/vi/_TzHDQ9pWPg/mqdefault.jpg",
    "title": "【#生スバル】スト６視聴者参加３勝するまで終われません！！！！！！！！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-25T15:08:56Z"
  },
  {
    "videoId": "4LRUIRdaPUk",
    "thumbnail": "https://i.ytimg.com/vi/4LRUIRdaPUk/mqdefault.jpg",
    "title": "【#2】ジョジョ３部同時視聴 ep7~ep12 / watching party JoJo's Bizarre Adventure: Part 3--Stardust Crusaders【大空スバル】",
    "publishedAt": "2024-04-26T15:23:51Z"
  },
  {
    "videoId": "Qmwopd8AqXA",
    "thumbnail": "https://i.ytimg.com/vi/Qmwopd8AqXA/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-27T02:20:40Z"
  },
  {
    "videoId": "4YquhaMTQYE",
    "thumbnail": "https://i.ytimg.com/vi/4YquhaMTQYE/mqdefault.jpg",
    "title": "【#7】 FINAL FANTASY VII REBIRTH するしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2024-04-27T09:00:02Z"
  },
  {
    "videoId": "sBS6dyzvhpk",
    "thumbnail": "https://i.ytimg.com/vi/sBS6dyzvhpk/mqdefault.jpg",
    "title": "【#8】 FINAL FANTASY VII REBIRTH するしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2024-04-28T09:08:40Z"
  },
  {
    "videoId": "9Yf9CIlaB-0",
    "thumbnail": "https://i.ytimg.com/vi/9Yf9CIlaB-0/mqdefault.jpg",
    "title": "【#ホロドロケイ2024】ホロドロケイ！！！！！泥棒視点しゅばああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-28T13:39:34Z"
  },
  {
    "videoId": "gl5Jgbc2LLY",
    "thumbnail": "https://i.ytimg.com/vi/gl5Jgbc2LLY/mqdefault.jpg",
    "title": "💥Attack on Subaru 💥 進撃の巨人見終わった記念～！！  #shorts #short",
    "publishedAt": "2024-04-30T10:09:39Z"
  },
  {
    "videoId": "o2QS7mrak1U",
    "thumbnail": "https://i.ytimg.com/vi/o2QS7mrak1U/mqdefault.jpg",
    "title": "【#生スバル】かまいたちの夜 特別編 クリア耐久【ホロライブ/大空スバル】",
    "publishedAt": "2024-04-30T19:39:40Z"
  },
  {
    "videoId": "-b1mu7cFRyQ",
    "thumbnail": "https://i.ytimg.com/vi/-b1mu7cFRyQ/mqdefault.jpg",
    "title": "#ビビデバ 踊ってみた～！💫✨️ #踊ってみた #shorts #short",
    "publishedAt": "2024-05-01T09:00:00Z"
  },
  {
    "videoId": "jP9q9NXVnvo",
    "thumbnail": "https://i.ytimg.com/vi/jP9q9NXVnvo/mqdefault.jpg",
    "title": "【#生スバル】世界的人気？！？俺だけレベルアップな件：ARISEをプレイしてみるしゅばああああああああああああ！！！！！/ Solo Leveling【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-01T11:53:52Z"
  },
  {
    "videoId": "9F_H9MuuJWU",
    "thumbnail": "https://i.ytimg.com/vi/9F_H9MuuJWU/mqdefault.jpg",
    "title": "【＃生スバル】スバルの小屋　ゲスト：カリちゃん！/CALLI Suba Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-02T14:00:28Z"
  },
  {
    "videoId": "j1fP38QKDng",
    "thumbnail": "https://i.ytimg.com/vi/j1fP38QKDng/mqdefault.jpg",
    "title": "【#3】ジョジョ３部同時視聴 ep14~ep18 / watching party JoJo's Bizarre Adventure: Part 3--Stardust Crusaders",
    "publishedAt": "2024-05-03T14:32:44Z"
  },
  {
    "videoId": "WKH_xxd3f2c",
    "thumbnail": "https://i.ytimg.com/vi/WKH_xxd3f2c/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-04T02:25:14Z"
  },
  {
    "videoId": "Xfoe5IsnvWA",
    "thumbnail": "https://i.ytimg.com/vi/Xfoe5IsnvWA/mqdefault.jpg",
    "title": "【#9】 FINAL FANTASY VII REBIRTH するしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2024-05-04T10:16:53Z"
  },
  {
    "videoId": "AHdZwVDIq1A",
    "thumbnail": "https://i.ytimg.com/vi/AHdZwVDIq1A/mqdefault.jpg",
    "title": "【#10】 FINAL FANTASY VII REBIRTH するしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2024-05-05T11:26:36Z"
  },
  {
    "videoId": "x__aTpCDSrU",
    "thumbnail": "https://i.ytimg.com/vi/x__aTpCDSrU/mqdefault.jpg",
    "title": "【＃生スバル】FCスーパーマリオブラザーズSWITCH版！！！クリア耐久～～～！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-06T20:30:24Z"
  },
  {
    "videoId": "o2rZVZ0KL9E",
    "thumbnail": "https://i.ytimg.com/vi/o2rZVZ0KL9E/mqdefault.jpg",
    "title": "【＃生スバル】負けたら即終了スト６しゅばああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-07T11:13:44Z"
  },
  {
    "videoId": "nL7S4-GZMPI",
    "thumbnail": "https://i.ytimg.com/vi/nL7S4-GZMPI/mqdefault.jpg",
    "title": "【＃生スバル】負けたら即終了スト６しゅばああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-07T11:48:34Z"
  },
  {
    "videoId": "K6m2CjFW3dQ",
    "thumbnail": "https://i.ytimg.com/vi/K6m2CjFW3dQ/mqdefault.jpg",
    "title": "【＃２】FCスーパーマリオブラザーズSWITCH版！！！ノーセーブクリア目指すぞ～～！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-07T19:43:41Z"
  },
  {
    "videoId": "JRl3NGwNzqc",
    "thumbnail": "https://i.ytimg.com/vi/JRl3NGwNzqc/mqdefault.jpg",
    "title": "【＃3】FCスーパーマリオブラザーズSWITCH版！！！ノーセーブクリア目指すぞ～～！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-09T12:58:19Z"
  },
  {
    "videoId": "doxn1a_ArdQ",
    "thumbnail": "https://i.ytimg.com/vi/doxn1a_ArdQ/mqdefault.jpg",
    "title": "【#4】ジョジョ３部同時視聴 ep19~ep24 / watching party JoJo's Bizarre Adventure: Part 3--Stardust Crusaders",
    "publishedAt": "2024-05-10T14:55:15Z"
  },
  {
    "videoId": "aRz9l857vL4",
    "thumbnail": "https://i.ytimg.com/vi/aRz9l857vL4/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！：ゲストはまた来週になりそう！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-11T02:12:13Z"
  },
  {
    "videoId": "4xghCXvB0qc",
    "thumbnail": "https://i.ytimg.com/vi/4xghCXvB0qc/mqdefault.jpg",
    "title": "【#11】 FINAL FANTASY VII REBIRTH するしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2024-05-11T09:08:26Z"
  },
  {
    "videoId": "411vIdTArCg",
    "thumbnail": "https://i.ytimg.com/vi/411vIdTArCg/mqdefault.jpg",
    "title": "【＃4】FCスーパーマリオブラザーズSWITCH版！！！ノーセーブクリア目指すぞ～～！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-11T18:16:57Z"
  },
  {
    "videoId": "2LcucuMe6W0",
    "thumbnail": "https://i.ytimg.com/vi/2LcucuMe6W0/mqdefault.jpg",
    "title": "【#12】 FINAL FANTASY VII REBIRTH するしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2024-05-12T10:50:09Z"
  },
  {
    "videoId": "Q26I-_DMQpw",
    "thumbnail": "https://i.ytimg.com/vi/Q26I-_DMQpw/mqdefault.jpg",
    "title": "SUBADANCEしゅば～！！🐥⸒⸒ #pokedance  #踊ってみた #shorts  #short",
    "publishedAt": "2024-05-13T11:40:18Z"
  },
  {
    "videoId": "1vWEK_b9BdM",
    "thumbnail": "https://i.ytimg.com/vi/1vWEK_b9BdM/mqdefault.jpg",
    "title": "【＃5】FCスーパーマリオブラザーズSWITCH版！！！ノーセーブクリア目指すぞ～～！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-14T18:14:45Z"
  },
  {
    "videoId": "iMbZYtwosfI",
    "thumbnail": "https://i.ytimg.com/vi/iMbZYtwosfI/mqdefault.jpg",
    "title": "【＃ホロ鯖ハードコアマイクラ】ハードコア・チンチロ / mine craft【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-15T16:59:19Z"
  },
  {
    "videoId": "R_iNY0ps5LM",
    "thumbnail": "https://i.ytimg.com/vi/R_iNY0ps5LM/mqdefault.jpg",
    "title": "【＃ホロ鯖ハードコアマイクラ】ハードコア・チンチロマイクラ2日目 / mine craft【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-16T14:31:04Z"
  },
  {
    "videoId": "b0t5Tr4LJbA",
    "thumbnail": "https://i.ytimg.com/vi/b0t5Tr4LJbA/mqdefault.jpg",
    "title": "【#5】ジョジョ３部同時視聴 エジプトへん！ / watching party JoJo's Bizarre Adventure: Part 3--Stardust Crusaders",
    "publishedAt": "2024-05-17T15:31:00Z"
  },
  {
    "videoId": "LckMeqdMDoE",
    "thumbnail": "https://i.ytimg.com/vi/LckMeqdMDoE/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！：ゲストあり！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-18T02:11:38Z"
  },
  {
    "videoId": "s1TdJWOmefU",
    "thumbnail": "https://i.ytimg.com/vi/s1TdJWOmefU/mqdefault.jpg",
    "title": "【#13】 FINAL FANTASY VII REBIRTH するしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2024-05-18T09:20:46Z"
  },
  {
    "videoId": "ktqrOp9ANO4",
    "thumbnail": "https://i.ytimg.com/vi/ktqrOp9ANO4/mqdefault.jpg",
    "title": "【#最終回】 FINAL FANTASY VII REBIRTH するしゅばああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2024-05-19T12:45:10Z"
  },
  {
    "videoId": "uGO1NCwSx3w",
    "thumbnail": "https://i.ytimg.com/vi/uGO1NCwSx3w/mqdefault.jpg",
    "title": "わんだふるぷりきゅあ！踊ってみた🐶🐾 #踊ってみた #shorts #short",
    "publishedAt": "2024-05-21T11:00:48Z"
  },
  {
    "videoId": "-ZQ_ZDRZX5U",
    "thumbnail": "https://i.ytimg.com/vi/-ZQ_ZDRZX5U/mqdefault.jpg",
    "title": "【＃生スバル】スト６！！！！！１時間でダイヤ５目指すぞ！！！！！！！→次回へ続く/ street fighter 6【ホロライブ/大空スバル】メンバーになるアナリティクス",
    "publishedAt": "2024-05-22T12:49:45Z"
  },
  {
    "videoId": "-lrp22Hc47s",
    "thumbnail": "https://i.ytimg.com/vi/-lrp22Hc47s/mqdefault.jpg",
    "title": "【＃生スバル】DON'T SCREAMするしゅばあああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-23T12:35:41Z"
  },
  {
    "videoId": "wpkOOijN3C8",
    "thumbnail": "https://i.ytimg.com/vi/wpkOOijN3C8/mqdefault.jpg",
    "title": "【＃スバおかおっぱっぴー】賭博黙示録カイジ with OKAYU【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-23T14:33:33Z"
  },
  {
    "videoId": "l1WLW7hNjzs",
    "thumbnail": "https://i.ytimg.com/vi/l1WLW7hNjzs/mqdefault.jpg",
    "title": "【#6】ジョジョ３部同時視聴 エジプトへん！ Ep30~ / watching party JoJo's Bizarre Adventure: Part 3--Stardust Crusaders",
    "publishedAt": "2024-05-24T14:56:42Z"
  },
  {
    "videoId": "xntbg9faWvo",
    "thumbnail": "https://i.ytimg.com/vi/xntbg9faWvo/mqdefault.jpg",
    "title": "【＃8】FCスーパーマリオブラザーズSWITCH版！！！ノーセーブクリア！！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-26T11:05:45Z"
  },
  {
    "videoId": "aTm6qovhIcw",
    "thumbnail": "https://i.ytimg.com/vi/aTm6qovhIcw/mqdefault.jpg",
    "title": "【#生スバル】最恐ホラゲ！！love samするしゅばああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-29T16:11:08Z"
  },
  {
    "videoId": "yvZ1Fz6GIpU",
    "thumbnail": "https://i.ytimg.com/vi/yvZ1Fz6GIpU/mqdefault.jpg",
    "title": "【＃生スバル】スト６！！！！！１時間でダイヤ５目指すぞ！！！！！！！→次回へ続く/ street fighter 6【ホロライブ/大空スバル】",
    "publishedAt": "2024-05-30T16:00:32Z"
  },
  {
    "videoId": "N2xTOzpWfK0",
    "thumbnail": "https://i.ytimg.com/vi/N2xTOzpWfK0/mqdefault.jpg",
    "title": "【#7】ジョジョ３部同時視聴 エジプトへん！ Ep30~ / watching party JoJo's Bizarre Adventure: Part 3--Stardust Crusaders",
    "publishedAt": "2024-05-31T15:23:34Z"
  },
  {
    "videoId": "XdVEN3cGEqM",
    "thumbnail": "https://i.ytimg.com/vi/XdVEN3cGEqM/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-01T02:15:47Z"
  },
  {
    "videoId": "ruuwvgYEASA",
    "thumbnail": "https://i.ytimg.com/vi/ruuwvgYEASA/mqdefault.jpg",
    "title": "【#生スバル】初見！！！ダンガンロンパ 希望の学園と絶望の高校生をプレイするしゅばああああ！！！ / Danganronpa: Trigger Happy Havoc【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-01T10:18:41Z"
  },
  {
    "videoId": "fUoWsTloCJ8",
    "thumbnail": "https://i.ytimg.com/vi/fUoWsTloCJ8/mqdefault.jpg",
    "title": "【#2】初見！！！ダンガンロンパ 希望の学園と絶望の高校生をプレイするしゅばああああ！！！ / Danganronpa: Trigger Happy Havoc【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-02T09:40:35Z"
  },
  {
    "videoId": "PSLOp4D6jmc",
    "thumbnail": "https://i.ytimg.com/vi/PSLOp4D6jmc/mqdefault.jpg",
    "title": "【#生スバル】このビッグウェーブに乗れ！！！！８番のりばやるしゅばああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-04T12:55:39Z"
  },
  {
    "videoId": "Iu_QW8_VAuk",
    "thumbnail": "https://i.ytimg.com/vi/Iu_QW8_VAuk/mqdefault.jpg",
    "title": "【＃生スバル】スト６！！！！！お願いしますダイヤ５いかせてくださいおねがいおねがいおねがい！！！！！！！→次回へ続く/ street fighter 6【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-04T16:18:48Z"
  },
  {
    "videoId": "R9WA9iST2FE",
    "thumbnail": "https://i.ytimg.com/vi/R9WA9iST2FE/mqdefault.jpg",
    "title": "【#最終回】ジョジョ３部同時視聴 エジプトへん！  / watching party JoJo's Bizarre Adventure: Part 3--Stardust Crusaders",
    "publishedAt": "2024-06-07T16:35:42Z"
  },
  {
    "videoId": "Gf6OalqgyyA",
    "thumbnail": "https://i.ytimg.com/vi/Gf6OalqgyyA/mqdefault.jpg",
    "title": "【#3】初見！！！ダンガンロンパ 希望の学園と絶望の高校生をプレイするしゅばああああ！！！ / Danganronpa: Trigger Happy Havoc【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-08T07:39:36Z"
  },
  {
    "videoId": "_4wyXyR9Cys",
    "thumbnail": "https://i.ytimg.com/vi/_4wyXyR9Cys/mqdefault.jpg",
    "title": "【#生スバル】スーパーマリオブラザーズ3で遊ぶしゅばあああああああああああああああああ！！！！！！ / SUPER MARIO BROS. 3【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-11T17:14:46Z"
  },
  {
    "videoId": "ScGL9akGZBI",
    "thumbnail": "https://i.ytimg.com/vi/ScGL9akGZBI/mqdefault.jpg",
    "title": "【#生スバル】Five Nights at Freddy'sをプレイしてみるしゅばああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-12T16:58:41Z"
  },
  {
    "videoId": "mlTt3LD0bW8",
    "thumbnail": "https://i.ytimg.com/vi/mlTt3LD0bW8/mqdefault.jpg",
    "title": "【#生スバル】無事故確定放送/Euro Truck Simulator 2【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-13T14:25:36Z"
  },
  {
    "videoId": "PvP4bvj6yzA",
    "thumbnail": "https://i.ytimg.com/vi/PvP4bvj6yzA/mqdefault.jpg",
    "title": "【#生スバル】ストリートファイターII MOVIE 同時視聴 / STREET FIGHTER II MOVIE【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-14T14:13:29Z"
  },
  {
    "videoId": "bLCr0iat_80",
    "thumbnail": "https://i.ytimg.com/vi/bLCr0iat_80/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-15T02:18:42Z"
  },
  {
    "videoId": "utPgXCKTqUA",
    "thumbnail": "https://i.ytimg.com/vi/utPgXCKTqUA/mqdefault.jpg",
    "title": "【#4】初見！！！ダンガンロンパ 希望の学園と絶望の高校生をプレイするしゅばああああ！！！ / Danganronpa: Trigger Happy Havoc【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-15T09:10:24Z"
  },
  {
    "videoId": "QPiVpmM3YMo",
    "thumbnail": "https://i.ytimg.com/vi/QPiVpmM3YMo/mqdefault.jpg",
    "title": "【#5】初見！！！ダンガンロンパ 希望の学園と絶望の高校生をプレイするしゅばああああ！！！ / Danganronpa: Trigger Happy Havoc【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-16T08:35:13Z"
  },
  {
    "videoId": "3RsRzUtIpog",
    "thumbnail": "https://i.ytimg.com/vi/3RsRzUtIpog/mqdefault.jpg",
    "title": "【#生スバル】フブキちゃんとリベンジ！！！！！Five Nights at Freddy'sをクリアするしゅばああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-19T12:55:06Z"
  },
  {
    "videoId": "k9z35Vgr9gM",
    "thumbnail": "https://i.ytimg.com/vi/k9z35Vgr9gM/mqdefault.jpg",
    "title": "【＃生スバル】ついにきた！！！！！！！！！！！！スト６マスターチャレンジ！！！！！！ / Street Fighter6 master Challenge【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-20T17:10:20Z"
  },
  {
    "videoId": "imYZmFeb6oU",
    "thumbnail": "https://i.ytimg.com/vi/imYZmFeb6oU/mqdefault.jpg",
    "title": "【＃生スバル】鋼の錬金術師 Fullmetal Alchemist. 同時視聴 / Fullmetal Alchemist. watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-21T14:57:50Z"
  },
  {
    "videoId": "CN6jdwWX8hg",
    "thumbnail": "https://i.ytimg.com/vi/CN6jdwWX8hg/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-22T02:20:07Z"
  },
  {
    "videoId": "ZeMljIh6CtU",
    "thumbnail": "https://i.ytimg.com/vi/ZeMljIh6CtU/mqdefault.jpg",
    "title": "【#6】初見！！！ダンガンロンパ 希望の学園と絶望の高校生をプレイするしゅばああああ！！！ / Danganronpa: Trigger Happy Havoc【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-22T09:27:19Z"
  },
  {
    "videoId": "5OtED3fuaG8",
    "thumbnail": "https://i.ytimg.com/vi/5OtED3fuaG8/mqdefault.jpg",
    "title": "【#生スバル】スーパーマリオブラザーズ3で遊ぶしゅばあああああああああああああああああ！！！！！！ / SUPER MARIO BROS. 3【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-22T15:11:11Z"
  },
  {
    "videoId": "DLLuuSyMY44",
    "thumbnail": "https://i.ytimg.com/vi/DLLuuSyMY44/mqdefault.jpg",
    "title": "【#7】初見！！！ダンガンロンパ 希望の学園と絶望の高校生をプレイするしゅばああああ！！！ / Danganronpa: Trigger Happy Havoc【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-23T10:23:23Z"
  },
  {
    "videoId": "u-AV6LbF5kg",
    "thumbnail": "https://i.ytimg.com/vi/u-AV6LbF5kg/mqdefault.jpg",
    "title": "【マリオメーカー２】３年ぶりに古のホロメンのコースクリアします【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-25T13:50:07Z"
  },
  {
    "videoId": "VZo-TP44wVQ",
    "thumbnail": "https://i.ytimg.com/vi/VZo-TP44wVQ/mqdefault.jpg",
    "title": "【＃2】鋼の錬金術師 Fullmetal Alchemist. 同時視聴会しゅばあああああああ / Fullmetal Alchemist. watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-28T15:07:08Z"
  },
  {
    "videoId": "PIvgy7EgN_o",
    "thumbnail": "https://i.ytimg.com/vi/PIvgy7EgN_o/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-29T02:19:33Z"
  },
  {
    "videoId": "J7LvUR1sk_s",
    "thumbnail": "https://i.ytimg.com/vi/J7LvUR1sk_s/mqdefault.jpg",
    "title": "【#8】初見！！！ダンガンロンパ 希望の学園と絶望の高校生をプレイするしゅばああああ！！！ / Danganronpa: Trigger Happy Havoc【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-29T08:34:23Z"
  },
  {
    "videoId": "jy_4xQRLabU",
    "thumbnail": "https://i.ytimg.com/vi/jy_4xQRLabU/mqdefault.jpg",
    "title": "【#9】初見！！！ダンガンロンパ 希望の学園と絶望の高校生をプレイするしゅばああああ！！！ / Danganronpa: Trigger Happy Havoc【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-30T07:10:05Z"
  },
  {
    "videoId": "u2rp0nXJLOI",
    "thumbnail": "https://i.ytimg.com/vi/u2rp0nXJLOI/mqdefault.jpg",
    "title": "【＃みこスバ】chained together with MIKOCHI 2日目しゅばあああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-06-30T14:19:00Z"
  },
  {
    "videoId": "9rp3TO4iu7Y",
    "thumbnail": "https://i.ytimg.com/vi/9rp3TO4iu7Y/mqdefault.jpg",
    "title": "【歌ってみた】君が飛び降りるのならば！【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-02T12:00:06Z"
  },
  {
    "videoId": "H4hEJDK42xs",
    "thumbnail": "https://i.ytimg.com/vi/H4hEJDK42xs/mqdefault.jpg",
    "title": "【#大空スバル生誕祭2024】大空スバル生誕祭2024：Happy Birth Day Stream【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-02T12:05:17Z"
  },
  {
    "videoId": "R6hZKtdjiW8",
    "thumbnail": "https://i.ytimg.com/vi/R6hZKtdjiW8/mqdefault.jpg",
    "title": "【＃生スバル】迷惑客をぶん殴ろう！！！僕、アルバイトォ！！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-04T12:35:45Z"
  },
  {
    "videoId": "K-s4fGsuoAs",
    "thumbnail": "https://i.ytimg.com/vi/K-s4fGsuoAs/mqdefault.jpg",
    "title": "【＃3】鋼の錬金術師 Fullmetal Alchemist. 同時視聴会しゅばあああああああ / Fullmetal Alchemist. watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-05T15:30:45Z"
  },
  {
    "videoId": "-QyokWA_tHE",
    "thumbnail": "https://i.ytimg.com/vi/-QyokWA_tHE/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-06T02:21:12Z"
  },
  {
    "videoId": "0k-pOyI7OaM",
    "thumbnail": "https://i.ytimg.com/vi/0k-pOyI7OaM/mqdefault.jpg",
    "title": "【#10】初見！！！ダンガンロンパ 希望の学園と絶望の高校生をプレイするしゅばああああ！！！ / Danganronpa: Trigger Happy Havoc【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-06T08:09:51Z"
  },
  {
    "videoId": "5A9iaksZiaA",
    "thumbnail": "https://i.ytimg.com/vi/5A9iaksZiaA/mqdefault.jpg",
    "title": "【#最終回】初見！！！ダンガンロンパ 希望の学園と絶望の高校生をプレイするしゅばああああ！！！ / Danganronpa: Trigger Happy Havoc【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-07T09:54:17Z"
  },
  {
    "videoId": "AIFK8I9uZNg",
    "thumbnail": "https://i.ytimg.com/vi/AIFK8I9uZNg/mqdefault.jpg",
    "title": "【＃生スバル】ストリートファイター６！！！サブキャラ選び＆ちょっとマスターランクマしゅばあああああああああああああああ！！！！！ / Street Fighter6【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-07T14:29:49Z"
  },
  {
    "videoId": "kjDXhUFsPDg",
    "thumbnail": "https://i.ytimg.com/vi/kjDXhUFsPDg/mqdefault.jpg",
    "title": "【#スバおか】おかゆ見守り！スーパーマリオブラザーズ3で遊ぶしゅばあああああああああああああああああ！！！！！！ / SUPER MARIO BROS. 3【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-09T15:43:59Z"
  },
  {
    "videoId": "88QhuJwQ2TU",
    "thumbnail": "https://i.ytimg.com/vi/88QhuJwQ2TU/mqdefault.jpg",
    "title": "【＃みこスバ】chained together with MIKOCHI 4日目しゅばあああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-11T13:36:53Z"
  },
  {
    "videoId": "Arz_do51LWc",
    "thumbnail": "https://i.ytimg.com/vi/Arz_do51LWc/mqdefault.jpg",
    "title": "【＃4】鋼の錬金術師 Fullmetal Alchemist. 同時視聴会しゅばあああああああ / Fullmetal Alchemist. watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-12T15:33:11Z"
  },
  {
    "videoId": "1CLnmEVvhWU",
    "thumbnail": "https://i.ytimg.com/vi/1CLnmEVvhWU/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-13T02:27:36Z"
  },
  {
    "videoId": "X8-nJXAtfCo",
    "thumbnail": "https://i.ytimg.com/vi/X8-nJXAtfCo/mqdefault.jpg",
    "title": "【＃生スバル】逆転裁判123 成歩堂セレクションするしゅばああああああああああああああああああああああああ！！！！/ Ace Attorney 1【ネタバレあり】",
    "publishedAt": "2024-07-13T08:28:06Z"
  },
  {
    "videoId": "C1GzWuerFZA",
    "thumbnail": "https://i.ytimg.com/vi/C1GzWuerFZA/mqdefault.jpg",
    "title": "【＃2】逆転裁判123 成歩堂セレクションするしゅばああああああああああああああああああああああああ！！！！/ Ace Attorney 1【ネタバレあり】",
    "publishedAt": "2024-07-14T08:56:14Z"
  },
  {
    "videoId": "EFvfVon9-zY",
    "thumbnail": "https://i.ytimg.com/vi/EFvfVon9-zY/mqdefault.jpg",
    "title": "【＃生スバル】失踪 - タケシ、お前の言う通りだった。あの廃村はヤバすぎる。【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-16T13:34:52Z"
  },
  {
    "videoId": "EoY2uS6Aw90",
    "thumbnail": "https://i.ytimg.com/vi/EoY2uS6Aw90/mqdefault.jpg",
    "title": "【＃生スバル】無免許トラック再 in 日本 /Euro Truck Simulator 2 Japan MOD【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-18T15:17:37Z"
  },
  {
    "videoId": "FvP4UV_qk8U",
    "thumbnail": "https://i.ytimg.com/vi/FvP4UV_qk8U/mqdefault.jpg",
    "title": "【＃5】鋼の錬金術師 Fullmetal Alchemist. 同時視聴会しゅばあああああああ / Fullmetal Alchemist. watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-19T15:38:27Z"
  },
  {
    "videoId": "Vv-mygJwLiU",
    "thumbnail": "https://i.ytimg.com/vi/Vv-mygJwLiU/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-20T02:17:56Z"
  },
  {
    "videoId": "mA0NJZQJq_E",
    "thumbnail": "https://i.ytimg.com/vi/mA0NJZQJq_E/mqdefault.jpg",
    "title": "【＃3】逆転裁判123 成歩堂セレクションするしゅばああああああああああああああああああああああああ！！！！/ Ace Attorney 1【ネタバレあり】",
    "publishedAt": "2024-07-20T09:49:52Z"
  },
  {
    "videoId": "AZoo_OOvkng",
    "thumbnail": "https://i.ytimg.com/vi/AZoo_OOvkng/mqdefault.jpg",
    "title": "#ラビットホール  #踊ってみた ！🐰💘 #short #shorts",
    "publishedAt": "2024-07-20T11:00:07Z"
  },
  {
    "videoId": "rQEpMXDnc0k",
    "thumbnail": "https://i.ytimg.com/vi/rQEpMXDnc0k/mqdefault.jpg",
    "title": "【＃4】逆転裁判123 成歩堂セレクションするしゅばああああああああああああああああああああああああ！！！！/ Ace Attorney 1【ネタバレあり】",
    "publishedAt": "2024-07-21T09:38:03Z"
  },
  {
    "videoId": "-A5e1zeHMsc",
    "thumbnail": "https://i.ytimg.com/vi/-A5e1zeHMsc/mqdefault.jpg",
    "title": "【＃ホロARK】ホロARKするしゅばああああああああああああああああああああああああああああああああああ！！！！！！！！　【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-23T17:58:06Z"
  },
  {
    "videoId": "7KT1LhPAwoA",
    "thumbnail": "https://i.ytimg.com/vi/7KT1LhPAwoA/mqdefault.jpg",
    "title": "【＃ホロARK】ホロARKするしゅばああああああああああああああああああああああああああああああああああ！！！！！！！！　【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-24T16:53:37Z"
  },
  {
    "videoId": "ahTLOIANyvg",
    "thumbnail": "https://i.ytimg.com/vi/ahTLOIANyvg/mqdefault.jpg",
    "title": "【＃ホロARK】ホロARKするしゅばああああああああああああああああああああああああああああああああああ！！！！！！！！　【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-25T17:29:51Z"
  },
  {
    "videoId": "2iL1UBuzxPo",
    "thumbnail": "https://i.ytimg.com/vi/2iL1UBuzxPo/mqdefault.jpg",
    "title": "【＃ホロARK】ホロARKするしゅばああああああああああああああああああああああああああああああああああ！！！！！！！！　【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-26T18:29:19Z"
  },
  {
    "videoId": "Di_tC0PuHfU",
    "thumbnail": "https://i.ytimg.com/vi/Di_tC0PuHfU/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-27T02:13:08Z"
  },
  {
    "videoId": "y_RQYSubhQk",
    "thumbnail": "https://i.ytimg.com/vi/y_RQYSubhQk/mqdefault.jpg",
    "title": "【＃5】逆転裁判123 成歩堂セレクションするしゅばああああああああああああああああああああああああ！！！！/ Ace Attorney 1【ネタバレあり】",
    "publishedAt": "2024-07-27T09:34:48Z"
  },
  {
    "videoId": "zYQbfJ2iN_k",
    "thumbnail": "https://i.ytimg.com/vi/zYQbfJ2iN_k/mqdefault.jpg",
    "title": "【＃ホロARK】ホロARKするしゅばああああああああああああああああああああああああああああああああああ！！！！！！！！　【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-27T22:12:55Z"
  },
  {
    "videoId": "j_xUuwQKHb4",
    "thumbnail": "https://i.ytimg.com/vi/j_xUuwQKHb4/mqdefault.jpg",
    "title": "【＃ホロARK】ホロARKするしゅばああああああああああああああああああああああああああああああああああ！！！！！！！！　【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-28T13:34:38Z"
  },
  {
    "videoId": "JuWvsxenJZ8",
    "thumbnail": "https://i.ytimg.com/vi/JuWvsxenJZ8/mqdefault.jpg",
    "title": "【＃ホロARK】ホロARKするしゅばああああああああああああああああああああああああああああああああああ！！！！！！！！　【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-30T14:53:09Z"
  },
  {
    "videoId": "hvTXy8fwpLk",
    "thumbnail": "https://i.ytimg.com/vi/hvTXy8fwpLk/mqdefault.jpg",
    "title": "【＃ホロARK】ホロARKするしゅばああああああああああああああああああああああああああああああああああ！！！！！！！！　【ホロライブ/大空スバル】",
    "publishedAt": "2024-07-31T15:47:17Z"
  },
  {
    "videoId": "iIMgGozUkis",
    "thumbnail": "https://i.ytimg.com/vi/iIMgGozUkis/mqdefault.jpg",
    "title": "【＃6】鋼の錬金術師 Fullmetal Alchemist. 同時視聴会しゅばあああああああ / Fullmetal Alchemist. watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-02T15:40:27Z"
  },
  {
    "videoId": "0Rex3-wUCZ8",
    "thumbnail": "https://i.ytimg.com/vi/0Rex3-wUCZ8/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-03T02:33:49Z"
  },
  {
    "videoId": "gUyd657OLZQ",
    "thumbnail": "https://i.ytimg.com/vi/gUyd657OLZQ/mqdefault.jpg",
    "title": "【＃6】逆転裁判123 成歩堂セレクションするしゅばああああああああああああああああああああああああ！！！！/ Ace Attorney 1【ネタバレあり】",
    "publishedAt": "2024-08-03T08:34:36Z"
  },
  {
    "videoId": "EtVD3Vd-0t4",
    "thumbnail": "https://i.ytimg.com/vi/EtVD3Vd-0t4/mqdefault.jpg",
    "title": "【＃7】逆転裁判123 成歩堂セレクションするしゅばああああああああああああああああああああああああ！！！！/ Ace Attorney 1【ネタバレあり】",
    "publishedAt": "2024-08-04T10:25:57Z"
  },
  {
    "videoId": "MAGE5omuq90",
    "thumbnail": "https://i.ytimg.com/vi/MAGE5omuq90/mqdefault.jpg",
    "title": "【＃みこスバ】chained together with MIKOCHI ６日目しゅばあああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-07T15:22:48Z"
  },
  {
    "videoId": "lJp_vxjOeVM",
    "thumbnail": "https://i.ytimg.com/vi/lJp_vxjOeVM/mqdefault.jpg",
    "title": "【#生スバル】スーパーマリオブラザーズ3で遊ぶしゅばあああああああああああああああああ！！！！！！ / SUPER MARIO BROS. 3【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-08T16:22:01Z"
  },
  {
    "videoId": "1vUmcnfvAJw",
    "thumbnail": "https://i.ytimg.com/vi/1vUmcnfvAJw/mqdefault.jpg",
    "title": "【＃7】鋼の錬金術師 Fullmetal Alchemist. 同時視聴会しゅばあああああああ / Fullmetal Alchemist. watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-09T15:09:01Z"
  },
  {
    "videoId": "eJyLagcMN1w",
    "thumbnail": "https://i.ytimg.com/vi/eJyLagcMN1w/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-10T02:21:49Z"
  },
  {
    "videoId": "f84oH_mdGxk",
    "thumbnail": "https://i.ytimg.com/vi/f84oH_mdGxk/mqdefault.jpg",
    "title": "【＃8】逆転裁判123 成歩堂セレクションするしゅばああああああああああああああああああああああああ！！！！/ Ace Attorney 1【ネタバレあり】",
    "publishedAt": "2024-08-10T08:43:23Z"
  },
  {
    "videoId": "mFWwVfUL73I",
    "thumbnail": "https://i.ytimg.com/vi/mFWwVfUL73I/mqdefault.jpg",
    "title": "【＃最終回】逆転裁判123 成歩堂セレクションするしゅばああああああああああああああああああああああああ！！！！/ Ace Attorney 1【ネタバレあり】",
    "publishedAt": "2024-08-11T11:13:00Z"
  },
  {
    "videoId": "RWOYJd3895w",
    "thumbnail": "https://i.ytimg.com/vi/RWOYJd3895w/mqdefault.jpg",
    "title": "【 #雀指 】ミリしら麻雀大会　圧倒的運否天賦　大空スバル視点【大空スバル/ホロライブ】",
    "publishedAt": "2024-08-13T13:56:00Z"
  },
  {
    "videoId": "ng6vwsNj0-I",
    "thumbnail": "https://i.ytimg.com/vi/ng6vwsNj0-I/mqdefault.jpg",
    "title": "【＃生スバル】噂のホロライブ！お宝マウンテン！！をやってみるしゅばああああああああああああああああああ【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-14T11:22:36Z"
  },
  {
    "videoId": "UBdlR6k41iE",
    "thumbnail": "https://i.ytimg.com/vi/UBdlR6k41iE/mqdefault.jpg",
    "title": "【#ホロ7DTD】みんなで生き残れ！！！！！７DAYS TO DIEやるしゅばああああああああああああああああああああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-14T16:24:22Z"
  },
  {
    "videoId": "6nIk_juxKfo",
    "thumbnail": "https://i.ytimg.com/vi/6nIk_juxKfo/mqdefault.jpg",
    "title": "【#ホロ7DTD】みんなで生き残れ！！！！！７DAYS TO DIEやるしゅばああああああああああああああああああああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-15T14:16:12Z"
  },
  {
    "videoId": "H4TPcx2BCgw",
    "thumbnail": "https://i.ytimg.com/vi/H4TPcx2BCgw/mqdefault.jpg",
    "title": "【＃8】鋼の錬金術師 Fullmetal Alchemist. 同時視聴会しゅばあああああああ / Fullmetal Alchemist. watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-16T15:24:32Z"
  },
  {
    "videoId": "7lKvBjMMbUs",
    "thumbnail": "https://i.ytimg.com/vi/7lKvBjMMbUs/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-17T02:22:56Z"
  },
  {
    "videoId": "OGmvRQShRlo",
    "thumbnail": "https://i.ytimg.com/vi/OGmvRQShRlo/mqdefault.jpg",
    "title": "【＃生スバル】初見！！！どきどき文芸部！やるしゅばあああああああああああああああああああああ！！！！！Doki Doki Literature Club!【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-17T10:17:00Z"
  },
  {
    "videoId": "-rWvkgYEvJs",
    "thumbnail": "https://i.ytimg.com/vi/-rWvkgYEvJs/mqdefault.jpg",
    "title": "【＃2】初見！！！どきどき文芸部！やるしゅばあああああああああああああああああああああ！！！！！Doki Doki Literature Club!【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-18T10:30:45Z"
  },
  {
    "videoId": "MK5QB8D7jTw",
    "thumbnail": "https://i.ytimg.com/vi/MK5QB8D7jTw/mqdefault.jpg",
    "title": "【＃みこスバ】chained together with MIKOCHI きっときっと真最終回しゅばあああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-20T14:13:28Z"
  },
  {
    "videoId": "8beJmHeAdag",
    "thumbnail": "https://i.ytimg.com/vi/8beJmHeAdag/mqdefault.jpg",
    "title": "【#ホロ7DTD】みんなで生き残れ！！！！！７DAYS TO DIEやるしゅばああああああああああああああああああああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-21T16:21:25Z"
  },
  {
    "videoId": "G8xcJ28eGSo",
    "thumbnail": "https://i.ytimg.com/vi/G8xcJ28eGSo/mqdefault.jpg",
    "title": "【＃生スバル】SIRENするしゅばあああああああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-22T17:55:38Z"
  },
  {
    "videoId": "l6fBMZhw2pY",
    "thumbnail": "https://i.ytimg.com/vi/l6fBMZhw2pY/mqdefault.jpg",
    "title": "【＃9】鋼の錬金術師  Fullmetal Alchemist. 同時視聴会しゅばあああああああ / Fullmetal Alchemist. watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-23T15:39:43Z"
  },
  {
    "videoId": "Q3P6i1BMYaQ",
    "thumbnail": "https://i.ytimg.com/vi/Q3P6i1BMYaQ/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-24T02:28:04Z"
  },
  {
    "videoId": "qjG2Ku5QdEA",
    "thumbnail": "https://i.ytimg.com/vi/qjG2Ku5QdEA/mqdefault.jpg",
    "title": "【#生スバル】スーパーマリオブラザーズ3で遊ぶしゅばあああああああああああああああああ！！！！！！ / SUPER MARIO BROS. 3【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-24T08:52:44Z"
  },
  {
    "videoId": "xzmj22L9cqk",
    "thumbnail": "https://i.ytimg.com/vi/xzmj22L9cqk/mqdefault.jpg",
    "title": "【＃ホロ女子会】ギリギリトーク？！？？！？！アイドルの女子会 /talk【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-24T13:08:30Z"
  },
  {
    "videoId": "Pvsg89sVFxY",
    "thumbnail": "https://i.ytimg.com/vi/Pvsg89sVFxY/mqdefault.jpg",
    "title": "【#生スバル】スーパーマリオブラザーズ3で遊ぶしゅばあああああああああああああああああ！！！！！！ / SUPER MARIO BROS. 3【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-25T09:27:53Z"
  },
  {
    "videoId": "W0mgPXJ75co",
    "thumbnail": "https://i.ytimg.com/vi/W0mgPXJ75co/mqdefault.jpg",
    "title": "【#ホロ7DTD】みんなで生き残れ！！！！！７DAYS TO DIEやるしゅばああああああああああああああああああああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-29T15:56:30Z"
  },
  {
    "videoId": "LITji8Dn1EU",
    "thumbnail": "https://i.ytimg.com/vi/LITji8Dn1EU/mqdefault.jpg",
    "title": "【＃最終回】鋼の錬金術師  Fullmetal Alchemist. 同時視聴会しゅばあああああ / Fullmetal Alchemist. watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-30T16:33:37Z"
  },
  {
    "videoId": "UFQASuX_y3A",
    "thumbnail": "https://i.ytimg.com/vi/UFQASuX_y3A/mqdefault.jpg",
    "title": "【#生スバル】最終回！！！！スーパーマリオブラザーズ3で遊ぶしゅばあああああああああああああああああ！！！！！！ / SUPER MARIO BROS. 3【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-31T09:56:12Z"
  },
  {
    "videoId": "XAB6ocUPRvE",
    "thumbnail": "https://i.ytimg.com/vi/XAB6ocUPRvE/mqdefault.jpg",
    "title": "【＃2】SIRENするしゅばあああああああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-08-31T18:40:32Z"
  },
  {
    "videoId": "Kj9yBp8x3oU",
    "thumbnail": "https://i.ytimg.com/vi/Kj9yBp8x3oU/mqdefault.jpg",
    "title": "【#生スバル】アンチャーテッド エル・ドラドの秘宝！！！やるしゅばああああああああああああああああああ！！！！  Uncharted: Drake's Fortune【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-01T10:10:36Z"
  },
  {
    "videoId": "UWflYbSD0jE",
    "thumbnail": "https://i.ytimg.com/vi/UWflYbSD0jE/mqdefault.jpg",
    "title": "【＃みこスバ】真真真最終回やああああああああああああああああああ！！！！！！！chained together with MIKOCHI 【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-03T12:32:43Z"
  },
  {
    "videoId": "UD7zcZpyhHM",
    "thumbnail": "https://i.ytimg.com/vi/UD7zcZpyhHM/mqdefault.jpg",
    "title": "【#生スバル】真最終回！！！！スーパーマリオブラザーズ3で遊ぶしゅばあああああああああああああああああ！！！！！！ / SUPER MARIO BROS. 3【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-04T15:58:09Z"
  },
  {
    "videoId": "zxmQ2KwdmdY",
    "thumbnail": "https://i.ytimg.com/vi/zxmQ2KwdmdY/mqdefault.jpg",
    "title": "【#ホロ7DTD】最終回！みんなで生き残れ！！！！！７DAYS TO DIEやるしゅばああああああああああああああああああああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-05T15:15:00Z"
  },
  {
    "videoId": "1UvQLzbKYxw",
    "thumbnail": "https://i.ytimg.com/vi/1UvQLzbKYxw/mqdefault.jpg",
    "title": "【歌ってみた】忘れてやらない【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-06T11:00:06Z"
  },
  {
    "videoId": "JXMWvYGE0aw",
    "thumbnail": "https://i.ytimg.com/vi/JXMWvYGE0aw/mqdefault.jpg",
    "title": "【#生スバル】ザ・スーパーマリオブラザーズ・ムービー同時視聴 / The Mario Bros. Movie watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-06T13:57:04Z"
  },
  {
    "videoId": "mHW_8qXDqlI",
    "thumbnail": "https://i.ytimg.com/vi/mHW_8qXDqlI/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-07T02:51:05Z"
  },
  {
    "videoId": "-Ztigx1CXs8",
    "thumbnail": "https://i.ytimg.com/vi/-Ztigx1CXs8/mqdefault.jpg",
    "title": "【#最終回】アンチャーテッド エル・ドラドの秘宝！！！やるしゅばああああああああああああああああああ！！！！  Uncharted: Drake's Fortune【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-07T09:52:16Z"
  },
  {
    "videoId": "FUZTTF58SKo",
    "thumbnail": "https://i.ytimg.com/vi/FUZTTF58SKo/mqdefault.jpg",
    "title": "【＃3】SIRENするしゅばあああああああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-07T17:26:08Z"
  },
  {
    "videoId": "NbJZhHK1w-g",
    "thumbnail": "https://i.ytimg.com/vi/NbJZhHK1w-g/mqdefault.jpg",
    "title": "【#生スバル】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-09-08T08:02:07Z"
  },
  {
    "videoId": "X7OAKrDbqb8",
    "thumbnail": "https://i.ytimg.com/vi/X7OAKrDbqb8/mqdefault.jpg",
    "title": "【#生スバル】戦国BASARA２ 英雄外伝するしゅばあああああああああああああああああああああ！！！！！ Sengoku BASARA Samurai Kings【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-10T15:16:21Z"
  },
  {
    "videoId": "ZKrFxrWoqTY",
    "thumbnail": "https://i.ytimg.com/vi/ZKrFxrWoqTY/mqdefault.jpg",
    "title": "【#生スバル】とらドラ！同時視聴 / Toradora watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-13T13:23:01Z"
  },
  {
    "videoId": "xtHJxIgPMA8",
    "thumbnail": "https://i.ytimg.com/vi/xtHJxIgPMA8/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-14T02:21:00Z"
  },
  {
    "videoId": "POqwqH0xEHc",
    "thumbnail": "https://i.ytimg.com/vi/POqwqH0xEHc/mqdefault.jpg",
    "title": "【#2】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-09-14T08:50:09Z"
  },
  {
    "videoId": "5prk6JNTbsI",
    "thumbnail": "https://i.ytimg.com/vi/5prk6JNTbsI/mqdefault.jpg",
    "title": "【#BIG3】BIG3 声真似キングの会【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-14T13:10:19Z"
  },
  {
    "videoId": "8s4rgD0AGdw",
    "thumbnail": "https://i.ytimg.com/vi/8s4rgD0AGdw/mqdefault.jpg",
    "title": "【#3】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-09-15T07:09:11Z"
  },
  {
    "videoId": "K_IsIE1TS8U",
    "thumbnail": "https://i.ytimg.com/vi/K_IsIE1TS8U/mqdefault.jpg",
    "title": "【オリジナル曲】ホットダック！【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-16T13:15:07Z"
  },
  {
    "videoId": "Bq9-k5muqq4",
    "thumbnail": "https://i.ytimg.com/vi/Bq9-k5muqq4/mqdefault.jpg",
    "title": "【#大空スバル６周年】6周年！しゅばああああああああああああああああああ！！！！ / 6 anniversary & new outfit & original song【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-16T13:29:30Z"
  },
  {
    "videoId": "QBtvVaGXj0w",
    "thumbnail": "https://i.ytimg.com/vi/QBtvVaGXj0w/mqdefault.jpg",
    "title": "【#holoGTA】　ホロポリスおおぞら署長　１日目【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-17T16:16:07Z"
  },
  {
    "videoId": "KNWo8d0MDGA",
    "thumbnail": "https://i.ytimg.com/vi/KNWo8d0MDGA/mqdefault.jpg",
    "title": "【#holoGTA】　ホロポリスおおぞら署長　２日目【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-18T16:20:40Z"
  },
  {
    "videoId": "m2s-quKy4d0",
    "thumbnail": "https://i.ytimg.com/vi/m2s-quKy4d0/mqdefault.jpg",
    "title": "【#holoGTA】　ホロポリスおおぞら署長　３日目【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-19T16:20:20Z"
  },
  {
    "videoId": "qRQZlenbNvM",
    "thumbnail": "https://i.ytimg.com/vi/qRQZlenbNvM/mqdefault.jpg",
    "title": "【#holoGTA】　ホロポリスおおぞら署長　４日目【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-20T16:27:37Z"
  },
  {
    "videoId": "SCMsYgb3ock",
    "thumbnail": "https://i.ytimg.com/vi/SCMsYgb3ock/mqdefault.jpg",
    "title": "【#holoGTA】　ホロポリスおおぞら署長　5日目【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-21T16:20:34Z"
  },
  {
    "videoId": "07RIE_S8jag",
    "thumbnail": "https://i.ytimg.com/vi/07RIE_S8jag/mqdefault.jpg",
    "title": "【#holoGTA】　ホロポリスおおぞら署長　6日目【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-22T16:19:50Z"
  },
  {
    "videoId": "_tTBVvfVOys",
    "thumbnail": "https://i.ytimg.com/vi/_tTBVvfVOys/mqdefault.jpg",
    "title": "【#holoGTA】　ホロポリスおおぞら署長　最終日【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-23T16:54:35Z"
  },
  {
    "videoId": "QCUXAxyoKvU",
    "thumbnail": "https://i.ytimg.com/vi/QCUXAxyoKvU/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-28T02:28:12Z"
  },
  {
    "videoId": "ky_EP0NHH0A",
    "thumbnail": "https://i.ytimg.com/vi/ky_EP0NHH0A/mqdefault.jpg",
    "title": "【#4】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-09-28T08:43:31Z"
  },
  {
    "videoId": "Rs0qVii7g5o",
    "thumbnail": "https://i.ytimg.com/vi/Rs0qVii7g5o/mqdefault.jpg",
    "title": "【＃4】SIRENするしゅばあああああああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-09-28T17:59:47Z"
  },
  {
    "videoId": "XrRNJqwOHmU",
    "thumbnail": "https://i.ytimg.com/vi/XrRNJqwOHmU/mqdefault.jpg",
    "title": "【#5】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-09-29T08:42:16Z"
  },
  {
    "videoId": "Re8R1o1mvco",
    "thumbnail": "https://i.ytimg.com/vi/Re8R1o1mvco/mqdefault.jpg",
    "title": "【＃生スバル】カドショ開店しゅばああああああああああああああああああああああああ！！！！！！/ TCG Card Shop Simulator【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-01T16:30:06Z"
  },
  {
    "videoId": "-TRsMnIpabg",
    "thumbnail": "https://i.ytimg.com/vi/-TRsMnIpabg/mqdefault.jpg",
    "title": "【#生スバル】ホラゲーウラヤマ【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-02T15:08:13Z"
  },
  {
    "videoId": "ofTMiiKFYm4",
    "thumbnail": "https://i.ytimg.com/vi/ofTMiiKFYm4/mqdefault.jpg",
    "title": "【＃生スバル】カドショ開店しゅばああああああああああああああああああああああああ！！！！！！/ TCG Card Shop Simulator【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-03T16:58:27Z"
  },
  {
    "videoId": "GXcXdzpBlz4",
    "thumbnail": "https://i.ytimg.com/vi/GXcXdzpBlz4/mqdefault.jpg",
    "title": "【#2】とらドラ！同時視聴 / Toradora watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-04T15:19:46Z"
  },
  {
    "videoId": "BiOLCllF1mI",
    "thumbnail": "https://i.ytimg.com/vi/BiOLCllF1mI/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-05T02:36:26Z"
  },
  {
    "videoId": "6veKN4bwmkw",
    "thumbnail": "https://i.ytimg.com/vi/6veKN4bwmkw/mqdefault.jpg",
    "title": "【#6】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-10-05T07:52:30Z"
  },
  {
    "videoId": "4AWiEuoKlzo",
    "thumbnail": "https://i.ytimg.com/vi/4AWiEuoKlzo/mqdefault.jpg",
    "title": "【#7】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-10-06T08:11:30Z"
  },
  {
    "videoId": "Btz0_-rRUug",
    "thumbnail": "https://i.ytimg.com/vi/Btz0_-rRUug/mqdefault.jpg",
    "title": "‪⸜‪‪‪‪🐣⸝‬‪ホットダック！踊ってみた～！‪⸜‪‪‪‪🐣⸝‬‪ #short #shorts #踊ってみた #dance #ホットダック",
    "publishedAt": "2024-10-06T11:00:10Z"
  },
  {
    "videoId": "nYq9sgFdR4A",
    "thumbnail": "https://i.ytimg.com/vi/nYq9sgFdR4A/mqdefault.jpg",
    "title": "【#生スバル】カドショ開店！！！！高額カードだすしゅばあああああああああああああああああああああああああああああ【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-08T16:07:50Z"
  },
  {
    "videoId": "lb461uRxMY0",
    "thumbnail": "https://i.ytimg.com/vi/lb461uRxMY0/mqdefault.jpg",
    "title": "【#生スバル】メタファー：リファンタジオ 体験版クリアまでするしゅばあああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-09T20:06:03Z"
  },
  {
    "videoId": "c3G1zJBLy8I",
    "thumbnail": "https://i.ytimg.com/vi/c3G1zJBLy8I/mqdefault.jpg",
    "title": "【＃スバルの小屋】スバルの小屋　ゲスト：Hakosちゃん！/Hakos Suba Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-10T14:06:37Z"
  },
  {
    "videoId": "2moRzfICMN8",
    "thumbnail": "https://i.ytimg.com/vi/2moRzfICMN8/mqdefault.jpg",
    "title": "【#3】とらドラ！同時視聴 / Toradora watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-11T15:27:12Z"
  },
  {
    "videoId": "n78g9isp9Is",
    "thumbnail": "https://i.ytimg.com/vi/n78g9isp9Is/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-12T02:13:24Z"
  },
  {
    "videoId": "3_NTn2prqKE",
    "thumbnail": "https://i.ytimg.com/vi/3_NTn2prqKE/mqdefault.jpg",
    "title": "【#8】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-10-12T08:29:13Z"
  },
  {
    "videoId": "qPD5x-XRs9s",
    "thumbnail": "https://i.ytimg.com/vi/qPD5x-XRs9s/mqdefault.jpg",
    "title": "【#9】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-10-13T10:29:08Z"
  },
  {
    "videoId": "44YiQdZbs_k",
    "thumbnail": "https://i.ytimg.com/vi/44YiQdZbs_k/mqdefault.jpg",
    "title": "【＃5】SIRENするしゅばあああああああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-13T18:20:58Z"
  },
  {
    "videoId": "J4IbWkPKzpY",
    "thumbnail": "https://i.ytimg.com/vi/J4IbWkPKzpY/mqdefault.jpg",
    "title": "#しかのこのこのここしたんたん 踊ってみた！🦌🦌🦌🦌 #short #shorts  #dance #踊ってみた",
    "publishedAt": "2024-10-14T11:19:36Z"
  },
  {
    "videoId": "wLuq0xZGz6o",
    "thumbnail": "https://i.ytimg.com/vi/wLuq0xZGz6o/mqdefault.jpg",
    "title": "【#スバおか】初見！不思議のダンジョン2 風来のシレンするしゅばあああああああああああ！！！！：Shiren the Wanderer【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-15T16:36:00Z"
  },
  {
    "videoId": "N2-LQLB9pz8",
    "thumbnail": "https://i.ytimg.com/vi/N2-LQLB9pz8/mqdefault.jpg",
    "title": "【#鳥獣ぎーが】神ゲーCore Keeperやるしゅばあああああああああああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-16T17:14:09Z"
  },
  {
    "videoId": "6mdcWcjeQcA",
    "thumbnail": "https://i.ytimg.com/vi/6mdcWcjeQcA/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-19T02:19:50Z"
  },
  {
    "videoId": "2UAxCNGiXaM",
    "thumbnail": "https://i.ytimg.com/vi/2UAxCNGiXaM/mqdefault.jpg",
    "title": "【#10】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-10-19T10:30:08Z"
  },
  {
    "videoId": "9WHqbrKe7mc",
    "thumbnail": "https://i.ytimg.com/vi/9WHqbrKe7mc/mqdefault.jpg",
    "title": "【#11】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-10-20T09:58:27Z"
  },
  {
    "videoId": "L7NiM4VJoXk",
    "thumbnail": "https://i.ytimg.com/vi/L7NiM4VJoXk/mqdefault.jpg",
    "title": "【#生スバル】サイコSFホラーMouthwashingやるしゅばあああああああああああああああああああああ！！！！！：Mouthwashing【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-22T16:14:25Z"
  },
  {
    "videoId": "o0h8IjDeitY",
    "thumbnail": "https://i.ytimg.com/vi/o0h8IjDeitY/mqdefault.jpg",
    "title": "【#生スバル】ホロメン家系図やるしゅばあああああああああああああああああ！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-23T14:45:41Z"
  },
  {
    "videoId": "wqoBzTPbzv0",
    "thumbnail": "https://i.ytimg.com/vi/wqoBzTPbzv0/mqdefault.jpg",
    "title": "【#4】とらドラ！同時視聴 / Toradora watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-25T14:09:25Z"
  },
  {
    "videoId": "gY7hQ9YrfAU",
    "thumbnail": "https://i.ytimg.com/vi/gY7hQ9YrfAU/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-26T02:14:16Z"
  },
  {
    "videoId": "vdFgpH_QEhY",
    "thumbnail": "https://i.ytimg.com/vi/vdFgpH_QEhY/mqdefault.jpg",
    "title": "【#12】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-10-26T09:04:03Z"
  },
  {
    "videoId": "uAR3Ii9ejis",
    "thumbnail": "https://i.ytimg.com/vi/uAR3Ii9ejis/mqdefault.jpg",
    "title": "【＃6】SIRENするしゅばあああああああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-26T18:21:35Z"
  },
  {
    "videoId": "23aq4bY3NqQ",
    "thumbnail": "https://i.ytimg.com/vi/23aq4bY3NqQ/mqdefault.jpg",
    "title": "【#13】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-10-27T08:38:40Z"
  },
  {
    "videoId": "qPh28AV1bNk",
    "thumbnail": "https://i.ytimg.com/vi/qPh28AV1bNk/mqdefault.jpg",
    "title": "【#生スバル】ソロliar's barやるしゅばああああああああああああああああああああああああああああああああああああああ：liar's bar【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-29T14:39:56Z"
  },
  {
    "videoId": "QlfUocn2QlA",
    "thumbnail": "https://i.ytimg.com/vi/QlfUocn2QlA/mqdefault.jpg",
    "title": "【#BIG3】BIG3のビッグな雑談 Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2024-10-30T14:06:10Z"
  },
  {
    "videoId": "JyjHN13HVFI",
    "thumbnail": "https://i.ytimg.com/vi/JyjHN13HVFI/mqdefault.jpg",
    "title": "【#最終回】とらドラ！同時視聴 / Toradora watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-01T14:52:46Z"
  },
  {
    "videoId": "4b09XmKCnd0",
    "thumbnail": "https://i.ytimg.com/vi/4b09XmKCnd0/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-02T02:13:15Z"
  },
  {
    "videoId": "ErZul72V3cE",
    "thumbnail": "https://i.ytimg.com/vi/ErZul72V3cE/mqdefault.jpg",
    "title": "【#14】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-11-02T08:51:20Z"
  },
  {
    "videoId": "HB0KXRZdb98",
    "thumbnail": "https://i.ytimg.com/vi/HB0KXRZdb98/mqdefault.jpg",
    "title": "【＃7】SIRENするしゅばあああああああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-02T18:17:22Z"
  },
  {
    "videoId": "wPgOgBvQm1g",
    "thumbnail": "https://i.ytimg.com/vi/wPgOgBvQm1g/mqdefault.jpg",
    "title": "【#15】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-11-03T11:12:19Z"
  },
  {
    "videoId": "H8kzmw2j39M",
    "thumbnail": "https://i.ytimg.com/vi/H8kzmw2j39M/mqdefault.jpg",
    "title": "【#生スバル】ソロliar's barやるしゅばああああああああああああああああああああああああああああああああああああああ：liar's bar【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-04T13:53:22Z"
  },
  {
    "videoId": "FUfA_zRwKRI",
    "thumbnail": "https://i.ytimg.com/vi/FUfA_zRwKRI/mqdefault.jpg",
    "title": "【#生スバル】理想の学園生活！！！ホロメン座席表を作るしゅばあああああ！！！！/ Ideal school life! ! ! Make a Holomen seating table【大空スバル】",
    "publishedAt": "2024-11-07T13:22:37Z"
  },
  {
    "videoId": "Hvy4xxdP8Dg",
    "thumbnail": "https://i.ytimg.com/vi/Hvy4xxdP8Dg/mqdefault.jpg",
    "title": "【#生スバル】AKIRA同時視聴するしゅばあああああああああああああああああああああああああ！！！！：AKIRA watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-08T14:49:46Z"
  },
  {
    "videoId": "4sYZf6q5Wd8",
    "thumbnail": "https://i.ytimg.com/vi/4sYZf6q5Wd8/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-09T02:17:20Z"
  },
  {
    "videoId": "wPJ8KV9uKHo",
    "thumbnail": "https://i.ytimg.com/vi/wPJ8KV9uKHo/mqdefault.jpg",
    "title": "【#16】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-11-09T09:39:24Z"
  },
  {
    "videoId": "qhH-azW3LJw",
    "thumbnail": "https://i.ytimg.com/vi/qhH-azW3LJw/mqdefault.jpg",
    "title": "【#最終回】ドラゴンクエストⅣするしゅばああああああああああああああああ！！！ / DRAGON QUESTⅣ【ネタバレあり】",
    "publishedAt": "2024-11-10T11:02:40Z"
  },
  {
    "videoId": "oXDUaBRann8",
    "thumbnail": "https://i.ytimg.com/vi/oXDUaBRann8/mqdefault.jpg",
    "title": "【地獄】初配信を見よう雑談 with ラミィ【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-10T14:10:05Z"
  },
  {
    "videoId": "WEN9Y8_tav4",
    "thumbnail": "https://i.ytimg.com/vi/WEN9Y8_tav4/mqdefault.jpg",
    "title": "【#ミオスバみこ】アメリカからただいま～！！！！！：I'm back from the U.S.【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-19T14:11:39Z"
  },
  {
    "videoId": "W9MXr9-odyk",
    "thumbnail": "https://i.ytimg.com/vi/W9MXr9-odyk/mqdefault.jpg",
    "title": "【#生スバル】銀行強盗するしゅばあああああああああああああああああああああああああ！！！！！：payday2【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-20T15:16:06Z"
  },
  {
    "videoId": "JRxiUbUlM-o",
    "thumbnail": "https://i.ytimg.com/vi/JRxiUbUlM-o/mqdefault.jpg",
    "title": "【#ホロ大並走鎖バトル】大並走！！！！！！！鎖バトル！！！！！！！！！：chained together【ホロライブ】",
    "publishedAt": "2024-11-22T14:04:04Z"
  },
  {
    "videoId": "TWqZ6VurH2M",
    "thumbnail": "https://i.ytimg.com/vi/TWqZ6VurH2M/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-23T02:24:45Z"
  },
  {
    "videoId": "9vHFYXrX5y0",
    "thumbnail": "https://i.ytimg.com/vi/9vHFYXrX5y0/mqdefault.jpg",
    "title": "【#生スバル】ホロキュアやるしゅばあああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-23T09:57:44Z"
  },
  {
    "videoId": "VmxNg1edwog",
    "thumbnail": "https://i.ytimg.com/vi/VmxNg1edwog/mqdefault.jpg",
    "title": "【#生スバル】キャプテン翼 RISE OF NEW CHAMPIONSやるしゅばああああああああああああ：Captain Tsubasa: Rise of New Champions【ネタバレあり】",
    "publishedAt": "2024-11-24T08:41:37Z"
  },
  {
    "videoId": "MMB7JafZiEE",
    "thumbnail": "https://i.ytimg.com/vi/MMB7JafZiEE/mqdefault.jpg",
    "title": "【グラクロ5.5周年】七つの大罪～光と闇の交戦～やるしゅばああああああああああああああああああああ【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-24T13:15:25Z"
  },
  {
    "videoId": "p3nGkXfSzwU",
    "thumbnail": "https://i.ytimg.com/vi/p3nGkXfSzwU/mqdefault.jpg",
    "title": "【#生スバル】大声を出さずに１８分耐えるしゅばあああああああああああああああああああああああ！！！！：DON'T SCREAM 【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-26T14:45:53Z"
  },
  {
    "videoId": "U3brhZD1jNY",
    "thumbnail": "https://i.ytimg.com/vi/U3brhZD1jNY/mqdefault.jpg",
    "title": "【#生スバル】空気よみます【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-28T14:21:00Z"
  },
  {
    "videoId": "q-a91uXv1pg",
    "thumbnail": "https://i.ytimg.com/vi/q-a91uXv1pg/mqdefault.jpg",
    "title": "【#生スバル】ジョジョの奇妙な冒険 ダイヤモンドは砕けない 同時視聴しゅばあああああああああああ！！！ :jojo part4 watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-29T15:37:15Z"
  },
  {
    "videoId": "mIPi_5p0XJc",
    "thumbnail": "https://i.ytimg.com/vi/mIPi_5p0XJc/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-30T02:18:00Z"
  },
  {
    "videoId": "X2XYuWNxvKs",
    "thumbnail": "https://i.ytimg.com/vi/X2XYuWNxvKs/mqdefault.jpg",
    "title": "【#2】キャプテン翼 RISE OF NEW CHAMPIONSやるしゅばああああああああああああ：Captain Tsubasa: Rise of New Champions【ネタバレあり】",
    "publishedAt": "2024-11-30T09:03:15Z"
  },
  {
    "videoId": "1R3NgRVXXFY",
    "thumbnail": "https://i.ytimg.com/vi/1R3NgRVXXFY/mqdefault.jpg",
    "title": "【＃8】SIRENするしゅばあああああああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-11-30T16:33:39Z"
  },
  {
    "videoId": "xRjR-qViSN8",
    "thumbnail": "https://i.ytimg.com/vi/xRjR-qViSN8/mqdefault.jpg",
    "title": "【#3】キャプテン翼 RISE OF NEW CHAMPIONSやるしゅばああああああああああああ：Captain Tsubasa: Rise of New Champions【ネタバレあり】",
    "publishedAt": "2024-12-01T09:34:44Z"
  },
  {
    "videoId": "Hg0kH_iUVDg",
    "thumbnail": "https://i.ytimg.com/vi/Hg0kH_iUVDg/mqdefault.jpg",
    "title": "【ペルソナ５: The Phantom X】ペルソナ５新章開幕？！？P5X！クローズドβテストに参加させて頂くしゅばあああああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-03T15:27:26Z"
  },
  {
    "videoId": "LLdv-es2Oic",
    "thumbnail": "https://i.ytimg.com/vi/LLdv-es2Oic/mqdefault.jpg",
    "title": "【#生スバル】星のカービィ64やるしゅばああああああああああああああああああああああああああ！！！！！！：Kirby 64: The Crystal Shards.【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-04T16:28:00Z"
  },
  {
    "videoId": "3qVhXlKC8TA",
    "thumbnail": "https://i.ytimg.com/vi/3qVhXlKC8TA/mqdefault.jpg",
    "title": "【#生スバル】星のカービィ64やるしゅばああああああああああああああああああああああああああ！！！！！！：Kirby 64: The Crystal Shards.【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-05T16:46:45Z"
  },
  {
    "videoId": "3pVawOhS9YA",
    "thumbnail": "https://i.ytimg.com/vi/3pVawOhS9YA/mqdefault.jpg",
    "title": "【#2】ジョジョの奇妙な冒険 ダイヤモンドは砕けない 同時視聴しゅばあああああああああああ！！！ :jojo part4 watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-06T15:45:57Z"
  },
  {
    "videoId": "3LA6t9YHsKw",
    "thumbnail": "https://i.ytimg.com/vi/3LA6t9YHsKw/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-07T02:30:42Z"
  },
  {
    "videoId": "b51_KqTzEmE",
    "thumbnail": "https://i.ytimg.com/vi/b51_KqTzEmE/mqdefault.jpg",
    "title": "【#4】キャプテン翼 RISE OF NEW CHAMPIONSやるしゅばああああああああああああ：Captain Tsubasa: Rise of New Champions【ネタバレあり】",
    "publishedAt": "2024-12-07T09:27:24Z"
  },
  {
    "videoId": "acZUgxJTaJ8",
    "thumbnail": "https://i.ytimg.com/vi/acZUgxJTaJ8/mqdefault.jpg",
    "title": "【＃9】SIRENするしゅばあああああああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-07T16:52:50Z"
  },
  {
    "videoId": "1rh2yINMnqc",
    "thumbnail": "https://i.ytimg.com/vi/1rh2yINMnqc/mqdefault.jpg",
    "title": "【#みこスバ】みこスバ Human Fall Flatやるしゅばあああああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-10T15:21:41Z"
  },
  {
    "videoId": "zm3H-J1kjAQ",
    "thumbnail": "https://i.ytimg.com/vi/zm3H-J1kjAQ/mqdefault.jpg",
    "title": "【#生スバル】 先行プレイだ～！漢字でGO! 集英社マンガ祭しゅばああああああああああああああああああああああ【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-12T15:53:23Z"
  },
  {
    "videoId": "l1jZRDNPiUM",
    "thumbnail": "https://i.ytimg.com/vi/l1jZRDNPiUM/mqdefault.jpg",
    "title": "【#3】ジョジョの奇妙な冒険 ダイヤモンドは砕けない 同時視聴しゅばあああああああああああ！！！ :jojo part4 watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-13T15:41:59Z"
  },
  {
    "videoId": "M8CwyRvBMy8",
    "thumbnail": "https://i.ytimg.com/vi/M8CwyRvBMy8/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-14T02:26:09Z"
  },
  {
    "videoId": "85DO0LKaNho",
    "thumbnail": "https://i.ytimg.com/vi/85DO0LKaNho/mqdefault.jpg",
    "title": "【#5】キャプテン翼 RISE OF NEW CHAMPIONSやるしゅばああああああああああああ：Captain Tsubasa: Rise of New Champions【ネタバレあり】",
    "publishedAt": "2024-12-14T09:26:00Z"
  },
  {
    "videoId": "zalP4voi9zA",
    "thumbnail": "https://i.ytimg.com/vi/zalP4voi9zA/mqdefault.jpg",
    "title": "【＃最終回】SIRENするしゅばあああああああああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-14T17:01:26Z"
  },
  {
    "videoId": "lDDMozC7csI",
    "thumbnail": "https://i.ytimg.com/vi/lDDMozC7csI/mqdefault.jpg",
    "title": "【#6】キャプテン翼 RISE OF NEW CHAMPIONSやるしゅばああああああああああああ：Captain Tsubasa: Rise of New Champions【ネタバレあり】",
    "publishedAt": "2024-12-15T08:45:12Z"
  },
  {
    "videoId": "580DKQ3p9PE",
    "thumbnail": "https://i.ytimg.com/vi/580DKQ3p9PE/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-21T02:51:16Z"
  },
  {
    "videoId": "UCVmyQGLobg",
    "thumbnail": "https://i.ytimg.com/vi/UCVmyQGLobg/mqdefault.jpg",
    "title": "【#7】キャプテン翼 RISE OF NEW CHAMPIONSやるしゅばああああああああああああ：Captain Tsubasa: Rise of New Champions【ネタバレあり】",
    "publishedAt": "2024-12-22T09:28:33Z"
  },
  {
    "videoId": "FcHSmYW8W5Y",
    "thumbnail": "https://i.ytimg.com/vi/FcHSmYW8W5Y/mqdefault.jpg",
    "title": "【#みこスバ】🎄クリスマスイブのキャプテン翼🎄みこスバ対決しゅばあああああああああああ！！！：Captain Tsubasa: Rise of New Champions【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-24T11:58:29Z"
  },
  {
    "videoId": "UjRStwig2WE",
    "thumbnail": "https://i.ytimg.com/vi/UjRStwig2WE/mqdefault.jpg",
    "title": "【#BIG3】BIG3！遅れてやってきたクリスマス会しゅばあああああああああああああああ【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-26T13:02:12Z"
  },
  {
    "videoId": "AEnktZPv-Mc",
    "thumbnail": "https://i.ytimg.com/vi/AEnktZPv-Mc/mqdefault.jpg",
    "title": "【#4】ジョジョの奇妙な冒険 ダイヤモンドは砕けない 同時視聴しゅばあああああああああああ！！！ :jojo part4 watching party【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-27T15:05:51Z"
  },
  {
    "videoId": "X3y57JspBfA",
    "thumbnail": "https://i.ytimg.com/vi/X3y57JspBfA/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-28T02:21:59Z"
  },
  {
    "videoId": "F1uSNR8-oTo",
    "thumbnail": "https://i.ytimg.com/vi/F1uSNR8-oTo/mqdefault.jpg",
    "title": "【#大空警察2024】大空警察2024しゅばああああああああああああああああああああああああ！！！！ /OOZORA Police 2024【ホロライブ/大空スバル】",
    "publishedAt": "2024-12-28T13:42:00Z"
  },
  {
    "videoId": "DoIDomrM_jk",
    "thumbnail": "https://i.ytimg.com/vi/DoIDomrM_jk/mqdefault.jpg",
    "title": "【#8】キャプテン翼 RISE OF NEW CHAMPIONSやるしゅばああああああああああああ：Captain Tsubasa: Rise of New Champions【ネタバレあり】",
    "publishedAt": "2024-12-29T10:11:31Z"
  },
  {
    "videoId": "lorxlqKOY9s",
    "thumbnail": "https://i.ytimg.com/vi/lorxlqKOY9s/mqdefault.jpg",
    "title": "【#生スバル】2025年新年雑談！しゅばあああああああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-01-01T03:41:31Z"
  },
  {
    "videoId": "XuWYl42q23s",
    "thumbnail": "https://i.ytimg.com/vi/XuWYl42q23s/mqdefault.jpg",
    "title": "【#生スバル】お正月デトロイトやるしゅばあああああああああああああああああああああああ！！！！ / Detroit: Become Human【ホロライブ/大空スバル】",
    "publishedAt": "2025-01-01T09:51:22Z"
  },
  {
    "videoId": "13BeKpEzGwg",
    "thumbnail": "https://i.ytimg.com/vi/13BeKpEzGwg/mqdefault.jpg",
    "title": "【#生スバル】人徳凸待ちガチアポなし凸待ちしゅばあああああああああ（誰か来てくださいお願いします）【ホロライブ/大空スバル】",
    "publishedAt": "2025-01-01T12:34:21Z"
  },
  {
    "videoId": "3XjeQOFsNEw",
    "thumbnail": "https://i.ytimg.com/vi/3XjeQOFsNEw/mqdefault.jpg",
    "title": "【#2】お正月デトロイトやるしゅばあああああああああああああああああああああああ！！！！ / Detroit: Become Human【ホロライブ/大空スバル】",
    "publishedAt": "2025-01-02T09:45:34Z"
  },
  {
    "videoId": "d7juvrWBUhI",
    "thumbnail": "https://i.ytimg.com/vi/d7juvrWBUhI/mqdefault.jpg",
    "title": "【#最終回】お正月デトロイトやるしゅばあああああああああああああああああああああああ！！！！ / Detroit: Become Human【ホロライブ/大空スバル】",
    "publishedAt": "2025-01-03T09:29:47Z"
  },
  {
    "videoId": "-zV8isLMzQ0",
    "thumbnail": "https://i.ytimg.com/vi/-zV8isLMzQ0/mqdefault.jpg",
    "title": "【#スバおか】スバおか福袋大開封会やるしゅばああああああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-01-03T12:05:39Z"
  },
  {
    "videoId": "TsXKqAwtqxk",
    "thumbnail": "https://i.ytimg.com/vi/TsXKqAwtqxk/mqdefault.jpg",
    "title": "【#5】ジョジョの奇妙な冒険 ダイヤモンドは砕けない 同時視聴しゅばあああああああああああ！！！ :jojo part4 watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-01-03T15:44:13Z"
  },
  {
    "videoId": "Toqi2m0HgJ8",
    "thumbnail": "https://i.ytimg.com/vi/Toqi2m0HgJ8/mqdefault.jpg",
    "title": "【#ババドナ】ババドナ新年会やるしゅばあああああああああああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-01-04T14:17:17Z"
  },
  {
    "videoId": "vdiBHerbmLo",
    "thumbnail": "https://i.ytimg.com/vi/vdiBHerbmLo/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-01-11T02:24:34Z"
  },
  {
    "videoId": "7M4JieUYiGo",
    "thumbnail": "https://i.ytimg.com/vi/7M4JieUYiGo/mqdefault.jpg",
    "title": "【#ホロ新春ゲーム祭】フォールガイズチーム練習やるしゅばああああああああああああああああ！！！！！: Fall Guys: Ultimate Knockout【ホロライブ/大空スバル】",
    "publishedAt": "2025-01-12T15:50:07Z"
  },
  {
    "videoId": "1lnEOFPGyYQ",
    "thumbnail": "https://i.ytimg.com/vi/1lnEOFPGyYQ/mqdefault.jpg",
    "title": "【#生スバル】呪われたデジカメやるしゅばあああああああああああああああああああああああああ！！！！：Cursed Digicam【ホロライブ/大空スバル】",
    "publishedAt": "2025-01-14T12:54:59Z"
  },
  {
    "videoId": "SYsJusk4jSY",
    "thumbnail": "https://i.ytimg.com/vi/SYsJusk4jSY/mqdefault.jpg",
    "title": "【#ホロ新春ゲーム祭2025】今日はたのしむぞ～～～～～～～！！！！！！！！！！【ホロライブ/大空スバルチーム】",
    "publishedAt": "2025-01-15T18:32:47Z"
  },
  {
    "videoId": "_njEgF6uLGc",
    "thumbnail": "https://i.ytimg.com/vi/_njEgF6uLGc/mqdefault.jpg",
    "title": "【#生スバル】遊戯王マスターデュエルで視聴者対戦するしゅばああああああああああああああああああ！！！！！！！：Yu-Gi-Oh! Master Duel【ホロライブ/大空スバル】",
    "publishedAt": "2025-01-16T13:41:50Z"
  },
  {
    "videoId": "ooQu1THMWDs",
    "thumbnail": "https://i.ytimg.com/vi/ooQu1THMWDs/mqdefault.jpg",
    "title": "【#6】ジョジョの奇妙な冒険 ダイヤモンドは砕けない 同時視聴しゅばあああああああああああ！！！ :jojo part4 watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-01-17T15:45:47Z"
  },
  {
    "videoId": "WSlHwPKEZ5Q",
    "thumbnail": "https://i.ytimg.com/vi/WSlHwPKEZ5Q/mqdefault.jpg",
    "title": "【#生スバル】復 活 雑 談 しゅばあああああああああああああああああああああああああああああああ！！！！！！！/ Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-05T13:14:57Z"
  },
  {
    "videoId": "L_UskwkO9bU",
    "thumbnail": "https://i.ytimg.com/vi/L_UskwkO9bU/mqdefault.jpg",
    "title": "【#生スバル】おさんぽスバルしゅばああああああああああああああああああああああああああああ / MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-06T16:31:38Z"
  },
  {
    "videoId": "NNJ609JqvLg",
    "thumbnail": "https://i.ytimg.com/vi/NNJ609JqvLg/mqdefault.jpg",
    "title": "【#7】ジョジョの奇妙な冒険 ダイヤモンドは砕けない 同時視聴しゅばあああああああああああ！！！ :jojo part4 watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-07T15:36:40Z"
  },
  {
    "videoId": "rLrSgdGMWno",
    "thumbnail": "https://i.ytimg.com/vi/rLrSgdGMWno/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-08T03:03:50Z"
  },
  {
    "videoId": "LEDQ4BwDjCo",
    "thumbnail": "https://i.ytimg.com/vi/LEDQ4BwDjCo/mqdefault.jpg",
    "title": "【#生スバル】おかゆにゅ～～む！ 体 験 版 やるしゅばあああああああああああああああああああああああああ！！！！！ 【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-09T09:24:19Z"
  },
  {
    "videoId": "BvGlcMUhbKs",
    "thumbnail": "https://i.ytimg.com/vi/BvGlcMUhbKs/mqdefault.jpg",
    "title": "【#生スバル】おさんぽスバルしゅばああああああああああああああああああああああああああああ / MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-12T17:50:15Z"
  },
  {
    "videoId": "ewOFsYqf-YA",
    "thumbnail": "https://i.ytimg.com/vi/ewOFsYqf-YA/mqdefault.jpg",
    "title": "【#BIG3】BIG3 (ほぼ) バレンタイン コラボ【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-13T13:05:33Z"
  },
  {
    "videoId": "xEhLmTRuoXQ",
    "thumbnail": "https://i.ytimg.com/vi/xEhLmTRuoXQ/mqdefault.jpg",
    "title": "【#最終回】ジョジョの奇妙な冒険 ダイヤモンドは砕けない 同時視聴しゅばあああああああああああ！！！ :jojo part4 watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-14T15:46:38Z"
  },
  {
    "videoId": "4j2Szz9CnrE",
    "thumbnail": "https://i.ytimg.com/vi/4j2Szz9CnrE/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-15T02:19:47Z"
  },
  {
    "videoId": "BrJXZ-sEEzU",
    "thumbnail": "https://i.ytimg.com/vi/BrJXZ-sEEzU/mqdefault.jpg",
    "title": "【#生スバル】龍が如く６やるしゅばああああああああああああああああああああああああああ！！！！/YAKUZA 6【ネタバレ注意】",
    "publishedAt": "2025-02-15T08:50:59Z"
  },
  {
    "videoId": "nZVftu3JnZ4",
    "thumbnail": "https://i.ytimg.com/vi/nZVftu3JnZ4/mqdefault.jpg",
    "title": "【#2】龍が如く６やるしゅばああああああああああああああああああああああああああ！！！！/YAKUZA 6【ネタバレ注意】",
    "publishedAt": "2025-02-16T09:56:40Z"
  },
  {
    "videoId": "NS3aCXFsHt4",
    "thumbnail": "https://i.ytimg.com/vi/NS3aCXFsHt4/mqdefault.jpg",
    "title": "【#生スバル】おさんぽスバルしゅばああああああああああああああああああああああああああああ / MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-16T18:16:08Z"
  },
  {
    "videoId": "EhuvRrhufks",
    "thumbnail": "https://i.ytimg.com/vi/EhuvRrhufks/mqdefault.jpg",
    "title": "【#生スバル】おさんぽスバルしゅばああああああああああああああああああああああああああああ / MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-18T17:18:41Z"
  },
  {
    "videoId": "HKASvSVN8FE",
    "thumbnail": "https://i.ytimg.com/vi/HKASvSVN8FE/mqdefault.jpg",
    "title": "【#生スバル】おさんぽスバルしゅばああああああああああああああああああああああああああああ / MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-20T13:54:38Z"
  },
  {
    "videoId": "IeKx9sONNwc",
    "thumbnail": "https://i.ytimg.com/vi/IeKx9sONNwc/mqdefault.jpg",
    "title": "【#スバちょこるなたん】地下廃病院で死体を回収するしゅばあああああああああああああああああああああああ！！！！！ / UNDERWARD【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-20T16:11:07Z"
  },
  {
    "videoId": "i2cILyBqbS0",
    "thumbnail": "https://i.ytimg.com/vi/i2cILyBqbS0/mqdefault.jpg",
    "title": "【#生スバル】岸辺露伴は動かないを同時視聴するしゅばあああああああああああああああああああああ！！！：Thus spoke Kishibe Rohan【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-21T15:04:16Z"
  },
  {
    "videoId": "KZ0u0cKJF10",
    "thumbnail": "https://i.ytimg.com/vi/KZ0u0cKJF10/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-22T02:27:19Z"
  },
  {
    "videoId": "k90o-XPY3aM",
    "thumbnail": "https://i.ytimg.com/vi/k90o-XPY3aM/mqdefault.jpg",
    "title": "【#3】龍が如く６やるしゅばああああああああああああああああああああああああああ！！！！/YAKUZA 6【ネタバレ注意】",
    "publishedAt": "2025-02-22T09:48:16Z"
  },
  {
    "videoId": "H_DARUp6nE8",
    "thumbnail": "https://i.ytimg.com/vi/H_DARUp6nE8/mqdefault.jpg",
    "title": "【#4】龍が如く６やるしゅばああああああああああああああああああああああああああ！！！！/YAKUZA 6【ネタバレ注意】",
    "publishedAt": "2025-02-23T10:33:55Z"
  },
  {
    "videoId": "6rx-Xz35GUQ",
    "thumbnail": "https://i.ytimg.com/vi/6rx-Xz35GUQ/mqdefault.jpg",
    "title": "【#生スバル】おさんぽスバルしゅばああああああああああああああああああああああああああああ / MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-24T16:59:57Z"
  },
  {
    "videoId": "qdKgSIUoAlQ",
    "thumbnail": "https://i.ytimg.com/vi/qdKgSIUoAlQ/mqdefault.jpg",
    "title": "【#生スバル】高難易度ゲー？！？HoloRun2時間以内にクリアするしゅばあああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-26T13:31:38Z"
  },
  {
    "videoId": "Qb2oP5-TDTA",
    "thumbnail": "https://i.ytimg.com/vi/Qb2oP5-TDTA/mqdefault.jpg",
    "title": "【#生スバル】壺おじ指示＆声担当＆ラジコンコラボしゅばああああああああああああああああああああああああ【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-27T13:12:34Z"
  },
  {
    "videoId": "8XjnzOBEVVE",
    "thumbnail": "https://i.ytimg.com/vi/8XjnzOBEVVE/mqdefault.jpg",
    "title": "【#生スバル】日常 同時視聴 / NICHIJOU watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-02-28T15:06:45Z"
  },
  {
    "videoId": "fKy-qQ3xT_U",
    "thumbnail": "https://i.ytimg.com/vi/fKy-qQ3xT_U/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-01T02:15:02Z"
  },
  {
    "videoId": "K9AQRV93-1s",
    "thumbnail": "https://i.ytimg.com/vi/K9AQRV93-1s/mqdefault.jpg",
    "title": "【#5】龍が如く６やるしゅばああああああああああああああああああああああああああ！！！！/YAKUZA 6【ネタバレ注意】",
    "publishedAt": "2025-03-01T09:19:24Z"
  },
  {
    "videoId": "19-MpJeDxmU",
    "thumbnail": "https://i.ytimg.com/vi/19-MpJeDxmU/mqdefault.jpg",
    "title": "【#最終回】龍が如く６やるしゅばああああああああああああああああああああああああああ！！！！/YAKUZA 6【ネタバレ注意】",
    "publishedAt": "2025-03-02T10:14:25Z"
  },
  {
    "videoId": "KJGX0gJhvrM",
    "thumbnail": "https://i.ytimg.com/vi/KJGX0gJhvrM/mqdefault.jpg",
    "title": "【#大空スバル6周年LIVE】大空スバル 6th 記念LIVE 星灯【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-02T13:12:25Z"
  },
  {
    "videoId": "cuBAtp-_beY",
    "thumbnail": "https://i.ytimg.com/vi/cuBAtp-_beY/mqdefault.jpg",
    "title": "【#生スバル】記念ライブ振り返り＆ありがとうしゅばあああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-04T14:49:12Z"
  },
  {
    "videoId": "pqyK66L9J1U",
    "thumbnail": "https://i.ytimg.com/vi/pqyK66L9J1U/mqdefault.jpg",
    "title": "【#生スバル】おさんぽスバルしゅばああああああああああああああああああああああああああああ / MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-05T18:29:25Z"
  },
  {
    "videoId": "f_bENYi30l8",
    "thumbnail": "https://i.ytimg.com/vi/f_bENYi30l8/mqdefault.jpg",
    "title": "【#2】日常 同時視聴 / NICHIJOU watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-07T15:12:34Z"
  },
  {
    "videoId": "KRc_aZ7VRgc",
    "thumbnail": "https://i.ytimg.com/vi/KRc_aZ7VRgc/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ 今日はフェスだ～～～！！！！！/ OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-08T03:09:58Z"
  },
  {
    "videoId": "0C2HvJDbZuM",
    "thumbnail": "https://i.ytimg.com/vi/0C2HvJDbZuM/mqdefault.jpg",
    "title": "【#生スバル】hololive 6th fes. ＆ EXPO振り返り感想会～！！！🐣【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-10T12:12:20Z"
  },
  {
    "videoId": "wtBrJY4hX4I",
    "thumbnail": "https://i.ytimg.com/vi/wtBrJY4hX4I/mqdefault.jpg",
    "title": "【#生スバル】モンハンワイルズやるしゅばああああああああああああああああああああ！！！！/ MONSTER HUNTER WILDS【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-11T15:48:18Z"
  },
  {
    "videoId": "A5z3RPusCyg",
    "thumbnail": "https://i.ytimg.com/vi/A5z3RPusCyg/mqdefault.jpg",
    "title": "【#みこスバモンハン】みこちとモンハンワイルズやるしゅばああああああああああああああああああああ！！！！/ MONSTER HUNTER WILDS【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-12T15:45:45Z"
  },
  {
    "videoId": "D-lgq7J_4cA",
    "thumbnail": "https://i.ytimg.com/vi/D-lgq7J_4cA/mqdefault.jpg",
    "title": "【#みこスバモンハン】2日目！！！みこちとモンハンワイルズやるしゅばああああああああああああああああああああ！！！！/ MONSTER HUNTER WILDS【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-13T15:37:40Z"
  },
  {
    "videoId": "hl_pXnUV5bE",
    "thumbnail": "https://i.ytimg.com/vi/hl_pXnUV5bE/mqdefault.jpg",
    "title": "【#3】日常 同時視聴 / NICHIJOU watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-14T15:02:23Z"
  },
  {
    "videoId": "RZISTNcvoTQ",
    "thumbnail": "https://i.ytimg.com/vi/RZISTNcvoTQ/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-15T02:40:34Z"
  },
  {
    "videoId": "zyGv3U4sZ0Q",
    "thumbnail": "https://i.ytimg.com/vi/zyGv3U4sZ0Q/mqdefault.jpg",
    "title": "【#生スバル】龍が如く７やるしゅばあああああああああああああああああああああああああああああああ！！！！！：yakuza7【※ネタバレあり】",
    "publishedAt": "2025-03-16T09:26:18Z"
  },
  {
    "videoId": "LDRPxRz_SW4",
    "thumbnail": "https://i.ytimg.com/vi/LDRPxRz_SW4/mqdefault.jpg",
    "title": "大空スバル 1st Album 『Pleiades』クロスフェード",
    "publishedAt": "2025-03-16T11:00:19Z"
  },
  {
    "videoId": "odTjti_z5dQ",
    "thumbnail": "https://i.ytimg.com/vi/odTjti_z5dQ/mqdefault.jpg",
    "title": "【#みこスバモンハン】3日目！！！みこちとモンハンワイルズやるしゅばああああああああああああああああああああ！！！！/ MONSTER HUNTER WILDS【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-16T15:49:31Z"
  },
  {
    "videoId": "4eHIKHsbCEg",
    "thumbnail": "https://i.ytimg.com/vi/4eHIKHsbCEg/mqdefault.jpg",
    "title": "【#生スバル】おさんぽスバルしゅばああああああああああああああああああああああああああああ / MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-18T16:56:50Z"
  },
  {
    "videoId": "EzNrEqw_l6k",
    "thumbnail": "https://i.ytimg.com/vi/EzNrEqw_l6k/mqdefault.jpg",
    "title": "【#みこスバモンハン】4日目！！！みこちとモンハンワイルズやるしゅばああああああああああああああああああああ！！！！/ MONSTER HUNTER WILDS【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-19T16:23:11Z"
  },
  {
    "videoId": "vG9V3FECUhU",
    "thumbnail": "https://i.ytimg.com/vi/vG9V3FECUhU/mqdefault.jpg",
    "title": "【#4】日常 同時視聴 / NICHIJOU watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-21T15:02:07Z"
  },
  {
    "videoId": "9zhbMvAMyPY",
    "thumbnail": "https://i.ytimg.com/vi/9zhbMvAMyPY/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-22T02:22:50Z"
  },
  {
    "videoId": "0j0OLqjP5Gw",
    "thumbnail": "https://i.ytimg.com/vi/0j0OLqjP5Gw/mqdefault.jpg",
    "title": "【#2】龍が如く７やるしゅばあああああああああああああああああああああああああああああああ！！！！！：yakuza7【※ネタバレあり】",
    "publishedAt": "2025-03-22T09:06:49Z"
  },
  {
    "videoId": "tpiej-1YBN8",
    "thumbnail": "https://i.ytimg.com/vi/tpiej-1YBN8/mqdefault.jpg",
    "title": "【#3】龍が如く７やるしゅばあああああああああああああああああああああああああああああああ！！！！！：yakuza7【※ネタバレあり】",
    "publishedAt": "2025-03-23T08:53:51Z"
  },
  {
    "videoId": "_pSEk5PdRTY",
    "thumbnail": "https://i.ytimg.com/vi/_pSEk5PdRTY/mqdefault.jpg",
    "title": "【#みこスバモンハン】5日目！！！みこちとモンハンワイルズやるしゅばああああああああああああああああああああ！！！！/ MONSTER HUNTER WILDS【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-23T15:53:31Z"
  },
  {
    "videoId": "rzqDnZ0vXwc",
    "thumbnail": "https://i.ytimg.com/vi/rzqDnZ0vXwc/mqdefault.jpg",
    "title": "【#生スバル】心霊物件やるしゅばあああああああああああああああああああああああああああああああ！！！！！！！！：Haunted Property【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-26T14:33:34Z"
  },
  {
    "videoId": "t9MHW4V4ZBM",
    "thumbnail": "https://i.ytimg.com/vi/t9MHW4V4ZBM/mqdefault.jpg",
    "title": "【#生スバル】手書き切り抜き鑑賞会やるしゅばあああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-27T12:13:18Z"
  },
  {
    "videoId": "feghh-mCSm0",
    "thumbnail": "https://i.ytimg.com/vi/feghh-mCSm0/mqdefault.jpg",
    "title": "【#5】日常 同時視聴 / NICHIJOU watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-28T15:36:53Z"
  },
  {
    "videoId": "MApEM6jmlec",
    "thumbnail": "https://i.ytimg.com/vi/MApEM6jmlec/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-03-29T02:24:29Z"
  },
  {
    "videoId": "G1u7cli_xkI",
    "thumbnail": "https://i.ytimg.com/vi/G1u7cli_xkI/mqdefault.jpg",
    "title": "【#4】龍が如く７やるしゅばあああああああああああああああああああああああああああああああ！！！！！：yakuza7【※ネタバレあり】",
    "publishedAt": "2025-03-29T10:27:40Z"
  },
  {
    "videoId": "3fpvoVAsksA",
    "thumbnail": "https://i.ytimg.com/vi/3fpvoVAsksA/mqdefault.jpg",
    "title": "【#5】龍が如く７やるしゅばあああああああああああああああああああああああああああああああ！！！！！：yakuza7【※ネタバレあり】",
    "publishedAt": "2025-03-30T09:03:42Z"
  },
  {
    "videoId": "7srIelNVuos",
    "thumbnail": "https://i.ytimg.com/vi/7srIelNVuos/mqdefault.jpg",
    "title": "【#みこスバモンハン】6日目！下位最終回！！みこちとモンハンワイルズやるしゅばああああああああああああああああああああ！！！！/ MONSTER HUNTER WILDS【ネタバレ注意】",
    "publishedAt": "2025-03-30T16:31:04Z"
  },
  {
    "videoId": "DQaNi9eHS2A",
    "thumbnail": "https://i.ytimg.com/vi/DQaNi9eHS2A/mqdefault.jpg",
    "title": "【#スバおか】💛スバおか💜にゃんらぶ😸💛ちゃんねるっ💜  始動――――【ホロライブ】",
    "publishedAt": "2025-04-01T15:03:17Z"
  },
  {
    "videoId": "0rRvPOQ1kK8",
    "thumbnail": "https://i.ytimg.com/vi/0rRvPOQ1kK8/mqdefault.jpg",
    "title": "【#生スバル】BLEACH Rebirth of Soulsやるしゅばあああああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-02T12:23:33Z"
  },
  {
    "videoId": "RjjKIxcZvWQ",
    "thumbnail": "https://i.ytimg.com/vi/RjjKIxcZvWQ/mqdefault.jpg",
    "title": "【#生スバル】ニンダイ見るしゅばああああああああああああああああああああ！！！！！：Nintendo Direct watching【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-02T14:17:26Z"
  },
  {
    "videoId": "mtNeWquUCGE",
    "thumbnail": "https://i.ytimg.com/vi/mtNeWquUCGE/mqdefault.jpg",
    "title": "【#生スバル】7日目！上位突入！！みこちとモンハンワイルズやるしゅばああああああああああああああああああああ！！！！/ MONSTER HUNTER WILDS【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-03T17:12:22Z"
  },
  {
    "videoId": "DcDVBmuQf2s",
    "thumbnail": "https://i.ytimg.com/vi/DcDVBmuQf2s/mqdefault.jpg",
    "title": "🌼大空スバル 1st Album Pleiades 好評発売中しゅば！🌼 #hololive #shorts",
    "publishedAt": "2025-04-04T11:00:20Z"
  },
  {
    "videoId": "HWPHVRRGkYI",
    "thumbnail": "https://i.ytimg.com/vi/HWPHVRRGkYI/mqdefault.jpg",
    "title": "【#最終回】日常 同時視聴 / NICHIJOU watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-04T15:43:15Z"
  },
  {
    "videoId": "OXrTNqF-33U",
    "thumbnail": "https://i.ytimg.com/vi/OXrTNqF-33U/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-05T02:28:08Z"
  },
  {
    "videoId": "6CisK7Xpnl0",
    "thumbnail": "https://i.ytimg.com/vi/6CisK7Xpnl0/mqdefault.jpg",
    "title": "【#6】龍が如く７やるしゅばあああああああああああああああああああああああああああああああ！！！！！：yakuza7【※ネタバレあり】",
    "publishedAt": "2025-04-05T10:03:58Z"
  },
  {
    "videoId": "ddl3VyYtIak",
    "thumbnail": "https://i.ytimg.com/vi/ddl3VyYtIak/mqdefault.jpg",
    "title": "【#7】龍が如く７やるしゅばあああああああああああああああああああああああああああああああ！！！！！：yakuza7【※ネタバレあり】",
    "publishedAt": "2025-04-06T09:28:07Z"
  },
  {
    "videoId": "hDbaqtxreyY",
    "thumbnail": "https://i.ytimg.com/vi/hDbaqtxreyY/mqdefault.jpg",
    "title": "【#生スバル】スバルの小屋！！！やるしゅばあああああああああああああああああ！！！！！～ゲスト：FUWAMOCO～【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-06T12:06:34Z"
  },
  {
    "videoId": "bqQDHC8rByo",
    "thumbnail": "https://i.ytimg.com/vi/bqQDHC8rByo/mqdefault.jpg",
    "title": "【#生スバル】スバおかマリカ2025やるしゅばあああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-08T15:48:42Z"
  },
  {
    "videoId": "hJYgMyfFam0",
    "thumbnail": "https://i.ytimg.com/vi/hJYgMyfFam0/mqdefault.jpg",
    "title": "【#2】BLEACH Rebirth of Soulsやるしゅばあああああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-10T16:28:46Z"
  },
  {
    "videoId": "droIYawGwCM",
    "thumbnail": "https://i.ytimg.com/vi/droIYawGwCM/mqdefault.jpg",
    "title": "【#生スバル】Fate/stay night みるしゅばああああああああああああああああああ！！！！！！：Fate/stay night watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-11T15:20:54Z"
  },
  {
    "videoId": "ZElJT6PTpSE",
    "thumbnail": "https://i.ytimg.com/vi/ZElJT6PTpSE/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-12T02:22:28Z"
  },
  {
    "videoId": "2Jj2pROZldw",
    "thumbnail": "https://i.ytimg.com/vi/2Jj2pROZldw/mqdefault.jpg",
    "title": "【#8】龍が如く７やるしゅばあああああああああああああああああああああああああああああああ！！！！！：yakuza7【※ネタバレあり】",
    "publishedAt": "2025-04-12T10:03:34Z"
  },
  {
    "videoId": "4x58IAkvQ6E",
    "thumbnail": "https://i.ytimg.com/vi/4x58IAkvQ6E/mqdefault.jpg",
    "title": "【#9】龍が如く７やるしゅばあああああああああああああああああああああああああああああああ！！！！！：yakuza7【※ネタバレあり】",
    "publishedAt": "2025-04-13T10:09:42Z"
  },
  {
    "videoId": "y50Yh1-KUrM",
    "thumbnail": "https://i.ytimg.com/vi/y50Yh1-KUrM/mqdefault.jpg",
    "title": "【#生スバル】8日目！上位突入！！みこちとモンハンワイルズやるしゅばああああああああああああああああああああ！！！！/ MONSTER HUNTER WILDS【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-13T17:38:50Z"
  },
  {
    "videoId": "Rh8p4tyxzTA",
    "thumbnail": "https://i.ytimg.com/vi/Rh8p4tyxzTA/mqdefault.jpg",
    "title": "【#生スバル】大空スバルか、エレン・イェーガーか…クイズメーカーやるしゅばああああああああ：Quiz to choose between Eren Jaeger or Subaru【ホロライブ】",
    "publishedAt": "2025-04-15T14:36:53Z"
  },
  {
    "videoId": "viyOqZyTIVA",
    "thumbnail": "https://i.ytimg.com/vi/viyOqZyTIVA/mqdefault.jpg",
    "title": "【#3】BLEACH Rebirth of Soulsやるしゅばあああああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-18T12:44:55Z"
  },
  {
    "videoId": "BKV3WCIwlgQ",
    "thumbnail": "https://i.ytimg.com/vi/BKV3WCIwlgQ/mqdefault.jpg",
    "title": "【#2】Fate/stay night みるしゅばああああああああああああああああああ！！！！！！：Fate/stay night watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-18T15:18:59Z"
  },
  {
    "videoId": "e1aWk2tuIMI",
    "thumbnail": "https://i.ytimg.com/vi/e1aWk2tuIMI/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-19T02:26:58Z"
  },
  {
    "videoId": "5Gf_OXuNwfE",
    "thumbnail": "https://i.ytimg.com/vi/5Gf_OXuNwfE/mqdefault.jpg",
    "title": "【#10】龍が如く７やるしゅばあああああああああああああああああああああああああああああああ！！！！！：yakuza7【※ネタバレあり】",
    "publishedAt": "2025-04-19T09:20:06Z"
  },
  {
    "videoId": "8zjE59SQRjM",
    "thumbnail": "https://i.ytimg.com/vi/8zjE59SQRjM/mqdefault.jpg",
    "title": "【#holoRUST】仙人のホロ鯖おさんぽRUST【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-19T17:56:44Z"
  },
  {
    "videoId": "kEFL88TOlVU",
    "thumbnail": "https://i.ytimg.com/vi/kEFL88TOlVU/mqdefault.jpg",
    "title": "【#11】龍が如く７やるしゅばあああああああああああああああああああああああああああああああ！！！！！：yakuza7【※ネタバレあり】",
    "publishedAt": "2025-04-20T08:40:00Z"
  },
  {
    "videoId": "qZkkS2s8Nrg",
    "thumbnail": "https://i.ytimg.com/vi/qZkkS2s8Nrg/mqdefault.jpg",
    "title": "【#holoRUST】Daｙ２仙人のホロ鯖おさんぽRUST【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-20T17:27:17Z"
  },
  {
    "videoId": "3VkvG1GVE4Y",
    "thumbnail": "https://i.ytimg.com/vi/3VkvG1GVE4Y/mqdefault.jpg",
    "title": "【#holoRUST】Daｙ3 仙人のホロ鯖おさんぽRUST【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-22T18:35:18Z"
  },
  {
    "videoId": "ybHcwSByHFc",
    "thumbnail": "https://i.ytimg.com/vi/ybHcwSByHFc/mqdefault.jpg",
    "title": "【#holoRUST】Day4 仙人のホロ鯖おさんぽRUST【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-24T18:21:07Z"
  },
  {
    "videoId": "VKnoAYHVei4",
    "thumbnail": "https://i.ytimg.com/vi/VKnoAYHVei4/mqdefault.jpg",
    "title": "【#3】Fate/stay night みるしゅばああああああああああああああああああ！！！！！！：Fate/stay night watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-25T16:58:25Z"
  },
  {
    "videoId": "BBZmcncSRpQ",
    "thumbnail": "https://i.ytimg.com/vi/BBZmcncSRpQ/mqdefault.jpg",
    "title": "【#12】龍が如く７やるしゅばあああああああああああああああああああああああああああああああ！！！！！：yakuza7【※ネタバレあり】",
    "publishedAt": "2025-04-26T08:23:36Z"
  },
  {
    "videoId": "v-2eM7LoNq8",
    "thumbnail": "https://i.ytimg.com/vi/v-2eM7LoNq8/mqdefault.jpg",
    "title": "【MV】スターライト【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-26T13:50:06Z"
  },
  {
    "videoId": "GB4ZAGcoLVU",
    "thumbnail": "https://i.ytimg.com/vi/GB4ZAGcoLVU/mqdefault.jpg",
    "title": "【#4】BLEACH Rebirth of Soulsやるしゅばあああああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-04-29T17:33:36Z"
  },
  {
    "videoId": "_DG8EymRrlw",
    "thumbnail": "https://i.ytimg.com/vi/_DG8EymRrlw/mqdefault.jpg",
    "title": "【#生スバル】#大空スバルちゅきちゅき選手権　同時視聴しゅばああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-01T12:07:00Z"
  },
  {
    "videoId": "uM1Y5NnnV6k",
    "thumbnail": "https://i.ytimg.com/vi/uM1Y5NnnV6k/mqdefault.jpg",
    "title": "【#4】Fate/stay night みるしゅばああああああああああああああああああ！！！！！！：Fate/stay night watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-02T15:17:54Z"
  },
  {
    "videoId": "RXfKk6nC5n4",
    "thumbnail": "https://i.ytimg.com/vi/RXfKk6nC5n4/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-03T02:48:09Z"
  },
  {
    "videoId": "W5GNkDFjLGk",
    "thumbnail": "https://i.ytimg.com/vi/W5GNkDFjLGk/mqdefault.jpg",
    "title": "【#ホロGW釣り大会】魚釣るしゅばああああああああああああああああああああああああ！！！！！！！！！！/Mine Craft【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-03T06:27:43Z"
  },
  {
    "videoId": "g41OG-Vkayw",
    "thumbnail": "https://i.ytimg.com/vi/g41OG-Vkayw/mqdefault.jpg",
    "title": "【#生スバル】スバルの小屋！！！やるしゅばあああああああああああああああああ！！！！！～ゲスト：Marine～【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-05T12:04:06Z"
  },
  {
    "videoId": "iRzH1-TqEr8",
    "thumbnail": "https://i.ytimg.com/vi/iRzH1-TqEr8/mqdefault.jpg",
    "title": "【#ミオみこスバ 】春のホロメンお悩み相談会凸待ち【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-06T12:32:22Z"
  },
  {
    "videoId": "zlIReERds2U",
    "thumbnail": "https://i.ytimg.com/vi/zlIReERds2U/mqdefault.jpg",
    "title": "【#5】BLEACH Rebirth of Soulsやるしゅばあああああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-06T15:56:36Z"
  },
  {
    "videoId": "YWq8F9v2-ac",
    "thumbnail": "https://i.ytimg.com/vi/YWq8F9v2-ac/mqdefault.jpg",
    "title": "【#最終回】Fate/stay night みるしゅばああああああああああああああああああ！！！！！！：Fate/stay night watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-09T15:26:56Z"
  },
  {
    "videoId": "xBSKyauoXbU",
    "thumbnail": "https://i.ytimg.com/vi/xBSKyauoXbU/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-10T02:20:59Z"
  },
  {
    "videoId": "31pCN__bc8E",
    "thumbnail": "https://i.ytimg.com/vi/31pCN__bc8E/mqdefault.jpg",
    "title": "【#13】龍が如く７やるしゅばあああああああああああああああああああああああああああああああ！！！！！：yakuza7【※ネタバレあり】",
    "publishedAt": "2025-05-10T10:26:00Z"
  },
  {
    "videoId": "f7vXDoCPxCU",
    "thumbnail": "https://i.ytimg.com/vi/f7vXDoCPxCU/mqdefault.jpg",
    "title": "【#最終回】龍が如く７やるしゅばあああああああああああああああああああああああああああああああ！！！！！：yakuza7【※ネタバレあり】",
    "publishedAt": "2025-05-11T11:49:22Z"
  },
  {
    "videoId": "QNmCbZkwA1c",
    "thumbnail": "https://i.ytimg.com/vi/QNmCbZkwA1c/mqdefault.jpg",
    "title": "【#生スバル】ストーリークリア！！！！！みこちとモンハンワイルズやるしゅばああああああああああああああああああああ！！！！/ MONSTER HUNTER WILDS【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-13T15:50:24Z"
  },
  {
    "videoId": "wlF8R2LfnZw",
    "thumbnail": "https://i.ytimg.com/vi/wlF8R2LfnZw/mqdefault.jpg",
    "title": "【#6】BLEACH Rebirth of Soulsやるしゅばあああああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-15T16:23:40Z"
  },
  {
    "videoId": "KgQjaLsohtA",
    "thumbnail": "https://i.ytimg.com/vi/KgQjaLsohtA/mqdefault.jpg",
    "title": "【#生スバル】Fate/Zero 同時視聴しゅばあああああああああああああああああああああ！！！！：Fate/Zero watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-16T16:10:55Z"
  },
  {
    "videoId": "ZO-WRmVR5dY",
    "thumbnail": "https://i.ytimg.com/vi/ZO-WRmVR5dY/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-17T02:27:45Z"
  },
  {
    "videoId": "HVFzo0yP2Z4",
    "thumbnail": "https://i.ytimg.com/vi/HVFzo0yP2Z4/mqdefault.jpg",
    "title": "【#生スバル】龍が如く７外伝 名を消した男 やるしゅばあああああああああああ！！！！：Like a Dragon Gaiden: The Man Who Erased His Name【ネタバレあり】",
    "publishedAt": "2025-05-17T08:55:29Z"
  },
  {
    "videoId": "E8ekwedcAQ8",
    "thumbnail": "https://i.ytimg.com/vi/E8ekwedcAQ8/mqdefault.jpg",
    "title": "【#2】龍が如く７外伝 名を消した男 やるしゅばあああああああああああ！！！！：Like a Dragon Gaiden: The Man Who Erased His Name【ネタバレあり】",
    "publishedAt": "2025-05-18T08:42:47Z"
  },
  {
    "videoId": "GzBl7wOB_3o",
    "thumbnail": "https://i.ytimg.com/vi/GzBl7wOB_3o/mqdefault.jpg",
    "title": "🧸 #絶対アイドル辞めないで 🧸踊ってみたしゅば！ #shorts #short #踊ってみた #dance",
    "publishedAt": "2025-05-19T12:00:27Z"
  },
  {
    "videoId": "EU6r6n1nYJs",
    "thumbnail": "https://i.ytimg.com/vi/EU6r6n1nYJs/mqdefault.jpg",
    "title": "【#生スバル】最終回！！！！！みこちとモンハンワイルズやるしゅばああああああああああああああああああああ！！！！/ MONSTER HUNTER WILDS【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-20T16:34:23Z"
  },
  {
    "videoId": "iNGoDWB3l4Y",
    "thumbnail": "https://i.ytimg.com/vi/iNGoDWB3l4Y/mqdefault.jpg",
    "title": "【#生スバル】🚙１時間で１位とれなきゃ罰ゲームで誠意みせるマリオカート8DX🚙：MARIOKART【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-21T12:30:02Z"
  },
  {
    "videoId": "oDjN0xHjlCA",
    "thumbnail": "https://i.ytimg.com/vi/oDjN0xHjlCA/mqdefault.jpg",
    "title": "【#生スバル】スバルの小屋！！！やるしゅばあああああああああああああああああ！！！！！～ゲスト：Lamy～【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-21T14:13:50Z"
  },
  {
    "videoId": "OZlvi6MktyA",
    "thumbnail": "https://i.ytimg.com/vi/OZlvi6MktyA/mqdefault.jpg",
    "title": "【#生スバル】うなれ！！！！おれたちの！！！！報道魂！！！：The Headliners【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-22T13:31:18Z"
  },
  {
    "videoId": "1d0rC1uxeZo",
    "thumbnail": "https://i.ytimg.com/vi/1d0rC1uxeZo/mqdefault.jpg",
    "title": "【#2】Fate/Zero 同時視聴しゅばあああああああああああああああああああああ！！！！：Fate/Zero watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-23T15:49:18Z"
  },
  {
    "videoId": "Cia9PXI2ayY",
    "thumbnail": "https://i.ytimg.com/vi/Cia9PXI2ayY/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-24T02:31:38Z"
  },
  {
    "videoId": "_C3TLf_mlC0",
    "thumbnail": "https://i.ytimg.com/vi/_C3TLf_mlC0/mqdefault.jpg",
    "title": "【#3】龍が如く７外伝 名を消した男 やるしゅばあああああああああああ！！！！：Like a Dragon Gaiden: The Man Who Erased His Name【ネタバレあり】",
    "publishedAt": "2025-05-24T09:31:10Z"
  },
  {
    "videoId": "AMX3sacAJ_o",
    "thumbnail": "https://i.ytimg.com/vi/AMX3sacAJ_o/mqdefault.jpg",
    "title": "【#4】龍が如く７外伝 名を消した男 やるしゅばあああああああああああ！！！！：Like a Dragon Gaiden: The Man Who Erased His Name【ネタバレあり】",
    "publishedAt": "2025-05-25T09:27:31Z"
  },
  {
    "videoId": "sU9iG06OVBU",
    "thumbnail": "https://i.ytimg.com/vi/sU9iG06OVBU/mqdefault.jpg",
    "title": "【#7】BLEACH Rebirth of Soulsやるしゅばあああああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-27T15:57:51Z"
  },
  {
    "videoId": "716EGbZHk2Y",
    "thumbnail": "https://i.ytimg.com/vi/716EGbZHk2Y/mqdefault.jpg",
    "title": "【#生スバル】👻深夜の監視員がみた「何か」とは… 圧倒的高評価ホラゲー！Fears to Fathom - Ironbark Lookout👻【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-28T16:42:10Z"
  },
  {
    "videoId": "pWP-gqjhwuc",
    "thumbnail": "https://i.ytimg.com/vi/pWP-gqjhwuc/mqdefault.jpg",
    "title": "【#生スバル】👻化け物の住み家で宝探し！全員で生きて帰れ！圧倒的高評価神ゲーやるしゅばあああああああああああああああああああああ！！！！！！👻R.E.P.O【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-29T15:10:19Z"
  },
  {
    "videoId": "Jznr5qa2vtk",
    "thumbnail": "https://i.ytimg.com/vi/Jznr5qa2vtk/mqdefault.jpg",
    "title": "【#3】Fate/Zero 同時視聴しゅばあああああああああああああああああああああ！！！！：Fate/Zero watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-30T16:34:40Z"
  },
  {
    "videoId": "iuYJk0YffzY",
    "thumbnail": "https://i.ytimg.com/vi/iuYJk0YffzY/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-05-31T02:21:16Z"
  },
  {
    "videoId": "_B4tjQ-5DD4",
    "thumbnail": "https://i.ytimg.com/vi/_B4tjQ-5DD4/mqdefault.jpg",
    "title": "【#5】龍が如く７外伝 名を消した男 やるしゅばあああああああああああ！！！！：Like a Dragon Gaiden: The Man Who Erased His Name【ネタバレあり】",
    "publishedAt": "2025-05-31T10:02:11Z"
  },
  {
    "videoId": "N0ngi3SYqzU",
    "thumbnail": "https://i.ytimg.com/vi/N0ngi3SYqzU/mqdefault.jpg",
    "title": "【#8】BLEACH Rebirth of Soulsやるしゅばあああああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-01T09:12:49Z"
  },
  {
    "videoId": "_cOdVM_4GMM",
    "thumbnail": "https://i.ytimg.com/vi/_cOdVM_4GMM/mqdefault.jpg",
    "title": "【#生スバル】スバルの小屋！！！やるしゅばあああああああああああああああああ！！！！！～ゲスト：pekora～【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-03T12:09:44Z"
  },
  {
    "videoId": "DR0oHx7Dd3Q",
    "thumbnail": "https://i.ytimg.com/vi/DR0oHx7Dd3Q/mqdefault.jpg",
    "title": "【#SMOK】今日こそ生きて帰るぞ！！！！R.E.P.Oやるしゅばあああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-03T15:40:39Z"
  },
  {
    "videoId": "57FPjiR9UTE",
    "thumbnail": "https://i.ytimg.com/vi/57FPjiR9UTE/mqdefault.jpg",
    "title": "【#龍ファク】🦆ねこまたさんにルーンファクトリー最新作を布教してもらうしゅば？！？😸：Rune Factory Guardians of Azuma #ルンファク【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-04T12:45:09Z"
  },
  {
    "videoId": "2UKOSL1kccQ",
    "thumbnail": "https://i.ytimg.com/vi/2UKOSL1kccQ/mqdefault.jpg",
    "title": "【#ホロ落選マリカ】落選者・・・？？？取り消せよ！！！！今の言葉・・・！！！！！！！！！！！！！！：Mario Kart 8 Deluxe【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-05T14:15:47Z"
  },
  {
    "videoId": "Uyy2rFjCXCg",
    "thumbnail": "https://i.ytimg.com/vi/Uyy2rFjCXCg/mqdefault.jpg",
    "title": "【#4】Fate/Zero 同時視聴しゅばあああああああああああああああああああああ！！！！：Fate/Zero watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-06T15:38:36Z"
  },
  {
    "videoId": "0ZcrksUMvrE",
    "thumbnail": "https://i.ytimg.com/vi/0ZcrksUMvrE/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-07T02:30:31Z"
  },
  {
    "videoId": "5yPg7MKZcwc",
    "thumbnail": "https://i.ytimg.com/vi/5yPg7MKZcwc/mqdefault.jpg",
    "title": "【#9】BLEACH Rebirth of Soulsやるしゅばあああああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-07T10:04:07Z"
  },
  {
    "videoId": "QpZxNNN3raY",
    "thumbnail": "https://i.ytimg.com/vi/QpZxNNN3raY/mqdefault.jpg",
    "title": "【#最終回】BLEACH Rebirth of Soulsやるしゅばあああああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-08T12:17:24Z"
  },
  {
    "videoId": "HrZuM-uxcq0",
    "thumbnail": "https://i.ytimg.com/vi/HrZuM-uxcq0/mqdefault.jpg",
    "title": "【#ホロ金策サバイバル】💰DAY１💰 一攫千金めざして出陣しゅばあああああああああああああああああ！！！！！！！！:MineCraft【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-09T15:23:29Z"
  },
  {
    "videoId": "V_Em5yRKaA8",
    "thumbnail": "https://i.ytimg.com/vi/V_Em5yRKaA8/mqdefault.jpg",
    "title": "【#ホロ金策サバイバル】💰DAY2💰 一攫千金めざして出陣しゅばあああああああああああああああああ！！！！！！！！:MineCraft【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-10T15:13:09Z"
  },
  {
    "videoId": "8uuOhteYUSo",
    "thumbnail": "https://i.ytimg.com/vi/8uuOhteYUSo/mqdefault.jpg",
    "title": "【#ホロ金策サバイバル】💰DAY3💰 一攫千金めざして出陣しゅばあああああああああああああああああ！！！！！！！！:MineCraft【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-11T16:35:17Z"
  },
  {
    "videoId": "eFbSAmwQpFQ",
    "thumbnail": "https://i.ytimg.com/vi/eFbSAmwQpFQ/mqdefault.jpg",
    "title": "【#ホロ金策サバイバル】💰DAY4💰 一攫千金めざして出陣しゅばあああああああああああああああああ！！！！！！！！:MineCraft【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-12T15:50:23Z"
  },
  {
    "videoId": "0GP2q8arHyQ",
    "thumbnail": "https://i.ytimg.com/vi/0GP2q8arHyQ/mqdefault.jpg",
    "title": "【#ホロ金策サバイバル】💰最終日💰 一攫千金めざして出陣しゅばあああああああああああああああああ！！！！！！！！:MineCraft【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-13T16:09:22Z"
  },
  {
    "videoId": "IHxebEBBRyY",
    "thumbnail": "https://i.ytimg.com/vi/IHxebEBBRyY/mqdefault.jpg",
    "title": "【#最終回】Fate/Zero 同時視聴しゅばあああああああああああああああああああああ！！！！：Fate/Zero watching party【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-14T15:57:36Z"
  },
  {
    "videoId": "-jJl6nbOc8c",
    "thumbnail": "https://i.ytimg.com/vi/-jJl6nbOc8c/mqdefault.jpg",
    "title": "【#ホロ落選マリカ】最後かもしれないだろ・・・！！！！！！！！！！！！！！：Mario Kart 8 Deluxe【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-17T14:07:07Z"
  },
  {
    "videoId": "wfQ8U0FgHrQ",
    "thumbnail": "https://i.ytimg.com/vi/wfQ8U0FgHrQ/mqdefault.jpg",
    "title": "【#スバおか】ねこまたさん…帰って来なよ…俺たちの８デラックスにさ💜💛：Mario Kart 8 Deluxe【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-18T15:43:17Z"
  },
  {
    "videoId": "R8Qm6bjiF-Q",
    "thumbnail": "https://i.ytimg.com/vi/R8Qm6bjiF-Q/mqdefault.jpg",
    "title": "【#生スバル】スーパードンキーコングやるしゅばあああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-19T16:52:34Z"
  },
  {
    "videoId": "bBuE5a9tXBQ",
    "thumbnail": "https://i.ytimg.com/vi/bBuE5a9tXBQ/mqdefault.jpg",
    "title": "【#生スバル】Fate/stay night [Unlimited Blade Works]　同時視聴するしゅばああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-20T15:33:10Z"
  },
  {
    "videoId": "sIX5SP4Ro7E",
    "thumbnail": "https://i.ytimg.com/vi/sIX5SP4Ro7E/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-21T02:33:54Z"
  },
  {
    "videoId": "nYtOGTgrOK0",
    "thumbnail": "https://i.ytimg.com/vi/nYtOGTgrOK0/mqdefault.jpg",
    "title": "【ネタバレ有】逆転裁判２やるしゅばああああああああああああああああああ！！！！：Phoenix Wright: Ace Attorney – Justice for All【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-21T08:32:33Z"
  },
  {
    "videoId": "kbeRslAfP2Y",
    "thumbnail": "https://i.ytimg.com/vi/kbeRslAfP2Y/mqdefault.jpg",
    "title": "【#2】逆転裁判２やるしゅばああああああああああああああああああ！！！！：Phoenix Wright: Ace Attorney – Justice for All【ネタバレ有】",
    "publishedAt": "2025-06-22T06:24:36Z"
  },
  {
    "videoId": "E4ji0FY9JoA",
    "thumbnail": "https://i.ytimg.com/vi/E4ji0FY9JoA/mqdefault.jpg",
    "title": "【#ミオみこスバ 】みんなで山登りしゅばああああああああああああああああああああああああああああああああああああああああ！！！！！！！： PEAK【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-24T15:15:35Z"
  },
  {
    "videoId": "3f9Z11Q6F1c",
    "thumbnail": "https://i.ytimg.com/vi/3f9Z11Q6F1c/mqdefault.jpg",
    "title": "【#生スバル】👻高評価ホラゲー！！週末のレンタルハウスで起こった怪事件：Fears to Fathom: Woodbury Getaway👻【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-25T15:32:56Z"
  },
  {
    "videoId": "CVqum4UCdkw",
    "thumbnail": "https://i.ytimg.com/vi/CVqum4UCdkw/mqdefault.jpg",
    "title": "【#生スバル】スーパードンキーコングやるしゅばあああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-26T16:06:35Z"
  },
  {
    "videoId": "dYgPQxT3Ee0",
    "thumbnail": "https://i.ytimg.com/vi/dYgPQxT3Ee0/mqdefault.jpg",
    "title": "【#生スバル】遂にリリース！！！！シリーズ完全新作✨ ペルソナ５: The Phantom X プレイしていくしゅばああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-27T12:45:16Z"
  },
  {
    "videoId": "wrnTen9r1ho",
    "thumbnail": "https://i.ytimg.com/vi/wrnTen9r1ho/mqdefault.jpg",
    "title": "【#2】Fate/stay night [Unlimited Blade Works]　同時視聴するしゅばああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-27T15:21:08Z"
  },
  {
    "videoId": "D1mzk3-qQNU",
    "thumbnail": "https://i.ytimg.com/vi/D1mzk3-qQNU/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-06-28T02:32:05Z"
  },
  {
    "videoId": "KwtF8K6RPI0",
    "thumbnail": "https://i.ytimg.com/vi/KwtF8K6RPI0/mqdefault.jpg",
    "title": "【#3】逆転裁判２やるしゅばああああああああああああああああああ！！！！：Phoenix Wright: Ace Attorney – Justice for All【ネタバレ有】",
    "publishedAt": "2025-06-28T08:28:50Z"
  },
  {
    "videoId": "nhjRR6r78yI",
    "thumbnail": "https://i.ytimg.com/vi/nhjRR6r78yI/mqdefault.jpg",
    "title": "【#4】逆転裁判２やるしゅばああああああああああああああああああ！！！！：Phoenix Wright: Ace Attorney – Justice for All【ネタバレ有】",
    "publishedAt": "2025-06-29T08:25:27Z"
  },
  {
    "videoId": "oryWoTSfu2s",
    "thumbnail": "https://i.ytimg.com/vi/oryWoTSfu2s/mqdefault.jpg",
    "title": "【#生スバル】お誕生日カウントダウンしゅばああああああああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-01T15:36:35Z"
  },
  {
    "videoId": "cfWYBUuDRA8",
    "thumbnail": "https://i.ytimg.com/vi/cfWYBUuDRA8/mqdefault.jpg",
    "title": "【#大空スバル生誕祭2025】大空スバル爆誕！大空スバル分かり手選手権！！：Who Understands Subaru Oozora the Best?グッズ告知あり【ホロライブ】",
    "publishedAt": "2025-07-02T13:40:19Z"
  },
  {
    "videoId": "Wkp9558Wbk0",
    "thumbnail": "https://i.ytimg.com/vi/Wkp9558Wbk0/mqdefault.jpg",
    "title": "【#生スバル】ホロメンからの！大空スバル印象アンケート【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-03T14:14:07Z"
  },
  {
    "videoId": "z9R5SaJcb_4",
    "thumbnail": "https://i.ytimg.com/vi/z9R5SaJcb_4/mqdefault.jpg",
    "title": "【#3】Fate/stay night [Unlimited Blade Works]　同時視聴するしゅばああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-04T15:13:02Z"
  },
  {
    "videoId": "2S2RvaL954U",
    "thumbnail": "https://i.ytimg.com/vi/2S2RvaL954U/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-05T02:21:29Z"
  },
  {
    "videoId": "r265cpBRxC8",
    "thumbnail": "https://i.ytimg.com/vi/r265cpBRxC8/mqdefault.jpg",
    "title": "【#5】逆転裁判２やるしゅばああああああああああああああああああ！！！！：Phoenix Wright: Ace Attorney – Justice for All【ネタバレ有】",
    "publishedAt": "2025-07-05T08:31:05Z"
  },
  {
    "videoId": "7dvSj0YbiBs",
    "thumbnail": "https://i.ytimg.com/vi/7dvSj0YbiBs/mqdefault.jpg",
    "title": "【#スバころ】🐶緊急スバころ🦆【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-08T13:14:34Z"
  },
  {
    "videoId": "6jcv8qDxC40",
    "thumbnail": "https://i.ytimg.com/vi/6jcv8qDxC40/mqdefault.jpg",
    "title": "【#生スバル】スーパードンキーコングやるしゅばあああああああああああああああああああ！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-09T16:44:27Z"
  },
  {
    "videoId": "qglDB65p4bc",
    "thumbnail": "https://i.ytimg.com/vi/qglDB65p4bc/mqdefault.jpg",
    "title": "【#4】Fate/stay night [Unlimited Blade Works]　同時視聴するしゅばああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-11T15:40:28Z"
  },
  {
    "videoId": "TvKoJ0MDwUA",
    "thumbnail": "https://i.ytimg.com/vi/TvKoJ0MDwUA/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-12T02:29:34Z"
  },
  {
    "videoId": "lrgXvStqq3w",
    "thumbnail": "https://i.ytimg.com/vi/lrgXvStqq3w/mqdefault.jpg",
    "title": "【#6】逆転裁判２やるしゅばああああああああああああああああああ！！！！：Phoenix Wright: Ace Attorney – Justice for All【ネタバレ有】",
    "publishedAt": "2025-07-12T09:24:06Z"
  },
  {
    "videoId": "EZAGKN_GbrQ",
    "thumbnail": "https://i.ytimg.com/vi/EZAGKN_GbrQ/mqdefault.jpg",
    "title": "【#7】逆転裁判２やるしゅばああああああああああああああああああ！！！！：Phoenix Wright: Ace Attorney – Justice for All【ネタバレ有】",
    "publishedAt": "2025-07-13T08:36:37Z"
  },
  {
    "videoId": "sXlUsiY2uAg",
    "thumbnail": "https://i.ytimg.com/vi/sXlUsiY2uAg/mqdefault.jpg",
    "title": "【#生スバル】圧倒的神ゲー PORTAL するしゅばああああああああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-15T16:14:40Z"
  },
  {
    "videoId": "u0NlMQjVWZI",
    "thumbnail": "https://i.ytimg.com/vi/u0NlMQjVWZI/mqdefault.jpg",
    "title": "【#生スバル】スーパードンキーコング２：Donkey Kong Country 2: Diddy's Kong Quest【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-16T16:29:59Z"
  },
  {
    "videoId": "PySmn46Bn1Y",
    "thumbnail": "https://i.ytimg.com/vi/PySmn46Bn1Y/mqdefault.jpg",
    "title": "【グッズ告知】大空スバル2025生誕グッズ：Ozora Subaru Birth Day Goods2025【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-17T06:00:32Z"
  },
  {
    "videoId": "1Fobh1Z29A8",
    "thumbnail": "https://i.ytimg.com/vi/1Fobh1Z29A8/mqdefault.jpg",
    "title": "【#生スバル】鼻、バッバイ！手術直前魂の雑談：Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-17T12:06:22Z"
  },
  {
    "videoId": "j5v7PkuDlmc",
    "thumbnail": "https://i.ytimg.com/vi/j5v7PkuDlmc/mqdefault.jpg",
    "title": "【#ホロ7DTDハード】今回はハードモード？！？ゾンビVS人間のバトルしゅばあああああああああああああああ！！！！！：7days to die【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-17T16:35:25Z"
  },
  {
    "videoId": "cggbkt-OPv4",
    "thumbnail": "https://i.ytimg.com/vi/cggbkt-OPv4/mqdefault.jpg",
    "title": "最高の夏なんですけど！！#holonatsuParadise #ホロナツpiece #shorts【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-23T09:00:55Z"
  },
  {
    "videoId": "47xKEUQC30I",
    "thumbnail": "https://i.ytimg.com/vi/47xKEUQC30I/mqdefault.jpg",
    "title": "🏖マーちゃんのIII踊ってみたよ～！🏖 #踊ってみた #short #shorts #dance",
    "publishedAt": "2025-07-24T12:00:07Z"
  },
  {
    "videoId": "CHQuhy8FuYs",
    "thumbnail": "https://i.ytimg.com/vi/CHQuhy8FuYs/mqdefault.jpg",
    "title": "【#生スバル】復活のおはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-26T02:39:56Z"
  },
  {
    "videoId": "rlD10wF01qw",
    "thumbnail": "https://i.ytimg.com/vi/rlD10wF01qw/mqdefault.jpg",
    "title": "【最強】夏だ！水着だ！！一番強いケツは誰だ！？ホロライブ尻相撲大会！！【#holonatsuParadise】",
    "publishedAt": "2025-07-26T10:41:37Z"
  },
  {
    "videoId": "b0SKX1CU-40",
    "thumbnail": "https://i.ytimg.com/vi/b0SKX1CU-40/mqdefault.jpg",
    "title": "【#8】逆転裁判２やるしゅばああああああああああああああああああ！！！！：Phoenix Wright: Ace Attorney – Justice for All【ネタバレ有】",
    "publishedAt": "2025-07-27T08:17:45Z"
  },
  {
    "videoId": "EgGDLop0ZRM",
    "thumbnail": "https://i.ytimg.com/vi/EgGDLop0ZRM/mqdefault.jpg",
    "title": "#ハレ晴レユカイ 踊ってみた！👒 #shorts    #short #dance",
    "publishedAt": "2025-07-27T12:30:14Z"
  },
  {
    "videoId": "rSOeMd0ThiU",
    "thumbnail": "https://i.ytimg.com/vi/rSOeMd0ThiU/mqdefault.jpg",
    "title": "【#ホロ7DTDハード】お久しぶりです！！！！！！！！ゾンビVS人間のバトルしゅばあああああああああああああああ！！！！！：7days to die【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-29T16:50:03Z"
  },
  {
    "videoId": "PEBUb3AnDIg",
    "thumbnail": "https://i.ytimg.com/vi/PEBUb3AnDIg/mqdefault.jpg",
    "title": "【#2】スーパードンキーコング２：Donkey Kong Country 2: Diddy's Kong Quest【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-30T16:59:37Z"
  },
  {
    "videoId": "Kfu13pGNAms",
    "thumbnail": "https://i.ytimg.com/vi/Kfu13pGNAms/mqdefault.jpg",
    "title": "【#ホロ7DTDハード】襲撃だ～～～～！！！！ゾンビVS人間のバトルしゅばあああああああああああああああ！！！！！：7days to die【ホロライブ/大空スバル】",
    "publishedAt": "2025-07-31T16:59:27Z"
  },
  {
    "videoId": "lRzh96UsUpU",
    "thumbnail": "https://i.ytimg.com/vi/lRzh96UsUpU/mqdefault.jpg",
    "title": "【#5】Fate/stay night [Unlimited Blade Works]　同時視聴するしゅばああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-01T16:21:07Z"
  },
  {
    "videoId": "3jRfYyHxvws",
    "thumbnail": "https://i.ytimg.com/vi/3jRfYyHxvws/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-02T02:29:14Z"
  },
  {
    "videoId": "36fjO2dKZls",
    "thumbnail": "https://i.ytimg.com/vi/36fjO2dKZls/mqdefault.jpg",
    "title": "【#最終回】逆転裁判２やるしゅばああああああああああああああああああ！！！！：Phoenix Wright: Ace Attorney – Justice for All【ネタバレ有】",
    "publishedAt": "2025-08-02T09:41:00Z"
  },
  {
    "videoId": "IEv_Hy_lZOM",
    "thumbnail": "https://i.ytimg.com/vi/IEv_Hy_lZOM/mqdefault.jpg",
    "title": "【#ホロ7DTDハード】レベルあげだ～～～～！！！！ゾンビVS人間のバトルしゅばあああああああああああああああ！！！！！：7days to die【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-05T16:01:01Z"
  },
  {
    "videoId": "tW92KO2jdFU",
    "thumbnail": "https://i.ytimg.com/vi/tW92KO2jdFU/mqdefault.jpg",
    "title": "【#生スバル】👻絶対に人間以外を家の中に入れるな‼‼‼No, I'm not a Human👻【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-06T15:06:13Z"
  },
  {
    "videoId": "5rN_ewW0asQ",
    "thumbnail": "https://i.ytimg.com/vi/5rN_ewW0asQ/mqdefault.jpg",
    "title": "【#スバころ】スーパードンキー１時間大並走やるしゅばあああああああああああああ！【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-07T12:28:54Z"
  },
  {
    "videoId": "6j9GRI5liDo",
    "thumbnail": "https://i.ytimg.com/vi/6j9GRI5liDo/mqdefault.jpg",
    "title": "【#ホロ7DTDハード】襲撃リベンジ！！！！ゾンビVS人間のバトルしゅばあああああああああああああああ！！！！！：7days to die【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-07T16:27:41Z"
  },
  {
    "videoId": "D0VcOgQT-ys",
    "thumbnail": "https://i.ytimg.com/vi/D0VcOgQT-ys/mqdefault.jpg",
    "title": "【#最終回】最終回！Fate/stay night [Unlimited Blade Works]　同時視聴するしゅばああああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-08T16:33:14Z"
  },
  {
    "videoId": "IFgtivmamvs",
    "thumbnail": "https://i.ytimg.com/vi/IFgtivmamvs/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-09T02:53:28Z"
  },
  {
    "videoId": "4XojVqihboU",
    "thumbnail": "https://i.ytimg.com/vi/4XojVqihboU/mqdefault.jpg",
    "title": "【#生スバル】ナルティメットストーム！やるしゅばあああああああああああああああああああ！！！！：NARUTO－ナルト－ 疾風伝 ナルティメットストームトリロジー【ネタバレあり】",
    "publishedAt": "2025-08-09T09:51:36Z"
  },
  {
    "videoId": "bxujZqlHx_4",
    "thumbnail": "https://i.ytimg.com/vi/bxujZqlHx_4/mqdefault.jpg",
    "title": "【#2】ナルティメットストーム！やるしゅばあああああああああああああああああああ！！！！：NARUTO－ナルト－ 疾風伝 ナルティメットストームトリロジー【ネタバレあり】",
    "publishedAt": "2025-08-10T09:33:34Z"
  },
  {
    "videoId": "zkoOi3dvMDQ",
    "thumbnail": "https://i.ytimg.com/vi/zkoOi3dvMDQ/mqdefault.jpg",
    "title": "【#生スバル】👻マジで今一番怖いホラゲー：Dread Flats👻【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-11T15:57:03Z"
  },
  {
    "videoId": "amBKfML2HNM",
    "thumbnail": "https://i.ytimg.com/vi/amBKfML2HNM/mqdefault.jpg",
    "title": "【#スバおか】😸オフコラボ！スバおかで最強隊士を目指すしゅばあああああああああああああああ！！！！：鬼滅の刃🦆【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-12T14:00:18Z"
  },
  {
    "videoId": "Iz5kxenI7JQ",
    "thumbnail": "https://i.ytimg.com/vi/Iz5kxenI7JQ/mqdefault.jpg",
    "title": "【#生スバル】夏休み特番！！！スバルの小屋！！！～ゲスト：サロメちゃん～【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-13T12:03:22Z"
  },
  {
    "videoId": "rQhNMzuP3Bg",
    "thumbnail": "https://i.ytimg.com/vi/rQhNMzuP3Bg/mqdefault.jpg",
    "title": "【#ホロ鯖サマーパーク】BIG3で尻相撲会場建設しゅばあああああああああああああああああああ！！！：MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-14T16:09:44Z"
  },
  {
    "videoId": "bYFY8eHiexk",
    "thumbnail": "https://i.ytimg.com/vi/bYFY8eHiexk/mqdefault.jpg",
    "title": "【#生スバル】新機動戦記ガンダムW 同時視聴会【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-15T15:21:10Z"
  },
  {
    "videoId": "ONHD1Vr3Jvk",
    "thumbnail": "https://i.ytimg.com/vi/ONHD1Vr3Jvk/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-16T02:36:47Z"
  },
  {
    "videoId": "M_f7gf4HAA8",
    "thumbnail": "https://i.ytimg.com/vi/M_f7gf4HAA8/mqdefault.jpg",
    "title": "【最終回】ナルティメットストーム！やるしゅばあああああああああああああああああああ！！！！：NARUTO－ナルト－ 疾風伝 ナルティメットストームトリロジー【ネタバレあり】",
    "publishedAt": "2025-08-16T08:58:45Z"
  },
  {
    "videoId": "qDkSajr21_s",
    "thumbnail": "https://i.ytimg.com/vi/qDkSajr21_s/mqdefault.jpg",
    "title": "【#ホロ鯖サマーパーク】ついに開園当日！！サマーパーク楽しむぞ！！！！：MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-16T13:46:15Z"
  },
  {
    "videoId": "ZWERHboC7cI",
    "thumbnail": "https://i.ytimg.com/vi/ZWERHboC7cI/mqdefault.jpg",
    "title": "【#生スバル】ナルティメットストーム２するしゅばああああああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2025-08-17T09:40:59Z"
  },
  {
    "videoId": "ixnW1oLmFEU",
    "thumbnail": "https://i.ytimg.com/vi/ixnW1oLmFEU/mqdefault.jpg",
    "title": "【カメラ枠】ホロカ大開封しゅばあああああああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-19T13:22:15Z"
  },
  {
    "videoId": "3EiB8kF_PAw",
    "thumbnail": "https://i.ytimg.com/vi/3EiB8kF_PAw/mqdefault.jpg",
    "title": "【#生スバル】あなたの願望をかなえます✨ホロライブ罵倒選手権！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-28T13:17:55Z"
  },
  {
    "videoId": "xC6qj7Wtzeo",
    "thumbnail": "https://i.ytimg.com/vi/xC6qj7Wtzeo/mqdefault.jpg",
    "title": "【#2】新機動戦記ガンダムW 同時視聴会【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-29T15:21:47Z"
  },
  {
    "videoId": "-2S1oYAtz80",
    "thumbnail": "https://i.ytimg.com/vi/-2S1oYAtz80/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-30T03:05:20Z"
  },
  {
    "videoId": "-cysRaXipJQ",
    "thumbnail": "https://i.ytimg.com/vi/-cysRaXipJQ/mqdefault.jpg",
    "title": "【#2】ナルティメットストーム２するしゅばああああああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2025-08-30T08:42:48Z"
  },
  {
    "videoId": "8hKuxWvyznA",
    "thumbnail": "https://i.ytimg.com/vi/8hKuxWvyznA/mqdefault.jpg",
    "title": "【#ホロ7DTDハード】最終襲撃！！！ゾンビVS人間のバトルしゅばあああああああああああああああ！！！！！：7days to die【ホロライブ/大空スバル】",
    "publishedAt": "2025-08-30T17:08:13Z"
  },
  {
    "videoId": "OjKBcNcfaJA",
    "thumbnail": "https://i.ytimg.com/vi/OjKBcNcfaJA/mqdefault.jpg",
    "title": "【#3】ナルティメットストーム２するしゅばああああああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2025-08-31T10:21:00Z"
  },
  {
    "videoId": "0bFFM9y-Fj0",
    "thumbnail": "https://i.ytimg.com/vi/0bFFM9y-Fj0/mqdefault.jpg",
    "title": "【#生スバル】👻ガチで怖いと噂の事故物件を一晩監視するゲーム：JSP日本事故物件協会👻【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-02T15:48:06Z"
  },
  {
    "videoId": "sqNGYGYa700",
    "thumbnail": "https://i.ytimg.com/vi/sqNGYGYa700/mqdefault.jpg",
    "title": "【#3】スーパードンキーコング２：Donkey Kong Country 2: Diddy's Kong Quest【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-03T16:29:08Z"
  },
  {
    "videoId": "bIB-D7NmvWo",
    "thumbnail": "https://i.ytimg.com/vi/bIB-D7NmvWo/mqdefault.jpg",
    "title": "【#生スバル】SWITCH2GET！！！！！！！感謝のマリオカートワールドしゅばああああああああああああああ！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-04T15:12:24Z"
  },
  {
    "videoId": "AMnu-6aHTPc",
    "thumbnail": "https://i.ytimg.com/vi/AMnu-6aHTPc/mqdefault.jpg",
    "title": "【#3】新機動戦記ガンダムW 同時視聴会【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-05T14:25:09Z"
  },
  {
    "videoId": "PmyyuP6U1h8",
    "thumbnail": "https://i.ytimg.com/vi/PmyyuP6U1h8/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-06T02:26:09Z"
  },
  {
    "videoId": "37xb_M8dI-E",
    "thumbnail": "https://i.ytimg.com/vi/37xb_M8dI-E/mqdefault.jpg",
    "title": "【#4】ナルティメットストーム２するしゅばああああああああああああああああああああ！！！！！【ネタバレあり】",
    "publishedAt": "2025-09-06T09:53:21Z"
  },
  {
    "videoId": "ui2bdB7FOfA",
    "thumbnail": "https://i.ytimg.com/vi/ui2bdB7FOfA/mqdefault.jpg",
    "title": "【#生スバル】ナルティメットストーム３するしゅばあああああああああああああああああああああ！！！！！【※ネタバレあり】",
    "publishedAt": "2025-09-07T09:44:42Z"
  },
  {
    "videoId": "WpVJkCLgar4",
    "thumbnail": "https://i.ytimg.com/vi/WpVJkCLgar4/mqdefault.jpg",
    "title": "【#生スバル】ミオしゃに捧げる1位！！！マリオカートワールドサバイバルwithド珍【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-09T13:34:49Z"
  },
  {
    "videoId": "L2_PLbfDRZs",
    "thumbnail": "https://i.ytimg.com/vi/L2_PLbfDRZs/mqdefault.jpg",
    "title": "ドッタバッタ珍道中 踊ってみた！🐺🌲 #shorts    #short #dance",
    "publishedAt": "2025-09-10T13:30:31Z"
  },
  {
    "videoId": "Lnb65wgwJ8A",
    "thumbnail": "https://i.ytimg.com/vi/Lnb65wgwJ8A/mqdefault.jpg",
    "title": "【#4】スーパードンキーコング２：Donkey Kong Country 2: Diddy's Kong Quest【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-11T16:10:11Z"
  },
  {
    "videoId": "ylsIXGpR1IQ",
    "thumbnail": "https://i.ytimg.com/vi/ylsIXGpR1IQ/mqdefault.jpg",
    "title": "【#4】新機動戦記ガンダムW 同時視聴会【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-12T15:27:30Z"
  },
  {
    "videoId": "lPaJh_Cx1j0",
    "thumbnail": "https://i.ytimg.com/vi/lPaJh_Cx1j0/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-13T02:33:53Z"
  },
  {
    "videoId": "qJtgDHe6apc",
    "thumbnail": "https://i.ytimg.com/vi/qJtgDHe6apc/mqdefault.jpg",
    "title": "【#2】ナルティメットストーム３するしゅばあああああああああああああああああああああ！！！！！【※ネタバレあり】",
    "publishedAt": "2025-09-13T07:55:49Z"
  },
  {
    "videoId": "IOEssMPygCI",
    "thumbnail": "https://i.ytimg.com/vi/IOEssMPygCI/mqdefault.jpg",
    "title": "【#3】ナルティメットストーム３するしゅばあああああああああああああああああああああ！！！！！【※ネタバレあり】",
    "publishedAt": "2025-09-14T09:16:12Z"
  },
  {
    "videoId": "JnncOMMe2Ks",
    "thumbnail": "https://i.ytimg.com/vi/JnncOMMe2Ks/mqdefault.jpg",
    "title": "【#生スバル】７周年前夜祭？！旧マネ新マネの大空スバル引継ぎ計画書！📗✏【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-15T13:18:40Z"
  },
  {
    "videoId": "-a9hq46v0Tk",
    "thumbnail": "https://i.ytimg.com/vi/-a9hq46v0Tk/mqdefault.jpg",
    "title": "【オリジナル曲】ラブミ！【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-16T13:00:06Z"
  },
  {
    "videoId": "AAkHUuow3Wk",
    "thumbnail": "https://i.ytimg.com/vi/AAkHUuow3Wk/mqdefault.jpg",
    "title": "【 #大空スバル７周年 】新衣装大発表会＆重大告知大発表会しゅば～～！！！！！：NEW OUTFIT💛【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-16T13:31:43Z"
  },
  {
    "videoId": "fbtk6pbzqjc",
    "thumbnail": "https://i.ytimg.com/vi/fbtk6pbzqjc/mqdefault.jpg",
    "title": "オリジナル曲 #ラブミ！ 学校で踊ってみた！🏫✐ #dance #shorts #short",
    "publishedAt": "2025-09-17T11:53:12Z"
  },
  {
    "videoId": "TP10YeMp49s",
    "thumbnail": "https://i.ytimg.com/vi/TP10YeMp49s/mqdefault.jpg",
    "title": "【#5】スーパードンキーコング２：Donkey Kong Country 2: Diddy's Kong Quest【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-18T17:01:03Z"
  },
  {
    "videoId": "EwmqOsUIL1o",
    "thumbnail": "https://i.ytimg.com/vi/EwmqOsUIL1o/mqdefault.jpg",
    "title": "【#5】新機動戦記ガンダムW 同時視聴会【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-19T15:29:34Z"
  },
  {
    "videoId": "5iM1kcG5s1c",
    "thumbnail": "https://i.ytimg.com/vi/5iM1kcG5s1c/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-20T02:34:58Z"
  },
  {
    "videoId": "KMaciu9cZIw",
    "thumbnail": "https://i.ytimg.com/vi/KMaciu9cZIw/mqdefault.jpg",
    "title": "【#4】ナルティメットストーム３するしゅばあああああああああああああああああああああ！！！！！【※ネタバレあり】",
    "publishedAt": "2025-09-20T09:50:30Z"
  },
  {
    "videoId": "RrULzwCY9Dk",
    "thumbnail": "https://i.ytimg.com/vi/RrULzwCY9Dk/mqdefault.jpg",
    "title": "【#最終回】ナルティメットストーム３するしゅばあああああああああああああああああああああ！！！！！【※ネタバレあり】",
    "publishedAt": "2025-09-21T09:44:06Z"
  },
  {
    "videoId": "rAFos7wFojA",
    "thumbnail": "https://i.ytimg.com/vi/rAFos7wFojA/mqdefault.jpg",
    "title": "【#生スバル】製品版きたあああああああああああああああ！！！！No, I'm not a Human【ホロライブ/大空スバル】※ネタバレ有",
    "publishedAt": "2025-09-23T16:43:33Z"
  },
  {
    "videoId": "2ST9IavNy84",
    "thumbnail": "https://i.ytimg.com/vi/2ST9IavNy84/mqdefault.jpg",
    "title": "【#みこスバ】💣２人で爆弾解除するしゅばあああああああああああ！！！！！！：Keep Talking and Nobody Explodes【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-24T15:33:37Z"
  },
  {
    "videoId": "5X9XKESKGuc",
    "thumbnail": "https://i.ytimg.com/vi/5X9XKESKGuc/mqdefault.jpg",
    "title": "【#生スバル】ゼルダの伝説 神々のトライフォース：The Legend of Zelda: A Link to the Past【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-25T16:19:04Z"
  },
  {
    "videoId": "UTPjKX888Qw",
    "thumbnail": "https://i.ytimg.com/vi/UTPjKX888Qw/mqdefault.jpg",
    "title": "【#6】新機動戦記ガンダムW 同時視聴会【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-26T15:28:39Z"
  },
  {
    "videoId": "L9lH7K2kYG8",
    "thumbnail": "https://i.ytimg.com/vi/L9lH7K2kYG8/mqdefault.jpg",
    "title": "【#生スバル】おはすば！！！！！ / OHASHUBA！！！FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-27T02:44:03Z"
  },
  {
    "videoId": "8hAl4maPbog",
    "thumbnail": "https://i.ytimg.com/vi/8hAl4maPbog/mqdefault.jpg",
    "title": "【#生スバル】ナルティメットストーム４やるしゅばあああああああああああああああああああああ！！！！：NARUTO SHIPPUDEN: Ultimate Ninja STORM 4【※ネタバレあり】",
    "publishedAt": "2025-09-27T09:21:38Z"
  },
  {
    "videoId": "qzQhwGkD82A",
    "thumbnail": "https://i.ytimg.com/vi/qzQhwGkD82A/mqdefault.jpg",
    "title": "【#2】ナルティメットストーム４：NARUTO SHIPPUDEN: Ultimate Ninja STORM 4【※ネタバレあり】",
    "publishedAt": "2025-09-28T09:16:51Z"
  },
  {
    "videoId": "-_eQgxYaaP0",
    "thumbnail": "https://i.ytimg.com/vi/-_eQgxYaaP0/mqdefault.jpg",
    "title": "新曲 #ラブミ アイドル衣装で踊ってみた！🌼 #shorts  #short #dance #踊ってみた",
    "publishedAt": "2025-09-29T12:09:09Z"
  },
  {
    "videoId": "tglGd0b43w8",
    "thumbnail": "https://i.ytimg.com/vi/tglGd0b43w8/mqdefault.jpg",
    "title": "【#ホロAmongUs3D】ガチPON集合！！！ ホロライブAmongUs3D するしゅばあああああああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-09-30T15:22:15Z"
  },
  {
    "videoId": "9O2b2VROFoA",
    "thumbnail": "https://i.ytimg.com/vi/9O2b2VROFoA/mqdefault.jpg",
    "title": "【#2】ゼルダの伝説 神々のトライフォース：The Legend of Zelda: A Link to the Past【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-01T16:10:11Z"
  },
  {
    "videoId": "JePEmaYUAPo",
    "thumbnail": "https://i.ytimg.com/vi/JePEmaYUAPo/mqdefault.jpg",
    "title": "【#生スバル】🍔 デスバーガー ：DEATH BURGER🍔【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-02T15:47:23Z"
  },
  {
    "videoId": "4Fv3Uj_F3rs",
    "thumbnail": "https://i.ytimg.com/vi/4Fv3Uj_F3rs/mqdefault.jpg",
    "title": "【#生スバル】おはすば！：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-04T02:34:53Z"
  },
  {
    "videoId": "wb3WhqtKy7Y",
    "thumbnail": "https://i.ytimg.com/vi/wb3WhqtKy7Y/mqdefault.jpg",
    "title": "【#本編最終回】ナルティメットストーム４：NARUTO SHIPPUDEN: Ultimate Ninja STORM 4【※ネタバレあり】",
    "publishedAt": "2025-10-04T09:19:43Z"
  },
  {
    "videoId": "_h46BCAMY9A",
    "thumbnail": "https://i.ytimg.com/vi/_h46BCAMY9A/mqdefault.jpg",
    "title": "【ドラゴンボール ゲキシン スクアドラ】ドラゴンボールの新作ゲーム！？すばちょこるなたんで遊ばせて頂くしゅばああああ【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-04T12:13:19Z"
  },
  {
    "videoId": "RoAyaFCvtg8",
    "thumbnail": "https://i.ytimg.com/vi/RoAyaFCvtg8/mqdefault.jpg",
    "title": "【#最終回】ナルティメットストーム４：NARUTO SHIPPUDEN: Ultimate Ninja STORM 4【※ネタバレあり】",
    "publishedAt": "2025-10-05T10:35:08Z"
  },
  {
    "videoId": "mkvRuYvSMgk",
    "thumbnail": "https://i.ytimg.com/vi/mkvRuYvSMgk/mqdefault.jpg",
    "title": "【#生スバル】👻高評価ホラゲー！！週末、この家では何かが起きる：Fears to Fathom - Carson House👻【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-07T16:11:44Z"
  },
  {
    "videoId": "ihQsYGyGzP4",
    "thumbnail": "https://i.ytimg.com/vi/ihQsYGyGzP4/mqdefault.jpg",
    "title": "【UNO凸待ち】ガチのマジでUNOしたい人集合：UNO【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-08T14:09:25Z"
  },
  {
    "videoId": "78YidEt8LOM",
    "thumbnail": "https://i.ytimg.com/vi/78YidEt8LOM/mqdefault.jpg",
    "title": "【#3】ゼルダの伝説 神々のトライフォース：The Legend of Zelda: A Link to the Past【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-09T16:07:05Z"
  },
  {
    "videoId": "wsXGoFXS-Vs",
    "thumbnail": "https://i.ytimg.com/vi/wsXGoFXS-Vs/mqdefault.jpg",
    "title": "【#7】新機動戦記ガンダムW 同時視聴会【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-10T15:50:56Z"
  },
  {
    "videoId": "YucQM0kiE5s",
    "thumbnail": "https://i.ytimg.com/vi/YucQM0kiE5s/mqdefault.jpg",
    "title": "【#生スバル】おはすば！：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-11T02:46:37Z"
  },
  {
    "videoId": "5PBA2TMqJpw",
    "thumbnail": "https://i.ytimg.com/vi/5PBA2TMqJpw/mqdefault.jpg",
    "title": "🥦Poppipo #ぽっぴっぽー 踊ってみた🍅 #dance #shorts #short",
    "publishedAt": "2025-10-12T11:00:07Z"
  },
  {
    "videoId": "eKuoCejmMyA",
    "thumbnail": "https://i.ytimg.com/vi/eKuoCejmMyA/mqdefault.jpg",
    "title": "【ソニックレーシング クロスワールド】オールスターレースゲームで4人で大バトルしゅばああああああああ！！！！【大空スバル視点】",
    "publishedAt": "2025-10-13T12:33:42Z"
  },
  {
    "videoId": "QS0HWYmpFns",
    "thumbnail": "https://i.ytimg.com/vi/QS0HWYmpFns/mqdefault.jpg",
    "title": "めちゃくちゃ前に撮影したやつ～！💃💃 #dance #shorts #short #踊ってみた",
    "publishedAt": "2025-10-13T13:01:19Z"
  },
  {
    "videoId": "2fJL-vQtu4A",
    "thumbnail": "https://i.ytimg.com/vi/2fJL-vQtu4A/mqdefault.jpg",
    "title": "【#4】ゼルダの伝説 神々のトライフォース：The Legend of Zelda: A Link to the Past【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-15T16:14:37Z"
  },
  {
    "videoId": "8MZgGLB0KD8",
    "thumbnail": "https://i.ytimg.com/vi/8MZgGLB0KD8/mqdefault.jpg",
    "title": "【＃生スバル】スバルの小屋　ゲスト：いろは！/IROHA Suba Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-16T13:07:59Z"
  },
  {
    "videoId": "7r57cADufUY",
    "thumbnail": "https://i.ytimg.com/vi/7r57cADufUY/mqdefault.jpg",
    "title": "【#最終回】新機動戦記ガンダムW 同時視聴会【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-17T16:15:16Z"
  },
  {
    "videoId": "XuodWw5BCBg",
    "thumbnail": "https://i.ytimg.com/vi/XuodWw5BCBg/mqdefault.jpg",
    "title": "【#生スバル】おはすば！：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-18T02:25:35Z"
  },
  {
    "videoId": "ADTt-W4Ni6w",
    "thumbnail": "https://i.ytimg.com/vi/ADTt-W4Ni6w/mqdefault.jpg",
    "title": "【#生スバル】SFC版 ドラゴンクエストIII そして伝説へ…：Dragon Warrior III【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-18T09:27:01Z"
  },
  {
    "videoId": "XvjdBEqQ5j0",
    "thumbnail": "https://i.ytimg.com/vi/XvjdBEqQ5j0/mqdefault.jpg",
    "title": "【#2】SFC版 ドラゴンクエストIII そして伝説へ…：Dragon Warrior III【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-19T10:30:45Z"
  },
  {
    "videoId": "Gdvp8IFDLpk",
    "thumbnail": "https://i.ytimg.com/vi/Gdvp8IFDLpk/mqdefault.jpg",
    "title": "【#ド珍組】ホラゲー！！DEVOUR やるしゅばああああああああああああああああ！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-20T12:47:52Z"
  },
  {
    "videoId": "jkbcUZ4TGrQ",
    "thumbnail": "https://i.ytimg.com/vi/jkbcUZ4TGrQ/mqdefault.jpg",
    "title": "【#5】ゼルダの伝説 神々のトライフォース：The Legend of Zelda: A Link to the Past【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-23T16:18:56Z"
  },
  {
    "videoId": "JgpJvqnNdk8",
    "thumbnail": "https://i.ytimg.com/vi/JgpJvqnNdk8/mqdefault.jpg",
    "title": "【#生スバル】🍃NARUTO THE LAST -NARUTO THE MOVIE- 同時視聴🍃【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-24T15:32:05Z"
  },
  {
    "videoId": "B11rCAuY6MQ",
    "thumbnail": "https://i.ytimg.com/vi/B11rCAuY6MQ/mqdefault.jpg",
    "title": "【#生スバル】おはすば！：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-25T02:35:28Z"
  },
  {
    "videoId": "l6ZB_7JwZIY",
    "thumbnail": "https://i.ytimg.com/vi/l6ZB_7JwZIY/mqdefault.jpg",
    "title": "【#3】SFC版 ドラゴンクエストIII そして伝説へ…：Dragon Warrior III【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-25T09:19:49Z"
  },
  {
    "videoId": "c8DQiraWTls",
    "thumbnail": "https://i.ytimg.com/vi/c8DQiraWTls/mqdefault.jpg",
    "title": "【#ホロライブ甲子園2025】ホロライブ甲子園同時視聴＆応援配信【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-26T12:48:27Z"
  },
  {
    "videoId": "rLVtAlHA95c",
    "thumbnail": "https://i.ytimg.com/vi/rLVtAlHA95c/mqdefault.jpg",
    "title": "【#6】ゼルダの伝説 神々のトライフォース：The Legend of Zelda: A Link to the Past【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-29T16:08:37Z"
  },
  {
    "videoId": "QIXuM9_SUUc",
    "thumbnail": "https://i.ytimg.com/vi/QIXuM9_SUUc/mqdefault.jpg",
    "title": "【#パッションアモアス】ハロウィンだ！！！！パッションだ！！！！！AmongUsだ！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-10-31T13:51:34Z"
  },
  {
    "videoId": "cgKPj5Ygrf8",
    "thumbnail": "https://i.ytimg.com/vi/cgKPj5Ygrf8/mqdefault.jpg",
    "title": "【#生スバル】おはすば！：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-01T02:28:45Z"
  },
  {
    "videoId": "OpySxBBE_cw",
    "thumbnail": "https://i.ytimg.com/vi/OpySxBBE_cw/mqdefault.jpg",
    "title": "【#4】SFC版 ドラゴンクエストIII そして伝説へ…：Dragon Warrior III【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-01T09:15:05Z"
  },
  {
    "videoId": "SkWlwiQ12rg",
    "thumbnail": "https://i.ytimg.com/vi/SkWlwiQ12rg/mqdefault.jpg",
    "title": "もうすぐ50万再生だ～❣ギリギリハロウィン🎃👻 #shorts #dance #short",
    "publishedAt": "2025-11-01T11:01:00Z"
  },
  {
    "videoId": "bPGDT3UcdLQ",
    "thumbnail": "https://i.ytimg.com/vi/bPGDT3UcdLQ/mqdefault.jpg",
    "title": "【#5】SFC版 ドラゴンクエストIII そして伝説へ…：Dragon Warrior III【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-02T10:00:47Z"
  },
  {
    "videoId": "qgIIugSsVMI",
    "thumbnail": "https://i.ytimg.com/vi/qgIIugSsVMI/mqdefault.jpg",
    "title": "【限界配信界隈】大空スバル【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-04T15:42:11Z"
  },
  {
    "videoId": "E_S5zXxTYdw",
    "thumbnail": "https://i.ytimg.com/vi/E_S5zXxTYdw/mqdefault.jpg",
    "title": "【#7】ゼルダの伝説 神々のトライフォース：The Legend of Zelda: A Link to the Past【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-06T16:20:39Z"
  },
  {
    "videoId": "zXUJr_JFnNw",
    "thumbnail": "https://i.ytimg.com/vi/zXUJr_JFnNw/mqdefault.jpg",
    "title": "【#生スバル】劇場版「Fate/stay night [Heaven’s Feel]」I.presage flower 同時視聴【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-07T15:50:36Z"
  },
  {
    "videoId": "vzUtitbNR1Y",
    "thumbnail": "https://i.ytimg.com/vi/vzUtitbNR1Y/mqdefault.jpg",
    "title": "【#生スバル】おはすば！：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-08T02:37:15Z"
  },
  {
    "videoId": "Jq66SqD24LY",
    "thumbnail": "https://i.ytimg.com/vi/Jq66SqD24LY/mqdefault.jpg",
    "title": "【#6】SFC版 ドラゴンクエストIII そして伝説へ…：Dragon Warrior III【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-08T09:31:54Z"
  },
  {
    "videoId": "7vo0OoUACOM",
    "thumbnail": "https://i.ytimg.com/vi/7vo0OoUACOM/mqdefault.jpg",
    "title": "【#7】SFC版 ドラゴンクエストIII そして伝説へ…：Dragon Warrior III【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-09T08:38:41Z"
  },
  {
    "videoId": "Zu9kmlmOuSg",
    "thumbnail": "https://i.ytimg.com/vi/Zu9kmlmOuSg/mqdefault.jpg",
    "title": "【＃生スバル】スバルの小屋　ゲスト：りりか/RIRIKA Suba Free Talk【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-13T14:14:44Z"
  },
  {
    "videoId": "oE1zccMVi8c",
    "thumbnail": "https://i.ytimg.com/vi/oE1zccMVi8c/mqdefault.jpg",
    "title": "【#8】SFC版 ドラゴンクエストIII そして伝説へ…：Dragon Warrior III【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-16T09:12:37Z"
  },
  {
    "videoId": "rCWFl7L0dk4",
    "thumbnail": "https://i.ytimg.com/vi/rCWFl7L0dk4/mqdefault.jpg",
    "title": "【#スバおか】深夜の！！！！スバおかマリカワールド：Mario Kart World【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-18T15:44:00Z"
  },
  {
    "videoId": "2FUkqBH2BU4",
    "thumbnail": "https://i.ytimg.com/vi/2FUkqBH2BU4/mqdefault.jpg",
    "title": "【#生スバル】エアライダー発売日前日！カービィのエアライドコラボ：Kirby Air Ride　スバりりフブおか【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-19T12:12:38Z"
  },
  {
    "videoId": "jGUXPZYYmH4",
    "thumbnail": "https://i.ytimg.com/vi/jGUXPZYYmH4/mqdefault.jpg",
    "title": "【#2】劇場版「Fate/stay night [Heaven’s Feel]」II.lost butterfly 同時視聴【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-21T15:53:06Z"
  },
  {
    "videoId": "395442F72QY",
    "thumbnail": "https://i.ytimg.com/vi/395442F72QY/mqdefault.jpg",
    "title": "【#生スバル】おはすば！：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-22T02:38:22Z"
  },
  {
    "videoId": "1OtUs937H9U",
    "thumbnail": "https://i.ytimg.com/vi/1OtUs937H9U/mqdefault.jpg",
    "title": "【#9】SFC版 ドラゴンクエストIII そして伝説へ…：Dragon Warrior III【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-22T08:06:53Z"
  },
  {
    "videoId": "hIWNP4FZbsI",
    "thumbnail": "https://i.ytimg.com/vi/hIWNP4FZbsI/mqdefault.jpg",
    "title": "【#生スバル】美少女盛りだくさん？！？スターセイヴァーやるしゅばあああああああああああああああああああああああああああああああ！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-22T11:01:28Z"
  },
  {
    "videoId": "Yy2ZovGi-Uk",
    "thumbnail": "https://i.ytimg.com/vi/Yy2ZovGi-Uk/mqdefault.jpg",
    "title": "【#10】SFC版 ドラゴンクエストIII そして伝説へ…：Dragon Warrior III【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-23T10:08:14Z"
  },
  {
    "videoId": "xx3ZTvOhNoM",
    "thumbnail": "https://i.ytimg.com/vi/xx3ZTvOhNoM/mqdefault.jpg",
    "title": "【#8】ゼルダの伝説 神々のトライフォース：The Legend of Zelda: A Link to the Past【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-25T16:14:17Z"
  },
  {
    "videoId": "3ZTc6IFGZYA",
    "thumbnail": "https://i.ytimg.com/vi/3ZTc6IFGZYA/mqdefault.jpg",
    "title": "【#生スバル】春日一番参戦‼‼ 視聴者参加型ソニックレーシング クロスワールド【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-27T12:17:21Z"
  },
  {
    "videoId": "WVdvlBQORmY",
    "thumbnail": "https://i.ytimg.com/vi/WVdvlBQORmY/mqdefault.jpg",
    "title": "【#ラムベガスグランドオープン】いくぞ！！！ラムベガス！！！！！：MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-27T15:20:39Z"
  },
  {
    "videoId": "zUGEPJbYjSY",
    "thumbnail": "https://i.ytimg.com/vi/zUGEPJbYjSY/mqdefault.jpg",
    "title": "【#3】劇場版「Fate/stay night [Heaven's Feel]」Ⅲ.spring song 同時視聴【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-28T16:06:49Z"
  },
  {
    "videoId": "tyWUIwwh3r8",
    "thumbnail": "https://i.ytimg.com/vi/tyWUIwwh3r8/mqdefault.jpg",
    "title": "【#生スバル】おはすば！：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-29T02:37:23Z"
  },
  {
    "videoId": "jXdOAhgz_fA",
    "thumbnail": "https://i.ytimg.com/vi/jXdOAhgz_fA/mqdefault.jpg",
    "title": "【#最終回 】SFC版 ドラゴンクエストIII そして伝説へ…：Dragon Warrior III【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-29T08:38:43Z"
  },
  {
    "videoId": "ySGCb-NnXQ8",
    "thumbnail": "https://i.ytimg.com/vi/ySGCb-NnXQ8/mqdefault.jpg",
    "title": "【#ラムベガスグランドオープン】一攫千金しゅばああああああああああああああああああああああああああああ！！！！！！！！！！：MINE CRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-29T15:11:04Z"
  },
  {
    "videoId": "JSdHyLXfnik",
    "thumbnail": "https://i.ytimg.com/vi/JSdHyLXfnik/mqdefault.jpg",
    "title": "【#ガチ最終回 】ゼルダの伝説 神々のトライフォース：The Legend of Zelda: A Link to the Past【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-30T07:38:22Z"
  },
  {
    "videoId": "qfkgtZ3O8bU",
    "thumbnail": "https://i.ytimg.com/vi/qfkgtZ3O8bU/mqdefault.jpg",
    "title": "【#ホロのエアライダー】エアライダー！シティトライアルで激突しゅばあああああああああああああ！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-11-30T14:48:52Z"
  },
  {
    "videoId": "frZa5ZaRGAc",
    "thumbnail": "https://i.ytimg.com/vi/frZa5ZaRGAc/mqdefault.jpg",
    "title": "【#ド珍組】噂のAIゲーム？！MIMESISやるしゅばああああああああああああああ！！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-12-02T14:13:03Z"
  },
  {
    "videoId": "JOm2fhkpI5A",
    "thumbnail": "https://i.ytimg.com/vi/JOm2fhkpI5A/mqdefault.jpg",
    "title": "【#生スバル】１２月だ！切り抜き鑑賞会やるしゅばああああああああああああああ！！！！！！！【ホロライブ/大空スバル】",
    "publishedAt": "2025-12-04T14:37:51Z"
  },
  {
    "videoId": "cT2sIg7Ko_c",
    "thumbnail": "https://i.ytimg.com/vi/cT2sIg7Ko_c/mqdefault.jpg",
    "title": "【#生スバル】NARUTOピックアップ回、同時視聴！！！🍃【ホロライブ/大空スバル】",
    "publishedAt": "2025-12-05T15:13:17Z"
  },
  {
    "videoId": "x_r6SmNeX-U",
    "thumbnail": "https://i.ytimg.com/vi/x_r6SmNeX-U/mqdefault.jpg",
    "title": "【#裏ダンジョン 】SFC版 ドラゴンクエストIII そして伝説へ…：Dragon Warrior III【ホロライブ/大空スバル】",
    "publishedAt": "2025-12-06T09:14:50Z"
  },
  {
    "videoId": "QISkmAlF5F4",
    "thumbnail": "https://i.ytimg.com/vi/QISkmAlF5F4/mqdefault.jpg",
    "title": "【#ホロドラゴンマイクラ】幻のドラゴンをゲットしに大冒険へ出発しゅばあああああああああああああああああ！！！！：MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-12-08T14:39:32Z"
  },
  {
    "videoId": "YxYiAqOJEjU",
    "thumbnail": "https://i.ytimg.com/vi/YxYiAqOJEjU/mqdefault.jpg",
    "title": "【DAY2】#ホロドラゴンマイクラ 幻のドラゴンをゲットしに大冒険へ出発しゅばあああああああああああああああああ！！！！：MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-12-09T15:27:31Z"
  },
  {
    "videoId": "GM37wlKMftI",
    "thumbnail": "https://i.ytimg.com/vi/GM37wlKMftI/mqdefault_live.jpg",
    "title": "【DAY3】#ホロドラゴンマイクラ 幻のドラゴンをゲットしに大冒険へ出発しゅばあああああああああああああああああ！！！！：MINECRAFT【ホロライブ/大空スバル】",
    "publishedAt": "2025-12-10T13:10:50Z"
  },
  {
    "videoId": "cwb8Lv4csME",
    "thumbnail": "https://i.ytimg.com/vi/cwb8Lv4csME/mqdefault_live.jpg",
    "title": "【】ウマ娘プリティーダービー同時視聴しゅば！【ホロライブ/大空スバル】",
    "publishedAt": "2025-12-10T13:12:24Z"
  },
  {
    "videoId": "Jb1z9VCZzoI",
    "thumbnail": "https://i.ytimg.com/vi/Jb1z9VCZzoI/mqdefault_live.jpg",
    "title": "【#生スバル】おはすば！：FREE TALK【ホロライブ/大空スバル】",
    "publishedAt": "2025-12-10T13:13:13Z"
  },
  {
    "videoId": "2FIb7rRyw_k",
    "thumbnail": "https://i.ytimg.com/vi/2FIb7rRyw_k/mqdefault_live.jpg",
    "title": "【】スーパーダンガンロンパ2 さよなら絶望学園 Anniversary Editionやるしゅば！【ホロライブ/大空スバル】",
    "publishedAt": "2025-12-10T13:14:50Z"
  },
  {
    "videoId": "rGiNMIA_1tg",
    "thumbnail": "https://i.ytimg.com/vi/rGiNMIA_1tg/mqdefault_live.jpg",
    "title": "【】スーパーダンガンロンパ2 さよなら絶望学園 Anniversary Editionやるしゅば！【ホロライブ/大空スバル】",
    "publishedAt": "2025-12-10T13:27:47Z"
  }
],
  Choco :
  [
  {
    "videoId": "9btrd2rcJX8",
    "thumbnail": "https://i.ytimg.com/vi/9btrd2rcJX8/mqdefault.jpg",
    "title": "【Vtuber】悪魔の保健医癒月ちょこ初配信【ホロライブ/癒月ちょこ】",
    "publishedAt": "2018-09-04T14:37:55Z"
  },
  {
    "videoId": "n9DqvVNBdVI",
    "thumbnail": "https://i.ytimg.com/vi/n9DqvVNBdVI/mqdefault.jpg",
    "title": "【歌ってみた/4K】妄想税/癒月ちょこ【オリジナルMV】",
    "publishedAt": "2019-07-25T09:58:18Z"
  },
  {
    "videoId": "vmPpfJWxisU",
    "thumbnail": "https://i.ytimg.com/vi/vmPpfJWxisU/mqdefault.jpg",
    "title": "【歌ってみた】〇〇〇〇〇/癒月ちょこ【オリジナルMV】",
    "publishedAt": "2019-12-04T12:00:15Z"
  },
  {
    "videoId": "USnLp2v8chg",
    "thumbnail": "https://i.ytimg.com/vi/USnLp2v8chg/mqdefault.jpg",
    "title": "【案件放送】あやめ様と緊急授業？！噂のN高について【ホロライブ/百鬼あやめ/癒月ちょこ】",
    "publishedAt": "2020-03-18T13:11:31Z"
  },
  {
    "videoId": "SCOEeN_vHzc",
    "thumbnail": "https://i.ytimg.com/vi/SCOEeN_vHzc/mqdefault.jpg",
    "title": "【オフコラボ】ノエル様に手作りの愛情たっぷりキャラ弁食べてもらった結果【ホロライブ/白銀ノエル/癒月ちょこ】",
    "publishedAt": "2020-03-19T11:41:54Z"
  },
  {
    "videoId": "-tMd6H-IxcA",
    "thumbnail": "https://i.ytimg.com/vi/-tMd6H-IxcA/mqdefault_live.jpg",
    "title": "フリーチャット",
    "publishedAt": "2020-05-03T23:39:20Z"
  },
  {
    "videoId": "vzarJbwSNbE",
    "thumbnail": "https://i.ytimg.com/vi/vzarJbwSNbE/mqdefault.jpg",
    "title": "【凸待ち】20か月２０万人突破記念悪魔の凸待ち？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-05-04T15:36:17Z"
  },
  {
    "videoId": "sunmv_wIl9w",
    "thumbnail": "https://i.ytimg.com/vi/sunmv_wIl9w/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔のお手軽料理教室！火を使わない青椒肉絲作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-05-31T04:27:15Z"
  },
  {
    "videoId": "UzXgnQFFP94",
    "thumbnail": "https://i.ytimg.com/vi/UzXgnQFFP94/mqdefault.jpg",
    "title": "【エーペックスレジェンズ】へなちょこ悪魔の初心者APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-01T05:16:59Z"
  },
  {
    "videoId": "4vZ8XsclSwU",
    "thumbnail": "https://i.ytimg.com/vi/4vZ8XsclSwU/mqdefault.jpg",
    "title": "【エーペックスレジェンズ】へなちょこ悪魔の初心者APEX#2【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-02T06:25:47Z"
  },
  {
    "videoId": "KpadIthpVZA",
    "thumbnail": "https://i.ytimg.com/vi/KpadIthpVZA/mqdefault.jpg",
    "title": "【#アキちょこ】ARK廃人魂魅せろ！悪魔とハーフエルフのベータボス戦リベンジ戦！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-03T10:12:08Z"
  },
  {
    "videoId": "wSXXaVdcEJw",
    "thumbnail": "https://i.ytimg.com/vi/wSXXaVdcEJw/mqdefault.jpg",
    "title": "【#ホロARK最終決戦】ARK廃人魂魅せろ！廃人組で行くαボス戦！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-04T08:12:57Z"
  },
  {
    "videoId": "5zjTAVpEpl4",
    "thumbnail": "https://i.ytimg.com/vi/5zjTAVpEpl4/mqdefault.jpg",
    "title": "【エーペックスレジェンズ】へなちょこ悪魔のAPEX練習！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-06T05:54:25Z"
  },
  {
    "videoId": "oYjNU4uF90U",
    "thumbnail": "https://i.ytimg.com/vi/oYjNU4uF90U/mqdefault.jpg",
    "title": "【エーペックスレジェンズ】へなちょこ悪魔と愛園氏で悩殺するAPEX！【ホロライブ/癒月ちょこ/にじさんじ/愛園愛美】",
    "publishedAt": "2020-06-07T15:12:41Z"
  },
  {
    "videoId": "sApsZZWXLdc",
    "thumbnail": "https://i.ytimg.com/vi/sApsZZWXLdc/mqdefault.jpg",
    "title": "【エーペックスレジェンズ】へなちょこ悪魔と未来人であなたのハート射抜いてあげますわ！【ホロライブ/癒月ちょこ/にじさんじ/夕陽リリ】",
    "publishedAt": "2020-06-08T13:38:01Z"
  },
  {
    "videoId": "mqG_9pqECyE",
    "thumbnail": "https://i.ytimg.com/vi/mqG_9pqECyE/mqdefault.jpg",
    "title": "【エーペックスレジェンズ】３人揃ったら最強？まつり様と子兎音様とへなちょこ悪魔のAPEX【ホロライブ/癒月ちょこ/夏色まつり/天神子兎音】",
    "publishedAt": "2020-06-09T15:58:36Z"
  },
  {
    "videoId": "zRpsFUB_3Zk",
    "thumbnail": "https://i.ytimg.com/vi/zRpsFUB_3Zk/mqdefault.jpg",
    "title": "【#ちょこるし】へなちょこ悪魔がるしあ様と夜食ちゃんぽん食べたいからAPEX頑張る配信【ホロライブ/癒月ちょこ/潤羽るしあ】",
    "publishedAt": "2020-06-12T15:50:07Z"
  },
  {
    "videoId": "vvYMKdxJEQs",
    "thumbnail": "https://i.ytimg.com/vi/vvYMKdxJEQs/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔の深夜のお料理枠！火を使わない唐揚げつくってみた！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-14T16:14:11Z"
  },
  {
    "videoId": "6JuhSfC4nrw",
    "thumbnail": "https://i.ytimg.com/vi/6JuhSfC4nrw/mqdefault.jpg",
    "title": "【SuperBunnyMan】いちか様と二人三脚？大乱闘？この２人が揃うと…。【ホロライブ/癒月ちょこ/あにまーれ/宗谷いちか】",
    "publishedAt": "2020-06-16T11:42:35Z"
  },
  {
    "videoId": "N-v3mEQaVno",
    "thumbnail": "https://i.ytimg.com/vi/N-v3mEQaVno/mqdefault.jpg",
    "title": "【#ホロARK最終決戦】死んだら即終了ラスボスαボス戦！！悪魔のスピノ軍隊なめんなよ？！【ホロライブ/癒月ちょこ/桐生ココ/天音かなた/アキロゼ】",
    "publishedAt": "2020-06-16T14:07:30Z"
  },
  {
    "videoId": "KLwH82SvjUk",
    "thumbnail": "https://i.ytimg.com/vi/KLwH82SvjUk/mqdefault.jpg",
    "title": "【祝杯枠】頑張ったちょこを褒めてください！ボス戦祝杯枠！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-16T15:29:24Z"
  },
  {
    "videoId": "R2DUQyYTNLY",
    "thumbnail": "https://i.ytimg.com/vi/R2DUQyYTNLY/mqdefault.jpg",
    "title": "【#ちょろぼリー】夜飯はAPEXでちゃんぽん食べたい！悪魔と高性能ロボットと未来人揃ったら最強なのでは？！【ホロライブ/癒月ちょこ/ロボ子さん/夕陽リリ】",
    "publishedAt": "2020-06-17T13:53:16Z"
  },
  {
    "videoId": "P_dpG5oTcuA",
    "thumbnail": "https://i.ytimg.com/vi/P_dpG5oTcuA/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔の保健医が火を使わないさっぱり梅しそパスタ作ってみた【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-18T12:35:10Z"
  },
  {
    "videoId": "DK1YnXzxjj8",
    "thumbnail": "https://i.ytimg.com/vi/DK1YnXzxjj8/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔の保健医が火を使わないスタミナ生姜焼き作ってみた【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-19T16:25:53Z"
  },
  {
    "videoId": "EoI54HWYBy4",
    "thumbnail": "https://i.ytimg.com/vi/EoI54HWYBy4/mqdefault.jpg",
    "title": "【最重要事項】ちょこ先生から大切なお話があります。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-20T03:32:37Z"
  },
  {
    "videoId": "uwnRpkzHjoU",
    "thumbnail": "https://i.ytimg.com/vi/uwnRpkzHjoU/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔の飯テロ！火を使わないチキンカレー作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-20T15:34:25Z"
  },
  {
    "videoId": "Y-0PKT3YMhI",
    "thumbnail": "https://i.ytimg.com/vi/Y-0PKT3YMhI/mqdefault.jpg",
    "title": "【Getting Over It】へなちょこ悪魔が壺おじ初体験！初壺ハマるのか・・・？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-21T06:06:05Z"
  },
  {
    "videoId": "xWJn9tQ_c-E",
    "thumbnail": "https://i.ytimg.com/vi/xWJn9tQ_c-E/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔の飯テロ！火を使わないハンバーグ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-21T17:18:25Z"
  },
  {
    "videoId": "p8dfbmsYQ5A",
    "thumbnail": "https://i.ytimg.com/vi/p8dfbmsYQ5A/mqdefault.jpg",
    "title": "【#えーちょこ夜ふかし】第１回えーちょこ夜ふかし企画！今回のお題は女心！男性必見理想の男性像とは？【ホロライブ/桐生ココ/姫森ルーナ/赤井はあと/白銀ノエル/友人A/癒月ちょこ】",
    "publishedAt": "2020-06-22T17:24:13Z"
  },
  {
    "videoId": "5Dzbvma6hAc",
    "thumbnail": "https://i.ytimg.com/vi/5Dzbvma6hAc/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わない親子丼作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-24T04:17:56Z"
  },
  {
    "videoId": "YcF63eFMtUc",
    "thumbnail": "https://i.ytimg.com/vi/YcF63eFMtUc/mqdefault.jpg",
    "title": "【Vtuber身体測定】噂のバーチャルアイドル診察します！【のりプロ/愛宮みるく/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-25T13:19:30Z"
  },
  {
    "videoId": "d4pl6XEiz2I",
    "thumbnail": "https://i.ytimg.com/vi/d4pl6XEiz2I/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わない牛丼作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-26T03:56:06Z"
  },
  {
    "videoId": "PRKv918Zb-0",
    "thumbnail": "https://i.ytimg.com/vi/PRKv918Zb-0/mqdefault.jpg",
    "title": "【にじさんじ3D身体測定】3Dの緑仙様を悪魔の保健医が本能に従って診察いたします！【にじさんじ/緑仙/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-26T12:03:26Z"
  },
  {
    "videoId": "FIrbXXtlUvs",
    "thumbnail": "https://i.ytimg.com/vi/FIrbXXtlUvs/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わない冷やし肉みそうどん作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-27T04:14:18Z"
  },
  {
    "videoId": "8aBpfzKY958",
    "thumbnail": "https://i.ytimg.com/vi/8aBpfzKY958/mqdefault.jpg",
    "title": "【#緑ちょこ】４回BANされた緑仙３D身体測定裏話雑談コラボ【にじさんじ/緑仙/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-27T15:16:03Z"
  },
  {
    "videoId": "3vNxcyzPHzs",
    "thumbnail": "https://i.ytimg.com/vi/3vNxcyzPHzs/mqdefault.jpg",
    "title": "【#逆ちょこ凸】料理のスペシャリスト達にイカ墨リゾットのレシピ逆凸で聞いてみた結果…。【犬山たまき/にじさんじ/でびでび・でびる/ホロライブ/桐生ココ/宝鐘マリン/夜空メル/赤井はあと/癒月ちょこ】",
    "publishedAt": "2020-06-28T11:13:52Z"
  },
  {
    "videoId": "8WtKGVsQaJU",
    "thumbnail": "https://i.ytimg.com/vi/8WtKGVsQaJU/mqdefault.jpg",
    "title": "【ホロスターズ身体測定】悪魔の保健医が噂の女装アイドル(仮)診察します！【ホロスターズ/月下カオル/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-28T14:08:38Z"
  },
  {
    "videoId": "ZswGK1rweX4",
    "thumbnail": "https://i.ytimg.com/vi/ZswGK1rweX4/mqdefault.jpg",
    "title": "【にじさんじ3D身体測定】3Dの緑仙様を悪魔の保健医が本能に従って診察いたします！【にじさんじ/緑仙/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-29T12:33:53Z"
  },
  {
    "videoId": "9Ce7d13lwIY",
    "thumbnail": "https://i.ytimg.com/vi/9Ce7d13lwIY/mqdefault.jpg",
    "title": "【にじさんじ3D身体測定】3Dの緑仙様を悪魔の保健医が本能に従って診察いたします！【にじさんじ/緑仙/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-06-29T12:38:33Z"
  },
  {
    "videoId": "XhIOZwkHnPg",
    "thumbnail": "https://i.ytimg.com/vi/XhIOZwkHnPg/mqdefault.jpg",
    "title": "【#かなちょこ】悪魔と天使のギガノトテイム大作戦！【ホロライブ/天音かなた/癒月ちょこ】",
    "publishedAt": "2020-06-30T17:01:29Z"
  },
  {
    "videoId": "xJOQqvm6zfA",
    "thumbnail": "https://i.ytimg.com/vi/xJOQqvm6zfA/mqdefault.jpg",
    "title": "【雑談】悪魔の保健医の寝起き雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-01T03:40:09Z"
  },
  {
    "videoId": "u6z7QXGLv8Y",
    "thumbnail": "https://i.ytimg.com/vi/u6z7QXGLv8Y/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔がスバルイメージのお子様ランチ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-02T04:56:22Z"
  },
  {
    "videoId": "o4dihDKzURU",
    "thumbnail": "https://i.ytimg.com/vi/o4dihDKzURU/mqdefault.jpg",
    "title": "【エーペックスレジェンズ】夜食ちゃんぽん食べたい女たちのAPEX【夕陽リリ/天神子兎音/癒月ちょこ】",
    "publishedAt": "2020-07-02T16:00:40Z"
  },
  {
    "videoId": "LsmlgwB0SP8",
    "thumbnail": "https://i.ytimg.com/vi/LsmlgwB0SP8/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないオムライス作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-04T04:11:48Z"
  },
  {
    "videoId": "_CHH64FtPx8",
    "thumbnail": "https://i.ytimg.com/vi/_CHH64FtPx8/mqdefault.jpg",
    "title": "【エーペックスレジェンズ】スケベ３銃士のAPEX【にじさんじ/森中花咲/愛園愛美/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-04T12:07:27Z"
  },
  {
    "videoId": "p4h3g2iX6iQ",
    "thumbnail": "https://i.ytimg.com/vi/p4h3g2iX6iQ/mqdefault.jpg",
    "title": "【Getting Over Itwith Bennett Foddy】へなちょこ悪魔の壺おじ２日目！クリアできるのか？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-05T06:26:59Z"
  },
  {
    "videoId": "lXhA9Yp-3Xw",
    "thumbnail": "https://i.ytimg.com/vi/lXhA9Yp-3Xw/mqdefault.jpg",
    "title": "【Little Witch Nobeta】遂にへなちょこ悪魔が噂のロリダクソ初見プレイ１日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-06T11:16:08Z"
  },
  {
    "videoId": "5Y4tSntOpIw",
    "thumbnail": "https://i.ytimg.com/vi/5Y4tSntOpIw/mqdefault.jpg",
    "title": "【#えーちょこ夜ふかし】第2回は女子必見⁈理想の女性像、男心の本音に迫ります！【ホロプロ/夕刻ロベル/荒咬オウガ/影山シエン/月下カオル/友人A/癒月ちょこ】",
    "publishedAt": "2020-07-06T17:53:01Z"
  },
  {
    "videoId": "4--vNMqHKII",
    "thumbnail": "https://i.ytimg.com/vi/4--vNMqHKII/mqdefault.jpg",
    "title": "【Little Witch Nobeta】へなちょこ悪魔のロリダクソ挑戦!２日目！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-07T05:40:38Z"
  },
  {
    "videoId": "oZbECH6Ndv4",
    "thumbnail": "https://i.ytimg.com/vi/oZbECH6Ndv4/mqdefault.jpg",
    "title": "【七夕企画】ちょこ神様に任せなさい！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-07T11:24:09Z"
  },
  {
    "videoId": "g6wiAhOOKLg",
    "thumbnail": "https://i.ytimg.com/vi/g6wiAhOOKLg/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないすきやき作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-08T04:40:37Z"
  },
  {
    "videoId": "4_P-cxa5Dmo",
    "thumbnail": "https://i.ytimg.com/vi/4_P-cxa5Dmo/mqdefault.jpg",
    "title": "【レア枠】遂にちょこ先生の化粧ポーチの中身初公開？！【癒月ちょこ/ホロライブ】",
    "publishedAt": "2020-07-08T11:30:17Z"
  },
  {
    "videoId": "HKa2r_jY4wc",
    "thumbnail": "https://i.ytimg.com/vi/HKa2r_jY4wc/mqdefault.jpg",
    "title": "【エーペックスレジェンズ】夜食ちゃんぽん食べたい女たちのAPEX#2【夕陽リリ/天神子兎音/癒月ちょこ】",
    "publishedAt": "2020-07-08T16:33:12Z"
  },
  {
    "videoId": "_QwhBpJ7uCs",
    "thumbnail": "https://i.ytimg.com/vi/_QwhBpJ7uCs/mqdefault.jpg",
    "title": "【SuperBunnyMan】久々のメルティーキッスコラボ！この２人が揃うと？【ホロライブ/癒月ちょこ/夜空メル】",
    "publishedAt": "2020-07-09T15:23:35Z"
  },
  {
    "videoId": "tATUE6H8zvI",
    "thumbnail": "https://i.ytimg.com/vi/tATUE6H8zvI/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わない肉じゃが作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-10T07:54:59Z"
  },
  {
    "videoId": "3v2m6REI24Y",
    "thumbnail": "https://i.ytimg.com/vi/3v2m6REI24Y/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わない肉豆腐作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-11T04:40:16Z"
  },
  {
    "videoId": "YdvUQb_V-ic",
    "thumbnail": "https://i.ytimg.com/vi/YdvUQb_V-ic/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わない野菜炒め作る！塩ラーメンを添えて【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-11T21:04:44Z"
  },
  {
    "videoId": "OhQokuNsT9I",
    "thumbnail": "https://i.ytimg.com/vi/OhQokuNsT9I/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないエビピラフ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-13T04:47:13Z"
  },
  {
    "videoId": "HfG_gKZ0Fng",
    "thumbnail": "https://i.ytimg.com/vi/HfG_gKZ0Fng/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないナス肉みそ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-14T04:38:45Z"
  },
  {
    "videoId": "XSv9Z_gIciE",
    "thumbnail": "https://i.ytimg.com/vi/XSv9Z_gIciE/mqdefault.jpg",
    "title": "【Little Witch Nobeta】ボス戦耐久！へなちょこ悪魔が噂のロリダクソ3日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-14T13:08:12Z"
  },
  {
    "videoId": "T8CMdM5IFGc",
    "thumbnail": "https://i.ytimg.com/vi/T8CMdM5IFGc/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないナス焼売作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-15T04:37:20Z"
  },
  {
    "videoId": "-7pVucjMA20",
    "thumbnail": "https://i.ytimg.com/vi/-7pVucjMA20/mqdefault.jpg",
    "title": "【#メルティーキッス】メルキスで怨霊協力プレイ！この2人でクリアできるのか…？【ホロライブ/夜空メル/癒月ちょこ】",
    "publishedAt": "2020-07-15T11:52:28Z"
  },
  {
    "videoId": "o2yGzp9Wrbo",
    "thumbnail": "https://i.ytimg.com/vi/o2yGzp9Wrbo/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないナスの煮びたし作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-16T04:38:19Z"
  },
  {
    "videoId": "OsJB1uKg3aM",
    "thumbnail": "https://i.ytimg.com/vi/OsJB1uKg3aM/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないナスの肉ばさみ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-17T04:45:23Z"
  },
  {
    "videoId": "B_n5gCCjP5E",
    "thumbnail": "https://i.ytimg.com/vi/B_n5gCCjP5E/mqdefault.jpg",
    "title": "【#かなちょこ】かなた様とトロペオテイム大作戦！【ホロライブ/天音かなた/癒月ちょこ】",
    "publishedAt": "2020-07-17T08:45:52Z"
  },
  {
    "videoId": "qbJLQc0bXTk",
    "thumbnail": "https://i.ytimg.com/vi/qbJLQc0bXTk/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わない焼きうどん作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-19T06:43:38Z"
  },
  {
    "videoId": "IobT_eW3b9A",
    "thumbnail": "https://i.ytimg.com/vi/IobT_eW3b9A/mqdefault.jpg",
    "title": "【#えーちょこ夜ふかし】第3回はこだわり、フェチに迫ります！【ホロライブ/不知火フレア/白上フブキ/宝鐘マリン/天音かなた/友人A/癒月ちょこ】",
    "publishedAt": "2020-07-20T16:31:32Z"
  },
  {
    "videoId": "jrs3hm448WU",
    "thumbnail": "https://i.ytimg.com/vi/jrs3hm448WU/mqdefault.jpg",
    "title": "【#わたちょこ】ピーマン嫌いなわため様にピーマンレシピを作ってみた結果【ホロライブ/角巻わため/癒月ちょこ】",
    "publishedAt": "2020-07-21T04:54:49Z"
  },
  {
    "videoId": "6AV1bS5ljKo",
    "thumbnail": "https://i.ytimg.com/vi/6AV1bS5ljKo/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないナポリタン作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-22T04:12:00Z"
  },
  {
    "videoId": "DxcFPE4owvQ",
    "thumbnail": "https://i.ytimg.com/vi/DxcFPE4owvQ/mqdefault.jpg",
    "title": "【エーペックスレジェンズ】子兎音様と夜食ちゃんぽん食べたいのです！【天神子兎音/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-22T14:56:15Z"
  },
  {
    "videoId": "UgsZM_EJa-s",
    "thumbnail": "https://i.ytimg.com/vi/UgsZM_EJa-s/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないタンドリーチキン作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-23T04:39:01Z"
  },
  {
    "videoId": "bWgVbDaFy0M",
    "thumbnail": "https://i.ytimg.com/vi/bWgVbDaFy0M/mqdefault.jpg",
    "title": "【PIEN】へなちょこ悪魔がPIEN初見プレイする【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-23T09:33:14Z"
  },
  {
    "videoId": "0pQUV9QuZlM",
    "thumbnail": "https://i.ytimg.com/vi/0pQUV9QuZlM/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わない回鍋肉作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-24T04:52:08Z"
  },
  {
    "videoId": "rDBzFtLPLWk",
    "thumbnail": "https://i.ytimg.com/vi/rDBzFtLPLWk/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】火を使わない辛くない麻婆茄子つくる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-25T05:05:11Z"
  },
  {
    "videoId": "MmFRJuLfQnk",
    "thumbnail": "https://i.ytimg.com/vi/MmFRJuLfQnk/mqdefault.jpg",
    "title": "【#羊魔神】夜食のちゃんぽんを食べたい人外APEX【天神子兎音/ホロライブ/角巻わため/癒月ちょこ】",
    "publishedAt": "2020-07-25T16:32:48Z"
  },
  {
    "videoId": "eB5-GIuX3nA",
    "thumbnail": "https://i.ytimg.com/vi/eB5-GIuX3nA/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わない肉巻き作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-26T04:34:18Z"
  },
  {
    "videoId": "cb04Fr9atgc",
    "thumbnail": "https://i.ytimg.com/vi/cb04Fr9atgc/mqdefault.jpg",
    "title": "【APEX】おやつにちゃんぽん食べたい女たちのAPEX【あにまーれ/日ノ隈らん/ホロライブ/角巻わため/癒月ちょこ】",
    "publishedAt": "2020-07-27T09:12:32Z"
  },
  {
    "videoId": "bhBHkl1AK4c",
    "thumbnail": "https://i.ytimg.com/vi/bhBHkl1AK4c/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わない棒棒鶏作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-28T04:31:10Z"
  },
  {
    "videoId": "Nn-yV0fFjFo",
    "thumbnail": "https://i.ytimg.com/vi/Nn-yV0fFjFo/mqdefault.jpg",
    "title": "【Project Winter】雪山にホロメンが集まったら…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-29T11:49:04Z"
  },
  {
    "videoId": "-gC3SA_amtg",
    "thumbnail": "https://i.ytimg.com/vi/-gC3SA_amtg/mqdefault.jpg",
    "title": "【新LIVE2Dお披露目】ちょこのお胸が！顔が！重大発表も？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-29T14:22:15Z"
  },
  {
    "videoId": "ypUr5zLc5mI",
    "thumbnail": "https://i.ytimg.com/vi/ypUr5zLc5mI/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わない鶏の照り焼き作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-07-30T04:28:37Z"
  },
  {
    "videoId": "B9K8QU0irac",
    "thumbnail": "https://i.ytimg.com/vi/B9K8QU0irac/mqdefault.jpg",
    "title": "【APEX】おはようゲリラ！へねちょこ悪魔おさぼり中【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-02T04:15:28Z"
  },
  {
    "videoId": "sIPuVzxBI9o",
    "thumbnail": "https://i.ytimg.com/vi/sIPuVzxBI9o/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないきんぴらごぼう作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-04T04:56:22Z"
  },
  {
    "videoId": "ywT5fBQyQPA",
    "thumbnail": "https://i.ytimg.com/vi/ywT5fBQyQPA/mqdefault.jpg",
    "title": "【Dead by Daylight】復活！へなちょこ悪魔の逃走中？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-04T10:31:14Z"
  },
  {
    "videoId": "5oSCy0vDt54",
    "thumbnail": "https://i.ytimg.com/vi/5oSCy0vDt54/mqdefault.jpg",
    "title": "【#メルティーキッス】メルキスで怨霊協力クリア耐久？！【ホロライブ/夜空メル/癒月ちょこ】",
    "publishedAt": "2020-08-04T17:27:03Z"
  },
  {
    "videoId": "PDCQksfgBKk",
    "thumbnail": "https://i.ytimg.com/vi/PDCQksfgBKk/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないキーマカレー作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-05T12:23:12Z"
  },
  {
    "videoId": "S_scyJcVdU8",
    "thumbnail": "https://i.ytimg.com/vi/S_scyJcVdU8/mqdefault.jpg",
    "title": "【APEX】朝ごはんにちゃんぽん食べたい女のAPEX【紫雨刹那/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-06T02:49:17Z"
  },
  {
    "videoId": "i_eQnrw3tvI",
    "thumbnail": "https://i.ytimg.com/vi/i_eQnrw3tvI/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないサバの味噌煮作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-06T04:01:43Z"
  },
  {
    "videoId": "XcbCUJJtDik",
    "thumbnail": "https://i.ytimg.com/vi/XcbCUJJtDik/mqdefault.jpg",
    "title": "【APEX】夜食ちゃんぽんリベンジしたい人外APEX【あにまーれ/日ノ隈らん/ホロライブ/角巻わため/癒月ちょこ】",
    "publishedAt": "2020-08-07T15:54:36Z"
  },
  {
    "videoId": "_kGX_47l_LI",
    "thumbnail": "https://i.ytimg.com/vi/_kGX_47l_LI/mqdefault.jpg",
    "title": "【APEX】おはようゲリラ！へねちょこ悪魔のコソ連APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-08T03:08:11Z"
  },
  {
    "videoId": "7kT1-aHeSdI",
    "thumbnail": "https://i.ytimg.com/vi/7kT1-aHeSdI/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないしらすとたらこの和風パスタ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-08T04:01:55Z"
  },
  {
    "videoId": "pZ6djMf8zLA",
    "thumbnail": "https://i.ytimg.com/vi/pZ6djMf8zLA/mqdefault.jpg",
    "title": "【エーペックスレジェンズ】３人で悩殺？愛美様と子兎音様とへなちょこ悪魔のAPEX【ホロライブ/癒月ちょこ/にじさんじ/愛園愛美/天神子兎音】",
    "publishedAt": "2020-08-09T17:05:23Z"
  },
  {
    "videoId": "idFTO9mYdwc",
    "thumbnail": "https://i.ytimg.com/vi/idFTO9mYdwc/mqdefault.jpg",
    "title": "【#ちょこオネア】第7回ちょこオネア今回のゲストはルーナまつりコンビ！無事クリアすることができるのか？！【ホロライブ/癒月ちょこ/姫森ルーナ/夏色まつり/友人A】",
    "publishedAt": "2020-08-10T13:08:46Z"
  },
  {
    "videoId": "PdfPf1tn0Hw",
    "thumbnail": "https://i.ytimg.com/vi/PdfPf1tn0Hw/mqdefault.jpg",
    "title": "【#ちょろぼ】ロボ子先輩とミミズ対決？！【ホロライブ/癒月ちょこ/ロボ子さん】",
    "publishedAt": "2020-08-11T15:29:22Z"
  },
  {
    "videoId": "e804-Tj5vXA",
    "thumbnail": "https://i.ytimg.com/vi/e804-Tj5vXA/mqdefault.jpg",
    "title": "【ARK】廃人たちによる洞窟RTA【ホロライブ/桐生ココ/天音かなた/アキロゼ/癒月ちょこ】",
    "publishedAt": "2020-08-12T16:09:36Z"
  },
  {
    "videoId": "nDM3m42rhcM",
    "thumbnail": "https://i.ytimg.com/vi/nDM3m42rhcM/mqdefault.jpg",
    "title": "【Dead by Daylight】へなちょこ悪魔のゲリラ逃走中？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-13T07:09:27Z"
  },
  {
    "videoId": "4S__fQ-Mg5M",
    "thumbnail": "https://i.ytimg.com/vi/4S__fQ-Mg5M/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わない冷あな茶漬け作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-14T05:23:41Z"
  },
  {
    "videoId": "R1gwPOqim-g",
    "thumbnail": "https://i.ytimg.com/vi/R1gwPOqim-g/mqdefault.jpg",
    "title": "【30万人記念】社畜保健医復活？！悪魔の凸待ち企画！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-18T14:34:38Z"
  },
  {
    "videoId": "v8cfSre3jUQ",
    "thumbnail": "https://i.ytimg.com/vi/v8cfSre3jUQ/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わない鶏チャーシューつくる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-19T04:53:51Z"
  },
  {
    "videoId": "-ggL7j_mnsQ",
    "thumbnail": "https://i.ytimg.com/vi/-ggL7j_mnsQ/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔がさっぱりほてだいサラダつくる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-21T17:07:31Z"
  },
  {
    "videoId": "8LiLneMvoYc",
    "thumbnail": "https://i.ytimg.com/vi/8LiLneMvoYc/mqdefault.jpg",
    "title": "【30万人記念】ついに発売？！社畜脳Tシャツ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-22T09:59:28Z"
  },
  {
    "videoId": "_CUTtDMWRUg",
    "thumbnail": "https://i.ytimg.com/vi/_CUTtDMWRUg/mqdefault.jpg",
    "title": "【#メルティーキッス】ついにメルキスARK解禁？！【ホロライブ/夜空メル/癒月ちょこ】",
    "publishedAt": "2020-08-22T19:50:46Z"
  },
  {
    "videoId": "-ILtPAfsd2Q",
    "thumbnail": "https://i.ytimg.com/vi/-ILtPAfsd2Q/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わない焼売作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-23T06:40:14Z"
  },
  {
    "videoId": "drKd8RBCMKU",
    "thumbnail": "https://i.ytimg.com/vi/drKd8RBCMKU/mqdefault.jpg",
    "title": "【#羊魔神】ちゃんぽんを食べたい人外APEX【天神子兎音/ホロライブ/角巻わため/癒月ちょこ】",
    "publishedAt": "2020-08-23T14:17:26Z"
  },
  {
    "videoId": "PSor-2_to8Q",
    "thumbnail": "https://i.ytimg.com/vi/PSor-2_to8Q/mqdefault.jpg",
    "title": "【雑談】最近あったこと色々話す！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-26T08:28:36Z"
  },
  {
    "videoId": "i6J2V8eguTA",
    "thumbnail": "https://i.ytimg.com/vi/i6J2V8eguTA/mqdefault.jpg",
    "title": "【雪山人狼】この中に…。。方向音痴だけど頑張ります！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-28T14:04:04Z"
  },
  {
    "videoId": "kgcXhrp6AP0",
    "thumbnail": "https://i.ytimg.com/vi/kgcXhrp6AP0/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないローストビーフ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-29T05:16:54Z"
  },
  {
    "videoId": "PrSqdWg7l28",
    "thumbnail": "https://i.ytimg.com/vi/PrSqdWg7l28/mqdefault.jpg",
    "title": "【DeadbyDaylight】へなちょこ悪魔は逃げ切りたいのです！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-30T03:39:38Z"
  },
  {
    "videoId": "VDIgFMXXBGw",
    "thumbnail": "https://i.ytimg.com/vi/VDIgFMXXBGw/mqdefault.jpg",
    "title": "【APEX】へなちょこ悪魔のコソ連APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-08-31T11:29:38Z"
  },
  {
    "videoId": "IKmVqwH_Il0",
    "thumbnail": "https://i.ytimg.com/vi/IKmVqwH_Il0/mqdefault.jpg",
    "title": "【APEX】へなちょこ悪魔のコソ連２日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-01T15:46:53Z"
  },
  {
    "videoId": "eGfUkBRIzzM",
    "thumbnail": "https://i.ytimg.com/vi/eGfUkBRIzzM/mqdefault.jpg",
    "title": "【APEX】へなちょこ悪魔の寝起きのコソ連3日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-02T09:20:55Z"
  },
  {
    "videoId": "J99FQxxzSKM",
    "thumbnail": "https://i.ytimg.com/vi/J99FQxxzSKM/mqdefault.jpg",
    "title": "【APEX】へなちょこ悪魔の寝起きのコソ連4日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-03T12:40:18Z"
  },
  {
    "videoId": "H4aZ8vzyR9c",
    "thumbnail": "https://i.ytimg.com/vi/H4aZ8vzyR9c/mqdefault.jpg",
    "title": "【#癒月ちょこ２周年】今日でデビュー２周年！奇跡の3Ｄ配信【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-04T13:05:50Z"
  },
  {
    "videoId": "jB-XxWQSwqg",
    "thumbnail": "https://i.ytimg.com/vi/jB-XxWQSwqg/mqdefault.jpg",
    "title": "【Ark: Survival Evolved】ココ様のティタノテイムお手伝いする！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-05T17:38:38Z"
  },
  {
    "videoId": "PVY6kXWGdpU",
    "thumbnail": "https://i.ytimg.com/vi/PVY6kXWGdpU/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が火を使わないハッシュドビーフつくる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-06T07:48:21Z"
  },
  {
    "videoId": "KkmYSyl-GaE",
    "thumbnail": "https://i.ytimg.com/vi/KkmYSyl-GaE/mqdefault.jpg",
    "title": "【雑談】最近あったこととか色々お話しいたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-06T13:20:09Z"
  },
  {
    "videoId": "DZYZC4PcDZg",
    "thumbnail": "https://i.ytimg.com/vi/DZYZC4PcDZg/mqdefault.jpg",
    "title": "【APEX】へなちょこ悪魔のAPEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-07T09:38:35Z"
  },
  {
    "videoId": "zlf6VDDmy9o",
    "thumbnail": "https://i.ytimg.com/vi/zlf6VDDmy9o/mqdefault.jpg",
    "title": "【#ういちょこ】ういママ襲来！ういちょこお泊り会【しぐれうい/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-07T14:32:01Z"
  },
  {
    "videoId": "vxlfJJlY0Rw",
    "thumbnail": "https://i.ytimg.com/vi/vxlfJJlY0Rw/mqdefault.jpg",
    "title": "【APEX】上手くなりたいへなちょこ悪魔の挑戦！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-08T20:34:07Z"
  },
  {
    "videoId": "uw_7oFWKMrA",
    "thumbnail": "https://i.ytimg.com/vi/uw_7oFWKMrA/mqdefault.jpg",
    "title": "【#ちょこスバ】スバルの家にお泊りしてみた結果【ホロライブ/大空スバル／癒月ちょこ】",
    "publishedAt": "2020-09-11T23:32:00Z"
  },
  {
    "videoId": "pWcF9VsxAHg",
    "thumbnail": "https://i.ytimg.com/vi/pWcF9VsxAHg/mqdefault.jpg",
    "title": "【雑談】最近のちょこ事情色々お話しする！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-13T21:56:02Z"
  },
  {
    "videoId": "VXI9syxUqA0",
    "thumbnail": "https://i.ytimg.com/vi/VXI9syxUqA0/mqdefault.jpg",
    "title": "【APEX】へなちょこ悪魔が深夜のコソ連はじめました【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-15T21:04:32Z"
  },
  {
    "videoId": "8wPcGanCH9E",
    "thumbnail": "https://i.ytimg.com/vi/8wPcGanCH9E/mqdefault.jpg",
    "title": "【Dead by Daylight】へなちょこ悪魔は逃げ切りたい【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-16T09:38:45Z"
  },
  {
    "videoId": "armtm5GAyWg",
    "thumbnail": "https://i.ytimg.com/vi/armtm5GAyWg/mqdefault.jpg",
    "title": "【#あまちょこ】あまみゃ襲来！あまちょこお泊り会【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-17T15:04:02Z"
  },
  {
    "videoId": "i_Nadz9RElQ",
    "thumbnail": "https://i.ytimg.com/vi/i_Nadz9RElQ/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】へなちょこ悪魔が茄子のボロネーゼ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-20T07:42:25Z"
  },
  {
    "videoId": "TXlMRiTXcU0",
    "thumbnail": "https://i.ytimg.com/vi/TXlMRiTXcU0/mqdefault.jpg",
    "title": "【APEX】寝起き悪魔のコソ連開始！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-22T05:07:21Z"
  },
  {
    "videoId": "Gwk9CJq0mjs",
    "thumbnail": "https://i.ytimg.com/vi/Gwk9CJq0mjs/mqdefault.jpg",
    "title": "【#いちちょこ】いちか様と初心者APEX【あにまーれ/宗谷いちか/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-22T16:19:13Z"
  },
  {
    "videoId": "VYEDHv2Yznk",
    "thumbnail": "https://i.ytimg.com/vi/VYEDHv2Yznk/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】火を使わない色どりサラダ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-24T05:13:37Z"
  },
  {
    "videoId": "REG1VCjKMTs",
    "thumbnail": "https://i.ytimg.com/vi/REG1VCjKMTs/mqdefault.jpg",
    "title": "【ホロライブ身体測定】噂のサーカス美少女診察します！【ホロライブ/尾丸ポルカ/癒月ちょこ】",
    "publishedAt": "2020-09-24T11:10:49Z"
  },
  {
    "videoId": "TpHOnNb3kLU",
    "thumbnail": "https://i.ytimg.com/vi/TpHOnNb3kLU/mqdefault.jpg",
    "title": "【APEX】夜食ちゃんぽん食べたい人外APEX【天神子兎音/獅子神レオナ/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-24T16:02:16Z"
  },
  {
    "videoId": "WVthPdiG6wo",
    "thumbnail": "https://i.ytimg.com/vi/WVthPdiG6wo/mqdefault.jpg",
    "title": "【Ark: Survival Evolved】廃人コンビのお見合い大作戦！【ホロライブ/アキロゼ/癒月ちょこ】",
    "publishedAt": "2020-09-25T05:29:02Z"
  },
  {
    "videoId": "BdBa4oM7g0A",
    "thumbnail": "https://i.ytimg.com/vi/BdBa4oM7g0A/mqdefault.jpg",
    "title": "【APEX】朝活APEX!つよつよになりたいの！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-26T03:42:55Z"
  },
  {
    "videoId": "lGHD_9B611g",
    "thumbnail": "https://i.ytimg.com/vi/lGHD_9B611g/mqdefault.jpg",
    "title": "【APEX】悪魔とJKの清楚なAPEX【ホロライブ/夏色まつり/癒月ちょこ】",
    "publishedAt": "2020-09-26T18:35:43Z"
  },
  {
    "videoId": "pEUAdNtS5z0",
    "thumbnail": "https://i.ytimg.com/vi/pEUAdNtS5z0/mqdefault.jpg",
    "title": "【ホロライブ身体測定】噂の雪の令嬢診察いたします！【ホロライブ/雪花ラミィ/癒月ちょこ】",
    "publishedAt": "2020-09-27T14:21:34Z"
  },
  {
    "videoId": "YrBDEXLRGiY",
    "thumbnail": "https://i.ytimg.com/vi/YrBDEXLRGiY/mqdefault.jpg",
    "title": "【APEX】へなちょこ悪魔のつよつよ奮闘記【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-09-28T07:58:21Z"
  },
  {
    "videoId": "EMJAu7mo_Lg",
    "thumbnail": "https://i.ytimg.com/vi/EMJAu7mo_Lg/mqdefault.jpg",
    "title": "【ホロライブ身体測定】噂のホロ５期生！桃鈴ねね様診察いたします！【ホロライブ/桃鈴ねね/癒月ちょこ】",
    "publishedAt": "2020-09-30T14:12:27Z"
  },
  {
    "videoId": "nPHwllqfhOw",
    "thumbnail": "https://i.ytimg.com/vi/nPHwllqfhOw/mqdefault.jpg",
    "title": "【APEX】へなちょこ悪魔の寝起き奮闘記【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-01T09:55:35Z"
  },
  {
    "videoId": "cb0eZ-t1Rmg",
    "thumbnail": "https://i.ytimg.com/vi/cb0eZ-t1Rmg/mqdefault.jpg",
    "title": "【Dead by Daylight】アイドル達の逃走中開始！【にじさんじ/夕陽リリ/愛園愛美/あにまーれ/因幡はねる/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-01T11:16:25Z"
  },
  {
    "videoId": "XiH6FDJZVO4",
    "thumbnail": "https://i.ytimg.com/vi/XiH6FDJZVO4/mqdefault.jpg",
    "title": "【ホロライブ身体測定】噂の５期生！獅白ぼたん様診察いたします！【ホロライブ/獅白ぼたん/癒月ちょこ】",
    "publishedAt": "2020-10-02T12:14:26Z"
  },
  {
    "videoId": "cR1PS8CfojU",
    "thumbnail": "https://i.ytimg.com/vi/cR1PS8CfojU/mqdefault.jpg",
    "title": "【APEX】寝起き悪魔のへなちょこ奮闘記【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-05T07:32:17Z"
  },
  {
    "videoId": "EhYKXMOg-to",
    "thumbnail": "https://i.ytimg.com/vi/EhYKXMOg-to/mqdefault.jpg",
    "title": "【APEX】冬眠寝起きの悪魔のコソ連APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-08T07:09:20Z"
  },
  {
    "videoId": "qLJI5s3EYfI",
    "thumbnail": "https://i.ytimg.com/vi/qLJI5s3EYfI/mqdefault.jpg",
    "title": "【#メルティーキッス】夜食が食べたいメルキスAPEX【ホロライブ/夜空メル/癒月ちょこ】",
    "publishedAt": "2020-10-09T16:51:21Z"
  },
  {
    "videoId": "bdUr5B78voo",
    "thumbnail": "https://i.ytimg.com/vi/bdUr5B78voo/mqdefault.jpg",
    "title": "【APEX】お腹ぺこぺこの女たちのAPEX【小森めと/宗谷いちか/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-10T13:43:37Z"
  },
  {
    "videoId": "-bKXZ9XWSTk",
    "thumbnail": "https://i.ytimg.com/vi/-bKXZ9XWSTk/mqdefault.jpg",
    "title": "【にじさんじ身体測定】噂のお姉様白雪巴様診察いたします！【にじさんじ/白雪巴/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-10T14:11:48Z"
  },
  {
    "videoId": "vrJJyXLLja8",
    "thumbnail": "https://i.ytimg.com/vi/vrJJyXLLja8/mqdefault.jpg",
    "title": "【にじさんじ身体測定】噂のお姉様白雪巴様診察いたします！【にじさんじ/白雪巴/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-11T13:26:36Z"
  },
  {
    "videoId": "Er0xgACkKRw",
    "thumbnail": "https://i.ytimg.com/vi/Er0xgACkKRw/mqdefault.jpg",
    "title": "【雑談】夜ふかし悪魔のお話し会【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-11T17:30:24Z"
  },
  {
    "videoId": "NTVsA4IYzI0",
    "thumbnail": "https://i.ytimg.com/vi/NTVsA4IYzI0/mqdefault.jpg",
    "title": "【#ももちょこ】ハートを打ち抜きたい女たちのAPEX【ホロライブ/桃鈴ねね/癒月ちょこ】",
    "publishedAt": "2020-10-12T11:11:26Z"
  },
  {
    "videoId": "LiItELTkkko",
    "thumbnail": "https://i.ytimg.com/vi/LiItELTkkko/mqdefault.jpg",
    "title": "【#カレーメシWEEK】ちょこ先生が味変えアレンジカレーメシ作ってみたら【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-14T11:24:11Z"
  },
  {
    "videoId": "1VFFAhfc63Y",
    "thumbnail": "https://i.ytimg.com/vi/1VFFAhfc63Y/mqdefault.jpg",
    "title": "【#ちょこすば】事故防止？！食レポ向上レッスン！【ホロライブ/大空スバル/癒月ちょこ】",
    "publishedAt": "2020-10-14T15:25:29Z"
  },
  {
    "videoId": "nEpCFuATfe8",
    "thumbnail": "https://i.ytimg.com/vi/nEpCFuATfe8/mqdefault.jpg",
    "title": "【雑談】ちょこ先生の近状報告会【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-18T16:53:47Z"
  },
  {
    "videoId": "hBmpQ7LKdSY",
    "thumbnail": "https://i.ytimg.com/vi/hBmpQ7LKdSY/mqdefault.jpg",
    "title": "【#めいち組】お泊り鍋女子会【小森めと/宗谷いちか/ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-19T12:05:55Z"
  },
  {
    "videoId": "QmLDvCepHJ8",
    "thumbnail": "https://i.ytimg.com/vi/QmLDvCepHJ8/mqdefault.jpg",
    "title": "【#なとちょこ3D身体測定】噂の八重沢なとり様3Ｄで身体測定いたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-22T12:09:05Z"
  },
  {
    "videoId": "RD-8pyg2Qjo",
    "thumbnail": "https://i.ytimg.com/vi/RD-8pyg2Qjo/mqdefault.jpg",
    "title": "【#おでん会】女たちの欲望だらけのおでん会【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-23T07:21:40Z"
  },
  {
    "videoId": "Uw2l3H7RdpY",
    "thumbnail": "https://i.ytimg.com/vi/Uw2l3H7RdpY/mqdefault.jpg",
    "title": "【雑談】最近のちょこ事情お話しする！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-24T11:00:59Z"
  },
  {
    "videoId": "bXOTQHils-g",
    "thumbnail": "https://i.ytimg.com/vi/bXOTQHils-g/mqdefault.jpg",
    "title": "【#癒月ちょこ新衣装】新衣装お披露目配信？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-25T11:58:51Z"
  },
  {
    "videoId": "Um4rjVsohTE",
    "thumbnail": "https://i.ytimg.com/vi/Um4rjVsohTE/mqdefault.jpg",
    "title": "【APEX】悪魔のコソ連APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-28T07:44:51Z"
  },
  {
    "videoId": "isDgiaCDpvk",
    "thumbnail": "https://i.ytimg.com/vi/isDgiaCDpvk/mqdefault.jpg",
    "title": "【Dead by Daylight】ついにハロウィンイベ参戦ですわよ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-29T03:12:23Z"
  },
  {
    "videoId": "5MrOl0z6fFU",
    "thumbnail": "https://i.ytimg.com/vi/5MrOl0z6fFU/mqdefault.jpg",
    "title": "【雑談】真夜中の悪魔ざつだん【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-10-30T17:08:48Z"
  },
  {
    "videoId": "EnPSPV6iVTY",
    "thumbnail": "https://i.ytimg.com/vi/EnPSPV6iVTY/mqdefault.jpg",
    "title": "【Dead by Daylight】おさぼり悪魔の紫ランク目指すDBD【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-11-02T14:46:43Z"
  },
  {
    "videoId": "DOumIXe8HTE",
    "thumbnail": "https://i.ytimg.com/vi/DOumIXe8HTE/mqdefault.jpg",
    "title": "【apex】悪魔のコソ連APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-11-03T09:14:37Z"
  },
  {
    "videoId": "8IIdg2_oesk",
    "thumbnail": "https://i.ytimg.com/vi/8IIdg2_oesk/mqdefault.jpg",
    "title": "【APEX】新シーズンプレイするうううう！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-11-07T10:33:29Z"
  },
  {
    "videoId": "96JjN7NihW4",
    "thumbnail": "https://i.ytimg.com/vi/96JjN7NihW4/mqdefault_live.jpg",
    "title": "【】【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-11-07T11:58:42Z"
  },
  {
    "videoId": "RT_XCHqgOLM",
    "thumbnail": "https://i.ytimg.com/vi/RT_XCHqgOLM/mqdefault.jpg",
    "title": "【お泊り配信】ロボ子先輩とロールキャベツ作ってみた【ホロライブ/ロボ子さん/癒月ちょこ】",
    "publishedAt": "2020-11-07T14:35:01Z"
  },
  {
    "videoId": "lzwWf6zPRyI",
    "thumbnail": "https://i.ytimg.com/vi/lzwWf6zPRyI/mqdefault.jpg",
    "title": "【APEX】悪魔の保健医のコソ練APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-11-10T10:44:33Z"
  },
  {
    "videoId": "CXLmDSSuCm0",
    "thumbnail": "https://i.ytimg.com/vi/CXLmDSSuCm0/mqdefault.jpg",
    "title": "【Minecraft】悪魔の保健医がホロ鯖上陸？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-11-10T19:31:57Z"
  },
  {
    "videoId": "tjcePiwxowk",
    "thumbnail": "https://i.ytimg.com/vi/tjcePiwxowk/mqdefault.jpg",
    "title": "【雑談】朝の寝起き雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-11-13T03:37:12Z"
  },
  {
    "videoId": "pKEW64vxFTc",
    "thumbnail": "https://i.ytimg.com/vi/pKEW64vxFTc/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】はらぺこ羊に火を使わないグラタン作る！【ホロライブ/角巻わため/癒月ちょこ】",
    "publishedAt": "2020-11-13T06:51:56Z"
  },
  {
    "videoId": "gVrilUvpI0A",
    "thumbnail": "https://i.ytimg.com/vi/gVrilUvpI0A/mqdefault.jpg",
    "title": "【APEX】寝起き悪魔のコソ錬apex【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-11-15T12:25:05Z"
  },
  {
    "videoId": "Et_eI3OwHR0",
    "thumbnail": "https://i.ytimg.com/vi/Et_eI3OwHR0/mqdefault.jpg",
    "title": "【Minecraft】救護室完成させる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-11-17T12:48:42Z"
  },
  {
    "videoId": "oBJqNs013qw",
    "thumbnail": "https://i.ytimg.com/vi/oBJqNs013qw/mqdefault.jpg",
    "title": "【ホロライブID身体測定】イオフィ様診察させていただきます！【ホロライブ/癒月ちょこ/イオフィ】",
    "publishedAt": "2020-11-17T15:08:15Z"
  },
  {
    "videoId": "6nlyzm8sWO8",
    "thumbnail": "https://i.ytimg.com/vi/6nlyzm8sWO8/mqdefault.jpg",
    "title": "【眠れない夜に】最後に大切なお話があります！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-11-17T17:40:39Z"
  },
  {
    "videoId": "hPGEQs0yGZ0",
    "thumbnail": "https://i.ytimg.com/vi/hPGEQs0yGZ0/mqdefault.jpg",
    "title": "【復帰配信】ただいま！悪魔の保健医帰還‼【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-05T12:03:33Z"
  },
  {
    "videoId": "4yY6_clIF-Q",
    "thumbnail": "https://i.ytimg.com/vi/4yY6_clIF-Q/mqdefault.jpg",
    "title": "【ＡＰＥＸ】へなちょこ悪魔のリハビリＡＰＥＸ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-06T07:30:40Z"
  },
  {
    "videoId": "438qcfPU4hg",
    "thumbnail": "https://i.ytimg.com/vi/438qcfPU4hg/mqdefault.jpg",
    "title": "【雑談】ちょこ先生のリハビリゲリラ雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-07T11:59:42Z"
  },
  {
    "videoId": "Ya_p9QBUU5w",
    "thumbnail": "https://i.ytimg.com/vi/Ya_p9QBUU5w/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】寝起き悪魔が冷蔵庫のもので適当にお昼ご飯作るゲリラ配信【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-12T06:30:18Z"
  },
  {
    "videoId": "wfW4gJJHmKU",
    "thumbnail": "https://i.ytimg.com/vi/wfW4gJJHmKU/mqdefault.jpg",
    "title": "【Minecraft】悪魔の保健医のホロ鯖探索？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-13T11:38:48Z"
  },
  {
    "videoId": "3mzXza8BStE",
    "thumbnail": "https://i.ytimg.com/vi/3mzXza8BStE/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】小森めと様が癒月家にお昼ご飯食べに来た【ホロライブ/癒月ちょこ/小森めと】",
    "publishedAt": "2020-12-14T05:29:04Z"
  },
  {
    "videoId": "VoIVdUdD-2k",
    "thumbnail": "https://i.ytimg.com/vi/VoIVdUdD-2k/mqdefault.jpg",
    "title": "【#スバちょこルーナ】料理上手No1は誰だ！禁断の料理対決？！【ホロライブ/癒月ちょこ/大空スバル/姫森ルーナ】",
    "publishedAt": "2020-12-17T13:28:15Z"
  },
  {
    "videoId": "ZNK8CgjX7TY",
    "thumbnail": "https://i.ytimg.com/vi/ZNK8CgjX7TY/mqdefault.jpg",
    "title": "【雑談】寝起き悪魔が語る最近のちょこ事情【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-19T00:17:59Z"
  },
  {
    "videoId": "q-ead3i6oZU",
    "thumbnail": "https://i.ytimg.com/vi/q-ead3i6oZU/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】寝起きの朝ごはん！カルボナーラリゾット作る！【ホロライブ/癒月ちょこ/夜空メル】",
    "publishedAt": "2020-12-22T05:30:58Z"
  },
  {
    "videoId": "IlcGjTZa5cY",
    "thumbnail": "https://i.ytimg.com/vi/IlcGjTZa5cY/mqdefault.jpg",
    "title": "【ゲリラ雑談】ライブ振り返りとか色々話す！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-23T06:45:41Z"
  },
  {
    "videoId": "dITW7VaUj5M",
    "thumbnail": "https://i.ytimg.com/vi/dITW7VaUj5M/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔がクリスマス料理作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-24T05:45:32Z"
  },
  {
    "videoId": "UvZs-8Rfcq8",
    "thumbnail": "https://i.ytimg.com/vi/UvZs-8Rfcq8/mqdefault.jpg",
    "title": "【#ホロライブクリスマス】クリスマスに滅びバーストストリーム！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-25T08:34:25Z"
  },
  {
    "videoId": "admu6LOSMKI",
    "thumbnail": "https://i.ytimg.com/vi/admu6LOSMKI/mqdefault.jpg",
    "title": "【ホロライブEN身体測定】噂の小鳥遊キアラ様診察いたします！【ホロライブ/癒月ちょこ/小鳥遊キアラ】",
    "publishedAt": "2020-12-27T14:12:57Z"
  },
  {
    "videoId": "zJ61I-UkwB8",
    "thumbnail": "https://i.ytimg.com/vi/zJ61I-UkwB8/mqdefault.jpg",
    "title": "【APEX】寝起きの悪魔の保健医のコソ連APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-28T04:44:08Z"
  },
  {
    "videoId": "bA1UnDSCiCs",
    "thumbnail": "https://i.ytimg.com/vi/bA1UnDSCiCs/mqdefault.jpg",
    "title": "【トイレの花子さん】久々にビビり悪魔が今年最後のホラゲ配信する！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-28T10:52:39Z"
  },
  {
    "videoId": "f_ccRfYqXX4",
    "thumbnail": "https://i.ytimg.com/vi/f_ccRfYqXX4/mqdefault.jpg",
    "title": "【トイレの花子さん】今年最後のホラゲ！ビビり悪魔が挑戦？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-28T15:59:53Z"
  },
  {
    "videoId": "eRgbQiXEV3w",
    "thumbnail": "https://i.ytimg.com/vi/eRgbQiXEV3w/mqdefault.jpg",
    "title": "【雑談】46万人を見届けたい！寝起き雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-30T02:12:18Z"
  },
  {
    "videoId": "AE-5lwWonzk",
    "thumbnail": "https://i.ytimg.com/vi/AE-5lwWonzk/mqdefault.jpg",
    "title": "【 #年末ARKボス戦】年超す前にボスをわからせてあげましょう！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-30T12:47:33Z"
  },
  {
    "videoId": "qGJfO1W9DqE",
    "thumbnail": "https://i.ytimg.com/vi/qGJfO1W9DqE/mqdefault.jpg",
    "title": "【Dead by Daylight】へなちょこ悪魔の保健医の年納DBD！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2020-12-31T06:05:20Z"
  },
  {
    "videoId": "jqde8NKTz7c",
    "thumbnail": "https://i.ytimg.com/vi/jqde8NKTz7c/mqdefault.jpg",
    "title": "【あけおめ】帰ってきたちょこ神様が今年も占います！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-01T10:56:03Z"
  },
  {
    "videoId": "sYXvgeNR9_g",
    "thumbnail": "https://i.ytimg.com/vi/sYXvgeNR9_g/mqdefault.jpg",
    "title": "【#ういちょこ】ういちょこ朝ごはん【しぐれうい/ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-06T02:46:55Z"
  },
  {
    "videoId": "-pM2XNGTyCE",
    "thumbnail": "https://i.ytimg.com/vi/-pM2XNGTyCE/mqdefault.jpg",
    "title": "【雑談】最近あったコラボのこととか色々話す！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-07T12:19:51Z"
  },
  {
    "videoId": "_uJwzZbv1qE",
    "thumbnail": "https://i.ytimg.com/vi/_uJwzZbv1qE/mqdefault.jpg",
    "title": "【雑談】声に変化が⁈テスト雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-10T04:43:39Z"
  },
  {
    "videoId": "WbQbJK7u1ys",
    "thumbnail": "https://i.ytimg.com/vi/WbQbJK7u1ys/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】火を使わない白菜のミルフィーユ鍋風作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-13T07:20:47Z"
  },
  {
    "videoId": "kocBlkbWST4",
    "thumbnail": "https://i.ytimg.com/vi/kocBlkbWST4/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】火を使わない白菜のそぼろ餡かけ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-15T06:08:12Z"
  },
  {
    "videoId": "E_zPBE1gu6A",
    "thumbnail": "https://i.ytimg.com/vi/E_zPBE1gu6A/mqdefault.jpg",
    "title": "【深夜企画】ちょこおじが幼児化？！逆凸で色気を取り戻せ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-16T16:19:39Z"
  },
  {
    "videoId": "ClaxvhA-0fU",
    "thumbnail": "https://i.ytimg.com/vi/ClaxvhA-0fU/mqdefault.jpg",
    "title": "【Dead by Daylight】1.5倍期間BP食べながら極めます！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-18T09:05:02Z"
  },
  {
    "videoId": "V-IbkOzyqIQ",
    "thumbnail": "https://i.ytimg.com/vi/V-IbkOzyqIQ/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】火も牛乳も生クリームも使わないカルボナーラ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-21T07:22:17Z"
  },
  {
    "videoId": "xlV8u17B79Y",
    "thumbnail": "https://i.ytimg.com/vi/xlV8u17B79Y/mqdefault.jpg",
    "title": "【Dead by Daylight】１.５倍期間リリ様と稼ぎまくりますわよ！【にじさんじ/夕陽リリ/ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-21T13:12:45Z"
  },
  {
    "videoId": "yBTu6ebwbPU",
    "thumbnail": "https://i.ytimg.com/vi/yBTu6ebwbPU/mqdefault.jpg",
    "title": "【#ちょこフレマイクラ】初心者悪魔がフレア様にマイクラ教えてもらう！【ホロライブ/不知火フレア/癒月ちょこ】",
    "publishedAt": "2021-01-22T19:51:04Z"
  },
  {
    "videoId": "sykIprztetM",
    "thumbnail": "https://i.ytimg.com/vi/sykIprztetM/mqdefault.jpg",
    "title": "【雑談】冬眠から目覚めた悪魔の寝起き雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-24T10:40:35Z"
  },
  {
    "videoId": "_Wel2TQRGy8",
    "thumbnail": "https://i.ytimg.com/vi/_Wel2TQRGy8/mqdefault.jpg",
    "title": "【#AKUKIN本社建設リレー】初心者悪魔貢献なるか？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-25T12:36:02Z"
  },
  {
    "videoId": "17sVW77wahw",
    "thumbnail": "https://i.ytimg.com/vi/17sVW77wahw/mqdefault.jpg",
    "title": "【50万人記念枠】ハーフミニオン達成！ありがとう【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-27T16:49:42Z"
  },
  {
    "videoId": "m7aOWCPe3Hg",
    "thumbnail": "https://i.ytimg.com/vi/m7aOWCPe3Hg/mqdefault.jpg",
    "title": "【のりプロ身体測定】姫咲ゆずる様診察いたします！【姫咲ゆずる/ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-29T12:25:20Z"
  },
  {
    "videoId": "i_rehC4knAE",
    "thumbnail": "https://i.ytimg.com/vi/i_rehC4knAE/mqdefault.jpg",
    "title": "【Minecraft】初心者悪魔がレベル最強目指す！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-01-30T09:15:25Z"
  },
  {
    "videoId": "htCXVRneHhk",
    "thumbnail": "https://i.ytimg.com/vi/htCXVRneHhk/mqdefault.jpg",
    "title": "【Minecraft】ラピスにロックオン！宝石大量採掘する！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-02-01T16:19:36Z"
  },
  {
    "videoId": "pIAhv3p7GTQ",
    "thumbnail": "https://i.ytimg.com/vi/pIAhv3p7GTQ/mqdefault.jpg",
    "title": "【Minecraft】コラボ直前！ガチャ配信！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-02-03T12:44:43Z"
  },
  {
    "videoId": "jDydkn9tBa8",
    "thumbnail": "https://i.ytimg.com/vi/jDydkn9tBa8/mqdefault.jpg",
    "title": "【マインクラフト/Minecraft】初心者悪魔とフレア先生とポルカ嬢が遠足？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-02-03T18:23:08Z"
  },
  {
    "videoId": "i6ahRn3-L8U",
    "thumbnail": "https://i.ytimg.com/vi/i6ahRn3-L8U/mqdefault.jpg",
    "title": "【#にじホロあもあす】初見プレイだけど悪魔ならおいしくいただいてもいいよね？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-02-04T14:12:51Z"
  },
  {
    "videoId": "a4Kcq9zQgig",
    "thumbnail": "https://i.ytimg.com/vi/a4Kcq9zQgig/mqdefault.jpg",
    "title": "【Minecraft】エンドにとじこめられました…【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-02-08T09:27:34Z"
  },
  {
    "videoId": "GvHa920DYno",
    "thumbnail": "https://i.ytimg.com/vi/GvHa920DYno/mqdefault.jpg",
    "title": "【APEX】新シーズンお久しAPEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-02-10T13:54:03Z"
  },
  {
    "videoId": "Ct4zDYNgXxU",
    "thumbnail": "https://i.ytimg.com/vi/Ct4zDYNgXxU/mqdefault.jpg",
    "title": "【桃太郎電鉄】億万長者に私はなる！【#ホロ鉄10年/癒月ちょこ】",
    "publishedAt": "2021-02-13T14:13:48Z"
  },
  {
    "videoId": "7dsfaFeXcRA",
    "thumbnail": "https://i.ytimg.com/vi/7dsfaFeXcRA/mqdefault.jpg",
    "title": "【仮】お誕生日カウントダウン配信【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-02-13T16:19:50Z"
  },
  {
    "videoId": "GegRa9yZUb4",
    "thumbnail": "https://i.ytimg.com/vi/GegRa9yZUb4/mqdefault.jpg",
    "title": "【歌ってみた】スイートマジック/Covered by 癒月ちょこ&夜空メル【オリジナルMV/ホロライブ】",
    "publishedAt": "2021-02-14T13:00:15Z"
  },
  {
    "videoId": "p9k8A3XzH68",
    "thumbnail": "https://i.ytimg.com/vi/p9k8A3XzH68/mqdefault.jpg",
    "title": "【#ちょこ先生誕2021】ちょこ先生の3Dお誕生日会【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-02-14T13:05:55Z"
  },
  {
    "videoId": "QdNcvoYm0_k",
    "thumbnail": "https://i.ytimg.com/vi/QdNcvoYm0_k/mqdefault.jpg",
    "title": "【雑談】お誕生日振り返り雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-02-16T10:51:28Z"
  },
  {
    "videoId": "BvqmLldBcKM",
    "thumbnail": "https://i.ytimg.com/vi/BvqmLldBcKM/mqdefault.jpg",
    "title": "【Minecraft】遂に悪魔が地下暮らしから地上に？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-02-24T19:41:42Z"
  },
  {
    "videoId": "mZvhTzCLKYI",
    "thumbnail": "https://i.ytimg.com/vi/mZvhTzCLKYI/mqdefault.jpg",
    "title": "【APEX】1500ダメでるまで終われない悪魔耐久【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-02-28T14:36:58Z"
  },
  {
    "videoId": "iAl7acYA8uU",
    "thumbnail": "https://i.ytimg.com/vi/iAl7acYA8uU/mqdefault.jpg",
    "title": "【Minecraft】悪魔の保健医は家を作りたい！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-03-03T11:55:02Z"
  },
  {
    "videoId": "isROHow0ucY",
    "thumbnail": "https://i.ytimg.com/vi/isROHow0ucY/mqdefault.jpg",
    "title": "【Minecraft】悪魔は家を作りたい！素材集め編【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-03-06T19:35:05Z"
  },
  {
    "videoId": "nJ4y0XZVYh0",
    "thumbnail": "https://i.ytimg.com/vi/nJ4y0XZVYh0/mqdefault.jpg",
    "title": "【Minecraft】ちょこフレポルでシェルカーとりたいの！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-03-07T17:23:48Z"
  },
  {
    "videoId": "kk5JEUMtqys",
    "thumbnail": "https://i.ytimg.com/vi/kk5JEUMtqys/mqdefault.jpg",
    "title": "【Dead by Daylight】オリ―様と生き残りをかけたDBD！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-03-10T11:11:32Z"
  },
  {
    "videoId": "hOAoilooPxc",
    "thumbnail": "https://i.ytimg.com/vi/hOAoilooPxc/mqdefault.jpg",
    "title": "【#ホロARK】緊急参戦！戦じゃ！戦じゃ！防衛線でお宝GET【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-03-11T16:52:47Z"
  },
  {
    "videoId": "ZkHrNRD3BGU",
    "thumbnail": "https://i.ytimg.com/vi/ZkHrNRD3BGU/mqdefault.jpg",
    "title": "【#ホロ女子座談会】ホロ女子座談会！卒業式体験談編【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-03-12T11:09:09Z"
  },
  {
    "videoId": "f0mCD0_68Gg",
    "thumbnail": "https://i.ytimg.com/vi/f0mCD0_68Gg/mqdefault.jpg",
    "title": "【Minecraft】レベル最強悪魔復活！エンチャント沼へようこそ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-03-15T17:11:30Z"
  },
  {
    "videoId": "s65TV6XVJCo",
    "thumbnail": "https://i.ytimg.com/vi/s65TV6XVJCo/mqdefault.jpg",
    "title": "【#ホロARK】エクス緊急地下洞窟攻略！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-03-16T14:23:25Z"
  },
  {
    "videoId": "iNA0CsltTX8",
    "thumbnail": "https://i.ytimg.com/vi/iNA0CsltTX8/mqdefault.jpg",
    "title": "【龍が如く０】シリーズ初見プレイ！今日から保健医やめて極道目指します！#1【ホロライブ/癒月ちょこ】※ネタバレあり",
    "publishedAt": "2021-03-20T08:43:04Z"
  },
  {
    "videoId": "SialCV510iM",
    "thumbnail": "https://i.ytimg.com/vi/SialCV510iM/mqdefault.jpg",
    "title": "【龍が如く０】第２章突入！神室町の闇、謎の男の正体はいかに？！#2【ホロライブ/癒月ちょこ】※ネタバレあり",
    "publishedAt": "2021-03-21T09:40:13Z"
  },
  {
    "videoId": "6S22b-tAbUc",
    "thumbnail": "https://i.ytimg.com/vi/6S22b-tAbUc/mqdefault.jpg",
    "title": "【Minecraft】エンドリベンジ！全ロスからの這い上がり？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-03-21T18:10:12Z"
  },
  {
    "videoId": "1gjRdHxJkNc",
    "thumbnail": "https://i.ytimg.com/vi/1gjRdHxJkNc/mqdefault.jpg",
    "title": "【龍が如く０】第3章突入！極道悪魔が大阪進出？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-03-27T05:39:06Z"
  },
  {
    "videoId": "Uin6LqAVpzg",
    "thumbnail": "https://i.ytimg.com/vi/Uin6LqAVpzg/mqdefault.jpg",
    "title": "【龍が如く０】第４章突入！極道悪魔が大阪の闇に迫る？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-03-28T08:43:14Z"
  },
  {
    "videoId": "au8CjgLxVZc",
    "thumbnail": "https://i.ytimg.com/vi/au8CjgLxVZc/mqdefault.jpg",
    "title": "【ゲリラ】自由気ままに悪魔な枠を【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-04-03T16:24:15Z"
  },
  {
    "videoId": "7MzLAU8y95E",
    "thumbnail": "https://i.ytimg.com/vi/7MzLAU8y95E/mqdefault.jpg",
    "title": "【龍が如く０】第4.5章、極道悪魔が謎の少女の正体に迫る！【ホロライブ/癒月ちょこ】※ネタバレあり",
    "publishedAt": "2021-04-04T21:54:43Z"
  },
  {
    "videoId": "Y3qCKXRSClU",
    "thumbnail": "https://i.ytimg.com/vi/Y3qCKXRSClU/mqdefault.jpg",
    "title": "【Minecraft】新ホロ資源鯖で大量発掘目指す！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-04-09T18:33:17Z"
  },
  {
    "videoId": "_katY07ZnFI",
    "thumbnail": "https://i.ytimg.com/vi/_katY07ZnFI/mqdefault.jpg",
    "title": "【Minecraft】#ちょこポルフレでピグリン要塞攻略！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-04-11T16:03:22Z"
  },
  {
    "videoId": "6QGz5bWKnQA",
    "thumbnail": "https://i.ytimg.com/vi/6QGz5bWKnQA/mqdefault.jpg",
    "title": "【APEX】寝起き悪魔の１５００ダメだせるまで終われないAPEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-04-12T17:29:13Z"
  },
  {
    "videoId": "3_0ShRkXCwc",
    "thumbnail": "https://i.ytimg.com/vi/3_0ShRkXCwc/mqdefault.jpg",
    "title": "【APEX】寝起き悪魔のAPEXコソ連配信【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-04-19T04:32:04Z"
  },
  {
    "videoId": "gZJeqhf3aco",
    "thumbnail": "https://i.ytimg.com/vi/gZJeqhf3aco/mqdefault.jpg",
    "title": "【雑談】ちょこ先生の悪魔的雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-04-22T16:36:58Z"
  },
  {
    "videoId": "vRuY4T9YyZc",
    "thumbnail": "https://i.ytimg.com/vi/vRuY4T9YyZc/mqdefault.jpg",
    "title": "【Minecraft】メルキスで地獄の新鯖探索？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-04-24T15:52:44Z"
  },
  {
    "videoId": "oPP93EI56DY",
    "thumbnail": "https://i.ytimg.com/vi/oPP93EI56DY/mqdefault.jpg",
    "title": "【朝枠】早起きしたい悪魔の朝枠【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-04-29T00:01:15Z"
  },
  {
    "videoId": "zOHSa5IkvIY",
    "thumbnail": "https://i.ytimg.com/vi/zOHSa5IkvIY/mqdefault.jpg",
    "title": "【APEX】59キルするまで終われないAPEX耐久【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-04-29T12:44:14Z"
  },
  {
    "videoId": "ml2N1Zn6g7k",
    "thumbnail": "https://i.ytimg.com/vi/ml2N1Zn6g7k/mqdefault.jpg",
    "title": "【APEX】59キルするまで終われないAPEX耐久【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-04-29T14:32:06Z"
  },
  {
    "videoId": "fvxlobk--lQ",
    "thumbnail": "https://i.ytimg.com/vi/fvxlobk--lQ/mqdefault.jpg",
    "title": "【APEX】子兎音様と１人１０キル耐久！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-05-04T14:57:45Z"
  },
  {
    "videoId": "qjNGb-xvu_M",
    "thumbnail": "https://i.ytimg.com/vi/qjNGb-xvu_M/mqdefault.jpg",
    "title": "【APEX】メルキスで3000ダメいくまでおわれまてん【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-05-06T18:18:58Z"
  },
  {
    "videoId": "kbaFVbHuK4A",
    "thumbnail": "https://i.ytimg.com/vi/kbaFVbHuK4A/mqdefault.jpg",
    "title": "【APEX】スバちょこルーナでAPEXやってみた【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-05-08T12:30:50Z"
  },
  {
    "videoId": "eUxsMqLm_I4",
    "thumbnail": "https://i.ytimg.com/vi/eUxsMqLm_I4/mqdefault.jpg",
    "title": "【あにまーれ身体測定】瀬島るい様診察します！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-05-09T11:10:46Z"
  },
  {
    "videoId": "9dhzI5dLU2k",
    "thumbnail": "https://i.ytimg.com/vi/9dhzI5dLU2k/mqdefault.jpg",
    "title": "【雑談】ちょこ先生の悪魔的雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-05-17T16:25:46Z"
  },
  {
    "videoId": "z_RVty1Oa9g",
    "thumbnail": "https://i.ytimg.com/vi/z_RVty1Oa9g/mqdefault.jpg",
    "title": "【朝枠】悪魔の朝雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-05-23T23:08:01Z"
  },
  {
    "videoId": "lk-JM2po0ac",
    "thumbnail": "https://i.ytimg.com/vi/lk-JM2po0ac/mqdefault.jpg",
    "title": "【APEX】真夜中の悪魔のAPEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-05-29T21:02:51Z"
  },
  {
    "videoId": "pyh1F25LgWM",
    "thumbnail": "https://i.ytimg.com/vi/pyh1F25LgWM/mqdefault.jpg",
    "title": "【朝枠】悪魔の保健医の朝ゲリラ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-02T22:13:31Z"
  },
  {
    "videoId": "zDi8AcWJ5SE",
    "thumbnail": "https://i.ytimg.com/vi/zDi8AcWJ5SE/mqdefault.jpg",
    "title": "【雑談】深夜の悪魔的ざつだん【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-07T19:06:08Z"
  },
  {
    "videoId": "LHc1qpC7OhU",
    "thumbnail": "https://i.ytimg.com/vi/LHc1qpC7OhU/mqdefault.jpg",
    "title": "【#ちょろぼ】ちょろぼAPEX耐久！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-08T18:51:57Z"
  },
  {
    "videoId": "V_MZEtYfYcg",
    "thumbnail": "https://i.ytimg.com/vi/V_MZEtYfYcg/mqdefault.jpg",
    "title": "【のりプロ身体測定】噂のサキュバスJK診察します！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-10T14:12:35Z"
  },
  {
    "videoId": "VQiGXwrjU98",
    "thumbnail": "https://i.ytimg.com/vi/VQiGXwrjU98/mqdefault.jpg",
    "title": "【Dead by Daylight】悪魔の鬼ごっこ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-15T12:10:51Z"
  },
  {
    "videoId": "Ox6jMbM9148",
    "thumbnail": "https://i.ytimg.com/vi/Ox6jMbM9148/mqdefault.jpg",
    "title": "【Dead by Daylight】バイオコラボ！悪魔の初プレイ！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-16T14:46:27Z"
  },
  {
    "videoId": "qnhfL1ey20E",
    "thumbnail": "https://i.ytimg.com/vi/qnhfL1ey20E/mqdefault.jpg",
    "title": "【#ねちょっとキャラメル】やべぇ３人が集まってしまった…。APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-17T10:14:28Z"
  },
  {
    "videoId": "HnAx2WyCVxA",
    "thumbnail": "https://i.ytimg.com/vi/HnAx2WyCVxA/mqdefault.jpg",
    "title": "【#HOLODBD】遂にちょこ先生にお呼びがかかった！！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-17T14:51:23Z"
  },
  {
    "videoId": "BLTfAKnpmJk",
    "thumbnail": "https://i.ytimg.com/vi/BLTfAKnpmJk/mqdefault.jpg",
    "title": "【雑談】悪魔の保健医の奇跡の朝枠ゲリラ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-19T01:15:07Z"
  },
  {
    "videoId": "fH2iwhf_2Uk",
    "thumbnail": "https://i.ytimg.com/vi/fH2iwhf_2Uk/mqdefault.jpg",
    "title": "【APEX】悪魔の保健医が遂にランク耐久に手を出してしまった結果…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-19T17:43:31Z"
  },
  {
    "videoId": "raZ24O2yvu8",
    "thumbnail": "https://i.ytimg.com/vi/raZ24O2yvu8/mqdefault.jpg",
    "title": "【Dead by Daylight】悪魔の保健医が救助いたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-21T07:05:48Z"
  },
  {
    "videoId": "jZ4CLd3bIdU",
    "thumbnail": "https://i.ytimg.com/vi/jZ4CLd3bIdU/mqdefault.jpg",
    "title": "【APEX】悪魔の保健医のゴールド耐久！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-22T14:56:13Z"
  },
  {
    "videoId": "HpudCnQRzFY",
    "thumbnail": "https://i.ytimg.com/vi/HpudCnQRzFY/mqdefault.jpg",
    "title": "【APEX】プラチナ目指して悪魔の耐久配信１日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-24T06:03:00Z"
  },
  {
    "videoId": "61Vf3wL__NE",
    "thumbnail": "https://i.ytimg.com/vi/61Vf3wL__NE/mqdefault.jpg",
    "title": "【APEX】プラチナ目指して悪魔の耐久配信１日目vol2【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-24T17:33:13Z"
  },
  {
    "videoId": "7yX3gVYm0Yo",
    "thumbnail": "https://i.ytimg.com/vi/7yX3gVYm0Yo/mqdefault.jpg",
    "title": "【APEX】プラチナ目指して悪魔の耐久配信２日目vol1【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-25T18:52:54Z"
  },
  {
    "videoId": "9cAEx7ohgWs",
    "thumbnail": "https://i.ytimg.com/vi/9cAEx7ohgWs/mqdefault.jpg",
    "title": "【APEX】プラチナ目指して悪魔の耐久配信２日目vol2【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-26T04:09:42Z"
  },
  {
    "videoId": "LPym-r3zJpM",
    "thumbnail": "https://i.ytimg.com/vi/LPym-r3zJpM/mqdefault.jpg",
    "title": "【#メルキスココ】ココ様にメルキスが色気というものを教えてさしあげます！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-26T11:03:31Z"
  },
  {
    "videoId": "yq83e5DE6Pc",
    "thumbnail": "https://i.ytimg.com/vi/yq83e5DE6Pc/mqdefault.jpg",
    "title": "【#うさ建夏祭り】うさ建夏祭りへ遊びに行くわよ!!!!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-27T15:25:13Z"
  },
  {
    "videoId": "MCtf3roOHZ4",
    "thumbnail": "https://i.ytimg.com/vi/MCtf3roOHZ4/mqdefault.jpg",
    "title": "【APEX】プラチナ目指して悪魔の耐久配信3日目vol1【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-28T14:52:23Z"
  },
  {
    "videoId": "5yojzxUZRPw",
    "thumbnail": "https://i.ytimg.com/vi/5yojzxUZRPw/mqdefault.jpg",
    "title": "【APEX】プラチナ目指して悪魔の耐久配信4日目最終日vol1【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-29T12:01:30Z"
  },
  {
    "videoId": "E6pl5gLyE1c",
    "thumbnail": "https://i.ytimg.com/vi/E6pl5gLyE1c/mqdefault.jpg",
    "title": "【APEX】プラチナ目指して悪魔の耐久配信4日目最終日vol2【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-29T16:45:56Z"
  },
  {
    "videoId": "5WHeCQWZmyQ",
    "thumbnail": "https://i.ytimg.com/vi/5WHeCQWZmyQ/mqdefault.jpg",
    "title": "【#ムキロゼパーク】ホロARKコラボ楽しむ！！！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-06-30T14:43:57Z"
  },
  {
    "videoId": "RDDzZhuc0Sc",
    "thumbnail": "https://i.ytimg.com/vi/RDDzZhuc0Sc/mqdefault.jpg",
    "title": "【Dead by Daylight】悪魔の保健医の触手うけてみる？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-05T07:26:06Z"
  },
  {
    "videoId": "0bZJcKsLQdk",
    "thumbnail": "https://i.ytimg.com/vi/0bZJcKsLQdk/mqdefault.jpg",
    "title": "【APEX】レイネ様とデートAPEX！ヤるわよ！！！！！！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-05T14:51:55Z"
  },
  {
    "videoId": "WS3QK5Hac2M",
    "thumbnail": "https://i.ytimg.com/vi/WS3QK5Hac2M/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】ゆずる様にご飯作ってあげますわよ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-06T12:23:04Z"
  },
  {
    "videoId": "7_1occkrj_w",
    "thumbnail": "https://i.ytimg.com/vi/7_1occkrj_w/mqdefault.jpg",
    "title": "【逆凸企画】ちょこヤギに愛を！愛の逆凸企画⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-07T15:31:11Z"
  },
  {
    "videoId": "FGCEL-Gmguc",
    "thumbnail": "https://i.ytimg.com/vi/FGCEL-Gmguc/mqdefault.jpg",
    "title": "【APEX】悪魔のコソ連APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-08T14:09:51Z"
  },
  {
    "videoId": "RHuTxLBkX10",
    "thumbnail": "https://i.ytimg.com/vi/RHuTxLBkX10/mqdefault.jpg",
    "title": "【APEX】悪魔のコソ連APEX！ハンマー目指しの旅【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-09T09:51:57Z"
  },
  {
    "videoId": "Qq51nZExT0E",
    "thumbnail": "https://i.ytimg.com/vi/Qq51nZExT0E/mqdefault.jpg",
    "title": "【Dead by Daylight】BPを美女たちに貢ぎたい悪魔の保健医のDBD【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-12T13:41:28Z"
  },
  {
    "videoId": "8XWeXqji9zQ",
    "thumbnail": "https://i.ytimg.com/vi/8XWeXqji9zQ/mqdefault.jpg",
    "title": "【Minecraft】初心者悪魔、有能羊と家建てる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-13T20:40:20Z"
  },
  {
    "videoId": "LICY1X_xmlE",
    "thumbnail": "https://i.ytimg.com/vi/LICY1X_xmlE/mqdefault.jpg",
    "title": "【Freetalk】最近あった悪魔事情【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-14T16:47:15Z"
  },
  {
    "videoId": "tPiQQg02ZDo",
    "thumbnail": "https://i.ytimg.com/vi/tPiQQg02ZDo/mqdefault.jpg",
    "title": "【APEX】まつり様とエペ朝活！悪魔のAPEX練習【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-15T02:22:03Z"
  },
  {
    "videoId": "fMoeXlHM0c8",
    "thumbnail": "https://i.ytimg.com/vi/fMoeXlHM0c8/mqdefault.jpg",
    "title": "【APEX】悪魔のコソ連APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-15T15:19:57Z"
  },
  {
    "videoId": "41AY0vPsP_I",
    "thumbnail": "https://i.ytimg.com/vi/41AY0vPsP_I/mqdefault.jpg",
    "title": "【Dead by Daylight】#ホロdbd女子会　楽しむわよ！！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-16T11:25:05Z"
  },
  {
    "videoId": "Nu60AHJj2bA",
    "thumbnail": "https://i.ytimg.com/vi/Nu60AHJj2bA/mqdefault.jpg",
    "title": "【ネタバレあり】悪魔の保健医がプレイ！クレヨンしんちゃん『オラと博士の夏休み』#1【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-19T10:41:30Z"
  },
  {
    "videoId": "DH332FTgOg8",
    "thumbnail": "https://i.ytimg.com/vi/DH332FTgOg8/mqdefault.jpg",
    "title": "【ホロライブID身体測定】噂のレイネ様診察します！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-20T15:15:30Z"
  },
  {
    "videoId": "tbuMqI0PJ-8",
    "thumbnail": "https://i.ytimg.com/vi/tbuMqI0PJ-8/mqdefault.jpg",
    "title": "【APEX】寝起きの悪魔のコソ連APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-23T04:58:00Z"
  },
  {
    "videoId": "7vOP9Onyc98",
    "thumbnail": "https://i.ytimg.com/vi/7vOP9Onyc98/mqdefault.jpg",
    "title": "【ネタバレあり】悪魔の保健医がプレイ！クレヨンしんちゃん『オラと博士の夏休み』#2【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-23T12:47:41Z"
  },
  {
    "videoId": "HCaJFizJ3JE",
    "thumbnail": "https://i.ytimg.com/vi/HCaJFizJ3JE/mqdefault.jpg",
    "title": "【APEX】寝起きの悪魔の朝活コソ連APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-24T07:33:13Z"
  },
  {
    "videoId": "F-cZYvN2pR0",
    "thumbnail": "https://i.ytimg.com/vi/F-cZYvN2pR0/mqdefault.jpg",
    "title": "【Minecraft】わため様とフレア様に内装依頼！ChocoHouse完成させる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-24T19:25:00Z"
  },
  {
    "videoId": "aBCIWPNG9dE",
    "thumbnail": "https://i.ytimg.com/vi/aBCIWPNG9dE/mqdefault.jpg",
    "title": "【#ちょろぼ】ちょろぼAPEXゲリラ！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-27T17:55:28Z"
  },
  {
    "videoId": "OkV0ZHHK6GY",
    "thumbnail": "https://i.ytimg.com/vi/OkV0ZHHK6GY/mqdefault.jpg",
    "title": "【Call of Duty®: BOCW】スバちょこルーナぼたんでCOD！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-28T15:40:58Z"
  },
  {
    "videoId": "Pgu0hSP5tsc",
    "thumbnail": "https://i.ytimg.com/vi/Pgu0hSP5tsc/mqdefault.jpg",
    "title": "【#俺流ちょこ先私服イラスト】もしもちょこ先生がこんな私服を来ていたら…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-07-30T17:35:26Z"
  },
  {
    "videoId": "2aGZ3Et7zE8",
    "thumbnail": "https://i.ytimg.com/vi/2aGZ3Et7zE8/mqdefault.jpg",
    "title": "【Minecraft】ChocoHouse完成させる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-03T11:00:32Z"
  },
  {
    "videoId": "8_8ooTwHpwc",
    "thumbnail": "https://i.ytimg.com/vi/8_8ooTwHpwc/mqdefault.jpg",
    "title": "【#ちょろぼ】ちょろぼで新シーズンAPEXゲリラ！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-04T14:02:07Z"
  },
  {
    "videoId": "77GUoZvOTmE",
    "thumbnail": "https://i.ytimg.com/vi/77GUoZvOTmE/mqdefault.jpg",
    "title": "【APEX】顔合わせAPEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-05T06:49:36Z"
  },
  {
    "videoId": "YGIdNfVmZPU",
    "thumbnail": "https://i.ytimg.com/vi/YGIdNfVmZPU/mqdefault.jpg",
    "title": "【APEX】ARCSTARSで練習APEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-07T08:27:29Z"
  },
  {
    "videoId": "HJE1fAo555w",
    "thumbnail": "https://i.ytimg.com/vi/HJE1fAo555w/mqdefault.jpg",
    "title": "【Minecraft】初心者悪魔のフィーリングマイクラ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-08T08:56:58Z"
  },
  {
    "videoId": "Xo_yPKqPnIg",
    "thumbnail": "https://i.ytimg.com/vi/Xo_yPKqPnIg/mqdefault.jpg",
    "title": "【APEX】寝起きの悪魔の朝活コソ連APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-12T07:16:14Z"
  },
  {
    "videoId": "PUaCGsBkdNo",
    "thumbnail": "https://i.ytimg.com/vi/PUaCGsBkdNo/mqdefault.jpg",
    "title": "【Freetalk】悪魔の保健医の深夜のゲリラ雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-13T16:55:52Z"
  },
  {
    "videoId": "VsZ7eeg5uZs",
    "thumbnail": "https://i.ytimg.com/vi/VsZ7eeg5uZs/mqdefault.jpg",
    "title": "【Phasmophobia】初見プレイなので優しくしてください…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-15T16:15:49Z"
  },
  {
    "videoId": "grHXIoFiuss",
    "thumbnail": "https://i.ytimg.com/vi/grHXIoFiuss/mqdefault.jpg",
    "title": "【Call of Duty®: BOCW】スバちょこルーナぼたんでCOD！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-16T16:15:23Z"
  },
  {
    "videoId": "1nRHYxCgBOA",
    "thumbnail": "https://i.ytimg.com/vi/1nRHYxCgBOA/mqdefault.jpg",
    "title": "【Freetalk】悪魔の保健医のゲリラ雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-17T09:31:31Z"
  },
  {
    "videoId": "3eOCxB2-1cw",
    "thumbnail": "https://i.ytimg.com/vi/3eOCxB2-1cw/mqdefault.jpg",
    "title": "【APEX】ARCSTARSでカスタム練習APEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-17T15:11:28Z"
  },
  {
    "videoId": "mXG-omaMPIg",
    "thumbnail": "https://i.ytimg.com/vi/mXG-omaMPIg/mqdefault.jpg",
    "title": "【例外配達】ホラー嫌いな悪魔の配達員が届けます！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-18T12:53:52Z"
  },
  {
    "videoId": "WPrKSzPbMBM",
    "thumbnail": "https://i.ytimg.com/vi/WPrKSzPbMBM/mqdefault.jpg",
    "title": "【APEX】ARCSTARSで最協練習APEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-19T14:36:17Z"
  },
  {
    "videoId": "tadz1c-M0OE",
    "thumbnail": "https://i.ytimg.com/vi/tadz1c-M0OE/mqdefault.jpg",
    "title": "【Call of Duty®: BOCW】スバちょこルーナぼたんでゾンビCOD！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-19T16:12:36Z"
  },
  {
    "videoId": "K8j4RImdlIc",
    "thumbnail": "https://i.ytimg.com/vi/K8j4RImdlIc/mqdefault.jpg",
    "title": "【APEX】ARCSTARSで最協練習APEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-20T16:00:48Z"
  },
  {
    "videoId": "js-xelJvyUI",
    "thumbnail": "https://i.ytimg.com/vi/js-xelJvyUI/mqdefault.jpg",
    "title": "【APEX】ARCSTARSで最協練習前夜祭APEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-21T15:57:22Z"
  },
  {
    "videoId": "b8EQZ1-qeP8",
    "thumbnail": "https://i.ytimg.com/vi/b8EQZ1-qeP8/mqdefault.jpg",
    "title": "【APEX】ARCSTARSでVtuver最協決定戦 本番⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-22T16:22:39Z"
  },
  {
    "videoId": "x5rjjz2UHDw",
    "thumbnail": "https://i.ytimg.com/vi/x5rjjz2UHDw/mqdefault.jpg",
    "title": "【APEX】ARCSTARSでVtuver最協決定戦後夜祭⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-22T18:45:36Z"
  },
  {
    "videoId": "pDzgPVohU3E",
    "thumbnail": "https://i.ytimg.com/vi/pDzgPVohU3E/mqdefault.jpg",
    "title": "【Vtuber身体測定】噂のあやみ様診察いたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-23T12:24:43Z"
  },
  {
    "videoId": "qYtx2xtE1AA",
    "thumbnail": "https://i.ytimg.com/vi/qYtx2xtE1AA/mqdefault.jpg",
    "title": "【APEX】二度寝悪魔の寝起きの悪魔のAPEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-08-24T12:43:49Z"
  },
  {
    "videoId": "q8XMyYMsUGM",
    "thumbnail": "https://i.ytimg.com/vi/q8XMyYMsUGM/mqdefault.jpg",
    "title": "【Freetalk】ただいま！悪魔の保健医復活雑談⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-09-03T23:52:43Z"
  },
  {
    "videoId": "spHKQDaz0C0",
    "thumbnail": "https://i.ytimg.com/vi/spHKQDaz0C0/mqdefault.jpg",
    "title": "【#癒月ちょこ3周年】３周年記念3D配信⚡重大告知あり！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-09-04T12:31:35Z"
  },
  {
    "videoId": "njeUgc0a5ko",
    "thumbnail": "https://i.ytimg.com/vi/njeUgc0a5ko/mqdefault.jpg",
    "title": "【オリジナル曲】ChocoLove/癒月ちょこ【３周年記念配信】",
    "publishedAt": "2021-09-04T15:00:15Z"
  },
  {
    "videoId": "6VuDkiadBqg",
    "thumbnail": "https://i.ytimg.com/vi/6VuDkiadBqg/mqdefault.jpg",
    "title": "【Freetalk】３周年記念配信振り返り雑談⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-09-05T12:13:29Z"
  },
  {
    "videoId": "YK0gmfEP4Ls",
    "thumbnail": "https://i.ytimg.com/vi/YK0gmfEP4Ls/mqdefault.jpg",
    "title": "【Dead by Daylight】美女たちを守りたい悪魔の保健医のDBD【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-09-06T15:55:51Z"
  },
  {
    "videoId": "V8dM0pESsNw",
    "thumbnail": "https://i.ytimg.com/vi/V8dM0pESsNw/mqdefault.jpg",
    "title": "【APEX】宗谷いちかと21キルできるまで終われまてん！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-09-08T12:44:40Z"
  },
  {
    "videoId": "C02_XubayWc",
    "thumbnail": "https://i.ytimg.com/vi/C02_XubayWc/mqdefault.jpg",
    "title": "【APEX】寝起きの悪魔の朝活コソ連APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-09-15T00:34:14Z"
  },
  {
    "videoId": "CkYuADUJ95E",
    "thumbnail": "https://i.ytimg.com/vi/CkYuADUJ95E/mqdefault.jpg",
    "title": "【Freetalk】悪魔の保健医のゲリラ枠【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-09-18T16:43:12Z"
  },
  {
    "videoId": "Nqe9mdTgwvs",
    "thumbnail": "https://i.ytimg.com/vi/Nqe9mdTgwvs/mqdefault.jpg",
    "title": "【#スバちょこるなたん】WATCH DOGS LEGION初プレイ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-09-21T14:33:12Z"
  },
  {
    "videoId": "i9NLgXcHvOE",
    "thumbnail": "https://i.ytimg.com/vi/i9NLgXcHvOE/mqdefault.jpg",
    "title": "【Dead by Daylight】全員で逃げ切りたい悪魔の保健医のDBD【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-09-22T15:38:24Z"
  },
  {
    "videoId": "IqOVXTyGPAc",
    "thumbnail": "https://i.ytimg.com/vi/IqOVXTyGPAc/mqdefault.jpg",
    "title": "【#スバちょこるなたん】L4D2でゾンビ退治する！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-09-23T15:50:08Z"
  },
  {
    "videoId": "0Ke0MGE1QeA",
    "thumbnail": "https://i.ytimg.com/vi/0Ke0MGE1QeA/mqdefault.jpg",
    "title": "【Minecraft】レベル０から始まる悪魔の深夜マイクラ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-09-27T17:55:27Z"
  },
  {
    "videoId": "fG4ef85unZE",
    "thumbnail": "https://i.ytimg.com/vi/fG4ef85unZE/mqdefault.jpg",
    "title": "【Phasmophobia】リベンジ！リベンジ！もう怖くない、、、もん！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-09-30T14:59:19Z"
  },
  {
    "videoId": "I0xK-Re9Pr4",
    "thumbnail": "https://i.ytimg.com/vi/I0xK-Re9Pr4/mqdefault.jpg",
    "title": "【Minecraft】狂犬と狩りに行く悪魔の深夜マイクラ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-10-05T17:50:13Z"
  },
  {
    "videoId": "jlELf83gpBw",
    "thumbnail": "https://i.ytimg.com/vi/jlELf83gpBw/mqdefault.jpg",
    "title": "【original】ChocoLove/癒月ちょこ",
    "publishedAt": "2021-10-10T09:00:10Z"
  },
  {
    "videoId": "Jq_0nTSSSHo",
    "thumbnail": "https://i.ytimg.com/vi/Jq_0nTSSSHo/mqdefault.jpg",
    "title": "【Freetalk】悪魔の保健医のゲリラ雑談枠【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-10-11T04:42:17Z"
  },
  {
    "videoId": "cRqHDtaCqZ4",
    "thumbnail": "https://i.ytimg.com/vi/cRqHDtaCqZ4/mqdefault.jpg",
    "title": "【CoD:BOCW】シーズン６到来！ぼたん様とゾンビから脱出するわよ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-10-11T12:12:24Z"
  },
  {
    "videoId": "PFsUZUyVB8A",
    "thumbnail": "https://i.ytimg.com/vi/PFsUZUyVB8A/mqdefault.jpg",
    "title": "【Dead by Daylight】フルパで遊びまくる！悪魔の保健医のDBD【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-10-13T10:18:33Z"
  },
  {
    "videoId": "BAx2GtYGJxs",
    "thumbnail": "https://i.ytimg.com/vi/BAx2GtYGJxs/mqdefault.jpg",
    "title": "【歌ってみた】「チェリボム」/Covered by癒月ちょこ＆大空スバル＆姫森ルーナ【ホロライブ/オリジナルＭＶ】",
    "publishedAt": "2021-10-15T12:00:12Z"
  },
  {
    "videoId": "CbLKw2CjPE0",
    "thumbnail": "https://i.ytimg.com/vi/CbLKw2CjPE0/mqdefault.jpg",
    "title": "【Dead by Daylight】フルパDBD!騒ぎまくる！！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-10-20T12:31:07Z"
  },
  {
    "videoId": "NinnRkvQsPg",
    "thumbnail": "https://i.ytimg.com/vi/NinnRkvQsPg/mqdefault.jpg",
    "title": "【APEX】寝起きの悪魔の朝活コソ連APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-10-21T02:23:35Z"
  },
  {
    "videoId": "QJ9QMi8qQ28",
    "thumbnail": "https://i.ytimg.com/vi/QJ9QMi8qQ28/mqdefault.jpg",
    "title": "【APEX】寝起きの悪魔のゴールド耐久APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-10-23T15:21:27Z"
  },
  {
    "videoId": "dUsyMPgGey8",
    "thumbnail": "https://i.ytimg.com/vi/dUsyMPgGey8/mqdefault.jpg",
    "title": "【Phasmophobia】もうやられない！最後まで生き残るんだ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-10-26T14:32:02Z"
  },
  {
    "videoId": "TUMGbwpq8Uk",
    "thumbnail": "https://i.ytimg.com/vi/TUMGbwpq8Uk/mqdefault.jpg",
    "title": "【Minecraft】猫を探しの旅に出ます【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-10-29T17:22:07Z"
  },
  {
    "videoId": "5YfWZc8dB6w",
    "thumbnail": "https://i.ytimg.com/vi/5YfWZc8dB6w/mqdefault.jpg",
    "title": "【逆凸】深夜のロリちょこおねだり企画【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-10-31T16:42:22Z"
  },
  {
    "videoId": "nDwAOPtk4fk",
    "thumbnail": "https://i.ytimg.com/vi/nDwAOPtk4fk/mqdefault.jpg",
    "title": "【Minecraft】皆で運動会練習⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-11-03T13:09:34Z"
  },
  {
    "videoId": "EHwTlsrWrl8",
    "thumbnail": "https://i.ytimg.com/vi/EHwTlsrWrl8/mqdefault.jpg",
    "title": "【欲望企画】ロリちょこ絵を愛でたい！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-11-04T13:08:12Z"
  },
  {
    "videoId": "_uIFTV-ahZ8",
    "thumbnail": "https://i.ytimg.com/vi/_uIFTV-ahZ8/mqdefault.jpg",
    "title": "【Minecraft】ちょこ先生の深夜マイクラ⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-11-08T17:05:42Z"
  },
  {
    "videoId": "uteeonfRAAg",
    "thumbnail": "https://i.ytimg.com/vi/uteeonfRAAg/mqdefault.jpg",
    "title": "【2Dお披露目配信】突然ですが、お披露目です！癒月ついに…！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-11-11T14:50:10Z"
  },
  {
    "videoId": "JYXiFqa1pww",
    "thumbnail": "https://i.ytimg.com/vi/JYXiFqa1pww/mqdefault.jpg",
    "title": "【邪神ころね】邪神ころね様？悪魔より崇拝されてるってがちぃ？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-11-12T11:20:36Z"
  },
  {
    "videoId": "cO19uLPFhC8",
    "thumbnail": "https://i.ytimg.com/vi/cO19uLPFhC8/mqdefault.jpg",
    "title": "【APEX】寝起きの新マップ探索APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-11-14T14:08:18Z"
  },
  {
    "videoId": "A3Q36k0XbHU",
    "thumbnail": "https://i.ytimg.com/vi/A3Q36k0XbHU/mqdefault.jpg",
    "title": "【Minecraft】お宝を釣りあげたい悪魔の深夜マイクラ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-11-16T15:37:07Z"
  },
  {
    "videoId": "-wMARha4rlA",
    "thumbnail": "https://i.ytimg.com/vi/-wMARha4rlA/mqdefault.jpg",
    "title": "【にじさんじ身体測定】噂の詩子お姉様診察いたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-11-19T15:30:04Z"
  },
  {
    "videoId": "j5-1ktM3elc",
    "thumbnail": "https://i.ytimg.com/vi/j5-1ktM3elc/mqdefault.jpg",
    "title": "【Minecraft】レベル最強になりたい悪魔マイクラ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-11-22T16:35:56Z"
  },
  {
    "videoId": "bmjqxBATOmY",
    "thumbnail": "https://i.ytimg.com/vi/bmjqxBATOmY/mqdefault.jpg",
    "title": "【Minecraft】レベル最強になりたい悪魔耐久マイクラ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-11-23T17:08:59Z"
  },
  {
    "videoId": "4D-W4zdLQ84",
    "thumbnail": "https://i.ytimg.com/vi/4D-W4zdLQ84/mqdefault.jpg",
    "title": "【Dead by Daylight】2倍イベント開始？！BP稼ぎたい悪魔DBD【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-11-26T15:23:17Z"
  },
  {
    "videoId": "Z-EYYnPgTCA",
    "thumbnail": "https://i.ytimg.com/vi/Z-EYYnPgTCA/mqdefault.jpg",
    "title": "【Minecraft】レベル最強になりたい悪魔のレベリングマイクラ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-11-30T10:21:58Z"
  },
  {
    "videoId": "mKXG98mQfyU",
    "thumbnail": "https://i.ytimg.com/vi/mKXG98mQfyU/mqdefault.jpg",
    "title": "【Minecraft】復活したい悪魔のレベリングマイクラ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-12-05T09:59:34Z"
  },
  {
    "videoId": "IRiCyiP9pPE",
    "thumbnail": "https://i.ytimg.com/vi/IRiCyiP9pPE/mqdefault.jpg",
    "title": "【Minecraft】復活したい悪魔のレベリングマイクラ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-12-09T11:05:56Z"
  },
  {
    "videoId": "b7xbo707sX0",
    "thumbnail": "https://i.ytimg.com/vi/b7xbo707sX0/mqdefault.jpg",
    "title": "【APEX】神様と悪魔で最強装備手に入れる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-12-09T15:49:48Z"
  },
  {
    "videoId": "39UjFH9Uku0",
    "thumbnail": "https://i.ytimg.com/vi/39UjFH9Uku0/mqdefault.jpg",
    "title": "【APEX】寝起きの悪魔のゴールド耐久APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-12-11T09:13:44Z"
  },
  {
    "videoId": "K2rZSFpg3kw",
    "thumbnail": "https://i.ytimg.com/vi/K2rZSFpg3kw/mqdefault.jpg",
    "title": "【Minecraft】復活したい悪魔のレベリングマイクラ⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-12-12T12:25:05Z"
  },
  {
    "videoId": "kWWX2WOPkdQ",
    "thumbnail": "https://i.ytimg.com/vi/kWWX2WOPkdQ/mqdefault.jpg",
    "title": "【Freetalk】深夜の悪魔雑談⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-12-19T16:09:28Z"
  },
  {
    "videoId": "ZevY_VHsR2c",
    "thumbnail": "https://i.ytimg.com/vi/ZevY_VHsR2c/mqdefault.jpg",
    "title": "【Dead by Daylight】雪だるまイベントで生着替えできるってがちぃ？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-12-23T12:14:08Z"
  },
  {
    "videoId": "bD7ol15yJSk",
    "thumbnail": "https://i.ytimg.com/vi/bD7ol15yJSk/mqdefault.jpg",
    "title": "【Dead by Daylight】アーニャ様と雪だるまイベント参戦！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-12-24T03:51:30Z"
  },
  {
    "videoId": "QaEW5hhLxuk",
    "thumbnail": "https://i.ytimg.com/vi/QaEW5hhLxuk/mqdefault.jpg",
    "title": "【original】Choco♡Melty【ホロライブ/癒月ちょこ/夜空メル】",
    "publishedAt": "2021-12-24T11:00:13Z"
  },
  {
    "videoId": "O3oJy2ZshkY",
    "thumbnail": "https://i.ytimg.com/vi/O3oJy2ZshkY/mqdefault.jpg",
    "title": "【懺悔企画】悪魔と神様に今年最後の懺悔せよ！悪神懺悔企画⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-12-27T15:27:56Z"
  },
  {
    "videoId": "kaK0DBoBxcI",
    "thumbnail": "https://i.ytimg.com/vi/kaK0DBoBxcI/mqdefault.jpg",
    "title": "【マリオカート8DX】毎年最下位だけど強くなりたい悪魔のマリカ練習⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-12-30T06:56:57Z"
  },
  {
    "videoId": "6mgk1AkXBOM",
    "thumbnail": "https://i.ytimg.com/vi/6mgk1AkXBOM/mqdefault.jpg",
    "title": "【逆凸企画】悪魔の逆凸企画⚡我々を崇拝せよ！【ホロライブ/癒月ちょこ/にじさんじ/でびでび・でびる】",
    "publishedAt": "2021-12-30T07:10:57Z"
  },
  {
    "videoId": "pL8T_egKnvI",
    "thumbnail": "https://i.ytimg.com/vi/pL8T_egKnvI/mqdefault.jpg",
    "title": "【スバちょこルーナ】BAN回避できるか！ぎりちょこ企画⚡【ホロライブ/癒月ちょこ/大空スバル/姫森ルーナ】",
    "publishedAt": "2021-12-30T11:55:16Z"
  },
  {
    "videoId": "8EiCShdZ2CU",
    "thumbnail": "https://i.ytimg.com/vi/8EiCShdZ2CU/mqdefault.jpg",
    "title": "【Freetalk】今年最後の悪魔雑談⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2021-12-31T15:26:38Z"
  },
  {
    "videoId": "_e9NeBqHVWM",
    "thumbnail": "https://i.ytimg.com/vi/_e9NeBqHVWM/mqdefault.jpg",
    "title": "【プチお披露目】2.0お正月衣装お披露目&ちょこ神様企画⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-01T18:23:40Z"
  },
  {
    "videoId": "hvZH7Fh4JqU",
    "thumbnail": "https://i.ytimg.com/vi/hvZH7Fh4JqU/mqdefault.jpg",
    "title": "【お正月企画】あけおめ逆凸⚡悪魔の誘惑凸待ち【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-02T12:39:42Z"
  },
  {
    "videoId": "TwgQFxAZF6A",
    "thumbnail": "https://i.ytimg.com/vi/TwgQFxAZF6A/mqdefault.jpg",
    "title": "【Minecraft】復活したい悪魔のレベリング耐久マイクラ⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-04T19:26:19Z"
  },
  {
    "videoId": "PBmiVhhKnN0",
    "thumbnail": "https://i.ytimg.com/vi/PBmiVhhKnN0/mqdefault.jpg",
    "title": "【マリオカート8DX】毎年最下位だけど強くなりたい悪魔のマリカ大会⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-07T05:34:33Z"
  },
  {
    "videoId": "e9ACfKW-zW0",
    "thumbnail": "https://i.ytimg.com/vi/e9ACfKW-zW0/mqdefault.jpg",
    "title": "【マリオカート8DX】元祖ザコ杯王悪魔のマリカ大会⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-07T07:31:06Z"
  },
  {
    "videoId": "DrOYSJaEGrQ",
    "thumbnail": "https://i.ytimg.com/vi/DrOYSJaEGrQ/mqdefault.jpg",
    "title": "【Freetalk】ちょこ先生からのお願いとお話し⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-07T11:09:40Z"
  },
  {
    "videoId": "2wypWkQBdOs",
    "thumbnail": "https://i.ytimg.com/vi/2wypWkQBdOs/mqdefault.jpg",
    "title": "【Minecraft】復活したい悪魔のレベリング耐久マイクラ最終回⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-08T14:19:49Z"
  },
  {
    "videoId": "FaNf9gh3kn8",
    "thumbnail": "https://i.ytimg.com/vi/FaNf9gh3kn8/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】火を使わない鶏肉のさっぱり煮作る⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-10T11:12:36Z"
  },
  {
    "videoId": "ooHGePRkMCw",
    "thumbnail": "https://i.ytimg.com/vi/ooHGePRkMCw/mqdefault.jpg",
    "title": "【ARK】０から始まるARK生活１日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-10T20:05:53Z"
  },
  {
    "videoId": "PkU99pRVI3I",
    "thumbnail": "https://i.ytimg.com/vi/PkU99pRVI3I/mqdefault.jpg",
    "title": "【ARK】０から始まるARK生活2日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-11T17:31:54Z"
  },
  {
    "videoId": "_4-GBdcWhHM",
    "thumbnail": "https://i.ytimg.com/vi/_4-GBdcWhHM/mqdefault.jpg",
    "title": "【APEX】Ollie様とAPEXデート⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-12T10:50:14Z"
  },
  {
    "videoId": "xHmPqvrRaHg",
    "thumbnail": "https://i.ytimg.com/vi/xHmPqvrRaHg/mqdefault.jpg",
    "title": "【ARK】０から始まるARK生活3日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-12T21:23:01Z"
  },
  {
    "videoId": "enA0W-Tkuho",
    "thumbnail": "https://i.ytimg.com/vi/enA0W-Tkuho/mqdefault.jpg",
    "title": "【Dead by Daylight】悪魔の女子会DBD⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-13T13:54:36Z"
  },
  {
    "videoId": "idgIG-3FCn0",
    "thumbnail": "https://i.ytimg.com/vi/idgIG-3FCn0/mqdefault.jpg",
    "title": "【ARK】０から始まるARK生活4日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-14T20:36:06Z"
  },
  {
    "videoId": "W92EfndgENM",
    "thumbnail": "https://i.ytimg.com/vi/W92EfndgENM/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】火を使わないボロネーゼソース作る⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-16T13:15:58Z"
  },
  {
    "videoId": "qIZFX7hfv78",
    "thumbnail": "https://i.ytimg.com/vi/qIZFX7hfv78/mqdefault.jpg",
    "title": "【ホロライブ身体測定】噂の風真いろは様診察いたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-19T11:19:21Z"
  },
  {
    "videoId": "g4oZ4TQYwSw",
    "thumbnail": "https://i.ytimg.com/vi/g4oZ4TQYwSw/mqdefault.jpg",
    "title": "【ARK】０から始まるARK生活5日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-21T18:58:33Z"
  },
  {
    "videoId": "YgGvenyER8w",
    "thumbnail": "https://i.ytimg.com/vi/YgGvenyER8w/mqdefault.jpg",
    "title": "【ARK】０から始まるARK生活6日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-23T17:54:18Z"
  },
  {
    "videoId": "YpU_GOF4-RQ",
    "thumbnail": "https://i.ytimg.com/vi/YpU_GOF4-RQ/mqdefault.jpg",
    "title": "【ホロライブ身体測定】博衣こより様診察いたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-25T11:05:39Z"
  },
  {
    "videoId": "1wBGvwuDK-g",
    "thumbnail": "https://i.ytimg.com/vi/1wBGvwuDK-g/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】火を使わない生姜焼き作る⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-26T06:18:29Z"
  },
  {
    "videoId": "MQ-QnXZR4mc",
    "thumbnail": "https://i.ytimg.com/vi/MQ-QnXZR4mc/mqdefault.jpg",
    "title": "【歌ってみた】神のまにまに/Covered by癒月ちょこ＆大空スバル＆姫森ルーナ【ホロライブ/オリジナルＭＶ】",
    "publishedAt": "2022-01-26T11:00:12Z"
  },
  {
    "videoId": "an2SuXL_Tf0",
    "thumbnail": "https://i.ytimg.com/vi/an2SuXL_Tf0/mqdefault.jpg",
    "title": "【重大告知あり！】スバちょこルーナ神になるの巻！【ホロライブ/癒月ちょこ/大空スバル/姫森ルーナ】",
    "publishedAt": "2022-01-26T11:07:59Z"
  },
  {
    "videoId": "GWiUjywN7iU",
    "thumbnail": "https://i.ytimg.com/vi/GWiUjywN7iU/mqdefault.jpg",
    "title": "【ホロライブ身体測定】鷹嶺ルイ様診察いたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-29T15:33:43Z"
  },
  {
    "videoId": "L81J7oGmdK8",
    "thumbnail": "https://i.ytimg.com/vi/L81J7oGmdK8/mqdefault.jpg",
    "title": "【雑談】深夜にMVを語る会【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-29T19:10:36Z"
  },
  {
    "videoId": "UnyuiAl7kfA",
    "thumbnail": "https://i.ytimg.com/vi/UnyuiAl7kfA/mqdefault.jpg",
    "title": "【ホロライブ身体測定】噂のラプラス・ダークネス様診察いたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-30T12:06:04Z"
  },
  {
    "videoId": "DAHF9o57nEE",
    "thumbnail": "https://i.ytimg.com/vi/DAHF9o57nEE/mqdefault.jpg",
    "title": "【郡道美玲】久々の対談？！美玲先生と今夜は呑むぞ！新年会【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-01-31T15:14:51Z"
  },
  {
    "videoId": "N3Jg3ghORiI",
    "thumbnail": "https://i.ytimg.com/vi/N3Jg3ghORiI/mqdefault.jpg",
    "title": "【ARK】０から始まるARK生活7日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-01T18:51:36Z"
  },
  {
    "videoId": "aw5oq5b_J3A",
    "thumbnail": "https://i.ytimg.com/vi/aw5oq5b_J3A/mqdefault.jpg",
    "title": "【告知もあります】突然ですが、お披露目です！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-04T10:55:12Z"
  },
  {
    "videoId": "ZNsxrhPIzlE",
    "thumbnail": "https://i.ytimg.com/vi/ZNsxrhPIzlE/mqdefault.jpg",
    "title": "【ARK】０から始まるARK生活８日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-04T18:51:50Z"
  },
  {
    "videoId": "s51GMXaR-Y8",
    "thumbnail": "https://i.ytimg.com/vi/s51GMXaR-Y8/mqdefault.jpg",
    "title": "【APEX】寝起き悪魔のゴールド耐久APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-06T15:16:11Z"
  },
  {
    "videoId": "G--3gY8_NwI",
    "thumbnail": "https://i.ytimg.com/vi/G--3gY8_NwI/mqdefault.jpg",
    "title": "【あにまーれ/宗谷いちか】もしも私が○○だったら対談企画【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-07T12:16:22Z"
  },
  {
    "videoId": "1n-jdbcH30Y",
    "thumbnail": "https://i.ytimg.com/vi/1n-jdbcH30Y/mqdefault.jpg",
    "title": "【ARK】０から始まるARK生活9日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-07T23:11:57Z"
  },
  {
    "videoId": "7G6fjOfg-Dw",
    "thumbnail": "https://i.ytimg.com/vi/7G6fjOfg-Dw/mqdefault.jpg",
    "title": "【APEX】すばちょこるなたん全肯定APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-09T14:10:08Z"
  },
  {
    "videoId": "hf489GLpSrw",
    "thumbnail": "https://i.ytimg.com/vi/hf489GLpSrw/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】久々に火を使って筑前煮作る⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-10T11:55:58Z"
  },
  {
    "videoId": "ixAzubfUdfI",
    "thumbnail": "https://i.ytimg.com/vi/ixAzubfUdfI/mqdefault.jpg",
    "title": "【ARK】０から始まるARK生活10日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-11T20:34:10Z"
  },
  {
    "videoId": "vsFmWYe-SiA",
    "thumbnail": "https://i.ytimg.com/vi/vsFmWYe-SiA/mqdefault.jpg",
    "title": "【ASMR】お誕生日カウントダウン【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-13T16:46:05Z"
  },
  {
    "videoId": "e-mI0HJr3VA",
    "thumbnail": "https://i.ytimg.com/vi/e-mI0HJr3VA/mqdefault.jpg",
    "title": "【original】SecretClass/癒月ちょこ【ホロライブ】",
    "publishedAt": "2022-02-14T12:00:16Z"
  },
  {
    "videoId": "uHtWZbAu7iE",
    "thumbnail": "https://i.ytimg.com/vi/uHtWZbAu7iE/mqdefault.jpg",
    "title": "【＃癒月ちょこ誕生日LIVE】重大告知あり？！3Dお誕生日ライブ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-14T12:15:23Z"
  },
  {
    "videoId": "WUBohLaaM7E",
    "thumbnail": "https://i.ytimg.com/vi/WUBohLaaM7E/mqdefault.jpg",
    "title": "【雑談】深夜のライブ振り返りtalk【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-15T18:13:35Z"
  },
  {
    "videoId": "3_Tmw_JNso4",
    "thumbnail": "https://i.ytimg.com/vi/3_Tmw_JNso4/mqdefault.jpg",
    "title": "【#Apex3周年デュオ】ロボ子先輩とデュオカスタム参戦！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-16T13:33:12Z"
  },
  {
    "videoId": "1CwISXBS7VE",
    "thumbnail": "https://i.ytimg.com/vi/1CwISXBS7VE/mqdefault.jpg",
    "title": "【#スバちょこルーナ】重大告知あり？！スバちょこルーナクッキング⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-17T11:19:53Z"
  },
  {
    "videoId": "OLMYvZ2ONjI",
    "thumbnail": "https://i.ytimg.com/vi/OLMYvZ2ONjI/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】深夜に手羽中の照り焼き作る⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-18T17:54:36Z"
  },
  {
    "videoId": "6ws0wf5PQ6A",
    "thumbnail": "https://i.ytimg.com/vi/6ws0wf5PQ6A/mqdefault.jpg",
    "title": "【#りっちしょこら】ルイ様とハンバーグ作る⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-19T12:24:49Z"
  },
  {
    "videoId": "ht7_b_f8zCk",
    "thumbnail": "https://i.ytimg.com/vi/ht7_b_f8zCk/mqdefault.jpg",
    "title": "【ホロライブ身体測定】噂の沙花叉クロヱ様診察いたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-21T11:11:21Z"
  },
  {
    "videoId": "NgObxQE9PvI",
    "thumbnail": "https://i.ytimg.com/vi/NgObxQE9PvI/mqdefault.jpg",
    "title": "【APEX】深夜のゲリラAPEX練習⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-22T22:18:25Z"
  },
  {
    "videoId": "eC6QTyiU0eY",
    "thumbnail": "https://i.ytimg.com/vi/eC6QTyiU0eY/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】葉加瀬様とオムライス作る⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-23T12:36:09Z"
  },
  {
    "videoId": "FmFsU7X5J08",
    "thumbnail": "https://i.ytimg.com/vi/FmFsU7X5J08/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】カグラナナ様とハンバーグ作る⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-24T11:57:04Z"
  },
  {
    "videoId": "Zy6Vm8BTJLQ",
    "thumbnail": "https://i.ytimg.com/vi/Zy6Vm8BTJLQ/mqdefault.jpg",
    "title": "【freetalk】ちょこ先生はSecretClassのMV語りたい【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-24T16:27:54Z"
  },
  {
    "videoId": "A8KPlESwZ_k",
    "thumbnail": "https://i.ytimg.com/vi/A8KPlESwZ_k/mqdefault.jpg",
    "title": "【逆凸】スバちょこがちぃ検証逆凸企画【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-25T12:16:55Z"
  },
  {
    "videoId": "X5IYD35JZqQ",
    "thumbnail": "https://i.ytimg.com/vi/X5IYD35JZqQ/mqdefault.jpg",
    "title": "【House Flipper】汚部屋改造ちょこアクター⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-26T10:02:13Z"
  },
  {
    "videoId": "jl3Q5QKaVJ4",
    "thumbnail": "https://i.ytimg.com/vi/jl3Q5QKaVJ4/mqdefault.jpg",
    "title": "【Vampire Survivors】悪魔が挑む！神ゲークリア目指す⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-02-27T15:08:09Z"
  },
  {
    "videoId": "BpzBzgUtgTU",
    "thumbnail": "https://i.ytimg.com/vi/BpzBzgUtgTU/mqdefault.jpg",
    "title": "【Vampire Survivors】悪魔が挑む！寝起きクリア目指す！⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-03T03:30:52Z"
  },
  {
    "videoId": "0NDaG5c10iY",
    "thumbnail": "https://i.ytimg.com/vi/0NDaG5c10iY/mqdefault.jpg",
    "title": "【ARK】みんなでボス戦！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-03T14:13:17Z"
  },
  {
    "videoId": "mQp_uhn59OM",
    "thumbnail": "https://i.ytimg.com/vi/mQp_uhn59OM/mqdefault.jpg",
    "title": "【ARK】深夜のスピノ子育てする！！！！！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-07T19:36:27Z"
  },
  {
    "videoId": "mQhc6vX37Hg",
    "thumbnail": "https://i.ytimg.com/vi/mQhc6vX37Hg/mqdefault.jpg",
    "title": "【写るんです】恐怖の森の作者が送る和風ホラーゲームに悪魔が挑戦！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-08T17:08:24Z"
  },
  {
    "videoId": "6etELtHkkQY",
    "thumbnail": "https://i.ytimg.com/vi/6etELtHkkQY/mqdefault.jpg",
    "title": "【Dead by Daylight】貞子に会えるまで終われないDBD【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-10T12:51:38Z"
  },
  {
    "videoId": "L_FxFtQoI1M",
    "thumbnail": "https://i.ytimg.com/vi/L_FxFtQoI1M/mqdefault.jpg",
    "title": "【雑談】悪魔のサムネ作り配信【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-11T14:58:30Z"
  },
  {
    "videoId": "vtsxmqfEkP8",
    "thumbnail": "https://i.ytimg.com/vi/vtsxmqfEkP8/mqdefault.jpg",
    "title": "【ARK】深夜のボス戦準備！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-11T19:56:25Z"
  },
  {
    "videoId": "YeiJnvJWVgw",
    "thumbnail": "https://i.ytimg.com/vi/YeiJnvJWVgw/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストはマリン様⚡ルイ様とビーフストロガノフ作る！【ホロライブ/癒月ちょこ/鷹嶺ルイ/宝鐘マリン】",
    "publishedAt": "2022-03-12T11:54:46Z"
  },
  {
    "videoId": "Wnjc5_LqZ3k",
    "thumbnail": "https://i.ytimg.com/vi/Wnjc5_LqZ3k/mqdefault.jpg",
    "title": "【APEX】寝起き悪魔のプラチナ耐久APEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-13T15:15:25Z"
  },
  {
    "videoId": "SJ0bsz-lOO4",
    "thumbnail": "https://i.ytimg.com/vi/SJ0bsz-lOO4/mqdefault.jpg",
    "title": "【APEX】悪魔のプラチナ耐久リベンジAPEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-14T13:58:06Z"
  },
  {
    "videoId": "vE-lilRtRiM",
    "thumbnail": "https://i.ytimg.com/vi/vE-lilRtRiM/mqdefault.jpg",
    "title": "【ARK】有識者求む！深夜のアーティファクト巡り！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-14T17:49:39Z"
  },
  {
    "videoId": "jouD15gF3zA",
    "thumbnail": "https://i.ytimg.com/vi/jouD15gF3zA/mqdefault.jpg",
    "title": "【ARK】みんなでボス戦！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-15T15:59:20Z"
  },
  {
    "videoId": "Px4SGa0_Ymk",
    "thumbnail": "https://i.ytimg.com/vi/Px4SGa0_Ymk/mqdefault.jpg",
    "title": "【雑談】ライブお疲れ様でした会【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-21T09:11:55Z"
  },
  {
    "videoId": "I5_EpkqRJaE",
    "thumbnail": "https://i.ytimg.com/vi/I5_EpkqRJaE/mqdefault.jpg",
    "title": "【ARK】有識者求む！TEKステゴブリ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-21T13:01:50Z"
  },
  {
    "videoId": "qDPk1Xs1IfA",
    "thumbnail": "https://i.ytimg.com/vi/qDPk1Xs1IfA/mqdefault.jpg",
    "title": "【閉店事件】悪魔の恐怖のカフェバイト【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-25T17:00:40Z"
  },
  {
    "videoId": "qn8nkwCRlZM",
    "thumbnail": "https://i.ytimg.com/vi/qn8nkwCRlZM/mqdefault.jpg",
    "title": "【Within Skerry】怖くても立ち向かわなきゃいけない時がある…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-27T12:18:38Z"
  },
  {
    "videoId": "dtLUYHxSkBY",
    "thumbnail": "https://i.ytimg.com/vi/dtLUYHxSkBY/mqdefault.jpg",
    "title": "【#ゆるホロチームカート】ザコ杯1位の実力魅せてやんよ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-30T15:02:27Z"
  },
  {
    "videoId": "EB1q9C5wopc",
    "thumbnail": "https://i.ytimg.com/vi/EB1q9C5wopc/mqdefault.jpg",
    "title": "【バビロンズフォール】スバちょこるなたんでBABYLON'S FALLプレイ！！※ネタバレあり【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-03-31T12:03:46Z"
  },
  {
    "videoId": "Mns-MUjbNGQ",
    "thumbnail": "https://i.ytimg.com/vi/Mns-MUjbNGQ/mqdefault.jpg",
    "title": "【Core Keeper】神ゲーと聞きまして初見プレイ失礼いたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-01T12:37:48Z"
  },
  {
    "videoId": "vIToFaezbZk",
    "thumbnail": "https://i.ytimg.com/vi/vIToFaezbZk/mqdefault.jpg",
    "title": "【Core Keeper】スライムボス討伐目指す！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-02T18:45:13Z"
  },
  {
    "videoId": "Gk-swlED2jQ",
    "thumbnail": "https://i.ytimg.com/vi/Gk-swlED2jQ/mqdefault.jpg",
    "title": "【Core Keeper】虫たちを殲滅いたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-03T03:20:37Z"
  },
  {
    "videoId": "yAnMOSH9_9E",
    "thumbnail": "https://i.ytimg.com/vi/yAnMOSH9_9E/mqdefault.jpg",
    "title": "【Core Keeper】ゴブリン討伐！２％の確率耐久⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-04T23:29:07Z"
  },
  {
    "videoId": "DQcR46Ds0AU",
    "thumbnail": "https://i.ytimg.com/vi/DQcR46Ds0AU/mqdefault.jpg",
    "title": "【シン・クロニクル】一度きりの物語、悪魔の選択はいかに？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-06T20:57:49Z"
  },
  {
    "videoId": "RXGElgXU4RQ",
    "thumbnail": "https://i.ytimg.com/vi/RXGElgXU4RQ/mqdefault.jpg",
    "title": "【Core Keeper】１時間以内に資源拠点作り上げる⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-07T05:27:10Z"
  },
  {
    "videoId": "u4Jx08LejwQ",
    "thumbnail": "https://i.ytimg.com/vi/u4Jx08LejwQ/mqdefault.jpg",
    "title": "【Core Keeper】ちょろぼコラボ⚡ロボ子先輩に布教する！！！！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-07T17:35:07Z"
  },
  {
    "videoId": "FCjuchjIZ-M",
    "thumbnail": "https://i.ytimg.com/vi/FCjuchjIZ-M/mqdefault.jpg",
    "title": "【APEX】悪魔の寝起きAPEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-08T13:16:51Z"
  },
  {
    "videoId": "5v0oOp_0wOc",
    "thumbnail": "https://i.ytimg.com/vi/5v0oOp_0wOc/mqdefault.jpg",
    "title": "【Core Keeper】ついに悪魔の新エリア探索がはじまる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-10T21:41:30Z"
  },
  {
    "videoId": "AR0saRCV9qQ",
    "thumbnail": "https://i.ytimg.com/vi/AR0saRCV9qQ/mqdefault.jpg",
    "title": "【Core Keeper】悪魔が壁全部壊してあげますわ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-11T18:33:25Z"
  },
  {
    "videoId": "jfGf_9QsccA",
    "thumbnail": "https://i.ytimg.com/vi/jfGf_9QsccA/mqdefault.jpg",
    "title": "【#スバちょこるなたん】ある日、幼女になってしまったら…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-12T16:03:56Z"
  },
  {
    "videoId": "CnckFlBxw_c",
    "thumbnail": "https://i.ytimg.com/vi/CnckFlBxw_c/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストはスバル⚡ルイ様とオムライス作る！【ホロライブ/癒月ちょこ/鷹嶺ルイ/大空スバル】",
    "publishedAt": "2022-04-13T11:59:26Z"
  },
  {
    "videoId": "fm1yzAU5YTQ",
    "thumbnail": "https://i.ytimg.com/vi/fm1yzAU5YTQ/mqdefault.jpg",
    "title": "【Core Keeper】イースターイベント調査いたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-16T18:53:12Z"
  },
  {
    "videoId": "FTCPb_OtXXk",
    "thumbnail": "https://i.ytimg.com/vi/FTCPb_OtXXk/mqdefault.jpg",
    "title": "【Core Keeper】イースターイベント調査いたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-17T01:15:18Z"
  },
  {
    "videoId": "t_NF25JOaac",
    "thumbnail": "https://i.ytimg.com/vi/t_NF25JOaac/mqdefault.jpg",
    "title": "【Vampire Survivors】災害級悪魔の復活⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-18T07:29:51Z"
  },
  {
    "videoId": "TNMHRY3QhXc",
    "thumbnail": "https://i.ytimg.com/vi/TNMHRY3QhXc/mqdefault.jpg",
    "title": "【Apex】ロボ子先輩とゲリラランク参戦！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-19T14:33:44Z"
  },
  {
    "videoId": "r9oe4bGAygE",
    "thumbnail": "https://i.ytimg.com/vi/r9oe4bGAygE/mqdefault.jpg",
    "title": "【青鬼】あの伝説の恐怖のおいかけっこゲームクリア耐久⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-21T11:04:35Z"
  },
  {
    "videoId": "TAIG0eLvZho",
    "thumbnail": "https://i.ytimg.com/vi/TAIG0eLvZho/mqdefault.jpg",
    "title": "【Apex】悪魔のゲリラランク！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-23T09:42:02Z"
  },
  {
    "videoId": "OuCyUrBN2UQ",
    "thumbnail": "https://i.ytimg.com/vi/OuCyUrBN2UQ/mqdefault.jpg",
    "title": "【#スバちょこるなたん】スバル王になるのは誰だ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-04-26T14:47:36Z"
  },
  {
    "videoId": "a29JETIdv70",
    "thumbnail": "https://i.ytimg.com/vi/a29JETIdv70/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】ホロ寿司再現チャレンジ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-05-02T11:43:43Z"
  },
  {
    "videoId": "uGxsbArmFig",
    "thumbnail": "https://i.ytimg.com/vi/uGxsbArmFig/mqdefault.jpg",
    "title": "【#ういちょこ】まったりういちょこラジオ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-05-03T14:04:44Z"
  },
  {
    "videoId": "BkO3OZQCuq8",
    "thumbnail": "https://i.ytimg.com/vi/BkO3OZQCuq8/mqdefault.jpg",
    "title": "【Dead by Daylight】久々参戦！寝起き悪魔のDBD【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-05-05T07:24:21Z"
  },
  {
    "videoId": "MrubpNPqgAI",
    "thumbnail": "https://i.ytimg.com/vi/MrubpNPqgAI/mqdefault.jpg",
    "title": "【Core Keeper】虫スキンを求めて悪魔のボス召喚⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-05-07T12:28:30Z"
  },
  {
    "videoId": "2WTUzebQSeQ",
    "thumbnail": "https://i.ytimg.com/vi/2WTUzebQSeQ/mqdefault.jpg",
    "title": "【Freetalk】寝起き保健医の悪魔雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-05-11T10:15:56Z"
  },
  {
    "videoId": "e5UKKgAW9tQ",
    "thumbnail": "https://i.ytimg.com/vi/e5UKKgAW9tQ/mqdefault.jpg",
    "title": "【Apex】新シーズン初プレイ！寝起きAPEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-05-15T07:12:20Z"
  },
  {
    "videoId": "T7Vo9aqJ_bE",
    "thumbnail": "https://i.ytimg.com/vi/T7Vo9aqJ_bE/mqdefault.jpg",
    "title": "【Dead by Daylight】ゲリラ悪魔の深夜DBD【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-05-16T16:18:53Z"
  },
  {
    "videoId": "NLtpU0BXq4I",
    "thumbnail": "https://i.ytimg.com/vi/NLtpU0BXq4I/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】深夜に悪魔飯⚡鶏チャーシュー作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-05-18T16:59:07Z"
  },
  {
    "videoId": "vp1GCIHWqwI",
    "thumbnail": "https://i.ytimg.com/vi/vp1GCIHWqwI/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストはしぐれうい様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/しぐれうい】",
    "publishedAt": "2022-05-19T12:02:59Z"
  },
  {
    "videoId": "3oc-fcbyyog",
    "thumbnail": "https://i.ytimg.com/vi/3oc-fcbyyog/mqdefault.jpg",
    "title": "【Apex】ハイテンション悪魔のAPEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-05-21T15:39:24Z"
  },
  {
    "videoId": "pF2tEY0pQEo",
    "thumbnail": "https://i.ytimg.com/vi/pF2tEY0pQEo/mqdefault.jpg",
    "title": "【Is Simon There?】死の電話かかってくるってがちぃ？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-05-26T04:52:43Z"
  },
  {
    "videoId": "Gl72o28AGUU",
    "thumbnail": "https://i.ytimg.com/vi/Gl72o28AGUU/mqdefault.jpg",
    "title": "【Freetalk】寝起きの悪魔雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-05-29T11:15:08Z"
  },
  {
    "videoId": "qqjc6lTUnUQ",
    "thumbnail": "https://i.ytimg.com/vi/qqjc6lTUnUQ/mqdefault.jpg",
    "title": "【朝枠】早起き悪魔の奇跡の朝枠【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-05-29T22:56:43Z"
  },
  {
    "videoId": "5oOg7Y-u_2o",
    "thumbnail": "https://i.ytimg.com/vi/5oOg7Y-u_2o/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】腹ペコ悪魔が牛丼作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-05-31T06:16:12Z"
  },
  {
    "videoId": "db6-kpmkURo",
    "thumbnail": "https://i.ytimg.com/vi/db6-kpmkURo/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔の飯テロ！タンドリーチキン作る⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-06-01T16:31:58Z"
  },
  {
    "videoId": "LKyhtz0vK28",
    "thumbnail": "https://i.ytimg.com/vi/LKyhtz0vK28/mqdefault.jpg",
    "title": "【ARK】甦れ！立ち上がれ！悪魔の恐竜達よ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-06-03T03:45:17Z"
  },
  {
    "videoId": "eil89EDQqfc",
    "thumbnail": "https://i.ytimg.com/vi/eil89EDQqfc/mqdefault.jpg",
    "title": "【APEX】悪魔のAPEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-06-03T11:01:13Z"
  },
  {
    "videoId": "3b5CVjol0ws",
    "thumbnail": "https://i.ytimg.com/vi/3b5CVjol0ws/mqdefault.jpg",
    "title": "【４５ヶ月記念】日頃の感謝を込めてシチュエーションASMR【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-06-04T15:26:07Z"
  },
  {
    "videoId": "3n-pCqEuC5M",
    "thumbnail": "https://i.ytimg.com/vi/3n-pCqEuC5M/mqdefault.jpg",
    "title": "【座談会】４人で夢の国行ってきました！【ホロライブ/癒月ちょこ/大空スバル/鷹嶺ルイ/しぐれうい】",
    "publishedAt": "2022-06-05T14:12:43Z"
  },
  {
    "videoId": "Hl9Rsf5ErX0",
    "thumbnail": "https://i.ytimg.com/vi/Hl9Rsf5ErX0/mqdefault.jpg",
    "title": "【おじさんと遊ぼう】悪魔がおじさんのあしらい方教えてやんよ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-06-07T10:07:47Z"
  },
  {
    "videoId": "tuY8sxg3G0w",
    "thumbnail": "https://i.ytimg.com/vi/tuY8sxg3G0w/mqdefault.jpg",
    "title": "【Mother Simulator】癒月、子供ができました。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-06-16T06:38:37Z"
  },
  {
    "videoId": "rKaBtMtu81c",
    "thumbnail": "https://i.ytimg.com/vi/rKaBtMtu81c/mqdefault.jpg",
    "title": "【朝枠】早起き悪魔の開封朝枠！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-06-18T01:18:06Z"
  },
  {
    "videoId": "AIfruAEjv08",
    "thumbnail": "https://i.ytimg.com/vi/AIfruAEjv08/mqdefault.jpg",
    "title": "【APEX】寝起き悪魔の初めてのAPEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-06-22T04:58:08Z"
  },
  {
    "videoId": "MdnwSOGGhLc",
    "thumbnail": "https://i.ytimg.com/vi/MdnwSOGGhLc/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは桃鈴ねね様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/桃鈴ねね】",
    "publishedAt": "2022-06-23T12:46:45Z"
  },
  {
    "videoId": "SbA-n47r_jA",
    "thumbnail": "https://i.ytimg.com/vi/SbA-n47r_jA/mqdefault.jpg",
    "title": "【朝枠】早起き悪魔の奇跡の朝枠！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-06-30T02:27:14Z"
  },
  {
    "videoId": "UvUQ7tgslfA",
    "thumbnail": "https://i.ytimg.com/vi/UvUQ7tgslfA/mqdefault.jpg",
    "title": "【HoloCure】話題のファンメイドのゲーム悪魔が初見プレイ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-07-05T17:10:51Z"
  },
  {
    "videoId": "iKa7vv8oXkA",
    "thumbnail": "https://i.ytimg.com/vi/iKa7vv8oXkA/mqdefault.jpg",
    "title": "【HoloCure】話題のファンメイドのゲームクリア耐久！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-07-06T17:16:00Z"
  },
  {
    "videoId": "giOAJq58IJo",
    "thumbnail": "https://i.ytimg.com/vi/giOAJq58IJo/mqdefault.jpg",
    "title": "【#ちょこちゃまクッキング】はあちゃまがちょこ家襲来⚡【ホロライブ/癒月ちょこ/赤井はあと】",
    "publishedAt": "2022-07-08T12:59:33Z"
  },
  {
    "videoId": "ug3vUsMP3Vw",
    "thumbnail": "https://i.ytimg.com/vi/ug3vUsMP3Vw/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは天音かなた様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/天音かなた】",
    "publishedAt": "2022-07-16T11:37:11Z"
  },
  {
    "videoId": "IC6N1agollU",
    "thumbnail": "https://i.ytimg.com/vi/IC6N1agollU/mqdefault.jpg",
    "title": "【歌枠】滅びのバーストストリーム【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-07-17T16:01:00Z"
  },
  {
    "videoId": "fzJlKA2FuBY",
    "thumbnail": "https://i.ytimg.com/vi/fzJlKA2FuBY/mqdefault.jpg",
    "title": "【ARK】拠点同居していいってがちぃ？悪魔のARK配信【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-07-20T17:56:53Z"
  },
  {
    "videoId": "qxH3_Ue91QU",
    "thumbnail": "https://i.ytimg.com/vi/qxH3_Ue91QU/mqdefault.jpg",
    "title": "【Freetalk】先生とお話ししてみない？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-07-22T08:18:12Z"
  },
  {
    "videoId": "irimNFUdNiA",
    "thumbnail": "https://i.ytimg.com/vi/irimNFUdNiA/mqdefault.jpg",
    "title": "【プチお披露目あり】ただいま！悪魔の復帰枠【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-08-12T15:34:29Z"
  },
  {
    "videoId": "DbQ47KUF0Jc",
    "thumbnail": "https://i.ytimg.com/vi/DbQ47KUF0Jc/mqdefault.jpg",
    "title": "【CALL OF DUTY MOBILE】りっちしょこらでCoDモバイルコラボ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-08-15T12:43:55Z"
  },
  {
    "videoId": "25UwF1-JsaE",
    "thumbnail": "https://i.ytimg.com/vi/25UwF1-JsaE/mqdefault.jpg",
    "title": "【FOREWARNED】スバちょこるなたんで遺跡調査？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-08-16T14:37:50Z"
  },
  {
    "videoId": "SrGRGZzu2xE",
    "thumbnail": "https://i.ytimg.com/vi/SrGRGZzu2xE/mqdefault.jpg",
    "title": "【Freetalk】深夜の癒月診療所【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-08-18T18:49:53Z"
  },
  {
    "videoId": "i5nAdQLpOBw",
    "thumbnail": "https://i.ytimg.com/vi/i5nAdQLpOBw/mqdefault.jpg",
    "title": "【Rust】悪魔の保健医RUST初上陸？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-08-21T04:33:16Z"
  },
  {
    "videoId": "KEwYRlxuShc",
    "thumbnail": "https://i.ytimg.com/vi/KEwYRlxuShc/mqdefault.jpg",
    "title": "【Rust】RUST上陸２日目⚡悪魔は発展させたい【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-08-23T03:03:35Z"
  },
  {
    "videoId": "CaJqI97qowk",
    "thumbnail": "https://i.ytimg.com/vi/CaJqI97qowk/mqdefault.jpg",
    "title": "【Rust】RUST上陸3日目⚡悪魔はつよつよ物資がほしい【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-08-24T06:36:38Z"
  },
  {
    "videoId": "jR2hW_MnW6w",
    "thumbnail": "https://i.ytimg.com/vi/jR2hW_MnW6w/mqdefault.jpg",
    "title": "【Rust】RUST上陸4日目⚡悪魔はカードキーがほしい【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-08-25T02:31:40Z"
  },
  {
    "videoId": "nmul7fi4AkM",
    "thumbnail": "https://i.ytimg.com/vi/nmul7fi4AkM/mqdefault.jpg",
    "title": "【 Occult 】スバちょこるなたん で恐怖のかくれんぼゲームプレイする⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-08-26T13:01:00Z"
  },
  {
    "videoId": "w4qx-o1PfW8",
    "thumbnail": "https://i.ytimg.com/vi/w4qx-o1PfW8/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは白銀ノエル様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/白銀ノエル】",
    "publishedAt": "2022-08-26T15:21:32Z"
  },
  {
    "videoId": "Qk4cLtodEaY",
    "thumbnail": "https://i.ytimg.com/vi/Qk4cLtodEaY/mqdefault.jpg",
    "title": "【Rust】RUST上陸5日目⚡ちょろぼでオイルリグ挑戦【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-08-27T13:30:52Z"
  },
  {
    "videoId": "LlPW-utdUKc",
    "thumbnail": "https://i.ytimg.com/vi/LlPW-utdUKc/mqdefault.jpg",
    "title": "【Minecraft】夏祭り直前！ちょこ先生はダイヤが欲しい！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-08-28T03:53:08Z"
  },
  {
    "videoId": "m-ZNADlbJG8",
    "thumbnail": "https://i.ytimg.com/vi/m-ZNADlbJG8/mqdefault.jpg",
    "title": "【Minecraft】#ホロ鯖夏祭り 本番！癒月商店OPEN！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-08-29T13:06:55Z"
  },
  {
    "videoId": "-ByxMmDO1Gw",
    "thumbnail": "https://i.ytimg.com/vi/-ByxMmDO1Gw/mqdefault.jpg",
    "title": "【告知あり】まだまだ夏は終わらない！水着&浴衣お披露目！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-08-30T16:28:51Z"
  },
  {
    "videoId": "XKBbbN7M44E",
    "thumbnail": "https://i.ytimg.com/vi/XKBbbN7M44E/mqdefault.jpg",
    "title": "【#癒月ちょこ4周年LIVE】ちょこから感謝を込めて4周年3ＤLIVE‼【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-04T12:04:29Z"
  },
  {
    "videoId": "X8DuimcnAVA",
    "thumbnail": "https://i.ytimg.com/vi/X8DuimcnAVA/mqdefault.jpg",
    "title": "【original】NoDistance/癒月ちょこ【ホロライブ】",
    "publishedAt": "2022-09-04T15:00:14Z"
  },
  {
    "videoId": "tM4JpGSJ3OI",
    "thumbnail": "https://i.ytimg.com/vi/tM4JpGSJ3OI/mqdefault.jpg",
    "title": "【朝枠】4周年LIVE振り返り雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-05T03:58:31Z"
  },
  {
    "videoId": "yXgAQrKO9uw",
    "thumbnail": "https://i.ytimg.com/vi/yXgAQrKO9uw/mqdefault.jpg",
    "title": "【Rust】シーズン3開幕！RUST1日目⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-07T18:13:30Z"
  },
  {
    "videoId": "sm9q5YZRmoo",
    "thumbnail": "https://i.ytimg.com/vi/sm9q5YZRmoo/mqdefault.jpg",
    "title": "【Rust】RUST2日目⚡悪魔は銃が欲しい【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-08T05:00:44Z"
  },
  {
    "videoId": "i5MkSFpgLQk",
    "thumbnail": "https://i.ytimg.com/vi/i5MkSFpgLQk/mqdefault.jpg",
    "title": "【Rust】RUST3日目⚡悪魔は素材王になりたい【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-09T06:46:41Z"
  },
  {
    "videoId": "sT-mnirkbic",
    "thumbnail": "https://i.ytimg.com/vi/sT-mnirkbic/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは犬山たまき様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/犬山たまき】",
    "publishedAt": "2022-09-09T12:02:19Z"
  },
  {
    "videoId": "fOFtKO-_ZXg",
    "thumbnail": "https://i.ytimg.com/vi/fOFtKO-_ZXg/mqdefault.jpg",
    "title": "【Rust】RUST4日目⚡まつり様とオイルリグ攻略【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-10T10:19:27Z"
  },
  {
    "videoId": "GIGalMrQX_0",
    "thumbnail": "https://i.ytimg.com/vi/GIGalMrQX_0/mqdefault.jpg",
    "title": "【APEX】悪魔の敵を打ちたいAPEX【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-11T11:44:49Z"
  },
  {
    "videoId": "9mt3OwB1IVU",
    "thumbnail": "https://i.ytimg.com/vi/9mt3OwB1IVU/mqdefault.jpg",
    "title": "【Rust】RUST5日目⚡昨日１日ログインしなかったら。。。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-13T11:46:30Z"
  },
  {
    "videoId": "V0gSNAJCYpQ",
    "thumbnail": "https://i.ytimg.com/vi/V0gSNAJCYpQ/mqdefault.jpg",
    "title": "【Rust】RUST6日目⚡ちょこ先生の戦車ガチャ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-16T04:40:23Z"
  },
  {
    "videoId": "HxWmbWBsOgo",
    "thumbnail": "https://i.ytimg.com/vi/HxWmbWBsOgo/mqdefault.jpg",
    "title": "【Rust】ホロRUSTバトロワちょこ参戦！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-19T03:59:15Z"
  },
  {
    "videoId": "EHMKqWUr1uQ",
    "thumbnail": "https://i.ytimg.com/vi/EHMKqWUr1uQ/mqdefault.jpg",
    "title": "【DeadbyDaylight】寝起き悪魔の追いかけっこ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-21T04:06:35Z"
  },
  {
    "videoId": "8tjGr-Filas",
    "thumbnail": "https://i.ytimg.com/vi/8tjGr-Filas/mqdefault.jpg",
    "title": "【Apex】楽しみたい悪魔のAPEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-21T11:57:35Z"
  },
  {
    "videoId": "P2Ko3k8sAeA",
    "thumbnail": "https://i.ytimg.com/vi/P2Ko3k8sAeA/mqdefault.jpg",
    "title": "【Rust】RUST7日目⚡ちょこ先生は回復アイテム大量生産したい【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-25T21:30:13Z"
  },
  {
    "videoId": "HpuW7WB_-44",
    "thumbnail": "https://i.ytimg.com/vi/HpuW7WB_-44/mqdefault.jpg",
    "title": "【Rust】TeamA で打ち抜きたい🔫 #ホロRUSTチーム戦 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-26T15:39:28Z"
  },
  {
    "videoId": "AQTGxTAAWM8",
    "thumbnail": "https://i.ytimg.com/vi/AQTGxTAAWM8/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔飯⚡トンテキ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-09-28T13:47:39Z"
  },
  {
    "videoId": "4zkLXY0VWu8",
    "thumbnail": "https://i.ytimg.com/vi/4zkLXY0VWu8/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストはときのそら様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/ときのそら】",
    "publishedAt": "2022-09-29T11:51:46Z"
  },
  {
    "videoId": "3pe1-B-kP6Y",
    "thumbnail": "https://i.ytimg.com/vi/3pe1-B-kP6Y/mqdefault.jpg",
    "title": "【地獄銭湯】恐ろしい銭湯でも悪魔なら大丈夫だよね…？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-10-03T17:31:01Z"
  },
  {
    "videoId": "CIWuQLXx2dw",
    "thumbnail": "https://i.ytimg.com/vi/CIWuQLXx2dw/mqdefault.jpg",
    "title": "【Rust】RUST最終日⚡まつり様と全てを破壊する【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-10-06T15:44:03Z"
  },
  {
    "videoId": "C7IkthM28oA",
    "thumbnail": "https://i.ytimg.com/vi/C7IkthM28oA/mqdefault.jpg",
    "title": "【Freetalk】寝起き悪魔の朝活【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-10-10T03:12:08Z"
  },
  {
    "videoId": "ueWTsRqEpK4",
    "thumbnail": "https://i.ytimg.com/vi/ueWTsRqEpK4/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔飯⚡ピラフ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-10-12T10:32:15Z"
  },
  {
    "videoId": "OfooitOd6ek",
    "thumbnail": "https://i.ytimg.com/vi/OfooitOd6ek/mqdefault.jpg",
    "title": "【モンスターハンターライズ】人生初めてのモンハン始めます！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-10-15T15:30:18Z"
  },
  {
    "videoId": "xaJDsMZzO1g",
    "thumbnail": "https://i.ytimg.com/vi/xaJDsMZzO1g/mqdefault.jpg",
    "title": "【モンスターハンターライズ】悪魔の人生初めてのモンハン2日目！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-10-16T08:37:52Z"
  },
  {
    "videoId": "o4PkoWq1KSE",
    "thumbnail": "https://i.ytimg.com/vi/o4PkoWq1KSE/mqdefault.jpg",
    "title": "【モンスターハンターライズ】人生初めてのモンハン3日目！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-10-17T06:22:31Z"
  },
  {
    "videoId": "SuXlanL5Cl0",
    "thumbnail": "https://i.ytimg.com/vi/SuXlanL5Cl0/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔飯⚡豚しぐれ煮作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-10-18T14:11:38Z"
  },
  {
    "videoId": "SThmZoqBmt8",
    "thumbnail": "https://i.ytimg.com/vi/SThmZoqBmt8/mqdefault.jpg",
    "title": "【モンスターハンターライズ】人生初めてのモンハン4日目！里クエ全クリ目指す！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-10-21T18:19:18Z"
  },
  {
    "videoId": "h03E4Kfdk-g",
    "thumbnail": "https://i.ytimg.com/vi/h03E4Kfdk-g/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストはアキロゼ様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/アキロゼ】",
    "publishedAt": "2022-10-23T13:28:56Z"
  },
  {
    "videoId": "s1ITxje7sa4",
    "thumbnail": "https://i.ytimg.com/vi/s1ITxje7sa4/mqdefault.jpg",
    "title": "【Freetalk】最近のちょこ事情【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-10-29T15:54:51Z"
  },
  {
    "videoId": "FjxVYxF5_7o",
    "thumbnail": "https://i.ytimg.com/vi/FjxVYxF5_7o/mqdefault.jpg",
    "title": "【#ホロ赤組】ホロライブ運動会赤組練習会参加するわよ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-10-31T13:44:05Z"
  },
  {
    "videoId": "h1EhR56V82Y",
    "thumbnail": "https://i.ytimg.com/vi/h1EhR56V82Y/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔飯⚡テーマはハロウィン【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-10-31T17:05:24Z"
  },
  {
    "videoId": "ABInVSJOTq0",
    "thumbnail": "https://i.ytimg.com/vi/ABInVSJOTq0/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔飯⚡フレア様おもてなしする！【ホロライブ/癒月ちょこ/不知火フレア】",
    "publishedAt": "2022-11-04T11:55:05Z"
  },
  {
    "videoId": "pjG1qrkZy6M",
    "thumbnail": "https://i.ytimg.com/vi/pjG1qrkZy6M/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔飯⚡ぺこら様おもてなしする！【ホロライブ/癒月ちょこ/兎田ぺこら】",
    "publishedAt": "2022-11-07T06:37:40Z"
  },
  {
    "videoId": "z157Hy5UJjs",
    "thumbnail": "https://i.ytimg.com/vi/z157Hy5UJjs/mqdefault.jpg",
    "title": "【モンスターハンターライズ】人生初めてのモンハン5日目！キーマウ操作最強目指す！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-11-09T16:54:13Z"
  },
  {
    "videoId": "uvmPPxUKkw4",
    "thumbnail": "https://i.ytimg.com/vi/uvmPPxUKkw4/mqdefault.jpg",
    "title": "【にじさんじ身体測定】​ ルイス・キャミー 様診察いたします！ 【ホロライブ/癒月ちょこ/ルイス・キャミー】",
    "publishedAt": "2022-11-10T11:01:15Z"
  },
  {
    "videoId": "fc5abaFMOC4",
    "thumbnail": "https://i.ytimg.com/vi/fc5abaFMOC4/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔飯⚡ハンバーグが食べたい！【ホロライブ/癒月ちょこ/赤井はあと】",
    "publishedAt": "2022-11-12T10:49:01Z"
  },
  {
    "videoId": "B4pTsG1-a_0",
    "thumbnail": "https://i.ytimg.com/vi/B4pTsG1-a_0/mqdefault.jpg",
    "title": "【モンスターハンターライズ】人生初めてのモンハン6日目！猛者求む！集会クエRTA！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-11-14T15:19:33Z"
  },
  {
    "videoId": "ag-hg6D-OjU",
    "thumbnail": "https://i.ytimg.com/vi/ag-hg6D-OjU/mqdefault.jpg",
    "title": "【Freetalk】あやみ先生とお絵描き雑談コラボ【ホロライブ/癒月ちょこ/あやみ】",
    "publishedAt": "2022-11-15T11:43:51Z"
  },
  {
    "videoId": "tNd79DbzyVk",
    "thumbnail": "https://i.ytimg.com/vi/tNd79DbzyVk/mqdefault.jpg",
    "title": "【公認ミラー配信】モンスターハンターライズ：サンブレイクの新情報一緒に見守るわよ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-11-16T14:34:30Z"
  },
  {
    "videoId": "I2vpZ1Dojgw",
    "thumbnail": "https://i.ytimg.com/vi/I2vpZ1Dojgw/mqdefault.jpg",
    "title": "【Freetalk】悪魔の保健医の奇跡の朝枠【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-11-17T01:15:45Z"
  },
  {
    "videoId": "stzIhrwenJQ",
    "thumbnail": "https://i.ytimg.com/vi/stzIhrwenJQ/mqdefault.jpg",
    "title": "【ポケットモンスター スカーレット】悪魔の草むらレベル上げRTA目指す！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-11-19T10:30:17Z"
  },
  {
    "videoId": "ZoL7ZTJ2t0Q",
    "thumbnail": "https://i.ytimg.com/vi/ZoL7ZTJ2t0Q/mqdefault.jpg",
    "title": "【ポケットモンスター スカーレット】悪魔の草むらレベル上げ配信！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-11-19T16:23:09Z"
  },
  {
    "videoId": "Bw7yCKz2bCI",
    "thumbnail": "https://i.ytimg.com/vi/Bw7yCKz2bCI/mqdefault.jpg",
    "title": "【にじさんじ身体測定】​竜胆 尊様診察いたします！ 【ホロライブ/癒月ちょこ/竜胆尊】",
    "publishedAt": "2022-11-21T11:13:16Z"
  },
  {
    "videoId": "-Bm-Opm55fA",
    "thumbnail": "https://i.ytimg.com/vi/-Bm-Opm55fA/mqdefault.jpg",
    "title": "【ポケットモンスター スカーレット】悪魔の草むらレベル上げ配信！２日目！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-11-21T16:22:07Z"
  },
  {
    "videoId": "nqMQj4ibNo0",
    "thumbnail": "https://i.ytimg.com/vi/nqMQj4ibNo0/mqdefault.jpg",
    "title": "【ポケットモンスター スカーレット】悪魔の草むらレベル上げ配信！３日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-11-23T18:40:13Z"
  },
  {
    "videoId": "RfsOWmdfs5Q",
    "thumbnail": "https://i.ytimg.com/vi/RfsOWmdfs5Q/mqdefault.jpg",
    "title": "【ポケットモンスター スカーレット】悪魔の草むらレベル上げ配信！4日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-11-24T07:21:21Z"
  },
  {
    "videoId": "29TshmkbdBs",
    "thumbnail": "https://i.ytimg.com/vi/29TshmkbdBs/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは戌神ころね様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/戌神ころね】",
    "publishedAt": "2022-11-24T11:38:48Z"
  },
  {
    "videoId": "2EIlQCL9gSg",
    "thumbnail": "https://i.ytimg.com/vi/2EIlQCL9gSg/mqdefault.jpg",
    "title": "【ポケットモンスター スカーレット】悪魔の草むらレベル上げ配信！5日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-11-27T09:51:20Z"
  },
  {
    "videoId": "C8BtXS1DHbM",
    "thumbnail": "https://i.ytimg.com/vi/C8BtXS1DHbM/mqdefault.jpg",
    "title": "【ポケットモンスター スカーレット】悪魔の草むらレベル上げ配信！6日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-11-28T02:04:18Z"
  },
  {
    "videoId": "4Ku1ExpcqoU",
    "thumbnail": "https://i.ytimg.com/vi/4Ku1ExpcqoU/mqdefault.jpg",
    "title": "【ホロライブEN身体測定】Mori Calliope様診察いたします！ 【ホロライブ/癒月ちょこ/Mori Calliope】",
    "publishedAt": "2022-11-30T06:01:39Z"
  },
  {
    "videoId": "9gZT0bnZzsQ",
    "thumbnail": "https://i.ytimg.com/vi/9gZT0bnZzsQ/mqdefault.jpg",
    "title": "【ポケットモンスター スカーレット】悪魔の草むらレベル上げ配信！7日目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-11-30T11:13:26Z"
  },
  {
    "videoId": "YNBLWdyase0",
    "thumbnail": "https://i.ytimg.com/vi/YNBLWdyase0/mqdefault.jpg",
    "title": "【#りっちしょこら】今回はEXPO特別版⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/友人A】",
    "publishedAt": "2022-12-01T13:02:39Z"
  },
  {
    "videoId": "NweX1dGMkr4",
    "thumbnail": "https://i.ytimg.com/vi/NweX1dGMkr4/mqdefault.jpg",
    "title": "【ポケットモンスター スカーレット】悪魔の100レべで殴るワンパンジム戦！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-12-04T14:42:56Z"
  },
  {
    "videoId": "nE8RYllu300",
    "thumbnail": "https://i.ytimg.com/vi/nE8RYllu300/mqdefault.jpg",
    "title": "【ポケットモンスター スカーレット】悪魔の100レべでカチコミ！スター団戦！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-12-05T18:39:45Z"
  },
  {
    "videoId": "7IUe0P3mzgs",
    "thumbnail": "https://i.ytimg.com/vi/7IUe0P3mzgs/mqdefault.jpg",
    "title": "【ポケットモンスター スカーレット】今日ですべてを終わらそう。レベル１００で挑むエリアゼロ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-12-09T17:37:30Z"
  },
  {
    "videoId": "c7dRGluCRuI",
    "thumbnail": "https://i.ytimg.com/vi/c7dRGluCRuI/mqdefault.jpg",
    "title": "【ホロライブ身体測定】AZKi様診察いたします！ 【ホロライブ/癒月ちょこ/AZKi】",
    "publishedAt": "2022-12-15T14:03:41Z"
  },
  {
    "videoId": "dkEP_R1MRXM",
    "thumbnail": "https://i.ytimg.com/vi/dkEP_R1MRXM/mqdefault.jpg",
    "title": "【スプラトゥーン3】初心者悪魔のよちよちスプラ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-12-16T18:52:35Z"
  },
  {
    "videoId": "VHLDnrER70I",
    "thumbnail": "https://i.ytimg.com/vi/VHLDnrER70I/mqdefault.jpg",
    "title": "【スプラトゥーン3】フレア様と一緒！初心者悪魔のよちよちスプラ【ホロライブ/癒月ちょこ/不知火フレア】",
    "publishedAt": "2022-12-19T17:33:40Z"
  },
  {
    "videoId": "bFeYFq42oiE",
    "thumbnail": "https://i.ytimg.com/vi/bFeYFq42oiE/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは角巻わため様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/角巻わため】",
    "publishedAt": "2022-12-20T13:55:09Z"
  },
  {
    "videoId": "y41q06WzctU",
    "thumbnail": "https://i.ytimg.com/vi/y41q06WzctU/mqdefault.jpg",
    "title": "【#ホロクリスマス歌枠リレー】クリスマスの滅びのバーストストリーム【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-12-25T06:42:10Z"
  },
  {
    "videoId": "7Tkx2XWNuXg",
    "thumbnail": "https://i.ytimg.com/vi/7Tkx2XWNuXg/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】ジェノベーゼ⚡鶏肉のマーマレード焼き【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-12-25T14:20:53Z"
  },
  {
    "videoId": "eIZDrfkf2bM",
    "thumbnail": "https://i.ytimg.com/vi/eIZDrfkf2bM/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】ハンバーグ作る！！！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2022-12-27T03:18:34Z"
  },
  {
    "videoId": "TFnrd-1M8FY",
    "thumbnail": "https://i.ytimg.com/vi/TFnrd-1M8FY/mqdefault.jpg",
    "title": "【#メルキス企業案件】とある企業からお手紙！？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-01-22T10:49:52Z"
  },
  {
    "videoId": "3Q3-NQlvZNM",
    "thumbnail": "https://i.ytimg.com/vi/3Q3-NQlvZNM/mqdefault.jpg",
    "title": "【#ひろがるホロライブ】すばちょこるなたんで谷郷社長作ってみる【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-01-25T12:56:11Z"
  },
  {
    "videoId": "rU30OF2oDVg",
    "thumbnail": "https://i.ytimg.com/vi/rU30OF2oDVg/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストはさくらみこ様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/さくらみこ】",
    "publishedAt": "2023-01-27T12:57:48Z"
  },
  {
    "videoId": "a48E5QnNa5E",
    "thumbnail": "https://i.ytimg.com/vi/a48E5QnNa5E/mqdefault.jpg",
    "title": "【あけおめ】今年初ソロ配信！ちょこ神様が占います！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-01-27T16:38:18Z"
  },
  {
    "videoId": "L1yB_nIixhw",
    "thumbnail": "https://i.ytimg.com/vi/L1yB_nIixhw/mqdefault.jpg",
    "title": "【Freetalk】悪魔の保健医の深夜雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-01-31T16:20:04Z"
  },
  {
    "videoId": "esvHF88NBz8",
    "thumbnail": "https://i.ytimg.com/vi/esvHF88NBz8/mqdefault.jpg",
    "title": "【マリカ8DX】ざこ王４連覇の神走りに見惚れな【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-02-04T10:29:07Z"
  },
  {
    "videoId": "B8qaByLawPk",
    "thumbnail": "https://i.ytimg.com/vi/B8qaByLawPk/mqdefault.jpg",
    "title": "【凸待ち】悪魔の保健医のお誕生日凸待ち【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-02-13T16:30:07Z"
  },
  {
    "videoId": "r8DrUubFFCQ",
    "thumbnail": "https://i.ytimg.com/vi/r8DrUubFFCQ/mqdefault.jpg",
    "title": "【＃癒月ちょこ生誕祭2023】ちょこ先生はてぇてぇに囲まれたい【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-02-14T12:12:06Z"
  },
  {
    "videoId": "LSIcyZbofnE",
    "thumbnail": "https://i.ytimg.com/vi/LSIcyZbofnE/mqdefault.jpg",
    "title": "【original】Sickbay Mistake/癒月ちょこ【ホロライブ】",
    "publishedAt": "2023-02-14T15:00:09Z"
  },
  {
    "videoId": "icQTySriCbk",
    "thumbnail": "https://i.ytimg.com/vi/icQTySriCbk/mqdefault.jpg",
    "title": "【Freetalk】ちょこ先生は語りたい【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-02-15T11:02:35Z"
  },
  {
    "videoId": "lfIwaRSlFH0",
    "thumbnail": "https://i.ytimg.com/vi/lfIwaRSlFH0/mqdefault.jpg",
    "title": "【HoloCure】ちょこ最強説あるってがちぃ？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-02-17T16:48:34Z"
  },
  {
    "videoId": "WbASChCsAj4",
    "thumbnail": "https://i.ytimg.com/vi/WbASChCsAj4/mqdefault.jpg",
    "title": "【APEX】KUREIJI ARCADE/ HOLO APEX祭楽しむわよ！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-02-18T12:18:12Z"
  },
  {
    "videoId": "g-YXiueVRw0",
    "thumbnail": "https://i.ytimg.com/vi/g-YXiueVRw0/mqdefault.jpg",
    "title": "【Apex】お久しぶりの悪魔のAPEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-02-20T11:52:57Z"
  },
  {
    "videoId": "Gal9_exxQu0",
    "thumbnail": "https://i.ytimg.com/vi/Gal9_exxQu0/mqdefault.jpg",
    "title": "【オフコラボ】Hakos様にJP先生コンビがお菓子作り指導⁈無事完成なるか！【ホロライブ/癒月ちょこ/Hakos Baelz/風真いろは】",
    "publishedAt": "2023-02-21T15:03:13Z"
  },
  {
    "videoId": "mhiV-J3c5_I",
    "thumbnail": "https://i.ytimg.com/vi/mhiV-J3c5_I/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔の保健医！フレア様を茄子料理でおもてなしするの巻！【ホロライブ/癒月ちょこ/不知火フレア】",
    "publishedAt": "2023-02-23T12:06:12Z"
  },
  {
    "videoId": "S4rR97dXd3Q",
    "thumbnail": "https://i.ytimg.com/vi/S4rR97dXd3Q/mqdefault.jpg",
    "title": "【HoloCure】ちょこに酔いしれな？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-03-09T09:28:04Z"
  },
  {
    "videoId": "elcv_Ub9mD0",
    "thumbnail": "https://i.ytimg.com/vi/elcv_Ub9mD0/mqdefault.jpg",
    "title": "【Freetalk】ちょこ先生は熱く語りたい。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-03-20T12:28:34Z"
  },
  {
    "videoId": "BJPTC0AyVZ0",
    "thumbnail": "https://i.ytimg.com/vi/BJPTC0AyVZ0/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔レシピ！大葉チーズの豚肉包み作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-03-22T10:56:57Z"
  },
  {
    "videoId": "IKg79jf3LH0",
    "thumbnail": "https://i.ytimg.com/vi/IKg79jf3LH0/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】EXPO&アレンジレシピ！チーズinハンバーグ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-03-23T11:57:29Z"
  },
  {
    "videoId": "RTdiewixwok",
    "thumbnail": "https://i.ytimg.com/vi/RTdiewixwok/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは猫又おかゆ様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/猫又おかゆ】",
    "publishedAt": "2023-03-29T12:51:50Z"
  },
  {
    "videoId": "p6hAYKguiHU",
    "thumbnail": "https://i.ytimg.com/vi/p6hAYKguiHU/mqdefault.jpg",
    "title": "【Minecraft】マイクラ新鯖どこですか！悪魔の大冒険！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-04-05T16:27:34Z"
  },
  {
    "videoId": "b3cYcEUJXmY",
    "thumbnail": "https://i.ytimg.com/vi/b3cYcEUJXmY/mqdefault.jpg",
    "title": "【Minecraft】エンダーマンを探せ！悪魔の大冒険！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-04-11T12:38:32Z"
  },
  {
    "videoId": "CxKYlKoxWaE",
    "thumbnail": "https://i.ytimg.com/vi/CxKYlKoxWaE/mqdefault.jpg",
    "title": "【#癒月ちょこ新衣装】2年ぶりの悪魔の新衣装お披露目【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-05-02T11:14:20Z"
  },
  {
    "videoId": "Rwkpp4-NBAk",
    "thumbnail": "https://i.ytimg.com/vi/Rwkpp4-NBAk/mqdefault.jpg",
    "title": "【Minecraft】ロマンを作れ！覗き露天風呂作り！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-05-03T14:49:23Z"
  },
  {
    "videoId": "KhU7vxlD94U",
    "thumbnail": "https://i.ytimg.com/vi/KhU7vxlD94U/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】愛園愛美様をおもてなし！ビーフストロガノフ作る！！【ホロライブ/癒月ちょこ/愛園愛美】",
    "publishedAt": "2023-05-04T11:34:55Z"
  },
  {
    "videoId": "FRV7-xf5WoE",
    "thumbnail": "https://i.ytimg.com/vi/FRV7-xf5WoE/mqdefault.jpg",
    "title": "【Apex】ちょこ先生は寝起きだけど久々にぶちかましたい⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-05-07T12:26:29Z"
  },
  {
    "videoId": "AeKr9mUQPgg",
    "thumbnail": "https://i.ytimg.com/vi/AeKr9mUQPgg/mqdefault.jpg",
    "title": "【Freetalk】深夜にちょこ先生は話したい【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-05-13T15:30:40Z"
  },
  {
    "videoId": "G1htm1WZ5-U",
    "thumbnail": "https://i.ytimg.com/vi/G1htm1WZ5-U/mqdefault.jpg",
    "title": "【DeadbyDaylight】寝起き悪魔の追いかけっこ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-05-19T04:43:55Z"
  },
  {
    "videoId": "L1ic2FHgC7I",
    "thumbnail": "https://i.ytimg.com/vi/L1ic2FHgC7I/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは獅白ぼたん様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/獅白ぼたん】",
    "publishedAt": "2023-05-25T10:59:32Z"
  },
  {
    "videoId": "bf5sTdQ5No8",
    "thumbnail": "https://i.ytimg.com/vi/bf5sTdQ5No8/mqdefault.jpg",
    "title": "【Hooked on You: A Dead by Daylight Dating Sim™】DBDの恋愛ゲーム初見プレイする！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-05-28T19:29:59Z"
  },
  {
    "videoId": "l50JLdCPZjE",
    "thumbnail": "https://i.ytimg.com/vi/l50JLdCPZjE/mqdefault.jpg",
    "title": "【DeadbyDaylight】夜ふかし悪魔の追いかけっこ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-05-30T17:14:23Z"
  },
  {
    "videoId": "wGE0FsJfqo0",
    "thumbnail": "https://i.ytimg.com/vi/wGE0FsJfqo0/mqdefault.jpg",
    "title": "【朝枠】悪魔の保健医の奇跡の朝枠【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-01T00:33:16Z"
  },
  {
    "videoId": "2OoxK11HH8g",
    "thumbnail": "https://i.ytimg.com/vi/2OoxK11HH8g/mqdefault.jpg",
    "title": "【獄門ペンギン】悪魔の保健医の脱獄劇！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-02T09:10:37Z"
  },
  {
    "videoId": "E9w5Q38iw3Y",
    "thumbnail": "https://i.ytimg.com/vi/E9w5Q38iw3Y/mqdefault.jpg",
    "title": "【朝枠】悪魔の保健医の余裕の朝枠【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-03T01:01:35Z"
  },
  {
    "videoId": "IxBFZj_zDiM",
    "thumbnail": "https://i.ytimg.com/vi/IxBFZj_zDiM/mqdefault.jpg",
    "title": "【真砂楼】廃業旅館に寝起きに侵入？！最恐ホラーに挑む！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-04T06:18:50Z"
  },
  {
    "videoId": "ko-nEyRX_90",
    "thumbnail": "https://i.ytimg.com/vi/ko-nEyRX_90/mqdefault.jpg",
    "title": "【朝枠】悪魔の保健医の朝礼【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-05T01:23:32Z"
  },
  {
    "videoId": "LA9qiFJ6mZ4",
    "thumbnail": "https://i.ytimg.com/vi/LA9qiFJ6mZ4/mqdefault.jpg",
    "title": "【フードデリバリーサービス】悪魔の保健医のデリバリサービス【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-05T16:05:22Z"
  },
  {
    "videoId": "WaIYplJ5V1g",
    "thumbnail": "https://i.ytimg.com/vi/WaIYplJ5V1g/mqdefault.jpg",
    "title": "【Apex】寝起き悪魔のAPEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-06T04:07:31Z"
  },
  {
    "videoId": "vT6NNd-UH4A",
    "thumbnail": "https://i.ytimg.com/vi/vT6NNd-UH4A/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】悪魔の保健医のお昼ご飯作り【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-07T05:39:54Z"
  },
  {
    "videoId": "yVocxBHOkXU",
    "thumbnail": "https://i.ytimg.com/vi/yVocxBHOkXU/mqdefault.jpg",
    "title": "【DeadbyDaylight】早起き悪魔の追いかけっこ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-07T12:49:45Z"
  },
  {
    "videoId": "N1ZSkmk2z-4",
    "thumbnail": "https://i.ytimg.com/vi/N1ZSkmk2z-4/mqdefault.jpg",
    "title": "【DeadbyDaylight】トワ様と悪魔の追いかけっこする！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-08T13:00:56Z"
  },
  {
    "videoId": "50hB_1aX0UQ",
    "thumbnail": "https://i.ytimg.com/vi/50hB_1aX0UQ/mqdefault.jpg",
    "title": "【#スバちょこるなたん】姫森ルーナについて語る会【癒月ちょこ/ホロライブ】",
    "publishedAt": "2023-06-08T15:10:42Z"
  },
  {
    "videoId": "Qau5DmaNq7Q",
    "thumbnail": "https://i.ytimg.com/vi/Qau5DmaNq7Q/mqdefault.jpg",
    "title": "【朝枠】寝起き悪魔のお目覚め雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-11T09:54:44Z"
  },
  {
    "videoId": "RqiyROsrZuU",
    "thumbnail": "https://i.ytimg.com/vi/RqiyROsrZuU/mqdefault.jpg",
    "title": "【Untitled Goose Game】いたずらの天才悪魔現れる？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-12T09:57:19Z"
  },
  {
    "videoId": "Z4OGadyN61k",
    "thumbnail": "https://i.ytimg.com/vi/Z4OGadyN61k/mqdefault.jpg",
    "title": "【歌ってみた】光るなら/Covered by癒月ちょこ＆大空スバル＆姫森ルーナ＆獅白ぼたん【ホロライブ/スバちょこるなたん】",
    "publishedAt": "2023-06-13T12:00:12Z"
  },
  {
    "videoId": "UGSevriWz2c",
    "thumbnail": "https://i.ytimg.com/vi/UGSevriWz2c/mqdefault.jpg",
    "title": "【Paranormal Cleanup】#スバちょこるなたん お化け屋敷でゴミ掃除するの巻【癒月ちょこ/ホロライブ】",
    "publishedAt": "2023-06-13T12:12:32Z"
  },
  {
    "videoId": "5TP2ItE1tAI",
    "thumbnail": "https://i.ytimg.com/vi/5TP2ItE1tAI/mqdefault.jpg",
    "title": "【朝枠】早起き悪魔の雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-16T00:23:18Z"
  },
  {
    "videoId": "Cak7O3vhRDk",
    "thumbnail": "https://i.ytimg.com/vi/Cak7O3vhRDk/mqdefault.jpg",
    "title": "【Apex】ちょこ先生の深夜の発作ぺクス⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-19T19:52:20Z"
  },
  {
    "videoId": "gLhm4GvDknw",
    "thumbnail": "https://i.ytimg.com/vi/gLhm4GvDknw/mqdefault.jpg",
    "title": "ねぇねぇねぇ。／Covered by癒月ちょこ＆しぐれうい【歌ってみた】",
    "publishedAt": "2023-06-21T09:00:07Z"
  },
  {
    "videoId": "VT4W8-nufuA",
    "thumbnail": "https://i.ytimg.com/vi/VT4W8-nufuA/mqdefault.jpg",
    "title": "【おバカ人狼/Feign】おバカの王になれってこと？ #わちゃっとおバカ人狼【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-22T12:58:59Z"
  },
  {
    "videoId": "JsfoM-duf1E",
    "thumbnail": "https://i.ytimg.com/vi/JsfoM-duf1E/mqdefault.jpg",
    "title": "【朝枠】目覚めた時が朝なのです。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-06-26T06:53:08Z"
  },
  {
    "videoId": "1jtOr1TPiAo",
    "thumbnail": "https://i.ytimg.com/vi/1jtOr1TPiAo/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは雪花ラミィ様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/雪花ラミィ】",
    "publishedAt": "2023-06-29T11:52:29Z"
  },
  {
    "videoId": "6l3JCuGzsQM",
    "thumbnail": "https://i.ytimg.com/vi/6l3JCuGzsQM/mqdefault.jpg",
    "title": "【朝枠】寝坊助悪魔の雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-07-04T00:51:43Z"
  },
  {
    "videoId": "dwCt7XIBRZI",
    "thumbnail": "https://i.ytimg.com/vi/dwCt7XIBRZI/mqdefault.jpg",
    "title": "もしかして食べたいの？#ホロサマshorts #hololivesummer2023 #shorts",
    "publishedAt": "2023-07-04T03:00:10Z"
  },
  {
    "videoId": "8tcMksuVoR0",
    "thumbnail": "https://i.ytimg.com/vi/8tcMksuVoR0/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】レイネ様おもてなしする！【ホロライブ/癒月ちょこ/Pavolia Reine】",
    "publishedAt": "2023-07-05T12:40:49Z"
  },
  {
    "videoId": "GyeXOhTzs-Y",
    "thumbnail": "https://i.ytimg.com/vi/GyeXOhTzs-Y/mqdefault.jpg",
    "title": "【VALORANT】初心者悪魔のよちよちVALORANT【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-07-31T15:21:36Z"
  },
  {
    "videoId": "YOPEvqqmpUg",
    "thumbnail": "https://i.ytimg.com/vi/YOPEvqqmpUg/mqdefault.jpg",
    "title": "【VALORANT】『それが大事』大会練習！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-08-01T12:22:05Z"
  },
  {
    "videoId": "BBmU9yo_48E",
    "thumbnail": "https://i.ytimg.com/vi/BBmU9yo_48E/mqdefault.jpg",
    "title": "【#それが大事WIN】下見ない！前を向け！『それが大事』大会本番！hololive × VALORANT MEETUP powered by Holizontal【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-08-03T14:16:40Z"
  },
  {
    "videoId": "YZ63VO3KSbo",
    "thumbnail": "https://i.ytimg.com/vi/YZ63VO3KSbo/mqdefault.jpg",
    "title": "【FreeTalk】寝坊助悪魔の復帰雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-08-10T11:17:45Z"
  },
  {
    "videoId": "9pP18CLzabM",
    "thumbnail": "https://i.ytimg.com/vi/9pP18CLzabM/mqdefault.jpg",
    "title": "【Only Up】悪魔の挑戦！初めてのOnly Up！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-08-12T10:57:52Z"
  },
  {
    "videoId": "mNm-hoKv5Kg",
    "thumbnail": "https://i.ytimg.com/vi/mNm-hoKv5Kg/mqdefault.jpg",
    "title": "【Only Up】悪魔の挑戦！上へ駆け上る！！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-08-13T01:58:21Z"
  },
  {
    "videoId": "YiYQDU4rOt8",
    "thumbnail": "https://i.ytimg.com/vi/YiYQDU4rOt8/mqdefault.jpg",
    "title": "【VALORANT】初心者悪魔のどきどきVALORANT【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-08-15T07:30:22Z"
  },
  {
    "videoId": "iSKYoeKw1KY",
    "thumbnail": "https://i.ytimg.com/vi/iSKYoeKw1KY/mqdefault.jpg",
    "title": "【 #ホロプロエイダ 】マーダーミステリー　エイダ　海人女王マリン・アントワーネ視点【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-08-15T16:45:47Z"
  },
  {
    "videoId": "pTO2Td12w5Y",
    "thumbnail": "https://i.ytimg.com/vi/pTO2Td12w5Y/mqdefault.jpg",
    "title": "【Minecraft】スバちょこルーナで夏祭り準備！【ホロライブ/癒月ちょこ/大空スバル/姫森ルーナ】",
    "publishedAt": "2023-08-18T12:10:48Z"
  },
  {
    "videoId": "eWzouayZtyw",
    "thumbnail": "https://i.ytimg.com/vi/eWzouayZtyw/mqdefault.jpg",
    "title": "【Only Up】悪魔の挑戦！！上へ駆け上る！！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-08-20T17:17:09Z"
  },
  {
    "videoId": "t3sFyx3EidM",
    "thumbnail": "https://i.ytimg.com/vi/t3sFyx3EidM/mqdefault.jpg",
    "title": "【Minecraft】夏祭り！本番！！！！！！【ホロライブ/癒月ちょこ/大空スバル/姫森ルーナ】",
    "publishedAt": "2023-08-29T15:23:50Z"
  },
  {
    "videoId": "9djNEEPOAY0",
    "thumbnail": "https://i.ytimg.com/vi/9djNEEPOAY0/mqdefault.jpg",
    "title": "【朝枠】寝坊助悪魔の雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-09-01T00:03:31Z"
  },
  {
    "videoId": "qJkyBCijzQk",
    "thumbnail": "https://i.ytimg.com/vi/qJkyBCijzQk/mqdefault.jpg",
    "title": "【ホロライブ身体測定】姫森ルーナ様診察いたします！ 【ホロライブ/癒月ちょこ/姫森ルーナ】",
    "publishedAt": "2023-09-01T11:05:42Z"
  },
  {
    "videoId": "Ym7Qe-hjzG4",
    "thumbnail": "https://i.ytimg.com/vi/Ym7Qe-hjzG4/mqdefault.jpg",
    "title": "【5周年】お披露目&重大発表あり？！デビュー５周年凸待ち！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-09-04T11:12:00Z"
  },
  {
    "videoId": "noDoyGAyIYM",
    "thumbnail": "https://i.ytimg.com/vi/noDoyGAyIYM/mqdefault.jpg",
    "title": "【Only Up】悪魔の挑戦！100万人耐久！！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-09-06T04:41:17Z"
  },
  {
    "videoId": "HQiGO8APlDk",
    "thumbnail": "https://i.ytimg.com/vi/HQiGO8APlDk/mqdefault.jpg",
    "title": "サマーチョコレート／Covered by癒月ちょこ＆しぐれうい【歌ってみた】",
    "publishedAt": "2023-09-06T09:00:09Z"
  },
  {
    "videoId": "_XiMrdKmMS4",
    "thumbnail": "https://i.ytimg.com/vi/_XiMrdKmMS4/mqdefault.jpg",
    "title": "【Only Up】悪魔の挑戦！クリア目指す！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-09-09T05:09:31Z"
  },
  {
    "videoId": "D2ZUEPmlaJg",
    "thumbnail": "https://i.ytimg.com/vi/D2ZUEPmlaJg/mqdefault.jpg",
    "title": "【逆凸】100万人祝ってほしい悪魔の深夜逆凸！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-09-09T17:10:54Z"
  },
  {
    "videoId": "es0VK5dDGCU",
    "thumbnail": "https://i.ytimg.com/vi/es0VK5dDGCU/mqdefault.jpg",
    "title": "【Only Up】悪魔の挑戦！クリア目指す！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-09-10T19:54:40Z"
  },
  {
    "videoId": "cgnnz9keeBA",
    "thumbnail": "https://i.ytimg.com/vi/cgnnz9keeBA/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは白上フブキ様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/白上フブキ】",
    "publishedAt": "2023-09-14T10:55:11Z"
  },
  {
    "videoId": "z-fIqQNhkgw",
    "thumbnail": "https://i.ytimg.com/vi/z-fIqQNhkgw/mqdefault.jpg",
    "title": "【朝枠】ゲリラ悪魔の寝起き雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-09-20T01:36:22Z"
  },
  {
    "videoId": "B9uf4uNM3Ms",
    "thumbnail": "https://i.ytimg.com/vi/B9uf4uNM3Ms/mqdefault.jpg",
    "title": "【Minecraft】ちょこが眠くなるまでダイヤ掘っちゃうもんね！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-09-23T19:20:38Z"
  },
  {
    "videoId": "7hdLgRLachc",
    "thumbnail": "https://i.ytimg.com/vi/7hdLgRLachc/mqdefault.jpg",
    "title": "【Minecraft】島流しに行ってくる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-09-29T15:20:26Z"
  },
  {
    "videoId": "_oL3Okaoj3s",
    "thumbnail": "https://i.ytimg.com/vi/_oL3Okaoj3s/mqdefault.jpg",
    "title": "【Minecraft】肝試しみんなでまわるの巻【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-09-30T17:25:19Z"
  },
  {
    "videoId": "UKurkzmn-e8",
    "thumbnail": "https://i.ytimg.com/vi/UKurkzmn-e8/mqdefault.jpg",
    "title": "[Chilla's Art] Parasocial | パラソーシャル初プレイ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-04T16:44:48Z"
  },
  {
    "videoId": "8W6huOx71Xw",
    "thumbnail": "https://i.ytimg.com/vi/8W6huOx71Xw/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARKに初参戦！よちよち悪魔のARK生活！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-05T23:05:28Z"
  },
  {
    "videoId": "UnnOX4NqpA4",
    "thumbnail": "https://i.ytimg.com/vi/UnnOX4NqpA4/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARKに初参戦！よちよち悪魔のARK生活！part２【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-05T23:07:55Z"
  },
  {
    "videoId": "7g12Dz-EzdY",
    "thumbnail": "https://i.ytimg.com/vi/7g12Dz-EzdY/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARKに初参戦！よちよち悪魔のARK生活！2日目！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-06T14:49:47Z"
  },
  {
    "videoId": "FiKkyRJQgU4",
    "thumbnail": "https://i.ytimg.com/vi/FiKkyRJQgU4/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARKに初参戦！よちよち悪魔のARK生活！2日目！Part2【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-07T01:19:12Z"
  },
  {
    "videoId": "wdU56cK5ja8",
    "thumbnail": "https://i.ytimg.com/vi/wdU56cK5ja8/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARKに初参戦！よちよち悪魔のARK生活！3日目！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-07T17:42:36Z"
  },
  {
    "videoId": "RI_fZsbzItY",
    "thumbnail": "https://i.ytimg.com/vi/RI_fZsbzItY/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARKに初参戦！よちよち悪魔のARK生活！4日目！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-08T12:58:30Z"
  },
  {
    "videoId": "AR8EaePt3EU",
    "thumbnail": "https://i.ytimg.com/vi/AR8EaePt3EU/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARKに初参戦！よちよち悪魔のARK生活！4日目！part２【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-08T19:40:23Z"
  },
  {
    "videoId": "rh8K5fwdd-w",
    "thumbnail": "https://i.ytimg.com/vi/rh8K5fwdd-w/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARKに初参戦！よちよち悪魔のARK生活！4日目！part3【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-09T02:01:45Z"
  },
  {
    "videoId": "JPV6uQuZMoA",
    "thumbnail": "https://i.ytimg.com/vi/JPV6uQuZMoA/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARKに初参戦！よちよち悪魔のARK生活！5日目！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-09T13:15:24Z"
  },
  {
    "videoId": "m1E3_qycuUs",
    "thumbnail": "https://i.ytimg.com/vi/m1E3_qycuUs/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARK5日目！レイド戦！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-09T15:32:06Z"
  },
  {
    "videoId": "QBFKERNdUhE",
    "thumbnail": "https://i.ytimg.com/vi/QBFKERNdUhE/mqdefault.jpg",
    "title": "【VCR ARK】寝起き悪魔のスト鯖ARK6日目！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-11T06:21:22Z"
  },
  {
    "videoId": "MJEX_ex9nZc",
    "thumbnail": "https://i.ytimg.com/vi/MJEX_ex9nZc/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARK6日目！最終日！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-11T15:45:50Z"
  },
  {
    "videoId": "pYrF70vJh3M",
    "thumbnail": "https://i.ytimg.com/vi/pYrF70vJh3M/mqdefault.jpg",
    "title": "【スマブラSP】スマブラ初心者悪魔のクリア耐久！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-12T10:47:05Z"
  },
  {
    "videoId": "4-K85qbuu1I",
    "thumbnail": "https://i.ytimg.com/vi/4-K85qbuu1I/mqdefault.jpg",
    "title": "【スマブラSP】スマブラ初心者悪魔のクリア耐久！part２【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-12T15:57:50Z"
  },
  {
    "videoId": "K4vUQYyUF7U",
    "thumbnail": "https://i.ytimg.com/vi/K4vUQYyUF7U/mqdefault.jpg",
    "title": "【スマブラSP】スマブラ初心者悪魔のクリア耐久！part3【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-13T06:53:55Z"
  },
  {
    "videoId": "ZQGQBt9tVyM",
    "thumbnail": "https://i.ytimg.com/vi/ZQGQBt9tVyM/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARK！第２幕始まり【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-14T20:32:23Z"
  },
  {
    "videoId": "V6R-T_wGPNA",
    "thumbnail": "https://i.ytimg.com/vi/V6R-T_wGPNA/mqdefault.jpg",
    "title": "【ピクミン４】初めてのピクミン！悪魔のミリしら実況！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-18T04:12:00Z"
  },
  {
    "videoId": "KFDnJ-YXooc",
    "thumbnail": "https://i.ytimg.com/vi/KFDnJ-YXooc/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARK！第２幕２日目！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-21T14:09:49Z"
  },
  {
    "videoId": "S57pwtshE9k",
    "thumbnail": "https://i.ytimg.com/vi/S57pwtshE9k/mqdefault.jpg",
    "title": "【ピクミン４】初めてのピクミン！悪魔のミリしら実況！part２【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-22T16:17:01Z"
  },
  {
    "videoId": "zxaTiCBcl4k",
    "thumbnail": "https://i.ytimg.com/vi/zxaTiCBcl4k/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARK！第２幕２日目！！part２【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-22T19:25:24Z"
  },
  {
    "videoId": "Vy7Fmy1zX9k",
    "thumbnail": "https://i.ytimg.com/vi/Vy7Fmy1zX9k/mqdefault.jpg",
    "title": "【Apex】深夜悪魔の１００億年ぶりのAPEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-24T17:28:01Z"
  },
  {
    "videoId": "9mj3N790PMo",
    "thumbnail": "https://i.ytimg.com/vi/9mj3N790PMo/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARK！第２幕3日目！！ドード軍団作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-26T18:27:36Z"
  },
  {
    "videoId": "bLDfEXe9C8E",
    "thumbnail": "https://i.ytimg.com/vi/bLDfEXe9C8E/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARK！第２幕4日目！！ドード軍団子育てする！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-28T12:59:25Z"
  },
  {
    "videoId": "ZKOldEv3_DU",
    "thumbnail": "https://i.ytimg.com/vi/ZKOldEv3_DU/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARK！第２幕4日目！！カルカロ軍団子育てする！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-28T15:57:32Z"
  },
  {
    "videoId": "-QD-bGgaQ3E",
    "thumbnail": "https://i.ytimg.com/vi/-QD-bGgaQ3E/mqdefault.jpg",
    "title": "【#スバちょこるなたん】スバちょこるなたん魂の雑談！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-29T13:08:49Z"
  },
  {
    "videoId": "FeTI1Hh-BdU",
    "thumbnail": "https://i.ytimg.com/vi/FeTI1Hh-BdU/mqdefault.jpg",
    "title": "【歌ってみた】BANG!BANG!BANG!/Covered by癒月ちょこ＆大空スバル＆姫森ルーナ＆獅白ぼたん【ホロライブ/スバちょこるなたん】",
    "publishedAt": "2023-10-29T13:45:09Z"
  },
  {
    "videoId": "hG6dp1qWu8s",
    "thumbnail": "https://i.ytimg.com/vi/hG6dp1qWu8s/mqdefault.jpg",
    "title": "【VCR ARK】スト鯖ARK！最終ボス戦挑む！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-10-31T17:04:46Z"
  },
  {
    "videoId": "PoWWEOaH33Q",
    "thumbnail": "https://i.ytimg.com/vi/PoWWEOaH33Q/mqdefault.jpg",
    "title": "【FreeTalk】今年残りわずか！みんなでワクワクすること話そうか！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-11-01T15:18:06Z"
  },
  {
    "videoId": "YegTzDZ2rak",
    "thumbnail": "https://i.ytimg.com/vi/YegTzDZ2rak/mqdefault.jpg",
    "title": "【#ホロライブ大運動会2023】今年は白組！楽しむわよ！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-11-04T12:46:14Z"
  },
  {
    "videoId": "9OgSXmv_sdc",
    "thumbnail": "https://i.ytimg.com/vi/9OgSXmv_sdc/mqdefault.jpg",
    "title": "【誘拐事件】悪魔誘拐してみる？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-11-05T09:43:51Z"
  },
  {
    "videoId": "qy3UXWM569c",
    "thumbnail": "https://i.ytimg.com/vi/qy3UXWM569c/mqdefault.jpg",
    "title": "【VALORANT】初心者悪魔のどきどきVALORANT【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-11-06T03:30:10Z"
  },
  {
    "videoId": "du4Fo_1mjxE",
    "thumbnail": "https://i.ytimg.com/vi/du4Fo_1mjxE/mqdefault.jpg",
    "title": "【スイカゲーム】悪魔のチャレンジ！高得点とれちゅかな？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-11-07T11:52:43Z"
  },
  {
    "videoId": "zwn2qan7iQA",
    "thumbnail": "https://i.ytimg.com/vi/zwn2qan7iQA/mqdefault.jpg",
    "title": "【STREET FIGHTER 6 】初めてのスト６！格ゲーチャレンジ！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-11-09T15:14:56Z"
  },
  {
    "videoId": "JYWswRONnlw",
    "thumbnail": "https://i.ytimg.com/vi/JYWswRONnlw/mqdefault.jpg",
    "title": "【STREET FIGHTER 6 】スト６！２日目！格ゲーキーマウチャレンジ！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-11-15T07:36:40Z"
  },
  {
    "videoId": "EYCXc8MhR24",
    "thumbnail": "https://i.ytimg.com/vi/EYCXc8MhR24/mqdefault.jpg",
    "title": "【朝枠】ゲリラ悪魔の寝起き雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-11-16T04:59:45Z"
  },
  {
    "videoId": "BxCJdxlorvo",
    "thumbnail": "https://i.ytimg.com/vi/BxCJdxlorvo/mqdefault.jpg",
    "title": "【DeadbyDaylight】寝起き悪魔の追いかけっこ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-11-24T05:47:43Z"
  },
  {
    "videoId": "Pnt5WIuEcO8",
    "thumbnail": "https://i.ytimg.com/vi/Pnt5WIuEcO8/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】ナスのとろとろはさみ焼きつくる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-11-25T05:27:52Z"
  },
  {
    "videoId": "uT1vi_Vr3nU",
    "thumbnail": "https://i.ytimg.com/vi/uT1vi_Vr3nU/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】火を使わないみぞれ唐揚げ作る！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-11-27T04:30:18Z"
  },
  {
    "videoId": "qFw531mqNrg",
    "thumbnail": "https://i.ytimg.com/vi/qFw531mqNrg/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】火を使わないそぼろ丼作る！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-11-28T09:04:55Z"
  },
  {
    "videoId": "Rl3CpaA3Ov4",
    "thumbnail": "https://i.ytimg.com/vi/Rl3CpaA3Ov4/mqdefault.jpg",
    "title": "【重大告知あり！】100の質問こたえます！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-11-30T15:55:57Z"
  },
  {
    "videoId": "TaCt-EG1pjs",
    "thumbnail": "https://i.ytimg.com/vi/TaCt-EG1pjs/mqdefault.jpg",
    "title": "【original】のーばでぃーくりすます！/癒月ちょこ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-12-02T10:50:09Z"
  },
  {
    "videoId": "YjTnRIIczcE",
    "thumbnail": "https://i.ytimg.com/vi/YjTnRIIczcE/mqdefault.jpg",
    "title": "【#ブラちょこ】Black choco Christmas！5周年３DLIVE！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-12-02T10:53:01Z"
  },
  {
    "videoId": "x8D1BPsHP-k",
    "thumbnail": "https://i.ytimg.com/vi/x8D1BPsHP-k/mqdefault.jpg",
    "title": "【FreeTalk】５周年ライブ振り返り配信【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-12-03T13:56:34Z"
  },
  {
    "videoId": "ROzyTfp1P8I",
    "thumbnail": "https://i.ytimg.com/vi/ROzyTfp1P8I/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】火を使わないチーズリゾット作る！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-12-07T10:47:38Z"
  },
  {
    "videoId": "xT-vqgFvnVw",
    "thumbnail": "https://i.ytimg.com/vi/xT-vqgFvnVw/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】家にある食材で何品作れるかチャレンジ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-12-09T17:02:03Z"
  },
  {
    "videoId": "TOM9ybqVy8E",
    "thumbnail": "https://i.ytimg.com/vi/TOM9ybqVy8E/mqdefault.jpg",
    "title": "【録画はメン限】悪魔の永眠ASMR【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-12-12T15:11:49Z"
  },
  {
    "videoId": "vJoqUZ-Mqgc",
    "thumbnail": "https://i.ytimg.com/vi/vJoqUZ-Mqgc/mqdefault.jpg",
    "title": "【ホロパレード】悪魔の保険医がミリしら初プレイ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-12-16T09:20:40Z"
  },
  {
    "videoId": "OZcHF2RT9gk",
    "thumbnail": "https://i.ytimg.com/vi/OZcHF2RT9gk/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】クリスマスにぴったり！クリチーズロール作る！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-12-21T10:25:52Z"
  },
  {
    "videoId": "LNxNwrpQN2c",
    "thumbnail": "https://i.ytimg.com/vi/LNxNwrpQN2c/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】ローストキチンとマグロアボカドツリー作る！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-12-22T05:17:39Z"
  },
  {
    "videoId": "Q29B-J10CCs",
    "thumbnail": "https://i.ytimg.com/vi/Q29B-J10CCs/mqdefault.jpg",
    "title": "【５周年記念】ちょこめいとコンテストついに！全体発表！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-12-23T15:53:23Z"
  },
  {
    "videoId": "uxiD5VY9NgE",
    "thumbnail": "https://i.ytimg.com/vi/uxiD5VY9NgE/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】ござるが来るまでに作り終えられるか！クリスマスチャレンジ！！【ホロライブ/癒月ちょこ/風真いろは】",
    "publishedAt": "2023-12-25T06:18:50Z"
  },
  {
    "videoId": "kZTH99kfqRk",
    "thumbnail": "https://i.ytimg.com/vi/kZTH99kfqRk/mqdefault.jpg",
    "title": "【#りっちしょこら】今回は特別お菓子編！緑仙ご来店だ！！！！！【ホロライブ/癒月ちょこ/鷹嶺ルイ/緑仙】",
    "publishedAt": "2023-12-26T11:33:44Z"
  },
  {
    "videoId": "RTawf1dbOtM",
    "thumbnail": "https://i.ytimg.com/vi/RTawf1dbOtM/mqdefault.jpg",
    "title": "【#火威青を救いたい】ござちょこサンタからのクリスマス会🎄【ホロライブ/癒月ちょこ/風真いろは/火威青】",
    "publishedAt": "2023-12-29T08:09:48Z"
  },
  {
    "videoId": "6D2Andm83-A",
    "thumbnail": "https://i.ytimg.com/vi/6D2Andm83-A/mqdefault.jpg",
    "title": "【Freetalk】今年最後にちょこ先生はおしゃべりしたい!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2023-12-31T07:59:47Z"
  },
  {
    "videoId": "_03U0dOD-L0",
    "thumbnail": "https://i.ytimg.com/vi/_03U0dOD-L0/mqdefault.jpg",
    "title": "【#ちょこっとクッキング 】お雑煮作ってみんなで新年会だ！！！！！！【ホロライブ/癒月ちょこ/獅白ぼたん/不知火フレア】",
    "publishedAt": "2024-01-03T03:57:55Z"
  },
  {
    "videoId": "3u4Z33EQNm4",
    "thumbnail": "https://i.ytimg.com/vi/3u4Z33EQNm4/mqdefault.jpg",
    "title": "【縦型雑談】ちょこ先生の奇跡の朝枠【ホロライブ/癒月ちょこ】#shorts #Vtuber",
    "publishedAt": "2024-01-08T23:12:03Z"
  },
  {
    "videoId": "9kIXOjvTWqQ",
    "thumbnail": "https://i.ytimg.com/vi/9kIXOjvTWqQ/mqdefault.jpg",
    "title": "【ななしいんく身体測定】龍ヶ崎リン様診察いたします！ 【ホロライブ/癒月ちょこ/龍ヶ崎リン】",
    "publishedAt": "2024-01-10T15:13:54Z"
  },
  {
    "videoId": "H9NnH9W4DPI",
    "thumbnail": "https://i.ytimg.com/vi/H9NnH9W4DPI/mqdefault.jpg",
    "title": "【Minecraft】#らいカンハードコアクリア目指す！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-01-15T18:40:34Z"
  },
  {
    "videoId": "wJ5pBPjEaDw",
    "thumbnail": "https://i.ytimg.com/vi/wJ5pBPjEaDw/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは風真いろは様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/風真いろは】",
    "publishedAt": "2024-01-16T12:20:28Z"
  },
  {
    "videoId": "VOgodQRzlKo",
    "thumbnail": "https://i.ytimg.com/vi/VOgodQRzlKo/mqdefault.jpg",
    "title": "【Lethal Company】 #スバちょこるなたん ホラー？廃品回収？協力する心！【ホロライブ/癒月ちょこ/大空スバル/獅白ぼたん/姫森ルーナ】",
    "publishedAt": "2024-01-18T15:49:39Z"
  },
  {
    "videoId": "17zQDpzQ4gc",
    "thumbnail": "https://i.ytimg.com/vi/17zQDpzQ4gc/mqdefault.jpg",
    "title": "【Palworld】初めてのPalworld！悪魔降臨！！ 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-01-22T18:56:59Z"
  },
  {
    "videoId": "NsDqQ0Yuk1I",
    "thumbnail": "https://i.ytimg.com/vi/NsDqQ0Yuk1I/mqdefault.jpg",
    "title": "【Palworld】Palworld２日目！悪魔の冒険！！ 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-01-24T17:10:26Z"
  },
  {
    "videoId": "nKYLbS6hAoE",
    "thumbnail": "https://i.ytimg.com/vi/nKYLbS6hAoE/mqdefault.jpg",
    "title": "【Palworld】Palworld3日目！悪魔のダンジョン挑戦！！ 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-01-25T20:48:49Z"
  },
  {
    "videoId": "AhwMj8bsr7w",
    "thumbnail": "https://i.ytimg.com/vi/AhwMj8bsr7w/mqdefault.jpg",
    "title": "【にじさんじ身体測定】えま★おうがすと様診察いたします！ 【ホロライブ/癒月ちょこ/えま★おうがすと】",
    "publishedAt": "2024-01-28T13:09:47Z"
  },
  {
    "videoId": "Y5XNWSjjikI",
    "thumbnail": "https://i.ytimg.com/vi/Y5XNWSjjikI/mqdefault.jpg",
    "title": "【にじさんじ身体測定】本間ひまわり様診察いたします！ 【ホロライブ/癒月ちょこ/本間ひまわり】",
    "publishedAt": "2024-01-29T11:05:38Z"
  },
  {
    "videoId": "DUmYLemXpC8",
    "thumbnail": "https://i.ytimg.com/vi/DUmYLemXpC8/mqdefault.jpg",
    "title": "【Palworld】Palworld4日目！悪魔の卵集め！！ 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-01-31T10:34:46Z"
  },
  {
    "videoId": "BHq_3j0YsVc",
    "thumbnail": "https://i.ytimg.com/vi/BHq_3j0YsVc/mqdefault.jpg",
    "title": "【豆まき大会】今年の不幸ちょこに食べられてみる？ 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-02-03T17:59:17Z"
  },
  {
    "videoId": "1Mg0yG1rQ9s",
    "thumbnail": "https://i.ytimg.com/vi/1Mg0yG1rQ9s/mqdefault.jpg",
    "title": "【アソビ大全】罰ゲームあり？！春香様と悪魔対決！ 【ホロライブ/癒月ちょこ/にじさんじ/小野町春香】",
    "publishedAt": "2024-02-05T11:24:10Z"
  },
  {
    "videoId": "ao3DUIEaO4c",
    "thumbnail": "https://i.ytimg.com/vi/ao3DUIEaO4c/mqdefault.jpg",
    "title": "【original】地獄で会おうぜ！スバちょこるなたん/ by癒月ちょこ＆大空スバル＆姫森ルーナ＆獅白ぼたん【ホロライブ/スバちょこるなたん】",
    "publishedAt": "2024-02-06T13:00:10Z"
  },
  {
    "videoId": "8C6mgV0DqZ0",
    "thumbnail": "https://i.ytimg.com/vi/8C6mgV0DqZ0/mqdefault.jpg",
    "title": "【#ラプラスマリカ雑魚杯】今日は前に誰か見れるかな？ 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-02-09T14:55:59Z"
  },
  {
    "videoId": "P0MF6E8Ab2U",
    "thumbnail": "https://i.ytimg.com/vi/P0MF6E8Ab2U/mqdefault.jpg",
    "title": "【Freetalk】ちょこ先生の夜更かし雑談 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-02-09T17:30:45Z"
  },
  {
    "videoId": "5-igRJtVbuI",
    "thumbnail": "https://i.ytimg.com/vi/5-igRJtVbuI/mqdefault.jpg",
    "title": "エンダーマンを狩りたいちょこ先生　#shorts 　#vtuber  #ホロライブ",
    "publishedAt": "2024-02-11T09:00:07Z"
  },
  {
    "videoId": "QYWLi2Zz-5g",
    "thumbnail": "https://i.ytimg.com/vi/QYWLi2Zz-5g/mqdefault.jpg",
    "title": "エンダーマンvsちょこ先生　#shorts 　#vtuber  #ホロライブ",
    "publishedAt": "2024-02-11T09:00:10Z"
  },
  {
    "videoId": "ZNYik6NjgwI",
    "thumbnail": "https://i.ytimg.com/vi/ZNYik6NjgwI/mqdefault.jpg",
    "title": "【 Dead by Daylight 】ばんちょーと真っ暗追いかけっこする! 【ホロライブ/癒月ちょこ/轟はじめ】",
    "publishedAt": "2024-02-12T16:41:49Z"
  },
  {
    "videoId": "dOLFYPvvrYY",
    "thumbnail": "https://i.ytimg.com/vi/dOLFYPvvrYY/mqdefault.jpg",
    "title": "【Freetalk】ちょこ先生のお誕生日カウントダウン配信【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-02-13T16:20:10Z"
  },
  {
    "videoId": "j87DD5m7tJQ",
    "thumbnail": "https://i.ytimg.com/vi/j87DD5m7tJQ/mqdefault.jpg",
    "title": "【original】Got Cheat/癒月ちょこ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-02-14T11:00:12Z"
  },
  {
    "videoId": "5rns6j2eHcQ",
    "thumbnail": "https://i.ytimg.com/vi/5rns6j2eHcQ/mqdefault.jpg",
    "title": "【#癒月ちょこ生誕祭2024】‐ GotCheat‐コラボ者多数！重大告知あり！3DBirthdayLIVE!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-02-14T11:10:37Z"
  },
  {
    "videoId": "ejpubVcsItk",
    "thumbnail": "https://i.ytimg.com/vi/ejpubVcsItk/mqdefault.jpg",
    "title": "【#癒月ちょこ生誕祭2024】お誕生日LIVE振り返り雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-02-15T17:56:15Z"
  },
  {
    "videoId": "vUB2an7e_As",
    "thumbnail": "https://i.ytimg.com/vi/vUB2an7e_As/mqdefault.jpg",
    "title": "【定点視点】HAPPY SCARY HALLOWEEN 【ホロライブ/癒月ちょこ/森カリオペ/小鳥遊キアラ/クレイジー・オリー】",
    "publishedAt": "2024-02-16T10:08:42Z"
  },
  {
    "videoId": "RuqGb51PV_8",
    "thumbnail": "https://i.ytimg.com/vi/RuqGb51PV_8/mqdefault.jpg",
    "title": "【Freetalk】ちょこ先生はMVを語りたい【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-02-18T16:28:10Z"
  },
  {
    "videoId": "5PvJzViemy0",
    "thumbnail": "https://i.ytimg.com/vi/5PvJzViemy0/mqdefault.jpg",
    "title": "【 Dead by Daylight 】悪魔が集めたメンツでわちゃわちゃフルパDBD【ホロライブ/癒月ちょこ/轟はじめ/風真いろは/宗谷いちか/夕陽リリ】",
    "publishedAt": "2024-02-19T16:21:39Z"
  },
  {
    "videoId": "kSGI8wnkvfQ",
    "thumbnail": "https://i.ytimg.com/vi/kSGI8wnkvfQ/mqdefault.jpg",
    "title": "【Apex】2００億年ぶりのゲリラAPEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-02-21T09:28:36Z"
  },
  {
    "videoId": "sSiZXQMc-w0",
    "thumbnail": "https://i.ytimg.com/vi/sSiZXQMc-w0/mqdefault.jpg",
    "title": "【ホロライブEN身体測定】魔界乃番犬シスターズFUWAMOCO様診察いたします！ 【ホロライブ/癒月ちょこ/FUWAMOCO】",
    "publishedAt": "2024-02-21T10:58:44Z"
  },
  {
    "videoId": "UlrjStofJsA",
    "thumbnail": "https://i.ytimg.com/vi/UlrjStofJsA/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】ばんちょーにオムライス食べさせる健全な配信です【ホロライブ/癒月ちょこ/轟はじめ】",
    "publishedAt": "2024-02-23T12:27:28Z"
  },
  {
    "videoId": "CcISIVJqjQA",
    "thumbnail": "https://i.ytimg.com/vi/CcISIVJqjQA/mqdefault.jpg",
    "title": "【アソビ大全】いちか呼び出し！タイマン悪魔対決！ 【ホロライブ/癒月ちょこ/宗谷いちか】",
    "publishedAt": "2024-02-24T14:52:54Z"
  },
  {
    "videoId": "3QhQVLJitAw",
    "thumbnail": "https://i.ytimg.com/vi/3QhQVLJitAw/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは常闇トワ様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/常闇トワ】",
    "publishedAt": "2024-02-27T11:51:46Z"
  },
  {
    "videoId": "HvibSWkkiKI",
    "thumbnail": "https://i.ytimg.com/vi/HvibSWkkiKI/mqdefault.jpg",
    "title": "【#FOAMSTARS】ブルーチーム参戦！ 楽しむわよ！！！！！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-02-28T13:08:38Z"
  },
  {
    "videoId": "-ZFxVYBqrwA",
    "thumbnail": "https://i.ytimg.com/vi/-ZFxVYBqrwA/mqdefault.jpg",
    "title": "【Apex】寝起き悪魔のゲリラAPEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-01T06:59:04Z"
  },
  {
    "videoId": "uaOb30GhO5U",
    "thumbnail": "https://i.ytimg.com/vi/uaOb30GhO5U/mqdefault.jpg",
    "title": "【Apex】キャリーお願いします！女子会APEXコラボ⚡【ホロライブ/癒月ちょこ/本間ひまわり/八雲べに】",
    "publishedAt": "2024-03-02T09:15:52Z"
  },
  {
    "videoId": "BUAf1Z842Q8",
    "thumbnail": "https://i.ytimg.com/vi/BUAf1Z842Q8/mqdefault.jpg",
    "title": "【定点視点】ハロウィンナイトパーティー【ホロライブ/癒月ちょこ/鷹嶺ルイ】",
    "publishedAt": "2024-03-03T14:15:38Z"
  },
  {
    "videoId": "WeMkxYsocf0",
    "thumbnail": "https://i.ytimg.com/vi/WeMkxYsocf0/mqdefault.jpg",
    "title": "【定点視点】Happy Halloween 【ホロライブ/癒月ちょこ/尾丸ポルカ/不知火フレア】",
    "publishedAt": "2024-03-04T04:59:35Z"
  },
  {
    "videoId": "7kiI87Fgngk",
    "thumbnail": "https://i.ytimg.com/vi/7kiI87Fgngk/mqdefault.jpg",
    "title": "【DeadbyDaylight】悪魔の追いかけっこ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-04T16:21:22Z"
  },
  {
    "videoId": "lceNDZQ52V8",
    "thumbnail": "https://i.ytimg.com/vi/lceNDZQ52V8/mqdefault.jpg",
    "title": "【Apex】深夜の悪魔のゲリラAPEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-05T18:08:36Z"
  },
  {
    "videoId": "_MZyqj8WSbk",
    "thumbnail": "https://i.ytimg.com/vi/_MZyqj8WSbk/mqdefault.jpg",
    "title": "【Freetalk】悪魔の保険医の奇跡の朝枠⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-08T23:52:28Z"
  },
  {
    "videoId": "HCJeb_gIPv4",
    "thumbnail": "https://i.ytimg.com/vi/HCJeb_gIPv4/mqdefault.jpg",
    "title": "【Freetalk】宗谷いちかの罰ゲーム決める会議⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-10T13:08:21Z"
  },
  {
    "videoId": "hJORD0hO288",
    "thumbnail": "https://i.ytimg.com/vi/hJORD0hO288/mqdefault.jpg",
    "title": "【Apex】よちよち悪魔のゲリラAPEX⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-12T10:04:21Z"
  },
  {
    "videoId": "oy8g3f1Q21M",
    "thumbnail": "https://i.ytimg.com/vi/oy8g3f1Q21M/mqdefault.jpg",
    "title": "【original】ユーフォリア/癒月ちょこ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-13T15:00:07Z"
  },
  {
    "videoId": "CfDfC9Vs2yU",
    "thumbnail": "https://i.ytimg.com/vi/CfDfC9Vs2yU/mqdefault.jpg",
    "title": "【重大告知あり】悪魔の保健医の深夜逆凸⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-13T15:02:41Z"
  },
  {
    "videoId": "NjmYlR95PWI",
    "thumbnail": "https://i.ytimg.com/vi/NjmYlR95PWI/mqdefault.jpg",
    "title": "【DeadbyDaylight】はじめましての悪魔の追いかけっこ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-13T17:07:23Z"
  },
  {
    "videoId": "vR_umyY19wY",
    "thumbnail": "https://i.ytimg.com/vi/vR_umyY19wY/mqdefault.jpg",
    "title": "【Freetalk】５thFes振り返り雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-17T18:03:46Z"
  },
  {
    "videoId": "IQsASL7NVzg",
    "thumbnail": "https://i.ytimg.com/vi/IQsASL7NVzg/mqdefault.jpg",
    "title": "【Lethal Company】ゴミ拾い？いや、そんな甘いと思ってる？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-19T14:30:57Z"
  },
  {
    "videoId": "9smjvJOVuiY",
    "thumbnail": "https://i.ytimg.com/vi/9smjvJOVuiY/mqdefault.jpg",
    "title": "【８番出口】方向音痴ですが？なにか？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-21T18:26:34Z"
  },
  {
    "videoId": "9Dz3B3ROnUA",
    "thumbnail": "https://i.ytimg.com/vi/9Dz3B3ROnUA/mqdefault.jpg",
    "title": "【にじホロコラボ】小野町春香様襲来？！手料理作ってくれるらしい…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-22T12:01:10Z"
  },
  {
    "videoId": "pUhupUBVOkg",
    "thumbnail": "https://i.ytimg.com/vi/pUhupUBVOkg/mqdefault.jpg",
    "title": "【定点視点】Crazy Party Night ～ぱんぷきんの逆襲～【ホロライブ/癒月ちょこ/大空スバル/姫森ルーナ】",
    "publishedAt": "2024-03-23T06:27:30Z"
  },
  {
    "videoId": "iu8dSwXDHFU",
    "thumbnail": "https://i.ytimg.com/vi/iu8dSwXDHFU/mqdefault.jpg",
    "title": "【定点視点】のーばでぃーくりすます！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-24T10:33:39Z"
  },
  {
    "videoId": "CWFWDkZLwc0",
    "thumbnail": "https://i.ytimg.com/vi/CWFWDkZLwc0/mqdefault.jpg",
    "title": "【Freetalk】寝起き悪魔の戦に勝ち抜いた悪魔の裏話【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-27T07:06:48Z"
  },
  {
    "videoId": "NYAVmLv_w-Q",
    "thumbnail": "https://i.ytimg.com/vi/NYAVmLv_w-Q/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】ゲストあり？！悪魔の１時間で何品作れるかチャレンジ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-29T06:50:45Z"
  },
  {
    "videoId": "_TKKZqd-FHs",
    "thumbnail": "https://i.ytimg.com/vi/_TKKZqd-FHs/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】深夜の悪魔の飯テロクッキング！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-30T17:00:04Z"
  },
  {
    "videoId": "_SAVHUyRTk4",
    "thumbnail": "https://i.ytimg.com/vi/_SAVHUyRTk4/mqdefault.jpg",
    "title": "【新幹線０号】こちら癒月です、なにやら異変があるらしいです…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-03-31T15:11:00Z"
  },
  {
    "videoId": "4A3q_znkxUI",
    "thumbnail": "https://i.ytimg.com/vi/4A3q_znkxUI/mqdefault.jpg",
    "title": "【#ホロドロケイ2024】holoXランドからの大脱出！泥棒？警察？悪魔が捕まるとでも？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-04-28T13:41:20Z"
  },
  {
    "videoId": "ox8xTI7M6Bk",
    "thumbnail": "https://i.ytimg.com/vi/ox8xTI7M6Bk/mqdefault.jpg",
    "title": "【Freetalk】ただいま！悪魔の復帰雑談‼【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-04-29T12:07:50Z"
  },
  {
    "videoId": "1rsBzneJWyo",
    "thumbnail": "https://i.ytimg.com/vi/1rsBzneJWyo/mqdefault.jpg",
    "title": "【#ホロドロケイ2024後夜祭】ホロドロケイ後夜祭参戦だーーーーーー！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-05-02T12:45:50Z"
  },
  {
    "videoId": "HvlVIgB_8gQ",
    "thumbnail": "https://i.ytimg.com/vi/HvlVIgB_8gQ/mqdefault.jpg",
    "title": "【 最恐 -青鬼- 】最新作青鬼3Dホラゲー！悪魔と最恐の鬼ごっこが始まる―。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-05-04T08:09:19Z"
  },
  {
    "videoId": "TxvNtwmYerA",
    "thumbnail": "https://i.ytimg.com/vi/TxvNtwmYerA/mqdefault.jpg",
    "title": "【#ばんちょこ】ばんちょーとデート雑談！【ホロライブ/癒月ちょこ/轟はじめ】",
    "publishedAt": "2024-05-04T12:35:37Z"
  },
  {
    "videoId": "L93enlVyak8",
    "thumbnail": "https://i.ytimg.com/vi/L93enlVyak8/mqdefault.jpg",
    "title": "【歌ってみた】ようこそ！ジャパリパークへ/Covered by癒月ちょこ＆アキロゼ＆本間ひまわり＆八雲べに【ホロライブ/にじさんじ/ぶいすぽ】",
    "publishedAt": "2024-05-07T12:00:07Z"
  },
  {
    "videoId": "h2BIGrG9QMU",
    "thumbnail": "https://i.ytimg.com/vi/h2BIGrG9QMU/mqdefault.jpg",
    "title": "「【重大発表あり】緊急招集⚡にじホロすぽ女子会!【ホロライブ/癒月ちょこ/アキロゼ/本間ひまわり/八雲べに】」のコピー",
    "publishedAt": "2024-05-07T23:13:38Z"
  },
  {
    "videoId": "c-fdTpbCcog",
    "thumbnail": "https://i.ytimg.com/vi/c-fdTpbCcog/mqdefault.jpg",
    "title": "【#ちょこっとクッキング 】材料は３つだけ！火を使わない天津飯つくる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-05-10T03:58:41Z"
  },
  {
    "videoId": "YNOEKFeiwoY",
    "thumbnail": "https://i.ytimg.com/vi/YNOEKFeiwoY/mqdefault.jpg",
    "title": "【#ちょこっとクッキング 】簡単！でもおいしい！バターチキンライスつくる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-05-12T16:43:49Z"
  },
  {
    "videoId": "X4QHCDzXTAo",
    "thumbnail": "https://i.ytimg.com/vi/X4QHCDzXTAo/mqdefault.jpg",
    "title": "【the game of sisyphus 】早起きしたので岩転がしてみるー。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-05-21T03:37:16Z"
  },
  {
    "videoId": "uIiswdWDRVc",
    "thumbnail": "https://i.ytimg.com/vi/uIiswdWDRVc/mqdefault.jpg",
    "title": "【House Flipper 2】汚れたところありませんか？悪魔に掃除されてみる？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-05-31T11:34:44Z"
  },
  {
    "videoId": "GGH6dDw9cYw",
    "thumbnail": "https://i.ytimg.com/vi/GGH6dDw9cYw/mqdefault.jpg",
    "title": "【Re≒Connect Exit LOOP 】おじさんしかいない駅からの脱出ー。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-06-01T11:40:08Z"
  },
  {
    "videoId": "DGX-F_iJrrc",
    "thumbnail": "https://i.ytimg.com/vi/DGX-F_iJrrc/mqdefault.jpg",
    "title": "【 最恐 -青鬼- 】ノーミスクリア耐久⚡悪魔と最恐の鬼ごっこが始まる―。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-06-04T11:07:00Z"
  },
  {
    "videoId": "r9e9eKXAfWY",
    "thumbnail": "https://i.ytimg.com/vi/r9e9eKXAfWY/mqdefault.jpg",
    "title": "【 Escape the Backrooms 】悪魔の探索！４人で協力して脱出せよー。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-06-05T15:55:51Z"
  },
  {
    "videoId": "khtQKVOPfGs",
    "thumbnail": "https://i.ytimg.com/vi/khtQKVOPfGs/mqdefault.jpg",
    "title": "【 ８番のりば 】異変が再び―。悪魔の無限列車【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-06-08T13:56:47Z"
  },
  {
    "videoId": "xIEsrePqER8",
    "thumbnail": "https://i.ytimg.com/vi/xIEsrePqER8/mqdefault.jpg",
    "title": "【悪魔が歌ってみた】ヴィラン/てにをは　covered by癒月ちょこ【ホロライブ】",
    "publishedAt": "2024-06-09T09:00:07Z"
  },
  {
    "videoId": "XUs8VTbeVss",
    "thumbnail": "https://i.ytimg.com/vi/XUs8VTbeVss/mqdefault.jpg",
    "title": "【#癒月ちょこ新衣装】悪魔の魅力に染められな！新衣装お披露目だーーーい！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-06-09T11:13:05Z"
  },
  {
    "videoId": "Pbqz4X-MGl8",
    "thumbnail": "https://i.ytimg.com/vi/Pbqz4X-MGl8/mqdefault.jpg",
    "title": "【Freetalk】寝起き悪魔のおしゃべり枠【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-06-10T05:45:34Z"
  },
  {
    "videoId": "cou2nCnDPx0",
    "thumbnail": "https://i.ytimg.com/vi/cou2nCnDPx0/mqdefault.jpg",
    "title": "【the game of sisyphus 】悪魔が深夜の岩転してみるー。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-06-13T17:17:15Z"
  },
  {
    "videoId": "ywaqnvmlY0U",
    "thumbnail": "https://i.ytimg.com/vi/ywaqnvmlY0U/mqdefault.jpg",
    "title": "【The Radio Station | 深夜放送】悪魔の深夜放送はじめるわよ!!!!!!!!!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-06-15T17:09:04Z"
  },
  {
    "videoId": "XzH1Sh9SrCY",
    "thumbnail": "https://i.ytimg.com/vi/XzH1Sh9SrCY/mqdefault.jpg",
    "title": "【行方不明】悪魔が誘拐されるってがちぃ？!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-06-16T15:38:07Z"
  },
  {
    "videoId": "vdqeFyYBIsc",
    "thumbnail": "https://i.ytimg.com/vi/vdqeFyYBIsc/mqdefault.jpg",
    "title": "【Dead by Daylight】５億年ぶりの悪魔のDBD⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-06-30T09:07:22Z"
  },
  {
    "videoId": "TFK3Cb-0iD8",
    "thumbnail": "https://i.ytimg.com/vi/TFK3Cb-0iD8/mqdefault.jpg",
    "title": "【Dead by Daylight】８周年⚡BP稼ぎまくりましょうか✨【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-07-01T06:00:08Z"
  },
  {
    "videoId": "WghyUoOF98A",
    "thumbnail": "https://i.ytimg.com/vi/WghyUoOF98A/mqdefault.jpg",
    "title": "【Dead by Daylight】８周年⚡悪魔の追いかけっこ✨【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-07-02T10:44:04Z"
  },
  {
    "videoId": "RVVyKBpAToY",
    "thumbnail": "https://i.ytimg.com/vi/RVVyKBpAToY/mqdefault.jpg",
    "title": "【Freetalk】悪魔の保健医の夜ふかし雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-07-06T15:31:39Z"
  },
  {
    "videoId": "0XQ1vOCjhUI",
    "thumbnail": "https://i.ytimg.com/vi/0XQ1vOCjhUI/mqdefault.jpg",
    "title": "【Freetalk】深夜におしょべり⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-07-13T14:55:38Z"
  },
  {
    "videoId": "68M3jTTBJ-E",
    "thumbnail": "https://i.ytimg.com/vi/68M3jTTBJ-E/mqdefault.jpg",
    "title": "【僕、アルバイトォォ！！】悪魔の接客⚡コンビニバイト始めます！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-07-15T12:52:23Z"
  },
  {
    "videoId": "0PF1MXEUEU4",
    "thumbnail": "https://i.ytimg.com/vi/0PF1MXEUEU4/mqdefault.jpg",
    "title": "【Apex】４人対戦！ちくまろAPEXコラボ⚡【ホロライブ/癒月ちょこ/本間ひまわり/八雲べに/アキロゼ】",
    "publishedAt": "2024-07-17T15:08:17Z"
  },
  {
    "videoId": "FzMrJC7Lz2Y",
    "thumbnail": "https://i.ytimg.com/vi/FzMrJC7Lz2Y/mqdefault.jpg",
    "title": "【Chained Together】#ばんちょこ で鎖に繋がれて二人三脚？！【ホロライブ/癒月ちょこ/轟はじめ】",
    "publishedAt": "2024-07-19T15:13:25Z"
  },
  {
    "videoId": "vnE98mcxsZI",
    "thumbnail": "https://i.ytimg.com/vi/vnE98mcxsZI/mqdefault.jpg",
    "title": "【#ちょこっとクッキング 】サーモンの味ぽん漬け丼つくるっ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-07-22T00:14:26Z"
  },
  {
    "videoId": "85iGNO5FyTI",
    "thumbnail": "https://i.ytimg.com/vi/85iGNO5FyTI/mqdefault.jpg",
    "title": "【#ホロARK】ホロARK１日目🦖出陣しますかっ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-07-23T20:28:50Z"
  },
  {
    "videoId": "dqxBjnj5-98",
    "thumbnail": "https://i.ytimg.com/vi/dqxBjnj5-98/mqdefault.jpg",
    "title": "【#ホロARK】ホロARK２日目🦖シャドウメイテイムしたい！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-07-24T17:03:08Z"
  },
  {
    "videoId": "lg8U9iZUyCI",
    "thumbnail": "https://i.ytimg.com/vi/lg8U9iZUyCI/mqdefault.jpg",
    "title": "【#ホロARK】ホロARK３日目🦖子育てする！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-07-25T20:00:20Z"
  },
  {
    "videoId": "51b5ZQ47YMM",
    "thumbnail": "https://i.ytimg.com/vi/51b5ZQ47YMM/mqdefault.jpg",
    "title": "【#ホロARK】ホロARK4日目🦖らでんとレイド戦！【ホロライブ/癒月ちょこ/儒烏風亭らでん  】",
    "publishedAt": "2024-07-26T13:58:24Z"
  },
  {
    "videoId": "RuaQuvFVa5k",
    "thumbnail": "https://i.ytimg.com/vi/RuaQuvFVa5k/mqdefault.jpg",
    "title": "【#ホロARK】ホロARK５日目🦖ふぁーむ！鉄あつめるわよ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-07-29T16:49:08Z"
  },
  {
    "videoId": "QRO74w3Qvzg",
    "thumbnail": "https://i.ytimg.com/vi/QRO74w3Qvzg/mqdefault.jpg",
    "title": "【Dead by Daylight】２VS８⚡悪魔の追いかけっこ✨【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-07-30T04:16:53Z"
  },
  {
    "videoId": "Aw0F7liyFlQ",
    "thumbnail": "https://i.ytimg.com/vi/Aw0F7liyFlQ/mqdefault.jpg",
    "title": "【ホロぽん飯テロ部】味ぽんを一番上手く使いこなした最強投稿は誰だ？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-07-30T11:09:28Z"
  },
  {
    "videoId": "Oe2AO-5TI_w",
    "thumbnail": "https://i.ytimg.com/vi/Oe2AO-5TI_w/mqdefault.jpg",
    "title": "【#ホロARK】ホロARK６日目🦖まぐたん復活？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-07-30T16:46:03Z"
  },
  {
    "videoId": "Xsr25TWU77c",
    "thumbnail": "https://i.ytimg.com/vi/Xsr25TWU77c/mqdefault.jpg",
    "title": "【#ホロARK】ホロARK最終日🦖生き残りたいっ!!!!!!!!!!!!!!!【ホロライブ/癒月ちょこ  】",
    "publishedAt": "2024-07-31T15:13:11Z"
  },
  {
    "videoId": "hxvxWeb9Uuc",
    "thumbnail": "https://i.ytimg.com/vi/hxvxWeb9Uuc/mqdefault.jpg",
    "title": "【Freetalk】ちょこ先生の夜更かし雑談 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-08-04T14:36:41Z"
  },
  {
    "videoId": "WlE8bxeW9u0",
    "thumbnail": "https://i.ytimg.com/vi/WlE8bxeW9u0/mqdefault.jpg",
    "title": "【Dead by Daylight】いちかと２VS８挑戦⚡悪魔の追いかけっこ✨【ホロライブ/癒月ちょこ/宗谷いちか】",
    "publishedAt": "2024-08-06T14:35:20Z"
  },
  {
    "videoId": "PjZXRETkpSk",
    "thumbnail": "https://i.ytimg.com/vi/PjZXRETkpSk/mqdefault.jpg",
    "title": "【#ちょこっとクッキング 】火を使わないなすドッグつくるっ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-08-10T05:09:00Z"
  },
  {
    "videoId": "0GL7Gn5p5Uk",
    "thumbnail": "https://i.ytimg.com/vi/0GL7Gn5p5Uk/mqdefault.jpg",
    "title": "【迷宮校舎】深夜の学校で肝試しするっ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-08-10T14:32:35Z"
  },
  {
    "videoId": "l-N3nRt1eBw",
    "thumbnail": "https://i.ytimg.com/vi/l-N3nRt1eBw/mqdefault.jpg",
    "title": "【#ちょこっとクッキング 】火を使わない豚の角煮つくるっ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-08-11T07:02:03Z"
  },
  {
    "videoId": "_iI5ZZNobzQ",
    "thumbnail": "https://i.ytimg.com/vi/_iI5ZZNobzQ/mqdefault.jpg",
    "title": "【霊室 / Ghost room】すべての異変が恐怖のホラーゲーム【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-08-11T15:00:50Z"
  },
  {
    "videoId": "bxtf_Bi73dM",
    "thumbnail": "https://i.ytimg.com/vi/bxtf_Bi73dM/mqdefault.jpg",
    "title": "【青鬼】チェイス大好き悪魔の倍速モードで逃げまくるっ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-08-13T15:56:34Z"
  },
  {
    "videoId": "u53eMzvazQY",
    "thumbnail": "https://i.ytimg.com/vi/u53eMzvazQY/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは湊あくあ様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/湊あくあ】",
    "publishedAt": "2024-08-16T11:39:07Z"
  },
  {
    "videoId": "NxmOB-oSwTE",
    "thumbnail": "https://i.ytimg.com/vi/NxmOB-oSwTE/mqdefault.jpg",
    "title": "【青鬼】挑戦するたびに館が変化する？！青鬼 - 藍編 -初プレイ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-08-17T15:50:40Z"
  },
  {
    "videoId": "W7yZ3KougcU",
    "thumbnail": "https://i.ytimg.com/vi/W7yZ3KougcU/mqdefault.jpg",
    "title": "【失踪 - タケシ、お前の言う通りだった。あの廃村はヤバすぎる。】なんかやけに長いタイトルのホラゲー見つけました【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-08-18T15:16:02Z"
  },
  {
    "videoId": "my7svbqqykM",
    "thumbnail": "https://i.ytimg.com/vi/my7svbqqykM/mqdefault.jpg",
    "title": "【 RE：地獄銭湯 】販売中止になったあのホラゲーが帰ってきたそうで…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-08-20T17:36:08Z"
  },
  {
    "videoId": "rZMgvoQEMzg",
    "thumbnail": "https://i.ytimg.com/vi/rZMgvoQEMzg/mqdefault.jpg",
    "title": "【 #ばんちょこ 】ばんちょこどう森！釣り＆虫取り勝負！【ホロライブ轟はじめ//癒月ちょこ】",
    "publishedAt": "2024-08-21T15:55:00Z"
  },
  {
    "videoId": "6lycvVy0os0",
    "thumbnail": "https://i.ytimg.com/vi/6lycvVy0os0/mqdefault.jpg",
    "title": "【 #ばんちょこ 】ばんちょこ夏の自由研究！琥珀糖づくり！【ホロライブ轟はじめ//癒月ちょこ】",
    "publishedAt": "2024-08-21T16:58:20Z"
  },
  {
    "videoId": "U6nHP5lze8Q",
    "thumbnail": "https://i.ytimg.com/vi/U6nHP5lze8Q/mqdefault.jpg",
    "title": "【Freetalk】悪魔の保険医の奇跡の朝枠⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-09-02T23:26:24Z"
  },
  {
    "videoId": "LOeMlKWsRDU",
    "thumbnail": "https://i.ytimg.com/vi/LOeMlKWsRDU/mqdefault.jpg",
    "title": "【original】ちょこせんせーしょん/癒月ちょこ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-09-04T11:15:07Z"
  },
  {
    "videoId": "0yIrVQNmcBU",
    "thumbnail": "https://i.ytimg.com/vi/0yIrVQNmcBU/mqdefault.jpg",
    "title": "【 #癒月ちょこ６周年 】６周年新衣装✨重大告知ありっ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-09-04T11:18:55Z"
  },
  {
    "videoId": "bq9-pYaOM7c",
    "thumbnail": "https://i.ytimg.com/vi/bq9-pYaOM7c/mqdefault.jpg",
    "title": "【怨枉 】恨みの呪縛を解き放て！除霊させていただきますっ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-09-07T17:46:04Z"
  },
  {
    "videoId": "VT-VlBRFEWo",
    "thumbnail": "https://i.ytimg.com/vi/VT-VlBRFEWo/mqdefault.jpg",
    "title": "【LOVESAM 】日記に隠された秘密…傑作サイコホラーゲームやってみるっ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-09-09T06:31:38Z"
  },
  {
    "videoId": "KBkTJPiCzYs",
    "thumbnail": "https://i.ytimg.com/vi/KBkTJPiCzYs/mqdefault.jpg",
    "title": "【Freetalk】寝起き悪魔のもぐもぐ朝枠【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-09-13T02:54:52Z"
  },
  {
    "videoId": "AzeEFIt4_l4",
    "thumbnail": "https://i.ytimg.com/vi/AzeEFIt4_l4/mqdefault.jpg",
    "title": "【ウツロマユ】深夜の和風ホラー悪魔プレイしてみる!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-09-23T17:59:47Z"
  },
  {
    "videoId": "DIWuXcCiQUM",
    "thumbnail": "https://i.ytimg.com/vi/DIWuXcCiQUM/mqdefault.jpg",
    "title": "癒月ちょこ1st Album『滅びのBurst Song』クロスフェード【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-09-27T11:00:32Z"
  },
  {
    "videoId": "XJ4yNhWaIuA",
    "thumbnail": "https://i.ytimg.com/vi/XJ4yNhWaIuA/mqdefault.jpg",
    "title": "【Freetalk】深夜の密会っ！真夜中の保健室で、、、【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-10-01T18:07:23Z"
  },
  {
    "videoId": "TbfSRkXE4jI",
    "thumbnail": "https://i.ytimg.com/vi/TbfSRkXE4jI/mqdefault.jpg",
    "title": "【DON'T SCREAM】叫んだら終了のホラゲーってがちぃ？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-10-05T18:54:04Z"
  },
  {
    "videoId": "IkMgWDDMgZE",
    "thumbnail": "https://i.ytimg.com/vi/IkMgWDDMgZE/mqdefault.jpg",
    "title": "【Freetalk】寝坊助悪魔の奇跡の朝枠【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-10-10T02:48:22Z"
  },
  {
    "videoId": "o1PHkHkYDtY",
    "thumbnail": "https://i.ytimg.com/vi/o1PHkHkYDtY/mqdefault.jpg",
    "title": "【Freetalk】寝坊助悪魔のただいま枠【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-10-30T04:03:56Z"
  },
  {
    "videoId": "MD3Zsv-Wgv8",
    "thumbnail": "https://i.ytimg.com/vi/MD3Zsv-Wgv8/mqdefault.jpg",
    "title": "【Oxide Room 104】悪夢の施設モーテル、グロ注意ってがちぃ？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-10-31T06:09:40Z"
  },
  {
    "videoId": "iI5S0l80iX8",
    "thumbnail": "https://i.ytimg.com/vi/iI5S0l80iX8/mqdefault.jpg",
    "title": "【悪魔が歌ってみた】酔いどれ知らず / Kanaria　covered by癒月ちょこ【ホロライブ】",
    "publishedAt": "2024-10-31T09:00:06Z"
  },
  {
    "videoId": "dbCKyjjy4jo",
    "thumbnail": "https://i.ytimg.com/vi/dbCKyjjy4jo/mqdefault.jpg",
    "title": "【里帰り】一緒に刺激的な里帰りしてみる？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-11-03T02:21:17Z"
  },
  {
    "videoId": "vkVHRVJbg-Y",
    "thumbnail": "https://i.ytimg.com/vi/vkVHRVJbg-Y/mqdefault.jpg",
    "title": "【#ちょこっとクッキング 】ふーたんとミルフィーユ鍋つくるっ！【ホロライブ/癒月ちょこ/不知火フレア】",
    "publishedAt": "2024-11-03T13:14:35Z"
  },
  {
    "videoId": "HxaSCo9zi_A",
    "thumbnail": "https://i.ytimg.com/vi/HxaSCo9zi_A/mqdefault.jpg",
    "title": "【Visage】ふーたんに見守られながら最恐ホラゲーする…。【ホロライブ/癒月ちょこ/不知火フレア】",
    "publishedAt": "2024-11-04T17:24:53Z"
  },
  {
    "videoId": "lv0EIvymKuM",
    "thumbnail": "https://i.ytimg.com/vi/lv0EIvymKuM/mqdefault.jpg",
    "title": "【#ちょこっとクッキング 】鶏肉と蓮根の海苔マヨつくるっ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-11-05T16:12:55Z"
  },
  {
    "videoId": "cQCh_MzDPLc",
    "thumbnail": "https://i.ytimg.com/vi/cQCh_MzDPLc/mqdefault.jpg",
    "title": "【EXIT FROM】殺人鬼がいるマンションからの脱出？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-11-06T16:24:44Z"
  },
  {
    "videoId": "C34YYMfExJQ",
    "thumbnail": "https://i.ytimg.com/vi/C34YYMfExJQ/mqdefault.jpg",
    "title": "【Visage】ふーたんに見守られながら最恐ホラゲーする…。【ホロライブ/癒月ちょこ/不知火フレア】",
    "publishedAt": "2024-11-07T17:20:25Z"
  },
  {
    "videoId": "5MewS-wuXKo",
    "thumbnail": "https://i.ytimg.com/vi/5MewS-wuXKo/mqdefault.jpg",
    "title": "【Visage】ふーたんに見守られながら最恐ホラゲーする…。【ホロライブ/癒月ちょこ/不知火フレア】",
    "publishedAt": "2024-11-09T18:04:02Z"
  },
  {
    "videoId": "XJyt4e_pj4w",
    "thumbnail": "https://i.ytimg.com/vi/XJyt4e_pj4w/mqdefault.jpg",
    "title": "【Visage】ふーたんに見守られながら最恐ホラゲーする…。最終回!!!!!!!!!!!!【ホロライブ/癒月ちょこ/不知火フレア】",
    "publishedAt": "2024-11-10T16:11:00Z"
  },
  {
    "videoId": "zQ8ct1Qb_MI",
    "thumbnail": "https://i.ytimg.com/vi/zQ8ct1Qb_MI/mqdefault.jpg",
    "title": "【Dead by Daylight】ゲリラで100億年ぶりにDBDやってみる【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-11-12T17:16:40Z"
  },
  {
    "videoId": "nNkmhEV-2u0",
    "thumbnail": "https://i.ytimg.com/vi/nNkmhEV-2u0/mqdefault.jpg",
    "title": "【EXIT FROM】殺人鬼がいるマンションからのクリア耐久？！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-11-18T15:41:48Z"
  },
  {
    "videoId": "RVYJiQwdLYw",
    "thumbnail": "https://i.ytimg.com/vi/RVYJiQwdLYw/mqdefault.jpg",
    "title": "【PR】nosh食べ比べレポ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-11-22T07:52:49Z"
  },
  {
    "videoId": "2NdnkFOdj_w",
    "thumbnail": "https://i.ytimg.com/vi/2NdnkFOdj_w/mqdefault.jpg",
    "title": "【Dead by Daylight】⚡皆でわちゃわちゃ！にじホロすぽDBD⚡【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-11-25T13:23:57Z"
  },
  {
    "videoId": "KLUeLae4y6k",
    "thumbnail": "https://i.ytimg.com/vi/KLUeLae4y6k/mqdefault.jpg",
    "title": "【歌ってみた】威風堂々/Covered by癒月ちょこ＆猫又おかゆ【ホロライブ】",
    "publishedAt": "2024-11-29T09:00:06Z"
  },
  {
    "videoId": "iN4W2ZbOKJU",
    "thumbnail": "https://i.ytimg.com/vi/iN4W2ZbOKJU/mqdefault.jpg",
    "title": "【孵道】絶対に振り返ってはいけないホラゲープレイするっ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-12-02T15:07:41Z"
  },
  {
    "videoId": "xIUWHp7ZD5M",
    "thumbnail": "https://i.ytimg.com/vi/xIUWHp7ZD5M/mqdefault.jpg",
    "title": "【鳴蟇村】地図にはない立ち入り禁止の村からの脱出【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-12-09T18:06:57Z"
  },
  {
    "videoId": "7LeMrIbMXbs",
    "thumbnail": "https://i.ytimg.com/vi/7LeMrIbMXbs/mqdefault.jpg",
    "title": "【#パンの日】NEKOパンVlog【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-12-12T12:00:07Z"
  },
  {
    "videoId": "2UcZHr6r3Oo",
    "thumbnail": "https://i.ytimg.com/vi/2UcZHr6r3Oo/mqdefault.jpg",
    "title": "【Freetalk】悪魔の保健医の深夜雑談のお時間です⏰【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-12-18T20:06:34Z"
  },
  {
    "videoId": "_J3zHTRZhPQ",
    "thumbnail": "https://i.ytimg.com/vi/_J3zHTRZhPQ/mqdefault.jpg",
    "title": "【Dead by Daylight】ゲリラDBD⚡深夜悪魔のおいかけっこ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-12-22T17:30:09Z"
  },
  {
    "videoId": "3vCNDP3xbw8",
    "thumbnail": "https://i.ytimg.com/vi/3vCNDP3xbw8/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】今回はクリスマスディナー🎄ご堪能あれ!!!!!!!!!!!!【ホロライブ/癒月ちょこ/雪花ラミィ/ロボ子さん/轟はじめ】",
    "publishedAt": "2024-12-24T13:28:56Z"
  },
  {
    "videoId": "kb6_DVgmDNw",
    "thumbnail": "https://i.ytimg.com/vi/kb6_DVgmDNw/mqdefault.jpg",
    "title": "【Freetalk】悪魔の保健医の深夜雑談⏰【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-12-25T19:13:25Z"
  },
  {
    "videoId": "J9QMuolFcYk",
    "thumbnail": "https://i.ytimg.com/vi/J9QMuolFcYk/mqdefault.jpg",
    "title": "【Freetalk＆song】ちょこめいとからのクズ男エピおかずに食べさせてもらいます【ホロライブ/癒月ちょこ】",
    "publishedAt": "2024-12-29T16:44:02Z"
  },
  {
    "videoId": "8A28vN8pU58",
    "thumbnail": "https://i.ytimg.com/vi/8A28vN8pU58/mqdefault.jpg",
    "title": "【あけおめ】今年もちょこ神様降臨！ちょこみくじするわよ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-01-01T11:05:44Z"
  },
  {
    "videoId": "rDOQUrvxlA4",
    "thumbnail": "https://i.ytimg.com/vi/rDOQUrvxlA4/mqdefault.jpg",
    "title": "【Dead by Daylight】ゲリラDBD⚡寝起き悪魔のおいかけっこ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-01-04T14:06:02Z"
  },
  {
    "videoId": "XCPuLETsGes",
    "thumbnail": "https://i.ytimg.com/vi/XCPuLETsGes/mqdefault.jpg",
    "title": "【CRUELTY】和製最恐級スプラッターホラー、屠殺場で生き残れ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-01-06T16:21:19Z"
  },
  {
    "videoId": "v3MVDCf9u38",
    "thumbnail": "https://i.ytimg.com/vi/v3MVDCf9u38/mqdefault.jpg",
    "title": "【不審者通報しました。】下校中…不審者だらけの街で本物の不審者を探し出せ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-01-15T12:07:12Z"
  },
  {
    "videoId": "0yOOav3EqSs",
    "thumbnail": "https://i.ytimg.com/vi/0yOOav3EqSs/mqdefault.jpg",
    "title": "【不審者通報しました。】下校中…不審者だらけの街で本物の不審者を探し出せ！-クリア耐久-【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-01-16T16:53:20Z"
  },
  {
    "videoId": "bWDoZ_Xe5Pc",
    "thumbnail": "https://i.ytimg.com/vi/bWDoZ_Xe5Pc/mqdefault.jpg",
    "title": "【呪われたデジカメ】呪われたカメラ手に入れました…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-01-19T10:46:13Z"
  },
  {
    "videoId": "vW-06vyWHvM",
    "thumbnail": "https://i.ytimg.com/vi/vW-06vyWHvM/mqdefault.jpg",
    "title": "【#ばんちょこ】ReGLOSS身体測定！ばんちょー診察いたします！【ホロライブ/癒月ちょこ/轟はじめ】",
    "publishedAt": "2025-01-20T14:09:49Z"
  },
  {
    "videoId": "pxIWoKnYhrU",
    "thumbnail": "https://i.ytimg.com/vi/pxIWoKnYhrU/mqdefault.jpg",
    "title": "【P.I.】生配信で住所特定されました…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-01-21T16:06:40Z"
  },
  {
    "videoId": "WsFYIZTf3SI",
    "thumbnail": "https://i.ytimg.com/vi/WsFYIZTf3SI/mqdefault.jpg",
    "title": "【#ミオちょこ】今年の運勢ミオ様に占っていただきますっ！【ホロライブ/癒月ちょこ/大神ミオ】",
    "publishedAt": "2025-01-22T13:07:17Z"
  },
  {
    "videoId": "ZC0gr4KRaJ4",
    "thumbnail": "https://i.ytimg.com/vi/ZC0gr4KRaJ4/mqdefault.jpg",
    "title": "【姫井ダム】異変だらけのダムでのバイト始めました…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-01-23T17:33:24Z"
  },
  {
    "videoId": "Ulrj112kRO0",
    "thumbnail": "https://i.ytimg.com/vi/Ulrj112kRO0/mqdefault.jpg",
    "title": "【失踪した友人の部屋に残されていたゲーム】不気味すぎると噂のゲームプレイしてみる…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-01-24T11:54:56Z"
  },
  {
    "videoId": "CyVKiF8_two",
    "thumbnail": "https://i.ytimg.com/vi/CyVKiF8_two/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】ういござご訪問！今宵は堪能あれ!!!!!!!!!!!!【ホロライブ/癒月ちょこ/風真いろは/しぐれうい】",
    "publishedAt": "2025-01-29T10:48:57Z"
  },
  {
    "videoId": "Pyx7h5_YxG4",
    "thumbnail": "https://i.ytimg.com/vi/Pyx7h5_YxG4/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】パティシエちょこが手掛けるスフレパンケーキご堪能あれ!!!!!!!!!!!!【ホロライブ/癒月ちょこ/周防パトラ/でびでび・でびる/鷹宮リオン】",
    "publishedAt": "2025-01-30T13:31:05Z"
  },
  {
    "videoId": "6pnmP5kcOi8",
    "thumbnail": "https://i.ytimg.com/vi/6pnmP5kcOi8/mqdefault.jpg",
    "title": "【While We Wait Here】会話の選択で結末が変わるー。世界が終わる日までレストランを経営するホラーゲーム【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-02-01T16:35:08Z"
  },
  {
    "videoId": "M3xnM6kJdzQ",
    "thumbnail": "https://i.ytimg.com/vi/M3xnM6kJdzQ/mqdefault.jpg",
    "title": "【節分】アニメイトコラボの恵方巻食べる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-02-02T15:28:59Z"
  },
  {
    "videoId": "hfw_YTCq0fo",
    "thumbnail": "https://i.ytimg.com/vi/hfw_YTCq0fo/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】いちか襲来！悪魔の手料理召し上がれ！【ホロライブ/癒月ちょこ/宗谷いちか】",
    "publishedAt": "2025-02-04T10:50:14Z"
  },
  {
    "videoId": "lygwabscLzY",
    "thumbnail": "https://i.ytimg.com/vi/lygwabscLzY/mqdefault.jpg",
    "title": "【真実か×××か】選ばれし人間だけがアクセスできるサイトにアクセスしてみる…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-02-05T16:49:29Z"
  },
  {
    "videoId": "86HaeXhEnS4",
    "thumbnail": "https://i.ytimg.com/vi/86HaeXhEnS4/mqdefault.jpg",
    "title": "【告知】ちょこ先生は寝起きだけど告知がしたい！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-02-09T05:19:26Z"
  },
  {
    "videoId": "_zcLafWyH_8",
    "thumbnail": "https://i.ytimg.com/vi/_zcLafWyH_8/mqdefault.jpg",
    "title": "【CRUELTY】和製最恐級スプラッターホラー、屠殺場で生き残れ、リベンジ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-02-11T16:46:22Z"
  },
  {
    "videoId": "LZtvnkkj3hw",
    "thumbnail": "https://i.ytimg.com/vi/LZtvnkkj3hw/mqdefault.jpg",
    "title": "【凸待ち】誕生日カウントダウン！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-02-13T16:36:53Z"
  },
  {
    "videoId": "Z96aINLMDJo",
    "thumbnail": "https://i.ytimg.com/vi/Z96aINLMDJo/mqdefault.jpg",
    "title": "【#癒月ちょこ生誕祭2025】ゲスト多数！ちょこのお誕生日LIVE🎂【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-02-14T12:02:24Z"
  },
  {
    "videoId": "HgxgqdsAACg",
    "thumbnail": "https://i.ytimg.com/vi/HgxgqdsAACg/mqdefault.jpg",
    "title": "【Freetalk】誕生日振り返り雑談！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-02-15T17:02:42Z"
  },
  {
    "videoId": "4ZTb-Ioj6DQ",
    "thumbnail": "https://i.ytimg.com/vi/4ZTb-Ioj6DQ/mqdefault.jpg",
    "title": "【#スバちょこるなたん】スバちょこるなたんで地下廃病院探索する！-UNDERWARD-【ホロライブ/癒月ちょこ/大空スバル/ 姫森ルーナ/ 獅白ぼたん】",
    "publishedAt": "2025-02-20T16:26:03Z"
  },
  {
    "videoId": "FMKBR_KrJZI",
    "thumbnail": "https://i.ytimg.com/vi/FMKBR_KrJZI/mqdefault.jpg",
    "title": "【Liminalcore】現実が歪み、理性が試される世界で迷子になりました…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-02-28T16:07:27Z"
  },
  {
    "videoId": "8E-NyBm6OH4",
    "thumbnail": "https://i.ytimg.com/vi/8E-NyBm6OH4/mqdefault.jpg",
    "title": "【置忌配】自分宛ではない「不気味な贈り物」が次々と届くらしい…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-01T16:13:46Z"
  },
  {
    "videoId": "lRjAPS-cBXw",
    "thumbnail": "https://i.ytimg.com/vi/lRjAPS-cBXw/mqdefault.jpg",
    "title": "【近畿霊務局 - Kinki Spiritual Affairs Bureau】思いっきりやり返せるホラーゲームプレイしてみる…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-02T05:53:34Z"
  },
  {
    "videoId": "f7GVzwpMaps",
    "thumbnail": "https://i.ytimg.com/vi/f7GVzwpMaps/mqdefault.jpg",
    "title": "【Mouthwashing】「マウスウォッシュ」だけ食べて狂っていく名作ホラーゲームプレイしてみる…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-03T16:56:21Z"
  },
  {
    "videoId": "QWsP_0F5VlM",
    "thumbnail": "https://i.ytimg.com/vi/QWsP_0F5VlM/mqdefault.jpg",
    "title": "【ウラヤマ】幽霊が出ると噂の「不気味な裏山」探索してみる…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-04T14:58:13Z"
  },
  {
    "videoId": "N72io1eviU4",
    "thumbnail": "https://i.ytimg.com/vi/N72io1eviU4/mqdefault.jpg",
    "title": "【hololive 6th fes. ＆ EXPO】繰り帰り雑談💋 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-10T14:49:25Z"
  },
  {
    "videoId": "qVHu93mpYKc",
    "thumbnail": "https://i.ytimg.com/vi/qVHu93mpYKc/mqdefault.jpg",
    "title": "【The Classrooms】「本当に怖すぎる」と話題の声で反応してしまうホラーゲームプレイしてみる…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-11T03:39:09Z"
  },
  {
    "videoId": "ihlh2w2MOjg",
    "thumbnail": "https://i.ytimg.com/vi/ihlh2w2MOjg/mqdefault.jpg",
    "title": "【The Classrooms】RE:「本当に怖すぎる」と話題の声で反応してしまうホラーゲームプレイしてみる…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-14T14:18:52Z"
  },
  {
    "videoId": "B2LNJNeWaCQ",
    "thumbnail": "https://i.ytimg.com/vi/B2LNJNeWaCQ/mqdefault.jpg",
    "title": "【カメラあり！】マネちゃんとホロカ開封する！ 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-15T11:15:32Z"
  },
  {
    "videoId": "8su5y3qBh74",
    "thumbnail": "https://i.ytimg.com/vi/8su5y3qBh74/mqdefault.jpg",
    "title": "【#ちょこっとクッキング】本日は至高の中華料理作らせていただきます!【ホロライブ/癒月ちょこ/周防パトラ/でびでび・でびる/鷹宮リオン】",
    "publishedAt": "2025-03-18T14:05:11Z"
  },
  {
    "videoId": "t3DzrlLbEY8",
    "thumbnail": "https://i.ytimg.com/vi/t3DzrlLbEY8/mqdefault.jpg",
    "title": "【ムベンベラジオ】放送が禁止された「ラジオ番組」を聴くホラーゲームプレイしてみる…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-20T14:19:55Z"
  },
  {
    "videoId": "Riiaaf3oy6k",
    "thumbnail": "https://i.ytimg.com/vi/Riiaaf3oy6k/mqdefault.jpg",
    "title": "【Crime Scene Cleaner】殺人現場をキレイに証拠隠滅します…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-21T20:11:16Z"
  },
  {
    "videoId": "qA4LfGSUxU8",
    "thumbnail": "https://i.ytimg.com/vi/qA4LfGSUxU8/mqdefault.jpg",
    "title": "【Crime Scene Cleaner】証拠隠滅はちょこ先生にお任せあれ！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-22T13:04:57Z"
  },
  {
    "videoId": "5xNgig6uwuY",
    "thumbnail": "https://i.ytimg.com/vi/5xNgig6uwuY/mqdefault.jpg",
    "title": "【Crime Scene Cleaner】証拠隠滅クリア耐久！すべてお掃除いたします！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-24T22:45:20Z"
  },
  {
    "videoId": "DqObfwi5m6s",
    "thumbnail": "https://i.ytimg.com/vi/DqObfwi5m6s/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは大神ミオ様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/大神ミオ】",
    "publishedAt": "2025-03-26T11:12:17Z"
  },
  {
    "videoId": "ltY4Q5LRk6o",
    "thumbnail": "https://i.ytimg.com/vi/ltY4Q5LRk6o/mqdefault.jpg",
    "title": "【心霊物件】訳アリ格安アパートに引っ越します…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-27T15:25:29Z"
  },
  {
    "videoId": "Fe_-JuSXooo",
    "thumbnail": "https://i.ytimg.com/vi/Fe_-JuSXooo/mqdefault.jpg",
    "title": "【カメラあり！】マネちゃんとホロカ最新パック🌟エリートスパーク開封する！ 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-29T11:23:18Z"
  },
  {
    "videoId": "Bg8415gk3Ww",
    "thumbnail": "https://i.ytimg.com/vi/Bg8415gk3Ww/mqdefault.jpg",
    "title": "【Newspaper Day】何かがおかしい新聞配達のアルバイト悪魔がプレイしてみる…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-29T15:58:54Z"
  },
  {
    "videoId": "xuDAX2gXBEY",
    "thumbnail": "https://i.ytimg.com/vi/xuDAX2gXBEY/mqdefault.jpg",
    "title": "【Dead by Daylight】ゲリラで100億年ぶりにDBDやってみる【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-03-30T15:39:46Z"
  },
  {
    "videoId": "gg2qkAiPkXg",
    "thumbnail": "https://i.ytimg.com/vi/gg2qkAiPkXg/mqdefault.jpg",
    "title": "【Fears to Fathom - Woodbury Getaway】「正しい選択」それが生き延びるためのただ一つの選択…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-05T17:38:21Z"
  },
  {
    "videoId": "HLk7cLgmVtM",
    "thumbnail": "https://i.ytimg.com/vi/HLk7cLgmVtM/mqdefault.jpg",
    "title": "【 #ホロライブファーマーズ】悪魔の農業初体験！１日目!!!!!!!!!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-06T18:53:08Z"
  },
  {
    "videoId": "8SfwAJl_Ot0",
    "thumbnail": "https://i.ytimg.com/vi/8SfwAJl_Ot0/mqdefault.jpg",
    "title": "【 #ホロライブファーマーズ】悪魔ファーマー農業２日目!!!!!!!!!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-07T20:29:48Z"
  },
  {
    "videoId": "p7cZErmAgYw",
    "thumbnail": "https://i.ytimg.com/vi/p7cZErmAgYw/mqdefault.jpg",
    "title": "【 #ホロライブファーマーズ】悪魔ファーマー農業3日目!!!!!!!!!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-08T20:25:52Z"
  },
  {
    "videoId": "rdYk9QM_Stk",
    "thumbnail": "https://i.ytimg.com/vi/rdYk9QM_Stk/mqdefault.jpg",
    "title": "【 #ホロライブファーマーズ】悪魔ファーマー農業４日目!!!!!!!!!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-09T18:25:13Z"
  },
  {
    "videoId": "dZ-r1-wNnyY",
    "thumbnail": "https://i.ytimg.com/vi/dZ-r1-wNnyY/mqdefault.jpg",
    "title": "【 #ホロライブファーマーズ】悪魔ファーマー農業５日目!!!!!!!!!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-10T19:33:40Z"
  },
  {
    "videoId": "qvrpl-ow24c",
    "thumbnail": "https://i.ytimg.com/vi/qvrpl-ow24c/mqdefault.jpg",
    "title": "【カメラあり！】マネちゃんとホロカ開封🌟ブルーミングレディアンス開封する！ 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-11T11:33:13Z"
  },
  {
    "videoId": "22SFJUStqkQ",
    "thumbnail": "https://i.ytimg.com/vi/22SFJUStqkQ/mqdefault.jpg",
    "title": "【 #ホロライブファーマーズ】悪魔ファーマー農業6日目!!!!!!!!!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-11T18:17:10Z"
  },
  {
    "videoId": "29Xh_T6jOZY",
    "thumbnail": "https://i.ytimg.com/vi/29Xh_T6jOZY/mqdefault.jpg",
    "title": "【 #ホロライブファーマーズ】悪魔ファーマー農業７日目!!!!!!!!!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-12T23:08:05Z"
  },
  {
    "videoId": "BSVoDjxVMcU",
    "thumbnail": "https://i.ytimg.com/vi/BSVoDjxVMcU/mqdefault.jpg",
    "title": "【 #ホロライブファーマーズ】悪魔ファーマー農業８日目!!!!!!!!!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-13T08:43:45Z"
  },
  {
    "videoId": "-KwYm9innak",
    "thumbnail": "https://i.ytimg.com/vi/-KwYm9innak/mqdefault.jpg",
    "title": "【 #ホロライブファーマーズ】悪魔ファーマー農業９日目!!!!!!!!!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-14T16:21:17Z"
  },
  {
    "videoId": "5PHWyhl34Cg",
    "thumbnail": "https://i.ytimg.com/vi/5PHWyhl34Cg/mqdefault.jpg",
    "title": "【 #ホロライブファーマーズ】悪魔ファーマー農業10日目!!!!!!!!!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-15T19:21:35Z"
  },
  {
    "videoId": "4cnvqeuJJSI",
    "thumbnail": "https://i.ytimg.com/vi/4cnvqeuJJSI/mqdefault.jpg",
    "title": "【#ちくまろ】ちくまろ探索隊！-UNDERWARD-【ホロライブ/癒月ちょこ/アキロゼ/ 本間ひまわり/ 八雲べに】",
    "publishedAt": "2025-04-17T13:26:46Z"
  },
  {
    "videoId": "tP_ErEOYgOU",
    "thumbnail": "https://i.ytimg.com/vi/tP_ErEOYgOU/mqdefault.jpg",
    "title": "【#りっちしょこら】今回のゲストは紫咲シオン様⚡今宵もご堪能あれ！【ホロライブ/癒月ちょこ/鷹嶺ルイ/紫咲シオン】",
    "publishedAt": "2025-04-18T12:55:36Z"
  },
  {
    "videoId": "YiTMocHWl-0",
    "thumbnail": "https://i.ytimg.com/vi/YiTMocHWl-0/mqdefault.jpg",
    "title": "【 #ホロライブファーマーズ】悪魔ファーマー農業11日目!!!!!!!!!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-18T17:47:02Z"
  },
  {
    "videoId": "GcLUmn7rkR8",
    "thumbnail": "https://i.ytimg.com/vi/GcLUmn7rkR8/mqdefault.jpg",
    "title": "【 #holoRUST】素材王、かぼちゃ農家になる！１日目🎃【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-19T21:13:55Z"
  },
  {
    "videoId": "hsuzcu1bEjY",
    "thumbnail": "https://i.ytimg.com/vi/hsuzcu1bEjY/mqdefault.jpg",
    "title": "【 #holoRUST】かぼちゃ畑つくる！２日目🎃【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-20T18:15:08Z"
  },
  {
    "videoId": "2NrZFhIuUug",
    "thumbnail": "https://i.ytimg.com/vi/2NrZFhIuUug/mqdefault.jpg",
    "title": "【 #holoRUST】シオンとかぼちゃ畑つくる！3日目🎃【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-21T12:09:58Z"
  },
  {
    "videoId": "keFxnMCmB6M",
    "thumbnail": "https://i.ytimg.com/vi/keFxnMCmB6M/mqdefault.jpg",
    "title": "【 #holoRUST】シオンとかぼちゃ畑つくる！3日目🎃【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-21T15:29:52Z"
  },
  {
    "videoId": "0lOSvxyevnc",
    "thumbnail": "https://i.ytimg.com/vi/0lOSvxyevnc/mqdefault.jpg",
    "title": "【 #holoRUST】RUST4日目！かぼちゃ農業完成させる🎃【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-23T19:29:07Z"
  },
  {
    "videoId": "rXyeVpMws2s",
    "thumbnail": "https://i.ytimg.com/vi/rXyeVpMws2s/mqdefault.jpg",
    "title": "【 #holoRUST】RUST最終日！最強カメラマン始動🎃【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-04-24T18:21:08Z"
  },
  {
    "videoId": "CDR6Plg3QJ8",
    "thumbnail": "https://i.ytimg.com/vi/CDR6Plg3QJ8/mqdefault.jpg",
    "title": "【お披露目あり!】遅めの春休みからただいまっ！復帰雑談📣 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-06-03T15:18:07Z"
  },
  {
    "videoId": "WmRu9E8wXE0",
    "thumbnail": "https://i.ytimg.com/vi/WmRu9E8wXE0/mqdefault.jpg",
    "title": "【Freetalk】悪魔の保健医のゲリラ集会のお時間です⏰【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-06-05T16:59:26Z"
  },
  {
    "videoId": "XYOqNv4iWhw",
    "thumbnail": "https://i.ytimg.com/vi/XYOqNv4iWhw/mqdefault.jpg",
    "title": "【 つぐのひ -彁名縛りの部屋-】ただ進むだけ…。日常侵食リアルホラーゲームしてみる。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-06-17T17:06:05Z"
  },
  {
    "videoId": "kHN1KolAfd0",
    "thumbnail": "https://i.ytimg.com/vi/kHN1KolAfd0/mqdefault.jpg",
    "title": "【 We Harvest Shadows】得体のしれない存在が、闇に紛れて彼に忍び寄る…農業ホラープレイ【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-06-19T06:51:19Z"
  },
  {
    "videoId": "-kGl4szP7Yc",
    "thumbnail": "https://i.ytimg.com/vi/-kGl4szP7Yc/mqdefault.jpg",
    "title": "【 呪巣 -怨ノ章-】最恐ホラー脱出ゲームプレイしてみる…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-06-23T17:28:53Z"
  },
  {
    "videoId": "Hb9MprkI6Dc",
    "thumbnail": "https://i.ytimg.com/vi/Hb9MprkI6Dc/mqdefault.jpg",
    "title": "【重大告知あり】癒月ちょこが新衣装お披露目するってよ📣 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-06-29T10:20:40Z"
  },
  {
    "videoId": "ZrmBFwmP8Cc",
    "thumbnail": "https://i.ytimg.com/vi/ZrmBFwmP8Cc/mqdefault.jpg",
    "title": "【Dead by Daylight】ゲリラDBD⚡１０億年ぶりの悪魔おいかけっこ始まる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-07-01T10:21:22Z"
  },
  {
    "videoId": "LqvPnXNfBdg",
    "thumbnail": "https://i.ytimg.com/vi/LqvPnXNfBdg/mqdefault.jpg",
    "title": "【録画はメン限】深夜の密会☎ASMR 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-07-02T18:07:11Z"
  },
  {
    "videoId": "J4tMqcK5SR4",
    "thumbnail": "https://i.ytimg.com/vi/J4tMqcK5SR4/mqdefault.jpg",
    "title": "【Freetalk】寝坊助悪魔の奇跡の朝枠📣 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-07-12T02:13:06Z"
  },
  {
    "videoId": "_6Rq7jNo0QI",
    "thumbnail": "https://i.ytimg.com/vi/_6Rq7jNo0QI/mqdefault.jpg",
    "title": "君のカメラで、最高の私を#holonatsuParadise #ホロナツpiece #shorts",
    "publishedAt": "2025-07-12T03:30:26Z"
  },
  {
    "videoId": "xZ6X86YfkDs",
    "thumbnail": "https://i.ytimg.com/vi/xZ6X86YfkDs/mqdefault.jpg",
    "title": "【Freetalk】深夜のちょこっと雑談📣 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-07-13T17:39:01Z"
  },
  {
    "videoId": "P7DQLXlOqn8",
    "thumbnail": "https://i.ytimg.com/vi/P7DQLXlOqn8/mqdefault.jpg",
    "title": "【Freetalk】真夜中のちょこっと雑談📣 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-07-21T17:08:22Z"
  },
  {
    "videoId": "pctVhYhXuRI",
    "thumbnail": "https://i.ytimg.com/vi/pctVhYhXuRI/mqdefault.jpg",
    "title": "【ちょこっとクッキング】番長とまったり夜ご飯食べる📣 【ホロライブ/癒月ちょこ/轟はじめ】",
    "publishedAt": "2025-07-24T13:04:52Z"
  },
  {
    "videoId": "6HbJFMZyZ44",
    "thumbnail": "https://i.ytimg.com/vi/6HbJFMZyZ44/mqdefault.jpg",
    "title": "【#ホロナツ歌枠リレー】滅びの熱い悪魔song響かせたいきもちっ！ 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-07-25T13:42:35Z"
  },
  {
    "videoId": "qYGvoM6umys",
    "thumbnail": "https://i.ytimg.com/vi/qYGvoM6umys/mqdefault.jpg",
    "title": "【Dollmare】\"静的な恐怖\"が迫りくる不気味なおもちゃ工場ホラー！ 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-07-31T02:12:21Z"
  },
  {
    "videoId": "u9XSZkxOUJo",
    "thumbnail": "https://i.ytimg.com/vi/u9XSZkxOUJo/mqdefault.jpg",
    "title": "【ちょこっとクッキング】べに様がちょこ家に?！愛情たっぷりオムライス作る！📣 【ホロライブ/癒月ちょこ/八雲べに】",
    "publishedAt": "2025-07-31T13:30:34Z"
  },
  {
    "videoId": "eNq_toN8n-c",
    "thumbnail": "https://i.ytimg.com/vi/eNq_toN8n-c/mqdefault.jpg",
    "title": "【That's not my Neighbor】 ドッペルゲンガーを見破れ！化け物だらけのアパートの管理人になりました…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-08-07T15:24:20Z"
  },
  {
    "videoId": "_4j1q7CIAdU",
    "thumbnail": "https://i.ytimg.com/vi/_4j1q7CIAdU/mqdefault.jpg",
    "title": "【カメラあり！】マネちゃんとホロカ開封🌟キュリアユニバース開封する！ 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-08-09T14:29:37Z"
  },
  {
    "videoId": "KOiYpFrlTG0",
    "thumbnail": "https://i.ytimg.com/vi/KOiYpFrlTG0/mqdefault.jpg",
    "title": "【バレずに夜ふかし】バレるかバレないかギリギリのスリル味わってみる？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-08-14T16:44:37Z"
  },
  {
    "videoId": "97hP3tew_6g",
    "thumbnail": "https://i.ytimg.com/vi/97hP3tew_6g/mqdefault.jpg",
    "title": "【異世界シリーズ口裂け女VS青鬼】最恐ホラー👻悪魔参戦させていただきます！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-08-17T15:35:07Z"
  },
  {
    "videoId": "shL8Sxhiptc",
    "thumbnail": "https://i.ytimg.com/vi/shL8Sxhiptc/mqdefault.jpg",
    "title": "【異世界シリーズ口裂け女VS青鬼】最恐ホラー👻クリア耐久!!!!!!!!!!!!【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-08-21T09:19:38Z"
  },
  {
    "videoId": "nXuHM5NknY4",
    "thumbnail": "https://i.ytimg.com/vi/nXuHM5NknY4/mqdefault.jpg",
    "title": "【Freetalk】飯テロ注意📣 深夜のまったり雑談【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-08-24T17:11:05Z"
  },
  {
    "videoId": "MLIE_WnYu08",
    "thumbnail": "https://i.ytimg.com/vi/MLIE_WnYu08/mqdefault.jpg",
    "title": "【Freetalk】悪魔の飯テロ注意📣 深夜の初めてのカップ焼きそば【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-09-02T17:59:59Z"
  },
  {
    "videoId": "BypGg9hEeyU",
    "thumbnail": "https://i.ytimg.com/vi/BypGg9hEeyU/mqdefault.jpg",
    "title": "【#癒月ちょこ７周年】重大告知あり！７周年記念配信✨【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-09-04T12:05:56Z"
  },
  {
    "videoId": "lP_0zLNHww8",
    "thumbnail": "https://i.ytimg.com/vi/lP_0zLNHww8/mqdefault.jpg",
    "title": "【禁足地 - 青鬼の窟 -】決して踏み入れてはならない禁忌の場所ー。悪魔なら大丈夫だよね？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-09-07T18:25:24Z"
  },
  {
    "videoId": "zhwPoMIM-R8",
    "thumbnail": "https://i.ytimg.com/vi/zhwPoMIM-R8/mqdefault.jpg",
    "title": "【禁足地 - 青鬼の窟 -】決して踏み入れてはならない禁忌の場所ー。無事脱出なるか！？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-09-08T18:10:21Z"
  },
  {
    "videoId": "y2rc9Cx3CnY",
    "thumbnail": "https://i.ytimg.com/vi/y2rc9Cx3CnY/mqdefault.jpg",
    "title": "【R.E.P.O】怪物から逃げながらホロメンと宝探しするっ！【ホロライブ/癒月ちょこ/アキロゼ/天音かなた/不知火フレア】",
    "publishedAt": "2025-09-15T14:16:57Z"
  },
  {
    "videoId": "E6uw_uBlPaU",
    "thumbnail": "https://i.ytimg.com/vi/E6uw_uBlPaU/mqdefault.jpg",
    "title": "【禁足地 - 青鬼の窟 -】決して踏み入れてはならない禁忌の場所ー。クリア目指す！？【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-09-15T18:14:24Z"
  },
  {
    "videoId": "lO-Nty8hmd4",
    "thumbnail": "https://i.ytimg.com/vi/lO-Nty8hmd4/mqdefault.jpg",
    "title": "【#ういちょこ】たこ焼き名人降臨🐙たこ焼きオフコラボっ！【ホロライブ/癒月ちょこ/しぐれうい】",
    "publishedAt": "2025-09-16T12:00:08Z"
  },
  {
    "videoId": "YmsSXBH_jas",
    "thumbnail": "https://i.ytimg.com/vi/YmsSXBH_jas/mqdefault.jpg",
    "title": "【No, I'm not a Human】深夜の怪しい訪問者。-入れていいのは人間だけ。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-09-20T17:34:14Z"
  },
  {
    "videoId": "FLiUNGiqDBs",
    "thumbnail": "https://i.ytimg.com/vi/FLiUNGiqDBs/mqdefault.jpg",
    "title": "【ノロイヅキ】ガラケーには謎の動画。ー25年前の事件が甦る。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-09-25T11:30:29Z"
  },
  {
    "videoId": "j60VImzLjR4",
    "thumbnail": "https://i.ytimg.com/vi/j60VImzLjR4/mqdefault.jpg",
    "title": "『コンプレックスが意外と役に立った時💕』 アキちょこナイトパレット第7回 ～ホロライブ深夜ラジオ～【ホロライブ/癒月ちょこ/アキロゼ】",
    "publishedAt": "2025-09-29T15:13:30Z"
  },
  {
    "videoId": "3kiaS62dJgc",
    "thumbnail": "https://i.ytimg.com/vi/3kiaS62dJgc/mqdefault.jpg",
    "title": "【ニコニコさん】都市伝説の笑顔の男からの脱出ー。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-10-01T16:18:40Z"
  },
  {
    "videoId": "ulj1OiAU78c",
    "thumbnail": "https://i.ytimg.com/vi/ulj1OiAU78c/mqdefault.jpg",
    "title": "【 案件 】新作ゲーム『ドラゴンボール ゲキシン スクアドラ』スバちょこるなたんでプレイする！！！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-10-04T12:10:51Z"
  },
  {
    "videoId": "qXO2JCaFaHE",
    "thumbnail": "https://i.ytimg.com/vi/qXO2JCaFaHE/mqdefault.jpg",
    "title": "【Dead by Daylight】ゲリラDBD⚡悪魔のおいかけっこ始まる！【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-10-09T17:34:22Z"
  },
  {
    "videoId": "gv_-_jFdJ80",
    "thumbnail": "https://i.ytimg.com/vi/gv_-_jFdJ80/mqdefault.jpg",
    "title": "【ちょこっとクッキング】かなあずとちょこっとクッキング📣 【ホロライブ/癒月ちょこ/天音かなた/AZKi】",
    "publishedAt": "2025-10-12T13:43:40Z"
  },
  {
    "videoId": "a_mDqa-wo8o",
    "thumbnail": "https://i.ytimg.com/vi/a_mDqa-wo8o/mqdefault.jpg",
    "title": "【重大告知あり！】マネちゃんとホロカ開封カメラ配信🌟エンチャントレガリア開封する！ 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-10-15T11:19:52Z"
  },
  {
    "videoId": "jYLWPepVvGs",
    "thumbnail": "https://i.ytimg.com/vi/jYLWPepVvGs/mqdefault.jpg",
    "title": "【凶寓 / Dread Flats】３日住むだけで150万円もらえる物件があるらしい…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-10-19T15:51:42Z"
  },
  {
    "videoId": "8jVrpbDyojY",
    "thumbnail": "https://i.ytimg.com/vi/8jVrpbDyojY/mqdefault.jpg",
    "title": "【異変踏切】日本一有名な踏切で何かがおこるらしい…。【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-10-20T17:29:31Z"
  },
  {
    "videoId": "-dfJItMJWO4",
    "thumbnail": "https://i.ytimg.com/vi/-dfJItMJWO4/mqdefault.jpg",
    "title": "【Freetalk】深夜にゲリラ雑談📣まったり悪魔と過ごしてみる？ 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-10-25T19:54:22Z"
  },
  {
    "videoId": "NTksndf1hm0",
    "thumbnail": "https://i.ytimg.com/vi/NTksndf1hm0/mqdefault.jpg",
    "title": "【漫ぷくメシ！】愛園愛美様とサンジのピラフ再現してみる！ 【ホロライブ/癒月ちょこ/にじさんじ/愛園愛美】",
    "publishedAt": "2025-10-30T11:15:58Z"
  },
  {
    "videoId": "swjMOhCaUCo",
    "thumbnail": "https://i.ytimg.com/vi/swjMOhCaUCo/mqdefault.jpg",
    "title": "【Freetalk】深夜にゲリラ雑談📣 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-11-04T17:59:08Z"
  },
  {
    "videoId": "vJmn91_GrAE",
    "thumbnail": "https://i.ytimg.com/vi/vJmn91_GrAE/mqdefault.jpg",
    "title": "【恐怖耐性診断テスト】悪魔が挑むー。恐怖耐性診断テスト【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-11-11T18:37:51Z"
  },
  {
    "videoId": "ndZRRxk2wE0",
    "thumbnail": "https://i.ytimg.com/vi/ndZRRxk2wE0/mqdefault.jpg",
    "title": "【Freetalk】深夜のゲリラ雑談📣 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-11-20T16:38:48Z"
  },
  {
    "videoId": "VbkOPrOg3f8",
    "thumbnail": "https://i.ytimg.com/vi/VbkOPrOg3f8/mqdefault.jpg",
    "title": "【DeadbyDaylight】まったり雑談しながら深夜のゲリラDBD📣 【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-11-29T17:09:01Z"
  },
  {
    "videoId": "bdO-Qzh1PzA",
    "thumbnail": "https://i.ytimg.com/vi/bdO-Qzh1PzA/mqdefault.jpg",
    "title": "【Dead by Daylight】深夜悪魔のゲリラDBD【ホロライブ/癒月ちょこ】",
    "publishedAt": "2025-12-04T18:54:06Z"
  }
],


  
}